/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function ajvEqual(a, b) {
    if (a === b)
        return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor)
            return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length)
                return false;
            for (i = length; i-- !== 0;)
                if (!ajvEqual(a[i], b[i]))
                    return false;
            return true;
        }
        if (a.constructor === RegExp)
            return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
            return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
            return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
            return false;
        for (i = length; i-- !== 0;)
            if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
                return false;
        for (i = length; i-- !== 0;) {
            var key = keys[i];
            if (!ajvEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const abodOutlierConfigSchemaValidation = validate12;
const schema29 = { $id: 'urn:wisepipe-common-pipe:AbodOutlierConfig', type: 'object', properties: {}, required: [] };
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AbodOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const adaptColumnSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common-pipe:AdaptColumn',
    type: 'object',
    properties: {
        oldName: { type: 'string', minLength: 1, maxLength: 150 },
        newName: { type: 'string', minLength: 1, maxLength: 150 },
        newType: { type: 'string', pattern: 'number|date|string|boolean|decimal' }
    },
    required: ['oldName', 'newName', 'newType']
};
const func2 = ucs2length;
const pattern0 = new RegExp('number|date|string|boolean|decimal', 'u');
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AdaptColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.oldName === undefined && (missing0 = 'oldName')) ||
                (data.newName === undefined && (missing0 = 'newName')) ||
                (data.newType === undefined && (missing0 = 'newType'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.oldName !== undefined) {
                    let data0 = data.oldName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/oldName',
                                        schemaPath: '#/properties/oldName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/oldName',
                                            schemaPath: '#/properties/oldName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/oldName',
                                    schemaPath: '#/properties/oldName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newName !== undefined) {
                        let data1 = data.newName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/newName',
                                            schemaPath: '#/properties/newName/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/newName',
                                                schemaPath: '#/properties/newName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/newName',
                                        schemaPath: '#/properties/newName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.newType !== undefined) {
                            let data2 = data.newType;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (!pattern0.test(data2)) {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/newType',
                                                schemaPath: '#/properties/newType/pattern',
                                                keyword: 'pattern',
                                                params: { pattern: 'number|date|string|boolean|decimal' },
                                                message: 'must match pattern "' + 'number|date|string|boolean|decimal' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/newType',
                                            schemaPath: '#/properties/newType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const adaptConfigSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-common-pipe:AdaptConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:AdaptColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['oldName', 'newName']
        }
    },
    required: ['columns']
};
const func10 = ajvEqual;
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AdaptConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        const _errs4 = errors;
                                        if (errors === _errs4) {
                                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                                let missing1;
                                                if ((data1.oldName === undefined && (missing1 = 'oldName')) ||
                                                    (data1.newName === undefined && (missing1 = 'newName')) ||
                                                    (data1.newType === undefined && (missing1 = 'newType'))) {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data1.oldName !== undefined) {
                                                        let data2 = data1.oldName;
                                                        const _errs6 = errors;
                                                        if (errors === _errs6) {
                                                            if (typeof data2 === 'string') {
                                                                if (func2(data2) > 150) {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/oldName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/oldName/maxLength',
                                                                            keyword: 'maxLength',
                                                                            params: { limit: 150 },
                                                                            message: 'must NOT have more than 150 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (func2(data2) < 1) {
                                                                        validate14.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/oldName',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/oldName/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/oldName',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/oldName/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs6 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.newName !== undefined) {
                                                            let data3 = data1.newName;
                                                            const _errs8 = errors;
                                                            if (errors === _errs8) {
                                                                if (typeof data3 === 'string') {
                                                                    if (func2(data3) > 150) {
                                                                        validate14.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/newName',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/newName/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 150 },
                                                                                message: 'must NOT have more than 150 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (func2(data3) < 1) {
                                                                            validate14.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/newName',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/newName/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/newName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/newName/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs8 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.newType !== undefined) {
                                                                let data4 = data1.newType;
                                                                const _errs10 = errors;
                                                                if (errors === _errs10) {
                                                                    if (typeof data4 === 'string') {
                                                                        if (!pattern0.test(data4)) {
                                                                            validate14.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/newType',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/newType/pattern',
                                                                                    keyword: 'pattern',
                                                                                    params: { pattern: 'number|date|string|boolean|decimal' },
                                                                                    message: 'must match pattern "' + 'number|date|string|boolean|decimal' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate14.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/newType',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/properties/newType/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid3 = _errs10 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:AdaptColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema31.properties.columns.uniqueItemProperties;
                                        let k0;
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data0.length; i1--;) {
                                                    let x0 = data0[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data0[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func10(x0[key0], y0[key0])) {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns',
                                                                    schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const advancedJoinColumnsSchemaValidation = validate15;
const schema33 = {
    $id: 'urn:wisepipe-common-pipe:AdvancedJoinColumns',
    type: 'object',
    properties: {
        leftColumn: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        rightColumn: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        operator: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                {
                    type: 'string',
                    enum: ['equal', 'less_than', 'less_than_or_equal', 'greater_than', 'greater_than_or_equal', 'like']
                }
            ]
        },
        pattern: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['starts_with', 'ends_with', 'contains'] }
            ]
        }
    },
    required: ['leftColumn', 'rightColumn'],
    if: { required: ['operator'], properties: { operator: { const: 'like' } } },
    then: { required: ['pattern'] }
};
const schema34 = { $id: 'urn:wisepipe-base-pipe:ColumnToolVariable', type: 'object', properties: {} };
const schema36 = {
    $id: 'urn:wisepipe-base-pipe:EnumToolVariable',
    type: 'object',
    properties: {
        toolEnumType: {
            type: 'string',
            enum: [
                'SortDirection',
                'AggregateColumnOperation',
                'DateFrequency',
                'DateAddType',
                'DateAddUnit',
                'DateUnitType',
                'DatePartType',
                'JoinOperator',
                'JoinPattern',
                'FilterStatementOp',
                'ColumnType',
                'PeriodAddType'
            ]
        }
    }
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AdvancedJoinColumns" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.operator === undefined && (missing0 = 'operator')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        else {
            if (data.operator !== undefined) {
                if ('like' !== data.operator) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.pattern === undefined && (missing1 = 'pattern')) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate15.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.leftColumn === undefined && (missing2 = 'leftColumn')) ||
                (data.rightColumn === undefined && (missing2 = 'rightColumn'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.leftColumn !== undefined) {
                    let data1 = data.leftColumn;
                    const _errs5 = errors;
                    const _errs6 = errors;
                    let valid3 = false;
                    let passing0 = null;
                    const _errs7 = errors;
                    const _errs8 = errors;
                    if (errors === _errs8) {
                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                            const err3 = {
                                instancePath: instancePath + '/leftColumn',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid1 = _errs7 === errors;
                    if (_valid1) {
                        valid3 = true;
                        passing0 = 0;
                    }
                    const _errs10 = errors;
                    if (typeof data1 !== 'string') {
                        const err4 = {
                            instancePath: instancePath + '/leftColumn',
                            schemaPath: '#/properties/leftColumn/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                    var _valid1 = _errs10 === errors;
                    if (_valid1 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid1) {
                            valid3 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid3) {
                        const err5 = {
                            instancePath: instancePath + '/leftColumn',
                            schemaPath: '#/properties/leftColumn/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                        validate15.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs6;
                        if (vErrors !== null) {
                            if (_errs6) {
                                vErrors.length = _errs6;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.rightColumn !== undefined) {
                        let data2 = data.rightColumn;
                        const _errs12 = errors;
                        const _errs13 = errors;
                        let valid5 = false;
                        let passing1 = null;
                        const _errs14 = errors;
                        const _errs15 = errors;
                        if (errors === _errs15) {
                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                const err6 = {
                                    instancePath: instancePath + '/rightColumn',
                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs14 === errors;
                        if (_valid2) {
                            valid5 = true;
                            passing1 = 0;
                        }
                        const _errs17 = errors;
                        if (typeof data2 !== 'string') {
                            const err7 = {
                                instancePath: instancePath + '/rightColumn',
                                schemaPath: '#/properties/rightColumn/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        var _valid2 = _errs17 === errors;
                        if (_valid2 && valid5) {
                            valid5 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid2) {
                                valid5 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid5) {
                            const err8 = {
                                instancePath: instancePath + '/rightColumn',
                                schemaPath: '#/properties/rightColumn/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            validate15.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs13;
                            if (vErrors !== null) {
                                if (_errs13) {
                                    vErrors.length = _errs13;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid2 = _errs12 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.operator !== undefined) {
                            let data3 = data.operator;
                            const _errs19 = errors;
                            const _errs20 = errors;
                            let valid7 = false;
                            let passing2 = null;
                            const _errs21 = errors;
                            const _errs22 = errors;
                            if (errors === _errs22) {
                                if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                    if (data3.toolEnumType !== undefined) {
                                        let data4 = data3.toolEnumType;
                                        if (typeof data4 !== 'string') {
                                            const err9 = {
                                                instancePath: instancePath + '/operator/toolEnumType',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err9];
                                            }
                                            else {
                                                vErrors.push(err9);
                                            }
                                            errors++;
                                        }
                                        if (!(data4 === 'SortDirection' ||
                                            data4 === 'AggregateColumnOperation' ||
                                            data4 === 'DateFrequency' ||
                                            data4 === 'DateAddType' ||
                                            data4 === 'DateAddUnit' ||
                                            data4 === 'DateUnitType' ||
                                            data4 === 'DatePartType' ||
                                            data4 === 'JoinOperator' ||
                                            data4 === 'JoinPattern' ||
                                            data4 === 'FilterStatementOp' ||
                                            data4 === 'ColumnType' ||
                                            data4 === 'PeriodAddType')) {
                                            const err10 = {
                                                instancePath: instancePath + '/operator/toolEnumType',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err10];
                                            }
                                            else {
                                                vErrors.push(err10);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err11 = {
                                        instancePath: instancePath + '/operator',
                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err11];
                                    }
                                    else {
                                        vErrors.push(err11);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs21 === errors;
                            if (_valid3) {
                                valid7 = true;
                                passing2 = 0;
                            }
                            const _errs26 = errors;
                            if (typeof data3 !== 'string') {
                                const err12 = {
                                    instancePath: instancePath + '/operator',
                                    schemaPath: '#/properties/operator/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            if (!(data3 === 'equal' ||
                                data3 === 'less_than' ||
                                data3 === 'less_than_or_equal' ||
                                data3 === 'greater_than' ||
                                data3 === 'greater_than_or_equal' ||
                                data3 === 'like')) {
                                const err13 = {
                                    instancePath: instancePath + '/operator',
                                    schemaPath: '#/properties/operator/oneOf/1/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema33.properties.operator.oneOf[1].enum },
                                    message: 'must be equal to one of the allowed values'
                                };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            var _valid3 = _errs26 === errors;
                            if (_valid3 && valid7) {
                                valid7 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid7 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid7) {
                                const err14 = {
                                    instancePath: instancePath + '/operator',
                                    schemaPath: '#/properties/operator/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                                validate15.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs20;
                                if (vErrors !== null) {
                                    if (_errs20) {
                                        vErrors.length = _errs20;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid2 = _errs19 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.pattern !== undefined) {
                                let data5 = data.pattern;
                                const _errs28 = errors;
                                const _errs29 = errors;
                                let valid10 = false;
                                let passing3 = null;
                                const _errs30 = errors;
                                const _errs31 = errors;
                                if (errors === _errs31) {
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        if (data5.toolEnumType !== undefined) {
                                            let data6 = data5.toolEnumType;
                                            if (typeof data6 !== 'string') {
                                                const err15 = {
                                                    instancePath: instancePath + '/pattern/toolEnumType',
                                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err15];
                                                }
                                                else {
                                                    vErrors.push(err15);
                                                }
                                                errors++;
                                            }
                                            if (!(data6 === 'SortDirection' ||
                                                data6 === 'AggregateColumnOperation' ||
                                                data6 === 'DateFrequency' ||
                                                data6 === 'DateAddType' ||
                                                data6 === 'DateAddUnit' ||
                                                data6 === 'DateUnitType' ||
                                                data6 === 'DatePartType' ||
                                                data6 === 'JoinOperator' ||
                                                data6 === 'JoinPattern' ||
                                                data6 === 'FilterStatementOp' ||
                                                data6 === 'ColumnType' ||
                                                data6 === 'PeriodAddType')) {
                                                const err16 = {
                                                    instancePath: instancePath + '/pattern/toolEnumType',
                                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err16];
                                                }
                                                else {
                                                    vErrors.push(err16);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err17 = {
                                            instancePath: instancePath + '/pattern',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err17];
                                        }
                                        else {
                                            vErrors.push(err17);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs30 === errors;
                                if (_valid4) {
                                    valid10 = true;
                                    passing3 = 0;
                                }
                                const _errs35 = errors;
                                if (typeof data5 !== 'string') {
                                    const err18 = {
                                        instancePath: instancePath + '/pattern',
                                        schemaPath: '#/properties/pattern/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err18];
                                    }
                                    else {
                                        vErrors.push(err18);
                                    }
                                    errors++;
                                }
                                if (!(data5 === 'starts_with' || data5 === 'ends_with' || data5 === 'contains')) {
                                    const err19 = {
                                        instancePath: instancePath + '/pattern',
                                        schemaPath: '#/properties/pattern/oneOf/1/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema33.properties.pattern.oneOf[1].enum },
                                        message: 'must be equal to one of the allowed values'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err19];
                                    }
                                    else {
                                        vErrors.push(err19);
                                    }
                                    errors++;
                                }
                                var _valid4 = _errs35 === errors;
                                if (_valid4 && valid10) {
                                    valid10 = false;
                                    passing3 = [passing3, 1];
                                }
                                else {
                                    if (_valid4) {
                                        valid10 = true;
                                        passing3 = 1;
                                    }
                                }
                                if (!valid10) {
                                    const err20 = {
                                        instancePath: instancePath + '/pattern',
                                        schemaPath: '#/properties/pattern/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing3 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err20];
                                    }
                                    else {
                                        vErrors.push(err20);
                                    }
                                    errors++;
                                    validate15.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs29;
                                    if (vErrors !== null) {
                                        if (_errs29) {
                                            vErrors.length = _errs29;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid2 = _errs28 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const aggregateColumnSchemaValidation = validate16;
const schema38 = {
    $id: 'urn:wisepipe-base-pipe:AggregateColumn',
    type: 'object',
    properties: {
        column: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        operation: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                {
                    type: 'string',
                    enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
                }
            ]
        },
        alias: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string' }] }
    },
    required: ['operation', 'alias'],
    if: { not: { properties: { operation: { const: 'COUNT' } } } },
    then: { required: ['column'] }
};
const schema41 = { $id: 'urn:wisepipe-base-pipe:StringToolVariable', type: 'object', properties: {} };
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:AggregateColumn" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.operation !== undefined) {
            if ('COUNT' !== data.operation) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var valid1 = _errs4 === errors;
    if (valid1) {
        const err1 = {};
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.column === undefined && (missing0 = 'column')) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate16.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.operation === undefined && (missing1 = 'operation')) ||
                (data.alias === undefined && (missing1 = 'alias'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data1 = data.column;
                    const _errs7 = errors;
                    const _errs8 = errors;
                    let valid4 = false;
                    let passing0 = null;
                    const _errs9 = errors;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                            const err3 = {
                                instancePath: instancePath + '/column',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid1 = _errs9 === errors;
                    if (_valid1) {
                        valid4 = true;
                        passing0 = 0;
                    }
                    const _errs12 = errors;
                    if (typeof data1 !== 'string') {
                        const err4 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                    var _valid1 = _errs12 === errors;
                    if (_valid1 && valid4) {
                        valid4 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid1) {
                            valid4 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid4) {
                        const err5 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                        validate16.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs8;
                        if (vErrors !== null) {
                            if (_errs8) {
                                vErrors.length = _errs8;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid3 = _errs7 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.operation !== undefined) {
                        let data2 = data.operation;
                        const _errs14 = errors;
                        const _errs15 = errors;
                        let valid6 = false;
                        let passing1 = null;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                if (data2.toolEnumType !== undefined) {
                                    let data3 = data2.toolEnumType;
                                    if (typeof data3 !== 'string') {
                                        const err6 = {
                                            instancePath: instancePath + '/operation/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    if (!(data3 === 'SortDirection' ||
                                        data3 === 'AggregateColumnOperation' ||
                                        data3 === 'DateFrequency' ||
                                        data3 === 'DateAddType' ||
                                        data3 === 'DateAddUnit' ||
                                        data3 === 'DateUnitType' ||
                                        data3 === 'DatePartType' ||
                                        data3 === 'JoinOperator' ||
                                        data3 === 'JoinPattern' ||
                                        data3 === 'FilterStatementOp' ||
                                        data3 === 'ColumnType' ||
                                        data3 === 'PeriodAddType')) {
                                        const err7 = {
                                            instancePath: instancePath + '/operation/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err8 = {
                                    instancePath: instancePath + '/operation',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs16 === errors;
                        if (_valid2) {
                            valid6 = true;
                            passing1 = 0;
                        }
                        const _errs21 = errors;
                        if (typeof data2 !== 'string') {
                            const err9 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                        if (!(data2 === 'MAX' ||
                            data2 === 'MIN' ||
                            data2 === 'COUNT' ||
                            data2 === 'SUM' ||
                            data2 === 'AVG' ||
                            data2 === 'OR' ||
                            data2 === 'AND' ||
                            data2 === 'MEDIAN' ||
                            data2 === 'DIFF' ||
                            data2 === 'PCT' ||
                            data2 === 'SHIFT' ||
                            data2 === 'STDEV')) {
                            const err10 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema38.properties.operation.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                        }
                        var _valid2 = _errs21 === errors;
                        if (_valid2 && valid6) {
                            valid6 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid2) {
                                valid6 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid6) {
                            const err11 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err11];
                            }
                            else {
                                vErrors.push(err11);
                            }
                            errors++;
                            validate16.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs15;
                            if (vErrors !== null) {
                                if (_errs15) {
                                    vErrors.length = _errs15;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid3 = _errs14 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.alias !== undefined) {
                            let data4 = data.alias;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            let valid9 = false;
                            let passing2 = null;
                            const _errs25 = errors;
                            const _errs26 = errors;
                            if (errors === _errs26) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err12 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err12];
                                    }
                                    else {
                                        vErrors.push(err12);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs25 === errors;
                            if (_valid3) {
                                valid9 = true;
                                passing2 = 0;
                            }
                            const _errs28 = errors;
                            if (typeof data4 !== 'string') {
                                const err13 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            var _valid3 = _errs28 === errors;
                            if (_valid3 && valid9) {
                                valid9 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid9 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid9) {
                                const err14 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                                validate16.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs24;
                                if (vErrors !== null) {
                                    if (_errs24) {
                                        vErrors.length = _errs24;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid3 = _errs23 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const aggregateConfigSchemaValidation = validate17;
const schema42 = {
    $id: 'urn:wisepipe-common-pipe:AggregateConfig',
    type: 'object',
    properties: {
        aggregateColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-base-pipe:AggregateColumn' },
            uniqueItemProperties: ['alias']
        },
        groupByColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
            uniqueItems: true
        },
        decimals: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' }, { type: 'integer', minimum: 0, maximum: 14 }]
        }
    },
    required: ['aggregateColumns', 'groupByColumns']
};
const schema44 = { $id: 'urn:wisepipe-base-pipe:NumberToolVariable', type: 'object', properties: {} };
const func11 = ajvEqual;
const func0 = ajvEqual;
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AggregateConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.aggregateColumns === undefined && (missing0 = 'aggregateColumns')) ||
                (data.groupByColumns === undefined && (missing0 = 'groupByColumns'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.aggregateColumns !== undefined) {
                    let data0 = data.aggregateColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate16(data0[i0], {
                                    instancePath: instancePath + '/aggregateColumns/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                const keys0 = schema42.properties.aggregateColumns.uniqueItemProperties;
                                let k0;
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                        let key0 = keys0[k0];
                                        for (i1 = data0.length; i1--;) {
                                            let x0 = data0[i1];
                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                continue;
                                            }
                                            for (j0 = i1; j0--;) {
                                                let y0 = data0[j0];
                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func11(x0[key0], y0[key0])) {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/aggregateColumns',
                                                            schemaPath: '#/properties/aggregateColumns/uniqueItemProperties',
                                                            keyword: 'uniqueItemProperties',
                                                            params: {},
                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/aggregateColumns',
                                    schemaPath: '#/properties/aggregateColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupByColumns !== undefined) {
                        let data2 = data.groupByColumns;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (Array.isArray(data2)) {
                                var valid3 = true;
                                const len1 = data2.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data3 = data2[i2];
                                    const _errs6 = errors;
                                    const _errs7 = errors;
                                    let valid4 = false;
                                    let passing0 = null;
                                    const _errs8 = errors;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                            const err0 = {
                                                instancePath: instancePath + '/groupByColumns/' + i2,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs8 === errors;
                                    if (_valid0) {
                                        valid4 = true;
                                        passing0 = 0;
                                    }
                                    const _errs11 = errors;
                                    if (typeof data3 !== 'string') {
                                        const err1 = {
                                            instancePath: instancePath + '/groupByColumns/' + i2,
                                            schemaPath: '#/properties/groupByColumns/items/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                    var _valid0 = _errs11 === errors;
                                    if (_valid0 && valid4) {
                                        valid4 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid4 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid4) {
                                        const err2 = {
                                            instancePath: instancePath + '/groupByColumns/' + i2,
                                            schemaPath: '#/properties/groupByColumns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                        validate17.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs7;
                                        if (vErrors !== null) {
                                            if (_errs7) {
                                                vErrors.length = _errs7;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid3 = _errs6 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                                if (valid3) {
                                    let i3 = data2.length;
                                    let j1;
                                    if (i3 > 1) {
                                        outer1: for (; i3--;) {
                                            for (j1 = i3; j1--;) {
                                                if (func0(data2[i3], data2[j1])) {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupByColumns',
                                                            schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i3, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer1;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/groupByColumns',
                                        schemaPath: '#/properties/groupByColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.decimals !== undefined) {
                            let data4 = data.decimals;
                            const _errs13 = errors;
                            const _errs14 = errors;
                            let valid7 = false;
                            let passing1 = null;
                            const _errs15 = errors;
                            const _errs16 = errors;
                            if (errors === _errs16) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err3 = {
                                        instancePath: instancePath + '/decimals',
                                        schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err3];
                                    }
                                    else {
                                        vErrors.push(err3);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs15 === errors;
                            if (_valid1) {
                                valid7 = true;
                                passing1 = 0;
                            }
                            const _errs18 = errors;
                            if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                const err4 = {
                                    instancePath: instancePath + '/decimals',
                                    schemaPath: '#/properties/decimals/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                            if (errors === _errs18) {
                                if (typeof data4 == 'number') {
                                    if (data4 > 14 || isNaN(data4)) {
                                        const err5 = {
                                            instancePath: instancePath + '/decimals',
                                            schemaPath: '#/properties/decimals/oneOf/1/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 14 },
                                            message: 'must be <= 14'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err5];
                                        }
                                        else {
                                            vErrors.push(err5);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (data4 < 0 || isNaN(data4)) {
                                            const err6 = {
                                                instancePath: instancePath + '/decimals',
                                                schemaPath: '#/properties/decimals/oneOf/1/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            }
                                            else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                            }
                            var _valid1 = _errs18 === errors;
                            if (_valid1 && valid7) {
                                valid7 = false;
                                passing1 = [passing1, 1];
                            }
                            else {
                                if (_valid1) {
                                    valid7 = true;
                                    passing1 = 1;
                                }
                            }
                            if (!valid7) {
                                const err7 = {
                                    instancePath: instancePath + '/decimals',
                                    schemaPath: '#/properties/decimals/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing1 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                                validate17.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs14;
                                if (vErrors !== null) {
                                    if (_errs14) {
                                        vErrors.length = _errs14;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs13 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const aggregateV2ConfigSchemaValidation = validate19;
const schema45 = {
    $id: 'urn:wisepipe-common-pipe:AggregateV2Config',
    type: 'object',
    properties: {
        aggregateColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-base-pipe:AggregateColumn' },
            uniqueItemProperties: ['alias']
        },
        groupByColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
            uniqueItems: true
        },
        decimals: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' }, { type: 'integer', minimum: 0, maximum: 14 }]
        },
        includeAllNulls: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:BoolToolVariable' }, { type: 'boolean' }] }
    },
    required: ['aggregateColumns', 'groupByColumns']
};
const schema48 = { $id: 'urn:wisepipe-base-pipe:BoolToolVariable', type: 'object', properties: {} };
const func13 = ajvEqual;
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AggregateV2Config" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.aggregateColumns === undefined && (missing0 = 'aggregateColumns')) ||
                (data.groupByColumns === undefined && (missing0 = 'groupByColumns'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.aggregateColumns !== undefined) {
                    let data0 = data.aggregateColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate16(data0[i0], {
                                    instancePath: instancePath + '/aggregateColumns/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                const keys0 = schema45.properties.aggregateColumns.uniqueItemProperties;
                                let k0;
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                        let key0 = keys0[k0];
                                        for (i1 = data0.length; i1--;) {
                                            let x0 = data0[i1];
                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                continue;
                                            }
                                            for (j0 = i1; j0--;) {
                                                let y0 = data0[j0];
                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func13(x0[key0], y0[key0])) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/aggregateColumns',
                                                            schemaPath: '#/properties/aggregateColumns/uniqueItemProperties',
                                                            keyword: 'uniqueItemProperties',
                                                            params: {},
                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/aggregateColumns',
                                    schemaPath: '#/properties/aggregateColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupByColumns !== undefined) {
                        let data2 = data.groupByColumns;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (Array.isArray(data2)) {
                                var valid3 = true;
                                const len1 = data2.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data3 = data2[i2];
                                    const _errs6 = errors;
                                    const _errs7 = errors;
                                    let valid4 = false;
                                    let passing0 = null;
                                    const _errs8 = errors;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                            const err0 = {
                                                instancePath: instancePath + '/groupByColumns/' + i2,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs8 === errors;
                                    if (_valid0) {
                                        valid4 = true;
                                        passing0 = 0;
                                    }
                                    const _errs11 = errors;
                                    if (typeof data3 !== 'string') {
                                        const err1 = {
                                            instancePath: instancePath + '/groupByColumns/' + i2,
                                            schemaPath: '#/properties/groupByColumns/items/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                    var _valid0 = _errs11 === errors;
                                    if (_valid0 && valid4) {
                                        valid4 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid4 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid4) {
                                        const err2 = {
                                            instancePath: instancePath + '/groupByColumns/' + i2,
                                            schemaPath: '#/properties/groupByColumns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                        validate19.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs7;
                                        if (vErrors !== null) {
                                            if (_errs7) {
                                                vErrors.length = _errs7;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid3 = _errs6 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                                if (valid3) {
                                    let i3 = data2.length;
                                    let j1;
                                    if (i3 > 1) {
                                        outer1: for (; i3--;) {
                                            for (j1 = i3; j1--;) {
                                                if (func0(data2[i3], data2[j1])) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupByColumns',
                                                            schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i3, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer1;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/groupByColumns',
                                        schemaPath: '#/properties/groupByColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.decimals !== undefined) {
                            let data4 = data.decimals;
                            const _errs13 = errors;
                            const _errs14 = errors;
                            let valid7 = false;
                            let passing1 = null;
                            const _errs15 = errors;
                            const _errs16 = errors;
                            if (errors === _errs16) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err3 = {
                                        instancePath: instancePath + '/decimals',
                                        schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err3];
                                    }
                                    else {
                                        vErrors.push(err3);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs15 === errors;
                            if (_valid1) {
                                valid7 = true;
                                passing1 = 0;
                            }
                            const _errs18 = errors;
                            if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                const err4 = {
                                    instancePath: instancePath + '/decimals',
                                    schemaPath: '#/properties/decimals/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                            if (errors === _errs18) {
                                if (typeof data4 == 'number') {
                                    if (data4 > 14 || isNaN(data4)) {
                                        const err5 = {
                                            instancePath: instancePath + '/decimals',
                                            schemaPath: '#/properties/decimals/oneOf/1/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 14 },
                                            message: 'must be <= 14'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err5];
                                        }
                                        else {
                                            vErrors.push(err5);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (data4 < 0 || isNaN(data4)) {
                                            const err6 = {
                                                instancePath: instancePath + '/decimals',
                                                schemaPath: '#/properties/decimals/oneOf/1/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            }
                                            else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                            }
                            var _valid1 = _errs18 === errors;
                            if (_valid1 && valid7) {
                                valid7 = false;
                                passing1 = [passing1, 1];
                            }
                            else {
                                if (_valid1) {
                                    valid7 = true;
                                    passing1 = 1;
                                }
                            }
                            if (!valid7) {
                                const err7 = {
                                    instancePath: instancePath + '/decimals',
                                    schemaPath: '#/properties/decimals/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing1 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                                validate19.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs14;
                                if (vErrors !== null) {
                                    if (_errs14) {
                                        vErrors.length = _errs14;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs13 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.includeAllNulls !== undefined) {
                                let data5 = data.includeAllNulls;
                                const _errs20 = errors;
                                const _errs21 = errors;
                                let valid9 = false;
                                let passing2 = null;
                                const _errs22 = errors;
                                const _errs23 = errors;
                                if (errors === _errs23) {
                                    if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                        const err8 = {
                                            instancePath: instancePath + '/includeAllNulls',
                                            schemaPath: 'urn:wisepipe-base-pipe:BoolToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err8];
                                        }
                                        else {
                                            vErrors.push(err8);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs22 === errors;
                                if (_valid2) {
                                    valid9 = true;
                                    passing2 = 0;
                                }
                                const _errs25 = errors;
                                if (typeof data5 !== 'boolean') {
                                    const err9 = {
                                        instancePath: instancePath + '/includeAllNulls',
                                        schemaPath: '#/properties/includeAllNulls/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err9];
                                    }
                                    else {
                                        vErrors.push(err9);
                                    }
                                    errors++;
                                }
                                var _valid2 = _errs25 === errors;
                                if (_valid2 && valid9) {
                                    valid9 = false;
                                    passing2 = [passing2, 1];
                                }
                                else {
                                    if (_valid2) {
                                        valid9 = true;
                                        passing2 = 1;
                                    }
                                }
                                if (!valid9) {
                                    const err10 = {
                                        instancePath: instancePath + '/includeAllNulls',
                                        schemaPath: '#/properties/includeAllNulls/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing2 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                    validate19.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs21;
                                    if (vErrors !== null) {
                                        if (_errs21) {
                                            vErrors.length = _errs21;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs20 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const amortizationConfigSchemaValidation = validate21;
const schema49 = {
    $id: 'urn:wisepipe-common-pipe:AmortizationConfig',
    type: 'object',
    properties: {
        valueColumn: { type: 'string', minLength: 1 },
        startDateColumn: { type: 'string', minLength: 1 },
        endDateColumn: { type: 'string', minLength: 1 },
        minStartDate: { type: 'string', format: 'date-time' },
        maxEndDate: { type: 'string', format: 'date-time' },
        durationUnits: { type: 'string', enum: ['days', 'weeks', 'biweeks', 'months', 'quarters', 'years'] },
        interestRate: { type: 'number', minimum: 0, maximum: 1 },
        indexColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        isEven: { type: 'boolean' },
        maxResultColumns: { type: 'number', minimum: 0, maximum: 100 }
    },
    required: [
        'indexColumns',
        'valueColumn',
        'startDateColumn',
        'endDateColumn',
        'minStartDate',
        'maxEndDate',
        'durationUnits',
        'isEven',
        'maxResultColumns'
    ]
};
const formats0 = formatWrapper['date-time'];
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AmortizationConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.indexColumns === undefined && (missing0 = 'indexColumns')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn')) ||
                (data.startDateColumn === undefined && (missing0 = 'startDateColumn')) ||
                (data.endDateColumn === undefined && (missing0 = 'endDateColumn')) ||
                (data.minStartDate === undefined && (missing0 = 'minStartDate')) ||
                (data.maxEndDate === undefined && (missing0 = 'maxEndDate')) ||
                (data.durationUnits === undefined && (missing0 = 'durationUnits')) ||
                (data.isEven === undefined && (missing0 = 'isEven')) ||
                (data.maxResultColumns === undefined && (missing0 = 'maxResultColumns'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.valueColumn !== undefined) {
                    let data0 = data.valueColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/valueColumn',
                                    schemaPath: '#/properties/valueColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.startDateColumn !== undefined) {
                        let data1 = data.startDateColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/startDateColumn',
                                            schemaPath: '#/properties/startDateColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/startDateColumn',
                                        schemaPath: '#/properties/startDateColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.endDateColumn !== undefined) {
                            let data2 = data.endDateColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/endDateColumn',
                                                schemaPath: '#/properties/endDateColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/endDateColumn',
                                            schemaPath: '#/properties/endDateColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.minStartDate !== undefined) {
                                let data3 = data.minStartDate;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.validate(data3)) {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/minStartDate',
                                                        schemaPath: '#/properties/minStartDate/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/minStartDate',
                                                    schemaPath: '#/properties/minStartDate/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.maxEndDate !== undefined) {
                                    let data4 = data.maxEndDate;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate21.errors = [
                                                        {
                                                            instancePath: instancePath + '/maxEndDate',
                                                            schemaPath: '#/properties/maxEndDate/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/maxEndDate',
                                                        schemaPath: '#/properties/maxEndDate/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.durationUnits !== undefined) {
                                        let data5 = data.durationUnits;
                                        const _errs11 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/durationUnits',
                                                    schemaPath: '#/properties/durationUnits/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'days' ||
                                            data5 === 'weeks' ||
                                            data5 === 'biweeks' ||
                                            data5 === 'months' ||
                                            data5 === 'quarters' ||
                                            data5 === 'years')) {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/durationUnits',
                                                    schemaPath: '#/properties/durationUnits/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema49.properties.durationUnits.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.interestRate !== undefined) {
                                            let data6 = data.interestRate;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 == 'number') {
                                                    if (data6 > 1 || isNaN(data6)) {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/interestRate',
                                                                schemaPath: '#/properties/interestRate/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 1 },
                                                                message: 'must be <= 1'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data6 < 0 || isNaN(data6)) {
                                                            validate21.errors = [
                                                                {
                                                                    instancePath: instancePath + '/interestRate',
                                                                    schemaPath: '#/properties/interestRate/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate21.errors = [
                                                        {
                                                            instancePath: instancePath + '/interestRate',
                                                            schemaPath: '#/properties/interestRate/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.indexColumns !== undefined) {
                                                let data7 = data.indexColumns;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (Array.isArray(data7)) {
                                                        var valid1 = true;
                                                        const len0 = data7.length;
                                                        for (let i0 = 0; i0 < len0; i0++) {
                                                            const _errs17 = errors;
                                                            if (typeof data7[i0] !== 'string') {
                                                                validate21.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/indexColumns/' + i0,
                                                                        schemaPath: '#/properties/indexColumns/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid1 = _errs17 === errors;
                                                            if (!valid1) {
                                                                break;
                                                            }
                                                        }
                                                        if (valid1) {
                                                            let i1 = data7.length;
                                                            let j0;
                                                            if (i1 > 1) {
                                                                const indices0 = {};
                                                                for (; i1--;) {
                                                                    let item0 = data7[i1];
                                                                    if (typeof item0 !== 'string') {
                                                                        continue;
                                                                    }
                                                                    if (typeof indices0[item0] == 'number') {
                                                                        j0 = indices0[item0];
                                                                        validate21.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/indexColumns',
                                                                                schemaPath: '#/properties/indexColumns/uniqueItems',
                                                                                keyword: 'uniqueItems',
                                                                                params: { i: i1, j: j0 },
                                                                                message: 'must NOT have duplicate items (items ## ' +
                                                                                    j0 +
                                                                                    ' and ' +
                                                                                    i1 +
                                                                                    ' are identical)'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                        break;
                                                                    }
                                                                    indices0[item0] = i1;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/indexColumns',
                                                                schemaPath: '#/properties/indexColumns/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.isEven !== undefined) {
                                                    const _errs19 = errors;
                                                    if (typeof data.isEven !== 'boolean') {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/isEven',
                                                                schemaPath: '#/properties/isEven/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.maxResultColumns !== undefined) {
                                                        let data10 = data.maxResultColumns;
                                                        const _errs21 = errors;
                                                        if (errors === _errs21) {
                                                            if (typeof data10 == 'number') {
                                                                if (data10 > 100 || isNaN(data10)) {
                                                                    validate21.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/maxResultColumns',
                                                                            schemaPath: '#/properties/maxResultColumns/maximum',
                                                                            keyword: 'maximum',
                                                                            params: { comparison: '<=', limit: 100 },
                                                                            message: 'must be <= 100'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data10 < 0 || isNaN(data10)) {
                                                                        validate21.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/maxResultColumns',
                                                                                schemaPath: '#/properties/maxResultColumns/minimum',
                                                                                keyword: 'minimum',
                                                                                params: { comparison: '>=', limit: 0 },
                                                                                message: 'must be >= 0'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate21.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/maxResultColumns',
                                                                        schemaPath: '#/properties/maxResultColumns/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs21 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const arimaForecastConfigSchemaValidation = validate22;
const schema50 = { $id: 'urn:wisepipe-common-pipe:ArimaForecastConfig', type: 'object', properties: {}, required: [] };
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ArimaForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const assignmentOptimizationConfigSchemaValidation = validate23;
const schema51 = {
    $id: 'urn:wisepipe-common-pipe:AssignmentOptimizationConfig',
    type: 'object',
    properties: {
        itemsToAssignColumn: { type: 'string', minLength: 1 },
        assigneeColumn: { type: 'string', minLength: 1 },
        valuesToOptimizeColumn: { type: 'string', minLength: 1 },
        functionToOptimize: { type: 'string', enum: ['balance', 'minimize', 'maximize'] },
        multipleValuesPerItems: { type: 'boolean' },
        mappingColumn: { type: 'string', minLength: 1 },
        constraints: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint' } },
        assignAllTasks: { type: 'boolean' },
        assignmentLockColumn: { type: 'string', minLength: 1 },
        groupingColumn: { type: 'string', minLength: 1 },
        maxTime: { type: 'number', minimum: 15, maximum: 86400 },
        solverType: { type: 'string', enum: ['CP-SAT', 'SCIP'] }
    },
    required: [
        'itemsToAssignColumn',
        'assigneeColumn',
        'valuesToOptimizeColumn',
        'functionToOptimize',
        'multipleValuesPerItems',
        'assignAllTasks',
        'maxTime'
    ]
};
const schema52 = {
    $id: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint',
    type: 'object',
    properties: {
        valueColumn: { type: 'string', minLength: 1 },
        lowerThreshold: { type: 'number' },
        upperThreshold: { type: 'number' }
    },
    required: ['valueColumn']
};
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AssignmentOptimizationConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.itemsToAssignColumn === undefined && (missing0 = 'itemsToAssignColumn')) ||
                (data.assigneeColumn === undefined && (missing0 = 'assigneeColumn')) ||
                (data.valuesToOptimizeColumn === undefined && (missing0 = 'valuesToOptimizeColumn')) ||
                (data.functionToOptimize === undefined && (missing0 = 'functionToOptimize')) ||
                (data.multipleValuesPerItems === undefined && (missing0 = 'multipleValuesPerItems')) ||
                (data.assignAllTasks === undefined && (missing0 = 'assignAllTasks')) ||
                (data.maxTime === undefined && (missing0 = 'maxTime'))) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.itemsToAssignColumn !== undefined) {
                    let data0 = data.itemsToAssignColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/itemsToAssignColumn',
                                        schemaPath: '#/properties/itemsToAssignColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate23.errors = [
                                {
                                    instancePath: instancePath + '/itemsToAssignColumn',
                                    schemaPath: '#/properties/itemsToAssignColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.assigneeColumn !== undefined) {
                        let data1 = data.assigneeColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/assigneeColumn',
                                            schemaPath: '#/properties/assigneeColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/assigneeColumn',
                                        schemaPath: '#/properties/assigneeColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.valuesToOptimizeColumn !== undefined) {
                            let data2 = data.valuesToOptimizeColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/valuesToOptimizeColumn',
                                                schemaPath: '#/properties/valuesToOptimizeColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/valuesToOptimizeColumn',
                                            schemaPath: '#/properties/valuesToOptimizeColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.functionToOptimize !== undefined) {
                                let data3 = data.functionToOptimize;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/functionToOptimize',
                                            schemaPath: '#/properties/functionToOptimize/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'balance' || data3 === 'minimize' || data3 === 'maximize')) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/functionToOptimize',
                                            schemaPath: '#/properties/functionToOptimize/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema51.properties.functionToOptimize.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.multipleValuesPerItems !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.multipleValuesPerItems !== 'boolean') {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/multipleValuesPerItems',
                                                schemaPath: '#/properties/multipleValuesPerItems/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.mappingColumn !== undefined) {
                                        let data5 = data.mappingColumn;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) < 1) {
                                                    validate23.errors = [
                                                        {
                                                            instancePath: instancePath + '/mappingColumn',
                                                            schemaPath: '#/properties/mappingColumn/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate23.errors = [
                                                    {
                                                        instancePath: instancePath + '/mappingColumn',
                                                        schemaPath: '#/properties/mappingColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.constraints !== undefined) {
                                            let data6 = data.constraints;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (Array.isArray(data6)) {
                                                    var valid1 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data7 = data6[i0];
                                                        const _errs15 = errors;
                                                        const _errs16 = errors;
                                                        if (errors === _errs16) {
                                                            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                let missing1;
                                                                if (data7.valueColumn === undefined && (missing1 = 'valueColumn')) {
                                                                    validate23.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/constraints/' + i0,
                                                                            schemaPath: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing1 },
                                                                            message: "must have required property '" + missing1 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data7.valueColumn !== undefined) {
                                                                        let data8 = data7.valueColumn;
                                                                        const _errs18 = errors;
                                                                        if (errors === _errs18) {
                                                                            if (typeof data8 === 'string') {
                                                                                if (func2(data8) < 1) {
                                                                                    validate23.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/constraints/' + i0 + '/valueColumn',
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint/properties/valueColumn/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate23.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/constraints/' + i0 + '/valueColumn',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint/properties/valueColumn/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid3 = _errs18 === errors;
                                                                    }
                                                                    else {
                                                                        var valid3 = true;
                                                                    }
                                                                    if (valid3) {
                                                                        if (data7.lowerThreshold !== undefined) {
                                                                            const _errs20 = errors;
                                                                            if (!(typeof data7.lowerThreshold == 'number')) {
                                                                                validate23.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/constraints/' + i0 + '/lowerThreshold',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint/properties/lowerThreshold/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid3 = _errs20 === errors;
                                                                        }
                                                                        else {
                                                                            var valid3 = true;
                                                                        }
                                                                        if (valid3) {
                                                                            if (data7.upperThreshold !== undefined) {
                                                                                const _errs22 = errors;
                                                                                if (!(typeof data7.upperThreshold == 'number')) {
                                                                                    validate23.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/constraints/' + i0 + '/upperThreshold',
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint/properties/upperThreshold/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'number' },
                                                                                            message: 'must be number'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid3 = _errs22 === errors;
                                                                            }
                                                                            else {
                                                                                var valid3 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate23.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/constraints/' + i0,
                                                                        schemaPath: 'urn:wisepipe-common-pipe:AssignmentOptimizationConstraint/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid1 = _errs15 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate23.errors = [
                                                        {
                                                            instancePath: instancePath + '/constraints',
                                                            schemaPath: '#/properties/constraints/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.assignAllTasks !== undefined) {
                                                const _errs24 = errors;
                                                if (typeof data.assignAllTasks !== 'boolean') {
                                                    validate23.errors = [
                                                        {
                                                            instancePath: instancePath + '/assignAllTasks',
                                                            schemaPath: '#/properties/assignAllTasks/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs24 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.assignmentLockColumn !== undefined) {
                                                    let data12 = data.assignmentLockColumn;
                                                    const _errs26 = errors;
                                                    if (errors === _errs26) {
                                                        if (typeof data12 === 'string') {
                                                            if (func2(data12) < 1) {
                                                                validate23.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/assignmentLockColumn',
                                                                        schemaPath: '#/properties/assignmentLockColumn/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate23.errors = [
                                                                {
                                                                    instancePath: instancePath + '/assignmentLockColumn',
                                                                    schemaPath: '#/properties/assignmentLockColumn/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs26 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.groupingColumn !== undefined) {
                                                        let data13 = data.groupingColumn;
                                                        const _errs28 = errors;
                                                        if (errors === _errs28) {
                                                            if (typeof data13 === 'string') {
                                                                if (func2(data13) < 1) {
                                                                    validate23.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/groupingColumn',
                                                                            schemaPath: '#/properties/groupingColumn/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate23.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groupingColumn',
                                                                        schemaPath: '#/properties/groupingColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs28 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.maxTime !== undefined) {
                                                            let data14 = data.maxTime;
                                                            const _errs30 = errors;
                                                            if (errors === _errs30) {
                                                                if (typeof data14 == 'number') {
                                                                    if (data14 > 86400 || isNaN(data14)) {
                                                                        validate23.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/maxTime',
                                                                                schemaPath: '#/properties/maxTime/maximum',
                                                                                keyword: 'maximum',
                                                                                params: { comparison: '<=', limit: 86400 },
                                                                                message: 'must be <= 86400'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data14 < 15 || isNaN(data14)) {
                                                                            validate23.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/maxTime',
                                                                                    schemaPath: '#/properties/maxTime/minimum',
                                                                                    keyword: 'minimum',
                                                                                    params: { comparison: '>=', limit: 15 },
                                                                                    message: 'must be >= 15'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate23.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/maxTime',
                                                                            schemaPath: '#/properties/maxTime/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'number' },
                                                                            message: 'must be number'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs30 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.solverType !== undefined) {
                                                                let data15 = data.solverType;
                                                                const _errs32 = errors;
                                                                if (typeof data15 !== 'string') {
                                                                    validate23.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/solverType',
                                                                            schemaPath: '#/properties/solverType/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (!(data15 === 'CP-SAT' || data15 === 'SCIP')) {
                                                                    validate23.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/solverType',
                                                                            schemaPath: '#/properties/solverType/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema51.properties.solverType.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs32 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const assignmentOptimizationConstraintSchemaValidation = validate24;
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AssignmentOptimizationConstraint" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.valueColumn === undefined && (missing0 = 'valueColumn')) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.valueColumn !== undefined) {
                    let data0 = data.valueColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate24.errors = [
                                {
                                    instancePath: instancePath + '/valueColumn',
                                    schemaPath: '#/properties/valueColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.lowerThreshold !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.lowerThreshold == 'number')) {
                            validate24.errors = [
                                {
                                    instancePath: instancePath + '/lowerThreshold',
                                    schemaPath: '#/properties/lowerThreshold/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.upperThreshold !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.upperThreshold == 'number')) {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/upperThreshold',
                                        schemaPath: '#/properties/upperThreshold/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const autoRegressiveForecastConfigSchemaValidation = validate25;
const schema54 = {
    $id: 'urn:wisepipe-common-pipe:AutoRegressiveForecastConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumn: { type: 'string', minLength: 1 },
        alias: { type: 'string', minLength: 1 },
        periods: { type: 'integer', minimum: 1 },
        frequency: { type: 'string', enum: ['D', 'W-MON', 'MS', 'AS-JAN', 'QS-', 'BEST_GUESS'] },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        uncertainty: { type: 'boolean' }
    },
    required: ['dateColumn', 'valueColumn', 'alias', 'periods']
};
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:AutoRegressiveForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn')) ||
                (data.alias === undefined && (missing0 = 'alias')) ||
                (data.periods === undefined && (missing0 = 'periods'))) {
                validate25.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate25.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.valueColumn !== undefined) {
                        let data1 = data.valueColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.alias !== undefined) {
                            let data2 = data.alias;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.periods !== undefined) {
                                let data3 = data.periods;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/periods',
                                            schemaPath: '#/properties/periods/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 1 || isNaN(data3)) {
                                            validate25.errors = [
                                                {
                                                    instancePath: instancePath + '/periods',
                                                    schemaPath: '#/properties/periods/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 1 },
                                                    message: 'must be >= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.frequency !== undefined) {
                                    let data4 = data.frequency;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/frequency',
                                                schemaPath: '#/properties/frequency/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'D' ||
                                        data4 === 'W-MON' ||
                                        data4 === 'MS' ||
                                        data4 === 'AS-JAN' ||
                                        data4 === 'QS-' ||
                                        data4 === 'BEST_GUESS')) {
                                        validate25.errors = [
                                            {
                                                instancePath: instancePath + '/frequency',
                                                schemaPath: '#/properties/frequency/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema54.properties.frequency.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.groupByColumns !== undefined) {
                                        let data5 = data.groupByColumns;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (Array.isArray(data5)) {
                                                var valid1 = true;
                                                const len0 = data5.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    const _errs13 = errors;
                                                    if (typeof data5[i0] !== 'string') {
                                                        validate25.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupByColumns/' + i0,
                                                                schemaPath: '#/properties/groupByColumns/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid1 = _errs13 === errors;
                                                    if (!valid1) {
                                                        break;
                                                    }
                                                }
                                                if (valid1) {
                                                    let i1 = data5.length;
                                                    let j0;
                                                    if (i1 > 1) {
                                                        const indices0 = {};
                                                        for (; i1--;) {
                                                            let item0 = data5[i1];
                                                            if (typeof item0 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices0[item0] == 'number') {
                                                                j0 = indices0[item0];
                                                                validate25.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groupByColumns',
                                                                        schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i1, j: j0 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices0[item0] = i1;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupByColumns',
                                                        schemaPath: '#/properties/groupByColumns/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.uncertainty !== undefined) {
                                            const _errs15 = errors;
                                            if (typeof data.uncertainty !== 'boolean') {
                                                validate25.errors = [
                                                    {
                                                        instancePath: instancePath + '/uncertainty',
                                                        schemaPath: '#/properties/uncertainty/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const baseClassifierConfigSchemaValidation = validate26;
const schema55 = {
    $id: 'urn:wisepipe-common-pipe:BaseClassifierConfig',
    type: 'object',
    properties: {
        excludeColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        autoExclude: { type: 'boolean' },
        autoExcludeCorrMethod: { type: 'string', enum: ['pearson', 'kendall', 'spearman'] },
        autoExcludeCorrThreshold: { type: 'number' },
        autoExcludePpsThreshold: { type: 'number' },
        performanceMeasureMethod: { type: 'string', enum: ['automatic', 'accuracy', 'roc_auc', 'precision', 'recall'] }
    },
    required: ['labelColumn']
};
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BaseClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.labelColumn === undefined && (missing0 = 'labelColumn')) {
                validate26.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.excludeColumns !== undefined) {
                    let data0 = data.excludeColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/excludeColumns/' + i0,
                                                    schemaPath: '#/properties/excludeColumns/items/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate26.errors = [
                                            {
                                                instancePath: instancePath + '/excludeColumns/' + i0,
                                                schemaPath: '#/properties/excludeColumns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    const indices0 = {};
                                    for (; i1--;) {
                                        let item0 = data0[i1];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j0 = indices0[item0];
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/excludeColumns',
                                                    schemaPath: '#/properties/excludeColumns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                }
                                            ];
                                            return false;
                                            break;
                                        }
                                        indices0[item0] = i1;
                                    }
                                }
                            }
                        }
                        else {
                            validate26.errors = [
                                {
                                    instancePath: instancePath + '/excludeColumns',
                                    schemaPath: '#/properties/excludeColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.autoExclude !== undefined) {
                        const _errs5 = errors;
                        if (typeof data.autoExclude !== 'boolean') {
                            validate26.errors = [
                                {
                                    instancePath: instancePath + '/autoExclude',
                                    schemaPath: '#/properties/autoExclude/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.autoExcludeCorrMethod !== undefined) {
                            let data3 = data.autoExcludeCorrMethod;
                            const _errs7 = errors;
                            if (typeof data3 !== 'string') {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/autoExcludeCorrMethod',
                                        schemaPath: '#/properties/autoExcludeCorrMethod/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'pearson' || data3 === 'kendall' || data3 === 'spearman')) {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/autoExcludeCorrMethod',
                                        schemaPath: '#/properties/autoExcludeCorrMethod/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema55.properties.autoExcludeCorrMethod.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.autoExcludeCorrThreshold !== undefined) {
                                const _errs9 = errors;
                                if (!(typeof data.autoExcludeCorrThreshold == 'number')) {
                                    validate26.errors = [
                                        {
                                            instancePath: instancePath + '/autoExcludeCorrThreshold',
                                            schemaPath: '#/properties/autoExcludeCorrThreshold/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.autoExcludePpsThreshold !== undefined) {
                                    const _errs11 = errors;
                                    if (!(typeof data.autoExcludePpsThreshold == 'number')) {
                                        validate26.errors = [
                                            {
                                                instancePath: instancePath + '/autoExcludePpsThreshold',
                                                schemaPath: '#/properties/autoExcludePpsThreshold/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.performanceMeasureMethod !== undefined) {
                                        let data6 = data.performanceMeasureMethod;
                                        const _errs13 = errors;
                                        if (typeof data6 !== 'string') {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/performanceMeasureMethod',
                                                    schemaPath: '#/properties/performanceMeasureMethod/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data6 === 'automatic' ||
                                            data6 === 'accuracy' ||
                                            data6 === 'roc_auc' ||
                                            data6 === 'precision' ||
                                            data6 === 'recall')) {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/performanceMeasureMethod',
                                                    schemaPath: '#/properties/performanceMeasureMethod/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema55.properties.performanceMeasureMethod.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate26.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
export const baseForecastConfigSchemaValidation = validate27;
const schema56 = {
    $id: 'urn:wisepipe-common-pipe:BaseForecastConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumn: { type: 'string', minLength: 1 },
        alias: { type: 'string', minLength: 1 },
        periods: { type: 'integer', minimum: 1 },
        frequency: { type: 'string', enum: ['D', 'W-MON', 'MS', 'AS-JAN', 'QS-', 'BEST_GUESS'] },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        uncertainty: { type: 'boolean' },
        ignoreLimit: { type: 'boolean' },
        isMultiVariate: { type: 'boolean' },
        staticAttributes: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        excludeColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        smartExclude: { type: 'boolean' },
        performanceMeasureMethod: {
            type: 'string',
            enum: ['automatic', 'r2', 'neg_mean_absolute_error', 'neg_mean_squared_error', 'smape']
        }
    },
    required: ['dateColumn', 'valueColumn', 'alias', 'periods']
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BaseForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn')) ||
                (data.alias === undefined && (missing0 = 'alias')) ||
                (data.periods === undefined && (missing0 = 'periods'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.valueColumn !== undefined) {
                        let data1 = data.valueColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.alias !== undefined) {
                            let data2 = data.alias;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.periods !== undefined) {
                                let data3 = data.periods;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/periods',
                                            schemaPath: '#/properties/periods/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 1 || isNaN(data3)) {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/periods',
                                                    schemaPath: '#/properties/periods/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 1 },
                                                    message: 'must be >= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.frequency !== undefined) {
                                    let data4 = data.frequency;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/frequency',
                                                schemaPath: '#/properties/frequency/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'D' ||
                                        data4 === 'W-MON' ||
                                        data4 === 'MS' ||
                                        data4 === 'AS-JAN' ||
                                        data4 === 'QS-' ||
                                        data4 === 'BEST_GUESS')) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/frequency',
                                                schemaPath: '#/properties/frequency/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema56.properties.frequency.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.groupByColumns !== undefined) {
                                        let data5 = data.groupByColumns;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (Array.isArray(data5)) {
                                                var valid1 = true;
                                                const len0 = data5.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    const _errs13 = errors;
                                                    if (typeof data5[i0] !== 'string') {
                                                        validate27.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupByColumns/' + i0,
                                                                schemaPath: '#/properties/groupByColumns/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid1 = _errs13 === errors;
                                                    if (!valid1) {
                                                        break;
                                                    }
                                                }
                                                if (valid1) {
                                                    let i1 = data5.length;
                                                    let j0;
                                                    if (i1 > 1) {
                                                        const indices0 = {};
                                                        for (; i1--;) {
                                                            let item0 = data5[i1];
                                                            if (typeof item0 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices0[item0] == 'number') {
                                                                j0 = indices0[item0];
                                                                validate27.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groupByColumns',
                                                                        schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i1, j: j0 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices0[item0] = i1;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupByColumns',
                                                        schemaPath: '#/properties/groupByColumns/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.uncertainty !== undefined) {
                                            const _errs15 = errors;
                                            if (typeof data.uncertainty !== 'boolean') {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/uncertainty',
                                                        schemaPath: '#/properties/uncertainty/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.ignoreLimit !== undefined) {
                                                const _errs17 = errors;
                                                if (typeof data.ignoreLimit !== 'boolean') {
                                                    validate27.errors = [
                                                        {
                                                            instancePath: instancePath + '/ignoreLimit',
                                                            schemaPath: '#/properties/ignoreLimit/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.isMultiVariate !== undefined) {
                                                    const _errs19 = errors;
                                                    if (typeof data.isMultiVariate !== 'boolean') {
                                                        validate27.errors = [
                                                            {
                                                                instancePath: instancePath + '/isMultiVariate',
                                                                schemaPath: '#/properties/isMultiVariate/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.staticAttributes !== undefined) {
                                                        let data10 = data.staticAttributes;
                                                        const _errs21 = errors;
                                                        if (errors === _errs21) {
                                                            if (Array.isArray(data10)) {
                                                                var valid3 = true;
                                                                const len1 = data10.length;
                                                                for (let i2 = 0; i2 < len1; i2++) {
                                                                    const _errs23 = errors;
                                                                    if (typeof data10[i2] !== 'string') {
                                                                        validate27.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/staticAttributes/' + i2,
                                                                                schemaPath: '#/properties/staticAttributes/items/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs23 === errors;
                                                                    if (!valid3) {
                                                                        break;
                                                                    }
                                                                }
                                                                if (valid3) {
                                                                    let i3 = data10.length;
                                                                    let j1;
                                                                    if (i3 > 1) {
                                                                        const indices1 = {};
                                                                        for (; i3--;) {
                                                                            let item1 = data10[i3];
                                                                            if (typeof item1 !== 'string') {
                                                                                continue;
                                                                            }
                                                                            if (typeof indices1[item1] == 'number') {
                                                                                j1 = indices1[item1];
                                                                                validate27.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/staticAttributes',
                                                                                        schemaPath: '#/properties/staticAttributes/uniqueItems',
                                                                                        keyword: 'uniqueItems',
                                                                                        params: { i: i3, j: j1 },
                                                                                        message: 'must NOT have duplicate items (items ## ' +
                                                                                            j1 +
                                                                                            ' and ' +
                                                                                            i3 +
                                                                                            ' are identical)'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                                break;
                                                                            }
                                                                            indices1[item1] = i3;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate27.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/staticAttributes',
                                                                        schemaPath: '#/properties/staticAttributes/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'array' },
                                                                        message: 'must be array'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs21 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.excludeColumns !== undefined) {
                                                            let data12 = data.excludeColumns;
                                                            const _errs25 = errors;
                                                            if (errors === _errs25) {
                                                                if (Array.isArray(data12)) {
                                                                    var valid5 = true;
                                                                    const len2 = data12.length;
                                                                    for (let i4 = 0; i4 < len2; i4++) {
                                                                        const _errs27 = errors;
                                                                        if (typeof data12[i4] !== 'string') {
                                                                            validate27.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/excludeColumns/' + i4,
                                                                                    schemaPath: '#/properties/excludeColumns/items/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid5 = _errs27 === errors;
                                                                        if (!valid5) {
                                                                            break;
                                                                        }
                                                                    }
                                                                    if (valid5) {
                                                                        let i5 = data12.length;
                                                                        let j2;
                                                                        if (i5 > 1) {
                                                                            const indices2 = {};
                                                                            for (; i5--;) {
                                                                                let item2 = data12[i5];
                                                                                if (typeof item2 !== 'string') {
                                                                                    continue;
                                                                                }
                                                                                if (typeof indices2[item2] == 'number') {
                                                                                    j2 = indices2[item2];
                                                                                    validate27.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/excludeColumns',
                                                                                            schemaPath: '#/properties/excludeColumns/uniqueItems',
                                                                                            keyword: 'uniqueItems',
                                                                                            params: { i: i5, j: j2 },
                                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                                j2 +
                                                                                                ' and ' +
                                                                                                i5 +
                                                                                                ' are identical)'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                    break;
                                                                                }
                                                                                indices2[item2] = i5;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate27.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/excludeColumns',
                                                                            schemaPath: '#/properties/excludeColumns/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs25 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.smartExclude !== undefined) {
                                                                const _errs29 = errors;
                                                                if (typeof data.smartExclude !== 'boolean') {
                                                                    validate27.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/smartExclude',
                                                                            schemaPath: '#/properties/smartExclude/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs29 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.performanceMeasureMethod !== undefined) {
                                                                    let data15 = data.performanceMeasureMethod;
                                                                    const _errs31 = errors;
                                                                    if (typeof data15 !== 'string') {
                                                                        validate27.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/performanceMeasureMethod',
                                                                                schemaPath: '#/properties/performanceMeasureMethod/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data15 === 'automatic' ||
                                                                        data15 === 'r2' ||
                                                                        data15 === 'neg_mean_absolute_error' ||
                                                                        data15 === 'neg_mean_squared_error' ||
                                                                        data15 === 'smape')) {
                                                                        validate27.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/performanceMeasureMethod',
                                                                                schemaPath: '#/properties/performanceMeasureMethod/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema56.properties.performanceMeasureMethod.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs31 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const baseMachineLearningConfigSchemaValidation = validate28;
const schema57 = {
    $id: 'urn:wisepipe-common-pipe:BaseMachineLearningConfig',
    type: 'object',
    properties: { labelColumn: { type: 'string', minLength: 1, maxLength: 150 } },
    required: ['labelColumn']
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BaseMachineLearningConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.labelColumn === undefined && (missing0 = 'labelColumn')) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.labelColumn !== undefined) {
                    let data0 = data.labelColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/labelColumn',
                                        schemaPath: '#/properties/labelColumn/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/labelColumn',
                                            schemaPath: '#/properties/labelColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/labelColumn',
                                    schemaPath: '#/properties/labelColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const baseOutlierConfigSchemaValidation = validate29;
const schema58 = {
    $id: 'urn:wisepipe-common-pipe:BaseOutlierConfig',
    type: 'object',
    properties: {
        column: { type: 'string', minLength: 1 },
        newColumn: { type: 'string', minLength: 1 },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['column']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BaseOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.column === undefined && (missing0 = 'column')) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data0 = data.column;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/column',
                                    schemaPath: '#/properties/column/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newColumn !== undefined) {
                        let data1 = data.newColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/newColumn',
                                            schemaPath: '#/properties/newColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/newColumn',
                                        schemaPath: '#/properties/newColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.groupByColumns !== undefined) {
                            let data2 = data.groupByColumns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (typeof data2[i0] !== 'string') {
                                            validate29.errors = [
                                                {
                                                    instancePath: instancePath + '/groupByColumns/' + i0,
                                                    schemaPath: '#/properties/groupByColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data2.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data2[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate29.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupByColumns',
                                                            schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/groupByColumns',
                                            schemaPath: '#/properties/groupByColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const baseRegressorConfigSchemaValidation = validate30;
const schema59 = {
    $id: 'urn:wisepipe-common-pipe:BaseRegressorConfig',
    type: 'object',
    properties: {
        excludeColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        autoExclude: { type: 'boolean' },
        autoExcludeCorrMethod: { type: 'string', enum: ['pearson', 'kendall', 'spearman'] },
        autoExcludeCorrThreshold: { type: 'number' },
        autoExcludePpsThreshold: { type: 'number' },
        performanceMeasureMethod: {
            type: 'string',
            enum: ['automatic', 'r2', 'neg_mean_absolute_error', 'neg_mean_squared_error', 'smape']
        }
    },
    required: ['labelColumn']
};
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BaseRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.labelColumn === undefined && (missing0 = 'labelColumn')) {
                validate30.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.excludeColumns !== undefined) {
                    let data0 = data.excludeColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/excludeColumns/' + i0,
                                                    schemaPath: '#/properties/excludeColumns/items/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate30.errors = [
                                            {
                                                instancePath: instancePath + '/excludeColumns/' + i0,
                                                schemaPath: '#/properties/excludeColumns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    const indices0 = {};
                                    for (; i1--;) {
                                        let item0 = data0[i1];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j0 = indices0[item0];
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/excludeColumns',
                                                    schemaPath: '#/properties/excludeColumns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                }
                                            ];
                                            return false;
                                            break;
                                        }
                                        indices0[item0] = i1;
                                    }
                                }
                            }
                        }
                        else {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/excludeColumns',
                                    schemaPath: '#/properties/excludeColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.autoExclude !== undefined) {
                        const _errs5 = errors;
                        if (typeof data.autoExclude !== 'boolean') {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/autoExclude',
                                    schemaPath: '#/properties/autoExclude/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.autoExcludeCorrMethod !== undefined) {
                            let data3 = data.autoExcludeCorrMethod;
                            const _errs7 = errors;
                            if (typeof data3 !== 'string') {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/autoExcludeCorrMethod',
                                        schemaPath: '#/properties/autoExcludeCorrMethod/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'pearson' || data3 === 'kendall' || data3 === 'spearman')) {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/autoExcludeCorrMethod',
                                        schemaPath: '#/properties/autoExcludeCorrMethod/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema59.properties.autoExcludeCorrMethod.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.autoExcludeCorrThreshold !== undefined) {
                                const _errs9 = errors;
                                if (!(typeof data.autoExcludeCorrThreshold == 'number')) {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/autoExcludeCorrThreshold',
                                            schemaPath: '#/properties/autoExcludeCorrThreshold/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.autoExcludePpsThreshold !== undefined) {
                                    const _errs11 = errors;
                                    if (!(typeof data.autoExcludePpsThreshold == 'number')) {
                                        validate30.errors = [
                                            {
                                                instancePath: instancePath + '/autoExcludePpsThreshold',
                                                schemaPath: '#/properties/autoExcludePpsThreshold/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.performanceMeasureMethod !== undefined) {
                                        let data6 = data.performanceMeasureMethod;
                                        const _errs13 = errors;
                                        if (typeof data6 !== 'string') {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/performanceMeasureMethod',
                                                    schemaPath: '#/properties/performanceMeasureMethod/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data6 === 'automatic' ||
                                            data6 === 'r2' ||
                                            data6 === 'neg_mean_absolute_error' ||
                                            data6 === 'neg_mean_squared_error' ||
                                            data6 === 'smape')) {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/performanceMeasureMethod',
                                                    schemaPath: '#/properties/performanceMeasureMethod/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema59.properties.performanceMeasureMethod.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate30.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
export const baseTextClassifierConfigSchemaValidation = validate31;
const schema60 = {
    $id: 'urn:wisepipe-common-pipe:BaseTextClassifierConfig',
    type: 'object',
    properties: { textColumn: { type: 'string', minLength: 1 } },
    required: ['labelColumn', 'textColumn']
};
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BaseTextClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.labelColumn === undefined && (missing0 = 'labelColumn')) ||
                (data.textColumn === undefined && (missing0 = 'textColumn'))) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.textColumn !== undefined) {
                    let data0 = data.textColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/textColumn',
                                        schemaPath: '#/properties/textColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/textColumn',
                                    schemaPath: '#/properties/textColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const batchTransactionInfoSchemaValidation = validate32;
const schema61 = {
    $id: 'urn:wisepipe-common-pipe:BatchTransactionInfo',
    type: 'object',
    properties: {
        transactionID: { type: 'string', uid: 9 },
        batchID: { type: 'string', minLength: 1 },
        totalBatches: { type: 'number' }
    },
    required: ['transactionID', 'batchID', 'totalBatches']
};
const func39 = ucs2length;
const func40 = base64urlToBuffer;
const func41 = base64urlEncode;
const func42 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BatchTransactionInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.transactionID === undefined && (missing0 = 'transactionID')) ||
                (data.batchID === undefined && (missing0 = 'batchID')) ||
                (data.totalBatches === undefined && (missing0 = 'totalBatches'))) {
                validate32.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.transactionID !== undefined) {
                    let data0 = data.transactionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func39(data0) < b64min0 || func39(data0) > b64max0) {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/transactionID',
                                        schemaPath: '#/properties/transactionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func39(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func39(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func40(data0);
                                if (decoded0.length !== 9) {
                                    validate32.errors = [
                                        {
                                            instancePath: instancePath + '/transactionID',
                                            schemaPath: '#/properties/transactionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func41(decoded0);
                                    if (func42(encoded0) !== func42(data0)) {
                                        validate32.errors = [
                                            {
                                                instancePath: instancePath + '/transactionID',
                                                schemaPath: '#/properties/transactionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate32.errors = [
                                {
                                    instancePath: instancePath + '/transactionID',
                                    schemaPath: '#/properties/transactionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.batchID !== undefined) {
                        let data1 = data.batchID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate32.errors = [
                                        {
                                            instancePath: instancePath + '/batchID',
                                            schemaPath: '#/properties/batchID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/batchID',
                                        schemaPath: '#/properties/batchID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.totalBatches !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.totalBatches == 'number')) {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/totalBatches',
                                        schemaPath: '#/properties/totalBatches/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const binningConfigSchemaValidation = validate33;
const schema62 = {
    $id: 'urn:wisepipe-common-pipe:BinningConfig',
    type: 'object',
    properties: {
        method: { type: 'string', enum: ['interval', 'auto_interval', 'quantile', 'manual_quantile'] },
        numBins: { type: 'integer', minimum: 1 },
        srcColumn: { type: 'string', minLength: 1 },
        columnName: { type: 'string', minLength: 1 },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['numBins', 'srcColumn', 'columnName'],
    if: { properties: { method: { const: 'interval' } } },
    then: {
        properties: {
            bins: {
                type: 'array',
                items: { type: 'number' },
                uniqueItems: true,
                minItems: { $data: '1/numBins' },
                maxItems: { $data: '1/numBins' }
            }
        },
        required: ['bins']
    },
    else: {
        if: { properties: { method: { const: 'manual_quantile' } } },
        then: {
            properties: {
                bins: {
                    type: 'array',
                    items: { type: 'number', exclusiveMinimum: 0, exclusiveMaximum: 100 },
                    uniqueItems: true
                }
            },
            required: ['bins']
        }
    }
};
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BinningConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.method !== undefined) {
            if ('interval' !== data.method) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.bins === undefined && (missing0 = 'bins')) {
                validate33.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bins !== undefined) {
                    let data1 = data.bins;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (Array.isArray(data1)) {
                            const vSchema0 = data && data.numBins;
                            if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data1.length > vSchema0)) {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/bins',
                                        schemaPath: '#/then/properties/bins/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: vSchema0 },
                                        message: 'must NOT have more than ' + vSchema0 + ' items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                const vSchema1 = data && data.numBins;
                                if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data1.length < vSchema1)) {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/bins',
                                            schemaPath: '#/then/properties/bins/minItems',
                                            keyword: 'minItems',
                                            params: { limit: vSchema1 },
                                            message: 'must NOT have fewer than ' + vSchema1 + ' items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid3 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (!(typeof data1[i0] == 'number')) {
                                            validate33.errors = [
                                                {
                                                    instancePath: instancePath + '/bins/' + i0,
                                                    schemaPath: '#/then/properties/bins/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs7 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                    if (valid3) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data1[i1];
                                                if (!(typeof item0 == 'number')) {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/bins',
                                                            schemaPath: '#/then/properties/bins/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/bins',
                                    schemaPath: '#/then/properties/bins/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs9 = errors;
        const _errs10 = errors;
        let valid5 = true;
        const _errs11 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.method !== undefined) {
                if ('manual_quantile' !== data.method) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs11 === errors;
        errors = _errs10;
        if (vErrors !== null) {
            if (_errs10) {
                vErrors.length = _errs10;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs13 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.bins === undefined && (missing1 = 'bins')) {
                    validate33.errors = [
                        {
                            instancePath,
                            schemaPath: '#/else/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
                else {
                    if (data.bins !== undefined) {
                        let data4 = data.bins;
                        const _errs14 = errors;
                        if (errors === _errs14) {
                            if (Array.isArray(data4)) {
                                var valid8 = true;
                                const len1 = data4.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data5 = data4[i2];
                                    const _errs16 = errors;
                                    if (errors === _errs16) {
                                        if (typeof data5 == 'number') {
                                            if (data5 >= 100 || isNaN(data5)) {
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/bins/' + i2,
                                                        schemaPath: '#/else/then/properties/bins/items/exclusiveMaximum',
                                                        keyword: 'exclusiveMaximum',
                                                        params: { comparison: '<', limit: 100 },
                                                        message: 'must be < 100'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data5 <= 0 || isNaN(data5)) {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/bins/' + i2,
                                                            schemaPath: '#/else/then/properties/bins/items/exclusiveMinimum',
                                                            keyword: 'exclusiveMinimum',
                                                            params: { comparison: '>', limit: 0 },
                                                            message: 'must be > 0'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate33.errors = [
                                                {
                                                    instancePath: instancePath + '/bins/' + i2,
                                                    schemaPath: '#/else/then/properties/bins/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid8 = _errs16 === errors;
                                    if (!valid8) {
                                        break;
                                    }
                                }
                                if (valid8) {
                                    let i3 = data4.length;
                                    let j1;
                                    if (i3 > 1) {
                                        const indices1 = {};
                                        for (; i3--;) {
                                            let item1 = data4[i3];
                                            if (!(typeof item1 == 'number')) {
                                                continue;
                                            }
                                            if (typeof indices1[item1] == 'number') {
                                                j1 = indices1[item1];
                                                validate33.errors = [
                                                    {
                                                        instancePath: instancePath + '/bins',
                                                        schemaPath: '#/else/then/properties/bins/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i3, j: j1 },
                                                        message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices1[item1] = i3;
                                        }
                                    }
                                }
                            }
                            else {
                                validate33.errors = [
                                    {
                                        instancePath: instancePath + '/bins',
                                        schemaPath: '#/else/then/properties/bins/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
            var _valid1 = _errs13 === errors;
            valid5 = _valid1;
        }
        if (!valid5) {
            const err2 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
            validate33.errors = vErrors;
            return false;
        }
        var _valid0 = _errs9 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate33.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.numBins === undefined && (missing2 = 'numBins')) ||
                (data.srcColumn === undefined && (missing2 = 'srcColumn')) ||
                (data.columnName === undefined && (missing2 = 'columnName'))) {
                validate33.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.method !== undefined) {
                    let data6 = data.method;
                    const _errs18 = errors;
                    if (typeof data6 !== 'string') {
                        validate33.errors = [
                            {
                                instancePath: instancePath + '/method',
                                schemaPath: '#/properties/method/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data6 === 'interval' || data6 === 'auto_interval' || data6 === 'quantile' || data6 === 'manual_quantile')) {
                        validate33.errors = [
                            {
                                instancePath: instancePath + '/method',
                                schemaPath: '#/properties/method/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema62.properties.method.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid10 = _errs18 === errors;
                }
                else {
                    var valid10 = true;
                }
                if (valid10) {
                    if (data.numBins !== undefined) {
                        let data7 = data.numBins;
                        const _errs20 = errors;
                        if (!(typeof data7 == 'number' && !(data7 % 1) && !isNaN(data7))) {
                            validate33.errors = [
                                {
                                    instancePath: instancePath + '/numBins',
                                    schemaPath: '#/properties/numBins/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs20) {
                            if (typeof data7 == 'number') {
                                if (data7 < 1 || isNaN(data7)) {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/numBins',
                                            schemaPath: '#/properties/numBins/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid10 = _errs20 === errors;
                    }
                    else {
                        var valid10 = true;
                    }
                    if (valid10) {
                        if (data.srcColumn !== undefined) {
                            let data8 = data.srcColumn;
                            const _errs22 = errors;
                            if (errors === _errs22) {
                                if (typeof data8 === 'string') {
                                    if (func2(data8) < 1) {
                                        validate33.errors = [
                                            {
                                                instancePath: instancePath + '/srcColumn',
                                                schemaPath: '#/properties/srcColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate33.errors = [
                                        {
                                            instancePath: instancePath + '/srcColumn',
                                            schemaPath: '#/properties/srcColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid10 = _errs22 === errors;
                        }
                        else {
                            var valid10 = true;
                        }
                        if (valid10) {
                            if (data.columnName !== undefined) {
                                let data9 = data.columnName;
                                const _errs24 = errors;
                                if (errors === _errs24) {
                                    if (typeof data9 === 'string') {
                                        if (func2(data9) < 1) {
                                            validate33.errors = [
                                                {
                                                    instancePath: instancePath + '/columnName',
                                                    schemaPath: '#/properties/columnName/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate33.errors = [
                                            {
                                                instancePath: instancePath + '/columnName',
                                                schemaPath: '#/properties/columnName/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid10 = _errs24 === errors;
                            }
                            else {
                                var valid10 = true;
                            }
                            if (valid10) {
                                if (data.groupByColumns !== undefined) {
                                    let data10 = data.groupByColumns;
                                    const _errs26 = errors;
                                    if (errors === _errs26) {
                                        if (Array.isArray(data10)) {
                                            var valid11 = true;
                                            const len2 = data10.length;
                                            for (let i4 = 0; i4 < len2; i4++) {
                                                const _errs28 = errors;
                                                if (typeof data10[i4] !== 'string') {
                                                    validate33.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupByColumns/' + i4,
                                                            schemaPath: '#/properties/groupByColumns/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid11 = _errs28 === errors;
                                                if (!valid11) {
                                                    break;
                                                }
                                            }
                                            if (valid11) {
                                                let i5 = data10.length;
                                                let j2;
                                                if (i5 > 1) {
                                                    const indices2 = {};
                                                    for (; i5--;) {
                                                        let item2 = data10[i5];
                                                        if (typeof item2 !== 'string') {
                                                            continue;
                                                        }
                                                        if (typeof indices2[item2] == 'number') {
                                                            j2 = indices2[item2];
                                                            validate33.errors = [
                                                                {
                                                                    instancePath: instancePath + '/groupByColumns',
                                                                    schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                    keyword: 'uniqueItems',
                                                                    params: { i: i5, j: j2 },
                                                                    message: 'must NOT have duplicate items (items ## ' + j2 + ' and ' + i5 + ' are identical)'
                                                                }
                                                            ];
                                                            return false;
                                                            break;
                                                        }
                                                        indices2[item2] = i5;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate33.errors = [
                                                {
                                                    instancePath: instancePath + '/groupByColumns',
                                                    schemaPath: '#/properties/groupByColumns/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs26 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const boWTextClassifierConfigSchemaValidation = validate34;
const schema63 = {
    $id: 'urn:wisepipe-common-pipe:BoWTextClassifierConfig',
    type: 'object',
    properties: {
        ngramSize: { type: 'integer', minimum: 1, maximum: 10 },
        lossOption: { type: 'integer', minimum: 0, maximum: 4 }
    },
    required: ['ngramSize', 'lossOption']
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:BoWTextClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.ngramSize === undefined && (missing0 = 'ngramSize')) ||
                (data.lossOption === undefined && (missing0 = 'lossOption'))) {
                validate34.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.ngramSize !== undefined) {
                    let data0 = data.ngramSize;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate34.errors = [
                            {
                                instancePath: instancePath + '/ngramSize',
                                schemaPath: '#/properties/ngramSize/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 10 || isNaN(data0)) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/ngramSize',
                                        schemaPath: '#/properties/ngramSize/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 10 },
                                        message: 'must be <= 10'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/ngramSize',
                                            schemaPath: '#/properties/ngramSize/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.lossOption !== undefined) {
                        let data1 = data.lossOption;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/lossOption',
                                    schemaPath: '#/properties/lossOption/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 > 4 || isNaN(data1)) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/lossOption',
                                            schemaPath: '#/properties/lossOption/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 4 },
                                            message: 'must be <= 4'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1 < 0 || isNaN(data1)) {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/lossOption',
                                                schemaPath: '#/properties/lossOption/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const boolToolVariableSchemaValidation = validate35;
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:BoolToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const calcOutputChangeRequestEventSchemaValidation = validate36;
const schema65 = {
    $id: 'urn:wisepipe-common-pipe:CalcOutputChangeRequestEvent',
    type: 'object',
    properties: {
        requestID: { type: 'string', uid: 9 },
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        requestedChanges: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:CalcOutputChangeRequest' } },
        initiatedAt: { type: 'string', format: 'date-time' },
        expireAt: { type: 'string', format: 'date-time' },
        status: { type: 'string', enum: ['pending', 'accepted', 'rejected', 'staged', 'withdrawn'] },
        respondedAt: { type: 'string', format: 'date-time' }
    },
    required: ['requestID', 'orgID', 'pipeID', 'requestedChanges', 'status', 'initiatedAt']
};
const func46 = ucs2length;
const func47 = base64urlToBuffer;
const func48 = base64urlEncode;
const func49 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func50 = ucs2length;
const func51 = base64urlToBuffer;
const func52 = base64urlEncode;
const func53 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const formats4 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const schema66 = {
    $id: 'urn:wisepipe-common-pipe:CalcOutputChangeRequest',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        changeType: { type: 'string', enum: ['modify', 'delete'] },
        newToolConfig: { $ref: 'urn:wisepipe-common-pipe:IncentivesExportConfig' }
    },
    required: ['elementID', 'changeType'],
    if: { properties: { changeType: { const: 'modify' } } },
    then: { required: ['newToolConfig'] }
};
const func54 = ucs2length;
const func55 = base64urlToBuffer;
const func56 = base64urlEncode;
const func57 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema67 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesExportConfig',
    type: 'object',
    properties: {
        exportColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:Column' },
            uniqueItemProperties: ['name']
        },
        uniqueKeys: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['exportColumns']
};
const schema68 = {
    $id: 'urn:wisepipe-common-data:Column',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', pattern: 'number|date|string|boolean|decimal|period' },
        metadata: {
            type: 'object',
            oneOf: [
                {
                    if: { properties: { type: { const: 'period' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' }
                },
                {
                    if: { properties: { type: { const: 'string' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' }
                }
            ]
        },
        isPrimaryKey: { type: 'boolean' }
    },
    required: ['name', 'type'],
    allOf: [
        {
            if: { properties: { type: { const: 'period' } } },
            then: {
                required: ['metadata'],
                properties: { metadata: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' } }
            }
        },
        {
            if: { properties: { type: { const: 'string' } } },
            then: { properties: { metadata: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' } } }
        },
        {
            if: { properties: { type: { enum: ['boolean', 'number', 'decimal', 'date'] } } },
            then: { not: { required: ['metadata'] } }
        }
    ]
};
const schema69 = {
    $id: 'urn:wisepipe-common-data:PeriodColumnMetadata',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, level: { type: 'string', minLength: 1 } },
    required: ['calendarID', 'level']
};
const schema70 = {
    $id: 'urn:wisepipe-common-data:PicklistColumnMetadata',
    type: 'object',
    properties: { table: { type: 'string', minLength: 1 }, column: { type: 'string', minLength: 1 } },
    required: ['table', 'column']
};
const pattern2 = new RegExp('number|date|string|boolean|decimal|period', 'u');
function validate39(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:Column" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('period' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.metadata === undefined && (missing0 = 'metadata')) {
                validate39.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.metadata !== undefined) {
                    let data1 = data.metadata;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            let missing1;
                            if ((data1.calendarID === undefined && (missing1 = 'calendarID')) ||
                                (data1.level === undefined && (missing1 = 'level'))) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1.calendarID !== undefined) {
                                    let data2 = data1.calendarID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/calendarID',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/calendarID',
                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs9 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data1.level !== undefined) {
                                        let data3 = data1.level;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate39.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/level',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/level',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs11 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate39.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate39.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs13 = errors;
        const _errs14 = errors;
        let valid6 = true;
        const _errs15 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs15 === errors;
        errors = _errs14;
        if (vErrors !== null) {
            if (_errs14) {
                vErrors.length = _errs14;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs17 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.metadata !== undefined) {
                    let data5 = data.metadata;
                    const _errs19 = errors;
                    if (errors === _errs19) {
                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                            let missing2;
                            if ((data5.table === undefined && (missing2 = 'table')) ||
                                (data5.column === undefined && (missing2 = 'column'))) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing2 },
                                        message: "must have required property '" + missing2 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data5.table !== undefined) {
                                    let data6 = data5.table;
                                    const _errs21 = errors;
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/table',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/table',
                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs21 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data5.column !== undefined) {
                                        let data7 = data5.column;
                                        const _errs23 = errors;
                                        if (errors === _errs23) {
                                            if (typeof data7 === 'string') {
                                                if (func2(data7) < 1) {
                                                    validate39.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/column',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/column',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs23 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate39.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
            var _valid1 = _errs17 === errors;
            valid6 = _valid1;
        }
        if (!valid6) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate39.errors = vErrors;
            return false;
        }
        var valid0 = _errs13 === errors;
        if (valid0) {
            const _errs25 = errors;
            const _errs26 = errors;
            let valid11 = true;
            const _errs27 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    let data8 = data.type;
                    if (!(data8 === 'boolean' || data8 === 'number' || data8 === 'decimal' || data8 === 'date')) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs27 === errors;
            errors = _errs26;
            if (vErrors !== null) {
                if (_errs26) {
                    vErrors.length = _errs26;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs29 = errors;
                const _errs30 = errors;
                const _errs31 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing3;
                    if (data.metadata === undefined && (missing3 = 'metadata')) {
                        const err5 = {};
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                }
                var valid13 = _errs31 === errors;
                if (valid13) {
                    validate39.errors = [
                        { instancePath, schemaPath: '#/allOf/2/then/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
                    ];
                    return false;
                }
                else {
                    errors = _errs30;
                    if (vErrors !== null) {
                        if (_errs30) {
                            vErrors.length = _errs30;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                }
                var _valid2 = _errs29 === errors;
                valid11 = _valid2;
            }
            if (!valid11) {
                const err6 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
                validate39.errors = vErrors;
                return false;
            }
            var valid0 = _errs25 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.name === undefined && (missing4 = 'name')) || (data.type === undefined && (missing4 = 'type'))) {
                validate39.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data9 = data.name;
                    const _errs32 = errors;
                    if (errors === _errs32) {
                        if (typeof data9 === 'string') {
                            if (func2(data9) > 150) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data9) < 1) {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate39.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid14 = _errs32 === errors;
                }
                else {
                    var valid14 = true;
                }
                if (valid14) {
                    if (data.type !== undefined) {
                        let data10 = data.type;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data10 === 'string') {
                                if (!pattern2.test(data10)) {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'number|date|string|boolean|decimal|period' },
                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal|period' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid14 = _errs34 === errors;
                    }
                    else {
                        var valid14 = true;
                    }
                    if (valid14) {
                        if (data.metadata !== undefined) {
                            let data11 = data.metadata;
                            const _errs36 = errors;
                            if (!(data11 && typeof data11 == 'object' && !Array.isArray(data11))) {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: '#/properties/metadata/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                            const _errs38 = errors;
                            let valid15 = false;
                            let passing0 = null;
                            const _errs39 = errors;
                            const _errs40 = errors;
                            let valid16 = true;
                            const _errs41 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('period' !== data11.type) {
                                        const err7 = {};
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid4 = _errs41 === errors;
                            errors = _errs40;
                            if (vErrors !== null) {
                                if (_errs40) {
                                    vErrors.length = _errs40;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs43 = errors;
                                const _errs44 = errors;
                                if (errors === _errs44) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing5;
                                        if ((data11.calendarID === undefined && (missing5 = 'calendarID')) ||
                                            (data11.level === undefined && (missing5 = 'level'))) {
                                            const err8 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.calendarID !== undefined) {
                                                let data13 = data11.calendarID;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data13 === 'string') {
                                                        if (func2(data13) < 1) {
                                                            const err9 = {
                                                                instancePath: instancePath + '/metadata/calendarID',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err9];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err10 = {
                                                            instancePath: instancePath + '/metadata/calendarID',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err10];
                                                        }
                                                        else {
                                                            vErrors.push(err10);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid19 = _errs46 === errors;
                                            }
                                            else {
                                                var valid19 = true;
                                            }
                                            if (valid19) {
                                                if (data11.level !== undefined) {
                                                    let data14 = data11.level;
                                                    const _errs48 = errors;
                                                    if (errors === _errs48) {
                                                        if (typeof data14 === 'string') {
                                                            if (func2(data14) < 1) {
                                                                const err11 = {
                                                                    instancePath: instancePath + '/metadata/level',
                                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err11];
                                                                }
                                                                else {
                                                                    vErrors.push(err11);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err12 = {
                                                                instancePath: instancePath + '/metadata/level',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err12];
                                                            }
                                                            else {
                                                                vErrors.push(err12);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid19 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid19 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs43 === errors;
                                valid16 = _valid4;
                            }
                            if (!valid16) {
                                const err14 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/0/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            var _valid3 = _errs39 === errors;
                            if (_valid3) {
                                valid15 = true;
                                passing0 = 0;
                            }
                            const _errs50 = errors;
                            const _errs51 = errors;
                            let valid20 = true;
                            const _errs52 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('string' !== data11.type) {
                                        const err15 = {};
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid5 = _errs52 === errors;
                            errors = _errs51;
                            if (vErrors !== null) {
                                if (_errs51) {
                                    vErrors.length = _errs51;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid5) {
                                const _errs54 = errors;
                                const _errs55 = errors;
                                if (errors === _errs55) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing6;
                                        if ((data11.table === undefined && (missing6 = 'table')) ||
                                            (data11.column === undefined && (missing6 = 'column'))) {
                                            const err16 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing6 },
                                                message: "must have required property '" + missing6 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err16];
                                            }
                                            else {
                                                vErrors.push(err16);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.table !== undefined) {
                                                let data16 = data11.table;
                                                const _errs57 = errors;
                                                if (errors === _errs57) {
                                                    if (typeof data16 === 'string') {
                                                        if (func2(data16) < 1) {
                                                            const err17 = {
                                                                instancePath: instancePath + '/metadata/table',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err17];
                                                            }
                                                            else {
                                                                vErrors.push(err17);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err18 = {
                                                            instancePath: instancePath + '/metadata/table',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err18];
                                                        }
                                                        else {
                                                            vErrors.push(err18);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid23 = _errs57 === errors;
                                            }
                                            else {
                                                var valid23 = true;
                                            }
                                            if (valid23) {
                                                if (data11.column !== undefined) {
                                                    let data17 = data11.column;
                                                    const _errs59 = errors;
                                                    if (errors === _errs59) {
                                                        if (typeof data17 === 'string') {
                                                            if (func2(data17) < 1) {
                                                                const err19 = {
                                                                    instancePath: instancePath + '/metadata/column',
                                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err19];
                                                                }
                                                                else {
                                                                    vErrors.push(err19);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err20 = {
                                                                instancePath: instancePath + '/metadata/column',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err20];
                                                            }
                                                            else {
                                                                vErrors.push(err20);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid23 = _errs59 === errors;
                                                }
                                                else {
                                                    var valid23 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err21 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs54 === errors;
                                valid20 = _valid5;
                            }
                            if (!valid20) {
                                const err22 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/1/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                            var _valid3 = _errs50 === errors;
                            if (_valid3 && valid15) {
                                valid15 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid15 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid15) {
                                const err23 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                                validate39.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs38;
                                if (vErrors !== null) {
                                    if (_errs38) {
                                        vErrors.length = _errs38;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid14 = _errs36 === errors;
                        }
                        else {
                            var valid14 = true;
                        }
                        if (valid14) {
                            if (data.isPrimaryKey !== undefined) {
                                const _errs61 = errors;
                                if (typeof data.isPrimaryKey !== 'boolean') {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/isPrimaryKey',
                                            schemaPath: '#/properties/isPrimaryKey/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid14 = _errs61 === errors;
                            }
                            else {
                                var valid14 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate39.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
const func68 = ajvEqual;
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesExportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.exportColumns === undefined && (missing0 = 'exportColumns')) {
                validate38.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.exportColumns !== undefined) {
                    let data0 = data.exportColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate39(data0[i0], {
                                    instancePath: instancePath + '/exportColumns/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                const keys0 = schema67.properties.exportColumns.uniqueItemProperties;
                                let k0;
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                        let key0 = keys0[k0];
                                        for (i1 = data0.length; i1--;) {
                                            let x0 = data0[i1];
                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                continue;
                                            }
                                            for (j0 = i1; j0--;) {
                                                let y0 = data0[j0];
                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func68(x0[key0], y0[key0])) {
                                                    validate38.errors = [
                                                        {
                                                            instancePath: instancePath + '/exportColumns',
                                                            schemaPath: '#/properties/exportColumns/uniqueItemProperties',
                                                            keyword: 'uniqueItemProperties',
                                                            params: {},
                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate38.errors = [
                                {
                                    instancePath: instancePath + '/exportColumns',
                                    schemaPath: '#/properties/exportColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.uniqueKeys !== undefined) {
                        let data2 = data.uniqueKeys;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (Array.isArray(data2)) {
                                var valid3 = true;
                                const len1 = data2.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    const _errs6 = errors;
                                    if (typeof data2[i2] !== 'string') {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/uniqueKeys/' + i2,
                                                schemaPath: '#/properties/uniqueKeys/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid3 = _errs6 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                                if (valid3) {
                                    let i3 = data2.length;
                                    let j1;
                                    if (i3 > 1) {
                                        const indices0 = {};
                                        for (; i3--;) {
                                            let item0 = data2[i3];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j1 = indices0[item0];
                                                validate38.errors = [
                                                    {
                                                        instancePath: instancePath + '/uniqueKeys',
                                                        schemaPath: '#/properties/uniqueKeys/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i3, j: j1 },
                                                        message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i3;
                                        }
                                    }
                                }
                            }
                            else {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/uniqueKeys',
                                        schemaPath: '#/properties/uniqueKeys/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate38.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CalcOutputChangeRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.changeType !== undefined) {
            if ('modify' !== data.changeType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.newToolConfig === undefined && (missing0 = 'newToolConfig')) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate37.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.elementID === undefined && (missing1 = 'elementID')) ||
                (data.changeType === undefined && (missing1 = 'changeType'))) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data1 = data.elementID;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (typeof data1 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func54(data1) < b64min0 || func54(data1) > b64max0) {
                                validate37.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func54(data1) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func54(data1)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func55(data1);
                                if (decoded0.length !== 10) {
                                    validate37.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func56(decoded0);
                                    if (func57(encoded0) !== func57(data1)) {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.changeType !== undefined) {
                        let data2 = data.changeType;
                        const _errs7 = errors;
                        if (typeof data2 !== 'string') {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/changeType',
                                    schemaPath: '#/properties/changeType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'modify' || data2 === 'delete')) {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/changeType',
                                    schemaPath: '#/properties/changeType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema66.properties.changeType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.newToolConfig !== undefined) {
                            const _errs9 = errors;
                            if (!validate38(data.newToolConfig, {
                                instancePath: instancePath + '/newToolConfig',
                                parentData: data,
                                parentDataProperty: 'newToolConfig',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
                                errors = vErrors.length;
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CalcOutputChangeRequestEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.requestID === undefined && (missing0 = 'requestID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.requestedChanges === undefined && (missing0 = 'requestedChanges')) ||
                (data.status === undefined && (missing0 = 'status')) ||
                (data.initiatedAt === undefined && (missing0 = 'initiatedAt'))) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.requestID !== undefined) {
                    let data0 = data.requestID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func46(data0) < b64min0 || func46(data0) > b64max0) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/requestID',
                                        schemaPath: '#/properties/requestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func46(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func46(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func47(data0);
                                if (decoded0.length !== 9) {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/requestID',
                                            schemaPath: '#/properties/requestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func48(decoded0);
                                    if (func49(encoded0) !== func49(data0)) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/requestID',
                                                schemaPath: '#/properties/requestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/requestID',
                                    schemaPath: '#/properties/requestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgID !== undefined) {
                        let data1 = data.orgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pipeID !== undefined) {
                            let data2 = data.pipeID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func50(data2) < b64min1 || func50(data2) > b64max1) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func50(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func50(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func51(data2);
                                        if (decoded1.length !== 10) {
                                            validate36.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func52(decoded1);
                                            if (func53(encoded1) !== func53(data2)) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.requestedChanges !== undefined) {
                                let data3 = data.requestedChanges;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid3 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs9 = errors;
                                            if (!validate37(data3[i0], {
                                                instancePath: instancePath + '/requestedChanges/' + i0,
                                                parentData: data3,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate37.errors : vErrors.concat(validate37.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid3 = _errs9 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/requestedChanges',
                                                schemaPath: '#/properties/requestedChanges/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.initiatedAt !== undefined) {
                                    let data5 = data.initiatedAt;
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (errors === _errs10) {
                                            if (typeof data5 === 'string') {
                                                if (!formats0.validate(data5)) {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/initiatedAt',
                                                            schemaPath: '#/properties/initiatedAt/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/initiatedAt',
                                                        schemaPath: '#/properties/initiatedAt/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs10 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.expireAt !== undefined) {
                                        let data6 = data.expireAt;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (errors === _errs12) {
                                                if (typeof data6 === 'string') {
                                                    if (!formats0.validate(data6)) {
                                                        validate36.errors = [
                                                            {
                                                                instancePath: instancePath + '/expireAt',
                                                                schemaPath: '#/properties/expireAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/expireAt',
                                                            schemaPath: '#/properties/expireAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs12 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.status !== undefined) {
                                            let data7 = data.status;
                                            const _errs14 = errors;
                                            if (typeof data7 !== 'string') {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/status',
                                                        schemaPath: '#/properties/status/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data7 === 'pending' ||
                                                data7 === 'accepted' ||
                                                data7 === 'rejected' ||
                                                data7 === 'staged' ||
                                                data7 === 'withdrawn')) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/status',
                                                        schemaPath: '#/properties/status/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema65.properties.status.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs14 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.respondedAt !== undefined) {
                                                let data8 = data.respondedAt;
                                                const _errs16 = errors;
                                                if (errors === _errs16) {
                                                    if (errors === _errs16) {
                                                        if (typeof data8 === 'string') {
                                                            if (!formats0.validate(data8)) {
                                                                validate36.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/respondedAt',
                                                                        schemaPath: '#/properties/respondedAt/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'date-time' },
                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate36.errors = [
                                                                {
                                                                    instancePath: instancePath + '/respondedAt',
                                                                    schemaPath: '#/properties/respondedAt/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid0 = _errs16 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const calcOutputChangeRequestResponseSchemaValidation = validate43;
const schema73 = {
    $id: 'urn:wisepipe-common-pipe:CalcOutputChangeRequestResponse',
    type: 'object',
    properties: {
        changeRequestID: { type: 'string', uid: 9 },
        status: { type: 'string', enum: ['pending', 'accepted', 'rejected', 'staged', 'withdrawn'] },
        calcOutputElementIDs: { type: 'array', items: { type: 'string', uid: 10 }, uniqueItems: true }
    },
    required: ['changeRequestID', 'status']
};
const func69 = ucs2length;
const func70 = base64urlToBuffer;
const func71 = base64urlEncode;
const func72 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func73 = ucs2length;
const func74 = base64urlToBuffer;
const func75 = base64urlEncode;
const func76 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CalcOutputChangeRequestResponse" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.changeRequestID === undefined && (missing0 = 'changeRequestID')) ||
                (data.status === undefined && (missing0 = 'status'))) {
                validate43.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.changeRequestID !== undefined) {
                    let data0 = data.changeRequestID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func69(data0) < b64min0 || func69(data0) > b64max0) {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/changeRequestID',
                                        schemaPath: '#/properties/changeRequestID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func69(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func69(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func70(data0);
                                if (decoded0.length !== 9) {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/changeRequestID',
                                            schemaPath: '#/properties/changeRequestID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func71(decoded0);
                                    if (func72(encoded0) !== func72(data0)) {
                                        validate43.errors = [
                                            {
                                                instancePath: instancePath + '/changeRequestID',
                                                schemaPath: '#/properties/changeRequestID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/changeRequestID',
                                    schemaPath: '#/properties/changeRequestID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.status !== undefined) {
                        let data1 = data.status;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'pending' ||
                            data1 === 'accepted' ||
                            data1 === 'rejected' ||
                            data1 === 'staged' ||
                            data1 === 'withdrawn')) {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/status',
                                    schemaPath: '#/properties/status/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema73.properties.status.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.calcOutputElementIDs !== undefined) {
                            let data2 = data.calcOutputElementIDs;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid2 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        if (errors === _errs7) {
                                            if (typeof data3 === 'string') {
                                                const b64min1 = Math.ceil((4 * 10) / 3);
                                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                                if (func73(data3) < b64min1 || func73(data3) > b64max1) {
                                                    validate43.errors = [
                                                        {
                                                            instancePath: instancePath + '/calcOutputElementIDs/' + i0,
                                                            schemaPath: '#/properties/calcOutputElementIDs/items/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func73(data3) },
                                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func73(data3)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded1 = func74(data3);
                                                    if (decoded1.length !== 10) {
                                                        validate43.errors = [
                                                            {
                                                                instancePath: instancePath + '/calcOutputElementIDs/' + i0,
                                                                schemaPath: '#/properties/calcOutputElementIDs/items/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 10 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded1 = func75(decoded1);
                                                        if (func76(encoded1) !== func76(data3)) {
                                                            validate43.errors = [
                                                                {
                                                                    instancePath: instancePath + '/calcOutputElementIDs/' + i0,
                                                                    schemaPath: '#/properties/calcOutputElementIDs/items/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate43.errors = [
                                                    {
                                                        instancePath: instancePath + '/calcOutputElementIDs/' + i0,
                                                        schemaPath: '#/properties/calcOutputElementIDs/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs7 === errors;
                                        if (!valid2) {
                                            break;
                                        }
                                    }
                                    if (valid2) {
                                        let i1 = data2.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data2[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate43.errors = [
                                                        {
                                                            instancePath: instancePath + '/calcOutputElementIDs',
                                                            schemaPath: '#/properties/calcOutputElementIDs/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/calcOutputElementIDs',
                                            schemaPath: '#/properties/calcOutputElementIDs/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate43.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const calcOutputChangeRequestSchemaValidation = validate37;
export const calendarToolVariableSchemaValidation = validate44;
const schema74 = { $id: 'urn:wisepipe-base-pipe:CalendarToolVariable', type: 'object', properties: {} };
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:CalendarToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate44.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const caseConditionSchemaValidation = validate45;
const schema75 = {
    $id: 'urn:wisepipe-common-pipe:CaseCondition',
    type: 'object',
    properties: {
        filter: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:CompoundToolVariable' }, { type: 'string', minLength: 1 }] },
        value: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1 }] },
        args: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string' }] }
        }
    },
    required: ['filter', 'value']
};
const schema76 = {
    $id: 'urn:wisepipe-base-pipe:CompoundToolVariable',
    type: 'object',
    properties: { value: { type: 'string' } },
    required: ['value']
};
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CaseCondition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.filter === undefined && (missing0 = 'filter')) || (data.value === undefined && (missing0 = 'value'))) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filter !== undefined) {
                    let data0 = data.filter;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.value === undefined && (missing1 = 'value')) {
                                const err0 = {
                                    instancePath: instancePath + '/filter',
                                    schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing1 },
                                    message: "must have required property '" + missing1 + "'"
                                };
                                if (vErrors === null) {
                                    vErrors = [err0];
                                }
                                else {
                                    vErrors.push(err0);
                                }
                                errors++;
                            }
                            else {
                                if (data0.value !== undefined) {
                                    if (typeof data0.value !== 'string') {
                                        const err1 = {
                                            instancePath: instancePath + '/filter/value',
                                            schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err2 = {
                                instancePath: instancePath + '/filter',
                                schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs8 = errors;
                    if (errors === _errs8) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                const err3 = {
                                    instancePath: instancePath + '/filter',
                                    schemaPath: '#/properties/filter/oneOf/1/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err4 = {
                                instancePath: instancePath + '/filter',
                                schemaPath: '#/properties/filter/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err4];
                            }
                            else {
                                vErrors.push(err4);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs8 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err5 = {
                            instancePath: instancePath + '/filter',
                            schemaPath: '#/properties/filter/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                        validate45.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.value !== undefined) {
                        let data2 = data.value;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        let valid4 = false;
                        let passing1 = null;
                        const _errs12 = errors;
                        const _errs13 = errors;
                        if (errors === _errs13) {
                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                const err6 = {
                                    instancePath: instancePath + '/value',
                                    schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs12 === errors;
                        if (_valid1) {
                            valid4 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (errors === _errs15) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    const err7 = {
                                        instancePath: instancePath + '/value',
                                        schemaPath: '#/properties/value/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err7];
                                    }
                                    else {
                                        vErrors.push(err7);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err8 = {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/properties/value/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid4) {
                            valid4 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid4 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid4) {
                            const err9 = {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/properties/value/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                            validate45.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs11;
                            if (vErrors !== null) {
                                if (_errs11) {
                                    vErrors.length = _errs11;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.args !== undefined) {
                            let data3 = data.args;
                            const _errs17 = errors;
                            if (errors === _errs17) {
                                if (Array.isArray(data3)) {
                                    var valid6 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data4 = data3[i0];
                                        const _errs19 = errors;
                                        const _errs20 = errors;
                                        let valid7 = false;
                                        let passing2 = null;
                                        const _errs21 = errors;
                                        const _errs22 = errors;
                                        if (errors === _errs22) {
                                            if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                                const err10 = {
                                                    instancePath: instancePath + '/args/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err10];
                                                }
                                                else {
                                                    vErrors.push(err10);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid2 = _errs21 === errors;
                                        if (_valid2) {
                                            valid7 = true;
                                            passing2 = 0;
                                        }
                                        const _errs24 = errors;
                                        if (typeof data4 !== 'string') {
                                            const err11 = {
                                                instancePath: instancePath + '/args/' + i0,
                                                schemaPath: '#/properties/args/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err11];
                                            }
                                            else {
                                                vErrors.push(err11);
                                            }
                                            errors++;
                                        }
                                        var _valid2 = _errs24 === errors;
                                        if (_valid2 && valid7) {
                                            valid7 = false;
                                            passing2 = [passing2, 1];
                                        }
                                        else {
                                            if (_valid2) {
                                                valid7 = true;
                                                passing2 = 1;
                                            }
                                        }
                                        if (!valid7) {
                                            const err12 = {
                                                instancePath: instancePath + '/args/' + i0,
                                                schemaPath: '#/properties/args/items/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing2 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err12];
                                            }
                                            else {
                                                vErrors.push(err12);
                                            }
                                            errors++;
                                            validate45.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs20;
                                            if (vErrors !== null) {
                                                if (_errs20) {
                                                    vErrors.length = _errs20;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid6 = _errs19 === errors;
                                        if (!valid6) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate45.errors = [
                                        {
                                            instancePath: instancePath + '/args',
                                            schemaPath: '#/properties/args/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs17 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate45.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
export const caseConfigSchemaValidation = validate46;
const schema79 = {
    $id: 'urn:wisepipe-common-pipe:CaseConfig',
    type: 'object',
    properties: {
        alias: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        conditions: {
            type: 'array',
            items: {
                oneOf: [
                    { $ref: 'urn:wisepipe-common-pipe:CaseCondition' },
                    { $ref: 'urn:wisepipe-common-pipe:CaseFilterCondition' }
                ]
            },
            minItems: 1,
            maxItems: 100
        },
        otherwise: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1 }] }
    },
    required: ['alias', 'conditions']
};
const schema81 = {
    $id: 'urn:wisepipe-common-pipe:CaseFilterCondition',
    type: 'object',
    properties: {
        filter: { $ref: 'urn:wisepipe-common-pipe:FilterGroup' },
        value: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1 }] }
    },
    required: ['filter', 'value']
};
const schema82 = {
    $id: 'urn:wisepipe-common-pipe:FilterGroup',
    type: 'object',
    properties: {
        op: { type: 'string', pattern: 'and|or' },
        filters: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:Filter' }, uniqueItems: true }
    },
    required: ['op', 'filters']
};
const schema83 = {
    $id: 'urn:wisepipe-common-pipe:Filter',
    type: 'object',
    properties: { filterType: { type: 'string', pattern: 'group|statement' } },
    required: ['filterType']
};
const pattern3 = new RegExp('and|or', 'u');
const pattern4 = new RegExp('group|statement', 'u');
function validate49(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FilterGroup" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.op === undefined && (missing0 = 'op')) || (data.filters === undefined && (missing0 = 'filters'))) {
                validate49.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.op !== undefined) {
                    let data0 = data.op;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern3.test(data0)) {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/op',
                                        schemaPath: '#/properties/op/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: 'and|or' },
                                        message: 'must match pattern "' + 'and|or' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate49.errors = [
                                {
                                    instancePath: instancePath + '/op',
                                    schemaPath: '#/properties/op/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.filters !== undefined) {
                        let data1 = data.filters;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if (data2.filterType === undefined && (missing1 = 'filterType')) {
                                                validate49.errors = [
                                                    {
                                                        instancePath: instancePath + '/filters/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:Filter/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.filterType !== undefined) {
                                                    let data3 = data2.filterType;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            if (!pattern4.test(data3)) {
                                                                validate49.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/filters/' + i0 + '/filterType',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:Filter/properties/filterType/pattern',
                                                                        keyword: 'pattern',
                                                                        params: { pattern: 'group|statement' },
                                                                        message: 'must match pattern "' + 'group|statement' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate49.errors = [
                                                                {
                                                                    instancePath: instancePath + '/filters/' + i0 + '/filterType',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:Filter/properties/filterType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate49.errors = [
                                                {
                                                    instancePath: instancePath + '/filters/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:Filter/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data1[i1], data1[j0])) {
                                                    validate49.errors = [
                                                        {
                                                            instancePath: instancePath + '/filters',
                                                            schemaPath: '#/properties/filters/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/filters',
                                        schemaPath: '#/properties/filters/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate49.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate49.errors = vErrors;
    return errors === 0;
}
function validate48(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CaseFilterCondition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.filter === undefined && (missing0 = 'filter')) || (data.value === undefined && (missing0 = 'value'))) {
                validate48.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filter !== undefined) {
                    const _errs1 = errors;
                    if (!validate49(data.filter, {
                        instancePath: instancePath + '/filter',
                        parentData: data,
                        parentDataProperty: 'filter',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate49.errors : vErrors.concat(validate49.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.value !== undefined) {
                        let data1 = data.value;
                        const _errs2 = errors;
                        const _errs3 = errors;
                        let valid1 = false;
                        let passing0 = null;
                        const _errs4 = errors;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                const err0 = {
                                    instancePath: instancePath + '/value',
                                    schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err0];
                                }
                                else {
                                    vErrors.push(err0);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs4 === errors;
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 0;
                        }
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    const err1 = {
                                        instancePath: instancePath + '/value',
                                        schemaPath: '#/properties/value/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err2 = {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/properties/value/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs7 === errors;
                        if (_valid0 && valid1) {
                            valid1 = false;
                            passing0 = [passing0, 1];
                        }
                        else {
                            if (_valid0) {
                                valid1 = true;
                                passing0 = 1;
                            }
                        }
                        if (!valid1) {
                            const err3 = {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/properties/value/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing0 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                            validate48.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs3;
                            if (vErrors !== null) {
                                if (_errs3) {
                                    vErrors.length = _errs3;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate48.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate48.errors = vErrors;
    return errors === 0;
}
function validate46(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CaseConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.alias === undefined && (missing0 = 'alias')) ||
                (data.conditions === undefined && (missing0 = 'conditions'))) {
                validate46.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.alias !== undefined) {
                    let data0 = data.alias;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/alias',
                                schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/alias',
                                schemaPath: '#/properties/alias/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/alias',
                            schemaPath: '#/properties/alias/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate46.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.conditions !== undefined) {
                        let data1 = data.conditions;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (Array.isArray(data1)) {
                                if (data1.length > 100) {
                                    validate46.errors = [
                                        {
                                            instancePath: instancePath + '/conditions',
                                            schemaPath: '#/properties/conditions/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.length < 1) {
                                        validate46.errors = [
                                            {
                                                instancePath: instancePath + '/conditions',
                                                schemaPath: '#/properties/conditions/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid3 = true;
                                        const len0 = data1.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data2 = data1[i0];
                                            const _errs10 = errors;
                                            const _errs11 = errors;
                                            let valid4 = false;
                                            let passing1 = null;
                                            const _errs12 = errors;
                                            if (!validate45(data2, {
                                                instancePath: instancePath + '/conditions/' + i0,
                                                parentData: data1,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
                                                errors = vErrors.length;
                                            }
                                            var _valid1 = _errs12 === errors;
                                            if (_valid1) {
                                                valid4 = true;
                                                passing1 = 0;
                                            }
                                            const _errs13 = errors;
                                            if (!validate48(data2, {
                                                instancePath: instancePath + '/conditions/' + i0,
                                                parentData: data1,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
                                                errors = vErrors.length;
                                            }
                                            var _valid1 = _errs13 === errors;
                                            if (_valid1 && valid4) {
                                                valid4 = false;
                                                passing1 = [passing1, 1];
                                            }
                                            else {
                                                if (_valid1) {
                                                    valid4 = true;
                                                    passing1 = 1;
                                                }
                                            }
                                            if (!valid4) {
                                                const err5 = {
                                                    instancePath: instancePath + '/conditions/' + i0,
                                                    schemaPath: '#/properties/conditions/items/oneOf',
                                                    keyword: 'oneOf',
                                                    params: { passingSchemas: passing1 },
                                                    message: 'must match exactly one schema in oneOf'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err5];
                                                }
                                                else {
                                                    vErrors.push(err5);
                                                }
                                                errors++;
                                                validate46.errors = vErrors;
                                                return false;
                                            }
                                            else {
                                                errors = _errs11;
                                                if (vErrors !== null) {
                                                    if (_errs11) {
                                                        vErrors.length = _errs11;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                            }
                                            var valid3 = _errs10 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate46.errors = [
                                    {
                                        instancePath: instancePath + '/conditions',
                                        schemaPath: '#/properties/conditions/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.otherwise !== undefined) {
                            let data3 = data.otherwise;
                            const _errs14 = errors;
                            const _errs15 = errors;
                            let valid5 = false;
                            let passing2 = null;
                            const _errs16 = errors;
                            const _errs17 = errors;
                            if (errors === _errs17) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err6 = {
                                        instancePath: instancePath + '/otherwise',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err6];
                                    }
                                    else {
                                        vErrors.push(err6);
                                    }
                                    errors++;
                                }
                            }
                            var _valid2 = _errs16 === errors;
                            if (_valid2) {
                                valid5 = true;
                                passing2 = 0;
                            }
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        const err7 = {
                                            instancePath: instancePath + '/otherwise',
                                            schemaPath: '#/properties/otherwise/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err8 = {
                                        instancePath: instancePath + '/otherwise',
                                        schemaPath: '#/properties/otherwise/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err8];
                                    }
                                    else {
                                        vErrors.push(err8);
                                    }
                                    errors++;
                                }
                            }
                            var _valid2 = _errs19 === errors;
                            if (_valid2 && valid5) {
                                valid5 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid2) {
                                    valid5 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid5) {
                                const err9 = {
                                    instancePath: instancePath + '/otherwise',
                                    schemaPath: '#/properties/otherwise/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                                validate46.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs15;
                                if (vErrors !== null) {
                                    if (_errs15) {
                                        vErrors.length = _errs15;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs14 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate46.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate46.errors = vErrors;
    return errors === 0;
}
export const caseFilterConditionSchemaValidation = validate48;
export const catBoostClassifierConfigSchemaValidation = validate52;
const schema86 = {
    $id: 'urn:wisepipe-common-pipe:CatBoostClassifierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate52(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CatBoostClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate52.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate52.errors = vErrors;
    return errors === 0;
}
export const catBoostRegressorConfigSchemaValidation = validate53;
const schema87 = {
    $id: 'urn:wisepipe-common-pipe:CatBoostRegressorConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate53(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CatBoostRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate53.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate53.errors = vErrors;
    return errors === 0;
}
export const categoryCalcConfigSchemaValidation = validate54;
const schema88 = { $id: 'urn:wisepipe-common-pipe:CategoryCalcConfig', type: 'object', properties: {}, required: [] };
function validate54(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CategoryCalcConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate54.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate54.errors = vErrors;
    return errors === 0;
}
export const categoryEncoderColumnSchemaValidation = validate55;
const schema89 = {
    $id: 'urn:wisepipe-common-pipe:CategoryEncoderColumn',
    type: 'object',
    properties: {
        source: { type: 'string', minLength: 1, maxLength: 150 },
        alias: { type: 'string', minLength: 1, maxLength: 150 }
    },
    required: ['source', 'alias']
};
function validate55(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CategoryEncoderColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.source === undefined && (missing0 = 'source')) || (data.alias === undefined && (missing0 = 'alias'))) {
                validate55.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.source !== undefined) {
                    let data0 = data.source;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate55.errors = [
                                    {
                                        instancePath: instancePath + '/source',
                                        schemaPath: '#/properties/source/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate55.errors = [
                                        {
                                            instancePath: instancePath + '/source',
                                            schemaPath: '#/properties/source/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate55.errors = [
                                {
                                    instancePath: instancePath + '/source',
                                    schemaPath: '#/properties/source/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.alias !== undefined) {
                        let data1 = data.alias;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate55.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate55.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate55.errors = [
                                    {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate55.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate55.errors = vErrors;
    return errors === 0;
}
export const categoryEncoderConfigSchemaValidation = validate56;
const schema90 = {
    $id: 'urn:wisepipe-common-pipe:CategoryEncoderConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:CategoryEncoderColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['source', 'alias']
        }
    },
    required: ['columns']
};
const func92 = ajvEqual;
function validate56(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CategoryEncoderConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate56.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate56.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate56.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        const _errs4 = errors;
                                        if (errors === _errs4) {
                                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                                let missing1;
                                                if ((data1.source === undefined && (missing1 = 'source')) ||
                                                    (data1.alias === undefined && (missing1 = 'alias'))) {
                                                    validate56.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data1.source !== undefined) {
                                                        let data2 = data1.source;
                                                        const _errs6 = errors;
                                                        if (errors === _errs6) {
                                                            if (typeof data2 === 'string') {
                                                                if (func2(data2) > 150) {
                                                                    validate56.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/source',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/properties/source/maxLength',
                                                                            keyword: 'maxLength',
                                                                            params: { limit: 150 },
                                                                            message: 'must NOT have more than 150 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (func2(data2) < 1) {
                                                                        validate56.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/source',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/properties/source/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate56.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/source',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/properties/source/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs6 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.alias !== undefined) {
                                                            let data3 = data1.alias;
                                                            const _errs8 = errors;
                                                            if (errors === _errs8) {
                                                                if (typeof data3 === 'string') {
                                                                    if (func2(data3) > 150) {
                                                                        validate56.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/alias',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/properties/alias/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 150 },
                                                                                message: 'must NOT have more than 150 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (func2(data3) < 1) {
                                                                            validate56.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/alias',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/properties/alias/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate56.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/alias',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/properties/alias/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs8 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate56.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:CategoryEncoderColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema90.properties.columns.uniqueItemProperties;
                                        let k0;
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data0.length; i1--;) {
                                                    let x0 = data0[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data0[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func92(x0[key0], y0[key0])) {
                                                            validate56.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns',
                                                                    schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate56.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate56.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate56.errors = vErrors;
    return errors === 0;
}
export const cblofOutlierConfigSchemaValidation = validate57;
const schema92 = {
    $id: 'urn:wisepipe-common-pipe:CblofOutlierConfig',
    type: 'object',
    properties: { alpha: { type: 'number', minimum: 0.5, maximum: 1 }, beta: { type: 'integer', minimum: 1 } },
    required: []
};
function validate57(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CblofOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.alpha !== undefined) {
                let data0 = data.alpha;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 > 1 || isNaN(data0)) {
                            validate57.errors = [
                                {
                                    instancePath: instancePath + '/alpha',
                                    schemaPath: '#/properties/alpha/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 1 },
                                    message: 'must be <= 1'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0 < 0.5 || isNaN(data0)) {
                                validate57.errors = [
                                    {
                                        instancePath: instancePath + '/alpha',
                                        schemaPath: '#/properties/alpha/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0.5 },
                                        message: 'must be >= 0.5'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate57.errors = [
                            {
                                instancePath: instancePath + '/alpha',
                                schemaPath: '#/properties/alpha/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.beta !== undefined) {
                    let data1 = data.beta;
                    const _errs3 = errors;
                    if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                        validate57.errors = [
                            {
                                instancePath: instancePath + '/beta',
                                schemaPath: '#/properties/beta/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 < 1 || isNaN(data1)) {
                                validate57.errors = [
                                    {
                                        instancePath: instancePath + '/beta',
                                        schemaPath: '#/properties/beta/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 1 },
                                        message: 'must be >= 1'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate57.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate57.errors = vErrors;
    return errors === 0;
}
export const challengeDataSchemaValidation = validate58;
const schema93 = {
    $id: 'urn:wisepipe-base-pipe:ChallengeData',
    type: 'object',
    properties: {
        challengeID: { type: 'number', minimum: 1 },
        userID: { type: 'string', minLength: 1, maxLength: 128 },
        dataSourceID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        createdAt: { type: 'string', format: 'date-time' },
        lastUpdatedAt: { type: 'string', format: 'date-time' },
        percentComplete: { type: 'number', minimum: 0, maximum: 100 },
        state: { type: 'string', enum: ['not_started', 'started', 'complete'] }
    },
    required: ['challengeID', 'percentComplete']
};
const func95 = ucs2length;
const func96 = base64urlToBuffer;
const func97 = base64urlEncode;
const func98 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func99 = ucs2length;
const func100 = base64urlToBuffer;
const func101 = base64urlEncode;
const func102 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate58(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ChallengeData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.challengeID === undefined && (missing0 = 'challengeID')) ||
                (data.percentComplete === undefined && (missing0 = 'percentComplete'))) {
                validate58.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.challengeID !== undefined) {
                    let data0 = data.challengeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 1 || isNaN(data0)) {
                                validate58.errors = [
                                    {
                                        instancePath: instancePath + '/challengeID',
                                        schemaPath: '#/properties/challengeID/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 1 },
                                        message: 'must be >= 1'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate58.errors = [
                                {
                                    instancePath: instancePath + '/challengeID',
                                    schemaPath: '#/properties/challengeID/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 128) {
                                    validate58.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 128 },
                                            message: 'must NOT have more than 128 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate58.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate58.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.dataSourceID !== undefined) {
                            let data2 = data.dataSourceID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func95(data2) < b64min0 || func95(data2) > b64max0) {
                                        validate58.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func95(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func95(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func96(data2);
                                        if (decoded0.length !== 9) {
                                            validate58.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func97(decoded0);
                                            if (func98(encoded0) !== func98(data2)) {
                                                validate58.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate58.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.originID !== undefined) {
                                let data3 = data.originID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func99(data3) < b64min1 || func99(data3) > b64max1) {
                                            validate58.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func99(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func99(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func100(data3);
                                            if (decoded1.length !== 9) {
                                                validate58.errors = [
                                                    {
                                                        instancePath: instancePath + '/originID',
                                                        schemaPath: '#/properties/originID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func101(decoded1);
                                                if (func102(encoded1) !== func102(data3)) {
                                                    validate58.errors = [
                                                        {
                                                            instancePath: instancePath + '/originID',
                                                            schemaPath: '#/properties/originID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate58.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.createdAt !== undefined) {
                                    let data4 = data.createdAt;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate58.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate58.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.lastUpdatedAt !== undefined) {
                                        let data5 = data.lastUpdatedAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.validate(data5)) {
                                                        validate58.errors = [
                                                            {
                                                                instancePath: instancePath + '/lastUpdatedAt',
                                                                schemaPath: '#/properties/lastUpdatedAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate58.errors = [
                                                        {
                                                            instancePath: instancePath + '/lastUpdatedAt',
                                                            schemaPath: '#/properties/lastUpdatedAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.percentComplete !== undefined) {
                                            let data6 = data.percentComplete;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 == 'number') {
                                                    if (data6 > 100 || isNaN(data6)) {
                                                        validate58.errors = [
                                                            {
                                                                instancePath: instancePath + '/percentComplete',
                                                                schemaPath: '#/properties/percentComplete/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 100 },
                                                                message: 'must be <= 100'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data6 < 0 || isNaN(data6)) {
                                                            validate58.errors = [
                                                                {
                                                                    instancePath: instancePath + '/percentComplete',
                                                                    schemaPath: '#/properties/percentComplete/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate58.errors = [
                                                        {
                                                            instancePath: instancePath + '/percentComplete',
                                                            schemaPath: '#/properties/percentComplete/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.state !== undefined) {
                                                let data7 = data.state;
                                                const _errs15 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate58.errors = [
                                                        {
                                                            instancePath: instancePath + '/state',
                                                            schemaPath: '#/properties/state/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'not_started' || data7 === 'started' || data7 === 'complete')) {
                                                    validate58.errors = [
                                                        {
                                                            instancePath: instancePath + '/state',
                                                            schemaPath: '#/properties/state/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema93.properties.state.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate58.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate58.errors = vErrors;
    return errors === 0;
}
export const changeCaseConfigSchemaValidation = validate59;
const schema94 = {
    $id: 'urn:wisepipe-common-pipe:ChangeCaseConfig',
    type: 'object',
    properties: {
        letterCase: { type: 'string', enum: ['lower', 'upper'] },
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        }
    },
    required: ['letterCase', 'columns']
};
function validate59(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ChangeCaseConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.letterCase === undefined && (missing0 = 'letterCase')) ||
                (data.columns === undefined && (missing0 = 'columns'))) {
                validate59.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.letterCase !== undefined) {
                    let data0 = data.letterCase;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate59.errors = [
                            {
                                instancePath: instancePath + '/letterCase',
                                schemaPath: '#/properties/letterCase/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'lower' || data0 === 'upper')) {
                        validate59.errors = [
                            {
                                instancePath: instancePath + '/letterCase',
                                schemaPath: '#/properties/letterCase/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema94.properties.letterCase.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columns !== undefined) {
                        let data1 = data.columns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length > 1000) {
                                    validate59.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        if (errors === _errs5) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) > 150) {
                                                    validate59.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 150 },
                                                            message: 'must NOT have more than 150 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data2) < 1) {
                                                        validate59.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns/' + i0,
                                                                schemaPath: '#/properties/columns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate59.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data1[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate59.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate59.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate59.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate59.errors = vErrors;
    return errors === 0;
}
export const changeTypeConfigSchemaValidation = validate60;
const schema95 = {
    $id: 'urn:wisepipe-common-pipe:ChangeTypeConfig',
    type: 'object',
    properties: {
        newType: { type: 'string', pattern: 'number|date|string|boolean|decimal' },
        columns: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true
        }
    },
    required: ['newType', 'columns']
};
function validate60(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ChangeTypeConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.newType === undefined && (missing0 = 'newType')) ||
                (data.columns === undefined && (missing0 = 'columns'))) {
                validate60.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.newType !== undefined) {
                    let data0 = data.newType;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern0.test(data0)) {
                                validate60.errors = [
                                    {
                                        instancePath: instancePath + '/newType',
                                        schemaPath: '#/properties/newType/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: 'number|date|string|boolean|decimal' },
                                        message: 'must match pattern "' + 'number|date|string|boolean|decimal' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate60.errors = [
                                {
                                    instancePath: instancePath + '/newType',
                                    schemaPath: '#/properties/newType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columns !== undefined) {
                        let data1 = data.columns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    let valid2 = false;
                                    let passing0 = null;
                                    const _errs7 = errors;
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                            const err0 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs7 === errors;
                                    if (_valid0) {
                                        valid2 = true;
                                        passing0 = 0;
                                    }
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) > 150) {
                                                const err1 = {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/oneOf/1/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 150 },
                                                    message: 'must NOT have more than 150 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err1];
                                                }
                                                else {
                                                    vErrors.push(err1);
                                                }
                                                errors++;
                                            }
                                            else {
                                                if (func2(data2) < 1) {
                                                    const err2 = {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/oneOf/1/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err2];
                                                    }
                                                    else {
                                                        vErrors.push(err2);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err3 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err3];
                                            }
                                            else {
                                                vErrors.push(err3);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs10 === errors;
                                    if (_valid0 && valid2) {
                                        valid2 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid2) {
                                        const err4 = {
                                            instancePath: instancePath + '/columns/' + i0,
                                            schemaPath: '#/properties/columns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                        validate60.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs6;
                                        if (vErrors !== null) {
                                            if (_errs6) {
                                                vErrors.length = _errs6;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data1[i1], data1[j0])) {
                                                    validate60.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate60.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate60.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate60.errors = vErrors;
    return errors === 0;
}
export const classifierConfigSchemaValidation = validate61;
const schema97 = {
    $id: 'urn:wisepipe-common-pipe:ClassifierConfig',
    type: 'object',
    properties: { options: { type: 'integer', minimum: 1, maximum: 15 } },
    required: ['options']
};
function validate61(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.options === undefined && (missing0 = 'options')) {
                validate61.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.options !== undefined) {
                    let data0 = data.options;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate61.errors = [
                            {
                                instancePath: instancePath + '/options',
                                schemaPath: '#/properties/options/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 15 || isNaN(data0)) {
                                validate61.errors = [
                                    {
                                        instancePath: instancePath + '/options',
                                        schemaPath: '#/properties/options/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 15 },
                                        message: 'must be <= 15'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate61.errors = [
                                        {
                                            instancePath: instancePath + '/options',
                                            schemaPath: '#/properties/options/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate61.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate61.errors = vErrors;
    return errors === 0;
}
export const cleanCharacterConditionSchemaValidation = validate62;
const schema98 = {
    $id: 'urn:wisepipe-common-pipe:CleanCharacterCondition',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        cleanMethod: { type: 'string', enum: ['convert', 'remove'] },
        addNewColumn: { type: 'boolean' },
        name: { type: 'string', minLength: 1 }
    },
    required: ['columns', 'cleanMethod', 'addNewColumn']
};
function validate62(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CleanCharacterCondition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.cleanMethod === undefined && (missing0 = 'cleanMethod')) ||
                (data.addNewColumn === undefined && (missing0 = 'addNewColumn'))) {
                validate62.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate62.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate62.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate62.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.cleanMethod !== undefined) {
                        let data2 = data.cleanMethod;
                        const _errs5 = errors;
                        if (typeof data2 !== 'string') {
                            validate62.errors = [
                                {
                                    instancePath: instancePath + '/cleanMethod',
                                    schemaPath: '#/properties/cleanMethod/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'convert' || data2 === 'remove')) {
                            validate62.errors = [
                                {
                                    instancePath: instancePath + '/cleanMethod',
                                    schemaPath: '#/properties/cleanMethod/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema98.properties.cleanMethod.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.addNewColumn !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.addNewColumn !== 'boolean') {
                                validate62.errors = [
                                    {
                                        instancePath: instancePath + '/addNewColumn',
                                        schemaPath: '#/properties/addNewColumn/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.name !== undefined) {
                                let data4 = data.name;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/name',
                                                    schemaPath: '#/properties/name/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate62.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate62.errors = vErrors;
    return errors === 0;
}
export const cleanCharacterConfigSchemaValidation = validate63;
const schema99 = {
    $id: 'urn:wisepipe-common-pipe:CleanCharacterConfig',
    type: 'object',
    properties: {
        cleanConditions: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:CleanCharacterCondition' }, minItems: 1 }
    },
    required: ['cleanConditions']
};
function validate63(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CleanCharacterConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.cleanConditions === undefined && (missing0 = 'cleanConditions')) {
                validate63.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.cleanConditions !== undefined) {
                    let data0 = data.cleanConditions;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate63.errors = [
                                    {
                                        instancePath: instancePath + '/cleanConditions',
                                        schemaPath: '#/properties/cleanConditions/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                            let missing1;
                                            if ((data1.columns === undefined && (missing1 = 'columns')) ||
                                                (data1.cleanMethod === undefined && (missing1 = 'cleanMethod')) ||
                                                (data1.addNewColumn === undefined && (missing1 = 'addNewColumn'))) {
                                                validate63.errors = [
                                                    {
                                                        instancePath: instancePath + '/cleanConditions/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data1.columns !== undefined) {
                                                    let data2 = data1.columns;
                                                    const _errs6 = errors;
                                                    if (errors === _errs6) {
                                                        if (Array.isArray(data2)) {
                                                            if (data2.length > 1000) {
                                                                validate63.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/cleanConditions/' + i0 + '/columns',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/columns/maxItems',
                                                                        keyword: 'maxItems',
                                                                        params: { limit: 1000 },
                                                                        message: 'must NOT have more than 1000 items'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                                const len1 = data2.length;
                                                                for (let i1 = 0; i1 < len1; i1++) {
                                                                    let data3 = data2[i1];
                                                                    const _errs8 = errors;
                                                                    if (errors === _errs8) {
                                                                        if (typeof data3 === 'string') {
                                                                            if (func2(data3) > 150) {
                                                                                validate63.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/cleanConditions/' + i0 + '/columns/' + i1,
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/columns/items/maxLength',
                                                                                        keyword: 'maxLength',
                                                                                        params: { limit: 150 },
                                                                                        message: 'must NOT have more than 150 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (func2(data3) < 1) {
                                                                                    validate63.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/cleanConditions/' + i0 + '/columns/' + i1,
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/columns/items/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate63.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/cleanConditions/' + i0 + '/columns/' + i1,
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/columns/items/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid4 = _errs8 === errors;
                                                                    if (!valid4) {
                                                                        break;
                                                                    }
                                                                }
                                                                if (valid4) {
                                                                    let i2 = data2.length;
                                                                    let j0;
                                                                    if (i2 > 1) {
                                                                        const indices0 = {};
                                                                        for (; i2--;) {
                                                                            let item0 = data2[i2];
                                                                            if (typeof item0 !== 'string') {
                                                                                continue;
                                                                            }
                                                                            if (typeof indices0[item0] == 'number') {
                                                                                j0 = indices0[item0];
                                                                                validate63.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/cleanConditions/' + i0 + '/columns',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/columns/uniqueItems',
                                                                                        keyword: 'uniqueItems',
                                                                                        params: { i: i2, j: j0 },
                                                                                        message: 'must NOT have duplicate items (items ## ' +
                                                                                            j0 +
                                                                                            ' and ' +
                                                                                            i2 +
                                                                                            ' are identical)'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                                break;
                                                                            }
                                                                            indices0[item0] = i2;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate63.errors = [
                                                                {
                                                                    instancePath: instancePath + '/cleanConditions/' + i0 + '/columns',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/columns/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs6 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.cleanMethod !== undefined) {
                                                        let data4 = data1.cleanMethod;
                                                        const _errs10 = errors;
                                                        if (typeof data4 !== 'string') {
                                                            validate63.errors = [
                                                                {
                                                                    instancePath: instancePath + '/cleanConditions/' + i0 + '/cleanMethod',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/cleanMethod/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data4 === 'convert' || data4 === 'remove')) {
                                                            validate63.errors = [
                                                                {
                                                                    instancePath: instancePath + '/cleanConditions/' + i0 + '/cleanMethod',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/cleanMethod/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema98.properties.cleanMethod.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.addNewColumn !== undefined) {
                                                            const _errs12 = errors;
                                                            if (typeof data1.addNewColumn !== 'boolean') {
                                                                validate63.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/cleanConditions/' + i0 + '/addNewColumn',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/addNewColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.name !== undefined) {
                                                                let data6 = data1.name;
                                                                const _errs14 = errors;
                                                                if (errors === _errs14) {
                                                                    if (typeof data6 === 'string') {
                                                                        if (func2(data6) < 1) {
                                                                            validate63.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/cleanConditions/' + i0 + '/name',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/name/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate63.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/cleanConditions/' + i0 + '/name',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/properties/name/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid3 = _errs14 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate63.errors = [
                                                {
                                                    instancePath: instancePath + '/cleanConditions/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:CleanCharacterCondition/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            validate63.errors = [
                                {
                                    instancePath: instancePath + '/cleanConditions',
                                    schemaPath: '#/properties/cleanConditions/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate63.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate63.errors = vErrors;
    return errors === 0;
}
export const cloudConfigSchemaValidation = validate64;
const schema101 = { $id: 'urn:wisepipe-common-pipe:CloudConfig', type: 'object', properties: {} };
function validate64(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CloudConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate64.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
export const cnnTextClassifierConfigSchemaValidation = validate65;
const schema102 = {
    $id: 'urn:wisepipe-common-pipe:CnnTextClassifierConfig',
    type: 'object',
    properties: { lossOption: { type: 'integer', minimum: 0, maximum: 4 } },
    required: ['lossOption']
};
function validate65(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CnnTextClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.lossOption === undefined && (missing0 = 'lossOption')) {
                validate65.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lossOption !== undefined) {
                    let data0 = data.lossOption;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate65.errors = [
                            {
                                instancePath: instancePath + '/lossOption',
                                schemaPath: '#/properties/lossOption/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 4 || isNaN(data0)) {
                                validate65.errors = [
                                    {
                                        instancePath: instancePath + '/lossOption',
                                        schemaPath: '#/properties/lossOption/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 4 },
                                        message: 'must be <= 4'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 0 || isNaN(data0)) {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/lossOption',
                                            schemaPath: '#/properties/lossOption/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate65.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate65.errors = vErrors;
    return errors === 0;
}
export const cofOutlierConfigSchemaValidation = validate66;
const schema103 = {
    $id: 'urn:wisepipe-common-pipe:CofOutlierConfig',
    type: 'object',
    properties: { n_neighbors: { type: 'integer', minimum: 1 } },
    required: []
};
function validate66(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CofOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.n_neighbors !== undefined) {
                let data0 = data.n_neighbors;
                const _errs1 = errors;
                if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                    validate66.errors = [
                        {
                            instancePath: instancePath + '/n_neighbors',
                            schemaPath: '#/properties/n_neighbors/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer'
                        }
                    ];
                    return false;
                }
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 < 1 || isNaN(data0)) {
                            validate66.errors = [
                                {
                                    instancePath: instancePath + '/n_neighbors',
                                    schemaPath: '#/properties/n_neighbors/minimum',
                                    keyword: 'minimum',
                                    params: { comparison: '>=', limit: 1 },
                                    message: 'must be >= 1'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate66.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate66.errors = vErrors;
    return errors === 0;
}
export const columnMetadataOriginItemSchemaValidation = validate67;
const schema104 = {
    $id: 'urn:wisepipe-common-pipe:ColumnMetadataOriginItem',
    type: 'object',
    properties: { columns: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-data:Column' } } },
    required: ['columns']
};
function validate67(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ColumnMetadataOriginItem" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate67.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                const _errs4 = errors;
                                if (!validate39(data0[key0], {
                                    instancePath: instancePath + '/columns/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                    parentData: data0,
                                    parentDataProperty: key0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate67.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate67.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate67.errors = vErrors;
    return errors === 0;
}
export const columnMetadataSchemaValidation = validate69;
const schema105 = {
    $id: 'urn:wisepipe-common-pipe:ColumnMetadata',
    type: 'object',
    properties: {
        column: { $ref: 'urn:wisepipe-common-data:Column' },
        name: { type: 'string' },
        colOrigins: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:ColumnMetadataOriginItem' } },
        required: { type: 'boolean' },
        customFormat: { $ref: 'urn:wisepipe-common-pipe:CustomFormat' }
    },
    required: ['column', 'name', 'colOrigins', 'required']
};
const schema106 = {
    $id: 'urn:wisepipe-common-pipe:CustomFormat',
    type: 'object',
    properties: {
        format: {
            type: 'string',
            enum: ['none', 'currency', 'percentage', 'fullDateAndTime', 'longDate', 'shortDate', 'time', 'shortMonth']
        },
        decimalPlace: { type: 'number', minimum: 0 },
        thousandSeparator: { type: 'boolean' },
        autoGenerated: { type: 'boolean' },
        inherited: { type: 'boolean' }
    },
    required: ['format', 'autoGenerated', 'inherited']
};
function validate69(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.column === undefined && (missing0 = 'column')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.colOrigins === undefined && (missing0 = 'colOrigins')) ||
                (data.required === undefined && (missing0 = 'required'))) {
                validate69.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    const _errs1 = errors;
                    if (!validate39(data.column, {
                        instancePath: instancePath + '/column',
                        parentData: data,
                        parentDataProperty: 'column',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        const _errs2 = errors;
                        if (typeof data.name !== 'string') {
                            validate69.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs2 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.colOrigins !== undefined) {
                            let data2 = data.colOrigins;
                            const _errs4 = errors;
                            if (errors === _errs4) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    for (const key0 in data2) {
                                        const _errs7 = errors;
                                        if (!validate67(data2[key0], {
                                            instancePath: instancePath + '/colOrigins/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                            parentData: data2,
                                            parentDataProperty: key0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate69.errors = [
                                        {
                                            instancePath: instancePath + '/colOrigins',
                                            schemaPath: '#/properties/colOrigins/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs4 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.required !== undefined) {
                                const _errs8 = errors;
                                if (typeof data.required !== 'boolean') {
                                    validate69.errors = [
                                        {
                                            instancePath: instancePath + '/required',
                                            schemaPath: '#/properties/required/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs8 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.customFormat !== undefined) {
                                    let data5 = data.customFormat;
                                    const _errs10 = errors;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                            let missing1;
                                            if ((data5.format === undefined && (missing1 = 'format')) ||
                                                (data5.autoGenerated === undefined && (missing1 = 'autoGenerated')) ||
                                                (data5.inherited === undefined && (missing1 = 'inherited'))) {
                                                validate69.errors = [
                                                    {
                                                        instancePath: instancePath + '/customFormat',
                                                        schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data5.format !== undefined) {
                                                    let data6 = data5.format;
                                                    const _errs13 = errors;
                                                    if (typeof data6 !== 'string') {
                                                        validate69.errors = [
                                                            {
                                                                instancePath: instancePath + '/customFormat/format',
                                                                schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/format/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data6 === 'none' ||
                                                        data6 === 'currency' ||
                                                        data6 === 'percentage' ||
                                                        data6 === 'fullDateAndTime' ||
                                                        data6 === 'longDate' ||
                                                        data6 === 'shortDate' ||
                                                        data6 === 'time' ||
                                                        data6 === 'shortMonth')) {
                                                        validate69.errors = [
                                                            {
                                                                instancePath: instancePath + '/customFormat/format',
                                                                schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/format/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema106.properties.format.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs13 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data5.decimalPlace !== undefined) {
                                                        let data7 = data5.decimalPlace;
                                                        const _errs15 = errors;
                                                        if (errors === _errs15) {
                                                            if (typeof data7 == 'number') {
                                                                if (data7 < 0 || isNaN(data7)) {
                                                                    validate69.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/customFormat/decimalPlace',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/decimalPlace/minimum',
                                                                            keyword: 'minimum',
                                                                            params: { comparison: '>=', limit: 0 },
                                                                            message: 'must be >= 0'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate69.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/customFormat/decimalPlace',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/decimalPlace/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs15 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data5.thousandSeparator !== undefined) {
                                                            const _errs17 = errors;
                                                            if (typeof data5.thousandSeparator !== 'boolean') {
                                                                validate69.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/customFormat/thousandSeparator',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/thousandSeparator/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs17 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data5.autoGenerated !== undefined) {
                                                                const _errs19 = errors;
                                                                if (typeof data5.autoGenerated !== 'boolean') {
                                                                    validate69.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/customFormat/autoGenerated',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/autoGenerated/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid3 = _errs19 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data5.inherited !== undefined) {
                                                                    const _errs21 = errors;
                                                                    if (typeof data5.inherited !== 'boolean') {
                                                                        validate69.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/customFormat/inherited',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/inherited/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs21 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate69.errors = [
                                                {
                                                    instancePath: instancePath + '/customFormat',
                                                    schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs10 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate69.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate69.errors = vErrors;
    return errors === 0;
}
export const columnSchemaValidation = validate39;
export const columnToolVariableSchemaValidation = validate72;
function validate72(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ColumnToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate72.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate72.errors = vErrors;
    return errors === 0;
}
export const combinationMatcherConfigSchemaValidation = validate73;
const schema108 = {
    $id: 'urn:wisepipe-common-pipe:CombinationMatcherConfig',
    type: 'object',
    properties: {
        matchColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns' },
            minItems: 1,
            uniqueItemProperties: ['combination', 'data']
        },
        combinationInput: { type: 'string', enum: ['top', 'bottom'] },
        idColumn: { type: 'string' },
        matchedAlias: { type: 'string' },
        matchIDAlias: { type: 'string' }
    },
    required: ['matchColumns', 'combinationInput']
};
const schema109 = {
    $id: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns',
    type: 'object',
    properties: {
        combination: { type: 'string' },
        data: { type: 'string' },
        matchType: { type: 'string', enum: ['exact_match', 'contains', 'is_contained_in'] }
    },
    required: ['combination', 'data']
};
const func114 = ajvEqual;
function validate73(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CombinationMatcherConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.matchColumns === undefined && (missing0 = 'matchColumns')) ||
                (data.combinationInput === undefined && (missing0 = 'combinationInput'))) {
                validate73.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.matchColumns !== undefined) {
                    let data0 = data.matchColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate73.errors = [
                                    {
                                        instancePath: instancePath + '/matchColumns',
                                        schemaPath: '#/properties/matchColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                            let missing1;
                                            if ((data1.combination === undefined && (missing1 = 'combination')) ||
                                                (data1.data === undefined && (missing1 = 'data'))) {
                                                validate73.errors = [
                                                    {
                                                        instancePath: instancePath + '/matchColumns/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data1.combination !== undefined) {
                                                    const _errs6 = errors;
                                                    if (typeof data1.combination !== 'string') {
                                                        validate73.errors = [
                                                            {
                                                                instancePath: instancePath + '/matchColumns/' + i0 + '/combination',
                                                                schemaPath: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns/properties/combination/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs6 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.data !== undefined) {
                                                        const _errs8 = errors;
                                                        if (typeof data1.data !== 'string') {
                                                            validate73.errors = [
                                                                {
                                                                    instancePath: instancePath + '/matchColumns/' + i0 + '/data',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns/properties/data/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.matchType !== undefined) {
                                                            let data4 = data1.matchType;
                                                            const _errs10 = errors;
                                                            if (typeof data4 !== 'string') {
                                                                validate73.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/matchColumns/' + i0 + '/matchType',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns/properties/matchType/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data4 === 'exact_match' || data4 === 'contains' || data4 === 'is_contained_in')) {
                                                                validate73.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/matchColumns/' + i0 + '/matchType',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns/properties/matchType/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema109.properties.matchType.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs10 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate73.errors = [
                                                {
                                                    instancePath: instancePath + '/matchColumns/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:CombinationMatcherMatchColumns/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema108.properties.matchColumns.uniqueItemProperties;
                                    let k0;
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data0.length; i1--;) {
                                                let x0 = data0[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data0[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func114(x0[key0], y0[key0])) {
                                                        validate73.errors = [
                                                            {
                                                                instancePath: instancePath + '/matchColumns',
                                                                schemaPath: '#/properties/matchColumns/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate73.errors = [
                                {
                                    instancePath: instancePath + '/matchColumns',
                                    schemaPath: '#/properties/matchColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.combinationInput !== undefined) {
                        let data5 = data.combinationInput;
                        const _errs12 = errors;
                        if (typeof data5 !== 'string') {
                            validate73.errors = [
                                {
                                    instancePath: instancePath + '/combinationInput',
                                    schemaPath: '#/properties/combinationInput/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data5 === 'top' || data5 === 'bottom')) {
                            validate73.errors = [
                                {
                                    instancePath: instancePath + '/combinationInput',
                                    schemaPath: '#/properties/combinationInput/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema108.properties.combinationInput.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs12 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.idColumn !== undefined) {
                            const _errs14 = errors;
                            if (typeof data.idColumn !== 'string') {
                                validate73.errors = [
                                    {
                                        instancePath: instancePath + '/idColumn',
                                        schemaPath: '#/properties/idColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs14 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.matchedAlias !== undefined) {
                                const _errs16 = errors;
                                if (typeof data.matchedAlias !== 'string') {
                                    validate73.errors = [
                                        {
                                            instancePath: instancePath + '/matchedAlias',
                                            schemaPath: '#/properties/matchedAlias/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs16 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.matchIDAlias !== undefined) {
                                    const _errs18 = errors;
                                    if (typeof data.matchIDAlias !== 'string') {
                                        validate73.errors = [
                                            {
                                                instancePath: instancePath + '/matchIDAlias',
                                                schemaPath: '#/properties/matchIDAlias/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs18 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate73.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate73.errors = vErrors;
    return errors === 0;
}
export const combinationMatcherMatchColumnsSchemaValidation = validate74;
function validate74(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CombinationMatcherMatchColumns" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.combination === undefined && (missing0 = 'combination')) ||
                (data.data === undefined && (missing0 = 'data'))) {
                validate74.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.combination !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.combination !== 'string') {
                        validate74.errors = [
                            {
                                instancePath: instancePath + '/combination',
                                schemaPath: '#/properties/combination/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.data !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.data !== 'string') {
                            validate74.errors = [
                                {
                                    instancePath: instancePath + '/data',
                                    schemaPath: '#/properties/data/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.matchType !== undefined) {
                            let data2 = data.matchType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate74.errors = [
                                    {
                                        instancePath: instancePath + '/matchType',
                                        schemaPath: '#/properties/matchType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'exact_match' || data2 === 'contains' || data2 === 'is_contained_in')) {
                                validate74.errors = [
                                    {
                                        instancePath: instancePath + '/matchType',
                                        schemaPath: '#/properties/matchType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema109.properties.matchType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate74.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate74.errors = vErrors;
    return errors === 0;
}
export const compoundToolVariableSchemaValidation = validate75;
function validate75(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:CompoundToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.value === undefined && (missing0 = 'value')) {
                validate75.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.value !== undefined) {
                    if (typeof data.value !== 'string') {
                        validate75.errors = [
                            {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/properties/value/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate75.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate75.errors = vErrors;
    return errors === 0;
}
export const conditionalConfigSchemaValidation = validate76;
const schema112 = {
    $id: 'urn:wisepipe-common-pipe:ConditionalConfig',
    type: 'object',
    properties: {
        columnName: { type: 'string', minLength: 1, maxLength: 150 },
        filter: { $ref: 'urn:wisepipe-common-pipe:Filter' }
    },
    required: ['columnName', 'filter']
};
function validate76(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ConditionalConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnName === undefined && (missing0 = 'columnName')) ||
                (data.filter === undefined && (missing0 = 'filter'))) {
                validate76.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnName !== undefined) {
                    let data0 = data.columnName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/columnName',
                                        schemaPath: '#/properties/columnName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/columnName',
                                            schemaPath: '#/properties/columnName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate76.errors = [
                                {
                                    instancePath: instancePath + '/columnName',
                                    schemaPath: '#/properties/columnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.filter !== undefined) {
                        let data1 = data.filter;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if (data1.filterType === undefined && (missing1 = 'filterType')) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/filter',
                                            schemaPath: 'urn:wisepipe-common-pipe:Filter/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.filterType !== undefined) {
                                        let data2 = data1.filterType;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (!pattern4.test(data2)) {
                                                    validate76.errors = [
                                                        {
                                                            instancePath: instancePath + '/filter/filterType',
                                                            schemaPath: 'urn:wisepipe-common-pipe:Filter/properties/filterType/pattern',
                                                            keyword: 'pattern',
                                                            params: { pattern: 'group|statement' },
                                                            message: 'must match pattern "' + 'group|statement' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate76.errors = [
                                                    {
                                                        instancePath: instancePath + '/filter/filterType',
                                                        schemaPath: 'urn:wisepipe-common-pipe:Filter/properties/filterType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/filter',
                                        schemaPath: 'urn:wisepipe-common-pipe:Filter/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate76.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate76.errors = vErrors;
    return errors === 0;
}
export const confusionMatrixConfigSchemaValidation = validate77;
const schema114 = {
    $id: 'urn:wisepipe-common-pipe:ConfusionMatrixConfig',
    type: 'object',
    properties: { trueColumn: { type: 'string', minLength: 1 }, predColumn: { type: 'string', minLength: 1 } },
    required: ['trueColumn', 'predColumn']
};
function validate77(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ConfusionMatrixConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.trueColumn === undefined && (missing0 = 'trueColumn')) ||
                (data.predColumn === undefined && (missing0 = 'predColumn'))) {
                validate77.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.trueColumn !== undefined) {
                    let data0 = data.trueColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate77.errors = [
                                    {
                                        instancePath: instancePath + '/trueColumn',
                                        schemaPath: '#/properties/trueColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate77.errors = [
                                {
                                    instancePath: instancePath + '/trueColumn',
                                    schemaPath: '#/properties/trueColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.predColumn !== undefined) {
                        let data1 = data.predColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate77.errors = [
                                        {
                                            instancePath: instancePath + '/predColumn',
                                            schemaPath: '#/properties/predColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate77.errors = [
                                    {
                                        instancePath: instancePath + '/predColumn',
                                        schemaPath: '#/properties/predColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate77.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate77.errors = vErrors;
    return errors === 0;
}
export const customFormatSchemaValidation = validate78;
function validate78(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:CustomFormat" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.format === undefined && (missing0 = 'format')) ||
                (data.autoGenerated === undefined && (missing0 = 'autoGenerated')) ||
                (data.inherited === undefined && (missing0 = 'inherited'))) {
                validate78.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.format !== undefined) {
                    let data0 = data.format;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate78.errors = [
                            {
                                instancePath: instancePath + '/format',
                                schemaPath: '#/properties/format/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'none' ||
                        data0 === 'currency' ||
                        data0 === 'percentage' ||
                        data0 === 'fullDateAndTime' ||
                        data0 === 'longDate' ||
                        data0 === 'shortDate' ||
                        data0 === 'time' ||
                        data0 === 'shortMonth')) {
                        validate78.errors = [
                            {
                                instancePath: instancePath + '/format',
                                schemaPath: '#/properties/format/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema106.properties.format.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.decimalPlace !== undefined) {
                        let data1 = data.decimalPlace;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate78.errors = [
                                        {
                                            instancePath: instancePath + '/decimalPlace',
                                            schemaPath: '#/properties/decimalPlace/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate78.errors = [
                                    {
                                        instancePath: instancePath + '/decimalPlace',
                                        schemaPath: '#/properties/decimalPlace/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.thousandSeparator !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.thousandSeparator !== 'boolean') {
                                validate78.errors = [
                                    {
                                        instancePath: instancePath + '/thousandSeparator',
                                        schemaPath: '#/properties/thousandSeparator/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.autoGenerated !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.autoGenerated !== 'boolean') {
                                    validate78.errors = [
                                        {
                                            instancePath: instancePath + '/autoGenerated',
                                            schemaPath: '#/properties/autoGenerated/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.inherited !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.inherited !== 'boolean') {
                                        validate78.errors = [
                                            {
                                                instancePath: instancePath + '/inherited',
                                                schemaPath: '#/properties/inherited/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate78.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate78.errors = vErrors;
    return errors === 0;
}
export const dataDistributionBinomialSchemaValidation = validate79;
const schema116 = {
    $id: 'urn:wisepipe-common-pipe:DataDistributionBinomial',
    type: 'object',
    properties: {
        probOfSuccess: { type: 'number', minimum: 0, maximum: 1 },
        numberOfTrials: { type: 'number', minimum: 0 }
    },
    required: ['probOfSuccess', 'numberOfTrials']
};
function validate79(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistributionBinomial" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.probOfSuccess === undefined && (missing0 = 'probOfSuccess')) ||
                (data.numberOfTrials === undefined && (missing0 = 'numberOfTrials'))) {
                validate79.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.probOfSuccess !== undefined) {
                    let data0 = data.probOfSuccess;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 1 || isNaN(data0)) {
                                validate79.errors = [
                                    {
                                        instancePath: instancePath + '/probOfSuccess',
                                        schemaPath: '#/properties/probOfSuccess/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 1 },
                                        message: 'must be <= 1'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 0 || isNaN(data0)) {
                                    validate79.errors = [
                                        {
                                            instancePath: instancePath + '/probOfSuccess',
                                            schemaPath: '#/properties/probOfSuccess/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate79.errors = [
                                {
                                    instancePath: instancePath + '/probOfSuccess',
                                    schemaPath: '#/properties/probOfSuccess/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.numberOfTrials !== undefined) {
                        let data1 = data.numberOfTrials;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate79.errors = [
                                        {
                                            instancePath: instancePath + '/numberOfTrials',
                                            schemaPath: '#/properties/numberOfTrials/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate79.errors = [
                                    {
                                        instancePath: instancePath + '/numberOfTrials',
                                        schemaPath: '#/properties/numberOfTrials/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate79.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate79.errors = vErrors;
    return errors === 0;
}
export const dataDistributionNormalSchemaValidation = validate80;
const schema117 = {
    $id: 'urn:wisepipe-common-pipe:DataDistributionNormal',
    type: 'object',
    properties: { mean: { type: 'number' }, std: { type: 'number', minimum: 0 } },
    required: ['mean', 'std']
};
function validate80(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistributionNormal" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.mean === undefined && (missing0 = 'mean')) || (data.std === undefined && (missing0 = 'std'))) {
                validate80.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mean !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.mean == 'number')) {
                        validate80.errors = [
                            {
                                instancePath: instancePath + '/mean',
                                schemaPath: '#/properties/mean/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.std !== undefined) {
                        let data1 = data.std;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate80.errors = [
                                        {
                                            instancePath: instancePath + '/std',
                                            schemaPath: '#/properties/std/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate80.errors = [
                                    {
                                        instancePath: instancePath + '/std',
                                        schemaPath: '#/properties/std/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate80.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate80.errors = vErrors;
    return errors === 0;
}
export const dataDistributionPoissonSchemaValidation = validate81;
const schema118 = {
    $id: 'urn:wisepipe-common-pipe:DataDistributionPoisson',
    type: 'object',
    properties: { mean: { type: 'number', minimum: 0 } },
    required: ['mean']
};
function validate81(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistributionPoisson" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.mean === undefined && (missing0 = 'mean')) {
                validate81.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mean !== undefined) {
                    let data0 = data.mean;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate81.errors = [
                                    {
                                        instancePath: instancePath + '/mean',
                                        schemaPath: '#/properties/mean/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate81.errors = [
                                {
                                    instancePath: instancePath + '/mean',
                                    schemaPath: '#/properties/mean/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate81.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate81.errors = vErrors;
    return errors === 0;
}
export const dataDistributionSchemaValidation = validate82;
const schema119 = {
    $id: 'urn:wisepipe-common-pipe:DataDistribution',
    type: 'object',
    properties: { type: { type: 'string', enum: ['normal', 'triangular', 'uniform', 'weibull', 'poisson', 'binomial'] } },
    required: ['type']
};
function validate82(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistribution" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.type === undefined && (missing0 = 'type')) {
                validate82.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    if (typeof data0 !== 'string') {
                        validate82.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'normal' ||
                        data0 === 'triangular' ||
                        data0 === 'uniform' ||
                        data0 === 'weibull' ||
                        data0 === 'poisson' ||
                        data0 === 'binomial')) {
                        validate82.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema119.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate82.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate82.errors = vErrors;
    return errors === 0;
}
export const dataDistributionTriangularSchemaValidation = validate83;
const schema120 = {
    $id: 'urn:wisepipe-common-pipe:DataDistributionTriangular',
    type: 'object',
    properties: { min: { type: 'number' }, max: { type: 'number' }, mode: { type: 'number' } },
    required: ['min', 'max', 'mode']
};
function validate83(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistributionTriangular" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.min === undefined && (missing0 = 'min')) ||
                (data.max === undefined && (missing0 = 'max')) ||
                (data.mode === undefined && (missing0 = 'mode'))) {
                validate83.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.min !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.min == 'number')) {
                        validate83.errors = [
                            {
                                instancePath: instancePath + '/min',
                                schemaPath: '#/properties/min/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.max !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.max == 'number')) {
                            validate83.errors = [
                                {
                                    instancePath: instancePath + '/max',
                                    schemaPath: '#/properties/max/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.mode !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.mode == 'number')) {
                                validate83.errors = [
                                    {
                                        instancePath: instancePath + '/mode',
                                        schemaPath: '#/properties/mode/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate83.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate83.errors = vErrors;
    return errors === 0;
}
export const dataDistributionUniformSchemaValidation = validate84;
const schema121 = {
    $id: 'urn:wisepipe-common-pipe:DataDistributionUniform',
    type: 'object',
    properties: { min: { type: 'number' }, max: { type: 'number' }, isDiscrete: { type: 'boolean' } },
    required: ['min', 'max', 'isDiscrete']
};
function validate84(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistributionUniform" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.min === undefined && (missing0 = 'min')) ||
                (data.max === undefined && (missing0 = 'max')) ||
                (data.isDiscrete === undefined && (missing0 = 'isDiscrete'))) {
                validate84.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.min !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.min == 'number')) {
                        validate84.errors = [
                            {
                                instancePath: instancePath + '/min',
                                schemaPath: '#/properties/min/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.max !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.max == 'number')) {
                            validate84.errors = [
                                {
                                    instancePath: instancePath + '/max',
                                    schemaPath: '#/properties/max/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.isDiscrete !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.isDiscrete !== 'boolean') {
                                validate84.errors = [
                                    {
                                        instancePath: instancePath + '/isDiscrete',
                                        schemaPath: '#/properties/isDiscrete/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate84.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate84.errors = vErrors;
    return errors === 0;
}
export const dataDistributionWeibullSchemaValidation = validate85;
const schema122 = {
    $id: 'urn:wisepipe-common-pipe:DataDistributionWeibull',
    type: 'object',
    properties: { shape: { type: 'number', minimum: 0 }, scale: { type: 'number', minimum: 0 }, loc: { type: 'number' } },
    required: ['shape', 'scale']
};
function validate85(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DataDistributionWeibull" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.shape === undefined && (missing0 = 'shape')) || (data.scale === undefined && (missing0 = 'scale'))) {
                validate85.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.shape !== undefined) {
                    let data0 = data.shape;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 0 || isNaN(data0)) {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/shape',
                                        schemaPath: '#/properties/shape/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate85.errors = [
                                {
                                    instancePath: instancePath + '/shape',
                                    schemaPath: '#/properties/shape/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.scale !== undefined) {
                        let data1 = data.scale;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate85.errors = [
                                        {
                                            instancePath: instancePath + '/scale',
                                            schemaPath: '#/properties/scale/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/scale',
                                        schemaPath: '#/properties/scale/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.loc !== undefined) {
                            const _errs5 = errors;
                            if (!(typeof data.loc == 'number')) {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/loc',
                                        schemaPath: '#/properties/loc/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate85.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate85.errors = vErrors;
    return errors === 0;
}
export const dateAddConfigSchemaValidation = validate86;
const schema123 = {
    $id: 'urn:wisepipe-common-pipe:DateAddConfig',
    type: 'object',
    properties: {
        date: { $ref: 'urn:wisepipe-common-pipe:DateOperand' },
        interval: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' }, { type: 'number' }] },
        alias: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        addType: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['number', 'column', 'none'] }
            ]
        },
        unit: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['Years', 'Months', 'Days', 'Hours', 'Minutes', 'Seconds', 'Milliseconds'] }
            ]
        },
        column: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['date', 'alias', 'addType'],
    allOf: [
        { if: { properties: { addType: { const: 'column' } } }, then: { required: ['column', 'unit'] } },
        { if: { properties: { addType: { const: 'number' } } }, then: { required: ['interval', 'unit'] } }
    ]
};
const schema124 = {
    $id: 'urn:wisepipe-common-pipe:DateOperand',
    type: 'object',
    properties: { operandType: { type: 'string', enum: ['now', 'column', 'literal'] } },
    required: ['operandType']
};
function validate86(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateAddConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.addType !== undefined) {
            if ('column' !== data.addType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.column === undefined && (missing0 = 'column')) || (data.unit === undefined && (missing0 = 'unit'))) {
                validate86.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate86.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.addType !== undefined) {
                if ('number' !== data.addType) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if ((data.interval === undefined && (missing1 = 'interval')) ||
                    (data.unit === undefined && (missing1 = 'unit'))) {
                    validate86.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate86.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.date === undefined && (missing2 = 'date')) ||
                (data.alias === undefined && (missing2 = 'alias')) ||
                (data.addType === undefined && (missing2 = 'addType'))) {
                validate86.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.date !== undefined) {
                    let data2 = data.date;
                    const _errs11 = errors;
                    const _errs12 = errors;
                    if (errors === _errs12) {
                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                            let missing3;
                            if (data2.operandType === undefined && (missing3 = 'operandType')) {
                                validate86.errors = [
                                    {
                                        instancePath: instancePath + '/date',
                                        schemaPath: 'urn:wisepipe-common-pipe:DateOperand/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing3 },
                                        message: "must have required property '" + missing3 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data2.operandType !== undefined) {
                                    let data3 = data2.operandType;
                                    if (typeof data3 !== 'string') {
                                        validate86.errors = [
                                            {
                                                instancePath: instancePath + '/date/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:DateOperand/properties/operandType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data3 === 'now' || data3 === 'column' || data3 === 'literal')) {
                                        validate86.errors = [
                                            {
                                                instancePath: instancePath + '/date/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:DateOperand/properties/operandType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema124.properties.operandType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate86.errors = [
                                {
                                    instancePath: instancePath + '/date',
                                    schemaPath: 'urn:wisepipe-common-pipe:DateOperand/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid5 = _errs11 === errors;
                }
                else {
                    var valid5 = true;
                }
                if (valid5) {
                    if (data.interval !== undefined) {
                        let data4 = data.interval;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        let valid8 = false;
                        let passing0 = null;
                        const _errs18 = errors;
                        const _errs19 = errors;
                        if (errors === _errs19) {
                            if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                const err4 = {
                                    instancePath: instancePath + '/interval',
                                    schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs18 === errors;
                        if (_valid2) {
                            valid8 = true;
                            passing0 = 0;
                        }
                        const _errs21 = errors;
                        if (!(typeof data4 == 'number')) {
                            const err5 = {
                                instancePath: instancePath + '/interval',
                                schemaPath: '#/properties/interval/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            };
                            if (vErrors === null) {
                                vErrors = [err5];
                            }
                            else {
                                vErrors.push(err5);
                            }
                            errors++;
                        }
                        var _valid2 = _errs21 === errors;
                        if (_valid2 && valid8) {
                            valid8 = false;
                            passing0 = [passing0, 1];
                        }
                        else {
                            if (_valid2) {
                                valid8 = true;
                                passing0 = 1;
                            }
                        }
                        if (!valid8) {
                            const err6 = {
                                instancePath: instancePath + '/interval',
                                schemaPath: '#/properties/interval/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing0 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                            validate86.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs17;
                            if (vErrors !== null) {
                                if (_errs17) {
                                    vErrors.length = _errs17;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid5 = _errs16 === errors;
                    }
                    else {
                        var valid5 = true;
                    }
                    if (valid5) {
                        if (data.alias !== undefined) {
                            let data5 = data.alias;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            let valid10 = false;
                            let passing1 = null;
                            const _errs25 = errors;
                            const _errs26 = errors;
                            if (errors === _errs26) {
                                if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                    const err7 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err7];
                                    }
                                    else {
                                        vErrors.push(err7);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs25 === errors;
                            if (_valid3) {
                                valid10 = true;
                                passing1 = 0;
                            }
                            const _errs28 = errors;
                            if (errors === _errs28) {
                                if (typeof data5 === 'string') {
                                    if (func2(data5) > 150) {
                                        const err8 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/oneOf/1/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err8];
                                        }
                                        else {
                                            vErrors.push(err8);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (func2(data5) < 1) {
                                            const err9 = {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err9];
                                            }
                                            else {
                                                vErrors.push(err9);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err10 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs28 === errors;
                            if (_valid3 && valid10) {
                                valid10 = false;
                                passing1 = [passing1, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid10 = true;
                                    passing1 = 1;
                                }
                            }
                            if (!valid10) {
                                const err11 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing1 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                                validate86.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs24;
                                if (vErrors !== null) {
                                    if (_errs24) {
                                        vErrors.length = _errs24;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid5 = _errs23 === errors;
                        }
                        else {
                            var valid5 = true;
                        }
                        if (valid5) {
                            if (data.addType !== undefined) {
                                let data6 = data.addType;
                                const _errs30 = errors;
                                const _errs31 = errors;
                                let valid12 = false;
                                let passing2 = null;
                                const _errs32 = errors;
                                const _errs33 = errors;
                                if (errors === _errs33) {
                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                        if (data6.toolEnumType !== undefined) {
                                            let data7 = data6.toolEnumType;
                                            if (typeof data7 !== 'string') {
                                                const err12 = {
                                                    instancePath: instancePath + '/addType/toolEnumType',
                                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err12];
                                                }
                                                else {
                                                    vErrors.push(err12);
                                                }
                                                errors++;
                                            }
                                            if (!(data7 === 'SortDirection' ||
                                                data7 === 'AggregateColumnOperation' ||
                                                data7 === 'DateFrequency' ||
                                                data7 === 'DateAddType' ||
                                                data7 === 'DateAddUnit' ||
                                                data7 === 'DateUnitType' ||
                                                data7 === 'DatePartType' ||
                                                data7 === 'JoinOperator' ||
                                                data7 === 'JoinPattern' ||
                                                data7 === 'FilterStatementOp' ||
                                                data7 === 'ColumnType' ||
                                                data7 === 'PeriodAddType')) {
                                                const err13 = {
                                                    instancePath: instancePath + '/addType/toolEnumType',
                                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err13];
                                                }
                                                else {
                                                    vErrors.push(err13);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err14 = {
                                            instancePath: instancePath + '/addType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err14];
                                        }
                                        else {
                                            vErrors.push(err14);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs32 === errors;
                                if (_valid4) {
                                    valid12 = true;
                                    passing2 = 0;
                                }
                                const _errs37 = errors;
                                if (typeof data6 !== 'string') {
                                    const err15 = {
                                        instancePath: instancePath + '/addType',
                                        schemaPath: '#/properties/addType/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err15];
                                    }
                                    else {
                                        vErrors.push(err15);
                                    }
                                    errors++;
                                }
                                if (!(data6 === 'number' || data6 === 'column' || data6 === 'none')) {
                                    const err16 = {
                                        instancePath: instancePath + '/addType',
                                        schemaPath: '#/properties/addType/oneOf/1/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema123.properties.addType.oneOf[1].enum },
                                        message: 'must be equal to one of the allowed values'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err16];
                                    }
                                    else {
                                        vErrors.push(err16);
                                    }
                                    errors++;
                                }
                                var _valid4 = _errs37 === errors;
                                if (_valid4 && valid12) {
                                    valid12 = false;
                                    passing2 = [passing2, 1];
                                }
                                else {
                                    if (_valid4) {
                                        valid12 = true;
                                        passing2 = 1;
                                    }
                                }
                                if (!valid12) {
                                    const err17 = {
                                        instancePath: instancePath + '/addType',
                                        schemaPath: '#/properties/addType/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing2 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err17];
                                    }
                                    else {
                                        vErrors.push(err17);
                                    }
                                    errors++;
                                    validate86.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs31;
                                    if (vErrors !== null) {
                                        if (_errs31) {
                                            vErrors.length = _errs31;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid5 = _errs30 === errors;
                            }
                            else {
                                var valid5 = true;
                            }
                            if (valid5) {
                                if (data.unit !== undefined) {
                                    let data8 = data.unit;
                                    const _errs39 = errors;
                                    const _errs40 = errors;
                                    let valid15 = false;
                                    let passing3 = null;
                                    const _errs41 = errors;
                                    const _errs42 = errors;
                                    if (errors === _errs42) {
                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                            if (data8.toolEnumType !== undefined) {
                                                let data9 = data8.toolEnumType;
                                                if (typeof data9 !== 'string') {
                                                    const err18 = {
                                                        instancePath: instancePath + '/unit/toolEnumType',
                                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err18];
                                                    }
                                                    else {
                                                        vErrors.push(err18);
                                                    }
                                                    errors++;
                                                }
                                                if (!(data9 === 'SortDirection' ||
                                                    data9 === 'AggregateColumnOperation' ||
                                                    data9 === 'DateFrequency' ||
                                                    data9 === 'DateAddType' ||
                                                    data9 === 'DateAddUnit' ||
                                                    data9 === 'DateUnitType' ||
                                                    data9 === 'DatePartType' ||
                                                    data9 === 'JoinOperator' ||
                                                    data9 === 'JoinPattern' ||
                                                    data9 === 'FilterStatementOp' ||
                                                    data9 === 'ColumnType' ||
                                                    data9 === 'PeriodAddType')) {
                                                    const err19 = {
                                                        instancePath: instancePath + '/unit/toolEnumType',
                                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err19];
                                                    }
                                                    else {
                                                        vErrors.push(err19);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err20 = {
                                                instancePath: instancePath + '/unit',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err20];
                                            }
                                            else {
                                                vErrors.push(err20);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid5 = _errs41 === errors;
                                    if (_valid5) {
                                        valid15 = true;
                                        passing3 = 0;
                                    }
                                    const _errs46 = errors;
                                    if (typeof data8 !== 'string') {
                                        const err21 = {
                                            instancePath: instancePath + '/unit',
                                            schemaPath: '#/properties/unit/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                    if (!(data8 === 'Years' ||
                                        data8 === 'Months' ||
                                        data8 === 'Days' ||
                                        data8 === 'Hours' ||
                                        data8 === 'Minutes' ||
                                        data8 === 'Seconds' ||
                                        data8 === 'Milliseconds')) {
                                        const err22 = {
                                            instancePath: instancePath + '/unit',
                                            schemaPath: '#/properties/unit/oneOf/1/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema123.properties.unit.oneOf[1].enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err22];
                                        }
                                        else {
                                            vErrors.push(err22);
                                        }
                                        errors++;
                                    }
                                    var _valid5 = _errs46 === errors;
                                    if (_valid5 && valid15) {
                                        valid15 = false;
                                        passing3 = [passing3, 1];
                                    }
                                    else {
                                        if (_valid5) {
                                            valid15 = true;
                                            passing3 = 1;
                                        }
                                    }
                                    if (!valid15) {
                                        const err23 = {
                                            instancePath: instancePath + '/unit',
                                            schemaPath: '#/properties/unit/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing3 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                        validate86.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs40;
                                        if (vErrors !== null) {
                                            if (_errs40) {
                                                vErrors.length = _errs40;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid5 = _errs39 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data.column !== undefined) {
                                        let data10 = data.column;
                                        const _errs48 = errors;
                                        const _errs49 = errors;
                                        let valid18 = false;
                                        let passing4 = null;
                                        const _errs50 = errors;
                                        const _errs51 = errors;
                                        if (errors === _errs51) {
                                            if (!(data10 && typeof data10 == 'object' && !Array.isArray(data10))) {
                                                const err24 = {
                                                    instancePath: instancePath + '/column',
                                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err24];
                                                }
                                                else {
                                                    vErrors.push(err24);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid6 = _errs50 === errors;
                                        if (_valid6) {
                                            valid18 = true;
                                            passing4 = 0;
                                        }
                                        const _errs53 = errors;
                                        if (errors === _errs53) {
                                            if (typeof data10 === 'string') {
                                                if (func2(data10) > 150) {
                                                    const err25 = {
                                                        instancePath: instancePath + '/column',
                                                        schemaPath: '#/properties/column/oneOf/1/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err25];
                                                    }
                                                    else {
                                                        vErrors.push(err25);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    if (func2(data10) < 1) {
                                                        const err26 = {
                                                            instancePath: instancePath + '/column',
                                                            schemaPath: '#/properties/column/oneOf/1/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err26];
                                                        }
                                                        else {
                                                            vErrors.push(err26);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err27 = {
                                                    instancePath: instancePath + '/column',
                                                    schemaPath: '#/properties/column/oneOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err27];
                                                }
                                                else {
                                                    vErrors.push(err27);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid6 = _errs53 === errors;
                                        if (_valid6 && valid18) {
                                            valid18 = false;
                                            passing4 = [passing4, 1];
                                        }
                                        else {
                                            if (_valid6) {
                                                valid18 = true;
                                                passing4 = 1;
                                            }
                                        }
                                        if (!valid18) {
                                            const err28 = {
                                                instancePath: instancePath + '/column',
                                                schemaPath: '#/properties/column/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing4 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err28];
                                            }
                                            else {
                                                vErrors.push(err28);
                                            }
                                            errors++;
                                            validate86.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs49;
                                            if (vErrors !== null) {
                                                if (_errs49) {
                                                    vErrors.length = _errs49;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid5 = _errs48 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate86.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate86.errors = vErrors;
    return errors === 0;
}
export const dateAggregateConfigSchemaValidation = validate87;
const schema130 = {
    $id: 'urn:wisepipe-common-pipe:DateAggregateConfig',
    type: 'object',
    properties: {
        dateColumn: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1 }] },
        frequency: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['yearly', 'quarterly', 'monthly', 'weekly', 'daily'] }
            ]
        },
        aggColumn: { $ref: 'urn:wisepipe-base-pipe:AggregateColumn' },
        groupByColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
            uniqueItems: true
        }
    },
    required: ['dateColumn', 'frequency', 'aggColumn']
};
function validate87(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateAggregateConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.frequency === undefined && (missing0 = 'frequency')) ||
                (data.aggColumn === undefined && (missing0 = 'aggColumn'))) {
                validate87.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/dateColumn',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                const err1 = {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/oneOf/1/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err2 = {
                                instancePath: instancePath + '/dateColumn',
                                schemaPath: '#/properties/dateColumn/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err3 = {
                            instancePath: instancePath + '/dateColumn',
                            schemaPath: '#/properties/dateColumn/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                        validate87.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.frequency !== undefined) {
                        let data1 = data.frequency;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        let passing1 = null;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                if (data1.toolEnumType !== undefined) {
                                    let data2 = data1.toolEnumType;
                                    if (typeof data2 !== 'string') {
                                        const err4 = {
                                            instancePath: instancePath + '/frequency/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                    if (!(data2 === 'SortDirection' ||
                                        data2 === 'AggregateColumnOperation' ||
                                        data2 === 'DateFrequency' ||
                                        data2 === 'DateAddType' ||
                                        data2 === 'DateAddUnit' ||
                                        data2 === 'DateUnitType' ||
                                        data2 === 'DatePartType' ||
                                        data2 === 'JoinOperator' ||
                                        data2 === 'JoinPattern' ||
                                        data2 === 'FilterStatementOp' ||
                                        data2 === 'ColumnType' ||
                                        data2 === 'PeriodAddType')) {
                                        const err5 = {
                                            instancePath: instancePath + '/frequency/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err5];
                                        }
                                        else {
                                            vErrors.push(err5);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err6 = {
                                    instancePath: instancePath + '/frequency',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        if (_valid1) {
                            valid3 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (typeof data1 !== 'string') {
                            const err7 = {
                                instancePath: instancePath + '/frequency',
                                schemaPath: '#/properties/frequency/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (!(data1 === 'yearly' ||
                            data1 === 'quarterly' ||
                            data1 === 'monthly' ||
                            data1 === 'weekly' ||
                            data1 === 'daily')) {
                            const err8 = {
                                instancePath: instancePath + '/frequency',
                                schemaPath: '#/properties/frequency/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema130.properties.frequency.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid3) {
                            valid3 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid3 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid3) {
                            const err9 = {
                                instancePath: instancePath + '/frequency',
                                schemaPath: '#/properties/frequency/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                            validate87.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.aggColumn !== undefined) {
                            const _errs17 = errors;
                            if (!validate16(data.aggColumn, {
                                instancePath: instancePath + '/aggColumn',
                                parentData: data,
                                parentDataProperty: 'aggColumn',
                                rootData
                            })) {
                                vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                                errors = vErrors.length;
                            }
                            var valid0 = _errs17 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.groupByColumns !== undefined) {
                                let data4 = data.groupByColumns;
                                const _errs18 = errors;
                                if (errors === _errs18) {
                                    if (Array.isArray(data4)) {
                                        var valid6 = true;
                                        const len0 = data4.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data5 = data4[i0];
                                            const _errs20 = errors;
                                            const _errs21 = errors;
                                            let valid7 = false;
                                            let passing2 = null;
                                            const _errs22 = errors;
                                            const _errs23 = errors;
                                            if (errors === _errs23) {
                                                if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                                    const err10 = {
                                                        instancePath: instancePath + '/groupByColumns/' + i0,
                                                        schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err10];
                                                    }
                                                    else {
                                                        vErrors.push(err10);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            var _valid2 = _errs22 === errors;
                                            if (_valid2) {
                                                valid7 = true;
                                                passing2 = 0;
                                            }
                                            const _errs25 = errors;
                                            if (typeof data5 !== 'string') {
                                                const err11 = {
                                                    instancePath: instancePath + '/groupByColumns/' + i0,
                                                    schemaPath: '#/properties/groupByColumns/items/oneOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err11];
                                                }
                                                else {
                                                    vErrors.push(err11);
                                                }
                                                errors++;
                                            }
                                            var _valid2 = _errs25 === errors;
                                            if (_valid2 && valid7) {
                                                valid7 = false;
                                                passing2 = [passing2, 1];
                                            }
                                            else {
                                                if (_valid2) {
                                                    valid7 = true;
                                                    passing2 = 1;
                                                }
                                            }
                                            if (!valid7) {
                                                const err12 = {
                                                    instancePath: instancePath + '/groupByColumns/' + i0,
                                                    schemaPath: '#/properties/groupByColumns/items/oneOf',
                                                    keyword: 'oneOf',
                                                    params: { passingSchemas: passing2 },
                                                    message: 'must match exactly one schema in oneOf'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err12];
                                                }
                                                else {
                                                    vErrors.push(err12);
                                                }
                                                errors++;
                                                validate87.errors = vErrors;
                                                return false;
                                            }
                                            else {
                                                errors = _errs21;
                                                if (vErrors !== null) {
                                                    if (_errs21) {
                                                        vErrors.length = _errs21;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                            }
                                            var valid6 = _errs20 === errors;
                                            if (!valid6) {
                                                break;
                                            }
                                        }
                                        if (valid6) {
                                            let i1 = data4.length;
                                            let j0;
                                            if (i1 > 1) {
                                                outer0: for (; i1--;) {
                                                    for (j0 = i1; j0--;) {
                                                        if (func0(data4[i1], data4[j0])) {
                                                            validate87.errors = [
                                                                {
                                                                    instancePath: instancePath + '/groupByColumns',
                                                                    schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                    keyword: 'uniqueItems',
                                                                    params: { i: i1, j: j0 },
                                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate87.errors = [
                                            {
                                                instancePath: instancePath + '/groupByColumns',
                                                schemaPath: '#/properties/groupByColumns/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs18 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate87.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate87.errors = vErrors;
    return errors === 0;
}
export const dateColumnSchemaValidation = validate89;
const schema134 = {
    $id: 'urn:wisepipe-common-pipe:DateColumn',
    type: 'object',
    properties: {
        name: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['name']
};
function validate89(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate89.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/name',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/name',
                                schemaPath: '#/properties/name/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate89.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate89.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate89.errors = vErrors;
    return errors === 0;
}
export const dateDiffConfigSchemaValidation = validate90;
const schema136 = {
    $id: 'urn:wisepipe-common-pipe:DateDiffConfig',
    type: 'object',
    properties: {
        lhs: { $ref: 'urn:wisepipe-common-pipe:DateOperand' },
        rhs: { $ref: 'urn:wisepipe-common-pipe:DateOperand' },
        unit: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['year', 'month', 'day', 'hour', 'minute', 'second'] }
            ]
        },
        alias: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['lhs', 'rhs', 'unit', 'alias']
};
function validate90(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateDiffConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lhs === undefined && (missing0 = 'lhs')) ||
                (data.rhs === undefined && (missing0 = 'rhs')) ||
                (data.unit === undefined && (missing0 = 'unit')) ||
                (data.alias === undefined && (missing0 = 'alias'))) {
                validate90.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lhs !== undefined) {
                    let data0 = data.lhs;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.operandType === undefined && (missing1 = 'operandType')) {
                                validate90.errors = [
                                    {
                                        instancePath: instancePath + '/lhs',
                                        schemaPath: 'urn:wisepipe-common-pipe:DateOperand/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.operandType !== undefined) {
                                    let data1 = data0.operandType;
                                    if (typeof data1 !== 'string') {
                                        validate90.errors = [
                                            {
                                                instancePath: instancePath + '/lhs/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:DateOperand/properties/operandType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data1 === 'now' || data1 === 'column' || data1 === 'literal')) {
                                        validate90.errors = [
                                            {
                                                instancePath: instancePath + '/lhs/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:DateOperand/properties/operandType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema124.properties.operandType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate90.errors = [
                                {
                                    instancePath: instancePath + '/lhs',
                                    schemaPath: 'urn:wisepipe-common-pipe:DateOperand/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rhs !== undefined) {
                        let data2 = data.rhs;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing2;
                                if (data2.operandType === undefined && (missing2 = 'operandType')) {
                                    validate90.errors = [
                                        {
                                            instancePath: instancePath + '/rhs',
                                            schemaPath: 'urn:wisepipe-common-pipe:DateOperand/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.operandType !== undefined) {
                                        let data3 = data2.operandType;
                                        if (typeof data3 !== 'string') {
                                            validate90.errors = [
                                                {
                                                    instancePath: instancePath + '/rhs/operandType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:DateOperand/properties/operandType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data3 === 'now' || data3 === 'column' || data3 === 'literal')) {
                                            validate90.errors = [
                                                {
                                                    instancePath: instancePath + '/rhs/operandType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:DateOperand/properties/operandType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema124.properties.operandType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate90.errors = [
                                    {
                                        instancePath: instancePath + '/rhs',
                                        schemaPath: 'urn:wisepipe-common-pipe:DateOperand/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.unit !== undefined) {
                            let data4 = data.unit;
                            const _errs11 = errors;
                            const _errs12 = errors;
                            let valid5 = false;
                            let passing0 = null;
                            const _errs13 = errors;
                            const _errs14 = errors;
                            if (errors === _errs14) {
                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                    if (data4.toolEnumType !== undefined) {
                                        let data5 = data4.toolEnumType;
                                        if (typeof data5 !== 'string') {
                                            const err0 = {
                                                instancePath: instancePath + '/unit/toolEnumType',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                        if (!(data5 === 'SortDirection' ||
                                            data5 === 'AggregateColumnOperation' ||
                                            data5 === 'DateFrequency' ||
                                            data5 === 'DateAddType' ||
                                            data5 === 'DateAddUnit' ||
                                            data5 === 'DateUnitType' ||
                                            data5 === 'DatePartType' ||
                                            data5 === 'JoinOperator' ||
                                            data5 === 'JoinPattern' ||
                                            data5 === 'FilterStatementOp' ||
                                            data5 === 'ColumnType' ||
                                            data5 === 'PeriodAddType')) {
                                            const err1 = {
                                                instancePath: instancePath + '/unit/toolEnumType',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err1];
                                            }
                                            else {
                                                vErrors.push(err1);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err2 = {
                                        instancePath: instancePath + '/unit',
                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                            var _valid0 = _errs13 === errors;
                            if (_valid0) {
                                valid5 = true;
                                passing0 = 0;
                            }
                            const _errs18 = errors;
                            if (typeof data4 !== 'string') {
                                const err3 = {
                                    instancePath: instancePath + '/unit',
                                    schemaPath: '#/properties/unit/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                            if (!(data4 === 'year' ||
                                data4 === 'month' ||
                                data4 === 'day' ||
                                data4 === 'hour' ||
                                data4 === 'minute' ||
                                data4 === 'second')) {
                                const err4 = {
                                    instancePath: instancePath + '/unit',
                                    schemaPath: '#/properties/unit/oneOf/1/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema136.properties.unit.oneOf[1].enum },
                                    message: 'must be equal to one of the allowed values'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                            var _valid0 = _errs18 === errors;
                            if (_valid0 && valid5) {
                                valid5 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid0) {
                                    valid5 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid5) {
                                const err5 = {
                                    instancePath: instancePath + '/unit',
                                    schemaPath: '#/properties/unit/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                                validate90.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs12;
                                if (vErrors !== null) {
                                    if (_errs12) {
                                        vErrors.length = _errs12;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs11 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.alias !== undefined) {
                                let data6 = data.alias;
                                const _errs20 = errors;
                                const _errs21 = errors;
                                let valid8 = false;
                                let passing1 = null;
                                const _errs22 = errors;
                                const _errs23 = errors;
                                if (errors === _errs23) {
                                    if (!(data6 && typeof data6 == 'object' && !Array.isArray(data6))) {
                                        const err6 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid1 = _errs22 === errors;
                                if (_valid1) {
                                    valid8 = true;
                                    passing1 = 0;
                                }
                                const _errs25 = errors;
                                if (errors === _errs25) {
                                    if (typeof data6 === 'string') {
                                        if (func2(data6) > 150) {
                                            const err7 = {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/oneOf/1/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err7];
                                            }
                                            else {
                                                vErrors.push(err7);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (func2(data6) < 1) {
                                                const err8 = {
                                                    instancePath: instancePath + '/alias',
                                                    schemaPath: '#/properties/alias/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err8];
                                                }
                                                else {
                                                    vErrors.push(err8);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err9 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err9];
                                        }
                                        else {
                                            vErrors.push(err9);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid1 = _errs25 === errors;
                                if (_valid1 && valid8) {
                                    valid8 = false;
                                    passing1 = [passing1, 1];
                                }
                                else {
                                    if (_valid1) {
                                        valid8 = true;
                                        passing1 = 1;
                                    }
                                }
                                if (!valid8) {
                                    const err10 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing1 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                    validate90.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs21;
                                    if (vErrors !== null) {
                                        if (_errs21) {
                                            vErrors.length = _errs21;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs20 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate90.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate90.errors = vErrors;
    return errors === 0;
}
export const dateFormatConfigSchemaValidation = validate91;
const schema141 = {
    $id: 'urn:wisepipe-common-pipe:DateFormatConfig',
    type: 'object',
    properties: {
        outputType: { type: 'string', pattern: 'date|string' },
        columns: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true
        },
        format: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string' }] }
    },
    required: ['outputType', 'columns', 'format']
};
const pattern7 = new RegExp('date|string', 'u');
function validate91(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateFormatConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.outputType === undefined && (missing0 = 'outputType')) ||
                (data.columns === undefined && (missing0 = 'columns')) ||
                (data.format === undefined && (missing0 = 'format'))) {
                validate91.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.outputType !== undefined) {
                    let data0 = data.outputType;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern7.test(data0)) {
                                validate91.errors = [
                                    {
                                        instancePath: instancePath + '/outputType',
                                        schemaPath: '#/properties/outputType/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: 'date|string' },
                                        message: 'must match pattern "' + 'date|string' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate91.errors = [
                                {
                                    instancePath: instancePath + '/outputType',
                                    schemaPath: '#/properties/outputType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columns !== undefined) {
                        let data1 = data.columns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    let valid2 = false;
                                    let passing0 = null;
                                    const _errs7 = errors;
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                            const err0 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs7 === errors;
                                    if (_valid0) {
                                        valid2 = true;
                                        passing0 = 0;
                                    }
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) > 150) {
                                                const err1 = {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/oneOf/1/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 150 },
                                                    message: 'must NOT have more than 150 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err1];
                                                }
                                                else {
                                                    vErrors.push(err1);
                                                }
                                                errors++;
                                            }
                                            else {
                                                if (func2(data2) < 1) {
                                                    const err2 = {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/oneOf/1/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err2];
                                                    }
                                                    else {
                                                        vErrors.push(err2);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err3 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err3];
                                            }
                                            else {
                                                vErrors.push(err3);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs10 === errors;
                                    if (_valid0 && valid2) {
                                        valid2 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid2) {
                                        const err4 = {
                                            instancePath: instancePath + '/columns/' + i0,
                                            schemaPath: '#/properties/columns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                        validate91.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs6;
                                        if (vErrors !== null) {
                                            if (_errs6) {
                                                vErrors.length = _errs6;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data1[i1], data1[j0])) {
                                                    validate91.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate91.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.format !== undefined) {
                            let data3 = data.format;
                            const _errs12 = errors;
                            const _errs13 = errors;
                            let valid5 = false;
                            let passing1 = null;
                            const _errs14 = errors;
                            const _errs15 = errors;
                            if (errors === _errs15) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err5 = {
                                        instancePath: instancePath + '/format',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs14 === errors;
                            if (_valid1) {
                                valid5 = true;
                                passing1 = 0;
                            }
                            const _errs17 = errors;
                            if (typeof data3 !== 'string') {
                                const err6 = {
                                    instancePath: instancePath + '/format',
                                    schemaPath: '#/properties/format/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            var _valid1 = _errs17 === errors;
                            if (_valid1 && valid5) {
                                valid5 = false;
                                passing1 = [passing1, 1];
                            }
                            else {
                                if (_valid1) {
                                    valid5 = true;
                                    passing1 = 1;
                                }
                            }
                            if (!valid5) {
                                const err7 = {
                                    instancePath: instancePath + '/format',
                                    schemaPath: '#/properties/format/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing1 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                                validate91.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs13;
                                if (vErrors !== null) {
                                    if (_errs13) {
                                        vErrors.length = _errs13;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate91.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate91.errors = vErrors;
    return errors === 0;
}
export const dateLiteralSchemaValidation = validate92;
const schema144 = {
    $id: 'urn:wisepipe-common-pipe:DateLiteral',
    type: 'object',
    properties: {
        value: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:DateToolVariable' }, { type: 'string', format: 'date-time' }] }
    },
    required: ['value']
};
const schema145 = { $id: 'urn:wisepipe-base-pipe:DateToolVariable', type: 'object', properties: {} };
function validate92(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateLiteral" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.value === undefined && (missing0 = 'value')) {
                validate92.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.value !== undefined) {
                    let data0 = data.value;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/value',
                                schemaPath: 'urn:wisepipe-base-pipe:DateToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (errors === _errs6) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    const err1 = {
                                        instancePath: instancePath + '/value',
                                        schemaPath: '#/properties/value/oneOf/1/format',
                                        keyword: 'format',
                                        params: { format: 'date-time' },
                                        message: 'must match format "' + 'date-time' + '"'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err2 = {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/properties/value/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                            }
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err3 = {
                            instancePath: instancePath + '/value',
                            schemaPath: '#/properties/value/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                        validate92.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate92.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate92.errors = vErrors;
    return errors === 0;
}
export const dateNowSchemaValidation = validate93;
const schema146 = { $id: 'urn:wisepipe-common-pipe:DateNow', type: 'object', properties: {} };
function validate93(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateNow" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate93.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate93.errors = vErrors;
    return errors === 0;
}
export const dateOperandSchemaValidation = validate94;
function validate94(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DateOperand" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.operandType === undefined && (missing0 = 'operandType')) {
                validate94.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.operandType !== undefined) {
                    let data0 = data.operandType;
                    if (typeof data0 !== 'string') {
                        validate94.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'now' || data0 === 'column' || data0 === 'literal')) {
                        validate94.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema124.properties.operandType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate94.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate94.errors = vErrors;
    return errors === 0;
}
export const datePartConfigSchemaValidation = validate95;
const schema148 = {
    $id: 'urn:wisepipe-common-pipe:DatePartConfig',
    type: 'object',
    properties: {
        source: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        parts: {
            type: 'array',
            items: {
                oneOf: [
                    { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                    { type: 'string', enum: ['year', 'month', 'quarter', 'week', 'day', 'weekday', 'hour', 'minute', 'second'] }
                ]
            },
            minItems: 1,
            uniqueItems: true
        }
    },
    required: ['source', 'parts']
};
function validate95(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DatePartConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.source === undefined && (missing0 = 'source')) || (data.parts === undefined && (missing0 = 'parts'))) {
                validate95.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.source !== undefined) {
                    let data0 = data.source;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/source',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/source',
                                    schemaPath: '#/properties/source/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/source',
                                        schemaPath: '#/properties/source/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/source',
                                schemaPath: '#/properties/source/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/source',
                            schemaPath: '#/properties/source/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate95.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.parts !== undefined) {
                        let data1 = data.parts;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate95.errors = [
                                        {
                                            instancePath: instancePath + '/parts',
                                            schemaPath: '#/properties/parts/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid3 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs10 = errors;
                                        const _errs11 = errors;
                                        let valid4 = false;
                                        let passing1 = null;
                                        const _errs12 = errors;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                                if (data2.toolEnumType !== undefined) {
                                                    let data3 = data2.toolEnumType;
                                                    if (typeof data3 !== 'string') {
                                                        const err5 = {
                                                            instancePath: instancePath + '/parts/' + i0 + '/toolEnumType',
                                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err5];
                                                        }
                                                        else {
                                                            vErrors.push(err5);
                                                        }
                                                        errors++;
                                                    }
                                                    if (!(data3 === 'SortDirection' ||
                                                        data3 === 'AggregateColumnOperation' ||
                                                        data3 === 'DateFrequency' ||
                                                        data3 === 'DateAddType' ||
                                                        data3 === 'DateAddUnit' ||
                                                        data3 === 'DateUnitType' ||
                                                        data3 === 'DatePartType' ||
                                                        data3 === 'JoinOperator' ||
                                                        data3 === 'JoinPattern' ||
                                                        data3 === 'FilterStatementOp' ||
                                                        data3 === 'ColumnType' ||
                                                        data3 === 'PeriodAddType')) {
                                                        const err6 = {
                                                            instancePath: instancePath + '/parts/' + i0 + '/toolEnumType',
                                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err6];
                                                        }
                                                        else {
                                                            vErrors.push(err6);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err7 = {
                                                    instancePath: instancePath + '/parts/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err7];
                                                }
                                                else {
                                                    vErrors.push(err7);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid1 = _errs12 === errors;
                                        if (_valid1) {
                                            valid4 = true;
                                            passing1 = 0;
                                        }
                                        const _errs17 = errors;
                                        if (typeof data2 !== 'string') {
                                            const err8 = {
                                                instancePath: instancePath + '/parts/' + i0,
                                                schemaPath: '#/properties/parts/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        if (!(data2 === 'year' ||
                                            data2 === 'month' ||
                                            data2 === 'quarter' ||
                                            data2 === 'week' ||
                                            data2 === 'day' ||
                                            data2 === 'weekday' ||
                                            data2 === 'hour' ||
                                            data2 === 'minute' ||
                                            data2 === 'second')) {
                                            const err9 = {
                                                instancePath: instancePath + '/parts/' + i0,
                                                schemaPath: '#/properties/parts/items/oneOf/1/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema148.properties.parts.items.oneOf[1].enum },
                                                message: 'must be equal to one of the allowed values'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err9];
                                            }
                                            else {
                                                vErrors.push(err9);
                                            }
                                            errors++;
                                        }
                                        var _valid1 = _errs17 === errors;
                                        if (_valid1 && valid4) {
                                            valid4 = false;
                                            passing1 = [passing1, 1];
                                        }
                                        else {
                                            if (_valid1) {
                                                valid4 = true;
                                                passing1 = 1;
                                            }
                                        }
                                        if (!valid4) {
                                            const err10 = {
                                                instancePath: instancePath + '/parts/' + i0,
                                                schemaPath: '#/properties/parts/items/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing1 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err10];
                                            }
                                            else {
                                                vErrors.push(err10);
                                            }
                                            errors++;
                                            validate95.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs11;
                                            if (vErrors !== null) {
                                                if (_errs11) {
                                                    vErrors.length = _errs11;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid3 = _errs10 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                    if (valid3) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (; i1--;) {
                                                for (j0 = i1; j0--;) {
                                                    if (func0(data1[i1], data1[j0])) {
                                                        validate95.errors = [
                                                            {
                                                                instancePath: instancePath + '/parts',
                                                                schemaPath: '#/properties/parts/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate95.errors = [
                                    {
                                        instancePath: instancePath + '/parts',
                                        schemaPath: '#/properties/parts/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate95.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate95.errors = vErrors;
    return errors === 0;
}
export const datePeriodSchemaValidation = validate96;
const schema151 = {
    $id: 'urn:wisepipe-common-pipe:DatePeriod',
    type: 'object',
    properties: {
        periodName: { type: 'string', minLength: 1 },
        startDate: { type: 'string', format: 'date-time' },
        endDate: { type: 'string', format: 'date-time' }
    },
    required: ['periodName', 'startDate', 'endDate']
};
function validate96(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DatePeriod" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.periodName === undefined && (missing0 = 'periodName')) ||
                (data.startDate === undefined && (missing0 = 'startDate')) ||
                (data.endDate === undefined && (missing0 = 'endDate'))) {
                validate96.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.periodName !== undefined) {
                    let data0 = data.periodName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate96.errors = [
                                    {
                                        instancePath: instancePath + '/periodName',
                                        schemaPath: '#/properties/periodName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate96.errors = [
                                {
                                    instancePath: instancePath + '/periodName',
                                    schemaPath: '#/properties/periodName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.startDate !== undefined) {
                        let data1 = data.startDate;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.validate(data1)) {
                                        validate96.errors = [
                                            {
                                                instancePath: instancePath + '/startDate',
                                                schemaPath: '#/properties/startDate/format',
                                                keyword: 'format',
                                                params: { format: 'date-time' },
                                                message: 'must match format "' + 'date-time' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate96.errors = [
                                        {
                                            instancePath: instancePath + '/startDate',
                                            schemaPath: '#/properties/startDate/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.endDate !== undefined) {
                            let data2 = data.endDate;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate96.errors = [
                                                {
                                                    instancePath: instancePath + '/endDate',
                                                    schemaPath: '#/properties/endDate/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate96.errors = [
                                            {
                                                instancePath: instancePath + '/endDate',
                                                schemaPath: '#/properties/endDate/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate96.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate96.errors = vErrors;
    return errors === 0;
}
export const dateToolVariableSchemaValidation = validate97;
function validate97(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:DateToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate97.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate97.errors = vErrors;
    return errors === 0;
}
export const decisionTreeRegressorConfigSchemaValidation = validate98;
const schema153 = {
    $id: 'urn:wisepipe-common-pipe:DecisionTreeRegressorConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate98(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DecisionTreeRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate98.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate98.errors = vErrors;
    return errors === 0;
}
export const decisionTreeTrainConfigSchemaValidation = validate99;
const schema154 = {
    $id: 'urn:wisepipe-common-pipe:DecisionTreeTrainConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate99(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DecisionTreeTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate99.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate99.errors = vErrors;
    return errors === 0;
}
export const demandForecastConfigSchemaValidation = validate100;
const schema155 = { $id: 'urn:wisepipe-common-pipe:DemandForecastConfig', type: 'object', properties: {} };
function validate100(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DemandForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate100.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate100.errors = vErrors;
    return errors === 0;
}
export const distinctConfigSchemaValidation = validate101;
const schema156 = {
    $id: 'urn:wisepipe-common-pipe:DistinctConfig',
    type: 'object',
    properties: {
        columns: { type: 'array', items: { type: 'string', minLength: 1, maxLength: 150 }, uniqueItems: true, minItems: 0 }
    },
    required: []
};
function validate101(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DistinctConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.columns !== undefined) {
                let data0 = data.columns;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (Array.isArray(data0)) {
                        if (data0.length < 0) {
                            validate101.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/minItems',
                                    keyword: 'minItems',
                                    params: { limit: 0 },
                                    message: 'must NOT have fewer than 0 items'
                                }
                            ];
                            return false;
                        }
                        else {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) > 150) {
                                            validate101.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 150 },
                                                    message: 'must NOT have more than 150 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data1) < 1) {
                                                validate101.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate101.errors = [
                                            {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    const indices0 = {};
                                    for (; i1--;) {
                                        let item0 = data0[i1];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j0 = indices0[item0];
                                            validate101.errors = [
                                                {
                                                    instancePath: instancePath + '/columns',
                                                    schemaPath: '#/properties/columns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                }
                                            ];
                                            return false;
                                            break;
                                        }
                                        indices0[item0] = i1;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        validate101.errors = [
                            {
                                instancePath: instancePath + '/columns',
                                schemaPath: '#/properties/columns/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate101.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate101.errors = vErrors;
    return errors === 0;
}
export const dropConfigSchemaValidation = validate102;
const schema157 = {
    $id: 'urn:wisepipe-common-pipe:DropConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['columns']
};
function validate102(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:DropConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate102.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate102.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate102.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        if (errors === _errs3) {
                                            if (typeof data1 === 'string') {
                                                if (func2(data1) > 150) {
                                                    validate102.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 150 },
                                                            message: 'must NOT have more than 150 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data1) < 1) {
                                                        validate102.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns/' + i0,
                                                                schemaPath: '#/properties/columns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate102.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data0[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate102.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate102.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate102.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate102.errors = vErrors;
    return errors === 0;
}
export const edgeElementEventSchemaValidation = validate103;
const schema158 = { $id: 'urn:wisepipe-common-pipe:EdgeElementEvent', type: 'object', properties: {} };
function validate103(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:EdgeElementEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate103.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate103.errors = vErrors;
    return errors === 0;
}
export const edgeElementSchemaValidation = validate104;
const schema159 = {
    $id: 'urn:wisepipe-common-pipe:EdgeElement',
    type: 'object',
    properties: {
        srcElementID: { type: 'string', uid: 10 },
        srcPort: { type: 'string', minLength: 1 },
        tarElementID: { type: 'string', uid: 10 },
        tarPort: { type: 'string', minLength: 1 }
    },
    required: ['srcElementID', 'srcPort', 'tarElementID', 'tarPort']
};
const func140 = ucs2length;
const func141 = base64urlToBuffer;
const func142 = base64urlEncode;
const func143 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func145 = ucs2length;
const func146 = base64urlToBuffer;
const func147 = base64urlEncode;
const func148 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate104(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:EdgeElement" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.srcElementID === undefined && (missing0 = 'srcElementID')) ||
                (data.srcPort === undefined && (missing0 = 'srcPort')) ||
                (data.tarElementID === undefined && (missing0 = 'tarElementID')) ||
                (data.tarPort === undefined && (missing0 = 'tarPort'))) {
                validate104.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.srcElementID !== undefined) {
                    let data0 = data.srcElementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func140(data0) < b64min0 || func140(data0) > b64max0) {
                                validate104.errors = [
                                    {
                                        instancePath: instancePath + '/srcElementID',
                                        schemaPath: '#/properties/srcElementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func140(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func140(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func141(data0);
                                if (decoded0.length !== 10) {
                                    validate104.errors = [
                                        {
                                            instancePath: instancePath + '/srcElementID',
                                            schemaPath: '#/properties/srcElementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func142(decoded0);
                                    if (func143(encoded0) !== func143(data0)) {
                                        validate104.errors = [
                                            {
                                                instancePath: instancePath + '/srcElementID',
                                                schemaPath: '#/properties/srcElementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate104.errors = [
                                {
                                    instancePath: instancePath + '/srcElementID',
                                    schemaPath: '#/properties/srcElementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.srcPort !== undefined) {
                        let data1 = data.srcPort;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate104.errors = [
                                        {
                                            instancePath: instancePath + '/srcPort',
                                            schemaPath: '#/properties/srcPort/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate104.errors = [
                                    {
                                        instancePath: instancePath + '/srcPort',
                                        schemaPath: '#/properties/srcPort/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.tarElementID !== undefined) {
                            let data2 = data.tarElementID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func145(data2) < b64min1 || func145(data2) > b64max1) {
                                        validate104.errors = [
                                            {
                                                instancePath: instancePath + '/tarElementID',
                                                schemaPath: '#/properties/tarElementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func145(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func145(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func146(data2);
                                        if (decoded1.length !== 10) {
                                            validate104.errors = [
                                                {
                                                    instancePath: instancePath + '/tarElementID',
                                                    schemaPath: '#/properties/tarElementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func147(decoded1);
                                            if (func148(encoded1) !== func148(data2)) {
                                                validate104.errors = [
                                                    {
                                                        instancePath: instancePath + '/tarElementID',
                                                        schemaPath: '#/properties/tarElementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate104.errors = [
                                        {
                                            instancePath: instancePath + '/tarElementID',
                                            schemaPath: '#/properties/tarElementID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.tarPort !== undefined) {
                                let data3 = data.tarPort;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate104.errors = [
                                                {
                                                    instancePath: instancePath + '/tarPort',
                                                    schemaPath: '#/properties/tarPort/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate104.errors = [
                                            {
                                                instancePath: instancePath + '/tarPort',
                                                schemaPath: '#/properties/tarPort/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate104.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate104.errors = vErrors;
    return errors === 0;
}
export const elementEventSchemaValidation = validate105;
const schema160 = {
    $id: 'urn:wisepipe-common-pipe:ElementEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        elementType: { type: 'string', pattern: 'edge|node|group' },
        eventType: { type: 'string', enum: ['insert', 'modify', 'remove'] }
    },
    required: ['orgID', 'pipeID', 'elementID', 'elementType', 'eventType']
};
const func152 = ucs2length;
const func153 = base64urlToBuffer;
const func154 = base64urlEncode;
const func155 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func156 = ucs2length;
const func157 = base64urlToBuffer;
const func158 = base64urlEncode;
const func159 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const pattern8 = new RegExp('edge|node|group', 'u');
function validate105(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ElementEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.elementType === undefined && (missing0 = 'elementType')) ||
                (data.eventType === undefined && (missing0 = 'eventType'))) {
                validate105.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 128) {
                                validate105.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate105.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate105.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pipeID !== undefined) {
                        let data1 = data.pipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func152(data1) < b64min0 || func152(data1) > b64max0) {
                                    validate105.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func152(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func152(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func153(data1);
                                    if (decoded0.length !== 10) {
                                        validate105.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func154(decoded0);
                                        if (func155(encoded0) !== func155(data1)) {
                                            validate105.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate105.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.elementID !== undefined) {
                            let data2 = data.elementID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func156(data2) < b64min1 || func156(data2) > b64max1) {
                                        validate105.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func156(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func156(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func157(data2);
                                        if (decoded1.length !== 10) {
                                            validate105.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func158(decoded1);
                                            if (func159(encoded1) !== func159(data2)) {
                                                validate105.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate105.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.elementType !== undefined) {
                                let data3 = data.elementType;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (!pattern8.test(data3)) {
                                            validate105.errors = [
                                                {
                                                    instancePath: instancePath + '/elementType',
                                                    schemaPath: '#/properties/elementType/pattern',
                                                    keyword: 'pattern',
                                                    params: { pattern: 'edge|node|group' },
                                                    message: 'must match pattern "' + 'edge|node|group' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate105.errors = [
                                            {
                                                instancePath: instancePath + '/elementType',
                                                schemaPath: '#/properties/elementType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.eventType !== undefined) {
                                    let data4 = data.eventType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate105.errors = [
                                            {
                                                instancePath: instancePath + '/eventType',
                                                schemaPath: '#/properties/eventType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'insert' || data4 === 'modify' || data4 === 'remove')) {
                                        validate105.errors = [
                                            {
                                                instancePath: instancePath + '/eventType',
                                                schemaPath: '#/properties/eventType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema160.properties.eventType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate105.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate105.errors = vErrors;
    return errors === 0;
}
export const encodingsSchemaValidation = validate106;
const schema161 = {
    $id: 'urn:wisepipe-common-pipe:Encodings',
    type: 'object',
    properties: {
        encodings: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { type: 'string', minLength: 1, maxLength: 150 },
                uniqueItems: true,
                minItems: 1,
                maxItems: 1000
            }
        }
    },
    required: ['encodings']
};
function validate106(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:Encodings" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.encodings === undefined && (missing0 = 'encodings')) {
                validate106.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.encodings !== undefined) {
                    let data0 = data.encodings;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                let data1 = data0[key0];
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (Array.isArray(data1)) {
                                        if (data1.length > 1000) {
                                            validate106.errors = [
                                                {
                                                    instancePath: instancePath + '/encodings/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/encodings/additionalProperties/maxItems',
                                                    keyword: 'maxItems',
                                                    params: { limit: 1000 },
                                                    message: 'must NOT have more than 1000 items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.length < 1) {
                                                validate106.errors = [
                                                    {
                                                        instancePath: instancePath + '/encodings/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: '#/properties/encodings/additionalProperties/minItems',
                                                        keyword: 'minItems',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 items'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                var valid2 = true;
                                                const len0 = data1.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    let data2 = data1[i0];
                                                    const _errs6 = errors;
                                                    if (errors === _errs6) {
                                                        if (typeof data2 === 'string') {
                                                            if (func2(data2) > 150) {
                                                                validate106.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/encodings/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/' +
                                                                            i0,
                                                                        schemaPath: '#/properties/encodings/additionalProperties/items/maxLength',
                                                                        keyword: 'maxLength',
                                                                        params: { limit: 150 },
                                                                        message: 'must NOT have more than 150 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (func2(data2) < 1) {
                                                                    validate106.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/encodings/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/' +
                                                                                i0,
                                                                            schemaPath: '#/properties/encodings/additionalProperties/items/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate106.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/encodings/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i0,
                                                                    schemaPath: '#/properties/encodings/additionalProperties/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs6 === errors;
                                                    if (!valid2) {
                                                        break;
                                                    }
                                                }
                                                if (valid2) {
                                                    let i1 = data1.length;
                                                    let j0;
                                                    if (i1 > 1) {
                                                        const indices0 = {};
                                                        for (; i1--;) {
                                                            let item0 = data1[i1];
                                                            if (typeof item0 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices0[item0] == 'number') {
                                                                j0 = indices0[item0];
                                                                validate106.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/encodings/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/encodings/additionalProperties/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i1, j: j0 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices0[item0] = i1;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate106.errors = [
                                            {
                                                instancePath: instancePath + '/encodings/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/encodings/additionalProperties/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate106.errors = [
                                {
                                    instancePath: instancePath + '/encodings',
                                    schemaPath: '#/properties/encodings/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate106.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate106.errors = vErrors;
    return errors === 0;
}
export const ensembleTextClassifierConfigSchemaValidation = validate107;
const schema162 = {
    $id: 'urn:wisepipe-common-pipe:EnsembleTextClassifierConfig',
    type: 'object',
    properties: {
        ngramSize: { type: 'integer', minimum: 1, maximum: 10 },
        lossOption: { type: 'integer', minimum: 0, maximum: 4 }
    },
    required: ['ngramSize', 'lossOption']
};
function validate107(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:EnsembleTextClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.ngramSize === undefined && (missing0 = 'ngramSize')) ||
                (data.lossOption === undefined && (missing0 = 'lossOption'))) {
                validate107.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.ngramSize !== undefined) {
                    let data0 = data.ngramSize;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate107.errors = [
                            {
                                instancePath: instancePath + '/ngramSize',
                                schemaPath: '#/properties/ngramSize/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 10 || isNaN(data0)) {
                                validate107.errors = [
                                    {
                                        instancePath: instancePath + '/ngramSize',
                                        schemaPath: '#/properties/ngramSize/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 10 },
                                        message: 'must be <= 10'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate107.errors = [
                                        {
                                            instancePath: instancePath + '/ngramSize',
                                            schemaPath: '#/properties/ngramSize/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.lossOption !== undefined) {
                        let data1 = data.lossOption;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                            validate107.errors = [
                                {
                                    instancePath: instancePath + '/lossOption',
                                    schemaPath: '#/properties/lossOption/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 > 4 || isNaN(data1)) {
                                    validate107.errors = [
                                        {
                                            instancePath: instancePath + '/lossOption',
                                            schemaPath: '#/properties/lossOption/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 4 },
                                            message: 'must be <= 4'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1 < 0 || isNaN(data1)) {
                                        validate107.errors = [
                                            {
                                                instancePath: instancePath + '/lossOption',
                                                schemaPath: '#/properties/lossOption/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate107.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate107.errors = vErrors;
    return errors === 0;
}
export const enumToolVariableSchemaValidation = validate108;
function validate108(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:EnumToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.toolEnumType !== undefined) {
                let data0 = data.toolEnumType;
                if (typeof data0 !== 'string') {
                    validate108.errors = [
                        {
                            instancePath: instancePath + '/toolEnumType',
                            schemaPath: '#/properties/toolEnumType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'SortDirection' ||
                    data0 === 'AggregateColumnOperation' ||
                    data0 === 'DateFrequency' ||
                    data0 === 'DateAddType' ||
                    data0 === 'DateAddUnit' ||
                    data0 === 'DateUnitType' ||
                    data0 === 'DatePartType' ||
                    data0 === 'JoinOperator' ||
                    data0 === 'JoinPattern' ||
                    data0 === 'FilterStatementOp' ||
                    data0 === 'ColumnType' ||
                    data0 === 'PeriodAddType')) {
                    validate108.errors = [
                        {
                            instancePath: instancePath + '/toolEnumType',
                            schemaPath: '#/properties/toolEnumType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        else {
            validate108.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate108.errors = vErrors;
    return errors === 0;
}
export const expSmoothingForecastConfigSchemaValidation = validate109;
const schema164 = {
    $id: 'urn:wisepipe-common-pipe:ExpSmoothingForecastConfig',
    type: 'object',
    properties: {
        trendType: { type: 'string', enum: ['add', 'mul'] },
        dampedTrend: { type: 'boolean' },
        seasonalType: { type: 'string', enum: ['none', 'add', 'mul'] },
        seasonalPeriods: { type: 'integer', minimum: 2 },
        seasonalityAutomatic: { type: 'boolean' }
    },
    required: ['trendType', 'dampedTrend', 'seasonalType'],
    if: { not: { properties: { seasonalType: { const: 'none' } } } },
    then: { required: ['seasonalPeriods'] }
};
function validate109(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ExpSmoothingForecastConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.seasonalType !== undefined) {
            if ('none' !== data.seasonalType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var valid1 = _errs4 === errors;
    if (valid1) {
        const err1 = {};
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.seasonalPeriods === undefined && (missing0 = 'seasonalPeriods')) {
                validate109.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate109.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.trendType === undefined && (missing1 = 'trendType')) ||
                (data.dampedTrend === undefined && (missing1 = 'dampedTrend')) ||
                (data.seasonalType === undefined && (missing1 = 'seasonalType'))) {
                validate109.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.trendType !== undefined) {
                    let data1 = data.trendType;
                    const _errs7 = errors;
                    if (typeof data1 !== 'string') {
                        validate109.errors = [
                            {
                                instancePath: instancePath + '/trendType',
                                schemaPath: '#/properties/trendType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'add' || data1 === 'mul')) {
                        validate109.errors = [
                            {
                                instancePath: instancePath + '/trendType',
                                schemaPath: '#/properties/trendType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema164.properties.trendType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid3 = _errs7 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.dampedTrend !== undefined) {
                        const _errs9 = errors;
                        if (typeof data.dampedTrend !== 'boolean') {
                            validate109.errors = [
                                {
                                    instancePath: instancePath + '/dampedTrend',
                                    schemaPath: '#/properties/dampedTrend/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid3 = _errs9 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.seasonalType !== undefined) {
                            let data3 = data.seasonalType;
                            const _errs11 = errors;
                            if (typeof data3 !== 'string') {
                                validate109.errors = [
                                    {
                                        instancePath: instancePath + '/seasonalType',
                                        schemaPath: '#/properties/seasonalType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'none' || data3 === 'add' || data3 === 'mul')) {
                                validate109.errors = [
                                    {
                                        instancePath: instancePath + '/seasonalType',
                                        schemaPath: '#/properties/seasonalType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema164.properties.seasonalType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid3 = _errs11 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.seasonalPeriods !== undefined) {
                                let data4 = data.seasonalPeriods;
                                const _errs13 = errors;
                                if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                    validate109.errors = [
                                        {
                                            instancePath: instancePath + '/seasonalPeriods',
                                            schemaPath: '#/properties/seasonalPeriods/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs13) {
                                    if (typeof data4 == 'number') {
                                        if (data4 < 2 || isNaN(data4)) {
                                            validate109.errors = [
                                                {
                                                    instancePath: instancePath + '/seasonalPeriods',
                                                    schemaPath: '#/properties/seasonalPeriods/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 2 },
                                                    message: 'must be >= 2'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid3 = _errs13 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.seasonalityAutomatic !== undefined) {
                                    const _errs15 = errors;
                                    if (typeof data.seasonalityAutomatic !== 'boolean') {
                                        validate109.errors = [
                                            {
                                                instancePath: instancePath + '/seasonalityAutomatic',
                                                schemaPath: '#/properties/seasonalityAutomatic/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid3 = _errs15 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate109.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate109.errors = vErrors;
    return errors === 0;
}
export const expandPicklistConfigSchemaValidation = validate110;
const schema165 = {
    $id: 'urn:wisepipe-common-pipe:ExpandPicklistConfig',
    type: 'object',
    properties: {
        elementIDToExpand: { type: 'string', uid: 10 },
        inputMap: { type: 'object', additionalProperties: { type: 'string' } },
        picklistColumns: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:PicklistColumn' }, minItems: 1 }
    },
    required: ['elementIDToExpand', 'inputMap', 'picklistColumns']
};
const func162 = ucs2length;
const func163 = base64urlToBuffer;
const func164 = base64urlEncode;
const func165 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema166 = {
    $id: 'urn:wisepipe-common-pipe:PicklistColumn',
    type: 'object',
    properties: {
        hierarchy: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:PicklistHierarchyNode' },
            minItems: 1,
            maxItems: 3,
            uniqueItemProperties: ['level']
        },
        includeLinkedAttributes: { type: 'boolean' }
    },
    required: ['hierarchy']
};
const schema167 = {
    $id: 'urn:wisepipe-common-pipe:PicklistHierarchyNode',
    type: 'object',
    properties: {
        level: { type: 'number', minimum: 0, maximum: 2 },
        columnName: { type: 'string' },
        attributes: { type: 'array', items: { type: 'string' } }
    },
    required: ['level', 'columnName']
};
const func166 = ajvEqual;
function validate111(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PicklistColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.hierarchy === undefined && (missing0 = 'hierarchy')) {
                validate111.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.hierarchy !== undefined) {
                    let data0 = data.hierarchy;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 3) {
                                validate111.errors = [
                                    {
                                        instancePath: instancePath + '/hierarchy',
                                        schemaPath: '#/properties/hierarchy/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 3 },
                                        message: 'must NOT have more than 3 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate111.errors = [
                                        {
                                            instancePath: instancePath + '/hierarchy',
                                            schemaPath: '#/properties/hierarchy/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        const _errs4 = errors;
                                        if (errors === _errs4) {
                                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                                let missing1;
                                                if ((data1.level === undefined && (missing1 = 'level')) ||
                                                    (data1.columnName === undefined && (missing1 = 'columnName'))) {
                                                    validate111.errors = [
                                                        {
                                                            instancePath: instancePath + '/hierarchy/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data1.level !== undefined) {
                                                        let data2 = data1.level;
                                                        const _errs6 = errors;
                                                        if (errors === _errs6) {
                                                            if (typeof data2 == 'number') {
                                                                if (data2 > 2 || isNaN(data2)) {
                                                                    validate111.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hierarchy/' + i0 + '/level',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/properties/level/maximum',
                                                                            keyword: 'maximum',
                                                                            params: { comparison: '<=', limit: 2 },
                                                                            message: 'must be <= 2'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data2 < 0 || isNaN(data2)) {
                                                                        validate111.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hierarchy/' + i0 + '/level',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/properties/level/minimum',
                                                                                keyword: 'minimum',
                                                                                params: { comparison: '>=', limit: 0 },
                                                                                message: 'must be >= 0'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate111.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchy/' + i0 + '/level',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/properties/level/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs6 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.columnName !== undefined) {
                                                            const _errs8 = errors;
                                                            if (typeof data1.columnName !== 'string') {
                                                                validate111.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchy/' + i0 + '/columnName',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/properties/columnName/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs8 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.attributes !== undefined) {
                                                                let data4 = data1.attributes;
                                                                const _errs10 = errors;
                                                                if (errors === _errs10) {
                                                                    if (Array.isArray(data4)) {
                                                                        var valid4 = true;
                                                                        const len1 = data4.length;
                                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                                            const _errs12 = errors;
                                                                            if (typeof data4[i1] !== 'string') {
                                                                                validate111.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/hierarchy/' + i0 + '/attributes/' + i1,
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/properties/attributes/items/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid4 = _errs12 === errors;
                                                                            if (!valid4) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate111.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hierarchy/' + i0 + '/attributes',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/properties/attributes/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'array' },
                                                                                message: 'must be array'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid3 = _errs10 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate111.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchy/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:PicklistHierarchyNode/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema166.properties.hierarchy.uniqueItemProperties;
                                        let k0;
                                        let i2 = data0.length;
                                        let j0;
                                        if (i2 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i2 = data0.length; i2--;) {
                                                    let x0 = data0[i2];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i2; j0--;) {
                                                        let y0 = data0[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func166(x0[key0], y0[key0])) {
                                                            validate111.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchy',
                                                                    schemaPath: '#/properties/hierarchy/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate111.errors = [
                                {
                                    instancePath: instancePath + '/hierarchy',
                                    schemaPath: '#/properties/hierarchy/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.includeLinkedAttributes !== undefined) {
                        const _errs14 = errors;
                        if (typeof data.includeLinkedAttributes !== 'boolean') {
                            validate111.errors = [
                                {
                                    instancePath: instancePath + '/includeLinkedAttributes',
                                    schemaPath: '#/properties/includeLinkedAttributes/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs14 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate111.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate111.errors = vErrors;
    return errors === 0;
}
function validate110(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ExpandPicklistConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementIDToExpand === undefined && (missing0 = 'elementIDToExpand')) ||
                (data.inputMap === undefined && (missing0 = 'inputMap')) ||
                (data.picklistColumns === undefined && (missing0 = 'picklistColumns'))) {
                validate110.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementIDToExpand !== undefined) {
                    let data0 = data.elementIDToExpand;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func162(data0) < b64min0 || func162(data0) > b64max0) {
                                validate110.errors = [
                                    {
                                        instancePath: instancePath + '/elementIDToExpand',
                                        schemaPath: '#/properties/elementIDToExpand/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func162(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func162(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func163(data0);
                                if (decoded0.length !== 10) {
                                    validate110.errors = [
                                        {
                                            instancePath: instancePath + '/elementIDToExpand',
                                            schemaPath: '#/properties/elementIDToExpand/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func164(decoded0);
                                    if (func165(encoded0) !== func165(data0)) {
                                        validate110.errors = [
                                            {
                                                instancePath: instancePath + '/elementIDToExpand',
                                                schemaPath: '#/properties/elementIDToExpand/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate110.errors = [
                                {
                                    instancePath: instancePath + '/elementIDToExpand',
                                    schemaPath: '#/properties/elementIDToExpand/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.inputMap !== undefined) {
                        let data1 = data.inputMap;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    const _errs6 = errors;
                                    if (typeof data1[key0] !== 'string') {
                                        validate110.errors = [
                                            {
                                                instancePath: instancePath + '/inputMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/inputMap/additionalProperties/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate110.errors = [
                                    {
                                        instancePath: instancePath + '/inputMap',
                                        schemaPath: '#/properties/inputMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.picklistColumns !== undefined) {
                            let data3 = data.picklistColumns;
                            const _errs8 = errors;
                            if (errors === _errs8) {
                                if (Array.isArray(data3)) {
                                    if (data3.length < 1) {
                                        validate110.errors = [
                                            {
                                                instancePath: instancePath + '/picklistColumns',
                                                schemaPath: '#/properties/picklistColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid3 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs10 = errors;
                                            if (!validate111(data3[i0], {
                                                instancePath: instancePath + '/picklistColumns/' + i0,
                                                parentData: data3,
                                                parentDataProperty: i0,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate111.errors : vErrors.concat(validate111.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid3 = _errs10 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate110.errors = [
                                        {
                                            instancePath: instancePath + '/picklistColumns',
                                            schemaPath: '#/properties/picklistColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs8 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate110.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate110.errors = vErrors;
    return errors === 0;
}
export const exportConfigSchemaValidation = validate113;
const schema168 = {
    $id: 'urn:wisepipe-common-pipe:ExportConfig',
    type: 'object',
    properties: {
        exportID: { type: 'string', uid: 9 },
        isExcel: { type: 'boolean' },
        exportFileType: { type: 'string', enum: ['.csv', '.xlsx', '.txt'] },
        delimiter: { type: 'string' }
    }
};
const func167 = ucs2length;
const func168 = base64urlToBuffer;
const func169 = base64urlEncode;
const func170 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate113(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ExportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.exportID !== undefined) {
                let data0 = data.exportID;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        const b64min0 = Math.ceil((4 * 9) / 3);
                        const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                        if (func167(data0) < b64min0 || func167(data0) > b64max0) {
                            validate113.errors = [
                                {
                                    instancePath: instancePath + '/exportID',
                                    schemaPath: '#/properties/exportID/uid',
                                    keyword: 'uid',
                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func167(data0) },
                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func167(data0)
                                }
                            ];
                            return false;
                        }
                        else {
                            const decoded0 = func168(data0);
                            if (decoded0.length !== 9) {
                                validate113.errors = [
                                    {
                                        instancePath: instancePath + '/exportID',
                                        schemaPath: '#/properties/exportID/uid',
                                        keyword: 'uid',
                                        params: { error: 'decoded' },
                                        message: 'must decode to 9 bytes'
                                    }
                                ];
                                return false;
                            }
                            else {
                                const encoded0 = func169(decoded0);
                                if (func170(encoded0) !== func170(data0)) {
                                    validate113.errors = [
                                        {
                                            instancePath: instancePath + '/exportID',
                                            schemaPath: '#/properties/exportID/uid',
                                            keyword: 'uid',
                                            params: { error: 'ambiguous' },
                                            message: 'encoding is ambiguous'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    else {
                        validate113.errors = [
                            {
                                instancePath: instancePath + '/exportID',
                                schemaPath: '#/properties/exportID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.isExcel !== undefined) {
                    const _errs3 = errors;
                    if (typeof data.isExcel !== 'boolean') {
                        validate113.errors = [
                            {
                                instancePath: instancePath + '/isExcel',
                                schemaPath: '#/properties/isExcel/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.exportFileType !== undefined) {
                        let data2 = data.exportFileType;
                        const _errs5 = errors;
                        if (typeof data2 !== 'string') {
                            validate113.errors = [
                                {
                                    instancePath: instancePath + '/exportFileType',
                                    schemaPath: '#/properties/exportFileType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === '.csv' || data2 === '.xlsx' || data2 === '.txt')) {
                            validate113.errors = [
                                {
                                    instancePath: instancePath + '/exportFileType',
                                    schemaPath: '#/properties/exportFileType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema168.properties.exportFileType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.delimiter !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.delimiter !== 'string') {
                                validate113.errors = [
                                    {
                                        instancePath: instancePath + '/delimiter',
                                        schemaPath: '#/properties/delimiter/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate113.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate113.errors = vErrors;
    return errors === 0;
}
export const extractConfigSchemaValidation = validate114;
const schema169 = {
    $id: 'urn:wisepipe-common-pipe:ExtractConfig',
    type: 'object',
    properties: {
        pattern: { type: 'string', minLength: 1 },
        column: { type: 'string', minLength: 1, maxLength: 150 },
        newColumn: { type: 'string', minLength: 1, maxLength: 150 }
    },
    required: ['pattern', 'column']
};
function validate114(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ExtractConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pattern === undefined && (missing0 = 'pattern')) ||
                (data.column === undefined && (missing0 = 'column'))) {
                validate114.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pattern !== undefined) {
                    let data0 = data.pattern;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate114.errors = [
                                    {
                                        instancePath: instancePath + '/pattern',
                                        schemaPath: '#/properties/pattern/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate114.errors = [
                                {
                                    instancePath: instancePath + '/pattern',
                                    schemaPath: '#/properties/pattern/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        let data1 = data.column;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate114.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate114.errors = [
                                            {
                                                instancePath: instancePath + '/column',
                                                schemaPath: '#/properties/column/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate114.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.newColumn !== undefined) {
                            let data2 = data.newColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 150) {
                                        validate114.errors = [
                                            {
                                                instancePath: instancePath + '/newColumn',
                                                schemaPath: '#/properties/newColumn/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate114.errors = [
                                                {
                                                    instancePath: instancePath + '/newColumn',
                                                    schemaPath: '#/properties/newColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate114.errors = [
                                        {
                                            instancePath: instancePath + '/newColumn',
                                            schemaPath: '#/properties/newColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate114.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate114.errors = vErrors;
    return errors === 0;
}
export const fileConfigSchemaValidation = validate115;
const schema170 = {
    $id: 'urn:wisepipe-common-pipe:FileConfig',
    type: 'object',
    properties: { fileID: { type: 'string', uid: 9 } },
    required: ['fileID']
};
const func176 = ucs2length;
const func177 = base64urlToBuffer;
const func178 = base64urlEncode;
const func179 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate115(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FileConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.fileID === undefined && (missing0 = 'fileID')) {
                validate115.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.fileID !== undefined) {
                    let data0 = data.fileID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func176(data0) < b64min0 || func176(data0) > b64max0) {
                                validate115.errors = [
                                    {
                                        instancePath: instancePath + '/fileID',
                                        schemaPath: '#/properties/fileID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func176(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func176(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func177(data0);
                                if (decoded0.length !== 9) {
                                    validate115.errors = [
                                        {
                                            instancePath: instancePath + '/fileID',
                                            schemaPath: '#/properties/fileID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func178(decoded0);
                                    if (func179(encoded0) !== func179(data0)) {
                                        validate115.errors = [
                                            {
                                                instancePath: instancePath + '/fileID',
                                                schemaPath: '#/properties/fileID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate115.errors = [
                                {
                                    instancePath: instancePath + '/fileID',
                                    schemaPath: '#/properties/fileID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate115.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate115.errors = vErrors;
    return errors === 0;
}
export const fillConfigSchemaValidation = validate116;
const schema171 = {
    $id: 'urn:wisepipe-common-pipe:FillConfig',
    type: 'object',
    properties: {
        selectedColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        stringFill: { type: 'string', minLength: 1 },
        numberFill: {
            type: ['number', 'string'],
            if: { type: 'string' },
            then: { oneOf: [{ enum: ['avg', 'median', 'mode'] }, { pattern: '^[-+]?[0-9]*\\.?[0-9]+([eE][-+]?[0-9]+)?$' }] }
        },
        dateFill: { type: 'string', format: 'date-time' },
        booleanFill: { type: 'boolean' }
    },
    required: ['selectedColumns'],
    minProperties: 3
};
const pattern9 = new RegExp('^[-+]?[0-9]*\\.?[0-9]+([eE][-+]?[0-9]+)?$', 'u');
function validate116(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FillConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (Object.keys(data).length < 3) {
                validate116.errors = [
                    {
                        instancePath,
                        schemaPath: '#/minProperties',
                        keyword: 'minProperties',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 properties'
                    }
                ];
                return false;
            }
            else {
                let missing0;
                if (data.selectedColumns === undefined && (missing0 = 'selectedColumns')) {
                    validate116.errors = [
                        {
                            instancePath,
                            schemaPath: '#/required',
                            keyword: 'required',
                            params: { missingProperty: missing0 },
                            message: "must have required property '" + missing0 + "'"
                        }
                    ];
                    return false;
                }
                else {
                    if (data.selectedColumns !== undefined) {
                        let data0 = data.selectedColumns;
                        const _errs1 = errors;
                        if (errors === _errs1) {
                            if (Array.isArray(data0)) {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate116.errors = [
                                                    {
                                                        instancePath: instancePath + '/selectedColumns/' + i0,
                                                        schemaPath: '#/properties/selectedColumns/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate116.errors = [
                                                {
                                                    instancePath: instancePath + '/selectedColumns/' + i0,
                                                    schemaPath: '#/properties/selectedColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate116.errors = [
                                                    {
                                                        instancePath: instancePath + '/selectedColumns',
                                                        schemaPath: '#/properties/selectedColumns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate116.errors = [
                                    {
                                        instancePath: instancePath + '/selectedColumns',
                                        schemaPath: '#/properties/selectedColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs1 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.stringFill !== undefined) {
                            let data2 = data.stringFill;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate116.errors = [
                                            {
                                                instancePath: instancePath + '/stringFill',
                                                schemaPath: '#/properties/stringFill/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate116.errors = [
                                        {
                                            instancePath: instancePath + '/stringFill',
                                            schemaPath: '#/properties/stringFill/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.numberFill !== undefined) {
                                let data3 = data.numberFill;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number') && typeof data3 !== 'string') {
                                    validate116.errors = [
                                        {
                                            instancePath: instancePath + '/numberFill',
                                            schemaPath: '#/properties/numberFill/type',
                                            keyword: 'type',
                                            params: { type: schema171.properties.numberFill.type },
                                            message: 'must be number,string'
                                        }
                                    ];
                                    return false;
                                }
                                const _errs9 = errors;
                                let valid3 = true;
                                const _errs10 = errors;
                                if (typeof data3 !== 'string') {
                                    const err0 = {};
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                                var _valid0 = _errs10 === errors;
                                errors = _errs9;
                                if (vErrors !== null) {
                                    if (_errs9) {
                                        vErrors.length = _errs9;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                if (_valid0) {
                                    const _errs12 = errors;
                                    const _errs13 = errors;
                                    let valid4 = false;
                                    let passing0 = null;
                                    const _errs14 = errors;
                                    if (!(data3 === 'avg' || data3 === 'median' || data3 === 'mode')) {
                                        const err1 = {
                                            instancePath: instancePath + '/numberFill',
                                            schemaPath: '#/properties/numberFill/then/oneOf/0/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema171.properties.numberFill.then.oneOf[0].enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err1];
                                        }
                                        else {
                                            vErrors.push(err1);
                                        }
                                        errors++;
                                    }
                                    var _valid1 = _errs14 === errors;
                                    if (_valid1) {
                                        valid4 = true;
                                        passing0 = 0;
                                    }
                                    const _errs15 = errors;
                                    if (typeof data3 === 'string') {
                                        if (!pattern9.test(data3)) {
                                            const err2 = {
                                                instancePath: instancePath + '/numberFill',
                                                schemaPath: '#/properties/numberFill/then/oneOf/1/pattern',
                                                keyword: 'pattern',
                                                params: { pattern: '^[-+]?[0-9]*\\.?[0-9]+([eE][-+]?[0-9]+)?$' },
                                                message: 'must match pattern "' + '^[-+]?[0-9]*\\.?[0-9]+([eE][-+]?[0-9]+)?$' + '"'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs15 === errors;
                                    if (_valid1 && valid4) {
                                        valid4 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid1) {
                                            valid4 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid4) {
                                        const err3 = {
                                            instancePath: instancePath + '/numberFill',
                                            schemaPath: '#/properties/numberFill/then/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                        validate116.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs13;
                                        if (vErrors !== null) {
                                            if (_errs13) {
                                                vErrors.length = _errs13;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var _valid0 = _errs12 === errors;
                                    valid3 = _valid0;
                                }
                                if (!valid3) {
                                    const err4 = {
                                        instancePath: instancePath + '/numberFill',
                                        schemaPath: '#/properties/numberFill/if',
                                        keyword: 'if',
                                        params: { failingKeyword: 'then' },
                                        message: 'must match "then" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err4];
                                    }
                                    else {
                                        vErrors.push(err4);
                                    }
                                    errors++;
                                    validate116.errors = vErrors;
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.dateFill !== undefined) {
                                    let data4 = data.dateFill;
                                    const _errs16 = errors;
                                    if (errors === _errs16) {
                                        if (errors === _errs16) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate116.errors = [
                                                        {
                                                            instancePath: instancePath + '/dateFill',
                                                            schemaPath: '#/properties/dateFill/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate116.errors = [
                                                    {
                                                        instancePath: instancePath + '/dateFill',
                                                        schemaPath: '#/properties/dateFill/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs16 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.booleanFill !== undefined) {
                                        const _errs18 = errors;
                                        if (typeof data.booleanFill !== 'boolean') {
                                            validate116.errors = [
                                                {
                                                    instancePath: instancePath + '/booleanFill',
                                                    schemaPath: '#/properties/booleanFill/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs18 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate116.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate116.errors = vErrors;
    return errors === 0;
}
export const filterColumnSchemaValidation = validate117;
const schema172 = {
    $id: 'urn:wisepipe-common-pipe:FilterColumn',
    type: 'object',
    properties: { name: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] } },
    required: ['name']
};
function validate117(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FilterColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate117.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/name',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (typeof data0 !== 'string') {
                        const err1 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err2 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                        validate117.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate117.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate117.errors = vErrors;
    return errors === 0;
}
export const filterConfigSchemaValidation = validate118;
const schema174 = {
    $id: 'urn:wisepipe-common-pipe:FilterConfig',
    type: 'object',
    properties: { filter: { $ref: 'urn:wisepipe-common-pipe:Filter' } },
    required: ['filter']
};
function validate118(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FilterConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.filter === undefined && (missing0 = 'filter')) {
                validate118.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filter !== undefined) {
                    let data0 = data.filter;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.filterType === undefined && (missing1 = 'filterType')) {
                                validate118.errors = [
                                    {
                                        instancePath: instancePath + '/filter',
                                        schemaPath: 'urn:wisepipe-common-pipe:Filter/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.filterType !== undefined) {
                                    let data1 = data0.filterType;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (!pattern4.test(data1)) {
                                                validate118.errors = [
                                                    {
                                                        instancePath: instancePath + '/filter/filterType',
                                                        schemaPath: 'urn:wisepipe-common-pipe:Filter/properties/filterType/pattern',
                                                        keyword: 'pattern',
                                                        params: { pattern: 'group|statement' },
                                                        message: 'must match pattern "' + 'group|statement' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate118.errors = [
                                                {
                                                    instancePath: instancePath + '/filter/filterType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:Filter/properties/filterType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate118.errors = [
                                {
                                    instancePath: instancePath + '/filter',
                                    schemaPath: 'urn:wisepipe-common-pipe:Filter/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate118.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate118.errors = vErrors;
    return errors === 0;
}
export const filterGroupSchemaValidation = validate49;
export const filterLiteralSchemaValidation = validate119;
const schema176 = {
    $id: 'urn:wisepipe-common-pipe:FilterLiteral',
    type: 'object',
    properties: {
        litType: { type: 'string', enum: ['string', 'number', 'date', 'boolean'] },
        value: {
            anyOf: [
                { $ref: 'urn:wisepipe-base-pipe:StringToolVariable' },
                { $ref: 'urn:wisepipe-base-pipe:DateToolVariable' },
                { $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' },
                { $ref: 'urn:wisepipe-base-pipe:BoolToolVariable' },
                { type: 'string' }
            ]
        }
    },
    required: ['litType', 'value']
};
function validate119(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FilterLiteral" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.litType === undefined && (missing0 = 'litType')) ||
                (data.value === undefined && (missing0 = 'value'))) {
                validate119.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.litType !== undefined) {
                    let data0 = data.litType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate119.errors = [
                            {
                                instancePath: instancePath + '/litType',
                                schemaPath: '#/properties/litType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'string' || data0 === 'number' || data0 === 'date' || data0 === 'boolean')) {
                        validate119.errors = [
                            {
                                instancePath: instancePath + '/litType',
                                schemaPath: '#/properties/litType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema176.properties.litType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.value !== undefined) {
                        let data1 = data.value;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        let valid1 = false;
                        const _errs5 = errors;
                        const _errs6 = errors;
                        if (errors === _errs6) {
                            if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                const err0 = {
                                    instancePath: instancePath + '/value',
                                    schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err0];
                                }
                                else {
                                    vErrors.push(err0);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs5 === errors;
                        valid1 = valid1 || _valid0;
                        if (!valid1) {
                            const _errs8 = errors;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                    const err1 = {
                                        instancePath: instancePath + '/value',
                                        schemaPath: 'urn:wisepipe-base-pipe:DateToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                }
                            }
                            var _valid0 = _errs8 === errors;
                            valid1 = valid1 || _valid0;
                            if (!valid1) {
                                const _errs11 = errors;
                                const _errs12 = errors;
                                if (errors === _errs12) {
                                    if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                        const err2 = {
                                            instancePath: instancePath + '/value',
                                            schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid0 = _errs11 === errors;
                                valid1 = valid1 || _valid0;
                                if (!valid1) {
                                    const _errs14 = errors;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                            const err3 = {
                                                instancePath: instancePath + '/value',
                                                schemaPath: 'urn:wisepipe-base-pipe:BoolToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err3];
                                            }
                                            else {
                                                vErrors.push(err3);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs14 === errors;
                                    valid1 = valid1 || _valid0;
                                    if (!valid1) {
                                        const _errs17 = errors;
                                        if (typeof data1 !== 'string') {
                                            const err4 = {
                                                instancePath: instancePath + '/value',
                                                schemaPath: '#/properties/value/anyOf/4/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                        var _valid0 = _errs17 === errors;
                                        valid1 = valid1 || _valid0;
                                    }
                                }
                            }
                        }
                        if (!valid1) {
                            const err5 = {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/properties/value/anyOf',
                                keyword: 'anyOf',
                                params: {},
                                message: 'must match a schema in anyOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err5];
                            }
                            else {
                                vErrors.push(err5);
                            }
                            errors++;
                            validate119.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs4;
                            if (vErrors !== null) {
                                if (_errs4) {
                                    vErrors.length = _errs4;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate119.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate119.errors = vErrors;
    return errors === 0;
}
export const filterOperandSchemaValidation = validate120;
const schema181 = {
    $id: 'urn:wisepipe-common-pipe:FilterOperand',
    type: 'object',
    properties: { operandType: { type: 'string', enum: ['column', 'literal'] } },
    required: ['operandType']
};
function validate120(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FilterOperand" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.operandType === undefined && (missing0 = 'operandType')) {
                validate120.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.operandType !== undefined) {
                    let data0 = data.operandType;
                    if (typeof data0 !== 'string') {
                        validate120.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'column' || data0 === 'literal')) {
                        validate120.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema181.properties.operandType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate120.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate120.errors = vErrors;
    return errors === 0;
}
export const filterSchemaValidation = validate121;
function validate121(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:Filter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.filterType === undefined && (missing0 = 'filterType')) {
                validate121.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.filterType !== undefined) {
                    let data0 = data.filterType;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern4.test(data0)) {
                                validate121.errors = [
                                    {
                                        instancePath: instancePath + '/filterType',
                                        schemaPath: '#/properties/filterType/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: 'group|statement' },
                                        message: 'must match pattern "' + 'group|statement' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate121.errors = [
                                {
                                    instancePath: instancePath + '/filterType',
                                    schemaPath: '#/properties/filterType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate121.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate121.errors = vErrors;
    return errors === 0;
}
export const filterStatementSchemaValidation = validate122;
const schema183 = {
    $id: 'urn:wisepipe-common-pipe:FilterStatement',
    type: 'object',
    properties: {
        lhs: { $ref: 'urn:wisepipe-common-pipe:FilterOperand' },
        op: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                {
                    type: 'string',
                    enum: [
                        'less_than',
                        'less_than_equals',
                        'equals',
                        'not_equals',
                        'greater_than_equals',
                        'greater_than',
                        'is_null',
                        'is_not_null',
                        'starts_with',
                        'ends_with',
                        'contains',
                        'not_contains'
                    ]
                }
            ]
        },
        rhs: { $ref: 'urn:wisepipe-common-pipe:FilterOperand' }
    },
    required: ['lhs', 'op'],
    if: {
        properties: {
            op: {
                type: 'string',
                enum: [
                    'less_than',
                    'less_than_equals',
                    'equals',
                    'not_equals',
                    'greater_than_equals',
                    'greater_than',
                    'starts_with',
                    'ends_with',
                    'contains',
                    'not_contains'
                ]
            }
        }
    },
    then: { required: ['rhs'] }
};
function validate122(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FilterStatement" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.op !== undefined) {
            let data0 = data.op;
            if (typeof data0 !== 'string') {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            if (!(data0 === 'less_than' ||
                data0 === 'less_than_equals' ||
                data0 === 'equals' ||
                data0 === 'not_equals' ||
                data0 === 'greater_than_equals' ||
                data0 === 'greater_than' ||
                data0 === 'starts_with' ||
                data0 === 'ends_with' ||
                data0 === 'contains' ||
                data0 === 'not_contains')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.rhs === undefined && (missing0 = 'rhs')) {
                validate122.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate122.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.lhs === undefined && (missing1 = 'lhs')) || (data.op === undefined && (missing1 = 'op'))) {
                validate122.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lhs !== undefined) {
                    let data1 = data.lhs;
                    const _errs6 = errors;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            let missing2;
                            if (data1.operandType === undefined && (missing2 = 'operandType')) {
                                validate122.errors = [
                                    {
                                        instancePath: instancePath + '/lhs',
                                        schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing2 },
                                        message: "must have required property '" + missing2 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1.operandType !== undefined) {
                                    let data2 = data1.operandType;
                                    if (typeof data2 !== 'string') {
                                        validate122.errors = [
                                            {
                                                instancePath: instancePath + '/lhs/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/properties/operandType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data2 === 'column' || data2 === 'literal')) {
                                        validate122.errors = [
                                            {
                                                instancePath: instancePath + '/lhs/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/properties/operandType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema181.properties.operandType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate122.errors = [
                                {
                                    instancePath: instancePath + '/lhs',
                                    schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.op !== undefined) {
                        let data3 = data.op;
                        const _errs11 = errors;
                        const _errs12 = errors;
                        let valid5 = false;
                        let passing0 = null;
                        const _errs13 = errors;
                        const _errs14 = errors;
                        if (errors === _errs14) {
                            if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                if (data3.toolEnumType !== undefined) {
                                    let data4 = data3.toolEnumType;
                                    if (typeof data4 !== 'string') {
                                        const err3 = {
                                            instancePath: instancePath + '/op/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                    }
                                    if (!(data4 === 'SortDirection' ||
                                        data4 === 'AggregateColumnOperation' ||
                                        data4 === 'DateFrequency' ||
                                        data4 === 'DateAddType' ||
                                        data4 === 'DateAddUnit' ||
                                        data4 === 'DateUnitType' ||
                                        data4 === 'DatePartType' ||
                                        data4 === 'JoinOperator' ||
                                        data4 === 'JoinPattern' ||
                                        data4 === 'FilterStatementOp' ||
                                        data4 === 'ColumnType' ||
                                        data4 === 'PeriodAddType')) {
                                        const err4 = {
                                            instancePath: instancePath + '/op/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err5 = {
                                    instancePath: instancePath + '/op',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs13 === errors;
                        if (_valid1) {
                            valid5 = true;
                            passing0 = 0;
                        }
                        const _errs18 = errors;
                        if (typeof data3 !== 'string') {
                            const err6 = {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                        }
                        if (!(data3 === 'less_than' ||
                            data3 === 'less_than_equals' ||
                            data3 === 'equals' ||
                            data3 === 'not_equals' ||
                            data3 === 'greater_than_equals' ||
                            data3 === 'greater_than' ||
                            data3 === 'is_null' ||
                            data3 === 'is_not_null' ||
                            data3 === 'starts_with' ||
                            data3 === 'ends_with' ||
                            data3 === 'contains' ||
                            data3 === 'not_contains')) {
                            const err7 = {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema183.properties.op.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        var _valid1 = _errs18 === errors;
                        if (_valid1 && valid5) {
                            valid5 = false;
                            passing0 = [passing0, 1];
                        }
                        else {
                            if (_valid1) {
                                valid5 = true;
                                passing0 = 1;
                            }
                        }
                        if (!valid5) {
                            const err8 = {
                                instancePath: instancePath + '/op',
                                schemaPath: '#/properties/op/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing0 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            validate122.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs12;
                            if (vErrors !== null) {
                                if (_errs12) {
                                    vErrors.length = _errs12;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid2 = _errs11 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.rhs !== undefined) {
                            let data5 = data.rhs;
                            const _errs20 = errors;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                    let missing3;
                                    if (data5.operandType === undefined && (missing3 = 'operandType')) {
                                        validate122.errors = [
                                            {
                                                instancePath: instancePath + '/rhs',
                                                schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data5.operandType !== undefined) {
                                            let data6 = data5.operandType;
                                            if (typeof data6 !== 'string') {
                                                validate122.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs/operandType',
                                                        schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/properties/operandType/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data6 === 'column' || data6 === 'literal')) {
                                                validate122.errors = [
                                                    {
                                                        instancePath: instancePath + '/rhs/operandType',
                                                        schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/properties/operandType/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema181.properties.operandType.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate122.errors = [
                                        {
                                            instancePath: instancePath + '/rhs',
                                            schemaPath: 'urn:wisepipe-common-pipe:FilterOperand/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs20 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            validate122.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate122.errors = vErrors;
    return errors === 0;
}
export const forecastConfigSchemaValidation = validate123;
const schema187 = {
    $id: 'urn:wisepipe-common-pipe:ForecastConfig',
    type: 'object',
    properties: { options: { type: 'integer', minimum: 1, maximum: 14 } },
    required: ['options']
};
function validate123(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.options === undefined && (missing0 = 'options')) {
                validate123.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.options !== undefined) {
                    let data0 = data.options;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate123.errors = [
                            {
                                instancePath: instancePath + '/options',
                                schemaPath: '#/properties/options/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 14 || isNaN(data0)) {
                                validate123.errors = [
                                    {
                                        instancePath: instancePath + '/options',
                                        schemaPath: '#/properties/options/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 14 },
                                        message: 'must be <= 14'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate123.errors = [
                                        {
                                            instancePath: instancePath + '/options',
                                            schemaPath: '#/properties/options/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate123.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate123.errors = vErrors;
    return errors === 0;
}
export const formulaConfigSchemaValidation = validate124;
const schema188 = {
    $id: 'urn:wisepipe-common-pipe:FormulaConfig',
    type: 'object',
    properties: {
        column: { anyOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1 }] },
        formula: { anyOf: [{ $ref: 'urn:wisepipe-base-pipe:CompoundToolVariable' }, { type: 'string', minLength: 1 }] }
    },
    required: ['column', 'formula']
};
function validate124(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FormulaConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.column === undefined && (missing0 = 'column')) ||
                (data.formula === undefined && (missing0 = 'formula'))) {
                validate124.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data0 = data.column;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/column',
                                schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    valid1 = valid1 || _valid0;
                    if (!valid1) {
                        const _errs6 = errors;
                        if (errors === _errs6) {
                            if (typeof data0 === 'string') {
                                if (func2(data0) < 1) {
                                    const err1 = {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/anyOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err2 = {
                                    instancePath: instancePath + '/column',
                                    schemaPath: '#/properties/column/anyOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs6 === errors;
                        valid1 = valid1 || _valid0;
                    }
                    if (!valid1) {
                        const err3 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/anyOf',
                            keyword: 'anyOf',
                            params: {},
                            message: 'must match a schema in anyOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                        validate124.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.formula !== undefined) {
                        let data1 = data.formula;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if (data1.value === undefined && (missing1 = 'value')) {
                                    const err4 = {
                                        instancePath: instancePath + '/formula',
                                        schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err4];
                                    }
                                    else {
                                        vErrors.push(err4);
                                    }
                                    errors++;
                                }
                                else {
                                    if (data1.value !== undefined) {
                                        if (typeof data1.value !== 'string') {
                                            const err5 = {
                                                instancePath: instancePath + '/formula/value',
                                                schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/properties/value/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                            }
                            else {
                                const err6 = {
                                    instancePath: instancePath + '/formula',
                                    schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        valid3 = valid3 || _valid1;
                        if (!valid3) {
                            const _errs15 = errors;
                            if (errors === _errs15) {
                                if (typeof data1 === 'string') {
                                    if (func2(data1) < 1) {
                                        const err7 = {
                                            instancePath: instancePath + '/formula',
                                            schemaPath: '#/properties/formula/anyOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err8 = {
                                        instancePath: instancePath + '/formula',
                                        schemaPath: '#/properties/formula/anyOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err8];
                                    }
                                    else {
                                        vErrors.push(err8);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs15 === errors;
                            valid3 = valid3 || _valid1;
                        }
                        if (!valid3) {
                            const err9 = {
                                instancePath: instancePath + '/formula',
                                schemaPath: '#/properties/formula/anyOf',
                                keyword: 'anyOf',
                                params: {},
                                message: 'must match a schema in anyOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                            validate124.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate124.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate124.errors = vErrors;
    return errors === 0;
}
export const formulaValidationInfoSchemaValidation = validate125;
const schema191 = {
    $id: 'urn:wisepipe-common-pipe:FormulaValidationInfo',
    type: 'object',
    properties: {
        validationState: {
            type: 'number',
            enum: [
                'VALID',
                'INVALID',
                'BAD_METADATA',
                'EMPTY',
                'PORT_MISMATCH',
                'PORT_MISSING_EDGES',
                'TWO_INCOMING_EDGES',
                'CYCLE',
                'SPARK_UNAVAILABLE',
                'DEPRECATED',
                'MISSING_INCOMING_EDGE',
                'NO_COLUMN_TYPE_FOUND',
                'MULTI_PORT_NOT_USED_INCOMING_EDGE',
                'MULTI_PORT_UNMAPPED_INPUT',
                'MULTI_PORT_UNMAPPED_OUTPUT',
                'MULTI_PORT_MAPPED_INPUT_MISSING',
                'MULTI_PORT_MAPPED_COLUMN_INVALID',
                'REUSABLE_LOGIC_EXTRA_PARAMETER_VALUE',
                'REUSABLE_LOGIC_PARAMETER_VALUE_TYPE_MISMATCH',
                'REUSABLE_LOGIC_UNMAPPED_INPUT',
                'REUSABLE_LOGIC_UNMAPPED_OUTPUT',
                'REUSABLE_LOGIC_MAPPED_INPUT_MISSING',
                'REUSABLE_LOGIC_MAPPED_COLUMN_INVALID',
                'REUSABLE_LOGIC_FORBIDDEN_TOOL',
                'REUSABLE_LOGIC_CYCLE',
                'REUSABLE_LOGIC_INNER_INVALID',
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25
            ]
        },
        errorType: {
            type: 'string',
            enum: [
                'syntax_error',
                'missing_arguments',
                'too_many_arguments',
                'invalid_argument',
                'invalid_data_format',
                'invalid_source',
                'unsupported_data_type',
                'function_not_exist',
                'implicit',
                'case_tool_not_condition',
                'other'
            ]
        },
        functionName: { type: 'string' },
        parameterName: { type: 'string' }
    },
    required: ['validationState']
};
function validate125(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FormulaValidationInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.validationState === undefined && (missing0 = 'validationState')) {
                validate125.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.validationState !== undefined) {
                    let data0 = data.validationState;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number')) {
                        validate125.errors = [
                            {
                                instancePath: instancePath + '/validationState',
                                schemaPath: '#/properties/validationState/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'VALID' ||
                        data0 === 'INVALID' ||
                        data0 === 'BAD_METADATA' ||
                        data0 === 'EMPTY' ||
                        data0 === 'PORT_MISMATCH' ||
                        data0 === 'PORT_MISSING_EDGES' ||
                        data0 === 'TWO_INCOMING_EDGES' ||
                        data0 === 'CYCLE' ||
                        data0 === 'SPARK_UNAVAILABLE' ||
                        data0 === 'DEPRECATED' ||
                        data0 === 'MISSING_INCOMING_EDGE' ||
                        data0 === 'NO_COLUMN_TYPE_FOUND' ||
                        data0 === 'MULTI_PORT_NOT_USED_INCOMING_EDGE' ||
                        data0 === 'MULTI_PORT_UNMAPPED_INPUT' ||
                        data0 === 'MULTI_PORT_UNMAPPED_OUTPUT' ||
                        data0 === 'MULTI_PORT_MAPPED_INPUT_MISSING' ||
                        data0 === 'MULTI_PORT_MAPPED_COLUMN_INVALID' ||
                        data0 === 'REUSABLE_LOGIC_EXTRA_PARAMETER_VALUE' ||
                        data0 === 'REUSABLE_LOGIC_PARAMETER_VALUE_TYPE_MISMATCH' ||
                        data0 === 'REUSABLE_LOGIC_UNMAPPED_INPUT' ||
                        data0 === 'REUSABLE_LOGIC_UNMAPPED_OUTPUT' ||
                        data0 === 'REUSABLE_LOGIC_MAPPED_INPUT_MISSING' ||
                        data0 === 'REUSABLE_LOGIC_MAPPED_COLUMN_INVALID' ||
                        data0 === 'REUSABLE_LOGIC_FORBIDDEN_TOOL' ||
                        data0 === 'REUSABLE_LOGIC_CYCLE' ||
                        data0 === 'REUSABLE_LOGIC_INNER_INVALID' ||
                        data0 === 0 ||
                        data0 === 1 ||
                        data0 === 2 ||
                        data0 === 3 ||
                        data0 === 4 ||
                        data0 === 5 ||
                        data0 === 6 ||
                        data0 === 7 ||
                        data0 === 8 ||
                        data0 === 9 ||
                        data0 === 10 ||
                        data0 === 11 ||
                        data0 === 12 ||
                        data0 === 13 ||
                        data0 === 14 ||
                        data0 === 15 ||
                        data0 === 16 ||
                        data0 === 17 ||
                        data0 === 18 ||
                        data0 === 19 ||
                        data0 === 20 ||
                        data0 === 21 ||
                        data0 === 22 ||
                        data0 === 23 ||
                        data0 === 24 ||
                        data0 === 25)) {
                        validate125.errors = [
                            {
                                instancePath: instancePath + '/validationState',
                                schemaPath: '#/properties/validationState/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema191.properties.validationState.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.errorType !== undefined) {
                        let data1 = data.errorType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate125.errors = [
                                {
                                    instancePath: instancePath + '/errorType',
                                    schemaPath: '#/properties/errorType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'syntax_error' ||
                            data1 === 'missing_arguments' ||
                            data1 === 'too_many_arguments' ||
                            data1 === 'invalid_argument' ||
                            data1 === 'invalid_data_format' ||
                            data1 === 'invalid_source' ||
                            data1 === 'unsupported_data_type' ||
                            data1 === 'function_not_exist' ||
                            data1 === 'implicit' ||
                            data1 === 'case_tool_not_condition' ||
                            data1 === 'other')) {
                            validate125.errors = [
                                {
                                    instancePath: instancePath + '/errorType',
                                    schemaPath: '#/properties/errorType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema191.properties.errorType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.functionName !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.functionName !== 'string') {
                                validate125.errors = [
                                    {
                                        instancePath: instancePath + '/functionName',
                                        schemaPath: '#/properties/functionName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.parameterName !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.parameterName !== 'string') {
                                    validate125.errors = [
                                        {
                                            instancePath: instancePath + '/parameterName',
                                            schemaPath: '#/properties/parameterName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate125.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate125.errors = vErrors;
    return errors === 0;
}
export const fuzzyMatcherConfigSchemaValidation = validate126;
const schema192 = {
    $id: 'urn:wisepipe-common-pipe:FuzzyMatcherConfig',
    type: 'object',
    properties: {
        fuzzyMatcherType: { type: 'string', enum: ['edit-distance'] },
        matchColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns' },
            minItems: 1,
            maxItems: 20,
            uniqueItemProperties: ['dataColumn', 'sourceColumn']
        },
        fuzzyMatcherSource: { type: 'string', enum: ['top', 'bottom'] },
        similarityColumnName: { type: 'string' }
    },
    required: ['fuzzyMatcherType', 'matchColumns', 'fuzzyMatcherSource', 'similarityColumnName']
};
const schema193 = {
    $id: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns',
    type: 'object',
    properties: {
        dataColumn: { type: 'string' },
        sourceColumn: { type: 'string' },
        fuzzyLevel: { type: 'number', minimum: 0, maximum: 1 }
    },
    required: ['dataColumn', 'sourceColumn', 'fuzzyLevel']
};
const func184 = ajvEqual;
function validate126(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FuzzyMatcherConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.fuzzyMatcherType === undefined && (missing0 = 'fuzzyMatcherType')) ||
                (data.matchColumns === undefined && (missing0 = 'matchColumns')) ||
                (data.fuzzyMatcherSource === undefined && (missing0 = 'fuzzyMatcherSource')) ||
                (data.similarityColumnName === undefined && (missing0 = 'similarityColumnName'))) {
                validate126.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.fuzzyMatcherType !== undefined) {
                    let data0 = data.fuzzyMatcherType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate126.errors = [
                            {
                                instancePath: instancePath + '/fuzzyMatcherType',
                                schemaPath: '#/properties/fuzzyMatcherType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'edit-distance')) {
                        validate126.errors = [
                            {
                                instancePath: instancePath + '/fuzzyMatcherType',
                                schemaPath: '#/properties/fuzzyMatcherType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema192.properties.fuzzyMatcherType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.matchColumns !== undefined) {
                        let data1 = data.matchColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length > 20) {
                                    validate126.errors = [
                                        {
                                            instancePath: instancePath + '/matchColumns',
                                            schemaPath: '#/properties/matchColumns/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 20 },
                                            message: 'must NOT have more than 20 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.length < 1) {
                                        validate126.errors = [
                                            {
                                                instancePath: instancePath + '/matchColumns',
                                                schemaPath: '#/properties/matchColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid1 = true;
                                        const len0 = data1.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data2 = data1[i0];
                                            const _errs5 = errors;
                                            const _errs6 = errors;
                                            if (errors === _errs6) {
                                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                                    let missing1;
                                                    if ((data2.dataColumn === undefined && (missing1 = 'dataColumn')) ||
                                                        (data2.sourceColumn === undefined && (missing1 = 'sourceColumn')) ||
                                                        (data2.fuzzyLevel === undefined && (missing1 = 'fuzzyLevel'))) {
                                                        validate126.errors = [
                                                            {
                                                                instancePath: instancePath + '/matchColumns/' + i0,
                                                                schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing1 },
                                                                message: "must have required property '" + missing1 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data2.dataColumn !== undefined) {
                                                            const _errs8 = errors;
                                                            if (typeof data2.dataColumn !== 'string') {
                                                                validate126.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/matchColumns/' + i0 + '/dataColumn',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/properties/dataColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs8 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data2.sourceColumn !== undefined) {
                                                                const _errs10 = errors;
                                                                if (typeof data2.sourceColumn !== 'string') {
                                                                    validate126.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/matchColumns/' + i0 + '/sourceColumn',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/properties/sourceColumn/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid3 = _errs10 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data2.fuzzyLevel !== undefined) {
                                                                    let data5 = data2.fuzzyLevel;
                                                                    const _errs12 = errors;
                                                                    if (errors === _errs12) {
                                                                        if (typeof data5 == 'number') {
                                                                            if (data5 > 1 || isNaN(data5)) {
                                                                                validate126.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/matchColumns/' + i0 + '/fuzzyLevel',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/properties/fuzzyLevel/maximum',
                                                                                        keyword: 'maximum',
                                                                                        params: { comparison: '<=', limit: 1 },
                                                                                        message: 'must be <= 1'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (data5 < 0 || isNaN(data5)) {
                                                                                    validate126.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/matchColumns/' + i0 + '/fuzzyLevel',
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/properties/fuzzyLevel/minimum',
                                                                                            keyword: 'minimum',
                                                                                            params: { comparison: '>=', limit: 0 },
                                                                                            message: 'must be >= 0'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate126.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/matchColumns/' + i0 + '/fuzzyLevel',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/properties/fuzzyLevel/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid3 = _errs12 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate126.errors = [
                                                        {
                                                            instancePath: instancePath + '/matchColumns/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs5 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            const keys0 = schema192.properties.matchColumns.uniqueItemProperties;
                                            let k0;
                                            let i1 = data1.length;
                                            let j0;
                                            if (i1 > 1) {
                                                outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                    let key0 = keys0[k0];
                                                    for (i1 = data1.length; i1--;) {
                                                        let x0 = data1[i1];
                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                            continue;
                                                        }
                                                        for (j0 = i1; j0--;) {
                                                            let y0 = data1[j0];
                                                            if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func184(x0[key0], y0[key0])) {
                                                                validate126.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/matchColumns',
                                                                        schemaPath: '#/properties/matchColumns/uniqueItemProperties',
                                                                        keyword: 'uniqueItemProperties',
                                                                        params: {},
                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/matchColumns',
                                        schemaPath: '#/properties/matchColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.fuzzyMatcherSource !== undefined) {
                            let data6 = data.fuzzyMatcherSource;
                            const _errs14 = errors;
                            if (typeof data6 !== 'string') {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/fuzzyMatcherSource',
                                        schemaPath: '#/properties/fuzzyMatcherSource/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data6 === 'top' || data6 === 'bottom')) {
                                validate126.errors = [
                                    {
                                        instancePath: instancePath + '/fuzzyMatcherSource',
                                        schemaPath: '#/properties/fuzzyMatcherSource/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema192.properties.fuzzyMatcherSource.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs14 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.similarityColumnName !== undefined) {
                                const _errs16 = errors;
                                if (typeof data.similarityColumnName !== 'string') {
                                    validate126.errors = [
                                        {
                                            instancePath: instancePath + '/similarityColumnName',
                                            schemaPath: '#/properties/similarityColumnName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs16 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate126.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate126.errors = vErrors;
    return errors === 0;
}
export const fuzzyMatcherMatchColumnsSchemaValidation = validate127;
function validate127(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:FuzzyMatcherMatchColumns" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dataColumn === undefined && (missing0 = 'dataColumn')) ||
                (data.sourceColumn === undefined && (missing0 = 'sourceColumn')) ||
                (data.fuzzyLevel === undefined && (missing0 = 'fuzzyLevel'))) {
                validate127.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.dataColumn !== 'string') {
                        validate127.errors = [
                            {
                                instancePath: instancePath + '/dataColumn',
                                schemaPath: '#/properties/dataColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.sourceColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.sourceColumn !== 'string') {
                            validate127.errors = [
                                {
                                    instancePath: instancePath + '/sourceColumn',
                                    schemaPath: '#/properties/sourceColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.fuzzyLevel !== undefined) {
                            let data2 = data.fuzzyLevel;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 > 1 || isNaN(data2)) {
                                        validate127.errors = [
                                            {
                                                instancePath: instancePath + '/fuzzyLevel',
                                                schemaPath: '#/properties/fuzzyLevel/maximum',
                                                keyword: 'maximum',
                                                params: { comparison: '<=', limit: 1 },
                                                message: 'must be <= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2 < 0 || isNaN(data2)) {
                                            validate127.errors = [
                                                {
                                                    instancePath: instancePath + '/fuzzyLevel',
                                                    schemaPath: '#/properties/fuzzyLevel/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate127.errors = [
                                        {
                                            instancePath: instancePath + '/fuzzyLevel',
                                            schemaPath: '#/properties/fuzzyLevel/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate127.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate127.errors = vErrors;
    return errors === 0;
}
export const gbtRegressorConfigSchemaValidation = validate128;
const schema195 = { $id: 'urn:wisepipe-common-pipe:GbtRegressorConfig', type: 'object', properties: {}, required: [] };
function validate128(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GbtRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate128.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate128.errors = vErrors;
    return errors === 0;
}
export const gbtTrainConfigSchemaValidation = validate129;
const schema196 = { $id: 'urn:wisepipe-common-pipe:GbtTrainConfig', type: 'object', properties: {}, required: [] };
function validate129(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GbtTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate129.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate129.errors = vErrors;
    return errors === 0;
}
export const globalNodeElementSchemaValidation = validate130;
const schema197 = {
    $id: 'urn:wisepipe-common-pipe:GlobalNodeElement',
    type: 'object',
    properties: { nameOverride: { type: 'string' }, pipeID: { type: 'string', uid: 10 } },
    if: { required: ['config'] },
    then: {
        properties: {
            config: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
            toolType: { type: 'string', const: { $data: '1/config/toolType' } }
        }
    },
    else: {
        properties: {
            toolType: {
                type: 'string',
                enum: [
                    'file',
                    'cloud',
                    'demand_forecast',
                    'sample_customers',
                    'pipe',
                    'multi_port_pipe',
                    'adapt',
                    'aggregate',
                    'aggregate_v2',
                    'amortization',
                    'binning',
                    'category_encoder',
                    'case',
                    'change_case',
                    'change_type',
                    'clean_character',
                    'combination_matcher',
                    'conditional',
                    'confusion_matrix',
                    'date_add',
                    'date_diff',
                    'date_part',
                    'date_aggregate',
                    'date_format',
                    'distinct',
                    'drop',
                    'export',
                    'extract',
                    'fill',
                    'filter',
                    'formula',
                    'multi_formula',
                    'fuzzy_matcher',
                    'join',
                    'join_v2',
                    'lag',
                    'limit',
                    'merge_columns',
                    'min_max_scaler',
                    'monte_carlo',
                    'most_common',
                    'one_hot_encoder',
                    'oversample',
                    'predict_gender',
                    'quantile',
                    'random_number_generator',
                    'rank',
                    'record_id',
                    'remove_outliers',
                    'remove_empty',
                    'rename',
                    'reorder',
                    'repeat',
                    'replace',
                    'multi_replace',
                    'reshape',
                    'reshape_v2',
                    'running_average',
                    'running_total',
                    'sample',
                    'segmentation',
                    'select',
                    'select_word',
                    'smart_matcher',
                    'snapshot',
                    'sort',
                    'split',
                    'standard_scaler',
                    'text_grade_level',
                    'text_between',
                    'text_length',
                    'text_part',
                    'text_sentiment',
                    'trim',
                    'trim_tags',
                    'undersample',
                    'union',
                    'multi_union',
                    'weighted_average',
                    'classifier',
                    'cat_boost_classifier',
                    'decision_tree_train',
                    'gbt_train',
                    'k_neighbors_classifier',
                    'lgbm_classifier',
                    'logistic_regression_train',
                    'naive_bayes_train',
                    'random_forest_train',
                    'svm_train',
                    'xgb_classifier',
                    'regressor',
                    'decision_tree_regressor',
                    'gbt_regressor',
                    'k_neighbors_regressor',
                    'lgbm_regressor',
                    'linear_regression_train',
                    'mlp_regressor',
                    'random_forest_regressor',
                    'xgb_regressor',
                    'cat_boost_regressor',
                    'forecast',
                    'arima_forecast',
                    'auto_regressive_forecast',
                    'exp_smoothing_forecast',
                    'linear_regression_forecast',
                    'moving_average_forecast',
                    'prophet_forecast',
                    'seasonal_arima_forecast',
                    'simple_exp_smoothing_forecast',
                    'vector_auto_regressive_forecast',
                    'weighted_moving_average_forecast',
                    'cnn_text_classifier',
                    'bow_text_classifier',
                    'ensemble_text_classifier',
                    'text_classifier',
                    'word_frequency',
                    'outlier',
                    'abod_outlier',
                    'cblof_outlier',
                    'cof_outlier',
                    'hbos_outlier',
                    'iqr_outlier',
                    'isolation_forest_outlier',
                    'k_neighbors_outlier',
                    'multi_objective_gaal_outlier',
                    'one_class_svm_outlier',
                    'pca_outlier',
                    'single_objective_gaal_outlier',
                    'subspace_outlier',
                    'z_score_outlier',
                    'assignment_optimization',
                    'predictor',
                    'us_income',
                    'us_population',
                    'weather',
                    'hierarchy',
                    'hierarchy_v2',
                    'hierarchy_validator',
                    'hierarchy_validator_v2',
                    'lookup',
                    'split_columns',
                    'period_mapper',
                    'rule_mapper',
                    'rule_mapper_v2',
                    'incentives_export',
                    'incentives_import',
                    'incentives_table',
                    'incentives_period',
                    'user_defined_calc',
                    'sort_calc',
                    'time_shift_calc',
                    'category_calc',
                    'true_up',
                    'period_add',
                    'period_diff',
                    'expand_picklist',
                    'period_accumulation',
                    'reusable_logic_input',
                    'reusable_logic_output',
                    'reusable_logic'
                ]
            }
        }
    },
    required: ['pipeID', 'toolType']
};
const schema198 = {
    $id: 'urn:wisepipe-common-pipe:ToolConfig',
    type: 'object',
    properties: {
        toolType: {
            type: 'string',
            enum: [
                'file',
                'cloud',
                'demand_forecast',
                'sample_customers',
                'pipe',
                'multi_port_pipe',
                'adapt',
                'aggregate',
                'aggregate_v2',
                'amortization',
                'binning',
                'category_encoder',
                'case',
                'change_case',
                'change_type',
                'clean_character',
                'combination_matcher',
                'conditional',
                'confusion_matrix',
                'date_add',
                'date_diff',
                'date_part',
                'date_aggregate',
                'date_format',
                'distinct',
                'drop',
                'export',
                'extract',
                'fill',
                'filter',
                'formula',
                'multi_formula',
                'fuzzy_matcher',
                'join',
                'join_v2',
                'lag',
                'limit',
                'merge_columns',
                'min_max_scaler',
                'monte_carlo',
                'most_common',
                'one_hot_encoder',
                'oversample',
                'predict_gender',
                'quantile',
                'random_number_generator',
                'rank',
                'record_id',
                'remove_outliers',
                'remove_empty',
                'rename',
                'reorder',
                'repeat',
                'replace',
                'multi_replace',
                'reshape',
                'reshape_v2',
                'running_average',
                'running_total',
                'sample',
                'segmentation',
                'select',
                'select_word',
                'smart_matcher',
                'snapshot',
                'sort',
                'split',
                'standard_scaler',
                'text_grade_level',
                'text_between',
                'text_length',
                'text_part',
                'text_sentiment',
                'trim',
                'trim_tags',
                'undersample',
                'union',
                'multi_union',
                'weighted_average',
                'classifier',
                'cat_boost_classifier',
                'decision_tree_train',
                'gbt_train',
                'k_neighbors_classifier',
                'lgbm_classifier',
                'logistic_regression_train',
                'naive_bayes_train',
                'random_forest_train',
                'svm_train',
                'xgb_classifier',
                'regressor',
                'decision_tree_regressor',
                'gbt_regressor',
                'k_neighbors_regressor',
                'lgbm_regressor',
                'linear_regression_train',
                'mlp_regressor',
                'random_forest_regressor',
                'xgb_regressor',
                'cat_boost_regressor',
                'forecast',
                'arima_forecast',
                'auto_regressive_forecast',
                'exp_smoothing_forecast',
                'linear_regression_forecast',
                'moving_average_forecast',
                'prophet_forecast',
                'seasonal_arima_forecast',
                'simple_exp_smoothing_forecast',
                'vector_auto_regressive_forecast',
                'weighted_moving_average_forecast',
                'cnn_text_classifier',
                'bow_text_classifier',
                'ensemble_text_classifier',
                'text_classifier',
                'word_frequency',
                'outlier',
                'abod_outlier',
                'cblof_outlier',
                'cof_outlier',
                'hbos_outlier',
                'iqr_outlier',
                'isolation_forest_outlier',
                'k_neighbors_outlier',
                'multi_objective_gaal_outlier',
                'one_class_svm_outlier',
                'pca_outlier',
                'single_objective_gaal_outlier',
                'subspace_outlier',
                'z_score_outlier',
                'assignment_optimization',
                'predictor',
                'us_income',
                'us_population',
                'weather',
                'hierarchy',
                'hierarchy_v2',
                'hierarchy_validator',
                'hierarchy_validator_v2',
                'lookup',
                'split_columns',
                'period_mapper',
                'rule_mapper',
                'rule_mapper_v2',
                'incentives_export',
                'incentives_import',
                'incentives_table',
                'incentives_period',
                'user_defined_calc',
                'sort_calc',
                'time_shift_calc',
                'category_calc',
                'true_up',
                'period_add',
                'period_diff',
                'expand_picklist',
                'period_accumulation',
                'reusable_logic_input',
                'reusable_logic_output',
                'reusable_logic'
            ]
        },
        customFormats: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:CustomFormat' } }
    },
    required: ['toolType']
};
function validate131(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ToolConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.toolType === undefined && (missing0 = 'toolType')) {
                validate131.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.toolType !== undefined) {
                    let data0 = data.toolType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate131.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/properties/toolType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'file' ||
                        data0 === 'cloud' ||
                        data0 === 'demand_forecast' ||
                        data0 === 'sample_customers' ||
                        data0 === 'pipe' ||
                        data0 === 'multi_port_pipe' ||
                        data0 === 'adapt' ||
                        data0 === 'aggregate' ||
                        data0 === 'aggregate_v2' ||
                        data0 === 'amortization' ||
                        data0 === 'binning' ||
                        data0 === 'category_encoder' ||
                        data0 === 'case' ||
                        data0 === 'change_case' ||
                        data0 === 'change_type' ||
                        data0 === 'clean_character' ||
                        data0 === 'combination_matcher' ||
                        data0 === 'conditional' ||
                        data0 === 'confusion_matrix' ||
                        data0 === 'date_add' ||
                        data0 === 'date_diff' ||
                        data0 === 'date_part' ||
                        data0 === 'date_aggregate' ||
                        data0 === 'date_format' ||
                        data0 === 'distinct' ||
                        data0 === 'drop' ||
                        data0 === 'export' ||
                        data0 === 'extract' ||
                        data0 === 'fill' ||
                        data0 === 'filter' ||
                        data0 === 'formula' ||
                        data0 === 'multi_formula' ||
                        data0 === 'fuzzy_matcher' ||
                        data0 === 'join' ||
                        data0 === 'join_v2' ||
                        data0 === 'lag' ||
                        data0 === 'limit' ||
                        data0 === 'merge_columns' ||
                        data0 === 'min_max_scaler' ||
                        data0 === 'monte_carlo' ||
                        data0 === 'most_common' ||
                        data0 === 'one_hot_encoder' ||
                        data0 === 'oversample' ||
                        data0 === 'predict_gender' ||
                        data0 === 'quantile' ||
                        data0 === 'random_number_generator' ||
                        data0 === 'rank' ||
                        data0 === 'record_id' ||
                        data0 === 'remove_outliers' ||
                        data0 === 'remove_empty' ||
                        data0 === 'rename' ||
                        data0 === 'reorder' ||
                        data0 === 'repeat' ||
                        data0 === 'replace' ||
                        data0 === 'multi_replace' ||
                        data0 === 'reshape' ||
                        data0 === 'reshape_v2' ||
                        data0 === 'running_average' ||
                        data0 === 'running_total' ||
                        data0 === 'sample' ||
                        data0 === 'segmentation' ||
                        data0 === 'select' ||
                        data0 === 'select_word' ||
                        data0 === 'smart_matcher' ||
                        data0 === 'snapshot' ||
                        data0 === 'sort' ||
                        data0 === 'split' ||
                        data0 === 'standard_scaler' ||
                        data0 === 'text_grade_level' ||
                        data0 === 'text_between' ||
                        data0 === 'text_length' ||
                        data0 === 'text_part' ||
                        data0 === 'text_sentiment' ||
                        data0 === 'trim' ||
                        data0 === 'trim_tags' ||
                        data0 === 'undersample' ||
                        data0 === 'union' ||
                        data0 === 'multi_union' ||
                        data0 === 'weighted_average' ||
                        data0 === 'classifier' ||
                        data0 === 'cat_boost_classifier' ||
                        data0 === 'decision_tree_train' ||
                        data0 === 'gbt_train' ||
                        data0 === 'k_neighbors_classifier' ||
                        data0 === 'lgbm_classifier' ||
                        data0 === 'logistic_regression_train' ||
                        data0 === 'naive_bayes_train' ||
                        data0 === 'random_forest_train' ||
                        data0 === 'svm_train' ||
                        data0 === 'xgb_classifier' ||
                        data0 === 'regressor' ||
                        data0 === 'decision_tree_regressor' ||
                        data0 === 'gbt_regressor' ||
                        data0 === 'k_neighbors_regressor' ||
                        data0 === 'lgbm_regressor' ||
                        data0 === 'linear_regression_train' ||
                        data0 === 'mlp_regressor' ||
                        data0 === 'random_forest_regressor' ||
                        data0 === 'xgb_regressor' ||
                        data0 === 'cat_boost_regressor' ||
                        data0 === 'forecast' ||
                        data0 === 'arima_forecast' ||
                        data0 === 'auto_regressive_forecast' ||
                        data0 === 'exp_smoothing_forecast' ||
                        data0 === 'linear_regression_forecast' ||
                        data0 === 'moving_average_forecast' ||
                        data0 === 'prophet_forecast' ||
                        data0 === 'seasonal_arima_forecast' ||
                        data0 === 'simple_exp_smoothing_forecast' ||
                        data0 === 'vector_auto_regressive_forecast' ||
                        data0 === 'weighted_moving_average_forecast' ||
                        data0 === 'cnn_text_classifier' ||
                        data0 === 'bow_text_classifier' ||
                        data0 === 'ensemble_text_classifier' ||
                        data0 === 'text_classifier' ||
                        data0 === 'word_frequency' ||
                        data0 === 'outlier' ||
                        data0 === 'abod_outlier' ||
                        data0 === 'cblof_outlier' ||
                        data0 === 'cof_outlier' ||
                        data0 === 'hbos_outlier' ||
                        data0 === 'iqr_outlier' ||
                        data0 === 'isolation_forest_outlier' ||
                        data0 === 'k_neighbors_outlier' ||
                        data0 === 'multi_objective_gaal_outlier' ||
                        data0 === 'one_class_svm_outlier' ||
                        data0 === 'pca_outlier' ||
                        data0 === 'single_objective_gaal_outlier' ||
                        data0 === 'subspace_outlier' ||
                        data0 === 'z_score_outlier' ||
                        data0 === 'assignment_optimization' ||
                        data0 === 'predictor' ||
                        data0 === 'us_income' ||
                        data0 === 'us_population' ||
                        data0 === 'weather' ||
                        data0 === 'hierarchy' ||
                        data0 === 'hierarchy_v2' ||
                        data0 === 'hierarchy_validator' ||
                        data0 === 'hierarchy_validator_v2' ||
                        data0 === 'lookup' ||
                        data0 === 'split_columns' ||
                        data0 === 'period_mapper' ||
                        data0 === 'rule_mapper' ||
                        data0 === 'rule_mapper_v2' ||
                        data0 === 'incentives_export' ||
                        data0 === 'incentives_import' ||
                        data0 === 'incentives_table' ||
                        data0 === 'incentives_period' ||
                        data0 === 'user_defined_calc' ||
                        data0 === 'sort_calc' ||
                        data0 === 'time_shift_calc' ||
                        data0 === 'category_calc' ||
                        data0 === 'true_up' ||
                        data0 === 'period_add' ||
                        data0 === 'period_diff' ||
                        data0 === 'expand_picklist' ||
                        data0 === 'period_accumulation' ||
                        data0 === 'reusable_logic_input' ||
                        data0 === 'reusable_logic_output' ||
                        data0 === 'reusable_logic')) {
                        validate131.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/properties/toolType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema198.properties.toolType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.customFormats !== undefined) {
                        let data1 = data.customFormats;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    let data2 = data1[key0];
                                    const _errs6 = errors;
                                    const _errs7 = errors;
                                    if (errors === _errs7) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.format === undefined && (missing1 = 'format')) ||
                                                (data2.autoGenerated === undefined && (missing1 = 'autoGenerated')) ||
                                                (data2.inherited === undefined && (missing1 = 'inherited'))) {
                                                validate131.errors = [
                                                    {
                                                        instancePath: instancePath + '/customFormats/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.format !== undefined) {
                                                    let data3 = data2.format;
                                                    const _errs9 = errors;
                                                    if (typeof data3 !== 'string') {
                                                        validate131.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/customFormats/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/format',
                                                                schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/format/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data3 === 'none' ||
                                                        data3 === 'currency' ||
                                                        data3 === 'percentage' ||
                                                        data3 === 'fullDateAndTime' ||
                                                        data3 === 'longDate' ||
                                                        data3 === 'shortDate' ||
                                                        data3 === 'time' ||
                                                        data3 === 'shortMonth')) {
                                                        validate131.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/customFormats/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                    '/format',
                                                                schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/format/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema106.properties.format.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs9 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data2.decimalPlace !== undefined) {
                                                        let data4 = data2.decimalPlace;
                                                        const _errs11 = errors;
                                                        if (errors === _errs11) {
                                                            if (typeof data4 == 'number') {
                                                                if (data4 < 0 || isNaN(data4)) {
                                                                    validate131.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/customFormats/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/decimalPlace',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/decimalPlace/minimum',
                                                                            keyword: 'minimum',
                                                                            params: { comparison: '>=', limit: 0 },
                                                                            message: 'must be >= 0'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate131.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/customFormats/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/decimalPlace',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/decimalPlace/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs11 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data2.thousandSeparator !== undefined) {
                                                            const _errs13 = errors;
                                                            if (typeof data2.thousandSeparator !== 'boolean') {
                                                                validate131.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/customFormats/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/thousandSeparator',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/thousandSeparator/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'boolean' },
                                                                        message: 'must be boolean'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs13 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data2.autoGenerated !== undefined) {
                                                                const _errs15 = errors;
                                                                if (typeof data2.autoGenerated !== 'boolean') {
                                                                    validate131.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/customFormats/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/autoGenerated',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/autoGenerated/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid3 = _errs15 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data2.inherited !== undefined) {
                                                                    const _errs17 = errors;
                                                                    if (typeof data2.inherited !== 'boolean') {
                                                                        validate131.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/customFormats/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/inherited',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/properties/inherited/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs17 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate131.errors = [
                                                {
                                                    instancePath: instancePath + '/customFormats/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: 'urn:wisepipe-common-pipe:CustomFormat/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs6 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate131.errors = [
                                    {
                                        instancePath: instancePath + '/customFormats',
                                        schemaPath: '#/properties/customFormats/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate131.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate131.errors = vErrors;
    return errors === 0;
}
const func186 = ucs2length;
const func187 = base64urlToBuffer;
const func188 = base64urlEncode;
const func189 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate130(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GlobalNodeElement" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.config === undefined && (missing0 = 'config')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.config !== undefined) {
                const _errs4 = errors;
                if (!validate131(data.config, {
                    instancePath: instancePath + '/config',
                    parentData: data,
                    parentDataProperty: 'config',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
                    errors = vErrors.length;
                }
                var valid1 = _errs4 === errors;
            }
            else {
                var valid1 = true;
            }
            if (valid1) {
                if (data.toolType !== undefined) {
                    let data1 = data.toolType;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate130.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/then/properties/toolType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    const vSchema0 = data && data.config && data.config.toolType;
                    if (vSchema0 !== undefined && !func0(data1, vSchema0)) {
                        validate130.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/then/properties/toolType/const',
                                keyword: 'const',
                                params: { allowedValue: vSchema0 },
                                message: 'must be equal to constant'
                            }
                        ];
                        return false;
                    }
                    var valid1 = _errs5 === errors;
                }
                else {
                    var valid1 = true;
                }
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.toolType !== undefined) {
                let data2 = data.toolType;
                if (typeof data2 !== 'string') {
                    validate130.errors = [
                        {
                            instancePath: instancePath + '/toolType',
                            schemaPath: '#/else/properties/toolType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data2 === 'file' ||
                    data2 === 'cloud' ||
                    data2 === 'demand_forecast' ||
                    data2 === 'sample_customers' ||
                    data2 === 'pipe' ||
                    data2 === 'multi_port_pipe' ||
                    data2 === 'adapt' ||
                    data2 === 'aggregate' ||
                    data2 === 'aggregate_v2' ||
                    data2 === 'amortization' ||
                    data2 === 'binning' ||
                    data2 === 'category_encoder' ||
                    data2 === 'case' ||
                    data2 === 'change_case' ||
                    data2 === 'change_type' ||
                    data2 === 'clean_character' ||
                    data2 === 'combination_matcher' ||
                    data2 === 'conditional' ||
                    data2 === 'confusion_matrix' ||
                    data2 === 'date_add' ||
                    data2 === 'date_diff' ||
                    data2 === 'date_part' ||
                    data2 === 'date_aggregate' ||
                    data2 === 'date_format' ||
                    data2 === 'distinct' ||
                    data2 === 'drop' ||
                    data2 === 'export' ||
                    data2 === 'extract' ||
                    data2 === 'fill' ||
                    data2 === 'filter' ||
                    data2 === 'formula' ||
                    data2 === 'multi_formula' ||
                    data2 === 'fuzzy_matcher' ||
                    data2 === 'join' ||
                    data2 === 'join_v2' ||
                    data2 === 'lag' ||
                    data2 === 'limit' ||
                    data2 === 'merge_columns' ||
                    data2 === 'min_max_scaler' ||
                    data2 === 'monte_carlo' ||
                    data2 === 'most_common' ||
                    data2 === 'one_hot_encoder' ||
                    data2 === 'oversample' ||
                    data2 === 'predict_gender' ||
                    data2 === 'quantile' ||
                    data2 === 'random_number_generator' ||
                    data2 === 'rank' ||
                    data2 === 'record_id' ||
                    data2 === 'remove_outliers' ||
                    data2 === 'remove_empty' ||
                    data2 === 'rename' ||
                    data2 === 'reorder' ||
                    data2 === 'repeat' ||
                    data2 === 'replace' ||
                    data2 === 'multi_replace' ||
                    data2 === 'reshape' ||
                    data2 === 'reshape_v2' ||
                    data2 === 'running_average' ||
                    data2 === 'running_total' ||
                    data2 === 'sample' ||
                    data2 === 'segmentation' ||
                    data2 === 'select' ||
                    data2 === 'select_word' ||
                    data2 === 'smart_matcher' ||
                    data2 === 'snapshot' ||
                    data2 === 'sort' ||
                    data2 === 'split' ||
                    data2 === 'standard_scaler' ||
                    data2 === 'text_grade_level' ||
                    data2 === 'text_between' ||
                    data2 === 'text_length' ||
                    data2 === 'text_part' ||
                    data2 === 'text_sentiment' ||
                    data2 === 'trim' ||
                    data2 === 'trim_tags' ||
                    data2 === 'undersample' ||
                    data2 === 'union' ||
                    data2 === 'multi_union' ||
                    data2 === 'weighted_average' ||
                    data2 === 'classifier' ||
                    data2 === 'cat_boost_classifier' ||
                    data2 === 'decision_tree_train' ||
                    data2 === 'gbt_train' ||
                    data2 === 'k_neighbors_classifier' ||
                    data2 === 'lgbm_classifier' ||
                    data2 === 'logistic_regression_train' ||
                    data2 === 'naive_bayes_train' ||
                    data2 === 'random_forest_train' ||
                    data2 === 'svm_train' ||
                    data2 === 'xgb_classifier' ||
                    data2 === 'regressor' ||
                    data2 === 'decision_tree_regressor' ||
                    data2 === 'gbt_regressor' ||
                    data2 === 'k_neighbors_regressor' ||
                    data2 === 'lgbm_regressor' ||
                    data2 === 'linear_regression_train' ||
                    data2 === 'mlp_regressor' ||
                    data2 === 'random_forest_regressor' ||
                    data2 === 'xgb_regressor' ||
                    data2 === 'cat_boost_regressor' ||
                    data2 === 'forecast' ||
                    data2 === 'arima_forecast' ||
                    data2 === 'auto_regressive_forecast' ||
                    data2 === 'exp_smoothing_forecast' ||
                    data2 === 'linear_regression_forecast' ||
                    data2 === 'moving_average_forecast' ||
                    data2 === 'prophet_forecast' ||
                    data2 === 'seasonal_arima_forecast' ||
                    data2 === 'simple_exp_smoothing_forecast' ||
                    data2 === 'vector_auto_regressive_forecast' ||
                    data2 === 'weighted_moving_average_forecast' ||
                    data2 === 'cnn_text_classifier' ||
                    data2 === 'bow_text_classifier' ||
                    data2 === 'ensemble_text_classifier' ||
                    data2 === 'text_classifier' ||
                    data2 === 'word_frequency' ||
                    data2 === 'outlier' ||
                    data2 === 'abod_outlier' ||
                    data2 === 'cblof_outlier' ||
                    data2 === 'cof_outlier' ||
                    data2 === 'hbos_outlier' ||
                    data2 === 'iqr_outlier' ||
                    data2 === 'isolation_forest_outlier' ||
                    data2 === 'k_neighbors_outlier' ||
                    data2 === 'multi_objective_gaal_outlier' ||
                    data2 === 'one_class_svm_outlier' ||
                    data2 === 'pca_outlier' ||
                    data2 === 'single_objective_gaal_outlier' ||
                    data2 === 'subspace_outlier' ||
                    data2 === 'z_score_outlier' ||
                    data2 === 'assignment_optimization' ||
                    data2 === 'predictor' ||
                    data2 === 'us_income' ||
                    data2 === 'us_population' ||
                    data2 === 'weather' ||
                    data2 === 'hierarchy' ||
                    data2 === 'hierarchy_v2' ||
                    data2 === 'hierarchy_validator' ||
                    data2 === 'hierarchy_validator_v2' ||
                    data2 === 'lookup' ||
                    data2 === 'split_columns' ||
                    data2 === 'period_mapper' ||
                    data2 === 'rule_mapper' ||
                    data2 === 'rule_mapper_v2' ||
                    data2 === 'incentives_export' ||
                    data2 === 'incentives_import' ||
                    data2 === 'incentives_table' ||
                    data2 === 'incentives_period' ||
                    data2 === 'user_defined_calc' ||
                    data2 === 'sort_calc' ||
                    data2 === 'time_shift_calc' ||
                    data2 === 'category_calc' ||
                    data2 === 'true_up' ||
                    data2 === 'period_add' ||
                    data2 === 'period_diff' ||
                    data2 === 'expand_picklist' ||
                    data2 === 'period_accumulation' ||
                    data2 === 'reusable_logic_input' ||
                    data2 === 'reusable_logic_output' ||
                    data2 === 'reusable_logic')) {
                    validate130.errors = [
                        {
                            instancePath: instancePath + '/toolType',
                            schemaPath: '#/else/properties/toolType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema197.else.properties.toolType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate130.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.pipeID === undefined && (missing1 = 'pipeID')) ||
                (data.toolType === undefined && (missing1 = 'toolType'))) {
                validate130.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.nameOverride !== undefined) {
                    const _errs10 = errors;
                    if (typeof data.nameOverride !== 'string') {
                        validate130.errors = [
                            {
                                instancePath: instancePath + '/nameOverride',
                                schemaPath: '#/properties/nameOverride/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid3 = _errs10 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.pipeID !== undefined) {
                        let data4 = data.pipeID;
                        const _errs12 = errors;
                        if (errors === _errs12) {
                            if (typeof data4 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func186(data4) < b64min0 || func186(data4) > b64max0) {
                                    validate130.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func186(data4) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func186(data4)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func187(data4);
                                    if (decoded0.length !== 10) {
                                        validate130.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func188(decoded0);
                                        if (func189(encoded0) !== func189(data4)) {
                                            validate130.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate130.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid3 = _errs12 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                }
            }
        }
        else {
            validate130.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate130.errors = vErrors;
    return errors === 0;
}
export const graphElementSchemaValidation = validate133;
const schema200 = {
    $id: 'urn:wisepipe-common-pipe:GraphElement',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        elementType: { type: 'string', pattern: 'edge|node|group' },
        lastModified: { type: 'string', format: 'date-time' },
        uniqueChangeID: { type: 'string' }
    },
    required: ['elementID', 'elementType']
};
const func190 = ucs2length;
const func191 = base64urlToBuffer;
const func192 = base64urlEncode;
const func193 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate133(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GraphElement" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.elementType === undefined && (missing0 = 'elementType'))) {
                validate133.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data0 = data.elementID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func190(data0) < b64min0 || func190(data0) > b64max0) {
                                validate133.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func190(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func190(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func191(data0);
                                if (decoded0.length !== 10) {
                                    validate133.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func192(decoded0);
                                    if (func193(encoded0) !== func193(data0)) {
                                        validate133.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate133.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elementType !== undefined) {
                        let data1 = data.elementType;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!pattern8.test(data1)) {
                                    validate133.errors = [
                                        {
                                            instancePath: instancePath + '/elementType',
                                            schemaPath: '#/properties/elementType/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'edge|node|group' },
                                            message: 'must match pattern "' + 'edge|node|group' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate133.errors = [
                                    {
                                        instancePath: instancePath + '/elementType',
                                        schemaPath: '#/properties/elementType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.lastModified !== undefined) {
                            let data2 = data.lastModified;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate133.errors = [
                                                {
                                                    instancePath: instancePath + '/lastModified',
                                                    schemaPath: '#/properties/lastModified/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate133.errors = [
                                            {
                                                instancePath: instancePath + '/lastModified',
                                                schemaPath: '#/properties/lastModified/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.uniqueChangeID !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.uniqueChangeID !== 'string') {
                                    validate133.errors = [
                                        {
                                            instancePath: instancePath + '/uniqueChangeID',
                                            schemaPath: '#/properties/uniqueChangeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate133.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate133.errors = vErrors;
    return errors === 0;
}
export const graphViewVertexSchemaValidation = validate134;
const schema201 = {
    $id: 'urn:wisepipe-common-pipe:GraphViewVertex',
    type: 'object',
    properties: {
        vertex: { $ref: 'urn:wisepipe-common-pipe:LineageVertex' },
        ins: { type: 'array', items: { type: 'string', minLength: 1 } },
        outs: { type: 'array', items: { type: 'string', minLength: 1 } }
    },
    required: ['vertex', 'ins', 'outs']
};
const schema202 = {
    $id: 'urn:wisepipe-common-pipe:LineageVertex',
    type: 'object',
    properties: {
        vertexID: { type: 'string', minLength: 1 },
        vertexType: { type: 'string', enum: ['incentives-table', 'incentives-export'] }
    },
    required: ['vertexID', 'vertexType']
};
function validate134(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GraphViewVertex" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.vertex === undefined && (missing0 = 'vertex')) ||
                (data.ins === undefined && (missing0 = 'ins')) ||
                (data.outs === undefined && (missing0 = 'outs'))) {
                validate134.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.vertex !== undefined) {
                    let data0 = data.vertex;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.vertexID === undefined && (missing1 = 'vertexID')) ||
                                (data0.vertexType === undefined && (missing1 = 'vertexType'))) {
                                validate134.errors = [
                                    {
                                        instancePath: instancePath + '/vertex',
                                        schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.vertexID !== undefined) {
                                    let data1 = data0.vertexID;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate134.errors = [
                                                    {
                                                        instancePath: instancePath + '/vertex/vertexID',
                                                        schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate134.errors = [
                                                {
                                                    instancePath: instancePath + '/vertex/vertexID',
                                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.vertexType !== undefined) {
                                        let data2 = data0.vertexType;
                                        const _errs6 = errors;
                                        if (typeof data2 !== 'string') {
                                            validate134.errors = [
                                                {
                                                    instancePath: instancePath + '/vertex/vertexType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data2 === 'incentives-table' || data2 === 'incentives-export')) {
                                            validate134.errors = [
                                                {
                                                    instancePath: instancePath + '/vertex/vertexType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema202.properties.vertexType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate134.errors = [
                                {
                                    instancePath: instancePath + '/vertex',
                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.ins !== undefined) {
                        let data3 = data.ins;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (Array.isArray(data3)) {
                                var valid3 = true;
                                const len0 = data3.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data4 = data3[i0];
                                    const _errs10 = errors;
                                    if (errors === _errs10) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate134.errors = [
                                                    {
                                                        instancePath: instancePath + '/ins/' + i0,
                                                        schemaPath: '#/properties/ins/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate134.errors = [
                                                {
                                                    instancePath: instancePath + '/ins/' + i0,
                                                    schemaPath: '#/properties/ins/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs10 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate134.errors = [
                                    {
                                        instancePath: instancePath + '/ins',
                                        schemaPath: '#/properties/ins/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.outs !== undefined) {
                            let data5 = data.outs;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (Array.isArray(data5)) {
                                    var valid4 = true;
                                    const len1 = data5.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                        let data6 = data5[i1];
                                        const _errs14 = errors;
                                        if (errors === _errs14) {
                                            if (typeof data6 === 'string') {
                                                if (func2(data6) < 1) {
                                                    validate134.errors = [
                                                        {
                                                            instancePath: instancePath + '/outs/' + i1,
                                                            schemaPath: '#/properties/outs/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate134.errors = [
                                                    {
                                                        instancePath: instancePath + '/outs/' + i1,
                                                        schemaPath: '#/properties/outs/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs14 === errors;
                                        if (!valid4) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate134.errors = [
                                        {
                                            instancePath: instancePath + '/outs',
                                            schemaPath: '#/properties/outs/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate134.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate134.errors = vErrors;
    return errors === 0;
}
export const groupElementSchemaValidation = validate135;
const schema203 = {
    $id: 'urn:wisepipe-common-pipe:GroupElement',
    type: 'object',
    properties: {
        x: { type: 'number', minimum: -100000, maximum: 100000 },
        y: { type: 'number', minimum: -100000, maximum: 100000 },
        name: { type: 'string' }
    }
};
function validate135(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:GroupElement" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.x !== undefined) {
                let data0 = data.x;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 > 100000 || isNaN(data0)) {
                            validate135.errors = [
                                {
                                    instancePath: instancePath + '/x',
                                    schemaPath: '#/properties/x/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 100000 },
                                    message: 'must be <= 100000'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0 < -100000 || isNaN(data0)) {
                                validate135.errors = [
                                    {
                                        instancePath: instancePath + '/x',
                                        schemaPath: '#/properties/x/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: -100000 },
                                        message: 'must be >= -100000'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate135.errors = [
                            {
                                instancePath: instancePath + '/x',
                                schemaPath: '#/properties/x/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.y !== undefined) {
                    let data1 = data.y;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 > 100000 || isNaN(data1)) {
                                validate135.errors = [
                                    {
                                        instancePath: instancePath + '/y',
                                        schemaPath: '#/properties/y/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 100000 },
                                        message: 'must be <= 100000'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1 < -100000 || isNaN(data1)) {
                                    validate135.errors = [
                                        {
                                            instancePath: instancePath + '/y',
                                            schemaPath: '#/properties/y/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: -100000 },
                                            message: 'must be >= -100000'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate135.errors = [
                                {
                                    instancePath: instancePath + '/y',
                                    schemaPath: '#/properties/y/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        const _errs5 = errors;
                        if (typeof data.name !== 'string') {
                            validate135.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate135.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate135.errors = vErrors;
    return errors === 0;
}
export const hbosOutlierConfigSchemaValidation = validate136;
const schema204 = {
    $id: 'urn:wisepipe-common-pipe:HbosOutlierConfig',
    type: 'object',
    properties: {
        nBins: { type: 'integer' },
        alpha: { type: 'number', minimum: 0, maximum: 1 },
        tol: { type: 'number', minimum: 0, maximum: 1 }
    },
    required: []
};
function validate136(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:HbosOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.nBins !== undefined) {
                let data0 = data.nBins;
                const _errs1 = errors;
                if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                    validate136.errors = [
                        {
                            instancePath: instancePath + '/nBins',
                            schemaPath: '#/properties/nBins/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer'
                        }
                    ];
                    return false;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.alpha !== undefined) {
                    let data1 = data.alpha;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 > 1 || isNaN(data1)) {
                                validate136.errors = [
                                    {
                                        instancePath: instancePath + '/alpha',
                                        schemaPath: '#/properties/alpha/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 1 },
                                        message: 'must be <= 1'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate136.errors = [
                                        {
                                            instancePath: instancePath + '/alpha',
                                            schemaPath: '#/properties/alpha/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate136.errors = [
                                {
                                    instancePath: instancePath + '/alpha',
                                    schemaPath: '#/properties/alpha/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.tol !== undefined) {
                        let data2 = data.tol;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 == 'number') {
                                if (data2 > 1 || isNaN(data2)) {
                                    validate136.errors = [
                                        {
                                            instancePath: instancePath + '/tol',
                                            schemaPath: '#/properties/tol/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1 },
                                            message: 'must be <= 1'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate136.errors = [
                                            {
                                                instancePath: instancePath + '/tol',
                                                schemaPath: '#/properties/tol/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate136.errors = [
                                    {
                                        instancePath: instancePath + '/tol',
                                        schemaPath: '#/properties/tol/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate136.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate136.errors = vErrors;
    return errors === 0;
}
export const hierarchyColumnSchemaValidation = validate137;
const schema205 = {
    $id: 'urn:wisepipe-common-pipe:HierarchyColumn',
    type: 'object',
    properties: { key: { type: 'string', minLength: 1 }, name: { type: 'string' } },
    required: ['key']
};
function validate137(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:HierarchyColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.key === undefined && (missing0 = 'key')) {
                validate137.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.key !== undefined) {
                    let data0 = data.key;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate137.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate137.errors = [
                                {
                                    instancePath: instancePath + '/key',
                                    schemaPath: '#/properties/key/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.name !== 'string') {
                            validate137.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate137.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate137.errors = vErrors;
    return errors === 0;
}
export const hierarchyConfigSchemaValidation = validate138;
const schema206 = {
    $id: 'urn:wisepipe-common-pipe:HierarchyConfig',
    type: 'object',
    oneOf: [
        {
            properties: {
                columns: {
                    type: 'array',
                    items: { $ref: 'urn:wisepipe-common-pipe:HierarchyColumn' },
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 10
                },
                rootName: { type: 'string', maxLength: 20 }
            }
        },
        {
            properties: {
                columns: { type: 'array', items: { type: 'string' }, uniqueItems: true, minItems: 1, maxItems: 10 },
                rootName: { type: 'string', maxLength: 20 }
            }
        }
    ],
    required: ['columns']
};
function validate138(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:HierarchyConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.columns !== undefined) {
            let data0 = data.columns;
            const _errs3 = errors;
            if (errors === _errs3) {
                if (Array.isArray(data0)) {
                    if (data0.length > 10) {
                        const err0 = {
                            instancePath: instancePath + '/columns',
                            schemaPath: '#/oneOf/0/properties/columns/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 10 },
                            message: 'must NOT have more than 10 items'
                        };
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                    else {
                        if (data0.length < 1) {
                            const err1 = {
                                instancePath: instancePath + '/columns',
                                schemaPath: '#/oneOf/0/properties/columns/minItems',
                                keyword: 'minItems',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 items'
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        else {
                            var valid2 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs5 = errors;
                                const _errs6 = errors;
                                if (errors === _errs6) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing0;
                                        if (data1.key === undefined && (missing0 = 'key')) {
                                            const err2 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing0 },
                                                message: "must have required property '" + missing0 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data1.key !== undefined) {
                                                let data2 = data1.key;
                                                const _errs8 = errors;
                                                if (errors === _errs8) {
                                                    if (typeof data2 === 'string') {
                                                        if (func2(data2) < 1) {
                                                            const err3 = {
                                                                instancePath: instancePath + '/columns/' + i0 + '/key',
                                                                schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/properties/key/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err3];
                                                            }
                                                            else {
                                                                vErrors.push(err3);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err4 = {
                                                            instancePath: instancePath + '/columns/' + i0 + '/key',
                                                            schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/properties/key/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err4];
                                                        }
                                                        else {
                                                            vErrors.push(err4);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid4 = _errs8 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data1.name !== undefined) {
                                                    const _errs10 = errors;
                                                    if (typeof data1.name !== 'string') {
                                                        const err5 = {
                                                            instancePath: instancePath + '/columns/' + i0 + '/name',
                                                            schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/properties/name/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err5];
                                                        }
                                                        else {
                                                            vErrors.push(err5);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid4 = _errs10 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err6 = {
                                            instancePath: instancePath + '/columns/' + i0,
                                            schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                                var valid2 = _errs5 === errors;
                                if (!valid2) {
                                    break;
                                }
                            }
                            if (valid2) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (; i1--;) {
                                        for (j0 = i1; j0--;) {
                                            if (func0(data0[i1], data0[j0])) {
                                                const err7 = {
                                                    instancePath: instancePath + '/columns',
                                                    schemaPath: '#/oneOf/0/properties/columns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err7];
                                                }
                                                else {
                                                    vErrors.push(err7);
                                                }
                                                errors++;
                                                break outer0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    const err8 = {
                        instancePath: instancePath + '/columns',
                        schemaPath: '#/oneOf/0/properties/columns/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array'
                    };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            var valid1 = _errs3 === errors;
        }
        else {
            var valid1 = true;
        }
        if (valid1) {
            if (data.rootName !== undefined) {
                let data4 = data.rootName;
                const _errs12 = errors;
                if (errors === _errs12) {
                    if (typeof data4 === 'string') {
                        if (func2(data4) > 20) {
                            const err9 = {
                                instancePath: instancePath + '/rootName',
                                schemaPath: '#/oneOf/0/properties/rootName/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 20 },
                                message: 'must NOT have more than 20 characters'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err10 = {
                            instancePath: instancePath + '/rootName',
                            schemaPath: '#/oneOf/0/properties/rootName/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
                var valid1 = _errs12 === errors;
            }
            else {
                var valid1 = true;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs14 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.columns !== undefined) {
            let data5 = data.columns;
            const _errs15 = errors;
            if (errors === _errs15) {
                if (Array.isArray(data5)) {
                    if (data5.length > 10) {
                        const err11 = {
                            instancePath: instancePath + '/columns',
                            schemaPath: '#/oneOf/1/properties/columns/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 10 },
                            message: 'must NOT have more than 10 items'
                        };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                    else {
                        if (data5.length < 1) {
                            const err12 = {
                                instancePath: instancePath + '/columns',
                                schemaPath: '#/oneOf/1/properties/columns/minItems',
                                keyword: 'minItems',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 items'
                            };
                            if (vErrors === null) {
                                vErrors = [err12];
                            }
                            else {
                                vErrors.push(err12);
                            }
                            errors++;
                        }
                        else {
                            var valid7 = true;
                            const len1 = data5.length;
                            for (let i2 = 0; i2 < len1; i2++) {
                                const _errs17 = errors;
                                if (typeof data5[i2] !== 'string') {
                                    const err13 = {
                                        instancePath: instancePath + '/columns/' + i2,
                                        schemaPath: '#/oneOf/1/properties/columns/items/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err13];
                                    }
                                    else {
                                        vErrors.push(err13);
                                    }
                                    errors++;
                                }
                                var valid7 = _errs17 === errors;
                                if (!valid7) {
                                    break;
                                }
                            }
                            if (valid7) {
                                let i3 = data5.length;
                                let j1;
                                if (i3 > 1) {
                                    const indices0 = {};
                                    for (; i3--;) {
                                        let item0 = data5[i3];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j1 = indices0[item0];
                                            const err14 = {
                                                instancePath: instancePath + '/columns',
                                                schemaPath: '#/oneOf/1/properties/columns/uniqueItems',
                                                keyword: 'uniqueItems',
                                                params: { i: i3, j: j1 },
                                                message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err14];
                                            }
                                            else {
                                                vErrors.push(err14);
                                            }
                                            errors++;
                                            break;
                                        }
                                        indices0[item0] = i3;
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    const err15 = {
                        instancePath: instancePath + '/columns',
                        schemaPath: '#/oneOf/1/properties/columns/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array'
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            var valid6 = _errs15 === errors;
        }
        else {
            var valid6 = true;
        }
        if (valid6) {
            if (data.rootName !== undefined) {
                let data7 = data.rootName;
                const _errs19 = errors;
                if (errors === _errs19) {
                    if (typeof data7 === 'string') {
                        if (func2(data7) > 20) {
                            const err16 = {
                                instancePath: instancePath + '/rootName',
                                schemaPath: '#/oneOf/1/properties/rootName/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 20 },
                                message: 'must NOT have more than 20 characters'
                            };
                            if (vErrors === null) {
                                vErrors = [err16];
                            }
                            else {
                                vErrors.push(err16);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err17 = {
                            instancePath: instancePath + '/rootName',
                            schemaPath: '#/oneOf/1/properties/rootName/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                }
                var valid6 = _errs19 === errors;
            }
            else {
                var valid6 = true;
            }
        }
    }
    var _valid0 = _errs14 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid0) {
            valid0 = true;
            passing0 = 1;
        }
    }
    if (!valid0) {
        const err18 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf'
        };
        if (vErrors === null) {
            vErrors = [err18];
        }
        else {
            vErrors.push(err18);
        }
        errors++;
        validate138.errors = vErrors;
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.columns === undefined && (missing1 = 'columns')) {
                validate138.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        else {
            validate138.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate138.errors = vErrors;
    return errors === 0;
}
export const hierarchyV2ConfigSchemaValidation = validate139;
const schema208 = {
    $id: 'urn:wisepipe-common-pipe:HierarchyV2Config',
    type: 'object',
    oneOf: [
        {
            properties: {
                columns: {
                    type: 'array',
                    items: { $ref: 'urn:wisepipe-common-pipe:HierarchyColumn' },
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 10
                },
                rootName: { type: 'string', maxLength: 20 }
            }
        },
        {
            properties: {
                columns: { type: 'array', items: { type: 'string' }, uniqueItems: true, minItems: 1, maxItems: 10 },
                rootName: { type: 'string', maxLength: 20 }
            }
        }
    ],
    required: ['columns']
};
function validate139(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:HierarchyV2Config" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.columns !== undefined) {
            let data0 = data.columns;
            const _errs3 = errors;
            if (errors === _errs3) {
                if (Array.isArray(data0)) {
                    if (data0.length > 10) {
                        const err0 = {
                            instancePath: instancePath + '/columns',
                            schemaPath: '#/oneOf/0/properties/columns/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 10 },
                            message: 'must NOT have more than 10 items'
                        };
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                    else {
                        if (data0.length < 1) {
                            const err1 = {
                                instancePath: instancePath + '/columns',
                                schemaPath: '#/oneOf/0/properties/columns/minItems',
                                keyword: 'minItems',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 items'
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                        }
                        else {
                            var valid2 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs5 = errors;
                                const _errs6 = errors;
                                if (errors === _errs6) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing0;
                                        if (data1.key === undefined && (missing0 = 'key')) {
                                            const err2 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing0 },
                                                message: "must have required property '" + missing0 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data1.key !== undefined) {
                                                let data2 = data1.key;
                                                const _errs8 = errors;
                                                if (errors === _errs8) {
                                                    if (typeof data2 === 'string') {
                                                        if (func2(data2) < 1) {
                                                            const err3 = {
                                                                instancePath: instancePath + '/columns/' + i0 + '/key',
                                                                schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/properties/key/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err3];
                                                            }
                                                            else {
                                                                vErrors.push(err3);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err4 = {
                                                            instancePath: instancePath + '/columns/' + i0 + '/key',
                                                            schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/properties/key/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err4];
                                                        }
                                                        else {
                                                            vErrors.push(err4);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid4 = _errs8 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data1.name !== undefined) {
                                                    const _errs10 = errors;
                                                    if (typeof data1.name !== 'string') {
                                                        const err5 = {
                                                            instancePath: instancePath + '/columns/' + i0 + '/name',
                                                            schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/properties/name/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err5];
                                                        }
                                                        else {
                                                            vErrors.push(err5);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid4 = _errs10 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err6 = {
                                            instancePath: instancePath + '/columns/' + i0,
                                            schemaPath: 'urn:wisepipe-common-pipe:HierarchyColumn/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                                var valid2 = _errs5 === errors;
                                if (!valid2) {
                                    break;
                                }
                            }
                            if (valid2) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (; i1--;) {
                                        for (j0 = i1; j0--;) {
                                            if (func0(data0[i1], data0[j0])) {
                                                const err7 = {
                                                    instancePath: instancePath + '/columns',
                                                    schemaPath: '#/oneOf/0/properties/columns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err7];
                                                }
                                                else {
                                                    vErrors.push(err7);
                                                }
                                                errors++;
                                                break outer0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    const err8 = {
                        instancePath: instancePath + '/columns',
                        schemaPath: '#/oneOf/0/properties/columns/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array'
                    };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            var valid1 = _errs3 === errors;
        }
        else {
            var valid1 = true;
        }
        if (valid1) {
            if (data.rootName !== undefined) {
                let data4 = data.rootName;
                const _errs12 = errors;
                if (errors === _errs12) {
                    if (typeof data4 === 'string') {
                        if (func2(data4) > 20) {
                            const err9 = {
                                instancePath: instancePath + '/rootName',
                                schemaPath: '#/oneOf/0/properties/rootName/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 20 },
                                message: 'must NOT have more than 20 characters'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err10 = {
                            instancePath: instancePath + '/rootName',
                            schemaPath: '#/oneOf/0/properties/rootName/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
                var valid1 = _errs12 === errors;
            }
            else {
                var valid1 = true;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs14 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.columns !== undefined) {
            let data5 = data.columns;
            const _errs15 = errors;
            if (errors === _errs15) {
                if (Array.isArray(data5)) {
                    if (data5.length > 10) {
                        const err11 = {
                            instancePath: instancePath + '/columns',
                            schemaPath: '#/oneOf/1/properties/columns/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 10 },
                            message: 'must NOT have more than 10 items'
                        };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                    else {
                        if (data5.length < 1) {
                            const err12 = {
                                instancePath: instancePath + '/columns',
                                schemaPath: '#/oneOf/1/properties/columns/minItems',
                                keyword: 'minItems',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 items'
                            };
                            if (vErrors === null) {
                                vErrors = [err12];
                            }
                            else {
                                vErrors.push(err12);
                            }
                            errors++;
                        }
                        else {
                            var valid7 = true;
                            const len1 = data5.length;
                            for (let i2 = 0; i2 < len1; i2++) {
                                const _errs17 = errors;
                                if (typeof data5[i2] !== 'string') {
                                    const err13 = {
                                        instancePath: instancePath + '/columns/' + i2,
                                        schemaPath: '#/oneOf/1/properties/columns/items/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err13];
                                    }
                                    else {
                                        vErrors.push(err13);
                                    }
                                    errors++;
                                }
                                var valid7 = _errs17 === errors;
                                if (!valid7) {
                                    break;
                                }
                            }
                            if (valid7) {
                                let i3 = data5.length;
                                let j1;
                                if (i3 > 1) {
                                    const indices0 = {};
                                    for (; i3--;) {
                                        let item0 = data5[i3];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j1 = indices0[item0];
                                            const err14 = {
                                                instancePath: instancePath + '/columns',
                                                schemaPath: '#/oneOf/1/properties/columns/uniqueItems',
                                                keyword: 'uniqueItems',
                                                params: { i: i3, j: j1 },
                                                message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err14];
                                            }
                                            else {
                                                vErrors.push(err14);
                                            }
                                            errors++;
                                            break;
                                        }
                                        indices0[item0] = i3;
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    const err15 = {
                        instancePath: instancePath + '/columns',
                        schemaPath: '#/oneOf/1/properties/columns/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array'
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            var valid6 = _errs15 === errors;
        }
        else {
            var valid6 = true;
        }
        if (valid6) {
            if (data.rootName !== undefined) {
                let data7 = data.rootName;
                const _errs19 = errors;
                if (errors === _errs19) {
                    if (typeof data7 === 'string') {
                        if (func2(data7) > 20) {
                            const err16 = {
                                instancePath: instancePath + '/rootName',
                                schemaPath: '#/oneOf/1/properties/rootName/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 20 },
                                message: 'must NOT have more than 20 characters'
                            };
                            if (vErrors === null) {
                                vErrors = [err16];
                            }
                            else {
                                vErrors.push(err16);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err17 = {
                            instancePath: instancePath + '/rootName',
                            schemaPath: '#/oneOf/1/properties/rootName/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                }
                var valid6 = _errs19 === errors;
            }
            else {
                var valid6 = true;
            }
        }
    }
    var _valid0 = _errs14 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid0) {
            valid0 = true;
            passing0 = 1;
        }
    }
    if (!valid0) {
        const err18 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf'
        };
        if (vErrors === null) {
            vErrors = [err18];
        }
        else {
            vErrors.push(err18);
        }
        errors++;
        validate139.errors = vErrors;
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.columns === undefined && (missing1 = 'columns')) {
                validate139.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        else {
            validate139.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate139.errors = vErrors;
    return errors === 0;
}
export const hierarchyValidatorConfigSchemaValidation = validate140;
const schema210 = {
    $id: 'urn:wisepipe-common-pipe:HierarchyValidatorConfig',
    type: 'object',
    properties: {
        keyColumn: { type: 'string' },
        keyNameColumn: { type: 'string' },
        parentKeyColumn: { type: 'string' },
        parentKeyNameColumn: { type: 'string' }
    },
    required: ['keyColumn', 'parentKeyColumn']
};
function validate140(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:HierarchyValidatorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.keyColumn === undefined && (missing0 = 'keyColumn')) ||
                (data.parentKeyColumn === undefined && (missing0 = 'parentKeyColumn'))) {
                validate140.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.keyColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.keyColumn !== 'string') {
                        validate140.errors = [
                            {
                                instancePath: instancePath + '/keyColumn',
                                schemaPath: '#/properties/keyColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.keyNameColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.keyNameColumn !== 'string') {
                            validate140.errors = [
                                {
                                    instancePath: instancePath + '/keyNameColumn',
                                    schemaPath: '#/properties/keyNameColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.parentKeyColumn !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.parentKeyColumn !== 'string') {
                                validate140.errors = [
                                    {
                                        instancePath: instancePath + '/parentKeyColumn',
                                        schemaPath: '#/properties/parentKeyColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.parentKeyNameColumn !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.parentKeyNameColumn !== 'string') {
                                    validate140.errors = [
                                        {
                                            instancePath: instancePath + '/parentKeyNameColumn',
                                            schemaPath: '#/properties/parentKeyNameColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate140.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate140.errors = vErrors;
    return errors === 0;
}
export const hierarchyValidatorV2ConfigSchemaValidation = validate141;
const schema211 = {
    $id: 'urn:wisepipe-common-pipe:HierarchyValidatorV2Config',
    type: 'object',
    properties: {
        keyColumn: { type: 'string' },
        keyNameColumn: { type: 'string' },
        parentKeyColumn: { type: 'string' },
        parentKeyNameColumn: { type: 'string' }
    },
    required: ['keyColumn', 'parentKeyColumn']
};
function validate141(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:HierarchyValidatorV2Config" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.keyColumn === undefined && (missing0 = 'keyColumn')) ||
                (data.parentKeyColumn === undefined && (missing0 = 'parentKeyColumn'))) {
                validate141.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.keyColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.keyColumn !== 'string') {
                        validate141.errors = [
                            {
                                instancePath: instancePath + '/keyColumn',
                                schemaPath: '#/properties/keyColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.keyNameColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.keyNameColumn !== 'string') {
                            validate141.errors = [
                                {
                                    instancePath: instancePath + '/keyNameColumn',
                                    schemaPath: '#/properties/keyNameColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.parentKeyColumn !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.parentKeyColumn !== 'string') {
                                validate141.errors = [
                                    {
                                        instancePath: instancePath + '/parentKeyColumn',
                                        schemaPath: '#/properties/parentKeyColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.parentKeyNameColumn !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.parentKeyNameColumn !== 'string') {
                                    validate141.errors = [
                                        {
                                            instancePath: instancePath + '/parentKeyNameColumn',
                                            schemaPath: '#/properties/parentKeyNameColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate141.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate141.errors = vErrors;
    return errors === 0;
}
export const incentivesDSMetadatasSchemaValidation = validate142;
const schema212 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesDSMetadatas',
    type: 'object',
    properties: {
        incentivesDSMetadatas: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta' }
        }
    },
    required: ['incentivesDSMetadatas']
};
const schema213 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta',
    type: 'object',
    properties: { incentivesDatasourceID: { type: 'string' }, pkColumns: { type: 'array', items: { type: 'string' } } },
    required: ['incentivesDatasourceID']
};
function validate142(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesDSMetadatas" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.incentivesDSMetadatas === undefined && (missing0 = 'incentivesDSMetadatas')) {
                validate142.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.incentivesDSMetadatas !== undefined) {
                    let data0 = data.incentivesDSMetadatas;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                let data1 = data0[key0];
                                const _errs4 = errors;
                                const _errs5 = errors;
                                if (errors === _errs5) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if (data1.incentivesDatasourceID === undefined && (missing1 = 'incentivesDatasourceID')) {
                                            validate142.errors = [
                                                {
                                                    instancePath: instancePath + '/incentivesDSMetadatas/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.incentivesDatasourceID !== undefined) {
                                                const _errs7 = errors;
                                                if (typeof data1.incentivesDatasourceID !== 'string') {
                                                    validate142.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/incentivesDSMetadatas/' +
                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                '/incentivesDatasourceID',
                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta/properties/incentivesDatasourceID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid3 = _errs7 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data1.pkColumns !== undefined) {
                                                    let data3 = data1.pkColumns;
                                                    const _errs9 = errors;
                                                    if (errors === _errs9) {
                                                        if (Array.isArray(data3)) {
                                                            var valid4 = true;
                                                            const len0 = data3.length;
                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                const _errs11 = errors;
                                                                if (typeof data3[i0] !== 'string') {
                                                                    validate142.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/incentivesDSMetadatas/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/pkColumns/' +
                                                                                i0,
                                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta/properties/pkColumns/items/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs11 === errors;
                                                                if (!valid4) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate142.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/incentivesDSMetadatas/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/pkColumns',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta/properties/pkColumns/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs9 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate142.errors = [
                                            {
                                                instancePath: instancePath + '/incentivesDSMetadatas/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesDatasourceMeta/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate142.errors = [
                                {
                                    instancePath: instancePath + '/incentivesDSMetadatas',
                                    schemaPath: '#/properties/incentivesDSMetadatas/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate142.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate142.errors = vErrors;
    return errors === 0;
}
export const incentivesDatasourceMetaSchemaValidation = validate143;
function validate143(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesDatasourceMeta" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.incentivesDatasourceID === undefined && (missing0 = 'incentivesDatasourceID')) {
                validate143.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.incentivesDatasourceID !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.incentivesDatasourceID !== 'string') {
                        validate143.errors = [
                            {
                                instancePath: instancePath + '/incentivesDatasourceID',
                                schemaPath: '#/properties/incentivesDatasourceID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pkColumns !== undefined) {
                        let data1 = data.pkColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs5 = errors;
                                    if (typeof data1[i0] !== 'string') {
                                        validate143.errors = [
                                            {
                                                instancePath: instancePath + '/pkColumns/' + i0,
                                                schemaPath: '#/properties/pkColumns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate143.errors = [
                                    {
                                        instancePath: instancePath + '/pkColumns',
                                        schemaPath: '#/properties/pkColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate143.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate143.errors = vErrors;
    return errors === 0;
}
export const incentivesExportConfigSchemaValidation = validate38;
export const incentivesExportValidationStateSchemaValidation = validate144;
const schema215 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesExportValidationState',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        isValid: { type: 'boolean' },
        insMatchConfig: { type: 'boolean' },
        lastValidated: { type: 'string', format: 'date-time' }
    },
    required: ['pipeID', 'elementID', 'isValid', 'lastValidated']
};
const func206 = ucs2length;
const func207 = base64urlToBuffer;
const func208 = base64urlEncode;
const func209 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func210 = ucs2length;
const func211 = base64urlToBuffer;
const func212 = base64urlEncode;
const func213 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate144(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesExportValidationState" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.isValid === undefined && (missing0 = 'isValid')) ||
                (data.lastValidated === undefined && (missing0 = 'lastValidated'))) {
                validate144.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func206(data0) < b64min0 || func206(data0) > b64max0) {
                                validate144.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func206(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func206(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func207(data0);
                                if (decoded0.length !== 10) {
                                    validate144.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func208(decoded0);
                                    if (func209(encoded0) !== func209(data0)) {
                                        validate144.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate144.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func210(data1) < b64min1 || func210(data1) > b64max1) {
                                    validate144.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func210(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func210(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func211(data1);
                                    if (decoded1.length !== 10) {
                                        validate144.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func212(decoded1);
                                        if (func213(encoded1) !== func213(data1)) {
                                            validate144.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate144.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.isValid !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.isValid !== 'boolean') {
                                validate144.errors = [
                                    {
                                        instancePath: instancePath + '/isValid',
                                        schemaPath: '#/properties/isValid/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.insMatchConfig !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.insMatchConfig !== 'boolean') {
                                    validate144.errors = [
                                        {
                                            instancePath: instancePath + '/insMatchConfig',
                                            schemaPath: '#/properties/insMatchConfig/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.lastValidated !== undefined) {
                                    let data4 = data.lastValidated;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate144.errors = [
                                                        {
                                                            instancePath: instancePath + '/lastValidated',
                                                            schemaPath: '#/properties/lastValidated/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate144.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastValidated',
                                                        schemaPath: '#/properties/lastValidated/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate144.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate144.errors = vErrors;
    return errors === 0;
}
export const incentivesExportVertexSchemaValidation = validate145;
const schema216 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesExportVertex',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        elementName: { type: 'string', minLength: 1 }
    },
    required: ['pipeID', 'elementID', 'elementName']
};
const func214 = ucs2length;
const func215 = base64urlToBuffer;
const func216 = base64urlEncode;
const func217 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func218 = ucs2length;
const func219 = base64urlToBuffer;
const func220 = base64urlEncode;
const func221 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate145(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesExportVertex" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.elementName === undefined && (missing0 = 'elementName'))) {
                validate145.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func214(data0) < b64min0 || func214(data0) > b64max0) {
                                validate145.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func214(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func214(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func215(data0);
                                if (decoded0.length !== 10) {
                                    validate145.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func216(decoded0);
                                    if (func217(encoded0) !== func217(data0)) {
                                        validate145.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate145.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func218(data1) < b64min1 || func218(data1) > b64max1) {
                                    validate145.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func218(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func218(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func219(data1);
                                    if (decoded1.length !== 10) {
                                        validate145.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func220(decoded1);
                                        if (func221(encoded1) !== func221(data1)) {
                                            validate145.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate145.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.elementName !== undefined) {
                            let data2 = data.elementName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate145.errors = [
                                            {
                                                instancePath: instancePath + '/elementName',
                                                schemaPath: '#/properties/elementName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate145.errors = [
                                        {
                                            instancePath: instancePath + '/elementName',
                                            schemaPath: '#/properties/elementName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate145.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate145.errors = vErrors;
    return errors === 0;
}
export const incentivesImportConfigByNameSchemaValidation = validate146;
const schema217 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesImportConfigByName',
    type: 'object',
    properties: { pipeName: { type: 'string' }, incentivesExportElementName: { type: 'string' } },
    required: ['pipeName', 'incentivesExportElementName']
};
function validate146(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesImportConfigByName" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeName === undefined && (missing0 = 'pipeName')) ||
                (data.incentivesExportElementName === undefined && (missing0 = 'incentivesExportElementName'))) {
                validate146.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.pipeName !== 'string') {
                        validate146.errors = [
                            {
                                instancePath: instancePath + '/pipeName',
                                schemaPath: '#/properties/pipeName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.incentivesExportElementName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.incentivesExportElementName !== 'string') {
                            validate146.errors = [
                                {
                                    instancePath: instancePath + '/incentivesExportElementName',
                                    schemaPath: '#/properties/incentivesExportElementName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate146.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate146.errors = vErrors;
    return errors === 0;
}
export const incentivesImportConfigSchemaValidation = validate147;
const schema218 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesImportConfig',
    type: 'object',
    properties: { pipeID: { type: 'string', uid: 10 }, incentivesExportElementID: { type: 'string', uid: 10 } },
    required: ['pipeID', 'incentivesExportElementID']
};
const func223 = ucs2length;
const func224 = base64urlToBuffer;
const func225 = base64urlEncode;
const func226 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func227 = ucs2length;
const func228 = base64urlToBuffer;
const func229 = base64urlEncode;
const func230 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate147(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesImportConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.incentivesExportElementID === undefined && (missing0 = 'incentivesExportElementID'))) {
                validate147.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func223(data0) < b64min0 || func223(data0) > b64max0) {
                                validate147.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func223(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func223(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func224(data0);
                                if (decoded0.length !== 10) {
                                    validate147.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func225(decoded0);
                                    if (func226(encoded0) !== func226(data0)) {
                                        validate147.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate147.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.incentivesExportElementID !== undefined) {
                        let data1 = data.incentivesExportElementID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func227(data1) < b64min1 || func227(data1) > b64max1) {
                                    validate147.errors = [
                                        {
                                            instancePath: instancePath + '/incentivesExportElementID',
                                            schemaPath: '#/properties/incentivesExportElementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func227(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func227(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func228(data1);
                                    if (decoded1.length !== 10) {
                                        validate147.errors = [
                                            {
                                                instancePath: instancePath + '/incentivesExportElementID',
                                                schemaPath: '#/properties/incentivesExportElementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func229(decoded1);
                                        if (func230(encoded1) !== func230(data1)) {
                                            validate147.errors = [
                                                {
                                                    instancePath: instancePath + '/incentivesExportElementID',
                                                    schemaPath: '#/properties/incentivesExportElementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate147.errors = [
                                    {
                                        instancePath: instancePath + '/incentivesExportElementID',
                                        schemaPath: '#/properties/incentivesExportElementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate147.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate147.errors = vErrors;
    return errors === 0;
}
export const incentivesPeriodColumnSchemaValidation = validate148;
const schema219 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesPeriodColumn',
    type: 'object',
    properties: {
        sourceColumnName: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        sourceColumnType: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' }, { type: 'string', pattern: 'date|period' }]
        },
        newColumnName: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        targetCalendarID: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:CalendarToolVariable' }, { type: 'string', minLength: 1 }]
        },
        targetPeriodLevel: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:CalendarToolVariable' }, { type: 'string', minLength: 1 }]
        }
    },
    required: ['sourceColumnName', 'sourceColumnType', 'newColumnName', 'targetCalendarID', 'targetPeriodLevel']
};
const pattern13 = new RegExp('date|period', 'u');
function validate148(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesPeriodColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.sourceColumnName === undefined && (missing0 = 'sourceColumnName')) ||
                (data.sourceColumnType === undefined && (missing0 = 'sourceColumnType')) ||
                (data.newColumnName === undefined && (missing0 = 'newColumnName')) ||
                (data.targetCalendarID === undefined && (missing0 = 'targetCalendarID')) ||
                (data.targetPeriodLevel === undefined && (missing0 = 'targetPeriodLevel'))) {
                validate148.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sourceColumnName !== undefined) {
                    let data0 = data.sourceColumnName;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/sourceColumnName',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/sourceColumnName',
                                    schemaPath: '#/properties/sourceColumnName/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/sourceColumnName',
                                        schemaPath: '#/properties/sourceColumnName/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/sourceColumnName',
                                schemaPath: '#/properties/sourceColumnName/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/sourceColumnName',
                            schemaPath: '#/properties/sourceColumnName/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate148.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.sourceColumnType !== undefined) {
                        let data1 = data.sourceColumnType;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        let passing1 = null;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                if (data1.toolEnumType !== undefined) {
                                    let data2 = data1.toolEnumType;
                                    if (typeof data2 !== 'string') {
                                        const err5 = {
                                            instancePath: instancePath + '/sourceColumnType/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err5];
                                        }
                                        else {
                                            vErrors.push(err5);
                                        }
                                        errors++;
                                    }
                                    if (!(data2 === 'SortDirection' ||
                                        data2 === 'AggregateColumnOperation' ||
                                        data2 === 'DateFrequency' ||
                                        data2 === 'DateAddType' ||
                                        data2 === 'DateAddUnit' ||
                                        data2 === 'DateUnitType' ||
                                        data2 === 'DatePartType' ||
                                        data2 === 'JoinOperator' ||
                                        data2 === 'JoinPattern' ||
                                        data2 === 'FilterStatementOp' ||
                                        data2 === 'ColumnType' ||
                                        data2 === 'PeriodAddType')) {
                                        const err6 = {
                                            instancePath: instancePath + '/sourceColumnType/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err7 = {
                                    instancePath: instancePath + '/sourceColumnType',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        if (_valid1) {
                            valid3 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (errors === _errs15) {
                            if (typeof data1 === 'string') {
                                if (!pattern13.test(data1)) {
                                    const err8 = {
                                        instancePath: instancePath + '/sourceColumnType',
                                        schemaPath: '#/properties/sourceColumnType/oneOf/1/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: 'date|period' },
                                        message: 'must match pattern "' + 'date|period' + '"'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err8];
                                    }
                                    else {
                                        vErrors.push(err8);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err9 = {
                                    instancePath: instancePath + '/sourceColumnType',
                                    schemaPath: '#/properties/sourceColumnType/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid3) {
                            valid3 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid3 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid3) {
                            const err10 = {
                                instancePath: instancePath + '/sourceColumnType',
                                schemaPath: '#/properties/sourceColumnType/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                            validate148.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.newColumnName !== undefined) {
                            let data3 = data.newColumnName;
                            const _errs17 = errors;
                            const _errs18 = errors;
                            let valid6 = false;
                            let passing2 = null;
                            const _errs19 = errors;
                            const _errs20 = errors;
                            if (errors === _errs20) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err11 = {
                                        instancePath: instancePath + '/newColumnName',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err11];
                                    }
                                    else {
                                        vErrors.push(err11);
                                    }
                                    errors++;
                                }
                            }
                            var _valid2 = _errs19 === errors;
                            if (_valid2) {
                                valid6 = true;
                                passing2 = 0;
                            }
                            const _errs22 = errors;
                            if (errors === _errs22) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 150) {
                                        const err12 = {
                                            instancePath: instancePath + '/newColumnName',
                                            schemaPath: '#/properties/newColumnName/oneOf/1/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err12];
                                        }
                                        else {
                                            vErrors.push(err12);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (func2(data3) < 1) {
                                            const err13 = {
                                                instancePath: instancePath + '/newColumnName',
                                                schemaPath: '#/properties/newColumnName/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err13];
                                            }
                                            else {
                                                vErrors.push(err13);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err14 = {
                                        instancePath: instancePath + '/newColumnName',
                                        schemaPath: '#/properties/newColumnName/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                }
                            }
                            var _valid2 = _errs22 === errors;
                            if (_valid2 && valid6) {
                                valid6 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid2) {
                                    valid6 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid6) {
                                const err15 = {
                                    instancePath: instancePath + '/newColumnName',
                                    schemaPath: '#/properties/newColumnName/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                                validate148.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs18;
                                if (vErrors !== null) {
                                    if (_errs18) {
                                        vErrors.length = _errs18;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs17 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.targetCalendarID !== undefined) {
                                let data4 = data.targetCalendarID;
                                const _errs24 = errors;
                                const _errs25 = errors;
                                let valid8 = false;
                                let passing3 = null;
                                const _errs26 = errors;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                        const err16 = {
                                            instancePath: instancePath + '/targetCalendarID',
                                            schemaPath: 'urn:wisepipe-base-pipe:CalendarToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err16];
                                        }
                                        else {
                                            vErrors.push(err16);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid3 = _errs26 === errors;
                                if (_valid3) {
                                    valid8 = true;
                                    passing3 = 0;
                                }
                                const _errs29 = errors;
                                if (errors === _errs29) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            const err17 = {
                                                instancePath: instancePath + '/targetCalendarID',
                                                schemaPath: '#/properties/targetCalendarID/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err17];
                                            }
                                            else {
                                                vErrors.push(err17);
                                            }
                                            errors++;
                                        }
                                    }
                                    else {
                                        const err18 = {
                                            instancePath: instancePath + '/targetCalendarID',
                                            schemaPath: '#/properties/targetCalendarID/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err18];
                                        }
                                        else {
                                            vErrors.push(err18);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid3 = _errs29 === errors;
                                if (_valid3 && valid8) {
                                    valid8 = false;
                                    passing3 = [passing3, 1];
                                }
                                else {
                                    if (_valid3) {
                                        valid8 = true;
                                        passing3 = 1;
                                    }
                                }
                                if (!valid8) {
                                    const err19 = {
                                        instancePath: instancePath + '/targetCalendarID',
                                        schemaPath: '#/properties/targetCalendarID/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing3 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err19];
                                    }
                                    else {
                                        vErrors.push(err19);
                                    }
                                    errors++;
                                    validate148.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs25;
                                    if (vErrors !== null) {
                                        if (_errs25) {
                                            vErrors.length = _errs25;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs24 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.targetPeriodLevel !== undefined) {
                                    let data5 = data.targetPeriodLevel;
                                    const _errs31 = errors;
                                    const _errs32 = errors;
                                    let valid10 = false;
                                    let passing4 = null;
                                    const _errs33 = errors;
                                    const _errs34 = errors;
                                    if (errors === _errs34) {
                                        if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                            const err20 = {
                                                instancePath: instancePath + '/targetPeriodLevel',
                                                schemaPath: 'urn:wisepipe-base-pipe:CalendarToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err20];
                                            }
                                            else {
                                                vErrors.push(err20);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid4 = _errs33 === errors;
                                    if (_valid4) {
                                        valid10 = true;
                                        passing4 = 0;
                                    }
                                    const _errs36 = errors;
                                    if (errors === _errs36) {
                                        if (typeof data5 === 'string') {
                                            if (func2(data5) < 1) {
                                                const err21 = {
                                                    instancePath: instancePath + '/targetPeriodLevel',
                                                    schemaPath: '#/properties/targetPeriodLevel/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err21];
                                                }
                                                else {
                                                    vErrors.push(err21);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err22 = {
                                                instancePath: instancePath + '/targetPeriodLevel',
                                                schemaPath: '#/properties/targetPeriodLevel/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err22];
                                            }
                                            else {
                                                vErrors.push(err22);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid4 = _errs36 === errors;
                                    if (_valid4 && valid10) {
                                        valid10 = false;
                                        passing4 = [passing4, 1];
                                    }
                                    else {
                                        if (_valid4) {
                                            valid10 = true;
                                            passing4 = 1;
                                        }
                                    }
                                    if (!valid10) {
                                        const err23 = {
                                            instancePath: instancePath + '/targetPeriodLevel',
                                            schemaPath: '#/properties/targetPeriodLevel/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing4 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                        validate148.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs32;
                                        if (vErrors !== null) {
                                            if (_errs32) {
                                                vErrors.length = _errs32;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid0 = _errs31 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate148.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate148.errors = vErrors;
    return errors === 0;
}
export const incentivesPeriodConfigSchemaValidation = validate149;
const schema225 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesPeriodConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:IncentivesPeriodColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['newColumnName']
        }
    },
    required: ['columns']
};
const func237 = ajvEqual;
function validate149(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesPeriodConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate149.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate149.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate149.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs3 = errors;
                                        if (!validate148(data0[i0], {
                                            instancePath: instancePath + '/columns/' + i0,
                                            parentData: data0,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate148.errors : vErrors.concat(validate148.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema225.properties.columns.uniqueItemProperties;
                                        let k0;
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data0.length; i1--;) {
                                                    let x0 = data0[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data0[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func237(x0[key0], y0[key0])) {
                                                            validate149.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns',
                                                                    schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate149.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate149.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate149.errors = vErrors;
    return errors === 0;
}
export const incentivesTableConfigSchemaValidation = validate151;
const schema226 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesTableConfig',
    type: 'object',
    properties: { incentivesDataSourceID: { type: 'string' } },
    required: ['incentivesDataSourceID']
};
function validate151(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesTableConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.incentivesDataSourceID === undefined && (missing0 = 'incentivesDataSourceID')) {
                validate151.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.incentivesDataSourceID !== undefined) {
                    if (typeof data.incentivesDataSourceID !== 'string') {
                        validate151.errors = [
                            {
                                instancePath: instancePath + '/incentivesDataSourceID',
                                schemaPath: '#/properties/incentivesDataSourceID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate151.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate151.errors = vErrors;
    return errors === 0;
}
export const incentivesTableVertexSchemaValidation = validate152;
const schema227 = {
    $id: 'urn:wisepipe-common-pipe:IncentivesTableVertex',
    type: 'object',
    properties: { incentivesDSID: { type: 'string', minLength: 1 } },
    required: ['incentivesDSID']
};
function validate152(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IncentivesTableVertex" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.incentivesDSID === undefined && (missing0 = 'incentivesDSID')) {
                validate152.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.incentivesDSID !== undefined) {
                    let data0 = data.incentivesDSID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate152.errors = [
                                    {
                                        instancePath: instancePath + '/incentivesDSID',
                                        schemaPath: '#/properties/incentivesDSID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate152.errors = [
                                {
                                    instancePath: instancePath + '/incentivesDSID',
                                    schemaPath: '#/properties/incentivesDSID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate152.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate152.errors = vErrors;
    return errors === 0;
}
export const integrationElementEventSchemaValidation = validate153;
const schema228 = {
    $id: 'urn:wisepipe-common-pipe:IntegrationElementEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        eventType: { type: 'string', enum: ['insert', 'modify', 'remove'] },
        integrationType: { type: 'string', enum: ['incentives'] },
        oldToolConfig: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
        newToolConfig: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
        oldToolName: { type: 'string' },
        newToolName: { type: 'string' }
    },
    required: ['orgID', 'pipeID', 'elementID', 'eventType', 'integrationType']
};
const func241 = ucs2length;
const func242 = base64urlToBuffer;
const func243 = base64urlEncode;
const func244 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func245 = ucs2length;
const func246 = base64urlToBuffer;
const func247 = base64urlEncode;
const func248 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate153(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IntegrationElementEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.eventType === undefined && (missing0 = 'eventType')) ||
                (data.integrationType === undefined && (missing0 = 'integrationType'))) {
                validate153.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 128) {
                                validate153.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate153.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate153.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pipeID !== undefined) {
                        let data1 = data.pipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func241(data1) < b64min0 || func241(data1) > b64max0) {
                                    validate153.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func241(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func241(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func242(data1);
                                    if (decoded0.length !== 10) {
                                        validate153.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func243(decoded0);
                                        if (func244(encoded0) !== func244(data1)) {
                                            validate153.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate153.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.elementID !== undefined) {
                            let data2 = data.elementID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func245(data2) < b64min1 || func245(data2) > b64max1) {
                                        validate153.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func245(data2) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func245(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded1 = func246(data2);
                                        if (decoded1.length !== 10) {
                                            validate153.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded1 = func247(decoded1);
                                            if (func248(encoded1) !== func248(data2)) {
                                                validate153.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate153.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.eventType !== undefined) {
                                let data3 = data.eventType;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate153.errors = [
                                        {
                                            instancePath: instancePath + '/eventType',
                                            schemaPath: '#/properties/eventType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'insert' || data3 === 'modify' || data3 === 'remove')) {
                                    validate153.errors = [
                                        {
                                            instancePath: instancePath + '/eventType',
                                            schemaPath: '#/properties/eventType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema228.properties.eventType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.integrationType !== undefined) {
                                    let data4 = data.integrationType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate153.errors = [
                                            {
                                                instancePath: instancePath + '/integrationType',
                                                schemaPath: '#/properties/integrationType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'incentives')) {
                                        validate153.errors = [
                                            {
                                                instancePath: instancePath + '/integrationType',
                                                schemaPath: '#/properties/integrationType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema228.properties.integrationType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.oldToolConfig !== undefined) {
                                        const _errs11 = errors;
                                        if (!validate131(data.oldToolConfig, {
                                            instancePath: instancePath + '/oldToolConfig',
                                            parentData: data,
                                            parentDataProperty: 'oldToolConfig',
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.newToolConfig !== undefined) {
                                            const _errs12 = errors;
                                            if (!validate131(data.newToolConfig, {
                                                instancePath: instancePath + '/newToolConfig',
                                                parentData: data,
                                                parentDataProperty: 'newToolConfig',
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid0 = _errs12 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.oldToolName !== undefined) {
                                                const _errs13 = errors;
                                                if (typeof data.oldToolName !== 'string') {
                                                    validate153.errors = [
                                                        {
                                                            instancePath: instancePath + '/oldToolName',
                                                            schemaPath: '#/properties/oldToolName/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs13 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.newToolName !== undefined) {
                                                    const _errs15 = errors;
                                                    if (typeof data.newToolName !== 'string') {
                                                        validate153.errors = [
                                                            {
                                                                instancePath: instancePath + '/newToolName',
                                                                schemaPath: '#/properties/newToolName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs15 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate153.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate153.errors = vErrors;
    return errors === 0;
}
export const integrationNodeValidationEventSchemaValidation = validate156;
const schema229 = {
    $id: 'urn:wisepipe-common-pipe:IntegrationNodeValidationEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        newValidationState: { $ref: 'urn:wisepipe-common-pipe:IncentivesExportValidationState' }
    },
    required: ['orgID', 'newValidationState']
};
const func251 = ucs2length;
const func252 = base64urlToBuffer;
const func253 = base64urlEncode;
const func254 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func255 = ucs2length;
const func256 = base64urlToBuffer;
const func257 = base64urlEncode;
const func258 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate156(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IntegrationNodeValidationEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.newValidationState === undefined && (missing0 = 'newValidationState'))) {
                validate156.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 128) {
                                validate156.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 128 },
                                        message: 'must NOT have more than 128 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate156.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate156.errors = [
                                {
                                    instancePath: instancePath + '/orgID',
                                    schemaPath: '#/properties/orgID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newValidationState !== undefined) {
                        let data1 = data.newValidationState;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if ((data1.pipeID === undefined && (missing1 = 'pipeID')) ||
                                    (data1.elementID === undefined && (missing1 = 'elementID')) ||
                                    (data1.isValid === undefined && (missing1 = 'isValid')) ||
                                    (data1.lastValidated === undefined && (missing1 = 'lastValidated'))) {
                                    validate156.errors = [
                                        {
                                            instancePath: instancePath + '/newValidationState',
                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.pipeID !== undefined) {
                                        let data2 = data1.pipeID;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                const b64min0 = Math.ceil((4 * 10) / 3);
                                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                                if (func251(data2) < b64min0 || func251(data2) > b64max0) {
                                                    validate156.errors = [
                                                        {
                                                            instancePath: instancePath + '/newValidationState/pipeID',
                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/pipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func251(data2) },
                                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func251(data2)
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const decoded0 = func252(data2);
                                                    if (decoded0.length !== 10) {
                                                        validate156.errors = [
                                                            {
                                                                instancePath: instancePath + '/newValidationState/pipeID',
                                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/pipeID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'decoded' },
                                                                message: 'must decode to 10 bytes'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const encoded0 = func253(decoded0);
                                                        if (func254(encoded0) !== func254(data2)) {
                                                            validate156.errors = [
                                                                {
                                                                    instancePath: instancePath + '/newValidationState/pipeID',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/pipeID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'ambiguous' },
                                                                    message: 'encoding is ambiguous'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate156.errors = [
                                                    {
                                                        instancePath: instancePath + '/newValidationState/pipeID',
                                                        schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/pipeID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data1.elementID !== undefined) {
                                            let data3 = data1.elementID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                                    if (func255(data3) < b64min1 || func255(data3) > b64max1) {
                                                        validate156.errors = [
                                                            {
                                                                instancePath: instancePath + '/newValidationState/elementID',
                                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/elementID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func255(data3) },
                                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func255(data3)
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        const decoded1 = func256(data3);
                                                        if (decoded1.length !== 10) {
                                                            validate156.errors = [
                                                                {
                                                                    instancePath: instancePath + '/newValidationState/elementID',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/elementID/uid',
                                                                    keyword: 'uid',
                                                                    params: { error: 'decoded' },
                                                                    message: 'must decode to 10 bytes'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const encoded1 = func257(decoded1);
                                                            if (func258(encoded1) !== func258(data3)) {
                                                                validate156.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/newValidationState/elementID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/elementID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'ambiguous' },
                                                                        message: 'encoding is ambiguous'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate156.errors = [
                                                        {
                                                            instancePath: instancePath + '/newValidationState/elementID',
                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/elementID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data1.isValid !== undefined) {
                                                const _errs10 = errors;
                                                if (typeof data1.isValid !== 'boolean') {
                                                    validate156.errors = [
                                                        {
                                                            instancePath: instancePath + '/newValidationState/isValid',
                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/isValid/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data1.insMatchConfig !== undefined) {
                                                    const _errs12 = errors;
                                                    if (typeof data1.insMatchConfig !== 'boolean') {
                                                        validate156.errors = [
                                                            {
                                                                instancePath: instancePath + '/newValidationState/insMatchConfig',
                                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/insMatchConfig/type',
                                                                keyword: 'type',
                                                                params: { type: 'boolean' },
                                                                message: 'must be boolean'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data1.lastValidated !== undefined) {
                                                        let data6 = data1.lastValidated;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (errors === _errs14) {
                                                                if (typeof data6 === 'string') {
                                                                    if (!formats0.validate(data6)) {
                                                                        validate156.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/newValidationState/lastValidated',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/lastValidated/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate156.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/newValidationState/lastValidated',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/properties/lastValidated/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate156.errors = [
                                    {
                                        instancePath: instancePath + '/newValidationState',
                                        schemaPath: 'urn:wisepipe-common-pipe:IncentivesExportValidationState/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate156.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate156.errors = vErrors;
    return errors === 0;
}
export const iqrOutlierConfigSchemaValidation = validate157;
const schema231 = { $id: 'urn:wisepipe-common-pipe:IqrOutlierConfig', type: 'object', properties: {}, required: [] };
function validate157(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IqrOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate157.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate157.errors = vErrors;
    return errors === 0;
}
export const isolationForestOutlierConfigSchemaValidation = validate158;
const schema232 = {
    $id: 'urn:wisepipe-common-pipe:IsolationForestOutlierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate158(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:IsolationForestOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate158.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate158.errors = vErrors;
    return errors === 0;
}
export const joinColumnsSchemaValidation = validate159;
const schema233 = {
    $id: 'urn:wisepipe-common-pipe:JoinColumns',
    type: 'object',
    properties: { leftColumn: { type: 'string' }, rightColumn: { type: 'string' } },
    required: ['leftColumn', 'rightColumn']
};
function validate159(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:JoinColumns" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.leftColumn === undefined && (missing0 = 'leftColumn')) ||
                (data.rightColumn === undefined && (missing0 = 'rightColumn'))) {
                validate159.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.leftColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.leftColumn !== 'string') {
                        validate159.errors = [
                            {
                                instancePath: instancePath + '/leftColumn',
                                schemaPath: '#/properties/leftColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rightColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.rightColumn !== 'string') {
                            validate159.errors = [
                                {
                                    instancePath: instancePath + '/rightColumn',
                                    schemaPath: '#/properties/rightColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate159.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate159.errors = vErrors;
    return errors === 0;
}
export const joinConfigSchemaValidation = validate160;
const schema234 = {
    $id: 'urn:wisepipe-common-pipe:JoinConfig',
    type: 'object',
    properties: {
        joinType: { type: 'string', enum: ['left', 'right', 'inner', 'anti', 'outer'] },
        joins: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:AdvancedJoinColumns' }, minItems: 1 },
        caseInsensitive: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:BoolToolVariable' }, { type: 'boolean' }] }
    },
    required: ['joinType', 'joins']
};
function validate160(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:JoinConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.joinType === undefined && (missing0 = 'joinType')) ||
                (data.joins === undefined && (missing0 = 'joins'))) {
                validate160.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.joinType !== undefined) {
                    let data0 = data.joinType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate160.errors = [
                            {
                                instancePath: instancePath + '/joinType',
                                schemaPath: '#/properties/joinType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'left' || data0 === 'right' || data0 === 'inner' || data0 === 'anti' || data0 === 'outer')) {
                        validate160.errors = [
                            {
                                instancePath: instancePath + '/joinType',
                                schemaPath: '#/properties/joinType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema234.properties.joinType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.joins !== undefined) {
                        let data1 = data.joins;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate160.errors = [
                                        {
                                            instancePath: instancePath + '/joins',
                                            schemaPath: '#/properties/joins/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs5 = errors;
                                        if (!validate15(data1[i0], {
                                            instancePath: instancePath + '/joins/' + i0,
                                            parentData: data1,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate15.errors : vErrors.concat(validate15.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                            }
                            else {
                                validate160.errors = [
                                    {
                                        instancePath: instancePath + '/joins',
                                        schemaPath: '#/properties/joins/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.caseInsensitive !== undefined) {
                            let data3 = data.caseInsensitive;
                            const _errs6 = errors;
                            const _errs7 = errors;
                            let valid2 = false;
                            let passing0 = null;
                            const _errs8 = errors;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err0 = {
                                        instancePath: instancePath + '/caseInsensitive',
                                        schemaPath: 'urn:wisepipe-base-pipe:BoolToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                            }
                            var _valid0 = _errs8 === errors;
                            if (_valid0) {
                                valid2 = true;
                                passing0 = 0;
                            }
                            const _errs11 = errors;
                            if (typeof data3 !== 'boolean') {
                                const err1 = {
                                    instancePath: instancePath + '/caseInsensitive',
                                    schemaPath: '#/properties/caseInsensitive/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            var _valid0 = _errs11 === errors;
                            if (_valid0 && valid2) {
                                valid2 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid0) {
                                    valid2 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid2) {
                                const err2 = {
                                    instancePath: instancePath + '/caseInsensitive',
                                    schemaPath: '#/properties/caseInsensitive/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                                validate160.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs7;
                                if (vErrors !== null) {
                                    if (_errs7) {
                                        vErrors.length = _errs7;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate160.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate160.errors = vErrors;
    return errors === 0;
}
export const joinV2ConfigSchemaValidation = validate162;
const schema236 = {
    $id: 'urn:wisepipe-common-pipe:JoinV2Config',
    type: 'object',
    properties: {
        joinType: { type: 'string', enum: ['left', 'right', 'inner', 'anti', 'outer'] },
        joins: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:AdvancedJoinColumns' }, minItems: 1 },
        caseInsensitive: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:BoolToolVariable' }, { type: 'boolean' }] }
    },
    required: ['joinType', 'joins']
};
function validate162(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:JoinV2Config" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.joinType === undefined && (missing0 = 'joinType')) ||
                (data.joins === undefined && (missing0 = 'joins'))) {
                validate162.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.joinType !== undefined) {
                    let data0 = data.joinType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate162.errors = [
                            {
                                instancePath: instancePath + '/joinType',
                                schemaPath: '#/properties/joinType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'left' || data0 === 'right' || data0 === 'inner' || data0 === 'anti' || data0 === 'outer')) {
                        validate162.errors = [
                            {
                                instancePath: instancePath + '/joinType',
                                schemaPath: '#/properties/joinType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema236.properties.joinType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.joins !== undefined) {
                        let data1 = data.joins;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate162.errors = [
                                        {
                                            instancePath: instancePath + '/joins',
                                            schemaPath: '#/properties/joins/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs5 = errors;
                                        if (!validate15(data1[i0], {
                                            instancePath: instancePath + '/joins/' + i0,
                                            parentData: data1,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate15.errors : vErrors.concat(validate15.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                            }
                            else {
                                validate162.errors = [
                                    {
                                        instancePath: instancePath + '/joins',
                                        schemaPath: '#/properties/joins/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.caseInsensitive !== undefined) {
                            let data3 = data.caseInsensitive;
                            const _errs6 = errors;
                            const _errs7 = errors;
                            let valid2 = false;
                            let passing0 = null;
                            const _errs8 = errors;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err0 = {
                                        instancePath: instancePath + '/caseInsensitive',
                                        schemaPath: 'urn:wisepipe-base-pipe:BoolToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                            }
                            var _valid0 = _errs8 === errors;
                            if (_valid0) {
                                valid2 = true;
                                passing0 = 0;
                            }
                            const _errs11 = errors;
                            if (typeof data3 !== 'boolean') {
                                const err1 = {
                                    instancePath: instancePath + '/caseInsensitive',
                                    schemaPath: '#/properties/caseInsensitive/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            var _valid0 = _errs11 === errors;
                            if (_valid0 && valid2) {
                                valid2 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid0) {
                                    valid2 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid2) {
                                const err2 = {
                                    instancePath: instancePath + '/caseInsensitive',
                                    schemaPath: '#/properties/caseInsensitive/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                                validate162.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs7;
                                if (vErrors !== null) {
                                    if (_errs7) {
                                        vErrors.length = _errs7;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate162.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate162.errors = vErrors;
    return errors === 0;
}
export const kNeighborsClassifierConfigSchemaValidation = validate164;
const schema238 = {
    $id: 'urn:wisepipe-common-pipe:KNeighborsClassifierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate164(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:KNeighborsClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate164.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate164.errors = vErrors;
    return errors === 0;
}
export const kNeighborsOutlierConfigSchemaValidation = validate165;
const schema239 = {
    $id: 'urn:wisepipe-common-pipe:KNeighborsOutlierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate165(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:KNeighborsOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate165.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate165.errors = vErrors;
    return errors === 0;
}
export const kNeighborsRegressorConfigSchemaValidation = validate166;
const schema240 = {
    $id: 'urn:wisepipe-common-pipe:KNeighborsRegressorConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate166(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:KNeighborsRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate166.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate166.errors = vErrors;
    return errors === 0;
}
export const lagAggregateColumnSchemaValidation = validate167;
const schema241 = {
    $id: 'urn:wisepipe-common-pipe:LagAggregateColumn',
    type: 'object',
    properties: { lag: { type: 'integer' } },
    required: ['lag']
};
function validate167(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LagAggregateColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.lag === undefined && (missing0 = 'lag')) {
                validate167.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lag !== undefined) {
                    let data0 = data.lag;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate167.errors = [
                            {
                                instancePath: instancePath + '/lag',
                                schemaPath: '#/properties/lag/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate167.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate167.errors = vErrors;
    return errors === 0;
}
export const lagConfigSchemaValidation = validate168;
const schema242 = {
    $id: 'urn:wisepipe-common-pipe:LagConfig',
    type: 'object',
    properties: {
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        dateColumn: { type: 'string', minLength: 1 },
        frequency: { type: 'string', enum: ['yearly', 'quarterly', 'monthly', 'weekly', 'daily'] },
        lagAggregateColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:LagAggregateColumn' },
            uniqueItemProperties: ['alias']
        },
        inclusive: { type: 'boolean' }
    },
    required: ['groupByColumns', 'dateColumn', 'frequency', 'lagAggregateColumns', 'inclusive']
};
const func260 = ajvEqual;
function validate168(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LagConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.groupByColumns === undefined && (missing0 = 'groupByColumns')) ||
                (data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.frequency === undefined && (missing0 = 'frequency')) ||
                (data.lagAggregateColumns === undefined && (missing0 = 'lagAggregateColumns')) ||
                (data.inclusive === undefined && (missing0 = 'inclusive'))) {
                validate168.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.groupByColumns !== undefined) {
                    let data0 = data.groupByColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (typeof data0[i0] !== 'string') {
                                    validate168.errors = [
                                        {
                                            instancePath: instancePath + '/groupByColumns/' + i0,
                                            schemaPath: '#/properties/groupByColumns/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    const indices0 = {};
                                    for (; i1--;) {
                                        let item0 = data0[i1];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j0 = indices0[item0];
                                            validate168.errors = [
                                                {
                                                    instancePath: instancePath + '/groupByColumns',
                                                    schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                }
                                            ];
                                            return false;
                                            break;
                                        }
                                        indices0[item0] = i1;
                                    }
                                }
                            }
                        }
                        else {
                            validate168.errors = [
                                {
                                    instancePath: instancePath + '/groupByColumns',
                                    schemaPath: '#/properties/groupByColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dateColumn !== undefined) {
                        let data2 = data.dateColumn;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate168.errors = [
                                        {
                                            instancePath: instancePath + '/dateColumn',
                                            schemaPath: '#/properties/dateColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate168.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.frequency !== undefined) {
                            let data3 = data.frequency;
                            const _errs7 = errors;
                            if (typeof data3 !== 'string') {
                                validate168.errors = [
                                    {
                                        instancePath: instancePath + '/frequency',
                                        schemaPath: '#/properties/frequency/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'yearly' ||
                                data3 === 'quarterly' ||
                                data3 === 'monthly' ||
                                data3 === 'weekly' ||
                                data3 === 'daily')) {
                                validate168.errors = [
                                    {
                                        instancePath: instancePath + '/frequency',
                                        schemaPath: '#/properties/frequency/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema242.properties.frequency.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.lagAggregateColumns !== undefined) {
                                let data4 = data.lagAggregateColumns;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid3 = true;
                                        const len1 = data4.length;
                                        for (let i2 = 0; i2 < len1; i2++) {
                                            let data5 = data4[i2];
                                            const _errs11 = errors;
                                            const _errs12 = errors;
                                            if (errors === _errs12) {
                                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                    let missing1;
                                                    if (data5.lag === undefined && (missing1 = 'lag')) {
                                                        validate168.errors = [
                                                            {
                                                                instancePath: instancePath + '/lagAggregateColumns/' + i2,
                                                                schemaPath: 'urn:wisepipe-common-pipe:LagAggregateColumn/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing1 },
                                                                message: "must have required property '" + missing1 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data5.lag !== undefined) {
                                                            let data6 = data5.lag;
                                                            if (!(typeof data6 == 'number' && !(data6 % 1) && !isNaN(data6))) {
                                                                validate168.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/lagAggregateColumns/' + i2 + '/lag',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:LagAggregateColumn/properties/lag/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'integer' },
                                                                        message: 'must be integer'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate168.errors = [
                                                        {
                                                            instancePath: instancePath + '/lagAggregateColumns/' + i2,
                                                            schemaPath: 'urn:wisepipe-common-pipe:LagAggregateColumn/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs11 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                        if (valid3) {
                                            const keys0 = schema242.properties.lagAggregateColumns.uniqueItemProperties;
                                            let k0;
                                            let i3 = data4.length;
                                            let j1;
                                            if (i3 > 1) {
                                                outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                    let key0 = keys0[k0];
                                                    for (i3 = data4.length; i3--;) {
                                                        let x0 = data4[i3];
                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                            continue;
                                                        }
                                                        for (j1 = i3; j1--;) {
                                                            let y0 = data4[j1];
                                                            if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func260(x0[key0], y0[key0])) {
                                                                validate168.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/lagAggregateColumns',
                                                                        schemaPath: '#/properties/lagAggregateColumns/uniqueItemProperties',
                                                                        keyword: 'uniqueItemProperties',
                                                                        params: {},
                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate168.errors = [
                                            {
                                                instancePath: instancePath + '/lagAggregateColumns',
                                                schemaPath: '#/properties/lagAggregateColumns/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.inclusive !== undefined) {
                                    const _errs16 = errors;
                                    if (typeof data.inclusive !== 'boolean') {
                                        validate168.errors = [
                                            {
                                                instancePath: instancePath + '/inclusive',
                                                schemaPath: '#/properties/inclusive/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs16 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate168.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate168.errors = vErrors;
    return errors === 0;
}
export const lgbmClassifierConfigSchemaValidation = validate169;
const schema244 = {
    $id: 'urn:wisepipe-common-pipe:LgbmClassifierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate169(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LgbmClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate169.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate169.errors = vErrors;
    return errors === 0;
}
export const lgbmRegressorConfigSchemaValidation = validate170;
const schema245 = { $id: 'urn:wisepipe-common-pipe:LgbmRegressorConfig', type: 'object', properties: {}, required: [] };
function validate170(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LgbmRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate170.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate170.errors = vErrors;
    return errors === 0;
}
export const limitConfigSchemaValidation = validate171;
const schema246 = {
    $id: 'urn:wisepipe-common-pipe:LimitConfig',
    type: 'object',
    properties: { limit: { type: 'number', minimum: 1 } },
    required: ['limit']
};
function validate171(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LimitConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.limit === undefined && (missing0 = 'limit')) {
                validate171.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.limit !== undefined) {
                    let data0 = data.limit;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 1 || isNaN(data0)) {
                                validate171.errors = [
                                    {
                                        instancePath: instancePath + '/limit',
                                        schemaPath: '#/properties/limit/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 1 },
                                        message: 'must be >= 1'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate171.errors = [
                                {
                                    instancePath: instancePath + '/limit',
                                    schemaPath: '#/properties/limit/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate171.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate171.errors = vErrors;
    return errors === 0;
}
export const lineageTaskSchemaValidation = validate172;
const schema247 = {
    $id: 'urn:wisepipe-common-pipe:LineageTask',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        taskType: { type: 'string', enum: ['regen-subgraph', 'remove-pipe-vertex'] }
    },
    required: ['orgID', 'pipeID', 'taskType']
};
const func261 = ucs2length;
const func262 = base64urlToBuffer;
const func263 = base64urlEncode;
const func264 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate172(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LineageTask" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.taskType === undefined && (missing0 = 'taskType'))) {
                validate172.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate172.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate172.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pipeID !== undefined) {
                        let data1 = data.pipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func261(data1) < b64min0 || func261(data1) > b64max0) {
                                    validate172.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func261(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func261(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func262(data1);
                                    if (decoded0.length !== 10) {
                                        validate172.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func263(decoded0);
                                        if (func264(encoded0) !== func264(data1)) {
                                            validate172.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate172.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taskType !== undefined) {
                            let data2 = data.taskType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate172.errors = [
                                    {
                                        instancePath: instancePath + '/taskType',
                                        schemaPath: '#/properties/taskType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'regen-subgraph' || data2 === 'remove-pipe-vertex')) {
                                validate172.errors = [
                                    {
                                        instancePath: instancePath + '/taskType',
                                        schemaPath: '#/properties/taskType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema247.properties.taskType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate172.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate172.errors = vErrors;
    return errors === 0;
}
export const lineageVertexSchemaValidation = validate173;
function validate173(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LineageVertex" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.vertexID === undefined && (missing0 = 'vertexID')) ||
                (data.vertexType === undefined && (missing0 = 'vertexType'))) {
                validate173.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.vertexID !== undefined) {
                    let data0 = data.vertexID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate173.errors = [
                                    {
                                        instancePath: instancePath + '/vertexID',
                                        schemaPath: '#/properties/vertexID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate173.errors = [
                                {
                                    instancePath: instancePath + '/vertexID',
                                    schemaPath: '#/properties/vertexID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.vertexType !== undefined) {
                        let data1 = data.vertexType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate173.errors = [
                                {
                                    instancePath: instancePath + '/vertexType',
                                    schemaPath: '#/properties/vertexType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'incentives-table' || data1 === 'incentives-export')) {
                            validate173.errors = [
                                {
                                    instancePath: instancePath + '/vertexType',
                                    schemaPath: '#/properties/vertexType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema202.properties.vertexType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate173.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate173.errors = vErrors;
    return errors === 0;
}
export const lineageViewSchemaValidation = validate174;
const schema249 = {
    $id: 'urn:wisepipe-common-pipe:LineageView',
    type: 'object',
    properties: {
        forwards: { $ref: 'urn:wisepipe-common-pipe:LineageViewVertex' },
        backwards: { $ref: 'urn:wisepipe-common-pipe:LineageViewVertex' }
    },
    required: []
};
const schema250 = {
    $id: 'urn:wisepipe-common-pipe:LineageViewVertex',
    type: 'object',
    properties: {
        vertex: { $ref: 'urn:wisepipe-common-pipe:LineageVertex' },
        children: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:LineageViewVertex' } }
    },
    required: ['vertex', 'children']
};
const wrapper0 = { validate: validate175 };
function validate175(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LineageViewVertex" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.vertex === undefined && (missing0 = 'vertex')) ||
                (data.children === undefined && (missing0 = 'children'))) {
                validate175.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.vertex !== undefined) {
                    let data0 = data.vertex;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.vertexID === undefined && (missing1 = 'vertexID')) ||
                                (data0.vertexType === undefined && (missing1 = 'vertexType'))) {
                                validate175.errors = [
                                    {
                                        instancePath: instancePath + '/vertex',
                                        schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.vertexID !== undefined) {
                                    let data1 = data0.vertexID;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate175.errors = [
                                                    {
                                                        instancePath: instancePath + '/vertex/vertexID',
                                                        schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate175.errors = [
                                                {
                                                    instancePath: instancePath + '/vertex/vertexID',
                                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.vertexType !== undefined) {
                                        let data2 = data0.vertexType;
                                        const _errs6 = errors;
                                        if (typeof data2 !== 'string') {
                                            validate175.errors = [
                                                {
                                                    instancePath: instancePath + '/vertex/vertexType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data2 === 'incentives-table' || data2 === 'incentives-export')) {
                                            validate175.errors = [
                                                {
                                                    instancePath: instancePath + '/vertex/vertexType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/properties/vertexType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema202.properties.vertexType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate175.errors = [
                                {
                                    instancePath: instancePath + '/vertex',
                                    schemaPath: 'urn:wisepipe-common-pipe:LineageVertex/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.children !== undefined) {
                        let data3 = data.children;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (Array.isArray(data3)) {
                                var valid3 = true;
                                const len0 = data3.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs10 = errors;
                                    if (!wrapper0.validate(data3[i0], {
                                        instancePath: instancePath + '/children/' + i0,
                                        parentData: data3,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? wrapper0.validate.errors : vErrors.concat(wrapper0.validate.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid3 = _errs10 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate175.errors = [
                                    {
                                        instancePath: instancePath + '/children',
                                        schemaPath: '#/properties/children/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate175.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate175.errors = vErrors;
    return errors === 0;
}
function validate174(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LineageView" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.forwards !== undefined) {
                const _errs1 = errors;
                if (!validate175(data.forwards, {
                    instancePath: instancePath + '/forwards',
                    parentData: data,
                    parentDataProperty: 'forwards',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
                    errors = vErrors.length;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.backwards !== undefined) {
                    const _errs2 = errors;
                    if (!validate175(data.backwards, {
                        instancePath: instancePath + '/backwards',
                        parentData: data,
                        parentDataProperty: 'backwards',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs2 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate174.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate174.errors = vErrors;
    return errors === 0;
}
export const lineageViewVertexSchemaValidation = validate175;
export const linearRegressionForecastConfigSchemaValidation = validate178;
const schema252 = {
    $id: 'urn:wisepipe-common-pipe:LinearRegressionForecastConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate178(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LinearRegressionForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate178.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate178.errors = vErrors;
    return errors === 0;
}
export const linearRegressionTrainConfigSchemaValidation = validate179;
const schema253 = {
    $id: 'urn:wisepipe-common-pipe:LinearRegressionTrainConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate179(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LinearRegressionTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate179.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate179.errors = vErrors;
    return errors === 0;
}
export const logisticRegressionTrainConfigSchemaValidation = validate180;
const schema254 = {
    $id: 'urn:wisepipe-common-pipe:LogisticRegressionTrainConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate180(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LogisticRegressionTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate180.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate180.errors = vErrors;
    return errors === 0;
}
export const lookupConfigSchemaValidation = validate181;
const schema255 = {
    $id: 'urn:wisepipe-common-pipe:LookupConfig',
    type: 'object',
    properties: {
        leftColumn: { type: 'string' },
        rightColumn: { type: 'string' },
        addToTopColumns: { type: 'array', items: { type: 'string' } }
    },
    required: ['leftColumn', 'rightColumn', 'addToTopColumns']
};
function validate181(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:LookupConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.leftColumn === undefined && (missing0 = 'leftColumn')) ||
                (data.rightColumn === undefined && (missing0 = 'rightColumn')) ||
                (data.addToTopColumns === undefined && (missing0 = 'addToTopColumns'))) {
                validate181.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.leftColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.leftColumn !== 'string') {
                        validate181.errors = [
                            {
                                instancePath: instancePath + '/leftColumn',
                                schemaPath: '#/properties/leftColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rightColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.rightColumn !== 'string') {
                            validate181.errors = [
                                {
                                    instancePath: instancePath + '/rightColumn',
                                    schemaPath: '#/properties/rightColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.addToTopColumns !== undefined) {
                            let data2 = data.addToTopColumns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (typeof data2[i0] !== 'string') {
                                            validate181.errors = [
                                                {
                                                    instancePath: instancePath + '/addToTopColumns/' + i0,
                                                    schemaPath: '#/properties/addToTopColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate181.errors = [
                                        {
                                            instancePath: instancePath + '/addToTopColumns',
                                            schemaPath: '#/properties/addToTopColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate181.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate181.errors = vErrors;
    return errors === 0;
}
export const mergeColumnsConfigSchemaValidation = validate182;
const schema256 = {
    $id: 'urn:wisepipe-common-pipe:MergeColumnsConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        },
        newColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['columns']
};
function validate182(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MergeColumnsConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate182.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate182.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate182.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        const _errs4 = errors;
                                        let valid2 = false;
                                        let passing0 = null;
                                        const _errs5 = errors;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                                const err0 = {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err0];
                                                }
                                                else {
                                                    vErrors.push(err0);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs5 === errors;
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 0;
                                        }
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (typeof data1 === 'string') {
                                                if (func2(data1) > 150) {
                                                    const err1 = {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/oneOf/1/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err1];
                                                    }
                                                    else {
                                                        vErrors.push(err1);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    if (func2(data1) < 1) {
                                                        const err2 = {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/oneOf/1/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err2];
                                                        }
                                                        else {
                                                            vErrors.push(err2);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err3 = {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/oneOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err3];
                                                }
                                                else {
                                                    vErrors.push(err3);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs8 === errors;
                                        if (_valid0 && valid2) {
                                            valid2 = false;
                                            passing0 = [passing0, 1];
                                        }
                                        else {
                                            if (_valid0) {
                                                valid2 = true;
                                                passing0 = 1;
                                            }
                                        }
                                        if (!valid2) {
                                            const err4 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing0 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                            validate182.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs4;
                                            if (vErrors !== null) {
                                                if (_errs4) {
                                                    vErrors.length = _errs4;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (; i1--;) {
                                                for (j0 = i1; j0--;) {
                                                    if (func0(data0[i1], data0[j0])) {
                                                        validate182.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns',
                                                                schemaPath: '#/properties/columns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate182.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newColumn !== undefined) {
                        let data2 = data.newColumn;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        let valid5 = false;
                        let passing1 = null;
                        const _errs12 = errors;
                        const _errs13 = errors;
                        if (errors === _errs13) {
                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                const err5 = {
                                    instancePath: instancePath + '/newColumn',
                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs12 === errors;
                        if (_valid1) {
                            valid5 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (errors === _errs15) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) > 150) {
                                    const err6 = {
                                        instancePath: instancePath + '/newColumn',
                                        schemaPath: '#/properties/newColumn/oneOf/1/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err6];
                                    }
                                    else {
                                        vErrors.push(err6);
                                    }
                                    errors++;
                                }
                                else {
                                    if (func2(data2) < 1) {
                                        const err7 = {
                                            instancePath: instancePath + '/newColumn',
                                            schemaPath: '#/properties/newColumn/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err8 = {
                                    instancePath: instancePath + '/newColumn',
                                    schemaPath: '#/properties/newColumn/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid5) {
                            valid5 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid5 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid5) {
                            const err9 = {
                                instancePath: instancePath + '/newColumn',
                                schemaPath: '#/properties/newColumn/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                            validate182.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs11;
                            if (vErrors !== null) {
                                if (_errs11) {
                                    vErrors.length = _errs11;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate182.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate182.errors = vErrors;
    return errors === 0;
}
export const minMaxScalerConfigSchemaValidation = validate183;
const schema259 = {
    $id: 'urn:wisepipe-common-pipe:MinMaxScalerConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            maxItems: 1000,
            uniqueItems: true
        },
        min: { type: 'number', exclusiveMaximum: { $data: '1/max' } },
        max: { type: 'number', exclusiveMinimum: { $data: '1/min' } }
    },
    required: ['columns']
};
function validate183(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MinMaxScalerConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate183.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate183.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate183.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate183.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate183.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate183.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate183.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.min !== undefined) {
                        let data2 = data.min;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 == 'number') {
                                const vSchema0 = data && data.max;
                                if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data2 >= vSchema0 || isNaN(data2))) {
                                    validate183.errors = [
                                        {
                                            instancePath: instancePath + '/min',
                                            schemaPath: '#/properties/min/exclusiveMaximum',
                                            keyword: 'exclusiveMaximum',
                                            params: { comparison: '<', limit: vSchema0 },
                                            message: 'must be < ' + vSchema0
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate183.errors = [
                                    {
                                        instancePath: instancePath + '/min',
                                        schemaPath: '#/properties/min/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.max !== undefined) {
                            let data3 = data.max;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 == 'number') {
                                    const vSchema1 = data && data.min;
                                    if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data3 <= vSchema1 || isNaN(data3))) {
                                        validate183.errors = [
                                            {
                                                instancePath: instancePath + '/max',
                                                schemaPath: '#/properties/max/exclusiveMinimum',
                                                keyword: 'exclusiveMinimum',
                                                params: { comparison: '>', limit: vSchema1 },
                                                message: 'must be > ' + vSchema1
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate183.errors = [
                                        {
                                            instancePath: instancePath + '/max',
                                            schemaPath: '#/properties/max/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate183.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate183.errors = vErrors;
    return errors === 0;
}
export const mlpRegressorConfigSchemaValidation = validate184;
const schema260 = { $id: 'urn:wisepipe-common-pipe:MlpRegressorConfig', type: 'object', properties: {}, required: [] };
function validate184(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MlpRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate184.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate184.errors = vErrors;
    return errors === 0;
}
export const monteCarloAssumptionSchemaValidation = validate185;
const schema261 = {
    $id: 'urn:wisepipe-common-pipe:MonteCarloAssumption',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        assumptionType: { type: 'string', enum: ['learned', 'data_distribution'] },
        constraint: { $ref: 'urn:wisepipe-common-pipe:MonteCarloConstraint' }
    },
    required: ['name', 'assumptionType']
};
const schema262 = {
    $id: 'urn:wisepipe-common-pipe:MonteCarloConstraint',
    type: 'object',
    properties: { min: { type: 'number' }, max: { type: 'number' } },
    required: []
};
function validate185(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MonteCarloAssumption" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.assumptionType === undefined && (missing0 = 'assumptionType'))) {
                validate185.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate185.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate185.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.assumptionType !== undefined) {
                        let data1 = data.assumptionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate185.errors = [
                                {
                                    instancePath: instancePath + '/assumptionType',
                                    schemaPath: '#/properties/assumptionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'learned' || data1 === 'data_distribution')) {
                            validate185.errors = [
                                {
                                    instancePath: instancePath + '/assumptionType',
                                    schemaPath: '#/properties/assumptionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema261.properties.assumptionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.constraint !== undefined) {
                            let data2 = data.constraint;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    if (data2.min !== undefined) {
                                        const _errs8 = errors;
                                        if (!(typeof data2.min == 'number')) {
                                            validate185.errors = [
                                                {
                                                    instancePath: instancePath + '/constraint/min',
                                                    schemaPath: 'urn:wisepipe-common-pipe:MonteCarloConstraint/properties/min/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs8 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data2.max !== undefined) {
                                            const _errs10 = errors;
                                            if (!(typeof data2.max == 'number')) {
                                                validate185.errors = [
                                                    {
                                                        instancePath: instancePath + '/constraint/max',
                                                        schemaPath: 'urn:wisepipe-common-pipe:MonteCarloConstraint/properties/max/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs10 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                                else {
                                    validate185.errors = [
                                        {
                                            instancePath: instancePath + '/constraint',
                                            schemaPath: 'urn:wisepipe-common-pipe:MonteCarloConstraint/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate185.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate185.errors = vErrors;
    return errors === 0;
}
export const monteCarloConfigSchemaValidation = validate186;
const schema263 = {
    $id: 'urn:wisepipe-common-pipe:MonteCarloConfig',
    type: 'object',
    properties: {
        scenarios: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:MonteCarloScenario' }, minItems: 1 },
        numberSimulations: { type: 'number', minimum: 1, maximum: 1000000 },
        numberInstances: { type: 'number', minimum: 0, maximum: 100000 }
    },
    required: ['scenarios', 'numberSimulations', 'numberInstances']
};
const schema264 = {
    $id: 'urn:wisepipe-common-pipe:MonteCarloScenario',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        assumptions: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:MonteCarloAssumption' }, minItems: 1 },
        outputs: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:MultiFormulaColumn' }, minItems: 0 }
    },
    required: ['name', 'assumptions', 'outputs']
};
const schema265 = {
    $id: 'urn:wisepipe-common-pipe:MultiFormulaColumn',
    type: 'object',
    properties: {
        column: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        formula: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:CompoundToolVariable' }, { type: 'string', minLength: 1 }] },
        columnToReplace: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['column', 'formula']
};
function validate189(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiFormulaColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.column === undefined && (missing0 = 'column')) ||
                (data.formula === undefined && (missing0 = 'formula'))) {
                validate189.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data0 = data.column;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/column',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/column',
                                    schemaPath: '#/properties/column/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/column',
                                schemaPath: '#/properties/column/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate189.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.formula !== undefined) {
                        let data1 = data.formula;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        let passing1 = null;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if (data1.value === undefined && (missing1 = 'value')) {
                                    const err5 = {
                                        instancePath: instancePath + '/formula',
                                        schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                                else {
                                    if (data1.value !== undefined) {
                                        if (typeof data1.value !== 'string') {
                                            const err6 = {
                                                instancePath: instancePath + '/formula/value',
                                                schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/properties/value/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            }
                                            else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                            }
                            else {
                                const err7 = {
                                    instancePath: instancePath + '/formula',
                                    schemaPath: 'urn:wisepipe-base-pipe:CompoundToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        if (_valid1) {
                            valid3 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (errors === _errs15) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    const err8 = {
                                        instancePath: instancePath + '/formula',
                                        schemaPath: '#/properties/formula/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err8];
                                    }
                                    else {
                                        vErrors.push(err8);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err9 = {
                                    instancePath: instancePath + '/formula',
                                    schemaPath: '#/properties/formula/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid3) {
                            valid3 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid3 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid3) {
                            const err10 = {
                                instancePath: instancePath + '/formula',
                                schemaPath: '#/properties/formula/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                            validate189.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columnToReplace !== undefined) {
                            let data3 = data.columnToReplace;
                            const _errs17 = errors;
                            const _errs18 = errors;
                            let valid6 = false;
                            let passing2 = null;
                            const _errs19 = errors;
                            const _errs20 = errors;
                            if (errors === _errs20) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err11 = {
                                        instancePath: instancePath + '/columnToReplace',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err11];
                                    }
                                    else {
                                        vErrors.push(err11);
                                    }
                                    errors++;
                                }
                            }
                            var _valid2 = _errs19 === errors;
                            if (_valid2) {
                                valid6 = true;
                                passing2 = 0;
                            }
                            const _errs22 = errors;
                            if (errors === _errs22) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 150) {
                                        const err12 = {
                                            instancePath: instancePath + '/columnToReplace',
                                            schemaPath: '#/properties/columnToReplace/oneOf/1/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err12];
                                        }
                                        else {
                                            vErrors.push(err12);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (func2(data3) < 1) {
                                            const err13 = {
                                                instancePath: instancePath + '/columnToReplace',
                                                schemaPath: '#/properties/columnToReplace/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err13];
                                            }
                                            else {
                                                vErrors.push(err13);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err14 = {
                                        instancePath: instancePath + '/columnToReplace',
                                        schemaPath: '#/properties/columnToReplace/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                }
                            }
                            var _valid2 = _errs22 === errors;
                            if (_valid2 && valid6) {
                                valid6 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid2) {
                                    valid6 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid6) {
                                const err15 = {
                                    instancePath: instancePath + '/columnToReplace',
                                    schemaPath: '#/properties/columnToReplace/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                                validate189.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs18;
                                if (vErrors !== null) {
                                    if (_errs18) {
                                        vErrors.length = _errs18;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs17 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate189.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate189.errors = vErrors;
    return errors === 0;
}
function validate187(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MonteCarloScenario" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.assumptions === undefined && (missing0 = 'assumptions')) ||
                (data.outputs === undefined && (missing0 = 'outputs'))) {
                validate187.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate187.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate187.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.assumptions !== undefined) {
                        let data1 = data.assumptions;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate187.errors = [
                                        {
                                            instancePath: instancePath + '/assumptions',
                                            schemaPath: '#/properties/assumptions/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs5 = errors;
                                        if (!validate185(data1[i0], {
                                            instancePath: instancePath + '/assumptions/' + i0,
                                            parentData: data1,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate185.errors : vErrors.concat(validate185.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                            }
                            else {
                                validate187.errors = [
                                    {
                                        instancePath: instancePath + '/assumptions',
                                        schemaPath: '#/properties/assumptions/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.outputs !== undefined) {
                            let data3 = data.outputs;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (Array.isArray(data3)) {
                                    if (data3.length < 0) {
                                        validate187.errors = [
                                            {
                                                instancePath: instancePath + '/outputs',
                                                schemaPath: '#/properties/outputs/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 0 },
                                                message: 'must NOT have fewer than 0 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid2 = true;
                                        const len1 = data3.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            const _errs8 = errors;
                                            if (!validate189(data3[i1], {
                                                instancePath: instancePath + '/outputs/' + i1,
                                                parentData: data3,
                                                parentDataProperty: i1,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate189.errors : vErrors.concat(validate189.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid2 = _errs8 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate187.errors = [
                                        {
                                            instancePath: instancePath + '/outputs',
                                            schemaPath: '#/properties/outputs/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate187.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate187.errors = vErrors;
    return errors === 0;
}
function validate186(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MonteCarloConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.scenarios === undefined && (missing0 = 'scenarios')) ||
                (data.numberSimulations === undefined && (missing0 = 'numberSimulations')) ||
                (data.numberInstances === undefined && (missing0 = 'numberInstances'))) {
                validate186.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.scenarios !== undefined) {
                    let data0 = data.scenarios;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate186.errors = [
                                    {
                                        instancePath: instancePath + '/scenarios',
                                        schemaPath: '#/properties/scenarios/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs3 = errors;
                                    if (!validate187(data0[i0], {
                                        instancePath: instancePath + '/scenarios/' + i0,
                                        parentData: data0,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate187.errors : vErrors.concat(validate187.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            validate186.errors = [
                                {
                                    instancePath: instancePath + '/scenarios',
                                    schemaPath: '#/properties/scenarios/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.numberSimulations !== undefined) {
                        let data2 = data.numberSimulations;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (typeof data2 == 'number') {
                                if (data2 > 1000000 || isNaN(data2)) {
                                    validate186.errors = [
                                        {
                                            instancePath: instancePath + '/numberSimulations',
                                            schemaPath: '#/properties/numberSimulations/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1000000 },
                                            message: 'must be <= 1000000'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2 < 1 || isNaN(data2)) {
                                        validate186.errors = [
                                            {
                                                instancePath: instancePath + '/numberSimulations',
                                                schemaPath: '#/properties/numberSimulations/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 1 },
                                                message: 'must be >= 1'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate186.errors = [
                                    {
                                        instancePath: instancePath + '/numberSimulations',
                                        schemaPath: '#/properties/numberSimulations/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.numberInstances !== undefined) {
                            let data3 = data.numberInstances;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (typeof data3 == 'number') {
                                    if (data3 > 100000 || isNaN(data3)) {
                                        validate186.errors = [
                                            {
                                                instancePath: instancePath + '/numberInstances',
                                                schemaPath: '#/properties/numberInstances/maximum',
                                                keyword: 'maximum',
                                                params: { comparison: '<=', limit: 100000 },
                                                message: 'must be <= 100000'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data3 < 0 || isNaN(data3)) {
                                            validate186.errors = [
                                                {
                                                    instancePath: instancePath + '/numberInstances',
                                                    schemaPath: '#/properties/numberInstances/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate186.errors = [
                                        {
                                            instancePath: instancePath + '/numberInstances',
                                            schemaPath: '#/properties/numberInstances/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs6 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate186.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate186.errors = vErrors;
    return errors === 0;
}
export const monteCarloConstraintSchemaValidation = validate192;
function validate192(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MonteCarloConstraint" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.min !== undefined) {
                const _errs1 = errors;
                if (!(typeof data.min == 'number')) {
                    validate192.errors = [
                        {
                            instancePath: instancePath + '/min',
                            schemaPath: '#/properties/min/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number'
                        }
                    ];
                    return false;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.max !== undefined) {
                    const _errs3 = errors;
                    if (!(typeof data.max == 'number')) {
                        validate192.errors = [
                            {
                                instancePath: instancePath + '/max',
                                schemaPath: '#/properties/max/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate192.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate192.errors = vErrors;
    return errors === 0;
}
export const monteCarloDataDistAssumptionSchemaValidation = validate193;
const schema270 = {
    $id: 'urn:wisepipe-common-pipe:MonteCarloDataDistAssumption',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        dataDistribution: { $ref: 'urn:wisepipe-common-pipe:DataDistribution' }
    },
    required: ['name', 'dataDistribution']
};
function validate193(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MonteCarloDataDistAssumption" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.dataDistribution === undefined && (missing0 = 'dataDistribution'))) {
                validate193.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate193.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate193.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dataDistribution !== undefined) {
                        let data1 = data.dataDistribution;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if (data1.type === undefined && (missing1 = 'type')) {
                                    validate193.errors = [
                                        {
                                            instancePath: instancePath + '/dataDistribution',
                                            schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.type !== undefined) {
                                        let data2 = data1.type;
                                        if (typeof data2 !== 'string') {
                                            validate193.errors = [
                                                {
                                                    instancePath: instancePath + '/dataDistribution/type',
                                                    schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/properties/type/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data2 === 'normal' ||
                                            data2 === 'triangular' ||
                                            data2 === 'uniform' ||
                                            data2 === 'weibull' ||
                                            data2 === 'poisson' ||
                                            data2 === 'binomial')) {
                                            validate193.errors = [
                                                {
                                                    instancePath: instancePath + '/dataDistribution/type',
                                                    schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/properties/type/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema119.properties.type.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate193.errors = [
                                    {
                                        instancePath: instancePath + '/dataDistribution',
                                        schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate193.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate193.errors = vErrors;
    return errors === 0;
}
export const monteCarloLearnedAssumptionSchemaValidation = validate194;
const schema272 = {
    $id: 'urn:wisepipe-common-pipe:MonteCarloLearnedAssumption',
    type: 'object',
    properties: { name: { type: 'string', minLength: 1 }, column: { type: 'string' } },
    required: ['column']
};
function validate194(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MonteCarloLearnedAssumption" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.column === undefined && (missing0 = 'column')) {
                validate194.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate194.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate194.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.column !== 'string') {
                            validate194.errors = [
                                {
                                    instancePath: instancePath + '/column',
                                    schemaPath: '#/properties/column/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate194.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate194.errors = vErrors;
    return errors === 0;
}
export const monteCarloScenarioSchemaValidation = validate187;
export const mostCommonConfigSchemaValidation = validate195;
const schema273 = {
    $id: 'urn:wisepipe-common-pipe:MostCommonConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        values: { type: 'integer', minimum: 1 },
        other: { type: 'string' }
    },
    required: ['columns', 'values']
};
function validate195(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MostCommonConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.values === undefined && (missing0 = 'values'))) {
                validate195.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate195.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate195.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate195.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate195.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate195.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate195.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.values !== undefined) {
                        let data2 = data.values;
                        const _errs5 = errors;
                        if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                            validate195.errors = [
                                {
                                    instancePath: instancePath + '/values',
                                    schemaPath: '#/properties/values/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs5) {
                            if (typeof data2 == 'number') {
                                if (data2 < 1 || isNaN(data2)) {
                                    validate195.errors = [
                                        {
                                            instancePath: instancePath + '/values',
                                            schemaPath: '#/properties/values/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.other !== undefined) {
                            const _errs7 = errors;
                            if (typeof data.other !== 'string') {
                                validate195.errors = [
                                    {
                                        instancePath: instancePath + '/other',
                                        schemaPath: '#/properties/other/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate195.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate195.errors = vErrors;
    return errors === 0;
}
export const movingAverageForecastConfigSchemaValidation = validate196;
const schema274 = {
    $id: 'urn:wisepipe-common-pipe:MovingAverageForecastConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumn: { type: 'string', minLength: 1 },
        alias: { type: 'string', minLength: 1 },
        window: { type: 'integer', minimum: 3 },
        periods: { type: 'integer', minimum: 1 },
        frequency: { type: 'string', enum: ['D', 'W-MON', 'MS', 'AS-JAN', 'QS-', 'BEST_GUESS'] },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['dateColumn', 'valueColumn', 'alias', 'window', 'periods']
};
function validate196(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MovingAverageForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn')) ||
                (data.alias === undefined && (missing0 = 'alias')) ||
                (data.window === undefined && (missing0 = 'window')) ||
                (data.periods === undefined && (missing0 = 'periods'))) {
                validate196.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate196.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate196.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.valueColumn !== undefined) {
                        let data1 = data.valueColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate196.errors = [
                                        {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate196.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.alias !== undefined) {
                            let data2 = data.alias;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate196.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate196.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.window !== undefined) {
                                let data3 = data.window;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    validate196.errors = [
                                        {
                                            instancePath: instancePath + '/window',
                                            schemaPath: '#/properties/window/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 3 || isNaN(data3)) {
                                            validate196.errors = [
                                                {
                                                    instancePath: instancePath + '/window',
                                                    schemaPath: '#/properties/window/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 3 },
                                                    message: 'must be >= 3'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.periods !== undefined) {
                                    let data4 = data.periods;
                                    const _errs9 = errors;
                                    if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                        validate196.errors = [
                                            {
                                                instancePath: instancePath + '/periods',
                                                schemaPath: '#/properties/periods/type',
                                                keyword: 'type',
                                                params: { type: 'integer' },
                                                message: 'must be integer'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (errors === _errs9) {
                                        if (typeof data4 == 'number') {
                                            if (data4 < 1 || isNaN(data4)) {
                                                validate196.errors = [
                                                    {
                                                        instancePath: instancePath + '/periods',
                                                        schemaPath: '#/properties/periods/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 1 },
                                                        message: 'must be >= 1'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.frequency !== undefined) {
                                        let data5 = data.frequency;
                                        const _errs11 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate196.errors = [
                                                {
                                                    instancePath: instancePath + '/frequency',
                                                    schemaPath: '#/properties/frequency/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'D' ||
                                            data5 === 'W-MON' ||
                                            data5 === 'MS' ||
                                            data5 === 'AS-JAN' ||
                                            data5 === 'QS-' ||
                                            data5 === 'BEST_GUESS')) {
                                            validate196.errors = [
                                                {
                                                    instancePath: instancePath + '/frequency',
                                                    schemaPath: '#/properties/frequency/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema274.properties.frequency.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.groupByColumns !== undefined) {
                                            let data6 = data.groupByColumns;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (Array.isArray(data6)) {
                                                    var valid1 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        const _errs15 = errors;
                                                        if (typeof data6[i0] !== 'string') {
                                                            validate196.errors = [
                                                                {
                                                                    instancePath: instancePath + '/groupByColumns/' + i0,
                                                                    schemaPath: '#/properties/groupByColumns/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid1 = _errs15 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                    if (valid1) {
                                                        let i1 = data6.length;
                                                        let j0;
                                                        if (i1 > 1) {
                                                            const indices0 = {};
                                                            for (; i1--;) {
                                                                let item0 = data6[i1];
                                                                if (typeof item0 !== 'string') {
                                                                    continue;
                                                                }
                                                                if (typeof indices0[item0] == 'number') {
                                                                    j0 = indices0[item0];
                                                                    validate196.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/groupByColumns',
                                                                            schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                            keyword: 'uniqueItems',
                                                                            params: { i: i1, j: j0 },
                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                j0 +
                                                                                ' and ' +
                                                                                i1 +
                                                                                ' are identical)'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                    break;
                                                                }
                                                                indices0[item0] = i1;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate196.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupByColumns',
                                                            schemaPath: '#/properties/groupByColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate196.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate196.errors = vErrors;
    return errors === 0;
}
export const multiFormulaColumnSchemaValidation = validate189;
export const multiFormulaConfigSchemaValidation = validate197;
const schema275 = {
    $id: 'urn:wisepipe-common-pipe:MultiFormulaConfig',
    type: 'object',
    properties: {
        multiFormulaColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:MultiFormulaColumn' },
            uniqueItemProperties: ['column']
        }
    },
    required: ['multiFormulaColumns']
};
const func288 = ajvEqual;
function validate197(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiFormulaConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.multiFormulaColumns === undefined && (missing0 = 'multiFormulaColumns')) {
                validate197.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.multiFormulaColumns !== undefined) {
                    let data0 = data.multiFormulaColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate189(data0[i0], {
                                    instancePath: instancePath + '/multiFormulaColumns/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate189.errors : vErrors.concat(validate189.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                const keys0 = schema275.properties.multiFormulaColumns.uniqueItemProperties;
                                let k0;
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                        let key0 = keys0[k0];
                                        for (i1 = data0.length; i1--;) {
                                            let x0 = data0[i1];
                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                continue;
                                            }
                                            for (j0 = i1; j0--;) {
                                                let y0 = data0[j0];
                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func288(x0[key0], y0[key0])) {
                                                    validate197.errors = [
                                                        {
                                                            instancePath: instancePath + '/multiFormulaColumns',
                                                            schemaPath: '#/properties/multiFormulaColumns/uniqueItemProperties',
                                                            keyword: 'uniqueItemProperties',
                                                            params: {},
                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate197.errors = [
                                {
                                    instancePath: instancePath + '/multiFormulaColumns',
                                    schemaPath: '#/properties/multiFormulaColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate197.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate197.errors = vErrors;
    return errors === 0;
}
export const multiObjectiveGaalOutlierConfigSchemaValidation = validate199;
const schema276 = {
    $id: 'urn:wisepipe-common-pipe:MultiObjectiveGaalOutlierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate199(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiObjectiveGaalOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate199.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate199.errors = vErrors;
    return errors === 0;
}
export const multiPortPipeConfigSchemaValidation = validate200;
const schema277 = {
    $id: 'urn:wisepipe-common-pipe:MultiPortPipeConfig',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        inputMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:MultiPortPipeInput' } },
        outputMap: { type: 'object', additionalProperties: { type: 'string' } }
    },
    required: ['pipeID', 'inputMap', 'outputMap']
};
const func289 = ucs2length;
const func290 = base64urlToBuffer;
const func291 = base64urlEncode;
const func292 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema278 = {
    $id: 'urn:wisepipe-common-pipe:MultiPortPipeInput',
    type: 'object',
    properties: {
        columnMappings: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:MultiPortPipeInputColumn' } },
        port: { type: 'string', minLength: 1 },
        previousPipeToolOutputPort: { type: 'string', minLength: 1 }
    },
    required: ['columnMappings', 'port']
};
const schema279 = {
    $id: 'urn:wisepipe-common-pipe:MultiPortPipeInputColumn',
    type: 'object',
    properties: { dependantColumnName: { type: 'string' }, dependeeColumnName: { type: 'string' } },
    required: ['dependeeColumnName']
};
function validate201(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiPortPipeInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnMappings === undefined && (missing0 = 'columnMappings')) ||
                (data.port === undefined && (missing0 = 'port'))) {
                validate201.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnMappings !== undefined) {
                    let data0 = data.columnMappings;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if (data1.dependeeColumnName === undefined && (missing1 = 'dependeeColumnName')) {
                                            validate201.errors = [
                                                {
                                                    instancePath: instancePath + '/columnMappings/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:MultiPortPipeInputColumn/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.dependantColumnName !== undefined) {
                                                const _errs6 = errors;
                                                if (typeof data1.dependantColumnName !== 'string') {
                                                    validate201.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnMappings/' + i0 + '/dependantColumnName',
                                                            schemaPath: 'urn:wisepipe-common-pipe:MultiPortPipeInputColumn/properties/dependantColumnName/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid3 = _errs6 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data1.dependeeColumnName !== undefined) {
                                                    const _errs8 = errors;
                                                    if (typeof data1.dependeeColumnName !== 'string') {
                                                        validate201.errors = [
                                                            {
                                                                instancePath: instancePath + '/columnMappings/' + i0 + '/dependeeColumnName',
                                                                schemaPath: 'urn:wisepipe-common-pipe:MultiPortPipeInputColumn/properties/dependeeColumnName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate201.errors = [
                                            {
                                                instancePath: instancePath + '/columnMappings/' + i0,
                                                schemaPath: 'urn:wisepipe-common-pipe:MultiPortPipeInputColumn/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate201.errors = [
                                {
                                    instancePath: instancePath + '/columnMappings',
                                    schemaPath: '#/properties/columnMappings/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data4 = data.port;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                            if (typeof data4 === 'string') {
                                if (func2(data4) < 1) {
                                    validate201.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate201.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.previousPipeToolOutputPort !== undefined) {
                            let data5 = data.previousPipeToolOutputPort;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (typeof data5 === 'string') {
                                    if (func2(data5) < 1) {
                                        validate201.errors = [
                                            {
                                                instancePath: instancePath + '/previousPipeToolOutputPort',
                                                schemaPath: '#/properties/previousPipeToolOutputPort/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate201.errors = [
                                        {
                                            instancePath: instancePath + '/previousPipeToolOutputPort',
                                            schemaPath: '#/properties/previousPipeToolOutputPort/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate201.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate201.errors = vErrors;
    return errors === 0;
}
function validate200(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiPortPipeConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.inputMap === undefined && (missing0 = 'inputMap')) ||
                (data.outputMap === undefined && (missing0 = 'outputMap'))) {
                validate200.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func289(data0) < b64min0 || func289(data0) > b64max0) {
                                validate200.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func289(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func289(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func290(data0);
                                if (decoded0.length !== 10) {
                                    validate200.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func291(decoded0);
                                    if (func292(encoded0) !== func292(data0)) {
                                        validate200.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate200.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.inputMap !== undefined) {
                        let data1 = data.inputMap;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    const _errs6 = errors;
                                    if (!validate201(data1[key0], {
                                        instancePath: instancePath + '/inputMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                        parentData: data1,
                                        parentDataProperty: key0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate201.errors : vErrors.concat(validate201.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate200.errors = [
                                    {
                                        instancePath: instancePath + '/inputMap',
                                        schemaPath: '#/properties/inputMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.outputMap !== undefined) {
                            let data3 = data.outputMap;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                    for (const key1 in data3) {
                                        const _errs10 = errors;
                                        if (typeof data3[key1] !== 'string') {
                                            validate200.errors = [
                                                {
                                                    instancePath: instancePath + '/outputMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/outputMap/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs10 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate200.errors = [
                                        {
                                            instancePath: instancePath + '/outputMap',
                                            schemaPath: '#/properties/outputMap/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate200.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate200.errors = vErrors;
    return errors === 0;
}
export const multiPortPipeInputColumnSchemaValidation = validate203;
function validate203(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiPortPipeInputColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.dependeeColumnName === undefined && (missing0 = 'dependeeColumnName')) {
                validate203.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dependantColumnName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.dependantColumnName !== 'string') {
                        validate203.errors = [
                            {
                                instancePath: instancePath + '/dependantColumnName',
                                schemaPath: '#/properties/dependantColumnName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dependeeColumnName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.dependeeColumnName !== 'string') {
                            validate203.errors = [
                                {
                                    instancePath: instancePath + '/dependeeColumnName',
                                    schemaPath: '#/properties/dependeeColumnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate203.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate203.errors = vErrors;
    return errors === 0;
}
export const multiPortPipeInputSchemaValidation = validate201;
export const multiReplaceConfigSchemaValidation = validate204;
const schema281 = {
    $id: 'urn:wisepipe-common-pipe:MultiReplaceConfig',
    type: 'object',
    properties: {
        replaceConditions: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:ReplaceCondition' }, minItems: 1 }
    },
    required: ['replaceConditions']
};
const schema282 = {
    $id: 'urn:wisepipe-common-pipe:ReplaceCondition',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        searchType: { type: 'string', enum: ['startsWith', 'endsWith', 'exactMatch', 'every', 'regex'] },
        searchFor: { type: 'string', minLength: 1 },
        replaceWith: { type: 'string', minLength: 1 },
        ignoreCase: { type: 'boolean' },
        matchWord: { type: 'boolean' },
        name: { type: 'string', minLength: 1 }
    },
    required: ['columns', 'searchType', 'searchFor', 'ignoreCase', 'matchWord']
};
function validate204(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiReplaceConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.replaceConditions === undefined && (missing0 = 'replaceConditions')) {
                validate204.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.replaceConditions !== undefined) {
                    let data0 = data.replaceConditions;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate204.errors = [
                                    {
                                        instancePath: instancePath + '/replaceConditions',
                                        schemaPath: '#/properties/replaceConditions/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                            let missing1;
                                            if ((data1.columns === undefined && (missing1 = 'columns')) ||
                                                (data1.searchType === undefined && (missing1 = 'searchType')) ||
                                                (data1.searchFor === undefined && (missing1 = 'searchFor')) ||
                                                (data1.ignoreCase === undefined && (missing1 = 'ignoreCase')) ||
                                                (data1.matchWord === undefined && (missing1 = 'matchWord'))) {
                                                validate204.errors = [
                                                    {
                                                        instancePath: instancePath + '/replaceConditions/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data1.columns !== undefined) {
                                                    let data2 = data1.columns;
                                                    const _errs6 = errors;
                                                    if (errors === _errs6) {
                                                        if (Array.isArray(data2)) {
                                                            if (data2.length > 1000) {
                                                                validate204.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/replaceConditions/' + i0 + '/columns',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/columns/maxItems',
                                                                        keyword: 'maxItems',
                                                                        params: { limit: 1000 },
                                                                        message: 'must NOT have more than 1000 items'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                                const len1 = data2.length;
                                                                for (let i1 = 0; i1 < len1; i1++) {
                                                                    let data3 = data2[i1];
                                                                    const _errs8 = errors;
                                                                    if (errors === _errs8) {
                                                                        if (typeof data3 === 'string') {
                                                                            if (func2(data3) > 150) {
                                                                                validate204.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/replaceConditions/' + i0 + '/columns/' + i1,
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/columns/items/maxLength',
                                                                                        keyword: 'maxLength',
                                                                                        params: { limit: 150 },
                                                                                        message: 'must NOT have more than 150 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (func2(data3) < 1) {
                                                                                    validate204.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/replaceConditions/' + i0 + '/columns/' + i1,
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/columns/items/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate204.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/replaceConditions/' + i0 + '/columns/' + i1,
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/columns/items/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid4 = _errs8 === errors;
                                                                    if (!valid4) {
                                                                        break;
                                                                    }
                                                                }
                                                                if (valid4) {
                                                                    let i2 = data2.length;
                                                                    let j0;
                                                                    if (i2 > 1) {
                                                                        const indices0 = {};
                                                                        for (; i2--;) {
                                                                            let item0 = data2[i2];
                                                                            if (typeof item0 !== 'string') {
                                                                                continue;
                                                                            }
                                                                            if (typeof indices0[item0] == 'number') {
                                                                                j0 = indices0[item0];
                                                                                validate204.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/replaceConditions/' + i0 + '/columns',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/columns/uniqueItems',
                                                                                        keyword: 'uniqueItems',
                                                                                        params: { i: i2, j: j0 },
                                                                                        message: 'must NOT have duplicate items (items ## ' +
                                                                                            j0 +
                                                                                            ' and ' +
                                                                                            i2 +
                                                                                            ' are identical)'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                                break;
                                                                            }
                                                                            indices0[item0] = i2;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate204.errors = [
                                                                {
                                                                    instancePath: instancePath + '/replaceConditions/' + i0 + '/columns',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/columns/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs6 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.searchType !== undefined) {
                                                        let data4 = data1.searchType;
                                                        const _errs10 = errors;
                                                        if (typeof data4 !== 'string') {
                                                            validate204.errors = [
                                                                {
                                                                    instancePath: instancePath + '/replaceConditions/' + i0 + '/searchType',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/searchType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data4 === 'startsWith' ||
                                                            data4 === 'endsWith' ||
                                                            data4 === 'exactMatch' ||
                                                            data4 === 'every' ||
                                                            data4 === 'regex')) {
                                                            validate204.errors = [
                                                                {
                                                                    instancePath: instancePath + '/replaceConditions/' + i0 + '/searchType',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/searchType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema282.properties.searchType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.searchFor !== undefined) {
                                                            let data5 = data1.searchFor;
                                                            const _errs12 = errors;
                                                            if (errors === _errs12) {
                                                                if (typeof data5 === 'string') {
                                                                    if (func2(data5) < 1) {
                                                                        validate204.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/replaceConditions/' + i0 + '/searchFor',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/searchFor/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate204.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/replaceConditions/' + i0 + '/searchFor',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/searchFor/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                        if (valid3) {
                                                            if (data1.replaceWith !== undefined) {
                                                                let data6 = data1.replaceWith;
                                                                const _errs14 = errors;
                                                                if (errors === _errs14) {
                                                                    if (typeof data6 === 'string') {
                                                                        if (func2(data6) < 1) {
                                                                            validate204.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/replaceConditions/' + i0 + '/replaceWith',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/replaceWith/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate204.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/replaceConditions/' + i0 + '/replaceWith',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/replaceWith/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid3 = _errs14 === errors;
                                                            }
                                                            else {
                                                                var valid3 = true;
                                                            }
                                                            if (valid3) {
                                                                if (data1.ignoreCase !== undefined) {
                                                                    const _errs16 = errors;
                                                                    if (typeof data1.ignoreCase !== 'boolean') {
                                                                        validate204.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/replaceConditions/' + i0 + '/ignoreCase',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/ignoreCase/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid3 = _errs16 === errors;
                                                                }
                                                                else {
                                                                    var valid3 = true;
                                                                }
                                                                if (valid3) {
                                                                    if (data1.matchWord !== undefined) {
                                                                        const _errs18 = errors;
                                                                        if (typeof data1.matchWord !== 'boolean') {
                                                                            validate204.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/replaceConditions/' + i0 + '/matchWord',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/matchWord/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'boolean' },
                                                                                    message: 'must be boolean'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid3 = _errs18 === errors;
                                                                    }
                                                                    else {
                                                                        var valid3 = true;
                                                                    }
                                                                    if (valid3) {
                                                                        if (data1.name !== undefined) {
                                                                            let data9 = data1.name;
                                                                            const _errs20 = errors;
                                                                            if (errors === _errs20) {
                                                                                if (typeof data9 === 'string') {
                                                                                    if (func2(data9) < 1) {
                                                                                        validate204.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/replaceConditions/' + i0 + '/name',
                                                                                                schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/name/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate204.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/replaceConditions/' + i0 + '/name',
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/properties/name/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid3 = _errs20 === errors;
                                                                        }
                                                                        else {
                                                                            var valid3 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate204.errors = [
                                                {
                                                    instancePath: instancePath + '/replaceConditions/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:ReplaceCondition/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            validate204.errors = [
                                {
                                    instancePath: instancePath + '/replaceConditions',
                                    schemaPath: '#/properties/replaceConditions/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate204.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate204.errors = vErrors;
    return errors === 0;
}
export const multiUnionConfigSchemaValidation = validate205;
const schema283 = { $id: 'urn:wisepipe-common-pipe:MultiUnionConfig', type: 'object', properties: {} };
function validate205(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:MultiUnionConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate205.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate205.errors = vErrors;
    return errors === 0;
}
export const naiveBayesTrainConfigSchemaValidation = validate206;
const schema284 = {
    $id: 'urn:wisepipe-common-pipe:NaiveBayesTrainConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate206(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:NaiveBayesTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate206.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate206.errors = vErrors;
    return errors === 0;
}
export const nodeElementEventSchemaValidation = validate207;
const schema285 = {
    $id: 'urn:wisepipe-common-pipe:NodeElementEvent',
    type: 'object',
    properties: { outs: { type: 'array', items: { type: 'string' } } },
    required: ['outs']
};
function validate207(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:NodeElementEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.outs === undefined && (missing0 = 'outs')) {
                validate207.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.outs !== undefined) {
                    let data0 = data.outs;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (typeof data0[i0] !== 'string') {
                                    validate207.errors = [
                                        {
                                            instancePath: instancePath + '/outs/' + i0,
                                            schemaPath: '#/properties/outs/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate207.errors = [
                                {
                                    instancePath: instancePath + '/outs',
                                    schemaPath: '#/properties/outs/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate207.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate207.errors = vErrors;
    return errors === 0;
}
export const nodeElementSchemaValidation = validate208;
const schema286 = {
    $id: 'urn:wisepipe-common-pipe:NodeElement',
    type: 'object',
    properties: {
        x: { type: 'number', minimum: -100000, maximum: 100000 },
        y: { type: 'number', minimum: -100000, maximum: 100000 },
        nameOverride: { type: 'string' },
        color: { type: 'string', minLength: 7, maxLength: 7 },
        parentID: { oneOf: [{ type: 'string', uid: 10 }, { type: 'null' }] },
        nodeIDPathFromReusableLogic: { type: 'string' }
    },
    if: { required: ['config'] },
    then: {
        properties: {
            config: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
            toolType: { type: 'string', const: { $data: '1/config/toolType' } }
        }
    },
    else: {
        properties: {
            toolType: {
                type: 'string',
                enum: [
                    'file',
                    'cloud',
                    'demand_forecast',
                    'sample_customers',
                    'pipe',
                    'multi_port_pipe',
                    'adapt',
                    'aggregate',
                    'aggregate_v2',
                    'amortization',
                    'binning',
                    'category_encoder',
                    'case',
                    'change_case',
                    'change_type',
                    'clean_character',
                    'combination_matcher',
                    'conditional',
                    'confusion_matrix',
                    'date_add',
                    'date_diff',
                    'date_part',
                    'date_aggregate',
                    'date_format',
                    'distinct',
                    'drop',
                    'export',
                    'extract',
                    'fill',
                    'filter',
                    'formula',
                    'multi_formula',
                    'fuzzy_matcher',
                    'join',
                    'join_v2',
                    'lag',
                    'limit',
                    'merge_columns',
                    'min_max_scaler',
                    'monte_carlo',
                    'most_common',
                    'one_hot_encoder',
                    'oversample',
                    'predict_gender',
                    'quantile',
                    'random_number_generator',
                    'rank',
                    'record_id',
                    'remove_outliers',
                    'remove_empty',
                    'rename',
                    'reorder',
                    'repeat',
                    'replace',
                    'multi_replace',
                    'reshape',
                    'reshape_v2',
                    'running_average',
                    'running_total',
                    'sample',
                    'segmentation',
                    'select',
                    'select_word',
                    'smart_matcher',
                    'snapshot',
                    'sort',
                    'split',
                    'standard_scaler',
                    'text_grade_level',
                    'text_between',
                    'text_length',
                    'text_part',
                    'text_sentiment',
                    'trim',
                    'trim_tags',
                    'undersample',
                    'union',
                    'multi_union',
                    'weighted_average',
                    'classifier',
                    'cat_boost_classifier',
                    'decision_tree_train',
                    'gbt_train',
                    'k_neighbors_classifier',
                    'lgbm_classifier',
                    'logistic_regression_train',
                    'naive_bayes_train',
                    'random_forest_train',
                    'svm_train',
                    'xgb_classifier',
                    'regressor',
                    'decision_tree_regressor',
                    'gbt_regressor',
                    'k_neighbors_regressor',
                    'lgbm_regressor',
                    'linear_regression_train',
                    'mlp_regressor',
                    'random_forest_regressor',
                    'xgb_regressor',
                    'cat_boost_regressor',
                    'forecast',
                    'arima_forecast',
                    'auto_regressive_forecast',
                    'exp_smoothing_forecast',
                    'linear_regression_forecast',
                    'moving_average_forecast',
                    'prophet_forecast',
                    'seasonal_arima_forecast',
                    'simple_exp_smoothing_forecast',
                    'vector_auto_regressive_forecast',
                    'weighted_moving_average_forecast',
                    'cnn_text_classifier',
                    'bow_text_classifier',
                    'ensemble_text_classifier',
                    'text_classifier',
                    'word_frequency',
                    'outlier',
                    'abod_outlier',
                    'cblof_outlier',
                    'cof_outlier',
                    'hbos_outlier',
                    'iqr_outlier',
                    'isolation_forest_outlier',
                    'k_neighbors_outlier',
                    'multi_objective_gaal_outlier',
                    'one_class_svm_outlier',
                    'pca_outlier',
                    'single_objective_gaal_outlier',
                    'subspace_outlier',
                    'z_score_outlier',
                    'assignment_optimization',
                    'predictor',
                    'us_income',
                    'us_population',
                    'weather',
                    'hierarchy',
                    'hierarchy_v2',
                    'hierarchy_validator',
                    'hierarchy_validator_v2',
                    'lookup',
                    'split_columns',
                    'period_mapper',
                    'rule_mapper',
                    'rule_mapper_v2',
                    'incentives_export',
                    'incentives_import',
                    'incentives_table',
                    'incentives_period',
                    'user_defined_calc',
                    'sort_calc',
                    'time_shift_calc',
                    'category_calc',
                    'true_up',
                    'period_add',
                    'period_diff',
                    'expand_picklist',
                    'period_accumulation',
                    'reusable_logic_input',
                    'reusable_logic_output',
                    'reusable_logic'
                ]
            }
        }
    },
    required: ['x', 'y', 'toolType']
};
const func303 = ucs2length;
const func304 = base64urlToBuffer;
const func305 = base64urlEncode;
const func306 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate208(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:NodeElement" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.config === undefined && (missing0 = 'config')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.config !== undefined) {
                const _errs4 = errors;
                if (!validate131(data.config, {
                    instancePath: instancePath + '/config',
                    parentData: data,
                    parentDataProperty: 'config',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
                    errors = vErrors.length;
                }
                var valid1 = _errs4 === errors;
            }
            else {
                var valid1 = true;
            }
            if (valid1) {
                if (data.toolType !== undefined) {
                    let data1 = data.toolType;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate208.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/then/properties/toolType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    const vSchema0 = data && data.config && data.config.toolType;
                    if (vSchema0 !== undefined && !func0(data1, vSchema0)) {
                        validate208.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/then/properties/toolType/const',
                                keyword: 'const',
                                params: { allowedValue: vSchema0 },
                                message: 'must be equal to constant'
                            }
                        ];
                        return false;
                    }
                    var valid1 = _errs5 === errors;
                }
                else {
                    var valid1 = true;
                }
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.toolType !== undefined) {
                let data2 = data.toolType;
                if (typeof data2 !== 'string') {
                    validate208.errors = [
                        {
                            instancePath: instancePath + '/toolType',
                            schemaPath: '#/else/properties/toolType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data2 === 'file' ||
                    data2 === 'cloud' ||
                    data2 === 'demand_forecast' ||
                    data2 === 'sample_customers' ||
                    data2 === 'pipe' ||
                    data2 === 'multi_port_pipe' ||
                    data2 === 'adapt' ||
                    data2 === 'aggregate' ||
                    data2 === 'aggregate_v2' ||
                    data2 === 'amortization' ||
                    data2 === 'binning' ||
                    data2 === 'category_encoder' ||
                    data2 === 'case' ||
                    data2 === 'change_case' ||
                    data2 === 'change_type' ||
                    data2 === 'clean_character' ||
                    data2 === 'combination_matcher' ||
                    data2 === 'conditional' ||
                    data2 === 'confusion_matrix' ||
                    data2 === 'date_add' ||
                    data2 === 'date_diff' ||
                    data2 === 'date_part' ||
                    data2 === 'date_aggregate' ||
                    data2 === 'date_format' ||
                    data2 === 'distinct' ||
                    data2 === 'drop' ||
                    data2 === 'export' ||
                    data2 === 'extract' ||
                    data2 === 'fill' ||
                    data2 === 'filter' ||
                    data2 === 'formula' ||
                    data2 === 'multi_formula' ||
                    data2 === 'fuzzy_matcher' ||
                    data2 === 'join' ||
                    data2 === 'join_v2' ||
                    data2 === 'lag' ||
                    data2 === 'limit' ||
                    data2 === 'merge_columns' ||
                    data2 === 'min_max_scaler' ||
                    data2 === 'monte_carlo' ||
                    data2 === 'most_common' ||
                    data2 === 'one_hot_encoder' ||
                    data2 === 'oversample' ||
                    data2 === 'predict_gender' ||
                    data2 === 'quantile' ||
                    data2 === 'random_number_generator' ||
                    data2 === 'rank' ||
                    data2 === 'record_id' ||
                    data2 === 'remove_outliers' ||
                    data2 === 'remove_empty' ||
                    data2 === 'rename' ||
                    data2 === 'reorder' ||
                    data2 === 'repeat' ||
                    data2 === 'replace' ||
                    data2 === 'multi_replace' ||
                    data2 === 'reshape' ||
                    data2 === 'reshape_v2' ||
                    data2 === 'running_average' ||
                    data2 === 'running_total' ||
                    data2 === 'sample' ||
                    data2 === 'segmentation' ||
                    data2 === 'select' ||
                    data2 === 'select_word' ||
                    data2 === 'smart_matcher' ||
                    data2 === 'snapshot' ||
                    data2 === 'sort' ||
                    data2 === 'split' ||
                    data2 === 'standard_scaler' ||
                    data2 === 'text_grade_level' ||
                    data2 === 'text_between' ||
                    data2 === 'text_length' ||
                    data2 === 'text_part' ||
                    data2 === 'text_sentiment' ||
                    data2 === 'trim' ||
                    data2 === 'trim_tags' ||
                    data2 === 'undersample' ||
                    data2 === 'union' ||
                    data2 === 'multi_union' ||
                    data2 === 'weighted_average' ||
                    data2 === 'classifier' ||
                    data2 === 'cat_boost_classifier' ||
                    data2 === 'decision_tree_train' ||
                    data2 === 'gbt_train' ||
                    data2 === 'k_neighbors_classifier' ||
                    data2 === 'lgbm_classifier' ||
                    data2 === 'logistic_regression_train' ||
                    data2 === 'naive_bayes_train' ||
                    data2 === 'random_forest_train' ||
                    data2 === 'svm_train' ||
                    data2 === 'xgb_classifier' ||
                    data2 === 'regressor' ||
                    data2 === 'decision_tree_regressor' ||
                    data2 === 'gbt_regressor' ||
                    data2 === 'k_neighbors_regressor' ||
                    data2 === 'lgbm_regressor' ||
                    data2 === 'linear_regression_train' ||
                    data2 === 'mlp_regressor' ||
                    data2 === 'random_forest_regressor' ||
                    data2 === 'xgb_regressor' ||
                    data2 === 'cat_boost_regressor' ||
                    data2 === 'forecast' ||
                    data2 === 'arima_forecast' ||
                    data2 === 'auto_regressive_forecast' ||
                    data2 === 'exp_smoothing_forecast' ||
                    data2 === 'linear_regression_forecast' ||
                    data2 === 'moving_average_forecast' ||
                    data2 === 'prophet_forecast' ||
                    data2 === 'seasonal_arima_forecast' ||
                    data2 === 'simple_exp_smoothing_forecast' ||
                    data2 === 'vector_auto_regressive_forecast' ||
                    data2 === 'weighted_moving_average_forecast' ||
                    data2 === 'cnn_text_classifier' ||
                    data2 === 'bow_text_classifier' ||
                    data2 === 'ensemble_text_classifier' ||
                    data2 === 'text_classifier' ||
                    data2 === 'word_frequency' ||
                    data2 === 'outlier' ||
                    data2 === 'abod_outlier' ||
                    data2 === 'cblof_outlier' ||
                    data2 === 'cof_outlier' ||
                    data2 === 'hbos_outlier' ||
                    data2 === 'iqr_outlier' ||
                    data2 === 'isolation_forest_outlier' ||
                    data2 === 'k_neighbors_outlier' ||
                    data2 === 'multi_objective_gaal_outlier' ||
                    data2 === 'one_class_svm_outlier' ||
                    data2 === 'pca_outlier' ||
                    data2 === 'single_objective_gaal_outlier' ||
                    data2 === 'subspace_outlier' ||
                    data2 === 'z_score_outlier' ||
                    data2 === 'assignment_optimization' ||
                    data2 === 'predictor' ||
                    data2 === 'us_income' ||
                    data2 === 'us_population' ||
                    data2 === 'weather' ||
                    data2 === 'hierarchy' ||
                    data2 === 'hierarchy_v2' ||
                    data2 === 'hierarchy_validator' ||
                    data2 === 'hierarchy_validator_v2' ||
                    data2 === 'lookup' ||
                    data2 === 'split_columns' ||
                    data2 === 'period_mapper' ||
                    data2 === 'rule_mapper' ||
                    data2 === 'rule_mapper_v2' ||
                    data2 === 'incentives_export' ||
                    data2 === 'incentives_import' ||
                    data2 === 'incentives_table' ||
                    data2 === 'incentives_period' ||
                    data2 === 'user_defined_calc' ||
                    data2 === 'sort_calc' ||
                    data2 === 'time_shift_calc' ||
                    data2 === 'category_calc' ||
                    data2 === 'true_up' ||
                    data2 === 'period_add' ||
                    data2 === 'period_diff' ||
                    data2 === 'expand_picklist' ||
                    data2 === 'period_accumulation' ||
                    data2 === 'reusable_logic_input' ||
                    data2 === 'reusable_logic_output' ||
                    data2 === 'reusable_logic')) {
                    validate208.errors = [
                        {
                            instancePath: instancePath + '/toolType',
                            schemaPath: '#/else/properties/toolType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema286.else.properties.toolType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate208.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.x === undefined && (missing1 = 'x')) ||
                (data.y === undefined && (missing1 = 'y')) ||
                (data.toolType === undefined && (missing1 = 'toolType'))) {
                validate208.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.x !== undefined) {
                    let data3 = data.x;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (typeof data3 == 'number') {
                            if (data3 > 100000 || isNaN(data3)) {
                                validate208.errors = [
                                    {
                                        instancePath: instancePath + '/x',
                                        schemaPath: '#/properties/x/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 100000 },
                                        message: 'must be <= 100000'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data3 < -100000 || isNaN(data3)) {
                                    validate208.errors = [
                                        {
                                            instancePath: instancePath + '/x',
                                            schemaPath: '#/properties/x/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: -100000 },
                                            message: 'must be >= -100000'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate208.errors = [
                                {
                                    instancePath: instancePath + '/x',
                                    schemaPath: '#/properties/x/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid3 = _errs10 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.y !== undefined) {
                        let data4 = data.y;
                        const _errs12 = errors;
                        if (errors === _errs12) {
                            if (typeof data4 == 'number') {
                                if (data4 > 100000 || isNaN(data4)) {
                                    validate208.errors = [
                                        {
                                            instancePath: instancePath + '/y',
                                            schemaPath: '#/properties/y/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 100000 },
                                            message: 'must be <= 100000'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data4 < -100000 || isNaN(data4)) {
                                        validate208.errors = [
                                            {
                                                instancePath: instancePath + '/y',
                                                schemaPath: '#/properties/y/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: -100000 },
                                                message: 'must be >= -100000'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate208.errors = [
                                    {
                                        instancePath: instancePath + '/y',
                                        schemaPath: '#/properties/y/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid3 = _errs12 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.nameOverride !== undefined) {
                            const _errs14 = errors;
                            if (typeof data.nameOverride !== 'string') {
                                validate208.errors = [
                                    {
                                        instancePath: instancePath + '/nameOverride',
                                        schemaPath: '#/properties/nameOverride/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid3 = _errs14 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.color !== undefined) {
                                let data6 = data.color;
                                const _errs16 = errors;
                                if (errors === _errs16) {
                                    if (typeof data6 === 'string') {
                                        if (func2(data6) > 7) {
                                            validate208.errors = [
                                                {
                                                    instancePath: instancePath + '/color',
                                                    schemaPath: '#/properties/color/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 7 },
                                                    message: 'must NOT have more than 7 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data6) < 7) {
                                                validate208.errors = [
                                                    {
                                                        instancePath: instancePath + '/color',
                                                        schemaPath: '#/properties/color/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 7 },
                                                        message: 'must NOT have fewer than 7 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate208.errors = [
                                            {
                                                instancePath: instancePath + '/color',
                                                schemaPath: '#/properties/color/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid3 = _errs16 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.parentID !== undefined) {
                                    let data7 = data.parentID;
                                    const _errs18 = errors;
                                    const _errs19 = errors;
                                    let valid4 = false;
                                    let passing0 = null;
                                    const _errs20 = errors;
                                    if (errors === _errs20) {
                                        if (typeof data7 === 'string') {
                                            const b64min0 = Math.ceil((4 * 10) / 3);
                                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func303(data7) < b64min0 || func303(data7) > b64max0) {
                                                const err2 = {
                                                    instancePath: instancePath + '/parentID',
                                                    schemaPath: '#/properties/parentID/oneOf/0/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func303(data7) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func303(data7)
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err2];
                                                }
                                                else {
                                                    vErrors.push(err2);
                                                }
                                                errors++;
                                            }
                                            else {
                                                const decoded0 = func304(data7);
                                                if (decoded0.length !== 10) {
                                                    const err3 = {
                                                        instancePath: instancePath + '/parentID',
                                                        schemaPath: '#/properties/parentID/oneOf/0/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err3];
                                                    }
                                                    else {
                                                        vErrors.push(err3);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    const encoded0 = func305(decoded0);
                                                    if (func306(encoded0) !== func306(data7)) {
                                                        const err4 = {
                                                            instancePath: instancePath + '/parentID',
                                                            schemaPath: '#/properties/parentID/oneOf/0/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err4];
                                                        }
                                                        else {
                                                            vErrors.push(err4);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            const err5 = {
                                                instancePath: instancePath + '/parentID',
                                                schemaPath: '#/properties/parentID/oneOf/0/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs20 === errors;
                                    if (_valid1) {
                                        valid4 = true;
                                        passing0 = 0;
                                    }
                                    const _errs22 = errors;
                                    if (data7 !== null) {
                                        const err6 = {
                                            instancePath: instancePath + '/parentID',
                                            schemaPath: '#/properties/parentID/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'null' },
                                            message: 'must be null'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    var _valid1 = _errs22 === errors;
                                    if (_valid1 && valid4) {
                                        valid4 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid1) {
                                            valid4 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid4) {
                                        const err7 = {
                                            instancePath: instancePath + '/parentID',
                                            schemaPath: '#/properties/parentID/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                        validate208.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs19;
                                        if (vErrors !== null) {
                                            if (_errs19) {
                                                vErrors.length = _errs19;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid3 = _errs18 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                                if (valid3) {
                                    if (data.nodeIDPathFromReusableLogic !== undefined) {
                                        const _errs24 = errors;
                                        if (typeof data.nodeIDPathFromReusableLogic !== 'string') {
                                            validate208.errors = [
                                                {
                                                    instancePath: instancePath + '/nodeIDPathFromReusableLogic',
                                                    schemaPath: '#/properties/nodeIDPathFromReusableLogic/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs24 === errors;
                                    }
                                    else {
                                        var valid3 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate208.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate208.errors = vErrors;
    return errors === 0;
}
export const numberToolVariableSchemaValidation = validate210;
function validate210(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:NumberToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate210.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate210.errors = vErrors;
    return errors === 0;
}
export const oneClassSvmOutlierConfigSchemaValidation = validate211;
const schema288 = {
    $id: 'urn:wisepipe-common-pipe:OneClassSvmOutlierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate211(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:OneClassSvmOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate211.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate211.errors = vErrors;
    return errors === 0;
}
export const oneHotEncoderConfigSchemaValidation = validate212;
const schema289 = {
    $id: 'urn:wisepipe-common-pipe:OneHotEncoderConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['columns']
};
function validate212(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:OneHotEncoderConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate212.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate212.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate212.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        if (errors === _errs3) {
                                            if (typeof data1 === 'string') {
                                                if (func2(data1) > 150) {
                                                    validate212.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 150 },
                                                            message: 'must NOT have more than 150 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data1) < 1) {
                                                        validate212.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns/' + i0,
                                                                schemaPath: '#/properties/columns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate212.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data0[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate212.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate212.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate212.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate212.errors = vErrors;
    return errors === 0;
}
export const outlierConfigSchemaValidation = validate213;
const schema290 = {
    $id: 'urn:wisepipe-common-pipe:OutlierConfig',
    type: 'object',
    properties: {
        options: { type: 'integer', minimum: 1, maximum: 11 },
        contamination: { type: 'number', minimum: 0, maximum: 0.5 },
        threshold: { type: 'number', minimum: 0, maximum: 1 },
        probaColumn: { type: 'string', minLength: 1 }
    },
    required: []
};
function validate213(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:OutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.options !== undefined) {
                let data0 = data.options;
                const _errs1 = errors;
                if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                    validate213.errors = [
                        {
                            instancePath: instancePath + '/options',
                            schemaPath: '#/properties/options/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer'
                        }
                    ];
                    return false;
                }
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 > 11 || isNaN(data0)) {
                            validate213.errors = [
                                {
                                    instancePath: instancePath + '/options',
                                    schemaPath: '#/properties/options/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 11 },
                                    message: 'must be <= 11'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0 < 1 || isNaN(data0)) {
                                validate213.errors = [
                                    {
                                        instancePath: instancePath + '/options',
                                        schemaPath: '#/properties/options/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 1 },
                                        message: 'must be >= 1'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.contamination !== undefined) {
                    let data1 = data.contamination;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 > 0.5 || isNaN(data1)) {
                                validate213.errors = [
                                    {
                                        instancePath: instancePath + '/contamination',
                                        schemaPath: '#/properties/contamination/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 0.5 },
                                        message: 'must be <= 0.5'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate213.errors = [
                                        {
                                            instancePath: instancePath + '/contamination',
                                            schemaPath: '#/properties/contamination/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate213.errors = [
                                {
                                    instancePath: instancePath + '/contamination',
                                    schemaPath: '#/properties/contamination/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.threshold !== undefined) {
                        let data2 = data.threshold;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 == 'number') {
                                if (data2 > 1 || isNaN(data2)) {
                                    validate213.errors = [
                                        {
                                            instancePath: instancePath + '/threshold',
                                            schemaPath: '#/properties/threshold/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1 },
                                            message: 'must be <= 1'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate213.errors = [
                                            {
                                                instancePath: instancePath + '/threshold',
                                                schemaPath: '#/properties/threshold/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate213.errors = [
                                    {
                                        instancePath: instancePath + '/threshold',
                                        schemaPath: '#/properties/threshold/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.probaColumn !== undefined) {
                            let data3 = data.probaColumn;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate213.errors = [
                                            {
                                                instancePath: instancePath + '/probaColumn',
                                                schemaPath: '#/properties/probaColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate213.errors = [
                                        {
                                            instancePath: instancePath + '/probaColumn',
                                            schemaPath: '#/properties/probaColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate213.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate213.errors = vErrors;
    return errors === 0;
}
export const oversampleConfigSchemaValidation = validate214;
const schema291 = {
    $id: 'urn:wisepipe-common-pipe:OversampleConfig',
    type: 'object',
    properties: { labelColumn: { type: 'string', minLength: 1 }, generatedColName: { type: 'string', minLength: 1 } },
    required: ['labelColumn']
};
function validate214(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:OversampleConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.labelColumn === undefined && (missing0 = 'labelColumn')) {
                validate214.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.labelColumn !== undefined) {
                    let data0 = data.labelColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate214.errors = [
                                    {
                                        instancePath: instancePath + '/labelColumn',
                                        schemaPath: '#/properties/labelColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate214.errors = [
                                {
                                    instancePath: instancePath + '/labelColumn',
                                    schemaPath: '#/properties/labelColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.generatedColName !== undefined) {
                        let data1 = data.generatedColName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate214.errors = [
                                        {
                                            instancePath: instancePath + '/generatedColName',
                                            schemaPath: '#/properties/generatedColName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate214.errors = [
                                    {
                                        instancePath: instancePath + '/generatedColName',
                                        schemaPath: '#/properties/generatedColName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate214.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate214.errors = vErrors;
    return errors === 0;
}
export const partialNodeElementSchemaValidation = validate215;
const schema292 = {
    $id: 'urn:wisepipe-common-pipe:PartialNodeElement',
    type: 'object',
    properties: {
        x: { type: 'number', minimum: -100000, maximum: 100000 },
        y: { type: 'number', minimum: -100000, maximum: 100000 },
        nameOverride: { type: 'string' },
        color: { type: 'string', minLength: 7, maxLength: 7 },
        parentID: { oneOf: [{ type: 'string', uid: 10 }, { type: 'null' }] }
    },
    if: { required: ['config'] },
    then: {
        properties: {
            config: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
            toolType: { type: 'string', const: { $data: '1/config/toolType' } }
        }
    },
    else: {
        properties: {
            toolType: {
                type: 'string',
                enum: [
                    'file',
                    'cloud',
                    'demand_forecast',
                    'sample_customers',
                    'pipe',
                    'multi_port_pipe',
                    'adapt',
                    'aggregate',
                    'aggregate_v2',
                    'amortization',
                    'binning',
                    'category_encoder',
                    'case',
                    'change_case',
                    'change_type',
                    'clean_character',
                    'combination_matcher',
                    'conditional',
                    'confusion_matrix',
                    'date_add',
                    'date_diff',
                    'date_part',
                    'date_aggregate',
                    'date_format',
                    'distinct',
                    'drop',
                    'export',
                    'extract',
                    'fill',
                    'filter',
                    'formula',
                    'multi_formula',
                    'fuzzy_matcher',
                    'join',
                    'join_v2',
                    'lag',
                    'limit',
                    'merge_columns',
                    'min_max_scaler',
                    'monte_carlo',
                    'most_common',
                    'one_hot_encoder',
                    'oversample',
                    'predict_gender',
                    'quantile',
                    'random_number_generator',
                    'rank',
                    'record_id',
                    'remove_outliers',
                    'remove_empty',
                    'rename',
                    'reorder',
                    'repeat',
                    'replace',
                    'multi_replace',
                    'reshape',
                    'reshape_v2',
                    'running_average',
                    'running_total',
                    'sample',
                    'segmentation',
                    'select',
                    'select_word',
                    'smart_matcher',
                    'snapshot',
                    'sort',
                    'split',
                    'standard_scaler',
                    'text_grade_level',
                    'text_between',
                    'text_length',
                    'text_part',
                    'text_sentiment',
                    'trim',
                    'trim_tags',
                    'undersample',
                    'union',
                    'multi_union',
                    'weighted_average',
                    'classifier',
                    'cat_boost_classifier',
                    'decision_tree_train',
                    'gbt_train',
                    'k_neighbors_classifier',
                    'lgbm_classifier',
                    'logistic_regression_train',
                    'naive_bayes_train',
                    'random_forest_train',
                    'svm_train',
                    'xgb_classifier',
                    'regressor',
                    'decision_tree_regressor',
                    'gbt_regressor',
                    'k_neighbors_regressor',
                    'lgbm_regressor',
                    'linear_regression_train',
                    'mlp_regressor',
                    'random_forest_regressor',
                    'xgb_regressor',
                    'cat_boost_regressor',
                    'forecast',
                    'arima_forecast',
                    'auto_regressive_forecast',
                    'exp_smoothing_forecast',
                    'linear_regression_forecast',
                    'moving_average_forecast',
                    'prophet_forecast',
                    'seasonal_arima_forecast',
                    'simple_exp_smoothing_forecast',
                    'vector_auto_regressive_forecast',
                    'weighted_moving_average_forecast',
                    'cnn_text_classifier',
                    'bow_text_classifier',
                    'ensemble_text_classifier',
                    'text_classifier',
                    'word_frequency',
                    'outlier',
                    'abod_outlier',
                    'cblof_outlier',
                    'cof_outlier',
                    'hbos_outlier',
                    'iqr_outlier',
                    'isolation_forest_outlier',
                    'k_neighbors_outlier',
                    'multi_objective_gaal_outlier',
                    'one_class_svm_outlier',
                    'pca_outlier',
                    'single_objective_gaal_outlier',
                    'subspace_outlier',
                    'z_score_outlier',
                    'assignment_optimization',
                    'predictor',
                    'us_income',
                    'us_population',
                    'weather',
                    'hierarchy',
                    'hierarchy_v2',
                    'hierarchy_validator',
                    'hierarchy_validator_v2',
                    'lookup',
                    'split_columns',
                    'period_mapper',
                    'rule_mapper',
                    'rule_mapper_v2',
                    'incentives_export',
                    'incentives_import',
                    'incentives_table',
                    'incentives_period',
                    'user_defined_calc',
                    'sort_calc',
                    'time_shift_calc',
                    'category_calc',
                    'true_up',
                    'period_add',
                    'period_diff',
                    'expand_picklist',
                    'period_accumulation',
                    'reusable_logic_input',
                    'reusable_logic_output',
                    'reusable_logic'
                ]
            }
        }
    },
    required: ['toolType']
};
const func315 = ucs2length;
const func316 = base64urlToBuffer;
const func317 = base64urlEncode;
const func318 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate215(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PartialNodeElement" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.config === undefined && (missing0 = 'config')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs3 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.config !== undefined) {
                const _errs4 = errors;
                if (!validate131(data.config, {
                    instancePath: instancePath + '/config',
                    parentData: data,
                    parentDataProperty: 'config',
                    rootData
                })) {
                    vErrors = vErrors === null ? validate131.errors : vErrors.concat(validate131.errors);
                    errors = vErrors.length;
                }
                var valid1 = _errs4 === errors;
            }
            else {
                var valid1 = true;
            }
            if (valid1) {
                if (data.toolType !== undefined) {
                    let data1 = data.toolType;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate215.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/then/properties/toolType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    const vSchema0 = data && data.config && data.config.toolType;
                    if (vSchema0 !== undefined && !func0(data1, vSchema0)) {
                        validate215.errors = [
                            {
                                instancePath: instancePath + '/toolType',
                                schemaPath: '#/then/properties/toolType/const',
                                keyword: 'const',
                                params: { allowedValue: vSchema0 },
                                message: 'must be equal to constant'
                            }
                        ];
                        return false;
                    }
                    var valid1 = _errs5 === errors;
                }
                else {
                    var valid1 = true;
                }
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.toolType !== undefined) {
                let data2 = data.toolType;
                if (typeof data2 !== 'string') {
                    validate215.errors = [
                        {
                            instancePath: instancePath + '/toolType',
                            schemaPath: '#/else/properties/toolType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data2 === 'file' ||
                    data2 === 'cloud' ||
                    data2 === 'demand_forecast' ||
                    data2 === 'sample_customers' ||
                    data2 === 'pipe' ||
                    data2 === 'multi_port_pipe' ||
                    data2 === 'adapt' ||
                    data2 === 'aggregate' ||
                    data2 === 'aggregate_v2' ||
                    data2 === 'amortization' ||
                    data2 === 'binning' ||
                    data2 === 'category_encoder' ||
                    data2 === 'case' ||
                    data2 === 'change_case' ||
                    data2 === 'change_type' ||
                    data2 === 'clean_character' ||
                    data2 === 'combination_matcher' ||
                    data2 === 'conditional' ||
                    data2 === 'confusion_matrix' ||
                    data2 === 'date_add' ||
                    data2 === 'date_diff' ||
                    data2 === 'date_part' ||
                    data2 === 'date_aggregate' ||
                    data2 === 'date_format' ||
                    data2 === 'distinct' ||
                    data2 === 'drop' ||
                    data2 === 'export' ||
                    data2 === 'extract' ||
                    data2 === 'fill' ||
                    data2 === 'filter' ||
                    data2 === 'formula' ||
                    data2 === 'multi_formula' ||
                    data2 === 'fuzzy_matcher' ||
                    data2 === 'join' ||
                    data2 === 'join_v2' ||
                    data2 === 'lag' ||
                    data2 === 'limit' ||
                    data2 === 'merge_columns' ||
                    data2 === 'min_max_scaler' ||
                    data2 === 'monte_carlo' ||
                    data2 === 'most_common' ||
                    data2 === 'one_hot_encoder' ||
                    data2 === 'oversample' ||
                    data2 === 'predict_gender' ||
                    data2 === 'quantile' ||
                    data2 === 'random_number_generator' ||
                    data2 === 'rank' ||
                    data2 === 'record_id' ||
                    data2 === 'remove_outliers' ||
                    data2 === 'remove_empty' ||
                    data2 === 'rename' ||
                    data2 === 'reorder' ||
                    data2 === 'repeat' ||
                    data2 === 'replace' ||
                    data2 === 'multi_replace' ||
                    data2 === 'reshape' ||
                    data2 === 'reshape_v2' ||
                    data2 === 'running_average' ||
                    data2 === 'running_total' ||
                    data2 === 'sample' ||
                    data2 === 'segmentation' ||
                    data2 === 'select' ||
                    data2 === 'select_word' ||
                    data2 === 'smart_matcher' ||
                    data2 === 'snapshot' ||
                    data2 === 'sort' ||
                    data2 === 'split' ||
                    data2 === 'standard_scaler' ||
                    data2 === 'text_grade_level' ||
                    data2 === 'text_between' ||
                    data2 === 'text_length' ||
                    data2 === 'text_part' ||
                    data2 === 'text_sentiment' ||
                    data2 === 'trim' ||
                    data2 === 'trim_tags' ||
                    data2 === 'undersample' ||
                    data2 === 'union' ||
                    data2 === 'multi_union' ||
                    data2 === 'weighted_average' ||
                    data2 === 'classifier' ||
                    data2 === 'cat_boost_classifier' ||
                    data2 === 'decision_tree_train' ||
                    data2 === 'gbt_train' ||
                    data2 === 'k_neighbors_classifier' ||
                    data2 === 'lgbm_classifier' ||
                    data2 === 'logistic_regression_train' ||
                    data2 === 'naive_bayes_train' ||
                    data2 === 'random_forest_train' ||
                    data2 === 'svm_train' ||
                    data2 === 'xgb_classifier' ||
                    data2 === 'regressor' ||
                    data2 === 'decision_tree_regressor' ||
                    data2 === 'gbt_regressor' ||
                    data2 === 'k_neighbors_regressor' ||
                    data2 === 'lgbm_regressor' ||
                    data2 === 'linear_regression_train' ||
                    data2 === 'mlp_regressor' ||
                    data2 === 'random_forest_regressor' ||
                    data2 === 'xgb_regressor' ||
                    data2 === 'cat_boost_regressor' ||
                    data2 === 'forecast' ||
                    data2 === 'arima_forecast' ||
                    data2 === 'auto_regressive_forecast' ||
                    data2 === 'exp_smoothing_forecast' ||
                    data2 === 'linear_regression_forecast' ||
                    data2 === 'moving_average_forecast' ||
                    data2 === 'prophet_forecast' ||
                    data2 === 'seasonal_arima_forecast' ||
                    data2 === 'simple_exp_smoothing_forecast' ||
                    data2 === 'vector_auto_regressive_forecast' ||
                    data2 === 'weighted_moving_average_forecast' ||
                    data2 === 'cnn_text_classifier' ||
                    data2 === 'bow_text_classifier' ||
                    data2 === 'ensemble_text_classifier' ||
                    data2 === 'text_classifier' ||
                    data2 === 'word_frequency' ||
                    data2 === 'outlier' ||
                    data2 === 'abod_outlier' ||
                    data2 === 'cblof_outlier' ||
                    data2 === 'cof_outlier' ||
                    data2 === 'hbos_outlier' ||
                    data2 === 'iqr_outlier' ||
                    data2 === 'isolation_forest_outlier' ||
                    data2 === 'k_neighbors_outlier' ||
                    data2 === 'multi_objective_gaal_outlier' ||
                    data2 === 'one_class_svm_outlier' ||
                    data2 === 'pca_outlier' ||
                    data2 === 'single_objective_gaal_outlier' ||
                    data2 === 'subspace_outlier' ||
                    data2 === 'z_score_outlier' ||
                    data2 === 'assignment_optimization' ||
                    data2 === 'predictor' ||
                    data2 === 'us_income' ||
                    data2 === 'us_population' ||
                    data2 === 'weather' ||
                    data2 === 'hierarchy' ||
                    data2 === 'hierarchy_v2' ||
                    data2 === 'hierarchy_validator' ||
                    data2 === 'hierarchy_validator_v2' ||
                    data2 === 'lookup' ||
                    data2 === 'split_columns' ||
                    data2 === 'period_mapper' ||
                    data2 === 'rule_mapper' ||
                    data2 === 'rule_mapper_v2' ||
                    data2 === 'incentives_export' ||
                    data2 === 'incentives_import' ||
                    data2 === 'incentives_table' ||
                    data2 === 'incentives_period' ||
                    data2 === 'user_defined_calc' ||
                    data2 === 'sort_calc' ||
                    data2 === 'time_shift_calc' ||
                    data2 === 'category_calc' ||
                    data2 === 'true_up' ||
                    data2 === 'period_add' ||
                    data2 === 'period_diff' ||
                    data2 === 'expand_picklist' ||
                    data2 === 'period_accumulation' ||
                    data2 === 'reusable_logic_input' ||
                    data2 === 'reusable_logic_output' ||
                    data2 === 'reusable_logic')) {
                    validate215.errors = [
                        {
                            instancePath: instancePath + '/toolType',
                            schemaPath: '#/else/properties/toolType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema292.else.properties.toolType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate215.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.toolType === undefined && (missing1 = 'toolType')) {
                validate215.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.x !== undefined) {
                    let data3 = data.x;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (typeof data3 == 'number') {
                            if (data3 > 100000 || isNaN(data3)) {
                                validate215.errors = [
                                    {
                                        instancePath: instancePath + '/x',
                                        schemaPath: '#/properties/x/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 100000 },
                                        message: 'must be <= 100000'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data3 < -100000 || isNaN(data3)) {
                                    validate215.errors = [
                                        {
                                            instancePath: instancePath + '/x',
                                            schemaPath: '#/properties/x/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: -100000 },
                                            message: 'must be >= -100000'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate215.errors = [
                                {
                                    instancePath: instancePath + '/x',
                                    schemaPath: '#/properties/x/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid3 = _errs10 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.y !== undefined) {
                        let data4 = data.y;
                        const _errs12 = errors;
                        if (errors === _errs12) {
                            if (typeof data4 == 'number') {
                                if (data4 > 100000 || isNaN(data4)) {
                                    validate215.errors = [
                                        {
                                            instancePath: instancePath + '/y',
                                            schemaPath: '#/properties/y/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 100000 },
                                            message: 'must be <= 100000'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data4 < -100000 || isNaN(data4)) {
                                        validate215.errors = [
                                            {
                                                instancePath: instancePath + '/y',
                                                schemaPath: '#/properties/y/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: -100000 },
                                                message: 'must be >= -100000'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate215.errors = [
                                    {
                                        instancePath: instancePath + '/y',
                                        schemaPath: '#/properties/y/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid3 = _errs12 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.nameOverride !== undefined) {
                            const _errs14 = errors;
                            if (typeof data.nameOverride !== 'string') {
                                validate215.errors = [
                                    {
                                        instancePath: instancePath + '/nameOverride',
                                        schemaPath: '#/properties/nameOverride/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid3 = _errs14 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.color !== undefined) {
                                let data6 = data.color;
                                const _errs16 = errors;
                                if (errors === _errs16) {
                                    if (typeof data6 === 'string') {
                                        if (func2(data6) > 7) {
                                            validate215.errors = [
                                                {
                                                    instancePath: instancePath + '/color',
                                                    schemaPath: '#/properties/color/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 7 },
                                                    message: 'must NOT have more than 7 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data6) < 7) {
                                                validate215.errors = [
                                                    {
                                                        instancePath: instancePath + '/color',
                                                        schemaPath: '#/properties/color/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 7 },
                                                        message: 'must NOT have fewer than 7 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate215.errors = [
                                            {
                                                instancePath: instancePath + '/color',
                                                schemaPath: '#/properties/color/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid3 = _errs16 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.parentID !== undefined) {
                                    let data7 = data.parentID;
                                    const _errs18 = errors;
                                    const _errs19 = errors;
                                    let valid4 = false;
                                    let passing0 = null;
                                    const _errs20 = errors;
                                    if (errors === _errs20) {
                                        if (typeof data7 === 'string') {
                                            const b64min0 = Math.ceil((4 * 10) / 3);
                                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func315(data7) < b64min0 || func315(data7) > b64max0) {
                                                const err2 = {
                                                    instancePath: instancePath + '/parentID',
                                                    schemaPath: '#/properties/parentID/oneOf/0/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func315(data7) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func315(data7)
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err2];
                                                }
                                                else {
                                                    vErrors.push(err2);
                                                }
                                                errors++;
                                            }
                                            else {
                                                const decoded0 = func316(data7);
                                                if (decoded0.length !== 10) {
                                                    const err3 = {
                                                        instancePath: instancePath + '/parentID',
                                                        schemaPath: '#/properties/parentID/oneOf/0/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err3];
                                                    }
                                                    else {
                                                        vErrors.push(err3);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    const encoded0 = func317(decoded0);
                                                    if (func318(encoded0) !== func318(data7)) {
                                                        const err4 = {
                                                            instancePath: instancePath + '/parentID',
                                                            schemaPath: '#/properties/parentID/oneOf/0/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err4];
                                                        }
                                                        else {
                                                            vErrors.push(err4);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            const err5 = {
                                                instancePath: instancePath + '/parentID',
                                                schemaPath: '#/properties/parentID/oneOf/0/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs20 === errors;
                                    if (_valid1) {
                                        valid4 = true;
                                        passing0 = 0;
                                    }
                                    const _errs22 = errors;
                                    if (data7 !== null) {
                                        const err6 = {
                                            instancePath: instancePath + '/parentID',
                                            schemaPath: '#/properties/parentID/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'null' },
                                            message: 'must be null'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    var _valid1 = _errs22 === errors;
                                    if (_valid1 && valid4) {
                                        valid4 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid1) {
                                            valid4 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid4) {
                                        const err7 = {
                                            instancePath: instancePath + '/parentID',
                                            schemaPath: '#/properties/parentID/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                        validate215.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs19;
                                        if (vErrors !== null) {
                                            if (_errs19) {
                                                vErrors.length = _errs19;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid3 = _errs18 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate215.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate215.errors = vErrors;
    return errors === 0;
}
export const pcaOutlierConfigSchemaValidation = validate217;
const schema293 = { $id: 'urn:wisepipe-common-pipe:PcaOutlierConfig', type: 'object', properties: {}, required: [] };
function validate217(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PcaOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate217.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate217.errors = vErrors;
    return errors === 0;
}
export const periodAccumulationConfigSchemaValidation = validate218;
const schema294 = {
    $id: 'urn:wisepipe-common-pipe:PeriodAccumulationConfig',
    type: 'object',
    properties: {
        valueColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1 }] },
            uniqueItems: true,
            minItems: 1
        },
        groupColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1 }] },
            uniqueItems: true
        },
        orderColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name'],
            minItems: 1
        },
        accumulationLevel: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:CalendarToolVariable' }, { type: 'string' }] }
    },
    required: ['valueColumns', 'groupColumns', 'orderColumns']
};
const func323 = ajvEqual;
const schema297 = {
    $id: 'urn:wisepipe-common-pipe:SortColumn',
    type: 'object',
    properties: {
        name: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        direction: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                { type: 'string', enum: ['ascending', 'descending'] }
            ]
        }
    },
    required: ['name', 'direction']
};
function validate219(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SortColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.direction === undefined && (missing0 = 'direction'))) {
                validate219.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/name',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (typeof data0 !== 'string') {
                        const err1 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err2 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                        validate219.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.direction !== undefined) {
                        let data1 = data.direction;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        let passing1 = null;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                if (data1.toolEnumType !== undefined) {
                                    let data2 = data1.toolEnumType;
                                    if (typeof data2 !== 'string') {
                                        const err3 = {
                                            instancePath: instancePath + '/direction/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                    }
                                    if (!(data2 === 'SortDirection' ||
                                        data2 === 'AggregateColumnOperation' ||
                                        data2 === 'DateFrequency' ||
                                        data2 === 'DateAddType' ||
                                        data2 === 'DateAddUnit' ||
                                        data2 === 'DateUnitType' ||
                                        data2 === 'DatePartType' ||
                                        data2 === 'JoinOperator' ||
                                        data2 === 'JoinPattern' ||
                                        data2 === 'FilterStatementOp' ||
                                        data2 === 'ColumnType' ||
                                        data2 === 'PeriodAddType')) {
                                        const err4 = {
                                            instancePath: instancePath + '/direction/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err5 = {
                                    instancePath: instancePath + '/direction',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        if (_valid1) {
                            valid3 = true;
                            passing1 = 0;
                        }
                        const _errs15 = errors;
                        if (typeof data1 !== 'string') {
                            const err6 = {
                                instancePath: instancePath + '/direction',
                                schemaPath: '#/properties/direction/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                        }
                        if (!(data1 === 'ascending' || data1 === 'descending')) {
                            const err7 = {
                                instancePath: instancePath + '/direction',
                                schemaPath: '#/properties/direction/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema297.properties.direction.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        var _valid1 = _errs15 === errors;
                        if (_valid1 && valid3) {
                            valid3 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid3 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid3) {
                            const err8 = {
                                instancePath: instancePath + '/direction',
                                schemaPath: '#/properties/direction/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            validate219.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate219.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate219.errors = vErrors;
    return errors === 0;
}
function validate218(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodAccumulationConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.valueColumns === undefined && (missing0 = 'valueColumns')) ||
                (data.groupColumns === undefined && (missing0 = 'groupColumns')) ||
                (data.orderColumns === undefined && (missing0 = 'orderColumns'))) {
                validate218.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.valueColumns !== undefined) {
                    let data0 = data.valueColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate218.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumns',
                                        schemaPath: '#/properties/valueColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    let valid2 = false;
                                    let passing0 = null;
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                            const err0 = {
                                                instancePath: instancePath + '/valueColumns/' + i0,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs5 === errors;
                                    if (_valid0) {
                                        valid2 = true;
                                        passing0 = 0;
                                    }
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                const err1 = {
                                                    instancePath: instancePath + '/valueColumns/' + i0,
                                                    schemaPath: '#/properties/valueColumns/items/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err1];
                                                }
                                                else {
                                                    vErrors.push(err1);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err2 = {
                                                instancePath: instancePath + '/valueColumns/' + i0,
                                                schemaPath: '#/properties/valueColumns/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs8 === errors;
                                    if (_valid0 && valid2) {
                                        valid2 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid2) {
                                        const err3 = {
                                            instancePath: instancePath + '/valueColumns/' + i0,
                                            schemaPath: '#/properties/valueColumns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                        validate218.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs4;
                                        if (vErrors !== null) {
                                            if (_errs4) {
                                                vErrors.length = _errs4;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data0[i1], data0[j0])) {
                                                    validate218.errors = [
                                                        {
                                                            instancePath: instancePath + '/valueColumns',
                                                            schemaPath: '#/properties/valueColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate218.errors = [
                                {
                                    instancePath: instancePath + '/valueColumns',
                                    schemaPath: '#/properties/valueColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupColumns !== undefined) {
                        let data2 = data.groupColumns;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                            if (Array.isArray(data2)) {
                                var valid5 = true;
                                const len1 = data2.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data3 = data2[i2];
                                    const _errs12 = errors;
                                    const _errs13 = errors;
                                    let valid6 = false;
                                    let passing1 = null;
                                    const _errs14 = errors;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                            const err4 = {
                                                instancePath: instancePath + '/groupColumns/' + i2,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs14 === errors;
                                    if (_valid1) {
                                        valid6 = true;
                                        passing1 = 0;
                                    }
                                    const _errs17 = errors;
                                    if (errors === _errs17) {
                                        if (typeof data3 === 'string') {
                                            if (func2(data3) < 1) {
                                                const err5 = {
                                                    instancePath: instancePath + '/groupColumns/' + i2,
                                                    schemaPath: '#/properties/groupColumns/items/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err5];
                                                }
                                                else {
                                                    vErrors.push(err5);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err6 = {
                                                instancePath: instancePath + '/groupColumns/' + i2,
                                                schemaPath: '#/properties/groupColumns/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            }
                                            else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs17 === errors;
                                    if (_valid1 && valid6) {
                                        valid6 = false;
                                        passing1 = [passing1, 1];
                                    }
                                    else {
                                        if (_valid1) {
                                            valid6 = true;
                                            passing1 = 1;
                                        }
                                    }
                                    if (!valid6) {
                                        const err7 = {
                                            instancePath: instancePath + '/groupColumns/' + i2,
                                            schemaPath: '#/properties/groupColumns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing1 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                        validate218.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs13;
                                        if (vErrors !== null) {
                                            if (_errs13) {
                                                vErrors.length = _errs13;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid5 = _errs12 === errors;
                                    if (!valid5) {
                                        break;
                                    }
                                }
                                if (valid5) {
                                    let i3 = data2.length;
                                    let j1;
                                    if (i3 > 1) {
                                        outer1: for (; i3--;) {
                                            for (j1 = i3; j1--;) {
                                                if (func0(data2[i3], data2[j1])) {
                                                    validate218.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupColumns',
                                                            schemaPath: '#/properties/groupColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i3, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer1;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate218.errors = [
                                    {
                                        instancePath: instancePath + '/groupColumns',
                                        schemaPath: '#/properties/groupColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orderColumns !== undefined) {
                            let data4 = data.orderColumns;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (Array.isArray(data4)) {
                                    if (data4.length < 1) {
                                        validate218.errors = [
                                            {
                                                instancePath: instancePath + '/orderColumns',
                                                schemaPath: '#/properties/orderColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid9 = true;
                                        const len2 = data4.length;
                                        for (let i4 = 0; i4 < len2; i4++) {
                                            const _errs21 = errors;
                                            if (!validate219(data4[i4], {
                                                instancePath: instancePath + '/orderColumns/' + i4,
                                                parentData: data4,
                                                parentDataProperty: i4,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid9 = _errs21 === errors;
                                            if (!valid9) {
                                                break;
                                            }
                                        }
                                        if (valid9) {
                                            const keys0 = schema294.properties.orderColumns.uniqueItemProperties;
                                            let k0;
                                            let i5 = data4.length;
                                            let j2;
                                            if (i5 > 1) {
                                                outer2: for (k0 = 0; k0 < keys0.length; k0++) {
                                                    let key0 = keys0[k0];
                                                    for (i5 = data4.length; i5--;) {
                                                        let x0 = data4[i5];
                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                            continue;
                                                        }
                                                        for (j2 = i5; j2--;) {
                                                            let y0 = data4[j2];
                                                            if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func323(x0[key0], y0[key0])) {
                                                                validate218.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/orderColumns',
                                                                        schemaPath: '#/properties/orderColumns/uniqueItemProperties',
                                                                        keyword: 'uniqueItemProperties',
                                                                        params: {},
                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer2;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate218.errors = [
                                        {
                                            instancePath: instancePath + '/orderColumns',
                                            schemaPath: '#/properties/orderColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs19 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.accumulationLevel !== undefined) {
                                let data6 = data.accumulationLevel;
                                const _errs22 = errors;
                                const _errs23 = errors;
                                let valid11 = false;
                                let passing2 = null;
                                const _errs24 = errors;
                                const _errs25 = errors;
                                if (errors === _errs25) {
                                    if (!(data6 && typeof data6 == 'object' && !Array.isArray(data6))) {
                                        const err8 = {
                                            instancePath: instancePath + '/accumulationLevel',
                                            schemaPath: 'urn:wisepipe-base-pipe:CalendarToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err8];
                                        }
                                        else {
                                            vErrors.push(err8);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs24 === errors;
                                if (_valid2) {
                                    valid11 = true;
                                    passing2 = 0;
                                }
                                const _errs27 = errors;
                                if (typeof data6 !== 'string') {
                                    const err9 = {
                                        instancePath: instancePath + '/accumulationLevel',
                                        schemaPath: '#/properties/accumulationLevel/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err9];
                                    }
                                    else {
                                        vErrors.push(err9);
                                    }
                                    errors++;
                                }
                                var _valid2 = _errs27 === errors;
                                if (_valid2 && valid11) {
                                    valid11 = false;
                                    passing2 = [passing2, 1];
                                }
                                else {
                                    if (_valid2) {
                                        valid11 = true;
                                        passing2 = 1;
                                    }
                                }
                                if (!valid11) {
                                    const err10 = {
                                        instancePath: instancePath + '/accumulationLevel',
                                        schemaPath: '#/properties/accumulationLevel/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing2 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                    validate218.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs23;
                                    if (vErrors !== null) {
                                        if (_errs23) {
                                            vErrors.length = _errs23;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs22 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate218.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate218.errors = vErrors;
    return errors === 0;
}
export const periodAddConfigSchemaValidation = validate221;
const schema301 = {
    $id: 'urn:wisepipe-common-pipe:PeriodAddConfig',
    type: 'object',
    properties: {
        periodColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        alias: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        addType: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' }, { type: 'string', enum: ['number', 'column'] }]
        },
        intervalsColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        intervalsNumber: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' }, { type: 'number' }] }
    },
    required: ['periodColumn', 'alias', 'addType'],
    allOf: [
        { if: { properties: { addType: { const: 'column' } } }, then: { required: ['intervalsColumn'] } },
        { if: { properties: { addType: { const: 'number' } } }, then: { required: ['intervalsNumber'] } }
    ]
};
function validate221(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodAddConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.addType !== undefined) {
            if ('column' !== data.addType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.intervalsColumn === undefined && (missing0 = 'intervalsColumn')) {
                validate221.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate221.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.addType !== undefined) {
                if ('number' !== data.addType) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.intervalsNumber === undefined && (missing1 = 'intervalsNumber')) {
                    validate221.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate221.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.periodColumn === undefined && (missing2 = 'periodColumn')) ||
                (data.alias === undefined && (missing2 = 'alias')) ||
                (data.addType === undefined && (missing2 = 'addType'))) {
                validate221.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.periodColumn !== undefined) {
                    let data2 = data.periodColumn;
                    const _errs11 = errors;
                    const _errs12 = errors;
                    let valid6 = false;
                    let passing0 = null;
                    const _errs13 = errors;
                    const _errs14 = errors;
                    if (errors === _errs14) {
                        if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                            const err4 = {
                                instancePath: instancePath + '/periodColumn',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err4];
                            }
                            else {
                                vErrors.push(err4);
                            }
                            errors++;
                        }
                    }
                    var _valid2 = _errs13 === errors;
                    if (_valid2) {
                        valid6 = true;
                        passing0 = 0;
                    }
                    const _errs16 = errors;
                    if (errors === _errs16) {
                        if (typeof data2 === 'string') {
                            if (func2(data2) > 150) {
                                const err5 = {
                                    instancePath: instancePath + '/periodColumn',
                                    schemaPath: '#/properties/periodColumn/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data2) < 1) {
                                    const err6 = {
                                        instancePath: instancePath + '/periodColumn',
                                        schemaPath: '#/properties/periodColumn/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err6];
                                    }
                                    else {
                                        vErrors.push(err6);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err7 = {
                                instancePath: instancePath + '/periodColumn',
                                schemaPath: '#/properties/periodColumn/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                    }
                    var _valid2 = _errs16 === errors;
                    if (_valid2 && valid6) {
                        valid6 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid2) {
                            valid6 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid6) {
                        const err8 = {
                            instancePath: instancePath + '/periodColumn',
                            schemaPath: '#/properties/periodColumn/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                        validate221.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs12;
                        if (vErrors !== null) {
                            if (_errs12) {
                                vErrors.length = _errs12;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid5 = _errs11 === errors;
                }
                else {
                    var valid5 = true;
                }
                if (valid5) {
                    if (data.alias !== undefined) {
                        let data3 = data.alias;
                        const _errs18 = errors;
                        const _errs19 = errors;
                        let valid8 = false;
                        let passing1 = null;
                        const _errs20 = errors;
                        const _errs21 = errors;
                        if (errors === _errs21) {
                            if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                const err9 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                        var _valid3 = _errs20 === errors;
                        if (_valid3) {
                            valid8 = true;
                            passing1 = 0;
                        }
                        const _errs23 = errors;
                        if (errors === _errs23) {
                            if (typeof data3 === 'string') {
                                if (func2(data3) > 150) {
                                    const err10 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/oneOf/1/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                }
                                else {
                                    if (func2(data3) < 1) {
                                        const err11 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err11];
                                        }
                                        else {
                                            vErrors.push(err11);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err12 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                        }
                        var _valid3 = _errs23 === errors;
                        if (_valid3 && valid8) {
                            valid8 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid3) {
                                valid8 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid8) {
                            const err13 = {
                                instancePath: instancePath + '/alias',
                                schemaPath: '#/properties/alias/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                            validate221.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs19;
                            if (vErrors !== null) {
                                if (_errs19) {
                                    vErrors.length = _errs19;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid5 = _errs18 === errors;
                    }
                    else {
                        var valid5 = true;
                    }
                    if (valid5) {
                        if (data.addType !== undefined) {
                            let data4 = data.addType;
                            const _errs25 = errors;
                            const _errs26 = errors;
                            let valid10 = false;
                            let passing2 = null;
                            const _errs27 = errors;
                            const _errs28 = errors;
                            if (errors === _errs28) {
                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                    if (data4.toolEnumType !== undefined) {
                                        let data5 = data4.toolEnumType;
                                        if (typeof data5 !== 'string') {
                                            const err14 = {
                                                instancePath: instancePath + '/addType/toolEnumType',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err14];
                                            }
                                            else {
                                                vErrors.push(err14);
                                            }
                                            errors++;
                                        }
                                        if (!(data5 === 'SortDirection' ||
                                            data5 === 'AggregateColumnOperation' ||
                                            data5 === 'DateFrequency' ||
                                            data5 === 'DateAddType' ||
                                            data5 === 'DateAddUnit' ||
                                            data5 === 'DateUnitType' ||
                                            data5 === 'DatePartType' ||
                                            data5 === 'JoinOperator' ||
                                            data5 === 'JoinPattern' ||
                                            data5 === 'FilterStatementOp' ||
                                            data5 === 'ColumnType' ||
                                            data5 === 'PeriodAddType')) {
                                            const err15 = {
                                                instancePath: instancePath + '/addType/toolEnumType',
                                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err15];
                                            }
                                            else {
                                                vErrors.push(err15);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err16 = {
                                        instancePath: instancePath + '/addType',
                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err16];
                                    }
                                    else {
                                        vErrors.push(err16);
                                    }
                                    errors++;
                                }
                            }
                            var _valid4 = _errs27 === errors;
                            if (_valid4) {
                                valid10 = true;
                                passing2 = 0;
                            }
                            const _errs32 = errors;
                            if (typeof data4 !== 'string') {
                                const err17 = {
                                    instancePath: instancePath + '/addType',
                                    schemaPath: '#/properties/addType/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err17];
                                }
                                else {
                                    vErrors.push(err17);
                                }
                                errors++;
                            }
                            if (!(data4 === 'number' || data4 === 'column')) {
                                const err18 = {
                                    instancePath: instancePath + '/addType',
                                    schemaPath: '#/properties/addType/oneOf/1/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema301.properties.addType.oneOf[1].enum },
                                    message: 'must be equal to one of the allowed values'
                                };
                                if (vErrors === null) {
                                    vErrors = [err18];
                                }
                                else {
                                    vErrors.push(err18);
                                }
                                errors++;
                            }
                            var _valid4 = _errs32 === errors;
                            if (_valid4 && valid10) {
                                valid10 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid4) {
                                    valid10 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid10) {
                                const err19 = {
                                    instancePath: instancePath + '/addType',
                                    schemaPath: '#/properties/addType/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err19];
                                }
                                else {
                                    vErrors.push(err19);
                                }
                                errors++;
                                validate221.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs26;
                                if (vErrors !== null) {
                                    if (_errs26) {
                                        vErrors.length = _errs26;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid5 = _errs25 === errors;
                        }
                        else {
                            var valid5 = true;
                        }
                        if (valid5) {
                            if (data.intervalsColumn !== undefined) {
                                let data6 = data.intervalsColumn;
                                const _errs34 = errors;
                                const _errs35 = errors;
                                let valid13 = false;
                                let passing3 = null;
                                const _errs36 = errors;
                                const _errs37 = errors;
                                if (errors === _errs37) {
                                    if (!(data6 && typeof data6 == 'object' && !Array.isArray(data6))) {
                                        const err20 = {
                                            instancePath: instancePath + '/intervalsColumn',
                                            schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err20];
                                        }
                                        else {
                                            vErrors.push(err20);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs36 === errors;
                                if (_valid5) {
                                    valid13 = true;
                                    passing3 = 0;
                                }
                                const _errs39 = errors;
                                if (errors === _errs39) {
                                    if (typeof data6 === 'string') {
                                        if (func2(data6) > 150) {
                                            const err21 = {
                                                instancePath: instancePath + '/intervalsColumn',
                                                schemaPath: '#/properties/intervalsColumn/oneOf/1/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err21];
                                            }
                                            else {
                                                vErrors.push(err21);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (func2(data6) < 1) {
                                                const err22 = {
                                                    instancePath: instancePath + '/intervalsColumn',
                                                    schemaPath: '#/properties/intervalsColumn/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err22];
                                                }
                                                else {
                                                    vErrors.push(err22);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err23 = {
                                            instancePath: instancePath + '/intervalsColumn',
                                            schemaPath: '#/properties/intervalsColumn/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs39 === errors;
                                if (_valid5 && valid13) {
                                    valid13 = false;
                                    passing3 = [passing3, 1];
                                }
                                else {
                                    if (_valid5) {
                                        valid13 = true;
                                        passing3 = 1;
                                    }
                                }
                                if (!valid13) {
                                    const err24 = {
                                        instancePath: instancePath + '/intervalsColumn',
                                        schemaPath: '#/properties/intervalsColumn/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing3 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                    validate221.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs35;
                                    if (vErrors !== null) {
                                        if (_errs35) {
                                            vErrors.length = _errs35;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid5 = _errs34 === errors;
                            }
                            else {
                                var valid5 = true;
                            }
                            if (valid5) {
                                if (data.intervalsNumber !== undefined) {
                                    let data7 = data.intervalsNumber;
                                    const _errs41 = errors;
                                    const _errs42 = errors;
                                    let valid15 = false;
                                    let passing4 = null;
                                    const _errs43 = errors;
                                    const _errs44 = errors;
                                    if (errors === _errs44) {
                                        if (!(data7 && typeof data7 == 'object' && !Array.isArray(data7))) {
                                            const err25 = {
                                                instancePath: instancePath + '/intervalsNumber',
                                                schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err25];
                                            }
                                            else {
                                                vErrors.push(err25);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid6 = _errs43 === errors;
                                    if (_valid6) {
                                        valid15 = true;
                                        passing4 = 0;
                                    }
                                    const _errs46 = errors;
                                    if (!(typeof data7 == 'number')) {
                                        const err26 = {
                                            instancePath: instancePath + '/intervalsNumber',
                                            schemaPath: '#/properties/intervalsNumber/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err26];
                                        }
                                        else {
                                            vErrors.push(err26);
                                        }
                                        errors++;
                                    }
                                    var _valid6 = _errs46 === errors;
                                    if (_valid6 && valid15) {
                                        valid15 = false;
                                        passing4 = [passing4, 1];
                                    }
                                    else {
                                        if (_valid6) {
                                            valid15 = true;
                                            passing4 = 1;
                                        }
                                    }
                                    if (!valid15) {
                                        const err27 = {
                                            instancePath: instancePath + '/intervalsNumber',
                                            schemaPath: '#/properties/intervalsNumber/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing4 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err27];
                                        }
                                        else {
                                            vErrors.push(err27);
                                        }
                                        errors++;
                                        validate221.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs42;
                                        if (vErrors !== null) {
                                            if (_errs42) {
                                                vErrors.length = _errs42;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid5 = _errs41 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate221.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate221.errors = vErrors;
    return errors === 0;
}
export const periodColumnMetadataSchemaValidation = validate222;
function validate222(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PeriodColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.level === undefined && (missing0 = 'level'))) {
                validate222.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate222.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate222.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate222.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate222.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate222.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate222.errors = vErrors;
    return errors === 0;
}
export const periodDiffConfigSchemaValidation = validate223;
const schema308 = {
    $id: 'urn:wisepipe-common-pipe:PeriodDiffConfig',
    type: 'object',
    properties: {
        lhs: { $ref: 'urn:wisepipe-common-pipe:PeriodOperand' },
        rhs: { $ref: 'urn:wisepipe-common-pipe:PeriodOperand' },
        includeStartPeriod: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:BoolToolVariable' }, { type: 'boolean' }] },
        alias: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['lhs', 'rhs', 'includeStartPeriod', 'alias']
};
const schema309 = {
    $id: 'urn:wisepipe-common-pipe:PeriodOperand',
    type: 'object',
    properties: { operandType: { type: 'string', enum: ['column', 'literal'] } },
    required: ['operandType']
};
function validate223(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodDiffConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lhs === undefined && (missing0 = 'lhs')) ||
                (data.rhs === undefined && (missing0 = 'rhs')) ||
                (data.includeStartPeriod === undefined && (missing0 = 'includeStartPeriod')) ||
                (data.alias === undefined && (missing0 = 'alias'))) {
                validate223.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lhs !== undefined) {
                    let data0 = data.lhs;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.operandType === undefined && (missing1 = 'operandType')) {
                                validate223.errors = [
                                    {
                                        instancePath: instancePath + '/lhs',
                                        schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.operandType !== undefined) {
                                    let data1 = data0.operandType;
                                    if (typeof data1 !== 'string') {
                                        validate223.errors = [
                                            {
                                                instancePath: instancePath + '/lhs/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/properties/operandType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data1 === 'column' || data1 === 'literal')) {
                                        validate223.errors = [
                                            {
                                                instancePath: instancePath + '/lhs/operandType',
                                                schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/properties/operandType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema309.properties.operandType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate223.errors = [
                                {
                                    instancePath: instancePath + '/lhs',
                                    schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rhs !== undefined) {
                        let data2 = data.rhs;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing2;
                                if (data2.operandType === undefined && (missing2 = 'operandType')) {
                                    validate223.errors = [
                                        {
                                            instancePath: instancePath + '/rhs',
                                            schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.operandType !== undefined) {
                                        let data3 = data2.operandType;
                                        if (typeof data3 !== 'string') {
                                            validate223.errors = [
                                                {
                                                    instancePath: instancePath + '/rhs/operandType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/properties/operandType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data3 === 'column' || data3 === 'literal')) {
                                            validate223.errors = [
                                                {
                                                    instancePath: instancePath + '/rhs/operandType',
                                                    schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/properties/operandType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema309.properties.operandType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate223.errors = [
                                    {
                                        instancePath: instancePath + '/rhs',
                                        schemaPath: 'urn:wisepipe-common-pipe:PeriodOperand/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.includeStartPeriod !== undefined) {
                            let data4 = data.includeStartPeriod;
                            const _errs11 = errors;
                            const _errs12 = errors;
                            let valid5 = false;
                            let passing0 = null;
                            const _errs13 = errors;
                            const _errs14 = errors;
                            if (errors === _errs14) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err0 = {
                                        instancePath: instancePath + '/includeStartPeriod',
                                        schemaPath: 'urn:wisepipe-base-pipe:BoolToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                            }
                            var _valid0 = _errs13 === errors;
                            if (_valid0) {
                                valid5 = true;
                                passing0 = 0;
                            }
                            const _errs16 = errors;
                            if (typeof data4 !== 'boolean') {
                                const err1 = {
                                    instancePath: instancePath + '/includeStartPeriod',
                                    schemaPath: '#/properties/includeStartPeriod/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            var _valid0 = _errs16 === errors;
                            if (_valid0 && valid5) {
                                valid5 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid0) {
                                    valid5 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid5) {
                                const err2 = {
                                    instancePath: instancePath + '/includeStartPeriod',
                                    schemaPath: '#/properties/includeStartPeriod/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                                validate223.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs12;
                                if (vErrors !== null) {
                                    if (_errs12) {
                                        vErrors.length = _errs12;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs11 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.alias !== undefined) {
                                let data5 = data.alias;
                                const _errs18 = errors;
                                const _errs19 = errors;
                                let valid7 = false;
                                let passing1 = null;
                                const _errs20 = errors;
                                const _errs21 = errors;
                                if (errors === _errs21) {
                                    if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                        const err3 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid1 = _errs20 === errors;
                                if (_valid1) {
                                    valid7 = true;
                                    passing1 = 0;
                                }
                                const _errs23 = errors;
                                if (errors === _errs23) {
                                    if (typeof data5 === 'string') {
                                        if (func2(data5) > 150) {
                                            const err4 = {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/oneOf/1/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (func2(data5) < 1) {
                                                const err5 = {
                                                    instancePath: instancePath + '/alias',
                                                    schemaPath: '#/properties/alias/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err5];
                                                }
                                                else {
                                                    vErrors.push(err5);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err6 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid1 = _errs23 === errors;
                                if (_valid1 && valid7) {
                                    valid7 = false;
                                    passing1 = [passing1, 1];
                                }
                                else {
                                    if (_valid1) {
                                        valid7 = true;
                                        passing1 = 1;
                                    }
                                }
                                if (!valid7) {
                                    const err7 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing1 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err7];
                                    }
                                    else {
                                        vErrors.push(err7);
                                    }
                                    errors++;
                                    validate223.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs19;
                                    if (vErrors !== null) {
                                        if (_errs19) {
                                            vErrors.length = _errs19;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs18 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate223.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate223.errors = vErrors;
    return errors === 0;
}
export const periodMapperConfigSchemaValidation = validate224;
const schema313 = {
    $id: 'urn:wisepipe-common-pipe:PeriodMapperConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        newColumnName: { type: 'string', minLength: 1 },
        startDate: { type: 'string', format: 'date-time' },
        endDate: { type: 'string', format: 'date-time' },
        periodType: { type: 'string', enum: ['monthly', 'semi_monthly', 'two_week', 'four_week', 'weekly'] },
        generatedPeriods: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:DatePeriod' }, minItems: 1 },
        outOfRangeValue: { type: 'string', minLength: 1 }
    },
    required: ['dateColumn', 'newColumnName', 'startDate', 'endDate', 'periodType', 'generatedPeriods']
};
function validate224(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodMapperConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.newColumnName === undefined && (missing0 = 'newColumnName')) ||
                (data.startDate === undefined && (missing0 = 'startDate')) ||
                (data.endDate === undefined && (missing0 = 'endDate')) ||
                (data.periodType === undefined && (missing0 = 'periodType')) ||
                (data.generatedPeriods === undefined && (missing0 = 'generatedPeriods'))) {
                validate224.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate224.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate224.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newColumnName !== undefined) {
                        let data1 = data.newColumnName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate224.errors = [
                                        {
                                            instancePath: instancePath + '/newColumnName',
                                            schemaPath: '#/properties/newColumnName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate224.errors = [
                                    {
                                        instancePath: instancePath + '/newColumnName',
                                        schemaPath: '#/properties/newColumnName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.startDate !== undefined) {
                            let data2 = data.startDate;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate224.errors = [
                                                {
                                                    instancePath: instancePath + '/startDate',
                                                    schemaPath: '#/properties/startDate/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate224.errors = [
                                            {
                                                instancePath: instancePath + '/startDate',
                                                schemaPath: '#/properties/startDate/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.endDate !== undefined) {
                                let data3 = data.endDate;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.validate(data3)) {
                                                validate224.errors = [
                                                    {
                                                        instancePath: instancePath + '/endDate',
                                                        schemaPath: '#/properties/endDate/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate224.errors = [
                                                {
                                                    instancePath: instancePath + '/endDate',
                                                    schemaPath: '#/properties/endDate/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.periodType !== undefined) {
                                    let data4 = data.periodType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate224.errors = [
                                            {
                                                instancePath: instancePath + '/periodType',
                                                schemaPath: '#/properties/periodType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'monthly' ||
                                        data4 === 'semi_monthly' ||
                                        data4 === 'two_week' ||
                                        data4 === 'four_week' ||
                                        data4 === 'weekly')) {
                                        validate224.errors = [
                                            {
                                                instancePath: instancePath + '/periodType',
                                                schemaPath: '#/properties/periodType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema313.properties.periodType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.generatedPeriods !== undefined) {
                                        let data5 = data.generatedPeriods;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (Array.isArray(data5)) {
                                                if (data5.length < 1) {
                                                    validate224.errors = [
                                                        {
                                                            instancePath: instancePath + '/generatedPeriods',
                                                            schemaPath: '#/properties/generatedPeriods/minItems',
                                                            keyword: 'minItems',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 items'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    var valid1 = true;
                                                    const len0 = data5.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data6 = data5[i0];
                                                        const _errs13 = errors;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                                let missing1;
                                                                if ((data6.periodName === undefined && (missing1 = 'periodName')) ||
                                                                    (data6.startDate === undefined && (missing1 = 'startDate')) ||
                                                                    (data6.endDate === undefined && (missing1 = 'endDate'))) {
                                                                    validate224.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/generatedPeriods/' + i0,
                                                                            schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing1 },
                                                                            message: "must have required property '" + missing1 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data6.periodName !== undefined) {
                                                                        let data7 = data6.periodName;
                                                                        const _errs16 = errors;
                                                                        if (errors === _errs16) {
                                                                            if (typeof data7 === 'string') {
                                                                                if (func2(data7) < 1) {
                                                                                    validate224.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/generatedPeriods/' + i0 + '/periodName',
                                                                                            schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/properties/periodName/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate224.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/generatedPeriods/' + i0 + '/periodName',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/properties/periodName/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid3 = _errs16 === errors;
                                                                    }
                                                                    else {
                                                                        var valid3 = true;
                                                                    }
                                                                    if (valid3) {
                                                                        if (data6.startDate !== undefined) {
                                                                            let data8 = data6.startDate;
                                                                            const _errs18 = errors;
                                                                            if (errors === _errs18) {
                                                                                if (errors === _errs18) {
                                                                                    if (typeof data8 === 'string') {
                                                                                        if (!formats0.validate(data8)) {
                                                                                            validate224.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/generatedPeriods/' + i0 + '/startDate',
                                                                                                    schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/properties/startDate/format',
                                                                                                    keyword: 'format',
                                                                                                    params: { format: 'date-time' },
                                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate224.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/generatedPeriods/' + i0 + '/startDate',
                                                                                                schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/properties/startDate/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                            var valid3 = _errs18 === errors;
                                                                        }
                                                                        else {
                                                                            var valid3 = true;
                                                                        }
                                                                        if (valid3) {
                                                                            if (data6.endDate !== undefined) {
                                                                                let data9 = data6.endDate;
                                                                                const _errs20 = errors;
                                                                                if (errors === _errs20) {
                                                                                    if (errors === _errs20) {
                                                                                        if (typeof data9 === 'string') {
                                                                                            if (!formats0.validate(data9)) {
                                                                                                validate224.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/generatedPeriods/' + i0 + '/endDate',
                                                                                                        schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/properties/endDate/format',
                                                                                                        keyword: 'format',
                                                                                                        params: { format: 'date-time' },
                                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate224.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/generatedPeriods/' + i0 + '/endDate',
                                                                                                    schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/properties/endDate/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                var valid3 = _errs20 === errors;
                                                                            }
                                                                            else {
                                                                                var valid3 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate224.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/generatedPeriods/' + i0,
                                                                        schemaPath: 'urn:wisepipe-common-pipe:DatePeriod/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid1 = _errs13 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate224.errors = [
                                                    {
                                                        instancePath: instancePath + '/generatedPeriods',
                                                        schemaPath: '#/properties/generatedPeriods/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.outOfRangeValue !== undefined) {
                                            let data10 = data.outOfRangeValue;
                                            const _errs22 = errors;
                                            if (errors === _errs22) {
                                                if (typeof data10 === 'string') {
                                                    if (func2(data10) < 1) {
                                                        validate224.errors = [
                                                            {
                                                                instancePath: instancePath + '/outOfRangeValue',
                                                                schemaPath: '#/properties/outOfRangeValue/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate224.errors = [
                                                        {
                                                            instancePath: instancePath + '/outOfRangeValue',
                                                            schemaPath: '#/properties/outOfRangeValue/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs22 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate224.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate224.errors = vErrors;
    return errors === 0;
}
export const periodOperandColumnSchemaValidation = validate225;
const schema315 = {
    $id: 'urn:wisepipe-common-pipe:PeriodOperandColumn',
    type: 'object',
    properties: {
        name: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['name']
};
function validate225(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodOperandColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate225.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/name',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/name',
                                schemaPath: '#/properties/name/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate225.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate225.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate225.errors = vErrors;
    return errors === 0;
}
export const periodOperandLiteralSchemaValidation = validate226;
const schema317 = {
    $id: 'urn:wisepipe-common-pipe:PeriodOperandLiteral',
    type: 'object',
    properties: {
        period: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1 }] }
    },
    required: ['period']
};
function validate226(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodOperandLiteral" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.period === undefined && (missing0 = 'period')) {
                validate226.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.period !== undefined) {
                    let data0 = data.period;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/period',
                                schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                const err1 = {
                                    instancePath: instancePath + '/period',
                                    schemaPath: '#/properties/period/oneOf/1/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err2 = {
                                instancePath: instancePath + '/period',
                                schemaPath: '#/properties/period/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err3 = {
                            instancePath: instancePath + '/period',
                            schemaPath: '#/properties/period/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                        validate226.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate226.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate226.errors = vErrors;
    return errors === 0;
}
export const periodOperandSchemaValidation = validate227;
function validate227(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PeriodOperand" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.operandType === undefined && (missing0 = 'operandType')) {
                validate227.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.operandType !== undefined) {
                    let data0 = data.operandType;
                    if (typeof data0 !== 'string') {
                        validate227.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'column' || data0 === 'literal')) {
                        validate227.errors = [
                            {
                                instancePath: instancePath + '/operandType',
                                schemaPath: '#/properties/operandType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema309.properties.operandType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate227.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate227.errors = vErrors;
    return errors === 0;
}
export const picklistColumnMetadataSchemaValidation = validate228;
function validate228(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PicklistColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.table === undefined && (missing0 = 'table')) || (data.column === undefined && (missing0 = 'column'))) {
                validate228.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    let data0 = data.table;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate228.errors = [
                                    {
                                        instancePath: instancePath + '/table',
                                        schemaPath: '#/properties/table/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate228.errors = [
                                {
                                    instancePath: instancePath + '/table',
                                    schemaPath: '#/properties/table/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        let data1 = data.column;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate228.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate228.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate228.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate228.errors = vErrors;
    return errors === 0;
}
export const picklistColumnSchemaValidation = validate111;
export const picklistHierarchyNodeSchemaValidation = validate229;
function validate229(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PicklistHierarchyNode" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.level === undefined && (missing0 = 'level')) ||
                (data.columnName === undefined && (missing0 = 'columnName'))) {
                validate229.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.level !== undefined) {
                    let data0 = data.level;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 2 || isNaN(data0)) {
                                validate229.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 2 },
                                        message: 'must be <= 2'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 0 || isNaN(data0)) {
                                    validate229.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate229.errors = [
                                {
                                    instancePath: instancePath + '/level',
                                    schemaPath: '#/properties/level/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.columnName !== 'string') {
                            validate229.errors = [
                                {
                                    instancePath: instancePath + '/columnName',
                                    schemaPath: '#/properties/columnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.attributes !== undefined) {
                            let data2 = data.attributes;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs7 = errors;
                                        if (typeof data2[i0] !== 'string') {
                                            validate229.errors = [
                                                {
                                                    instancePath: instancePath + '/attributes/' + i0,
                                                    schemaPath: '#/properties/attributes/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate229.errors = [
                                        {
                                            instancePath: instancePath + '/attributes',
                                            schemaPath: '#/properties/attributes/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate229.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate229.errors = vErrors;
    return errors === 0;
}
export const pipeConfigSchemaValidation = validate230;
const schema322 = {
    $id: 'urn:wisepipe-common-pipe:PipeConfig',
    type: 'object',
    properties: { pipeID: { type: 'string', uid: 10 } },
    required: ['pipeID']
};
const func343 = ucs2length;
const func344 = base64urlToBuffer;
const func345 = base64urlEncode;
const func346 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate230(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.pipeID === undefined && (missing0 = 'pipeID')) {
                validate230.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func343(data0) < b64min0 || func343(data0) > b64max0) {
                                validate230.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func343(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func343(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func344(data0);
                                if (decoded0.length !== 10) {
                                    validate230.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func345(decoded0);
                                    if (func346(encoded0) !== func346(data0)) {
                                        validate230.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate230.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate230.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate230.errors = vErrors;
    return errors === 0;
}
export const pipeCopyEventSchemaValidation = validate231;
const schema323 = {
    $id: 'urn:wisepipe-common-pipe:PipeCopyEvent',
    type: 'object',
    properties: {
        oldOrgID: { type: 'string', format: 'uuid' },
        oldPipeID: { type: 'string', uid: 10 },
        newOrgID: { type: 'string', format: 'uuid' },
        newPipeID: { type: 'string', uid: 10 },
        elementIDMap: { type: 'object', additionalProperties: { type: 'string', uid: 10 } }
    },
    required: ['oldOrgID', 'oldPipeID', 'newOrgID', 'newPipeID', 'elementIDMap']
};
const func347 = ucs2length;
const func348 = base64urlToBuffer;
const func349 = base64urlEncode;
const func350 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func351 = ucs2length;
const func352 = base64urlToBuffer;
const func353 = base64urlEncode;
const func354 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func355 = ucs2length;
const func356 = base64urlToBuffer;
const func357 = base64urlEncode;
const func358 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate231(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeCopyEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.oldOrgID === undefined && (missing0 = 'oldOrgID')) ||
                (data.oldPipeID === undefined && (missing0 = 'oldPipeID')) ||
                (data.newOrgID === undefined && (missing0 = 'newOrgID')) ||
                (data.newPipeID === undefined && (missing0 = 'newPipeID')) ||
                (data.elementIDMap === undefined && (missing0 = 'elementIDMap'))) {
                validate231.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.oldOrgID !== undefined) {
                    let data0 = data.oldOrgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate231.errors = [
                                        {
                                            instancePath: instancePath + '/oldOrgID',
                                            schemaPath: '#/properties/oldOrgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate231.errors = [
                                    {
                                        instancePath: instancePath + '/oldOrgID',
                                        schemaPath: '#/properties/oldOrgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.oldPipeID !== undefined) {
                        let data1 = data.oldPipeID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func347(data1) < b64min0 || func347(data1) > b64max0) {
                                    validate231.errors = [
                                        {
                                            instancePath: instancePath + '/oldPipeID',
                                            schemaPath: '#/properties/oldPipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func347(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func347(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func348(data1);
                                    if (decoded0.length !== 10) {
                                        validate231.errors = [
                                            {
                                                instancePath: instancePath + '/oldPipeID',
                                                schemaPath: '#/properties/oldPipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func349(decoded0);
                                        if (func350(encoded0) !== func350(data1)) {
                                            validate231.errors = [
                                                {
                                                    instancePath: instancePath + '/oldPipeID',
                                                    schemaPath: '#/properties/oldPipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate231.errors = [
                                    {
                                        instancePath: instancePath + '/oldPipeID',
                                        schemaPath: '#/properties/oldPipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.newOrgID !== undefined) {
                            let data2 = data.newOrgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats4.test(data2)) {
                                            validate231.errors = [
                                                {
                                                    instancePath: instancePath + '/newOrgID',
                                                    schemaPath: '#/properties/newOrgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate231.errors = [
                                            {
                                                instancePath: instancePath + '/newOrgID',
                                                schemaPath: '#/properties/newOrgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.newPipeID !== undefined) {
                                let data3 = data.newPipeID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 10) / 3);
                                        const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                        if (func351(data3) < b64min1 || func351(data3) > b64max1) {
                                            validate231.errors = [
                                                {
                                                    instancePath: instancePath + '/newPipeID',
                                                    schemaPath: '#/properties/newPipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func351(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func351(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func352(data3);
                                            if (decoded1.length !== 10) {
                                                validate231.errors = [
                                                    {
                                                        instancePath: instancePath + '/newPipeID',
                                                        schemaPath: '#/properties/newPipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func353(decoded1);
                                                if (func354(encoded1) !== func354(data3)) {
                                                    validate231.errors = [
                                                        {
                                                            instancePath: instancePath + '/newPipeID',
                                                            schemaPath: '#/properties/newPipeID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate231.errors = [
                                            {
                                                instancePath: instancePath + '/newPipeID',
                                                schemaPath: '#/properties/newPipeID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.elementIDMap !== undefined) {
                                    let data4 = data.elementIDMap;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            for (const key0 in data4) {
                                                let data5 = data4[key0];
                                                const _errs12 = errors;
                                                if (errors === _errs12) {
                                                    if (typeof data5 === 'string') {
                                                        const b64min2 = Math.ceil((4 * 10) / 3);
                                                        const b64max2 = Math.ceil((4 * 10) / 3) + 3;
                                                        if (func355(data5) < b64min2 || func355(data5) > b64max2) {
                                                            validate231.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elementIDMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: '#/properties/elementIDMap/additionalProperties/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min2,
                                                                        b64max: b64max2,
                                                                        length: func355(data5)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min2 +
                                                                        ' and ' +
                                                                        b64max2 +
                                                                        ', but is ' +
                                                                        func355(data5)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded2 = func356(data5);
                                                            if (decoded2.length !== 10) {
                                                                validate231.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elementIDMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/elementIDMap/additionalProperties/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 10 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded2 = func357(decoded2);
                                                                if (func358(encoded2) !== func358(data5)) {
                                                                    validate231.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elementIDMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/elementIDMap/additionalProperties/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate231.errors = [
                                                            {
                                                                instancePath: instancePath + '/elementIDMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/elementIDMap/additionalProperties/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs12 === errors;
                                                if (!valid3) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate231.errors = [
                                                {
                                                    instancePath: instancePath + '/elementIDMap',
                                                    schemaPath: '#/properties/elementIDMap/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate231.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate231.errors = vErrors;
    return errors === 0;
}
export const pipeDependeeSchemaValidation = validate232;
const schema324 = {
    $id: 'urn:wisepipe-common-pipe:PipeDependee',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elements: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:GraphElement' } }
    },
    required: ['pipeID', 'elements']
};
const func359 = ucs2length;
const func360 = base64urlToBuffer;
const func361 = base64urlEncode;
const func362 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func363 = ucs2length;
const func364 = base64urlToBuffer;
const func365 = base64urlEncode;
const func366 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate232(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeDependee" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elements === undefined && (missing0 = 'elements'))) {
                validate232.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func359(data0) < b64min0 || func359(data0) > b64max0) {
                                validate232.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func359(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func359(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func360(data0);
                                if (decoded0.length !== 10) {
                                    validate232.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func361(decoded0);
                                    if (func362(encoded0) !== func362(data0)) {
                                        validate232.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate232.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elements !== undefined) {
                        let data1 = data.elements;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid2 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                            let missing1;
                                            if ((data2.elementID === undefined && (missing1 = 'elementID')) ||
                                                (data2.elementType === undefined && (missing1 = 'elementType'))) {
                                                validate232.errors = [
                                                    {
                                                        instancePath: instancePath + '/elements/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing1 },
                                                        message: "must have required property '" + missing1 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data2.elementID !== undefined) {
                                                    let data3 = data2.elementID;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            const b64min1 = Math.ceil((4 * 10) / 3);
                                                            const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                                            if (func363(data3) < b64min1 || func363(data3) > b64max1) {
                                                                validate232.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min1,
                                                                            b64max: b64max1,
                                                                            length: func363(data3)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min1 +
                                                                            ' and ' +
                                                                            b64max1 +
                                                                            ', but is ' +
                                                                            func363(data3)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded1 = func364(data3);
                                                                if (decoded1.length !== 10) {
                                                                    validate232.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 10 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded1 = func365(decoded1);
                                                                    if (func366(encoded1) !== func366(data3)) {
                                                                        validate232.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate232.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data2.elementType !== undefined) {
                                                        let data4 = data2.elementType;
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (typeof data4 === 'string') {
                                                                if (!pattern8.test(data4)) {
                                                                    validate232.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/pattern',
                                                                            keyword: 'pattern',
                                                                            params: { pattern: 'edge|node|group' },
                                                                            message: 'must match pattern "' + 'edge|node|group' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate232.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid4 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data2.lastModified !== undefined) {
                                                            let data5 = data2.lastModified;
                                                            const _errs12 = errors;
                                                            if (errors === _errs12) {
                                                                if (errors === _errs12) {
                                                                    if (typeof data5 === 'string') {
                                                                        if (!formats0.validate(data5)) {
                                                                            validate232.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate232.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid4 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data2.uniqueChangeID !== undefined) {
                                                                const _errs14 = errors;
                                                                if (typeof data2.uniqueChangeID !== 'string') {
                                                                    validate232.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/uniqueChangeID',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/uniqueChangeID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs14 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate232.errors = [
                                                {
                                                    instancePath: instancePath + '/elements/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs5 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate232.errors = [
                                    {
                                        instancePath: instancePath + '/elements',
                                        schemaPath: '#/properties/elements/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate232.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate232.errors = vErrors;
    return errors === 0;
}
export const pipeDocumentationSchemaValidation = validate233;
const schema326 = {
    $id: 'urn:wisepipe-base-pipe:PipeDocumentation',
    type: 'object',
    properties: {
        lastModified: { type: 'string', format: 'date-time' },
        content: { type: 'string', minLength: 1, maxLength: 50000 }
    },
    required: ['lastModified', 'content']
};
function validate233(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:PipeDocumentation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lastModified === undefined && (missing0 = 'lastModified')) ||
                (data.content === undefined && (missing0 = 'content'))) {
                validate233.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lastModified !== undefined) {
                    let data0 = data.lastModified;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate233.errors = [
                                        {
                                            instancePath: instancePath + '/lastModified',
                                            schemaPath: '#/properties/lastModified/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate233.errors = [
                                    {
                                        instancePath: instancePath + '/lastModified',
                                        schemaPath: '#/properties/lastModified/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.content !== undefined) {
                        let data1 = data.content;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 50000) {
                                    validate233.errors = [
                                        {
                                            instancePath: instancePath + '/content',
                                            schemaPath: '#/properties/content/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 50000 },
                                            message: 'must NOT have more than 50000 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate233.errors = [
                                            {
                                                instancePath: instancePath + '/content',
                                                schemaPath: '#/properties/content/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate233.errors = [
                                    {
                                        instancePath: instancePath + '/content',
                                        schemaPath: '#/properties/content/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate233.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate233.errors = vErrors;
    return errors === 0;
}
export const pipeEventSchemaValidation = validate234;
const schema327 = {
    $id: 'urn:wisepipe-common-pipe:PipeEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        pipeID: { type: 'string', uid: 10 },
        type: { type: 'string', enum: ['insert', 'remove', 'update_mode'] },
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' }
    },
    required: ['orgID', 'pipeID', 'type']
};
const func369 = ucs2length;
const func370 = base64urlToBuffer;
const func371 = base64urlEncode;
const func372 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate234(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.type === undefined && (missing0 = 'type'))) {
                validate234.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate234.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate234.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgPlan !== undefined) {
                        let data1 = data.orgPlan;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate234.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'Social' ||
                            data1 === 'Enterprise' ||
                            data1 === 'Integration' ||
                            data1 === 'Temp' ||
                            data1 === 'Starter' ||
                            data1 === 'Professional')) {
                            validate234.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema327.properties.orgPlan.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pipeID !== undefined) {
                            let data2 = data.pipeID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 10) / 3);
                                    const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func369(data2) < b64min0 || func369(data2) > b64max0) {
                                        validate234.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func369(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func369(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func370(data2);
                                        if (decoded0.length !== 10) {
                                            validate234.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func371(decoded0);
                                            if (func372(encoded0) !== func372(data2)) {
                                                validate234.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate234.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.type !== undefined) {
                                let data3 = data.type;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate234.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'insert' || data3 === 'remove' || data3 === 'update_mode')) {
                                    validate234.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema327.properties.type.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.userID !== undefined) {
                                    let data4 = data.userID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats4.test(data4)) {
                                                    validate234.errors = [
                                                        {
                                                            instancePath: instancePath + '/userID',
                                                            schemaPath: '#/properties/userID/format',
                                                            keyword: 'format',
                                                            params: { format: 'uuid' },
                                                            message: 'must match format "' + 'uuid' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate234.errors = [
                                                    {
                                                        instancePath: instancePath + '/userID',
                                                        schemaPath: '#/properties/userID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.userName !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.userName !== 'string') {
                                            validate234.errors = [
                                                {
                                                    instancePath: instancePath + '/userName',
                                                    schemaPath: '#/properties/userName/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.userEmail !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.userEmail !== 'string') {
                                                validate234.errors = [
                                                    {
                                                        instancePath: instancePath + '/userEmail',
                                                        schemaPath: '#/properties/userEmail/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate234.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate234.errors = vErrors;
    return errors === 0;
}
export const pipeFolderPostRequestSchemaValidation = validate235;
const schema328 = {
    $id: 'urn:wisepipe-common-pipe:PipeFolderPostRequest',
    type: 'object',
    properties: { name: { type: 'string', minLength: 1, maxLength: 100 }, parentFolderID: { type: 'string', uid: 9 } },
    required: ['name']
};
const func375 = ucs2length;
const func376 = base64urlToBuffer;
const func377 = base64urlEncode;
const func378 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate235(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeFolderPostRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate235.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate235.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate235.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate235.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.parentFolderID !== undefined) {
                        let data1 = data.parentFolderID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func375(data1) < b64min0 || func375(data1) > b64max0) {
                                    validate235.errors = [
                                        {
                                            instancePath: instancePath + '/parentFolderID',
                                            schemaPath: '#/properties/parentFolderID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func375(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func375(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func376(data1);
                                    if (decoded0.length !== 9) {
                                        validate235.errors = [
                                            {
                                                instancePath: instancePath + '/parentFolderID',
                                                schemaPath: '#/properties/parentFolderID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func377(decoded0);
                                        if (func378(encoded0) !== func378(data1)) {
                                            validate235.errors = [
                                                {
                                                    instancePath: instancePath + '/parentFolderID',
                                                    schemaPath: '#/properties/parentFolderID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate235.errors = [
                                    {
                                        instancePath: instancePath + '/parentFolderID',
                                        schemaPath: '#/properties/parentFolderID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate235.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate235.errors = vErrors;
    return errors === 0;
}
export const pipeFolderSchemaValidation = validate236;
const schema329 = {
    $id: 'urn:wisepipe-common-pipe:PipeFolder',
    type: 'object',
    properties: {
        folderID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        createdAt: { type: 'string', format: 'date-time' },
        parentFolderID: { type: 'string', uid: 9, not: { const: { $data: '1/folderID' } } }
    },
    required: ['folderID', 'name', 'createdAt']
};
const func379 = ucs2length;
const func380 = base64urlToBuffer;
const func381 = base64urlEncode;
const func382 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func386 = ucs2length;
const func387 = base64urlToBuffer;
const func388 = base64urlEncode;
const func389 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate236(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeFolder" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.folderID === undefined && (missing0 = 'folderID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt'))) {
                validate236.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.folderID !== undefined) {
                    let data0 = data.folderID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func379(data0) < b64min0 || func379(data0) > b64max0) {
                                validate236.errors = [
                                    {
                                        instancePath: instancePath + '/folderID',
                                        schemaPath: '#/properties/folderID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func379(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func379(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func380(data0);
                                if (decoded0.length !== 9) {
                                    validate236.errors = [
                                        {
                                            instancePath: instancePath + '/folderID',
                                            schemaPath: '#/properties/folderID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func381(decoded0);
                                    if (func382(encoded0) !== func382(data0)) {
                                        validate236.errors = [
                                            {
                                                instancePath: instancePath + '/folderID',
                                                schemaPath: '#/properties/folderID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate236.errors = [
                                {
                                    instancePath: instancePath + '/folderID',
                                    schemaPath: '#/properties/folderID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate236.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate236.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate236.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.createdAt !== undefined) {
                            let data2 = data.createdAt;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate236.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate236.errors = [
                                            {
                                                instancePath: instancePath + '/createdAt',
                                                schemaPath: '#/properties/createdAt/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.parentFolderID !== undefined) {
                                let data3 = data.parentFolderID;
                                const _errs7 = errors;
                                const _errs9 = errors;
                                const _errs10 = errors;
                                const vSchema0 = data && data.folderID;
                                if (vSchema0 !== undefined && !func0(data3, vSchema0)) {
                                    const err0 = {};
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                                var valid2 = _errs10 === errors;
                                if (valid2) {
                                    validate236.errors = [
                                        {
                                            instancePath: instancePath + '/parentFolderID',
                                            schemaPath: '#/properties/parentFolderID/not',
                                            keyword: 'not',
                                            params: {},
                                            message: 'must NOT be valid'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    errors = _errs9;
                                    if (vErrors !== null) {
                                        if (_errs9) {
                                            vErrors.length = _errs9;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func386(data3) < b64min1 || func386(data3) > b64max1) {
                                            validate236.errors = [
                                                {
                                                    instancePath: instancePath + '/parentFolderID',
                                                    schemaPath: '#/properties/parentFolderID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func386(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func386(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func387(data3);
                                            if (decoded1.length !== 9) {
                                                validate236.errors = [
                                                    {
                                                        instancePath: instancePath + '/parentFolderID',
                                                        schemaPath: '#/properties/parentFolderID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func388(decoded1);
                                                if (func389(encoded1) !== func389(data3)) {
                                                    validate236.errors = [
                                                        {
                                                            instancePath: instancePath + '/parentFolderID',
                                                            schemaPath: '#/properties/parentFolderID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate236.errors = [
                                            {
                                                instancePath: instancePath + '/parentFolderID',
                                                schemaPath: '#/properties/parentFolderID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate236.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate236.errors = vErrors;
    return errors === 0;
}
export const pipeMigrationRequestSchemaValidation = validate237;
const schema330 = {
    $id: 'urn:wisepipe-common-pipe:PipeMigrationRequest',
    type: 'object',
    properties: {
        migrateToOrgID: { type: 'string', format: 'uuid' },
        migrateFromOrgID: { type: 'string', format: 'uuid' },
        integrationUserID: { type: 'string' },
        pipeVersionMap: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                properties: { sourcePipeID: { type: 'string', uid: 10 }, sourceVersionID: { type: 'string', uid: 10 } }
            }
        },
        incentivesImportNodeNameMap: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-pipe:IncentivesImportConfigByName' }
        },
        incentivesTableNodeDSMap: { type: 'object', additionalProperties: { type: 'string' } },
        reusableLogicVersionMap: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                properties: { sourceReusableLogicID: { type: 'string', uid: 9 }, sourceVersionID: { type: 'string', uid: 9 } }
            }
        }
    },
    required: ['migrateToOrgID', 'migrateFromOrgID', 'integrationUserID', 'pipeVersionMap']
};
const func390 = ucs2length;
const func391 = base64urlToBuffer;
const func392 = base64urlEncode;
const func393 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func394 = ucs2length;
const func395 = base64urlToBuffer;
const func396 = base64urlEncode;
const func397 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func398 = ucs2length;
const func399 = base64urlToBuffer;
const func400 = base64urlEncode;
const func401 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func402 = ucs2length;
const func403 = base64urlToBuffer;
const func404 = base64urlEncode;
const func405 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate237(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeMigrationRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.migrateToOrgID === undefined && (missing0 = 'migrateToOrgID')) ||
                (data.migrateFromOrgID === undefined && (missing0 = 'migrateFromOrgID')) ||
                (data.integrationUserID === undefined && (missing0 = 'integrationUserID')) ||
                (data.pipeVersionMap === undefined && (missing0 = 'pipeVersionMap'))) {
                validate237.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.migrateToOrgID !== undefined) {
                    let data0 = data.migrateToOrgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate237.errors = [
                                        {
                                            instancePath: instancePath + '/migrateToOrgID',
                                            schemaPath: '#/properties/migrateToOrgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate237.errors = [
                                    {
                                        instancePath: instancePath + '/migrateToOrgID',
                                        schemaPath: '#/properties/migrateToOrgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.migrateFromOrgID !== undefined) {
                        let data1 = data.migrateFromOrgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate237.errors = [
                                            {
                                                instancePath: instancePath + '/migrateFromOrgID',
                                                schemaPath: '#/properties/migrateFromOrgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate237.errors = [
                                        {
                                            instancePath: instancePath + '/migrateFromOrgID',
                                            schemaPath: '#/properties/migrateFromOrgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.integrationUserID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.integrationUserID !== 'string') {
                                validate237.errors = [
                                    {
                                        instancePath: instancePath + '/integrationUserID',
                                        schemaPath: '#/properties/integrationUserID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.pipeVersionMap !== undefined) {
                                let data3 = data.pipeVersionMap;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        for (const key0 in data3) {
                                            let data4 = data3[key0];
                                            const _errs10 = errors;
                                            if (errors === _errs10) {
                                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                    if (data4.sourcePipeID !== undefined) {
                                                        let data5 = data4.sourcePipeID;
                                                        const _errs12 = errors;
                                                        if (errors === _errs12) {
                                                            if (typeof data5 === 'string') {
                                                                const b64min0 = Math.ceil((4 * 10) / 3);
                                                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                                                if (func390(data5) < b64min0 || func390(data5) > b64max0) {
                                                                    validate237.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/pipeVersionMap/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/sourcePipeID',
                                                                            schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourcePipeID/uid',
                                                                            keyword: 'uid',
                                                                            params: {
                                                                                error: 'encoded',
                                                                                b64min: b64min0,
                                                                                b64max: b64max0,
                                                                                length: func390(data5)
                                                                            },
                                                                            message: 'length must be between ' +
                                                                                b64min0 +
                                                                                ' and ' +
                                                                                b64max0 +
                                                                                ', but is ' +
                                                                                func390(data5)
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const decoded0 = func391(data5);
                                                                    if (decoded0.length !== 10) {
                                                                        validate237.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/pipeVersionMap/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/sourcePipeID',
                                                                                schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourcePipeID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'decoded' },
                                                                                message: 'must decode to 10 bytes'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const encoded0 = func392(decoded0);
                                                                        if (func393(encoded0) !== func393(data5)) {
                                                                            validate237.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/pipeVersionMap/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/sourcePipeID',
                                                                                    schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourcePipeID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'ambiguous' },
                                                                                    message: 'encoding is ambiguous'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate237.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/pipeVersionMap/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/sourcePipeID',
                                                                        schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourcePipeID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs12 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data4.sourceVersionID !== undefined) {
                                                            let data6 = data4.sourceVersionID;
                                                            const _errs14 = errors;
                                                            if (errors === _errs14) {
                                                                if (typeof data6 === 'string') {
                                                                    const b64min1 = Math.ceil((4 * 10) / 3);
                                                                    const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                                                    if (func394(data6) < b64min1 || func394(data6) > b64max1) {
                                                                        validate237.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/pipeVersionMap/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/sourceVersionID',
                                                                                schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min1,
                                                                                    b64max: b64max1,
                                                                                    length: func394(data6)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min1 +
                                                                                    ' and ' +
                                                                                    b64max1 +
                                                                                    ', but is ' +
                                                                                    func394(data6)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded1 = func395(data6);
                                                                        if (decoded1.length !== 10) {
                                                                            validate237.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/pipeVersionMap/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/sourceVersionID',
                                                                                    schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 10 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded1 = func396(decoded1);
                                                                            if (func397(encoded1) !== func397(data6)) {
                                                                                validate237.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/pipeVersionMap/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/sourceVersionID',
                                                                                        schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate237.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/pipeVersionMap/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/sourceVersionID',
                                                                            schemaPath: '#/properties/pipeVersionMap/additionalProperties/properties/sourceVersionID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs14 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate237.errors = [
                                                        {
                                                            instancePath: instancePath + '/pipeVersionMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/pipeVersionMap/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs10 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate237.errors = [
                                            {
                                                instancePath: instancePath + '/pipeVersionMap',
                                                schemaPath: '#/properties/pipeVersionMap/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.incentivesImportNodeNameMap !== undefined) {
                                    let data7 = data.incentivesImportNodeNameMap;
                                    const _errs16 = errors;
                                    if (errors === _errs16) {
                                        if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                            for (const key1 in data7) {
                                                let data8 = data7[key1];
                                                const _errs19 = errors;
                                                const _errs20 = errors;
                                                if (errors === _errs20) {
                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                        let missing1;
                                                        if ((data8.pipeName === undefined && (missing1 = 'pipeName')) ||
                                                            (data8.incentivesExportElementName === undefined &&
                                                                (missing1 = 'incentivesExportElementName'))) {
                                                            validate237.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/incentivesImportNodeNameMap/' +
                                                                        key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: 'urn:wisepipe-common-pipe:IncentivesImportConfigByName/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing1 },
                                                                    message: "must have required property '" + missing1 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data8.pipeName !== undefined) {
                                                                const _errs22 = errors;
                                                                if (typeof data8.pipeName !== 'string') {
                                                                    validate237.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/incentivesImportNodeNameMap/' +
                                                                                key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/pipeName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:IncentivesImportConfigByName/properties/pipeName/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid7 = _errs22 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                                if (data8.incentivesExportElementName !== undefined) {
                                                                    const _errs24 = errors;
                                                                    if (typeof data8.incentivesExportElementName !== 'string') {
                                                                        validate237.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/incentivesImportNodeNameMap/' +
                                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/incentivesExportElementName',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesImportConfigByName/properties/incentivesExportElementName/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid7 = _errs24 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate237.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/incentivesImportNodeNameMap/' +
                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: 'urn:wisepipe-common-pipe:IncentivesImportConfigByName/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid5 = _errs19 === errors;
                                                if (!valid5) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate237.errors = [
                                                {
                                                    instancePath: instancePath + '/incentivesImportNodeNameMap',
                                                    schemaPath: '#/properties/incentivesImportNodeNameMap/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs16 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.incentivesTableNodeDSMap !== undefined) {
                                        let data11 = data.incentivesTableNodeDSMap;
                                        const _errs26 = errors;
                                        if (errors === _errs26) {
                                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                for (const key2 in data11) {
                                                    const _errs29 = errors;
                                                    if (typeof data11[key2] !== 'string') {
                                                        validate237.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/incentivesTableNodeDSMap/' +
                                                                    key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/incentivesTableNodeDSMap/additionalProperties/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid8 = _errs29 === errors;
                                                    if (!valid8) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate237.errors = [
                                                    {
                                                        instancePath: instancePath + '/incentivesTableNodeDSMap',
                                                        schemaPath: '#/properties/incentivesTableNodeDSMap/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs26 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.reusableLogicVersionMap !== undefined) {
                                            let data13 = data.reusableLogicVersionMap;
                                            const _errs31 = errors;
                                            if (errors === _errs31) {
                                                if (data13 && typeof data13 == 'object' && !Array.isArray(data13)) {
                                                    for (const key3 in data13) {
                                                        let data14 = data13[key3];
                                                        const _errs34 = errors;
                                                        if (errors === _errs34) {
                                                            if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                                if (data14.sourceReusableLogicID !== undefined) {
                                                                    let data15 = data14.sourceReusableLogicID;
                                                                    const _errs36 = errors;
                                                                    if (errors === _errs36) {
                                                                        if (typeof data15 === 'string') {
                                                                            const b64min2 = Math.ceil((4 * 9) / 3);
                                                                            const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                            if (func398(data15) < b64min2 || func398(data15) > b64max2) {
                                                                                validate237.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/reusableLogicVersionMap/' +
                                                                                            key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/sourceReusableLogicID',
                                                                                        schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: {
                                                                                            error: 'encoded',
                                                                                            b64min: b64min2,
                                                                                            b64max: b64max2,
                                                                                            length: func398(data15)
                                                                                        },
                                                                                        message: 'length must be between ' +
                                                                                            b64min2 +
                                                                                            ' and ' +
                                                                                            b64max2 +
                                                                                            ', but is ' +
                                                                                            func398(data15)
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const decoded2 = func399(data15);
                                                                                if (decoded2.length !== 9) {
                                                                                    validate237.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/reusableLogicVersionMap/' +
                                                                                                key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/sourceReusableLogicID',
                                                                                            schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'decoded' },
                                                                                            message: 'must decode to 9 bytes'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const encoded2 = func400(decoded2);
                                                                                    if (func401(encoded2) !== func401(data15)) {
                                                                                        validate237.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/reusableLogicVersionMap/' +
                                                                                                    key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/sourceReusableLogicID',
                                                                                                schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'ambiguous' },
                                                                                                message: 'encoding is ambiguous'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate237.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/reusableLogicVersionMap/' +
                                                                                        key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/sourceReusableLogicID',
                                                                                    schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid10 = _errs36 === errors;
                                                                }
                                                                else {
                                                                    var valid10 = true;
                                                                }
                                                                if (valid10) {
                                                                    if (data14.sourceVersionID !== undefined) {
                                                                        let data16 = data14.sourceVersionID;
                                                                        const _errs38 = errors;
                                                                        if (errors === _errs38) {
                                                                            if (typeof data16 === 'string') {
                                                                                const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                if (func402(data16) < b64min3 || func402(data16) > b64max3) {
                                                                                    validate237.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/reusableLogicVersionMap/' +
                                                                                                key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/sourceVersionID',
                                                                                            schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: {
                                                                                                error: 'encoded',
                                                                                                b64min: b64min3,
                                                                                                b64max: b64max3,
                                                                                                length: func402(data16)
                                                                                            },
                                                                                            message: 'length must be between ' +
                                                                                                b64min3 +
                                                                                                ' and ' +
                                                                                                b64max3 +
                                                                                                ', but is ' +
                                                                                                func402(data16)
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    const decoded3 = func403(data16);
                                                                                    if (decoded3.length !== 9) {
                                                                                        validate237.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/reusableLogicVersionMap/' +
                                                                                                    key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/sourceVersionID',
                                                                                                schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'decoded' },
                                                                                                message: 'must decode to 9 bytes'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const encoded3 = func404(decoded3);
                                                                                        if (func405(encoded3) !== func405(data16)) {
                                                                                            validate237.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath +
                                                                                                        '/reusableLogicVersionMap/' +
                                                                                                        key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/sourceVersionID',
                                                                                                    schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'ambiguous' },
                                                                                                    message: 'encoding is ambiguous'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate237.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/reusableLogicVersionMap/' +
                                                                                            key3.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/sourceVersionID',
                                                                                        schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid10 = _errs38 === errors;
                                                                    }
                                                                    else {
                                                                        var valid10 = true;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate237.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/reusableLogicVersionMap/' +
                                                                            key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                        schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid9 = _errs34 === errors;
                                                        if (!valid9) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate237.errors = [
                                                        {
                                                            instancePath: instancePath + '/reusableLogicVersionMap',
                                                            schemaPath: '#/properties/reusableLogicVersionMap/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs31 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate237.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate237.errors = vErrors;
    return errors === 0;
}
export const pipePostRequestSchemaValidation = validate238;
const schema332 = {
    $id: 'urn:wisepipe-common-pipe:PipePostRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 100 },
        engineMode: { type: 'string', enum: ['standard', 'big'] },
        copyOrgID: { type: 'string', format: 'uuid' },
        copyID: { type: 'string', uid: 10 },
        copyVersionID: { type: 'string', uid: 10 },
        description: { type: 'string', maxLength: 1000 },
        documentation: { type: 'string', minLength: 1, maxLength: 50000 },
        image: { type: 'string', maxLength: 1024 },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' }
    },
    required: ['name', 'engineMode'],
    allOf: [
        { if: { required: ['copyOrgID'] }, then: { required: ['copyID'] } },
        { if: { required: ['copyVersionID'] }, then: { required: ['copyID'] } }
    ]
};
const func408 = ucs2length;
const func409 = base64urlToBuffer;
const func410 = base64urlEncode;
const func411 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func412 = ucs2length;
const func413 = base64urlToBuffer;
const func414 = base64urlEncode;
const func415 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func422 = ucs2length;
const func423 = base64urlToBuffer;
const func424 = base64urlEncode;
const func425 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func426 = ucs2length;
const func427 = base64urlToBuffer;
const func428 = base64urlEncode;
const func429 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate238(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipePostRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.copyOrgID === undefined && (missing0 = 'copyOrgID')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.copyID === undefined && (missing1 = 'copyID')) {
                validate238.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate238.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.copyVersionID === undefined && (missing2 = 'copyVersionID')) {
                const err2 = {};
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs8 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if (data.copyID === undefined && (missing3 = 'copyID')) {
                    validate238.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs8 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate238.errors = vErrors;
            return false;
        }
        var valid0 = _errs5 === errors;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.name === undefined && (missing4 = 'name')) ||
                (data.engineMode === undefined && (missing4 = 'engineMode'))) {
                validate238.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs9 = errors;
                    if (errors === _errs9) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate238.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate238.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate238.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid3 = _errs9 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.engineMode !== undefined) {
                        let data1 = data.engineMode;
                        const _errs11 = errors;
                        if (typeof data1 !== 'string') {
                            validate238.errors = [
                                {
                                    instancePath: instancePath + '/engineMode',
                                    schemaPath: '#/properties/engineMode/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'standard' || data1 === 'big')) {
                            validate238.errors = [
                                {
                                    instancePath: instancePath + '/engineMode',
                                    schemaPath: '#/properties/engineMode/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema332.properties.engineMode.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid3 = _errs11 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.copyOrgID !== undefined) {
                            let data2 = data.copyOrgID;
                            const _errs13 = errors;
                            if (errors === _errs13) {
                                if (errors === _errs13) {
                                    if (typeof data2 === 'string') {
                                        if (!formats4.test(data2)) {
                                            validate238.errors = [
                                                {
                                                    instancePath: instancePath + '/copyOrgID',
                                                    schemaPath: '#/properties/copyOrgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate238.errors = [
                                            {
                                                instancePath: instancePath + '/copyOrgID',
                                                schemaPath: '#/properties/copyOrgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid3 = _errs13 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                        if (valid3) {
                            if (data.copyID !== undefined) {
                                let data3 = data.copyID;
                                const _errs15 = errors;
                                if (errors === _errs15) {
                                    if (typeof data3 === 'string') {
                                        const b64min0 = Math.ceil((4 * 10) / 3);
                                        const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                        if (func408(data3) < b64min0 || func408(data3) > b64max0) {
                                            validate238.errors = [
                                                {
                                                    instancePath: instancePath + '/copyID',
                                                    schemaPath: '#/properties/copyID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func408(data3) },
                                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func408(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded0 = func409(data3);
                                            if (decoded0.length !== 10) {
                                                validate238.errors = [
                                                    {
                                                        instancePath: instancePath + '/copyID',
                                                        schemaPath: '#/properties/copyID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 10 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded0 = func410(decoded0);
                                                if (func411(encoded0) !== func411(data3)) {
                                                    validate238.errors = [
                                                        {
                                                            instancePath: instancePath + '/copyID',
                                                            schemaPath: '#/properties/copyID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate238.errors = [
                                            {
                                                instancePath: instancePath + '/copyID',
                                                schemaPath: '#/properties/copyID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid3 = _errs15 === errors;
                            }
                            else {
                                var valid3 = true;
                            }
                            if (valid3) {
                                if (data.copyVersionID !== undefined) {
                                    let data4 = data.copyVersionID;
                                    const _errs17 = errors;
                                    if (errors === _errs17) {
                                        if (typeof data4 === 'string') {
                                            const b64min1 = Math.ceil((4 * 10) / 3);
                                            const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func412(data4) < b64min1 || func412(data4) > b64max1) {
                                                validate238.errors = [
                                                    {
                                                        instancePath: instancePath + '/copyVersionID',
                                                        schemaPath: '#/properties/copyVersionID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func412(data4) },
                                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func412(data4)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded1 = func413(data4);
                                                if (decoded1.length !== 10) {
                                                    validate238.errors = [
                                                        {
                                                            instancePath: instancePath + '/copyVersionID',
                                                            schemaPath: '#/properties/copyVersionID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded1 = func414(decoded1);
                                                    if (func415(encoded1) !== func415(data4)) {
                                                        validate238.errors = [
                                                            {
                                                                instancePath: instancePath + '/copyVersionID',
                                                                schemaPath: '#/properties/copyVersionID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate238.errors = [
                                                {
                                                    instancePath: instancePath + '/copyVersionID',
                                                    schemaPath: '#/properties/copyVersionID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs17 === errors;
                                }
                                else {
                                    var valid3 = true;
                                }
                                if (valid3) {
                                    if (data.description !== undefined) {
                                        let data5 = data.description;
                                        const _errs19 = errors;
                                        if (errors === _errs19) {
                                            if (typeof data5 === 'string') {
                                                if (func2(data5) > 1000) {
                                                    validate238.errors = [
                                                        {
                                                            instancePath: instancePath + '/description',
                                                            schemaPath: '#/properties/description/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 1000 },
                                                            message: 'must NOT have more than 1000 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate238.errors = [
                                                    {
                                                        instancePath: instancePath + '/description',
                                                        schemaPath: '#/properties/description/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid3 = _errs19 === errors;
                                    }
                                    else {
                                        var valid3 = true;
                                    }
                                    if (valid3) {
                                        if (data.documentation !== undefined) {
                                            let data6 = data.documentation;
                                            const _errs21 = errors;
                                            if (errors === _errs21) {
                                                if (typeof data6 === 'string') {
                                                    if (func2(data6) > 50000) {
                                                        validate238.errors = [
                                                            {
                                                                instancePath: instancePath + '/documentation',
                                                                schemaPath: '#/properties/documentation/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 50000 },
                                                                message: 'must NOT have more than 50000 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (func2(data6) < 1) {
                                                            validate238.errors = [
                                                                {
                                                                    instancePath: instancePath + '/documentation',
                                                                    schemaPath: '#/properties/documentation/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate238.errors = [
                                                        {
                                                            instancePath: instancePath + '/documentation',
                                                            schemaPath: '#/properties/documentation/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs21 === errors;
                                        }
                                        else {
                                            var valid3 = true;
                                        }
                                        if (valid3) {
                                            if (data.image !== undefined) {
                                                let data7 = data.image;
                                                const _errs23 = errors;
                                                if (errors === _errs23) {
                                                    if (typeof data7 === 'string') {
                                                        if (func2(data7) > 1024) {
                                                            validate238.errors = [
                                                                {
                                                                    instancePath: instancePath + '/image',
                                                                    schemaPath: '#/properties/image/maxLength',
                                                                    keyword: 'maxLength',
                                                                    params: { limit: 1024 },
                                                                    message: 'must NOT have more than 1024 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate238.errors = [
                                                            {
                                                                instancePath: instancePath + '/image',
                                                                schemaPath: '#/properties/image/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs23 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data.challengeData !== undefined) {
                                                    let data8 = data.challengeData;
                                                    const _errs25 = errors;
                                                    const _errs26 = errors;
                                                    if (errors === _errs26) {
                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                            let missing5;
                                                            if ((data8.challengeID === undefined && (missing5 = 'challengeID')) ||
                                                                (data8.percentComplete === undefined && (missing5 = 'percentComplete'))) {
                                                                validate238.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/challengeData',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing5 },
                                                                        message: "must have required property '" + missing5 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data8.challengeID !== undefined) {
                                                                    let data9 = data8.challengeID;
                                                                    const _errs28 = errors;
                                                                    if (errors === _errs28) {
                                                                        if (typeof data9 == 'number') {
                                                                            if (data9 < 1 || isNaN(data9)) {
                                                                                validate238.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/challengeID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/minimum',
                                                                                        keyword: 'minimum',
                                                                                        params: { comparison: '>=', limit: 1 },
                                                                                        message: 'must be >= 1'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate238.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/challengeData/challengeID',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid7 = _errs28 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                                if (valid7) {
                                                                    if (data8.userID !== undefined) {
                                                                        let data10 = data8.userID;
                                                                        const _errs30 = errors;
                                                                        if (errors === _errs30) {
                                                                            if (typeof data10 === 'string') {
                                                                                if (func2(data10) > 128) {
                                                                                    validate238.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/userID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/maxLength',
                                                                                            keyword: 'maxLength',
                                                                                            params: { limit: 128 },
                                                                                            message: 'must NOT have more than 128 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    if (func2(data10) < 1) {
                                                                                        validate238.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/userID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate238.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/userID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid7 = _errs30 === errors;
                                                                    }
                                                                    else {
                                                                        var valid7 = true;
                                                                    }
                                                                    if (valid7) {
                                                                        if (data8.dataSourceID !== undefined) {
                                                                            let data11 = data8.dataSourceID;
                                                                            const _errs32 = errors;
                                                                            if (errors === _errs32) {
                                                                                if (typeof data11 === 'string') {
                                                                                    const b64min2 = Math.ceil((4 * 9) / 3);
                                                                                    const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                                    if (func422(data11) < b64min2 || func422(data11) > b64max2) {
                                                                                        validate238.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: {
                                                                                                    error: 'encoded',
                                                                                                    b64min: b64min2,
                                                                                                    b64max: b64max2,
                                                                                                    length: func422(data11)
                                                                                                },
                                                                                                message: 'length must be between ' +
                                                                                                    b64min2 +
                                                                                                    ' and ' +
                                                                                                    b64max2 +
                                                                                                    ', but is ' +
                                                                                                    func422(data11)
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        const decoded2 = func423(data11);
                                                                                        if (decoded2.length !== 9) {
                                                                                            validate238.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: { error: 'decoded' },
                                                                                                    message: 'must decode to 9 bytes'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const encoded2 = func424(decoded2);
                                                                                            if (func425(encoded2) !== func425(data11)) {
                                                                                                validate238.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'ambiguous' },
                                                                                                        message: 'encoding is ambiguous'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate238.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid7 = _errs32 === errors;
                                                                        }
                                                                        else {
                                                                            var valid7 = true;
                                                                        }
                                                                        if (valid7) {
                                                                            if (data8.originID !== undefined) {
                                                                                let data12 = data8.originID;
                                                                                const _errs34 = errors;
                                                                                if (errors === _errs34) {
                                                                                    if (typeof data12 === 'string') {
                                                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func426(data12) < b64min3 || func426(data12) > b64max3) {
                                                                                            validate238.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/originID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min3,
                                                                                                        b64max: b64max3,
                                                                                                        length: func426(data12)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min3 +
                                                                                                        ' and ' +
                                                                                                        b64max3 +
                                                                                                        ', but is ' +
                                                                                                        func426(data12)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded3 = func427(data12);
                                                                                            if (decoded3.length !== 9) {
                                                                                                validate238.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/originID',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded3 = func428(decoded3);
                                                                                                if (func429(encoded3) !== func429(data12)) {
                                                                                                    validate238.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/originID',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate238.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/originID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid7 = _errs34 === errors;
                                                                            }
                                                                            else {
                                                                                var valid7 = true;
                                                                            }
                                                                            if (valid7) {
                                                                                if (data8.createdAt !== undefined) {
                                                                                    let data13 = data8.createdAt;
                                                                                    const _errs36 = errors;
                                                                                    if (errors === _errs36) {
                                                                                        if (errors === _errs36) {
                                                                                            if (typeof data13 === 'string') {
                                                                                                if (!formats0.validate(data13)) {
                                                                                                    validate238.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/createdAt',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/format',
                                                                                                            keyword: 'format',
                                                                                                            params: { format: 'date-time' },
                                                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                validate238.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/createdAt',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    var valid7 = _errs36 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid7 = true;
                                                                                }
                                                                                if (valid7) {
                                                                                    if (data8.lastUpdatedAt !== undefined) {
                                                                                        let data14 = data8.lastUpdatedAt;
                                                                                        const _errs38 = errors;
                                                                                        if (errors === _errs38) {
                                                                                            if (errors === _errs38) {
                                                                                                if (typeof data14 === 'string') {
                                                                                                    if (!formats0.validate(data14)) {
                                                                                                        validate238.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/format',
                                                                                                                keyword: 'format',
                                                                                                                params: { format: 'date-time' },
                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate238.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        var valid7 = _errs38 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid7 = true;
                                                                                    }
                                                                                    if (valid7) {
                                                                                        if (data8.percentComplete !== undefined) {
                                                                                            let data15 = data8.percentComplete;
                                                                                            const _errs40 = errors;
                                                                                            if (errors === _errs40) {
                                                                                                if (typeof data15 == 'number') {
                                                                                                    if (data15 > 100 || isNaN(data15)) {
                                                                                                        validate238.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/maximum',
                                                                                                                keyword: 'maximum',
                                                                                                                params: { comparison: '<=', limit: 100 },
                                                                                                                message: 'must be <= 100'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    else {
                                                                                                        if (data15 < 0 || isNaN(data15)) {
                                                                                                            validate238.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/minimum',
                                                                                                                    keyword: 'minimum',
                                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                                    message: 'must be >= 0'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate238.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'number' },
                                                                                                            message: 'must be number'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                            var valid7 = _errs40 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid7 = true;
                                                                                        }
                                                                                        if (valid7) {
                                                                                            if (data8.state !== undefined) {
                                                                                                let data16 = data8.state;
                                                                                                const _errs42 = errors;
                                                                                                if (typeof data16 !== 'string') {
                                                                                                    validate238.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/state',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                if (!(data16 === 'not_started' ||
                                                                                                    data16 === 'started' ||
                                                                                                    data16 === 'complete')) {
                                                                                                    validate238.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/state',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/enum',
                                                                                                            keyword: 'enum',
                                                                                                            params: { allowedValues: schema93.properties.state.enum },
                                                                                                            message: 'must be equal to one of the allowed values'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid7 = _errs42 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid7 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate238.errors = [
                                                                {
                                                                    instancePath: instancePath + '/challengeData',
                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs25 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate238.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate238.errors = vErrors;
    return errors === 0;
}
export const pipeSortParamsSchemaValidation = validate239;
const schema334 = {
    $id: 'urn:wisepipe-common-pipe:PipeSortParams',
    type: 'object',
    properties: { sortBy: { type: 'string', enum: ['name', 'createdAt'] } },
    required: []
};
function validate239(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeSortParams" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.sortBy !== undefined) {
                let data0 = data.sortBy;
                if (typeof data0 !== 'string') {
                    validate239.errors = [
                        {
                            instancePath: instancePath + '/sortBy',
                            schemaPath: '#/properties/sortBy/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'name' || data0 === 'createdAt')) {
                    validate239.errors = [
                        {
                            instancePath: instancePath + '/sortBy',
                            schemaPath: '#/properties/sortBy/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema334.properties.sortBy.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        else {
            validate239.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate239.errors = vErrors;
    return errors === 0;
}
export const pipeVersionPostRequestSchemaValidation = validate240;
const schema335 = {
    $id: 'urn:wisepipe-common-pipe:PipeVersionPostRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 100 },
        readonly: { type: 'boolean' },
        expireInDays: { type: 'number', exclusiveMinimum: 0, maximum: 365 }
    },
    required: ['name']
};
function validate240(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeVersionPostRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.name === undefined && (missing0 = 'name')) {
                validate240.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 100) {
                                validate240.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate240.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate240.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.readonly !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.readonly !== 'boolean') {
                            validate240.errors = [
                                {
                                    instancePath: instancePath + '/readonly',
                                    schemaPath: '#/properties/readonly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.expireInDays !== undefined) {
                            let data2 = data.expireInDays;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 > 365 || isNaN(data2)) {
                                        validate240.errors = [
                                            {
                                                instancePath: instancePath + '/expireInDays',
                                                schemaPath: '#/properties/expireInDays/maximum',
                                                keyword: 'maximum',
                                                params: { comparison: '<=', limit: 365 },
                                                message: 'must be <= 365'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2 <= 0 || isNaN(data2)) {
                                            validate240.errors = [
                                                {
                                                    instancePath: instancePath + '/expireInDays',
                                                    schemaPath: '#/properties/expireInDays/exclusiveMinimum',
                                                    keyword: 'exclusiveMinimum',
                                                    params: { comparison: '>', limit: 0 },
                                                    message: 'must be > 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate240.errors = [
                                        {
                                            instancePath: instancePath + '/expireInDays',
                                            schemaPath: '#/properties/expireInDays/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate240.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate240.errors = vErrors;
    return errors === 0;
}
export const pipeVersionSchemaValidation = validate241;
const schema336 = {
    $id: 'urn:wisepipe-common-pipe:PipeVersion',
    type: 'object',
    properties: {
        versionID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        createdAt: { type: 'string', format: 'date-time' },
        createdBy: { type: 'string', format: 'uuid' },
        readonly: { type: 'boolean' }
    },
    required: ['versionID', 'name', 'createdAt', 'createdBy']
};
const func432 = ucs2length;
const func433 = base64urlToBuffer;
const func434 = base64urlEncode;
const func435 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate241(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeVersion" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.versionID === undefined && (missing0 = 'versionID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt')) ||
                (data.createdBy === undefined && (missing0 = 'createdBy'))) {
                validate241.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.versionID !== undefined) {
                    let data0 = data.versionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func432(data0) < b64min0 || func432(data0) > b64max0) {
                                validate241.errors = [
                                    {
                                        instancePath: instancePath + '/versionID',
                                        schemaPath: '#/properties/versionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func432(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func432(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func433(data0);
                                if (decoded0.length !== 10) {
                                    validate241.errors = [
                                        {
                                            instancePath: instancePath + '/versionID',
                                            schemaPath: '#/properties/versionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func434(decoded0);
                                    if (func435(encoded0) !== func435(data0)) {
                                        validate241.errors = [
                                            {
                                                instancePath: instancePath + '/versionID',
                                                schemaPath: '#/properties/versionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate241.errors = [
                                {
                                    instancePath: instancePath + '/versionID',
                                    schemaPath: '#/properties/versionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate241.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate241.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate241.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.createdAt !== undefined) {
                            let data2 = data.createdAt;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate241.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate241.errors = [
                                            {
                                                instancePath: instancePath + '/createdAt',
                                                schemaPath: '#/properties/createdAt/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.createdBy !== undefined) {
                                let data3 = data.createdBy;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats4.test(data3)) {
                                                validate241.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdBy',
                                                        schemaPath: '#/properties/createdBy/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate241.errors = [
                                                {
                                                    instancePath: instancePath + '/createdBy',
                                                    schemaPath: '#/properties/createdBy/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.readonly !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.readonly !== 'boolean') {
                                        validate241.errors = [
                                            {
                                                instancePath: instancePath + '/readonly',
                                                schemaPath: '#/properties/readonly/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate241.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate241.errors = vErrors;
    return errors === 0;
}
export const pipeWithDependeesSchemaValidation = validate242;
const schema337 = {
    $id: 'urn:wisepipe-common-pipe:PipeWithDependees',
    type: 'object',
    properties: {
        elements: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:GraphElement' } },
        dependees: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:PipeDependee' } }
    },
    required: ['elements', 'dependees']
};
const func438 = ucs2length;
const func439 = base64urlToBuffer;
const func440 = base64urlEncode;
const func441 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate242(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PipeWithDependees" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elements === undefined && (missing0 = 'elements')) ||
                (data.dependees === undefined && (missing0 = 'dependees'))) {
                validate242.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elements !== undefined) {
                    let data0 = data.elements;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if ((data1.elementID === undefined && (missing1 = 'elementID')) ||
                                            (data1.elementType === undefined && (missing1 = 'elementType'))) {
                                            validate242.errors = [
                                                {
                                                    instancePath: instancePath + '/elements/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.elementID !== undefined) {
                                                let data2 = data1.elementID;
                                                const _errs6 = errors;
                                                if (errors === _errs6) {
                                                    if (typeof data2 === 'string') {
                                                        const b64min0 = Math.ceil((4 * 10) / 3);
                                                        const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                                        if (func438(data2) < b64min0 || func438(data2) > b64max0) {
                                                            validate242.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                    keyword: 'uid',
                                                                    params: {
                                                                        error: 'encoded',
                                                                        b64min: b64min0,
                                                                        b64max: b64max0,
                                                                        length: func438(data2)
                                                                    },
                                                                    message: 'length must be between ' +
                                                                        b64min0 +
                                                                        ' and ' +
                                                                        b64max0 +
                                                                        ', but is ' +
                                                                        func438(data2)
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            const decoded0 = func439(data2);
                                                            if (decoded0.length !== 10) {
                                                                validate242.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                        keyword: 'uid',
                                                                        params: { error: 'decoded' },
                                                                        message: 'must decode to 10 bytes'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const encoded0 = func440(decoded0);
                                                                if (func441(encoded0) !== func441(data2)) {
                                                                    validate242.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'ambiguous' },
                                                                            message: 'encoding is ambiguous'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate242.errors = [
                                                            {
                                                                instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs6 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data1.elementType !== undefined) {
                                                    let data3 = data1.elementType;
                                                    const _errs8 = errors;
                                                    if (errors === _errs8) {
                                                        if (typeof data3 === 'string') {
                                                            if (!pattern8.test(data3)) {
                                                                validate242.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/pattern',
                                                                        keyword: 'pattern',
                                                                        params: { pattern: 'edge|node|group' },
                                                                        message: 'must match pattern "' + 'edge|node|group' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate242.errors = [
                                                                {
                                                                    instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                                if (valid3) {
                                                    if (data1.lastModified !== undefined) {
                                                        let data4 = data1.lastModified;
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (errors === _errs10) {
                                                                if (typeof data4 === 'string') {
                                                                    if (!formats0.validate(data4)) {
                                                                        validate242.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate242.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid3 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.uniqueChangeID !== undefined) {
                                                            const _errs12 = errors;
                                                            if (typeof data1.uniqueChangeID !== 'string') {
                                                                validate242.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/uniqueChangeID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/uniqueChangeID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate242.errors = [
                                            {
                                                instancePath: instancePath + '/elements/' + i0,
                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate242.errors = [
                                {
                                    instancePath: instancePath + '/elements',
                                    schemaPath: '#/properties/elements/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dependees !== undefined) {
                        let data6 = data.dependees;
                        const _errs14 = errors;
                        if (errors === _errs14) {
                            if (Array.isArray(data6)) {
                                var valid5 = true;
                                const len1 = data6.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs16 = errors;
                                    if (!validate232(data6[i1], {
                                        instancePath: instancePath + '/dependees/' + i1,
                                        parentData: data6,
                                        parentDataProperty: i1,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate232.errors : vErrors.concat(validate232.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid5 = _errs16 === errors;
                                    if (!valid5) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate242.errors = [
                                    {
                                        instancePath: instancePath + '/dependees',
                                        schemaPath: '#/properties/dependees/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs14 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate242.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate242.errors = vErrors;
    return errors === 0;
}
export const predictGenderConfigSchemaValidation = validate244;
const schema339 = {
    $id: 'urn:wisepipe-common-pipe:PredictGenderConfig',
    type: 'object',
    properties: {
        nameColumn: { type: 'string', minLength: 1 },
        genderColumn: { type: 'string', minLength: 1 },
        probaColumn: { type: 'string', minLength: 1 }
    },
    required: ['nameColumn']
};
function validate244(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PredictGenderConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.nameColumn === undefined && (missing0 = 'nameColumn')) {
                validate244.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.nameColumn !== undefined) {
                    let data0 = data.nameColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate244.errors = [
                                    {
                                        instancePath: instancePath + '/nameColumn',
                                        schemaPath: '#/properties/nameColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate244.errors = [
                                {
                                    instancePath: instancePath + '/nameColumn',
                                    schemaPath: '#/properties/nameColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.genderColumn !== undefined) {
                        let data1 = data.genderColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate244.errors = [
                                        {
                                            instancePath: instancePath + '/genderColumn',
                                            schemaPath: '#/properties/genderColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate244.errors = [
                                    {
                                        instancePath: instancePath + '/genderColumn',
                                        schemaPath: '#/properties/genderColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.probaColumn !== undefined) {
                            let data2 = data.probaColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate244.errors = [
                                            {
                                                instancePath: instancePath + '/probaColumn',
                                                schemaPath: '#/properties/probaColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate244.errors = [
                                        {
                                            instancePath: instancePath + '/probaColumn',
                                            schemaPath: '#/properties/probaColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate244.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate244.errors = vErrors;
    return errors === 0;
}
export const predictorConfigSchemaValidation = validate245;
const schema340 = {
    $id: 'urn:wisepipe-common-pipe:PredictorConfig',
    type: 'object',
    properties: {
        options: { type: 'integer', minimum: 1, maximum: 15 },
        threshold: { type: 'number', minimum: 0, maximum: 1 },
        excludeColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        autoExclude: { type: 'boolean' },
        autoExcludeCorrMethod: { type: 'string', enum: ['pearson', 'kendall', 'spearman'] },
        autoExcludeCorrThreshold: { type: 'number' },
        autoExcludePpsThreshold: { type: 'number' }
    },
    required: ['labelColumn', 'options']
};
function validate245(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PredictorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.labelColumn === undefined && (missing0 = 'labelColumn')) ||
                (data.options === undefined && (missing0 = 'options'))) {
                validate245.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.options !== undefined) {
                    let data0 = data.options;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate245.errors = [
                            {
                                instancePath: instancePath + '/options',
                                schemaPath: '#/properties/options/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 15 || isNaN(data0)) {
                                validate245.errors = [
                                    {
                                        instancePath: instancePath + '/options',
                                        schemaPath: '#/properties/options/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 15 },
                                        message: 'must be <= 15'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate245.errors = [
                                        {
                                            instancePath: instancePath + '/options',
                                            schemaPath: '#/properties/options/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.threshold !== undefined) {
                        let data1 = data.threshold;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 > 1 || isNaN(data1)) {
                                    validate245.errors = [
                                        {
                                            instancePath: instancePath + '/threshold',
                                            schemaPath: '#/properties/threshold/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1 },
                                            message: 'must be <= 1'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1 < 0 || isNaN(data1)) {
                                        validate245.errors = [
                                            {
                                                instancePath: instancePath + '/threshold',
                                                schemaPath: '#/properties/threshold/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate245.errors = [
                                    {
                                        instancePath: instancePath + '/threshold',
                                        schemaPath: '#/properties/threshold/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.excludeColumns !== undefined) {
                            let data2 = data.excludeColumns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        if (errors === _errs7) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate245.errors = [
                                                        {
                                                            instancePath: instancePath + '/excludeColumns/' + i0,
                                                            schemaPath: '#/properties/excludeColumns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate245.errors = [
                                                    {
                                                        instancePath: instancePath + '/excludeColumns/' + i0,
                                                        schemaPath: '#/properties/excludeColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data2.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data2[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate245.errors = [
                                                        {
                                                            instancePath: instancePath + '/excludeColumns',
                                                            schemaPath: '#/properties/excludeColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate245.errors = [
                                        {
                                            instancePath: instancePath + '/excludeColumns',
                                            schemaPath: '#/properties/excludeColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.autoExclude !== undefined) {
                                const _errs9 = errors;
                                if (typeof data.autoExclude !== 'boolean') {
                                    validate245.errors = [
                                        {
                                            instancePath: instancePath + '/autoExclude',
                                            schemaPath: '#/properties/autoExclude/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.autoExcludeCorrMethod !== undefined) {
                                    let data5 = data.autoExcludeCorrMethod;
                                    const _errs11 = errors;
                                    if (typeof data5 !== 'string') {
                                        validate245.errors = [
                                            {
                                                instancePath: instancePath + '/autoExcludeCorrMethod',
                                                schemaPath: '#/properties/autoExcludeCorrMethod/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data5 === 'pearson' || data5 === 'kendall' || data5 === 'spearman')) {
                                        validate245.errors = [
                                            {
                                                instancePath: instancePath + '/autoExcludeCorrMethod',
                                                schemaPath: '#/properties/autoExcludeCorrMethod/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema340.properties.autoExcludeCorrMethod.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.autoExcludeCorrThreshold !== undefined) {
                                        const _errs13 = errors;
                                        if (!(typeof data.autoExcludeCorrThreshold == 'number')) {
                                            validate245.errors = [
                                                {
                                                    instancePath: instancePath + '/autoExcludeCorrThreshold',
                                                    schemaPath: '#/properties/autoExcludeCorrThreshold/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.autoExcludePpsThreshold !== undefined) {
                                            const _errs15 = errors;
                                            if (!(typeof data.autoExcludePpsThreshold == 'number')) {
                                                validate245.errors = [
                                                    {
                                                        instancePath: instancePath + '/autoExcludePpsThreshold',
                                                        schemaPath: '#/properties/autoExcludePpsThreshold/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate245.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate245.errors = vErrors;
    return errors === 0;
}
export const probabilityClassifierConfigSchemaValidation = validate246;
const schema341 = {
    $id: 'urn:wisepipe-common-pipe:ProbabilityClassifierConfig',
    type: 'object',
    properties: { threshold: { type: 'number', minimum: 0, maximum: 1 } },
    required: []
};
function validate246(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ProbabilityClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.threshold !== undefined) {
                let data0 = data.threshold;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 > 1 || isNaN(data0)) {
                            validate246.errors = [
                                {
                                    instancePath: instancePath + '/threshold',
                                    schemaPath: '#/properties/threshold/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 1 },
                                    message: 'must be <= 1'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0 < 0 || isNaN(data0)) {
                                validate246.errors = [
                                    {
                                        instancePath: instancePath + '/threshold',
                                        schemaPath: '#/properties/threshold/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate246.errors = [
                            {
                                instancePath: instancePath + '/threshold',
                                schemaPath: '#/properties/threshold/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate246.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate246.errors = vErrors;
    return errors === 0;
}
export const probabilityOutlierConfigSchemaValidation = validate247;
const schema342 = {
    $id: 'urn:wisepipe-common-pipe:ProbabilityOutlierConfig',
    type: 'object',
    properties: {
        contamination: { type: 'number', minimum: 0, maximum: 0.5 },
        threshold: { type: 'number', minimum: 0, maximum: 1 }
    },
    required: []
};
function validate247(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ProbabilityOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.contamination !== undefined) {
                let data0 = data.contamination;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 > 0.5 || isNaN(data0)) {
                            validate247.errors = [
                                {
                                    instancePath: instancePath + '/contamination',
                                    schemaPath: '#/properties/contamination/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 0.5 },
                                    message: 'must be <= 0.5'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0 < 0 || isNaN(data0)) {
                                validate247.errors = [
                                    {
                                        instancePath: instancePath + '/contamination',
                                        schemaPath: '#/properties/contamination/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate247.errors = [
                            {
                                instancePath: instancePath + '/contamination',
                                schemaPath: '#/properties/contamination/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.threshold !== undefined) {
                    let data1 = data.threshold;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (typeof data1 == 'number') {
                            if (data1 > 1 || isNaN(data1)) {
                                validate247.errors = [
                                    {
                                        instancePath: instancePath + '/threshold',
                                        schemaPath: '#/properties/threshold/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 1 },
                                        message: 'must be <= 1'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate247.errors = [
                                        {
                                            instancePath: instancePath + '/threshold',
                                            schemaPath: '#/properties/threshold/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate247.errors = [
                                {
                                    instancePath: instancePath + '/threshold',
                                    schemaPath: '#/properties/threshold/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate247.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate247.errors = vErrors;
    return errors === 0;
}
export const prophetForecastConfigSchemaValidation = validate248;
const schema343 = {
    $id: 'urn:wisepipe-common-pipe:ProphetForecastConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate248(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ProphetForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate248.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate248.errors = vErrors;
    return errors === 0;
}
export const pyToolScopeSchemaValidation = validate249;
const schema344 = {
    $id: 'urn:wisepipe-common-pipe:PyToolScope',
    type: 'object',
    properties: {
        encodings: { $ref: 'urn:wisepipe-common-pipe:Encodings' },
        data: { $ref: 'urn:wisepipe-common-pipe:Schemas' },
        incentivesDSMetadatas: { $ref: 'urn:wisepipe-common-pipe:IncentivesDSMetadatas' }
    },
    required: []
};
const schema346 = {
    $id: 'urn:wisepipe-common-pipe:Schemas',
    type: 'object',
    properties: {
        schemas: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-pipe:ColumnMetadata' },
                maxItems: 1000,
                uniqueItemProperties: ['name']
            }
        }
    },
    required: ['schemas']
};
const func448 = ajvEqual;
function validate250(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:Schemas" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.schemas === undefined && (missing0 = 'schemas')) {
                validate250.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.schemas !== undefined) {
                    let data0 = data.schemas;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                let data1 = data0[key0];
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (Array.isArray(data1)) {
                                        if (data1.length > 1000) {
                                            validate250.errors = [
                                                {
                                                    instancePath: instancePath + '/schemas/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/schemas/additionalProperties/maxItems',
                                                    keyword: 'maxItems',
                                                    params: { limit: 1000 },
                                                    message: 'must NOT have more than 1000 items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            var valid2 = true;
                                            const len0 = data1.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                const _errs6 = errors;
                                                if (!validate69(data1[i0], {
                                                    instancePath: instancePath + '/schemas/' + key0.replace(/~/g, '~0').replace(/\//g, '~1') + '/' + i0,
                                                    parentData: data1,
                                                    parentDataProperty: i0,
                                                    rootData
                                                })) {
                                                    vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
                                                    errors = vErrors.length;
                                                }
                                                var valid2 = _errs6 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                            if (valid2) {
                                                const keys0 = schema346.properties.schemas.additionalProperties.uniqueItemProperties;
                                                let k0;
                                                let i1 = data1.length;
                                                let j0;
                                                if (i1 > 1) {
                                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                        let key1 = keys0[k0];
                                                        for (i1 = data1.length; i1--;) {
                                                            let x0 = data1[i1];
                                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                                continue;
                                                            }
                                                            for (j0 = i1; j0--;) {
                                                                let y0 = data1[j0];
                                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func448(x0[key1], y0[key1])) {
                                                                    validate250.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/schemas/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                            schemaPath: '#/properties/schemas/additionalProperties/uniqueItemProperties',
                                                                            keyword: 'uniqueItemProperties',
                                                                            params: {},
                                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                    break outer0;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate250.errors = [
                                            {
                                                instancePath: instancePath + '/schemas/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/schemas/additionalProperties/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate250.errors = [
                                {
                                    instancePath: instancePath + '/schemas',
                                    schemaPath: '#/properties/schemas/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate250.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate250.errors = vErrors;
    return errors === 0;
}
function validate249(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:PyToolScope" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.encodings !== undefined) {
                let data0 = data.encodings;
                const _errs1 = errors;
                const _errs2 = errors;
                if (errors === _errs2) {
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        let missing0;
                        if (data0.encodings === undefined && (missing0 = 'encodings')) {
                            validate249.errors = [
                                {
                                    instancePath: instancePath + '/encodings',
                                    schemaPath: 'urn:wisepipe-common-pipe:Encodings/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing0 },
                                    message: "must have required property '" + missing0 + "'"
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0.encodings !== undefined) {
                                let data1 = data0.encodings;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        for (const key0 in data1) {
                                            let data2 = data1[key0];
                                            const _errs7 = errors;
                                            if (errors === _errs7) {
                                                if (Array.isArray(data2)) {
                                                    if (data2.length > 1000) {
                                                        validate249.errors = [
                                                            {
                                                                instancePath: instancePath +
                                                                    '/encodings/encodings/' +
                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/maxItems',
                                                                keyword: 'maxItems',
                                                                params: { limit: 1000 },
                                                                message: 'must NOT have more than 1000 items'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data2.length < 1) {
                                                            validate249.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/encodings/encodings/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                    schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/minItems',
                                                                    keyword: 'minItems',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 items'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                            const len0 = data2.length;
                                                            for (let i0 = 0; i0 < len0; i0++) {
                                                                let data3 = data2[i0];
                                                                const _errs9 = errors;
                                                                if (errors === _errs9) {
                                                                    if (typeof data3 === 'string') {
                                                                        if (func2(data3) > 150) {
                                                                            validate249.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/encodings/encodings/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/' +
                                                                                        i0,
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/items/maxLength',
                                                                                    keyword: 'maxLength',
                                                                                    params: { limit: 150 },
                                                                                    message: 'must NOT have more than 150 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (func2(data3) < 1) {
                                                                                validate249.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/encodings/encodings/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/' +
                                                                                            i0,
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/items/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate249.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/encodings/encodings/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/' +
                                                                                    i0,
                                                                                schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/items/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs9 === errors;
                                                                if (!valid4) {
                                                                    break;
                                                                }
                                                            }
                                                            if (valid4) {
                                                                let i1 = data2.length;
                                                                let j0;
                                                                if (i1 > 1) {
                                                                    const indices0 = {};
                                                                    for (; i1--;) {
                                                                        let item0 = data2[i1];
                                                                        if (typeof item0 !== 'string') {
                                                                            continue;
                                                                        }
                                                                        if (typeof indices0[item0] == 'number') {
                                                                            j0 = indices0[item0];
                                                                            validate249.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/encodings/encodings/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/uniqueItems',
                                                                                    keyword: 'uniqueItems',
                                                                                    params: { i: i1, j: j0 },
                                                                                    message: 'must NOT have duplicate items (items ## ' +
                                                                                        j0 +
                                                                                        ' and ' +
                                                                                        i1 +
                                                                                        ' are identical)'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                            break;
                                                                        }
                                                                        indices0[item0] = i1;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate249.errors = [
                                                        {
                                                            instancePath: instancePath + '/encodings/encodings/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs7 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate249.errors = [
                                            {
                                                instancePath: instancePath + '/encodings/encodings',
                                                schemaPath: 'urn:wisepipe-common-pipe:Encodings/properties/encodings/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        validate249.errors = [
                            {
                                instancePath: instancePath + '/encodings',
                                schemaPath: 'urn:wisepipe-common-pipe:Encodings/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.data !== undefined) {
                    const _errs11 = errors;
                    if (!validate250(data.data, {
                        instancePath: instancePath + '/data',
                        parentData: data,
                        parentDataProperty: 'data',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate250.errors : vErrors.concat(validate250.errors);
                        errors = vErrors.length;
                    }
                    var valid0 = _errs11 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.incentivesDSMetadatas !== undefined) {
                        const _errs12 = errors;
                        if (!validate142(data.incentivesDSMetadatas, {
                            instancePath: instancePath + '/incentivesDSMetadatas',
                            parentData: data,
                            parentDataProperty: 'incentivesDSMetadatas',
                            rootData
                        })) {
                            vErrors = vErrors === null ? validate142.errors : vErrors.concat(validate142.errors);
                            errors = vErrors.length;
                        }
                        var valid0 = _errs12 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate249.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate249.errors = vErrors;
    return errors === 0;
}
export const quantileColumnSchemaValidation = validate254;
const schema347 = {
    $id: 'urn:wisepipe-common-pipe:QuantileColumn',
    type: 'object',
    properties: {
        column: { type: 'string' },
        quantiles: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:Quantile' },
            uniqueItemProperties: ['quantile'],
            minItems: 1
        }
    },
    required: ['column', 'quantiles']
};
const schema348 = {
    $id: 'urn:wisepipe-common-pipe:Quantile',
    type: 'object',
    properties: { quantile: { type: 'number', minimum: 0, maximum: 1 }, newColumn: { type: 'string', minLength: 1 } },
    required: ['quantile']
};
const func450 = ajvEqual;
function validate254(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:QuantileColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.column === undefined && (missing0 = 'column')) ||
                (data.quantiles === undefined && (missing0 = 'quantiles'))) {
                validate254.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.column !== 'string') {
                        validate254.errors = [
                            {
                                instancePath: instancePath + '/column',
                                schemaPath: '#/properties/column/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.quantiles !== undefined) {
                        let data1 = data.quantiles;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 1) {
                                    validate254.errors = [
                                        {
                                            instancePath: instancePath + '/quantiles',
                                            schemaPath: '#/properties/quantiles/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                                let missing1;
                                                if (data2.quantile === undefined && (missing1 = 'quantile')) {
                                                    validate254.errors = [
                                                        {
                                                            instancePath: instancePath + '/quantiles/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:Quantile/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data2.quantile !== undefined) {
                                                        let data3 = data2.quantile;
                                                        const _errs8 = errors;
                                                        if (errors === _errs8) {
                                                            if (typeof data3 == 'number') {
                                                                if (data3 > 1 || isNaN(data3)) {
                                                                    validate254.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/quantiles/' + i0 + '/quantile',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:Quantile/properties/quantile/maximum',
                                                                            keyword: 'maximum',
                                                                            params: { comparison: '<=', limit: 1 },
                                                                            message: 'must be <= 1'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data3 < 0 || isNaN(data3)) {
                                                                        validate254.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/quantiles/' + i0 + '/quantile',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:Quantile/properties/quantile/minimum',
                                                                                keyword: 'minimum',
                                                                                params: { comparison: '>=', limit: 0 },
                                                                                message: 'must be >= 0'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate254.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/quantiles/' + i0 + '/quantile',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:Quantile/properties/quantile/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs8 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data2.newColumn !== undefined) {
                                                            let data4 = data2.newColumn;
                                                            const _errs10 = errors;
                                                            if (errors === _errs10) {
                                                                if (typeof data4 === 'string') {
                                                                    if (func2(data4) < 1) {
                                                                        validate254.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/quantiles/' + i0 + '/newColumn',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:Quantile/properties/newColumn/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate254.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/quantiles/' + i0 + '/newColumn',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:Quantile/properties/newColumn/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs10 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate254.errors = [
                                                    {
                                                        instancePath: instancePath + '/quantiles/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:Quantile/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema347.properties.quantiles.uniqueItemProperties;
                                        let k0;
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data1.length; i1--;) {
                                                    let x0 = data1[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data1[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func450(x0[key0], y0[key0])) {
                                                            validate254.errors = [
                                                                {
                                                                    instancePath: instancePath + '/quantiles',
                                                                    schemaPath: '#/properties/quantiles/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate254.errors = [
                                    {
                                        instancePath: instancePath + '/quantiles',
                                        schemaPath: '#/properties/quantiles/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate254.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate254.errors = vErrors;
    return errors === 0;
}
export const quantileConfigSchemaValidation = validate255;
const schema349 = {
    $id: 'urn:wisepipe-common-pipe:QuantileConfig',
    type: 'object',
    properties: {
        quantileColumns: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:QuantileColumn' }, minItems: 1 },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['quantileColumns', 'groupByColumns']
};
function validate255(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:QuantileConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.quantileColumns === undefined && (missing0 = 'quantileColumns')) ||
                (data.groupByColumns === undefined && (missing0 = 'groupByColumns'))) {
                validate255.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.quantileColumns !== undefined) {
                    let data0 = data.quantileColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate255.errors = [
                                    {
                                        instancePath: instancePath + '/quantileColumns',
                                        schemaPath: '#/properties/quantileColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs3 = errors;
                                    if (!validate254(data0[i0], {
                                        instancePath: instancePath + '/quantileColumns/' + i0,
                                        parentData: data0,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate254.errors : vErrors.concat(validate254.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            validate255.errors = [
                                {
                                    instancePath: instancePath + '/quantileColumns',
                                    schemaPath: '#/properties/quantileColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupByColumns !== undefined) {
                        let data2 = data.groupByColumns;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (Array.isArray(data2)) {
                                var valid2 = true;
                                const len1 = data2.length;
                                for (let i1 = 0; i1 < len1; i1++) {
                                    const _errs6 = errors;
                                    if (typeof data2[i1] !== 'string') {
                                        validate255.errors = [
                                            {
                                                instancePath: instancePath + '/groupByColumns/' + i1,
                                                schemaPath: '#/properties/groupByColumns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                                if (valid2) {
                                    let i2 = data2.length;
                                    let j0;
                                    if (i2 > 1) {
                                        const indices0 = {};
                                        for (; i2--;) {
                                            let item0 = data2[i2];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate255.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupByColumns',
                                                        schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i2, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i2 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i2;
                                        }
                                    }
                                }
                            }
                            else {
                                validate255.errors = [
                                    {
                                        instancePath: instancePath + '/groupByColumns',
                                        schemaPath: '#/properties/groupByColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate255.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate255.errors = vErrors;
    return errors === 0;
}
export const quantileSchemaValidation = validate257;
function validate257(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:Quantile" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.quantile === undefined && (missing0 = 'quantile')) {
                validate257.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.quantile !== undefined) {
                    let data0 = data.quantile;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 1 || isNaN(data0)) {
                                validate257.errors = [
                                    {
                                        instancePath: instancePath + '/quantile',
                                        schemaPath: '#/properties/quantile/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 1 },
                                        message: 'must be <= 1'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 0 || isNaN(data0)) {
                                    validate257.errors = [
                                        {
                                            instancePath: instancePath + '/quantile',
                                            schemaPath: '#/properties/quantile/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate257.errors = [
                                {
                                    instancePath: instancePath + '/quantile',
                                    schemaPath: '#/properties/quantile/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newColumn !== undefined) {
                        let data1 = data.newColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate257.errors = [
                                        {
                                            instancePath: instancePath + '/newColumn',
                                            schemaPath: '#/properties/newColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate257.errors = [
                                    {
                                        instancePath: instancePath + '/newColumn',
                                        schemaPath: '#/properties/newColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate257.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate257.errors = vErrors;
    return errors === 0;
}
export const queriesSchemaValidation = validate258;
const schema351 = {
    $id: 'urn:wisepipe-common-pipe:Queries',
    type: 'object',
    properties: { queries: { type: 'object', additionalProperties: { type: 'string' } } },
    required: ['queries']
};
function validate258(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:Queries" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.queries === undefined && (missing0 = 'queries')) {
                validate258.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.queries !== undefined) {
                    let data0 = data.queries;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                const _errs4 = errors;
                                if (typeof data0[key0] !== 'string') {
                                    validate258.errors = [
                                        {
                                            instancePath: instancePath + '/queries/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                            schemaPath: '#/properties/queries/additionalProperties/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate258.errors = [
                                {
                                    instancePath: instancePath + '/queries',
                                    schemaPath: '#/properties/queries/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate258.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate258.errors = vErrors;
    return errors === 0;
}
export const queueCreateChallengePipeEventSchemaValidation = validate259;
const schema352 = {
    $id: 'urn:wisepipe-common-pipe:QueueCreateChallengePipeEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', minLength: 1, maxLength: 128 },
        originID: { type: 'string', uid: 9 },
        dataSourceID: { type: 'string', uid: 9 },
        globalDataType: {
            type: 'string',
            enum: [
                'sampleCustomers',
                'adjustments',
                'commissions',
                'payouts',
                'transactions',
                'forecasting',
                'diversity',
                'sellerPerformance',
                'genderPay',
                'sellerChurn',
                'sellerChurnTest',
                'diversityCandidates',
                'leadScoring',
                'sellerCapacity',
                'sellerCapacityPerformance',
                'smartMatcherTransactionsTrain',
                'smartMatcherLookupTrain',
                'smartMatcherTransactionsTest',
                'smartMatcherLookupTest',
                'benchmarking',
                'oneColumnOneRow',
                'combinationMatcherData',
                'combinationMatcherValidCombination',
                'financialAdvisorTurnoverTrain',
                'financialAdvisorTurnoverTest',
                'customerLifetimeValueSMBRevenue',
                'customerLifetimeValueMMRevenue',
                'customerLifetimeValueEnterpriseRevenue',
                'dealValueChangesCRMOpportunities',
                'discountingDiagnosticsOrders',
                'discountingDiagnosticsIndustryBenchmarks',
                'discountingDiagnosticsDealSizeBenchmarks',
                'asc606PrepBaseCommission',
                'asc606PrepTransactionCredits',
                'asc606PrepTransactionMaster',
                'asc606TransactionalCommissions',
                'asc606DateString',
                'asc606AmortizationSetup',
                'opportunityScores',
                'rosterValidationICM',
                'rosterValidationSP',
                'orderValidationOrders',
                'orderValidationValidOrders',
                'orderValidationTransactions',
                'orderConsolidationOrders',
                'orderConsolidationValidOrders',
                'recordAndAdjustmentCurrentPeriodTransactions',
                'recordAndAdjustmentPriorPeriodTransactions',
                'identifyNewHiresAllEmployees',
                'identifyNewHiresNewHires',
                'trackTerritoryChangesCurrentCycle',
                'trackTerritoryChangesPreviousCycle',
                'transactionReconciliationBillingData',
                'transactionReconciliationOrders',
                'transactionValidationTransactions',
                'entityResolutionAccountLookup',
                'entityResolutionTransactions',
                'hierarchyCreationAccountList',
                'hierarchyCreationUSStatesCode',
                'hierarchyValidatorCustomerAccounts',
                'discountingDiagnosticsOverall',
                'discountingDiagnostics0_1000',
                'discountingDiagnostics1001_5000',
                'fuzzyMatcherCustomerLookup',
                'fuzzyMatcherSurveyResults',
                'hotelBookings',
                'netflixTitles',
                'netflix',
                'renewableEnergyProduction',
                'predictCOVID-19Deaths',
                'marketingCampaignTargetCustomer',
                'salesForecast',
                'vehicleTransactions',
                'telecommunicationsCustomers',
                'onlineRetailTransactions',
                'salesOpportunities',
                'salesForecasting',
                'crmData',
                'zoomInfoData',
                'wholesaleInvoice',
                'wholesaleProducts',
                'dynamicDashboard',
                'financialStatement',
                'gamification01',
                'forecastingSolutions'
            ]
        }
    },
    required: ['orgID', 'userID', 'originID', 'dataSourceID', 'globalDataType']
};
const func454 = ucs2length;
const func455 = base64urlToBuffer;
const func456 = base64urlEncode;
const func457 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func458 = ucs2length;
const func459 = base64urlToBuffer;
const func460 = base64urlEncode;
const func461 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate259(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:QueueCreateChallengePipeEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.originID === undefined && (missing0 = 'originID')) ||
                (data.dataSourceID === undefined && (missing0 = 'dataSourceID')) ||
                (data.globalDataType === undefined && (missing0 = 'globalDataType'))) {
                validate259.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate259.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate259.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 128) {
                                    validate259.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 128 },
                                            message: 'must NOT have more than 128 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate259.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate259.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.originID !== undefined) {
                            let data2 = data.originID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func454(data2) < b64min0 || func454(data2) > b64max0) {
                                        validate259.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func454(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func454(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func455(data2);
                                        if (decoded0.length !== 9) {
                                            validate259.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func456(decoded0);
                                            if (func457(encoded0) !== func457(data2)) {
                                                validate259.errors = [
                                                    {
                                                        instancePath: instancePath + '/originID',
                                                        schemaPath: '#/properties/originID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate259.errors = [
                                        {
                                            instancePath: instancePath + '/originID',
                                            schemaPath: '#/properties/originID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.dataSourceID !== undefined) {
                                let data3 = data.dataSourceID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func458(data3) < b64min1 || func458(data3) > b64max1) {
                                            validate259.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func458(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func458(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func459(data3);
                                            if (decoded1.length !== 9) {
                                                validate259.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func460(decoded1);
                                                if (func461(encoded1) !== func461(data3)) {
                                                    validate259.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataSourceID',
                                                            schemaPath: '#/properties/dataSourceID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate259.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.globalDataType !== undefined) {
                                    let data4 = data.globalDataType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate259.errors = [
                                            {
                                                instancePath: instancePath + '/globalDataType',
                                                schemaPath: '#/properties/globalDataType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'sampleCustomers' ||
                                        data4 === 'adjustments' ||
                                        data4 === 'commissions' ||
                                        data4 === 'payouts' ||
                                        data4 === 'transactions' ||
                                        data4 === 'forecasting' ||
                                        data4 === 'diversity' ||
                                        data4 === 'sellerPerformance' ||
                                        data4 === 'genderPay' ||
                                        data4 === 'sellerChurn' ||
                                        data4 === 'sellerChurnTest' ||
                                        data4 === 'diversityCandidates' ||
                                        data4 === 'leadScoring' ||
                                        data4 === 'sellerCapacity' ||
                                        data4 === 'sellerCapacityPerformance' ||
                                        data4 === 'smartMatcherTransactionsTrain' ||
                                        data4 === 'smartMatcherLookupTrain' ||
                                        data4 === 'smartMatcherTransactionsTest' ||
                                        data4 === 'smartMatcherLookupTest' ||
                                        data4 === 'benchmarking' ||
                                        data4 === 'oneColumnOneRow' ||
                                        data4 === 'combinationMatcherData' ||
                                        data4 === 'combinationMatcherValidCombination' ||
                                        data4 === 'financialAdvisorTurnoverTrain' ||
                                        data4 === 'financialAdvisorTurnoverTest' ||
                                        data4 === 'customerLifetimeValueSMBRevenue' ||
                                        data4 === 'customerLifetimeValueMMRevenue' ||
                                        data4 === 'customerLifetimeValueEnterpriseRevenue' ||
                                        data4 === 'dealValueChangesCRMOpportunities' ||
                                        data4 === 'discountingDiagnosticsOrders' ||
                                        data4 === 'discountingDiagnosticsIndustryBenchmarks' ||
                                        data4 === 'discountingDiagnosticsDealSizeBenchmarks' ||
                                        data4 === 'asc606PrepBaseCommission' ||
                                        data4 === 'asc606PrepTransactionCredits' ||
                                        data4 === 'asc606PrepTransactionMaster' ||
                                        data4 === 'asc606TransactionalCommissions' ||
                                        data4 === 'asc606DateString' ||
                                        data4 === 'asc606AmortizationSetup' ||
                                        data4 === 'opportunityScores' ||
                                        data4 === 'rosterValidationICM' ||
                                        data4 === 'rosterValidationSP' ||
                                        data4 === 'orderValidationOrders' ||
                                        data4 === 'orderValidationValidOrders' ||
                                        data4 === 'orderValidationTransactions' ||
                                        data4 === 'orderConsolidationOrders' ||
                                        data4 === 'orderConsolidationValidOrders' ||
                                        data4 === 'recordAndAdjustmentCurrentPeriodTransactions' ||
                                        data4 === 'recordAndAdjustmentPriorPeriodTransactions' ||
                                        data4 === 'identifyNewHiresAllEmployees' ||
                                        data4 === 'identifyNewHiresNewHires' ||
                                        data4 === 'trackTerritoryChangesCurrentCycle' ||
                                        data4 === 'trackTerritoryChangesPreviousCycle' ||
                                        data4 === 'transactionReconciliationBillingData' ||
                                        data4 === 'transactionReconciliationOrders' ||
                                        data4 === 'transactionValidationTransactions' ||
                                        data4 === 'entityResolutionAccountLookup' ||
                                        data4 === 'entityResolutionTransactions' ||
                                        data4 === 'hierarchyCreationAccountList' ||
                                        data4 === 'hierarchyCreationUSStatesCode' ||
                                        data4 === 'hierarchyValidatorCustomerAccounts' ||
                                        data4 === 'discountingDiagnosticsOverall' ||
                                        data4 === 'discountingDiagnostics0_1000' ||
                                        data4 === 'discountingDiagnostics1001_5000' ||
                                        data4 === 'fuzzyMatcherCustomerLookup' ||
                                        data4 === 'fuzzyMatcherSurveyResults' ||
                                        data4 === 'hotelBookings' ||
                                        data4 === 'netflixTitles' ||
                                        data4 === 'netflix' ||
                                        data4 === 'renewableEnergyProduction' ||
                                        data4 === 'predictCOVID-19Deaths' ||
                                        data4 === 'marketingCampaignTargetCustomer' ||
                                        data4 === 'salesForecast' ||
                                        data4 === 'vehicleTransactions' ||
                                        data4 === 'telecommunicationsCustomers' ||
                                        data4 === 'onlineRetailTransactions' ||
                                        data4 === 'salesOpportunities' ||
                                        data4 === 'salesForecasting' ||
                                        data4 === 'crmData' ||
                                        data4 === 'zoomInfoData' ||
                                        data4 === 'wholesaleInvoice' ||
                                        data4 === 'wholesaleProducts' ||
                                        data4 === 'dynamicDashboard' ||
                                        data4 === 'financialStatement' ||
                                        data4 === 'gamification01' ||
                                        data4 === 'forecastingSolutions')) {
                                        validate259.errors = [
                                            {
                                                instancePath: instancePath + '/globalDataType',
                                                schemaPath: '#/properties/globalDataType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema352.properties.globalDataType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate259.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate259.errors = vErrors;
    return errors === 0;
}
export const randomForestRegressorConfigSchemaValidation = validate260;
const schema353 = {
    $id: 'urn:wisepipe-common-pipe:RandomForestRegressorConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate260(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RandomForestRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate260.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate260.errors = vErrors;
    return errors === 0;
}
export const randomForestTrainConfigSchemaValidation = validate261;
const schema354 = {
    $id: 'urn:wisepipe-common-pipe:RandomForestTrainConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate261(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RandomForestTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate261.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate261.errors = vErrors;
    return errors === 0;
}
export const randomNumberGeneratorConfigSchemaValidation = validate262;
const schema355 = {
    $id: 'urn:wisepipe-common-pipe:RandomNumberGeneratorConfig',
    type: 'object',
    properties: {
        randomizerColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:RandomizerColumn' },
            uniqueItemProperties: ['name'],
            minItems: 1
        },
        repeatIDColName: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['randomizerColumns']
};
const schema356 = {
    $id: 'urn:wisepipe-common-pipe:RandomizerColumn',
    type: 'object',
    properties: {
        name: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        assumptionType: { type: 'string', enum: ['learned', 'data_distribution'] },
        constraints: { $ref: 'urn:wisepipe-common-pipe:MonteCarloConstraint' }
    },
    required: ['name', 'assumptionType']
};
function validate263(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RandomizerColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.assumptionType === undefined && (missing0 = 'assumptionType'))) {
                validate263.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/name',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/name',
                                schemaPath: '#/properties/name/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate263.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.assumptionType !== undefined) {
                        let data1 = data.assumptionType;
                        const _errs8 = errors;
                        if (typeof data1 !== 'string') {
                            validate263.errors = [
                                {
                                    instancePath: instancePath + '/assumptionType',
                                    schemaPath: '#/properties/assumptionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'learned' || data1 === 'data_distribution')) {
                            validate263.errors = [
                                {
                                    instancePath: instancePath + '/assumptionType',
                                    schemaPath: '#/properties/assumptionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema356.properties.assumptionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.constraints !== undefined) {
                            let data2 = data.constraints;
                            const _errs10 = errors;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    if (data2.min !== undefined) {
                                        const _errs13 = errors;
                                        if (!(typeof data2.min == 'number')) {
                                            validate263.errors = [
                                                {
                                                    instancePath: instancePath + '/constraints/min',
                                                    schemaPath: 'urn:wisepipe-common-pipe:MonteCarloConstraint/properties/min/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid4 = _errs13 === errors;
                                    }
                                    else {
                                        var valid4 = true;
                                    }
                                    if (valid4) {
                                        if (data2.max !== undefined) {
                                            const _errs15 = errors;
                                            if (!(typeof data2.max == 'number')) {
                                                validate263.errors = [
                                                    {
                                                        instancePath: instancePath + '/constraints/max',
                                                        schemaPath: 'urn:wisepipe-common-pipe:MonteCarloConstraint/properties/max/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid4 = _errs15 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                    }
                                }
                                else {
                                    validate263.errors = [
                                        {
                                            instancePath: instancePath + '/constraints',
                                            schemaPath: 'urn:wisepipe-common-pipe:MonteCarloConstraint/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs10 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate263.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate263.errors = vErrors;
    return errors === 0;
}
const func464 = ajvEqual;
function validate262(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RandomNumberGeneratorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.randomizerColumns === undefined && (missing0 = 'randomizerColumns')) {
                validate262.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.randomizerColumns !== undefined) {
                    let data0 = data.randomizerColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate262.errors = [
                                    {
                                        instancePath: instancePath + '/randomizerColumns',
                                        schemaPath: '#/properties/randomizerColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs3 = errors;
                                    if (!validate263(data0[i0], {
                                        instancePath: instancePath + '/randomizerColumns/' + i0,
                                        parentData: data0,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate263.errors : vErrors.concat(validate263.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema355.properties.randomizerColumns.uniqueItemProperties;
                                    let k0;
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data0.length; i1--;) {
                                                let x0 = data0[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data0[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func464(x0[key0], y0[key0])) {
                                                        validate262.errors = [
                                                            {
                                                                instancePath: instancePath + '/randomizerColumns',
                                                                schemaPath: '#/properties/randomizerColumns/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate262.errors = [
                                {
                                    instancePath: instancePath + '/randomizerColumns',
                                    schemaPath: '#/properties/randomizerColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.repeatIDColName !== undefined) {
                        let data2 = data.repeatIDColName;
                        const _errs4 = errors;
                        const _errs5 = errors;
                        let valid3 = false;
                        let passing0 = null;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                const err0 = {
                                    instancePath: instancePath + '/repeatIDColName',
                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err0];
                                }
                                else {
                                    vErrors.push(err0);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs6 === errors;
                        if (_valid0) {
                            valid3 = true;
                            passing0 = 0;
                        }
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) > 150) {
                                    const err1 = {
                                        instancePath: instancePath + '/repeatIDColName',
                                        schemaPath: '#/properties/repeatIDColName/oneOf/1/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                }
                                else {
                                    if (func2(data2) < 1) {
                                        const err2 = {
                                            instancePath: instancePath + '/repeatIDColName',
                                            schemaPath: '#/properties/repeatIDColName/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err3 = {
                                    instancePath: instancePath + '/repeatIDColName',
                                    schemaPath: '#/properties/repeatIDColName/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs9 === errors;
                        if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 1];
                        }
                        else {
                            if (_valid0) {
                                valid3 = true;
                                passing0 = 1;
                            }
                        }
                        if (!valid3) {
                            const err4 = {
                                instancePath: instancePath + '/repeatIDColName',
                                schemaPath: '#/properties/repeatIDColName/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing0 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err4];
                            }
                            else {
                                vErrors.push(err4);
                            }
                            errors++;
                            validate262.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs5;
                            if (vErrors !== null) {
                                if (_errs5) {
                                    vErrors.length = _errs5;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs4 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate262.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate262.errors = vErrors;
    return errors === 0;
}
export const randomizerColumnDataDistributionSchemaValidation = validate265;
const schema360 = {
    $id: 'urn:wisepipe-common-pipe:RandomizerColumnDataDistribution',
    type: 'object',
    properties: {
        distributionType: { type: 'string', enum: ['normal', 'triangular', 'uniform', 'weibull', 'poisson', 'binomial'] },
        distribution: { $ref: 'urn:wisepipe-common-pipe:DataDistribution' }
    },
    required: ['distributionType', 'distribution']
};
function validate265(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RandomizerColumnDataDistribution" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.distributionType === undefined && (missing0 = 'distributionType')) ||
                (data.distribution === undefined && (missing0 = 'distribution'))) {
                validate265.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.distributionType !== undefined) {
                    let data0 = data.distributionType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate265.errors = [
                            {
                                instancePath: instancePath + '/distributionType',
                                schemaPath: '#/properties/distributionType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'normal' ||
                        data0 === 'triangular' ||
                        data0 === 'uniform' ||
                        data0 === 'weibull' ||
                        data0 === 'poisson' ||
                        data0 === 'binomial')) {
                        validate265.errors = [
                            {
                                instancePath: instancePath + '/distributionType',
                                schemaPath: '#/properties/distributionType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema360.properties.distributionType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.distribution !== undefined) {
                        let data1 = data.distribution;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if (data1.type === undefined && (missing1 = 'type')) {
                                    validate265.errors = [
                                        {
                                            instancePath: instancePath + '/distribution',
                                            schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.type !== undefined) {
                                        let data2 = data1.type;
                                        if (typeof data2 !== 'string') {
                                            validate265.errors = [
                                                {
                                                    instancePath: instancePath + '/distribution/type',
                                                    schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/properties/type/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data2 === 'normal' ||
                                            data2 === 'triangular' ||
                                            data2 === 'uniform' ||
                                            data2 === 'weibull' ||
                                            data2 === 'poisson' ||
                                            data2 === 'binomial')) {
                                            validate265.errors = [
                                                {
                                                    instancePath: instancePath + '/distribution/type',
                                                    schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/properties/type/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema119.properties.type.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate265.errors = [
                                    {
                                        instancePath: instancePath + '/distribution',
                                        schemaPath: 'urn:wisepipe-common-pipe:DataDistribution/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate265.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate265.errors = vErrors;
    return errors === 0;
}
export const randomizerColumnLearnedSchemaValidation = validate266;
const schema362 = {
    $id: 'urn:wisepipe-common-pipe:RandomizerColumnLearned',
    type: 'object',
    properties: {
        learnFrom: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        groupBy: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true
        }
    },
    required: ['learnFrom']
};
function validate266(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RandomizerColumnLearned" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.learnFrom === undefined && (missing0 = 'learnFrom')) {
                validate266.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.learnFrom !== undefined) {
                    let data0 = data.learnFrom;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/learnFrom',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                const err1 = {
                                    instancePath: instancePath + '/learnFrom',
                                    schemaPath: '#/properties/learnFrom/oneOf/1/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 150 },
                                    message: 'must NOT have more than 150 characters'
                                };
                                if (vErrors === null) {
                                    vErrors = [err1];
                                }
                                else {
                                    vErrors.push(err1);
                                }
                                errors++;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    const err2 = {
                                        instancePath: instancePath + '/learnFrom',
                                        schemaPath: '#/properties/learnFrom/oneOf/1/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err3 = {
                                instancePath: instancePath + '/learnFrom',
                                schemaPath: '#/properties/learnFrom/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err4 = {
                            instancePath: instancePath + '/learnFrom',
                            schemaPath: '#/properties/learnFrom/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                        validate266.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupBy !== undefined) {
                        let data1 = data.groupBy;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (Array.isArray(data1)) {
                                var valid3 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs10 = errors;
                                    const _errs11 = errors;
                                    let valid4 = false;
                                    let passing1 = null;
                                    const _errs12 = errors;
                                    const _errs13 = errors;
                                    if (errors === _errs13) {
                                        if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                            const err5 = {
                                                instancePath: instancePath + '/groupBy/' + i0,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs12 === errors;
                                    if (_valid1) {
                                        valid4 = true;
                                        passing1 = 0;
                                    }
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) > 150) {
                                                const err6 = {
                                                    instancePath: instancePath + '/groupBy/' + i0,
                                                    schemaPath: '#/properties/groupBy/items/oneOf/1/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 150 },
                                                    message: 'must NOT have more than 150 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err6];
                                                }
                                                else {
                                                    vErrors.push(err6);
                                                }
                                                errors++;
                                            }
                                            else {
                                                if (func2(data2) < 1) {
                                                    const err7 = {
                                                        instancePath: instancePath + '/groupBy/' + i0,
                                                        schemaPath: '#/properties/groupBy/items/oneOf/1/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err7];
                                                    }
                                                    else {
                                                        vErrors.push(err7);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err8 = {
                                                instancePath: instancePath + '/groupBy/' + i0,
                                                schemaPath: '#/properties/groupBy/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs15 === errors;
                                    if (_valid1 && valid4) {
                                        valid4 = false;
                                        passing1 = [passing1, 1];
                                    }
                                    else {
                                        if (_valid1) {
                                            valid4 = true;
                                            passing1 = 1;
                                        }
                                    }
                                    if (!valid4) {
                                        const err9 = {
                                            instancePath: instancePath + '/groupBy/' + i0,
                                            schemaPath: '#/properties/groupBy/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing1 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err9];
                                        }
                                        else {
                                            vErrors.push(err9);
                                        }
                                        errors++;
                                        validate266.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs11;
                                        if (vErrors !== null) {
                                            if (_errs11) {
                                                vErrors.length = _errs11;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid3 = _errs10 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                                if (valid3) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data1[i1], data1[j0])) {
                                                    validate266.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupBy',
                                                            schemaPath: '#/properties/groupBy/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate266.errors = [
                                    {
                                        instancePath: instancePath + '/groupBy',
                                        schemaPath: '#/properties/groupBy/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate266.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate266.errors = vErrors;
    return errors === 0;
}
export const randomizerColumnSchemaValidation = validate263;
export const rankConfigSchemaValidation = validate267;
const schema365 = {
    $id: 'urn:wisepipe-common-pipe:RankConfig',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['rank', 'dense_rank', 'percent_rank'] },
        alias: { type: 'string', minLength: 1, maxLength: 150 },
        groupColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        orderColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name'],
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['type', 'alias', 'groupColumns', 'orderColumns']
};
const func476 = ajvEqual;
function validate267(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RankConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.type === undefined && (missing0 = 'type')) ||
                (data.alias === undefined && (missing0 = 'alias')) ||
                (data.groupColumns === undefined && (missing0 = 'groupColumns')) ||
                (data.orderColumns === undefined && (missing0 = 'orderColumns'))) {
                validate267.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate267.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'rank' || data0 === 'dense_rank' || data0 === 'percent_rank')) {
                        validate267.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema365.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.alias !== undefined) {
                        let data1 = data.alias;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate267.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate267.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate267.errors = [
                                    {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.groupColumns !== undefined) {
                            let data2 = data.groupColumns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    if (data2.length > 1000) {
                                        validate267.errors = [
                                            {
                                                instancePath: instancePath + '/groupColumns',
                                                schemaPath: '#/properties/groupColumns/maxItems',
                                                keyword: 'maxItems',
                                                params: { limit: 1000 },
                                                message: 'must NOT have more than 1000 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid1 = true;
                                        const len0 = data2.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data3 = data2[i0];
                                            const _errs7 = errors;
                                            if (errors === _errs7) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) > 150) {
                                                        validate267.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupColumns/' + i0,
                                                                schemaPath: '#/properties/groupColumns/items/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 150 },
                                                                message: 'must NOT have more than 150 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (func2(data3) < 1) {
                                                            validate267.errors = [
                                                                {
                                                                    instancePath: instancePath + '/groupColumns/' + i0,
                                                                    schemaPath: '#/properties/groupColumns/items/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate267.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupColumns/' + i0,
                                                            schemaPath: '#/properties/groupColumns/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs7 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            let i1 = data2.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data2[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate267.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupColumns',
                                                                schemaPath: '#/properties/groupColumns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate267.errors = [
                                        {
                                            instancePath: instancePath + '/groupColumns',
                                            schemaPath: '#/properties/groupColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.orderColumns !== undefined) {
                                let data4 = data.orderColumns;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        if (data4.length > 1000) {
                                            validate267.errors = [
                                                {
                                                    instancePath: instancePath + '/orderColumns',
                                                    schemaPath: '#/properties/orderColumns/maxItems',
                                                    keyword: 'maxItems',
                                                    params: { limit: 1000 },
                                                    message: 'must NOT have more than 1000 items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data4.length < 1) {
                                                validate267.errors = [
                                                    {
                                                        instancePath: instancePath + '/orderColumns',
                                                        schemaPath: '#/properties/orderColumns/minItems',
                                                        keyword: 'minItems',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 items'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                var valid3 = true;
                                                const len1 = data4.length;
                                                for (let i2 = 0; i2 < len1; i2++) {
                                                    const _errs11 = errors;
                                                    if (!validate219(data4[i2], {
                                                        instancePath: instancePath + '/orderColumns/' + i2,
                                                        parentData: data4,
                                                        parentDataProperty: i2,
                                                        rootData
                                                    })) {
                                                        vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
                                                        errors = vErrors.length;
                                                    }
                                                    var valid3 = _errs11 === errors;
                                                    if (!valid3) {
                                                        break;
                                                    }
                                                }
                                                if (valid3) {
                                                    const keys0 = schema365.properties.orderColumns.uniqueItemProperties;
                                                    let k0;
                                                    let i3 = data4.length;
                                                    let j1;
                                                    if (i3 > 1) {
                                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                            let key0 = keys0[k0];
                                                            for (i3 = data4.length; i3--;) {
                                                                let x0 = data4[i3];
                                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                                    continue;
                                                                }
                                                                for (j1 = i3; j1--;) {
                                                                    let y0 = data4[j1];
                                                                    if (y0 &&
                                                                        typeof y0 == 'object' &&
                                                                        !Array.isArray(y0) &&
                                                                        func476(x0[key0], y0[key0])) {
                                                                        validate267.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/orderColumns',
                                                                                schemaPath: '#/properties/orderColumns/uniqueItemProperties',
                                                                                keyword: 'uniqueItemProperties',
                                                                                params: {},
                                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                        break outer0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate267.errors = [
                                            {
                                                instancePath: instancePath + '/orderColumns',
                                                schemaPath: '#/properties/orderColumns/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate267.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate267.errors = vErrors;
    return errors === 0;
}
export const recordIdConfigSchemaValidation = validate269;
const schema366 = {
    $id: 'urn:wisepipe-common-pipe:RecordIdConfig',
    type: 'object',
    properties: { columnName: { type: 'string', minLength: 1 } },
    required: ['columnName']
};
function validate269(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RecordIdConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columnName === undefined && (missing0 = 'columnName')) {
                validate269.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnName !== undefined) {
                    let data0 = data.columnName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate269.errors = [
                                    {
                                        instancePath: instancePath + '/columnName',
                                        schemaPath: '#/properties/columnName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate269.errors = [
                                {
                                    instancePath: instancePath + '/columnName',
                                    schemaPath: '#/properties/columnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate269.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate269.errors = vErrors;
    return errors === 0;
}
export const regressorConfigSchemaValidation = validate270;
const schema367 = {
    $id: 'urn:wisepipe-common-pipe:RegressorConfig',
    type: 'object',
    properties: { options: { type: 'integer', minimum: 1, maximum: 15 } },
    required: ['options']
};
function validate270(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.options === undefined && (missing0 = 'options')) {
                validate270.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.options !== undefined) {
                    let data0 = data.options;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate270.errors = [
                            {
                                instancePath: instancePath + '/options',
                                schemaPath: '#/properties/options/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 15 || isNaN(data0)) {
                                validate270.errors = [
                                    {
                                        instancePath: instancePath + '/options',
                                        schemaPath: '#/properties/options/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 15 },
                                        message: 'must be <= 15'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate270.errors = [
                                        {
                                            instancePath: instancePath + '/options',
                                            schemaPath: '#/properties/options/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate270.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate270.errors = vErrors;
    return errors === 0;
}
export const removeEmptyConfigSchemaValidation = validate271;
const schema368 = {
    $id: 'urn:wisepipe-common-pipe:RemoveEmptyConfig',
    type: 'object',
    properties: { columns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true } },
    required: ['columns']
};
function validate271(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RemoveEmptyConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate271.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate271.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate271.errors = [
                                            {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    const indices0 = {};
                                    for (; i1--;) {
                                        let item0 = data0[i1];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j0 = indices0[item0];
                                            validate271.errors = [
                                                {
                                                    instancePath: instancePath + '/columns',
                                                    schemaPath: '#/properties/columns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                }
                                            ];
                                            return false;
                                            break;
                                        }
                                        indices0[item0] = i1;
                                    }
                                }
                            }
                        }
                        else {
                            validate271.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate271.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate271.errors = vErrors;
    return errors === 0;
}
export const removeOutliersConfigSchemaValidation = validate272;
const schema369 = {
    $id: 'urn:wisepipe-common-pipe:RemoveOutliersConfig',
    type: 'object',
    properties: {
        columnName: { type: 'string', minLength: 1 },
        min: { type: 'integer', maximum: { $data: '1/max' } },
        max: { type: 'integer', minimum: { $data: '1/min' } }
    },
    required: ['columnName', 'min', 'max']
};
function validate272(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RemoveOutliersConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnName === undefined && (missing0 = 'columnName')) ||
                (data.min === undefined && (missing0 = 'min')) ||
                (data.max === undefined && (missing0 = 'max'))) {
                validate272.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnName !== undefined) {
                    let data0 = data.columnName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate272.errors = [
                                    {
                                        instancePath: instancePath + '/columnName',
                                        schemaPath: '#/properties/columnName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate272.errors = [
                                {
                                    instancePath: instancePath + '/columnName',
                                    schemaPath: '#/properties/columnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.min !== undefined) {
                        let data1 = data.min;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number' && !(data1 % 1) && !isNaN(data1))) {
                            validate272.errors = [
                                {
                                    instancePath: instancePath + '/min',
                                    schemaPath: '#/properties/min/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                const vSchema0 = data && data.max;
                                if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data1 > vSchema0 || isNaN(data1))) {
                                    validate272.errors = [
                                        {
                                            instancePath: instancePath + '/min',
                                            schemaPath: '#/properties/min/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: vSchema0 },
                                            message: 'must be <= ' + vSchema0
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.max !== undefined) {
                            let data2 = data.max;
                            const _errs5 = errors;
                            if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                                validate272.errors = [
                                    {
                                        instancePath: instancePath + '/max',
                                        schemaPath: '#/properties/max/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer'
                                    }
                                ];
                                return false;
                            }
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    const vSchema1 = data && data.min;
                                    if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data2 < vSchema1 || isNaN(data2))) {
                                        validate272.errors = [
                                            {
                                                instancePath: instancePath + '/max',
                                                schemaPath: '#/properties/max/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: vSchema1 },
                                                message: 'must be >= ' + vSchema1
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate272.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate272.errors = vErrors;
    return errors === 0;
}
export const renameColumnSchemaValidation = validate273;
const schema370 = {
    $id: 'urn:wisepipe-common-pipe:RenameColumn',
    type: 'object',
    properties: {
        oldName: { type: 'string', minLength: 1, maxLength: 150 },
        newName: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['oldName', 'newName']
};
function validate273(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RenameColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.oldName === undefined && (missing0 = 'oldName')) ||
                (data.newName === undefined && (missing0 = 'newName'))) {
                validate273.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.oldName !== undefined) {
                    let data0 = data.oldName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate273.errors = [
                                    {
                                        instancePath: instancePath + '/oldName',
                                        schemaPath: '#/properties/oldName/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate273.errors = [
                                        {
                                            instancePath: instancePath + '/oldName',
                                            schemaPath: '#/properties/oldName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate273.errors = [
                                {
                                    instancePath: instancePath + '/oldName',
                                    schemaPath: '#/properties/oldName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newName !== undefined) {
                        let data1 = data.newName;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        let valid1 = false;
                        let passing0 = null;
                        const _errs5 = errors;
                        const _errs6 = errors;
                        if (errors === _errs6) {
                            if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                const err0 = {
                                    instancePath: instancePath + '/newName',
                                    schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err0];
                                }
                                else {
                                    vErrors.push(err0);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs5 === errors;
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 0;
                        }
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    const err1 = {
                                        instancePath: instancePath + '/newName',
                                        schemaPath: '#/properties/newName/oneOf/1/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        const err2 = {
                                            instancePath: instancePath + '/newName',
                                            schemaPath: '#/properties/newName/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err3 = {
                                    instancePath: instancePath + '/newName',
                                    schemaPath: '#/properties/newName/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                            }
                        }
                        var _valid0 = _errs8 === errors;
                        if (_valid0 && valid1) {
                            valid1 = false;
                            passing0 = [passing0, 1];
                        }
                        else {
                            if (_valid0) {
                                valid1 = true;
                                passing0 = 1;
                            }
                        }
                        if (!valid1) {
                            const err4 = {
                                instancePath: instancePath + '/newName',
                                schemaPath: '#/properties/newName/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing0 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err4];
                            }
                            else {
                                vErrors.push(err4);
                            }
                            errors++;
                            validate273.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs4;
                            if (vErrors !== null) {
                                if (_errs4) {
                                    vErrors.length = _errs4;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate273.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate273.errors = vErrors;
    return errors === 0;
}
export const renameConfigSchemaValidation = validate274;
const schema372 = {
    $id: 'urn:wisepipe-common-pipe:RenameConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:RenameColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['oldName', 'newName']
        }
    },
    required: ['columns']
};
const func484 = ajvEqual;
function validate274(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RenameConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate274.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate274.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate274.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs3 = errors;
                                        if (!validate273(data0[i0], {
                                            instancePath: instancePath + '/columns/' + i0,
                                            parentData: data0,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate273.errors : vErrors.concat(validate273.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema372.properties.columns.uniqueItemProperties;
                                        let k0;
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data0.length; i1--;) {
                                                    let x0 = data0[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data0[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func484(x0[key0], y0[key0])) {
                                                            validate274.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns',
                                                                    schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate274.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate274.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate274.errors = vErrors;
    return errors === 0;
}
export const reorderConfigSchemaValidation = validate276;
const schema373 = {
    $id: 'urn:wisepipe-common-pipe:ReorderConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['columns']
};
function validate276(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReorderConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate276.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate276.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate276.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        if (errors === _errs3) {
                                            if (typeof data1 === 'string') {
                                                if (func2(data1) > 150) {
                                                    validate276.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 150 },
                                                            message: 'must NOT have more than 150 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data1) < 1) {
                                                        validate276.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns/' + i0,
                                                                schemaPath: '#/properties/columns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate276.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data0[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate276.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate276.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate276.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate276.errors = vErrors;
    return errors === 0;
}
export const repeatConfigSchemaValidation = validate277;
const schema374 = {
    $id: 'urn:wisepipe-common-pipe:RepeatConfig',
    type: 'object',
    properties: {
        repeats: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' }, { type: 'integer', minimum: 1 }] },
        repeatIDColName: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['repeats']
};
function validate277(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RepeatConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.repeats === undefined && (missing0 = 'repeats')) {
                validate277.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.repeats !== undefined) {
                    let data0 = data.repeats;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    let valid1 = false;
                    let passing0 = null;
                    const _errs3 = errors;
                    const _errs4 = errors;
                    if (errors === _errs4) {
                        if (!(data0 && typeof data0 == 'object' && !Array.isArray(data0))) {
                            const err0 = {
                                instancePath: instancePath + '/repeats',
                                schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err0];
                            }
                            else {
                                vErrors.push(err0);
                            }
                            errors++;
                        }
                    }
                    var _valid0 = _errs3 === errors;
                    if (_valid0) {
                        valid1 = true;
                        passing0 = 0;
                    }
                    const _errs6 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        const err1 = {
                            instancePath: instancePath + '/repeats',
                            schemaPath: '#/properties/repeats/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer'
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                    if (errors === _errs6) {
                        if (typeof data0 == 'number') {
                            if (data0 < 1 || isNaN(data0)) {
                                const err2 = {
                                    instancePath: instancePath + '/repeats',
                                    schemaPath: '#/properties/repeats/oneOf/1/minimum',
                                    keyword: 'minimum',
                                    params: { comparison: '>=', limit: 1 },
                                    message: 'must be >= 1'
                                };
                                if (vErrors === null) {
                                    vErrors = [err2];
                                }
                                else {
                                    vErrors.push(err2);
                                }
                                errors++;
                            }
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    if (_valid0 && valid1) {
                        valid1 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid0) {
                            valid1 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid1) {
                        const err3 = {
                            instancePath: instancePath + '/repeats',
                            schemaPath: '#/properties/repeats/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                        validate277.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs2;
                        if (vErrors !== null) {
                            if (_errs2) {
                                vErrors.length = _errs2;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.repeatIDColName !== undefined) {
                        let data1 = data.repeatIDColName;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid3 = false;
                        let passing1 = null;
                        const _errs10 = errors;
                        const _errs11 = errors;
                        if (errors === _errs11) {
                            if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                const err4 = {
                                    instancePath: instancePath + '/repeatIDColName',
                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err4];
                                }
                                else {
                                    vErrors.push(err4);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs10 === errors;
                        if (_valid1) {
                            valid3 = true;
                            passing1 = 0;
                        }
                        const _errs13 = errors;
                        if (errors === _errs13) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    const err5 = {
                                        instancePath: instancePath + '/repeatIDColName',
                                        schemaPath: '#/properties/repeatIDColName/oneOf/1/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        const err6 = {
                                            instancePath: instancePath + '/repeatIDColName',
                                            schemaPath: '#/properties/repeatIDColName/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err7 = {
                                    instancePath: instancePath + '/repeatIDColName',
                                    schemaPath: '#/properties/repeatIDColName/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                        }
                        var _valid1 = _errs13 === errors;
                        if (_valid1 && valid3) {
                            valid3 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid1) {
                                valid3 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid3) {
                            const err8 = {
                                instancePath: instancePath + '/repeatIDColName',
                                schemaPath: '#/properties/repeatIDColName/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                            validate277.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs9;
                            if (vErrors !== null) {
                                if (_errs9) {
                                    vErrors.length = _errs9;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate277.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate277.errors = vErrors;
    return errors === 0;
}
export const replaceConditionSchemaValidation = validate278;
function validate278(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReplaceCondition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.searchType === undefined && (missing0 = 'searchType')) ||
                (data.searchFor === undefined && (missing0 = 'searchFor')) ||
                (data.ignoreCase === undefined && (missing0 = 'ignoreCase')) ||
                (data.matchWord === undefined && (missing0 = 'matchWord'))) {
                validate278.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate278.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate278.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate278.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate278.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate278.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate278.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.searchType !== undefined) {
                        let data2 = data.searchType;
                        const _errs5 = errors;
                        if (typeof data2 !== 'string') {
                            validate278.errors = [
                                {
                                    instancePath: instancePath + '/searchType',
                                    schemaPath: '#/properties/searchType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'startsWith' ||
                            data2 === 'endsWith' ||
                            data2 === 'exactMatch' ||
                            data2 === 'every' ||
                            data2 === 'regex')) {
                            validate278.errors = [
                                {
                                    instancePath: instancePath + '/searchType',
                                    schemaPath: '#/properties/searchType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema282.properties.searchType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.searchFor !== undefined) {
                            let data3 = data.searchFor;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate278.errors = [
                                            {
                                                instancePath: instancePath + '/searchFor',
                                                schemaPath: '#/properties/searchFor/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate278.errors = [
                                        {
                                            instancePath: instancePath + '/searchFor',
                                            schemaPath: '#/properties/searchFor/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.replaceWith !== undefined) {
                                let data4 = data.replaceWith;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate278.errors = [
                                                {
                                                    instancePath: instancePath + '/replaceWith',
                                                    schemaPath: '#/properties/replaceWith/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate278.errors = [
                                            {
                                                instancePath: instancePath + '/replaceWith',
                                                schemaPath: '#/properties/replaceWith/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.ignoreCase !== undefined) {
                                    const _errs11 = errors;
                                    if (typeof data.ignoreCase !== 'boolean') {
                                        validate278.errors = [
                                            {
                                                instancePath: instancePath + '/ignoreCase',
                                                schemaPath: '#/properties/ignoreCase/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.matchWord !== undefined) {
                                        const _errs13 = errors;
                                        if (typeof data.matchWord !== 'boolean') {
                                            validate278.errors = [
                                                {
                                                    instancePath: instancePath + '/matchWord',
                                                    schemaPath: '#/properties/matchWord/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.name !== undefined) {
                                            let data7 = data.name;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 === 'string') {
                                                    if (func2(data7) < 1) {
                                                        validate278.errors = [
                                                            {
                                                                instancePath: instancePath + '/name',
                                                                schemaPath: '#/properties/name/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate278.errors = [
                                                        {
                                                            instancePath: instancePath + '/name',
                                                            schemaPath: '#/properties/name/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate278.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate278.errors = vErrors;
    return errors === 0;
}
export const replaceConfigSchemaValidation = validate279;
const schema378 = {
    $id: 'urn:wisepipe-common-pipe:ReplaceConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        searchType: { type: 'string', enum: ['startsWith', 'endsWith', 'exactMatch', 'every', 'regex'] },
        searchFor: { type: 'string', minLength: 1 },
        replaceWith: { type: 'string', minLength: 1 },
        ignoreCase: { type: 'boolean' },
        matchWord: { type: 'boolean' }
    },
    required: ['columns', 'searchType', 'searchFor', 'ignoreCase', 'matchWord']
};
function validate279(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReplaceConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.searchType === undefined && (missing0 = 'searchType')) ||
                (data.searchFor === undefined && (missing0 = 'searchFor')) ||
                (data.ignoreCase === undefined && (missing0 = 'ignoreCase')) ||
                (data.matchWord === undefined && (missing0 = 'matchWord'))) {
                validate279.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate279.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate279.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate279.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate279.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate279.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate279.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.searchType !== undefined) {
                        let data2 = data.searchType;
                        const _errs5 = errors;
                        if (typeof data2 !== 'string') {
                            validate279.errors = [
                                {
                                    instancePath: instancePath + '/searchType',
                                    schemaPath: '#/properties/searchType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data2 === 'startsWith' ||
                            data2 === 'endsWith' ||
                            data2 === 'exactMatch' ||
                            data2 === 'every' ||
                            data2 === 'regex')) {
                            validate279.errors = [
                                {
                                    instancePath: instancePath + '/searchType',
                                    schemaPath: '#/properties/searchType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema378.properties.searchType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.searchFor !== undefined) {
                            let data3 = data.searchFor;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate279.errors = [
                                            {
                                                instancePath: instancePath + '/searchFor',
                                                schemaPath: '#/properties/searchFor/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate279.errors = [
                                        {
                                            instancePath: instancePath + '/searchFor',
                                            schemaPath: '#/properties/searchFor/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.replaceWith !== undefined) {
                                let data4 = data.replaceWith;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) < 1) {
                                            validate279.errors = [
                                                {
                                                    instancePath: instancePath + '/replaceWith',
                                                    schemaPath: '#/properties/replaceWith/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate279.errors = [
                                            {
                                                instancePath: instancePath + '/replaceWith',
                                                schemaPath: '#/properties/replaceWith/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.ignoreCase !== undefined) {
                                    const _errs11 = errors;
                                    if (typeof data.ignoreCase !== 'boolean') {
                                        validate279.errors = [
                                            {
                                                instancePath: instancePath + '/ignoreCase',
                                                schemaPath: '#/properties/ignoreCase/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.matchWord !== undefined) {
                                        const _errs13 = errors;
                                        if (typeof data.matchWord !== 'boolean') {
                                            validate279.errors = [
                                                {
                                                    instancePath: instancePath + '/matchWord',
                                                    schemaPath: '#/properties/matchWord/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate279.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate279.errors = vErrors;
    return errors === 0;
}
export const reshapeConfigSchemaValidation = validate280;
const schema379 = {
    $id: 'urn:wisepipe-common-pipe:ReshapeConfig',
    type: 'object',
    properties: {
        add: { type: 'string', enum: ['columns', 'rows'] },
        wideColumns: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true,
            maxItems: 1000
        },
        longColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        valueColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['add', 'wideColumns', 'longColumn', 'valueColumn']
};
function validate280(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReshapeConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.add === undefined && (missing0 = 'add')) ||
                (data.wideColumns === undefined && (missing0 = 'wideColumns')) ||
                (data.longColumn === undefined && (missing0 = 'longColumn')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn'))) {
                validate280.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.add !== undefined) {
                    let data0 = data.add;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate280.errors = [
                            {
                                instancePath: instancePath + '/add',
                                schemaPath: '#/properties/add/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'columns' || data0 === 'rows')) {
                        validate280.errors = [
                            {
                                instancePath: instancePath + '/add',
                                schemaPath: '#/properties/add/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema379.properties.add.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.wideColumns !== undefined) {
                        let data1 = data.wideColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length > 1000) {
                                    validate280.errors = [
                                        {
                                            instancePath: instancePath + '/wideColumns',
                                            schemaPath: '#/properties/wideColumns/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        const _errs6 = errors;
                                        let valid2 = false;
                                        let passing0 = null;
                                        const _errs7 = errors;
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                                const err0 = {
                                                    instancePath: instancePath + '/wideColumns/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err0];
                                                }
                                                else {
                                                    vErrors.push(err0);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs7 === errors;
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 0;
                                        }
                                        const _errs10 = errors;
                                        if (errors === _errs10) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) > 150) {
                                                    const err1 = {
                                                        instancePath: instancePath + '/wideColumns/' + i0,
                                                        schemaPath: '#/properties/wideColumns/items/oneOf/1/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err1];
                                                    }
                                                    else {
                                                        vErrors.push(err1);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    if (func2(data2) < 1) {
                                                        const err2 = {
                                                            instancePath: instancePath + '/wideColumns/' + i0,
                                                            schemaPath: '#/properties/wideColumns/items/oneOf/1/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err2];
                                                        }
                                                        else {
                                                            vErrors.push(err2);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err3 = {
                                                    instancePath: instancePath + '/wideColumns/' + i0,
                                                    schemaPath: '#/properties/wideColumns/items/oneOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err3];
                                                }
                                                else {
                                                    vErrors.push(err3);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs10 === errors;
                                        if (_valid0 && valid2) {
                                            valid2 = false;
                                            passing0 = [passing0, 1];
                                        }
                                        else {
                                            if (_valid0) {
                                                valid2 = true;
                                                passing0 = 1;
                                            }
                                        }
                                        if (!valid2) {
                                            const err4 = {
                                                instancePath: instancePath + '/wideColumns/' + i0,
                                                schemaPath: '#/properties/wideColumns/items/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing0 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                            validate280.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs6;
                                            if (vErrors !== null) {
                                                if (_errs6) {
                                                    vErrors.length = _errs6;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (; i1--;) {
                                                for (j0 = i1; j0--;) {
                                                    if (func0(data1[i1], data1[j0])) {
                                                        validate280.errors = [
                                                            {
                                                                instancePath: instancePath + '/wideColumns',
                                                                schemaPath: '#/properties/wideColumns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate280.errors = [
                                    {
                                        instancePath: instancePath + '/wideColumns',
                                        schemaPath: '#/properties/wideColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.longColumn !== undefined) {
                            let data3 = data.longColumn;
                            const _errs12 = errors;
                            const _errs13 = errors;
                            let valid5 = false;
                            let passing1 = null;
                            const _errs14 = errors;
                            const _errs15 = errors;
                            if (errors === _errs15) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err5 = {
                                        instancePath: instancePath + '/longColumn',
                                        schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs14 === errors;
                            if (_valid1) {
                                valid5 = true;
                                passing1 = 0;
                            }
                            const _errs17 = errors;
                            if (errors === _errs17) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 150) {
                                        const err6 = {
                                            instancePath: instancePath + '/longColumn',
                                            schemaPath: '#/properties/longColumn/oneOf/1/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (func2(data3) < 1) {
                                            const err7 = {
                                                instancePath: instancePath + '/longColumn',
                                                schemaPath: '#/properties/longColumn/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err7];
                                            }
                                            else {
                                                vErrors.push(err7);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err8 = {
                                        instancePath: instancePath + '/longColumn',
                                        schemaPath: '#/properties/longColumn/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err8];
                                    }
                                    else {
                                        vErrors.push(err8);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs17 === errors;
                            if (_valid1 && valid5) {
                                valid5 = false;
                                passing1 = [passing1, 1];
                            }
                            else {
                                if (_valid1) {
                                    valid5 = true;
                                    passing1 = 1;
                                }
                            }
                            if (!valid5) {
                                const err9 = {
                                    instancePath: instancePath + '/longColumn',
                                    schemaPath: '#/properties/longColumn/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing1 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                                validate280.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs13;
                                if (vErrors !== null) {
                                    if (_errs13) {
                                        vErrors.length = _errs13;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.valueColumn !== undefined) {
                                let data4 = data.valueColumn;
                                const _errs19 = errors;
                                const _errs20 = errors;
                                let valid7 = false;
                                let passing2 = null;
                                const _errs21 = errors;
                                const _errs22 = errors;
                                if (errors === _errs22) {
                                    if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                        const err10 = {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err10];
                                        }
                                        else {
                                            vErrors.push(err10);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs21 === errors;
                                if (_valid2) {
                                    valid7 = true;
                                    passing2 = 0;
                                }
                                const _errs24 = errors;
                                if (errors === _errs24) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) > 150) {
                                            const err11 = {
                                                instancePath: instancePath + '/valueColumn',
                                                schemaPath: '#/properties/valueColumn/oneOf/1/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err11];
                                            }
                                            else {
                                                vErrors.push(err11);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (func2(data4) < 1) {
                                                const err12 = {
                                                    instancePath: instancePath + '/valueColumn',
                                                    schemaPath: '#/properties/valueColumn/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err12];
                                                }
                                                else {
                                                    vErrors.push(err12);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs24 === errors;
                                if (_valid2 && valid7) {
                                    valid7 = false;
                                    passing2 = [passing2, 1];
                                }
                                else {
                                    if (_valid2) {
                                        valid7 = true;
                                        passing2 = 1;
                                    }
                                }
                                if (!valid7) {
                                    const err14 = {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing2 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                    validate280.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs20;
                                    if (vErrors !== null) {
                                        if (_errs20) {
                                            vErrors.length = _errs20;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs19 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate280.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate280.errors = vErrors;
    return errors === 0;
}
export const reshapeV2ConfigSchemaValidation = validate281;
const schema383 = {
    $id: 'urn:wisepipe-common-pipe:ReshapeV2Config',
    type: 'object',
    properties: {
        add: { type: 'string', enum: ['columns', 'rows'] },
        wideColumns: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true,
            maxItems: 1000
        },
        longColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        valueColumn: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        }
    },
    required: ['add', 'wideColumns', 'longColumn', 'valueColumn']
};
function validate281(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReshapeV2Config" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.add === undefined && (missing0 = 'add')) ||
                (data.wideColumns === undefined && (missing0 = 'wideColumns')) ||
                (data.longColumn === undefined && (missing0 = 'longColumn')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn'))) {
                validate281.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.add !== undefined) {
                    let data0 = data.add;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate281.errors = [
                            {
                                instancePath: instancePath + '/add',
                                schemaPath: '#/properties/add/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'columns' || data0 === 'rows')) {
                        validate281.errors = [
                            {
                                instancePath: instancePath + '/add',
                                schemaPath: '#/properties/add/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema383.properties.add.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.wideColumns !== undefined) {
                        let data1 = data.wideColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length > 1000) {
                                    validate281.errors = [
                                        {
                                            instancePath: instancePath + '/wideColumns',
                                            schemaPath: '#/properties/wideColumns/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        const _errs6 = errors;
                                        let valid2 = false;
                                        let passing0 = null;
                                        const _errs7 = errors;
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                                const err0 = {
                                                    instancePath: instancePath + '/wideColumns/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err0];
                                                }
                                                else {
                                                    vErrors.push(err0);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs7 === errors;
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 0;
                                        }
                                        const _errs10 = errors;
                                        if (errors === _errs10) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) > 150) {
                                                    const err1 = {
                                                        instancePath: instancePath + '/wideColumns/' + i0,
                                                        schemaPath: '#/properties/wideColumns/items/oneOf/1/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err1];
                                                    }
                                                    else {
                                                        vErrors.push(err1);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    if (func2(data2) < 1) {
                                                        const err2 = {
                                                            instancePath: instancePath + '/wideColumns/' + i0,
                                                            schemaPath: '#/properties/wideColumns/items/oneOf/1/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err2];
                                                        }
                                                        else {
                                                            vErrors.push(err2);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err3 = {
                                                    instancePath: instancePath + '/wideColumns/' + i0,
                                                    schemaPath: '#/properties/wideColumns/items/oneOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err3];
                                                }
                                                else {
                                                    vErrors.push(err3);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs10 === errors;
                                        if (_valid0 && valid2) {
                                            valid2 = false;
                                            passing0 = [passing0, 1];
                                        }
                                        else {
                                            if (_valid0) {
                                                valid2 = true;
                                                passing0 = 1;
                                            }
                                        }
                                        if (!valid2) {
                                            const err4 = {
                                                instancePath: instancePath + '/wideColumns/' + i0,
                                                schemaPath: '#/properties/wideColumns/items/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing0 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                            validate281.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs6;
                                            if (vErrors !== null) {
                                                if (_errs6) {
                                                    vErrors.length = _errs6;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (; i1--;) {
                                                for (j0 = i1; j0--;) {
                                                    if (func0(data1[i1], data1[j0])) {
                                                        validate281.errors = [
                                                            {
                                                                instancePath: instancePath + '/wideColumns',
                                                                schemaPath: '#/properties/wideColumns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate281.errors = [
                                    {
                                        instancePath: instancePath + '/wideColumns',
                                        schemaPath: '#/properties/wideColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.longColumn !== undefined) {
                            let data3 = data.longColumn;
                            const _errs12 = errors;
                            const _errs13 = errors;
                            let valid5 = false;
                            let passing1 = null;
                            const _errs14 = errors;
                            const _errs15 = errors;
                            if (errors === _errs15) {
                                if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                    const err5 = {
                                        instancePath: instancePath + '/longColumn',
                                        schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs14 === errors;
                            if (_valid1) {
                                valid5 = true;
                                passing1 = 0;
                            }
                            const _errs17 = errors;
                            if (errors === _errs17) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) > 150) {
                                        const err6 = {
                                            instancePath: instancePath + '/longColumn',
                                            schemaPath: '#/properties/longColumn/oneOf/1/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (func2(data3) < 1) {
                                            const err7 = {
                                                instancePath: instancePath + '/longColumn',
                                                schemaPath: '#/properties/longColumn/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err7];
                                            }
                                            else {
                                                vErrors.push(err7);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err8 = {
                                        instancePath: instancePath + '/longColumn',
                                        schemaPath: '#/properties/longColumn/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err8];
                                    }
                                    else {
                                        vErrors.push(err8);
                                    }
                                    errors++;
                                }
                            }
                            var _valid1 = _errs17 === errors;
                            if (_valid1 && valid5) {
                                valid5 = false;
                                passing1 = [passing1, 1];
                            }
                            else {
                                if (_valid1) {
                                    valid5 = true;
                                    passing1 = 1;
                                }
                            }
                            if (!valid5) {
                                const err9 = {
                                    instancePath: instancePath + '/longColumn',
                                    schemaPath: '#/properties/longColumn/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing1 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                                validate281.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs13;
                                if (vErrors !== null) {
                                    if (_errs13) {
                                        vErrors.length = _errs13;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.valueColumn !== undefined) {
                                let data4 = data.valueColumn;
                                const _errs19 = errors;
                                const _errs20 = errors;
                                let valid7 = false;
                                let passing2 = null;
                                const _errs21 = errors;
                                const _errs22 = errors;
                                if (errors === _errs22) {
                                    if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                        const err10 = {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err10];
                                        }
                                        else {
                                            vErrors.push(err10);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs21 === errors;
                                if (_valid2) {
                                    valid7 = true;
                                    passing2 = 0;
                                }
                                const _errs24 = errors;
                                if (errors === _errs24) {
                                    if (typeof data4 === 'string') {
                                        if (func2(data4) > 150) {
                                            const err11 = {
                                                instancePath: instancePath + '/valueColumn',
                                                schemaPath: '#/properties/valueColumn/oneOf/1/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err11];
                                            }
                                            else {
                                                vErrors.push(err11);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (func2(data4) < 1) {
                                                const err12 = {
                                                    instancePath: instancePath + '/valueColumn',
                                                    schemaPath: '#/properties/valueColumn/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err12];
                                                }
                                                else {
                                                    vErrors.push(err12);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs24 === errors;
                                if (_valid2 && valid7) {
                                    valid7 = false;
                                    passing2 = [passing2, 1];
                                }
                                else {
                                    if (_valid2) {
                                        valid7 = true;
                                        passing2 = 1;
                                    }
                                }
                                if (!valid7) {
                                    const err14 = {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing2 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                    validate281.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs20;
                                    if (vErrors !== null) {
                                        if (_errs20) {
                                            vErrors.length = _errs20;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid0 = _errs19 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate281.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate281.errors = vErrors;
    return errors === 0;
}
export const reusableLogicAIEventSchemaValidation = validate282;
const schema387 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicAIEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        reusableLogicID: { type: 'string', uid: 9 },
        eventType: { type: 'string', enum: ['publish'] }
    },
    required: ['orgID', 'reusableLogicID', 'eventType']
};
const func512 = ucs2length;
const func513 = base64urlToBuffer;
const func514 = base64urlEncode;
const func515 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate282(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicAIEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.reusableLogicID === undefined && (missing0 = 'reusableLogicID')) ||
                (data.eventType === undefined && (missing0 = 'eventType'))) {
                validate282.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate282.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate282.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.reusableLogicID !== undefined) {
                        let data1 = data.reusableLogicID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func512(data1) < b64min0 || func512(data1) > b64max0) {
                                    validate282.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func512(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func512(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func513(data1);
                                    if (decoded0.length !== 9) {
                                        validate282.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func514(decoded0);
                                        if (func515(encoded0) !== func515(data1)) {
                                            validate282.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicID',
                                                    schemaPath: '#/properties/reusableLogicID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate282.errors = [
                                    {
                                        instancePath: instancePath + '/reusableLogicID',
                                        schemaPath: '#/properties/reusableLogicID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.eventType !== undefined) {
                            let data2 = data.eventType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate282.errors = [
                                    {
                                        instancePath: instancePath + '/eventType',
                                        schemaPath: '#/properties/eventType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'publish')) {
                                validate282.errors = [
                                    {
                                        instancePath: instancePath + '/eventType',
                                        schemaPath: '#/properties/eventType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema387.properties.eventType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate282.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate282.errors = vErrors;
    return errors === 0;
}
export const reusableLogicClearAIDescriptionRequestSchemaValidation = validate283;
const schema388 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicClearAIDescriptionRequest',
    type: 'object',
    properties: {
        recreateAll: { type: 'boolean' },
        orgID: { type: 'string', format: 'uuid' },
        reusableLogicID: { type: 'string', uid: 9 }
    },
    required: ['recreateAll']
};
const func516 = ucs2length;
const func517 = base64urlToBuffer;
const func518 = base64urlEncode;
const func519 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate283(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicClearAIDescriptionRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.recreateAll === undefined && (missing0 = 'recreateAll')) {
                validate283.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.recreateAll !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.recreateAll !== 'boolean') {
                        validate283.errors = [
                            {
                                instancePath: instancePath + '/recreateAll',
                                schemaPath: '#/properties/recreateAll/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgID !== undefined) {
                        let data1 = data.orgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate283.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate283.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.reusableLogicID !== undefined) {
                            let data2 = data.reusableLogicID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func516(data2) < b64min0 || func516(data2) > b64max0) {
                                        validate283.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func516(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func516(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func517(data2);
                                        if (decoded0.length !== 9) {
                                            validate283.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicID',
                                                    schemaPath: '#/properties/reusableLogicID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func518(decoded0);
                                            if (func519(encoded0) !== func519(data2)) {
                                                validate283.errors = [
                                                    {
                                                        instancePath: instancePath + '/reusableLogicID',
                                                        schemaPath: '#/properties/reusableLogicID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate283.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate283.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate283.errors = vErrors;
    return errors === 0;
}
export const reusableLogicConfigSchemaValidation = validate284;
const schema389 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicConfig',
    type: 'object',
    properties: {
        reusableLogicID: { type: 'string', uid: 9 },
        inputMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-pipe:ReusableLogicInputMapping' } },
        outputMap: { type: 'object', additionalProperties: { type: 'string' } },
        parameterValues: {
            type: 'object',
            additionalProperties: {
                anyOf: [{ $ref: 'urn:wisepipe-base-pipe:SimpleToolVariable' }, { $ref: 'urn:wisepipe-base-pipe:ToolParameter' }]
            }
        }
    },
    required: ['reusableLogicID', 'inputMap', 'outputMap']
};
const schema392 = {
    $id: 'urn:wisepipe-base-pipe:SimpleToolVariable',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        expectedValueType: { type: 'string', enum: ['string', 'number', 'boolean', 'date', 'enum', 'column', 'calendar'] },
        parameterType: { type: 'string', enum: ['global', 'pipe', 'calc', 'reusable', 'tool'] }
    },
    required: ['name', 'parameterType']
};
const schema393 = {
    $id: 'urn:wisepipe-base-pipe:ToolParameter',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', enum: ['global', 'pipe', 'calc', 'reusable', 'tool'] },
        pipeID: { type: 'string', uid: 10 },
        description: { type: 'string', maxLength: 1000 },
        valueType: { type: 'string', enum: ['string', 'number', 'boolean', 'date', 'enum', 'column', 'calendar'] },
        createdAt: { type: 'string', format: 'date-time' },
        updatedAt: { type: 'string', format: 'date-time' }
    },
    required: ['name', 'type', 'pipeID', 'valueType'],
    if: { properties: { type: { const: 'global' } } },
    then: { properties: { pipeID: { type: 'string', const: 'AAAAAAAAAAAAAA' } } },
    else: {
        if: { properties: { type: { const: 'reusable' } } },
        then: { properties: { pipeID: { type: 'string', const: 'BBBBBBBBBBBBBA' } } },
        else: {
            if: { properties: { type: { const: 'tool' } } },
            then: { properties: { pipeID: { type: 'string', const: 'BBBBBBBBBBBBBA' } } }
        }
    }
};
const func520 = ucs2length;
const func521 = base64urlToBuffer;
const func522 = base64urlEncode;
const func523 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func529 = ucs2length;
const func530 = base64urlToBuffer;
const func531 = base64urlEncode;
const func532 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const schema390 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicInputMapping',
    type: 'object',
    properties: {
        columnMappings: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn' } },
        port: { type: 'string', minLength: 1 },
        previousToolOutputPort: { type: 'string', minLength: 1 }
    },
    required: ['columnMappings', 'port']
};
const schema391 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn',
    type: 'object',
    properties: { dependantColumnName: { type: 'string' }, dependeeColumnName: { type: 'string' } },
    required: ['dependeeColumnName']
};
function validate285(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicInputMapping" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnMappings === undefined && (missing0 = 'columnMappings')) ||
                (data.port === undefined && (missing0 = 'port'))) {
                validate285.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnMappings !== undefined) {
                    let data0 = data.columnMappings;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if (data1.dependeeColumnName === undefined && (missing1 = 'dependeeColumnName')) {
                                            validate285.errors = [
                                                {
                                                    instancePath: instancePath + '/columnMappings/' + i0,
                                                    schemaPath: 'urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.dependantColumnName !== undefined) {
                                                const _errs6 = errors;
                                                if (typeof data1.dependantColumnName !== 'string') {
                                                    validate285.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnMappings/' + i0 + '/dependantColumnName',
                                                            schemaPath: 'urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn/properties/dependantColumnName/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid3 = _errs6 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data1.dependeeColumnName !== undefined) {
                                                    const _errs8 = errors;
                                                    if (typeof data1.dependeeColumnName !== 'string') {
                                                        validate285.errors = [
                                                            {
                                                                instancePath: instancePath + '/columnMappings/' + i0 + '/dependeeColumnName',
                                                                schemaPath: 'urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn/properties/dependeeColumnName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs8 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate285.errors = [
                                            {
                                                instancePath: instancePath + '/columnMappings/' + i0,
                                                schemaPath: 'urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate285.errors = [
                                {
                                    instancePath: instancePath + '/columnMappings',
                                    schemaPath: '#/properties/columnMappings/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data4 = data.port;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                            if (typeof data4 === 'string') {
                                if (func2(data4) < 1) {
                                    validate285.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate285.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.previousToolOutputPort !== undefined) {
                            let data5 = data.previousToolOutputPort;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (typeof data5 === 'string') {
                                    if (func2(data5) < 1) {
                                        validate285.errors = [
                                            {
                                                instancePath: instancePath + '/previousToolOutputPort',
                                                schemaPath: '#/properties/previousToolOutputPort/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate285.errors = [
                                        {
                                            instancePath: instancePath + '/previousToolOutputPort',
                                            schemaPath: '#/properties/previousToolOutputPort/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate285.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate285.errors = vErrors;
    return errors === 0;
}
function validate284(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.reusableLogicID === undefined && (missing0 = 'reusableLogicID')) ||
                (data.inputMap === undefined && (missing0 = 'inputMap')) ||
                (data.outputMap === undefined && (missing0 = 'outputMap'))) {
                validate284.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.reusableLogicID !== undefined) {
                    let data0 = data.reusableLogicID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func520(data0) < b64min0 || func520(data0) > b64max0) {
                                validate284.errors = [
                                    {
                                        instancePath: instancePath + '/reusableLogicID',
                                        schemaPath: '#/properties/reusableLogicID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func520(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func520(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func521(data0);
                                if (decoded0.length !== 9) {
                                    validate284.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func522(decoded0);
                                    if (func523(encoded0) !== func523(data0)) {
                                        validate284.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate284.errors = [
                                {
                                    instancePath: instancePath + '/reusableLogicID',
                                    schemaPath: '#/properties/reusableLogicID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.inputMap !== undefined) {
                        let data1 = data.inputMap;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                for (const key0 in data1) {
                                    const _errs6 = errors;
                                    if (!validate285(data1[key0], {
                                        instancePath: instancePath + '/inputMap/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                        parentData: data1,
                                        parentDataProperty: key0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate285.errors : vErrors.concat(validate285.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid2 = _errs6 === errors;
                                    if (!valid2) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate284.errors = [
                                    {
                                        instancePath: instancePath + '/inputMap',
                                        schemaPath: '#/properties/inputMap/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.outputMap !== undefined) {
                            let data3 = data.outputMap;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                    for (const key1 in data3) {
                                        const _errs10 = errors;
                                        if (typeof data3[key1] !== 'string') {
                                            validate284.errors = [
                                                {
                                                    instancePath: instancePath + '/outputMap/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/outputMap/additionalProperties/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs10 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate284.errors = [
                                        {
                                            instancePath: instancePath + '/outputMap',
                                            schemaPath: '#/properties/outputMap/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.parameterValues !== undefined) {
                                let data5 = data.parameterValues;
                                const _errs12 = errors;
                                if (errors === _errs12) {
                                    if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                        for (const key2 in data5) {
                                            let data6 = data5[key2];
                                            const _errs15 = errors;
                                            const _errs16 = errors;
                                            let valid5 = false;
                                            const _errs17 = errors;
                                            const _errs18 = errors;
                                            if (errors === _errs18) {
                                                if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                    let missing1;
                                                    if ((data6.name === undefined && (missing1 = 'name')) ||
                                                        (data6.parameterType === undefined && (missing1 = 'parameterType'))) {
                                                        const err0 = {
                                                            instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err0];
                                                        }
                                                        else {
                                                            vErrors.push(err0);
                                                        }
                                                        errors++;
                                                    }
                                                    else {
                                                        if (data6.name !== undefined) {
                                                            let data7 = data6.name;
                                                            const _errs20 = errors;
                                                            if (errors === _errs20) {
                                                                if (typeof data7 === 'string') {
                                                                    if (func2(data7) < 1) {
                                                                        const err1 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/name',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/properties/name/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err1];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err1);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err2 = {
                                                                        instancePath: instancePath +
                                                                            '/parameterValues/' +
                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/name',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/properties/name/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err2];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err2);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            var valid7 = _errs20 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data6.expectedValueType !== undefined) {
                                                                let data8 = data6.expectedValueType;
                                                                const _errs22 = errors;
                                                                if (typeof data8 !== 'string') {
                                                                    const err3 = {
                                                                        instancePath: instancePath +
                                                                            '/parameterValues/' +
                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/expectedValueType',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/properties/expectedValueType/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err3];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err3);
                                                                    }
                                                                    errors++;
                                                                }
                                                                if (!(data8 === 'string' ||
                                                                    data8 === 'number' ||
                                                                    data8 === 'boolean' ||
                                                                    data8 === 'date' ||
                                                                    data8 === 'enum' ||
                                                                    data8 === 'column' ||
                                                                    data8 === 'calendar')) {
                                                                    const err4 = {
                                                                        instancePath: instancePath +
                                                                            '/parameterValues/' +
                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/expectedValueType',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/properties/expectedValueType/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema392.properties.expectedValueType.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err4];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err4);
                                                                    }
                                                                    errors++;
                                                                }
                                                                var valid7 = _errs22 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                                if (data6.parameterType !== undefined) {
                                                                    let data9 = data6.parameterType;
                                                                    const _errs24 = errors;
                                                                    if (typeof data9 !== 'string') {
                                                                        const err5 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/parameterType',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/properties/parameterType/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err5];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err5);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    if (!(data9 === 'global' ||
                                                                        data9 === 'pipe' ||
                                                                        data9 === 'calc' ||
                                                                        data9 === 'reusable' ||
                                                                        data9 === 'tool')) {
                                                                        const err6 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/parameterType',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/properties/parameterType/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema392.properties.parameterType.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err6];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err6);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    var valid7 = _errs24 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    const err7 = {
                                                        instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: 'urn:wisepipe-base-pipe:SimpleToolVariable/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err7];
                                                    }
                                                    else {
                                                        vErrors.push(err7);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            var _valid0 = _errs17 === errors;
                                            valid5 = valid5 || _valid0;
                                            if (!valid5) {
                                                const _errs26 = errors;
                                                const _errs27 = errors;
                                                const _errs29 = errors;
                                                let valid9 = true;
                                                const _errs30 = errors;
                                                if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                    if (data6.type !== undefined) {
                                                        if ('global' !== data6.type) {
                                                            const err8 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err8];
                                                            }
                                                            else {
                                                                vErrors.push(err8);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                }
                                                var _valid1 = _errs30 === errors;
                                                errors = _errs29;
                                                if (vErrors !== null) {
                                                    if (_errs29) {
                                                        vErrors.length = _errs29;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                                let ifClause0;
                                                if (_valid1) {
                                                    const _errs32 = errors;
                                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                        if (data6.pipeID !== undefined) {
                                                            let data11 = data6.pipeID;
                                                            if (typeof data11 !== 'string') {
                                                                const err9 = {
                                                                    instancePath: instancePath +
                                                                        '/parameterValues/' +
                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/pipeID',
                                                                    schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/then/properties/pipeID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err9];
                                                                }
                                                                else {
                                                                    vErrors.push(err9);
                                                                }
                                                                errors++;
                                                            }
                                                            if ('AAAAAAAAAAAAAA' !== data11) {
                                                                const err10 = {
                                                                    instancePath: instancePath +
                                                                        '/parameterValues/' +
                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/pipeID',
                                                                    schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/then/properties/pipeID/const',
                                                                    keyword: 'const',
                                                                    params: { allowedValue: 'AAAAAAAAAAAAAA' },
                                                                    message: 'must be equal to constant'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err10];
                                                                }
                                                                else {
                                                                    vErrors.push(err10);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                    }
                                                    var _valid1 = _errs32 === errors;
                                                    valid9 = _valid1;
                                                    ifClause0 = 'then';
                                                }
                                                else {
                                                    const _errs35 = errors;
                                                    const _errs36 = errors;
                                                    let valid12 = true;
                                                    const _errs37 = errors;
                                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                        if (data6.type !== undefined) {
                                                            if ('reusable' !== data6.type) {
                                                                const err11 = {};
                                                                if (vErrors === null) {
                                                                    vErrors = [err11];
                                                                }
                                                                else {
                                                                    vErrors.push(err11);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                    }
                                                    var _valid2 = _errs37 === errors;
                                                    errors = _errs36;
                                                    if (vErrors !== null) {
                                                        if (_errs36) {
                                                            vErrors.length = _errs36;
                                                        }
                                                        else {
                                                            vErrors = null;
                                                        }
                                                    }
                                                    let ifClause1;
                                                    if (_valid2) {
                                                        const _errs39 = errors;
                                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                            if (data6.pipeID !== undefined) {
                                                                let data13 = data6.pipeID;
                                                                if (typeof data13 !== 'string') {
                                                                    const err12 = {
                                                                        instancePath: instancePath +
                                                                            '/parameterValues/' +
                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/pipeID',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/else/then/properties/pipeID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err12];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err12);
                                                                    }
                                                                    errors++;
                                                                }
                                                                if ('BBBBBBBBBBBBBA' !== data13) {
                                                                    const err13 = {
                                                                        instancePath: instancePath +
                                                                            '/parameterValues/' +
                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/pipeID',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/else/then/properties/pipeID/const',
                                                                        keyword: 'const',
                                                                        params: { allowedValue: 'BBBBBBBBBBBBBA' },
                                                                        message: 'must be equal to constant'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err13];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err13);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                        }
                                                        var _valid2 = _errs39 === errors;
                                                        valid12 = _valid2;
                                                        ifClause1 = 'then';
                                                    }
                                                    else {
                                                        const _errs42 = errors;
                                                        const _errs43 = errors;
                                                        let valid15 = true;
                                                        const _errs44 = errors;
                                                        if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                            if (data6.type !== undefined) {
                                                                if ('tool' !== data6.type) {
                                                                    const err14 = {};
                                                                    if (vErrors === null) {
                                                                        vErrors = [err14];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err14);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                        }
                                                        var _valid3 = _errs44 === errors;
                                                        errors = _errs43;
                                                        if (vErrors !== null) {
                                                            if (_errs43) {
                                                                vErrors.length = _errs43;
                                                            }
                                                            else {
                                                                vErrors = null;
                                                            }
                                                        }
                                                        if (_valid3) {
                                                            const _errs46 = errors;
                                                            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                                if (data6.pipeID !== undefined) {
                                                                    let data15 = data6.pipeID;
                                                                    if (typeof data15 !== 'string') {
                                                                        const err15 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/pipeID',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/else/else/then/properties/pipeID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err15];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err15);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    if ('BBBBBBBBBBBBBA' !== data15) {
                                                                        const err16 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/pipeID',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/else/else/then/properties/pipeID/const',
                                                                            keyword: 'const',
                                                                            params: { allowedValue: 'BBBBBBBBBBBBBA' },
                                                                            message: 'must be equal to constant'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err16];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err16);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                            }
                                                            var _valid3 = _errs46 === errors;
                                                            valid15 = _valid3;
                                                        }
                                                        if (!valid15) {
                                                            const err17 = {
                                                                instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/else/else/if',
                                                                keyword: 'if',
                                                                params: { failingKeyword: 'then' },
                                                                message: 'must match "then" schema'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err17];
                                                            }
                                                            else {
                                                                vErrors.push(err17);
                                                            }
                                                            errors++;
                                                        }
                                                        var _valid2 = _errs42 === errors;
                                                        valid12 = _valid2;
                                                        ifClause1 = 'else';
                                                    }
                                                    if (!valid12) {
                                                        const err18 = {
                                                            instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/else/if',
                                                            keyword: 'if',
                                                            params: { failingKeyword: ifClause1 },
                                                            message: 'must match "' + ifClause1 + '" schema'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err18];
                                                        }
                                                        else {
                                                            vErrors.push(err18);
                                                        }
                                                        errors++;
                                                    }
                                                    var _valid1 = _errs35 === errors;
                                                    valid9 = _valid1;
                                                    ifClause0 = 'else';
                                                }
                                                if (!valid9) {
                                                    const err19 = {
                                                        instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/if',
                                                        keyword: 'if',
                                                        params: { failingKeyword: ifClause0 },
                                                        message: 'must match "' + ifClause0 + '" schema'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err19];
                                                    }
                                                    else {
                                                        vErrors.push(err19);
                                                    }
                                                    errors++;
                                                }
                                                if (errors === _errs27) {
                                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                                        let missing2;
                                                        if ((data6.name === undefined && (missing2 = 'name')) ||
                                                            (data6.type === undefined && (missing2 = 'type')) ||
                                                            (data6.pipeID === undefined && (missing2 = 'pipeID')) ||
                                                            (data6.valueType === undefined && (missing2 = 'valueType'))) {
                                                            const err20 = {
                                                                instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing2 },
                                                                message: "must have required property '" + missing2 + "'"
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err20];
                                                            }
                                                            else {
                                                                vErrors.push(err20);
                                                            }
                                                            errors++;
                                                        }
                                                        else {
                                                            if (data6.name !== undefined) {
                                                                let data16 = data6.name;
                                                                const _errs49 = errors;
                                                                if (errors === _errs49) {
                                                                    if (typeof data16 === 'string') {
                                                                        if (func2(data16) > 150) {
                                                                            const err21 = {
                                                                                instancePath: instancePath +
                                                                                    '/parameterValues/' +
                                                                                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/name',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/name/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 150 },
                                                                                message: 'must NOT have more than 150 characters'
                                                                            };
                                                                            if (vErrors === null) {
                                                                                vErrors = [err21];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err21);
                                                                            }
                                                                            errors++;
                                                                        }
                                                                        else {
                                                                            if (func2(data16) < 1) {
                                                                                const err22 = {
                                                                                    instancePath: instancePath +
                                                                                        '/parameterValues/' +
                                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/name',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/name/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                };
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err22];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err22);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        const err23 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/name',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/name/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err23];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err23);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                var valid18 = _errs49 === errors;
                                                            }
                                                            else {
                                                                var valid18 = true;
                                                            }
                                                            if (valid18) {
                                                                if (data6.type !== undefined) {
                                                                    let data17 = data6.type;
                                                                    const _errs51 = errors;
                                                                    if (typeof data17 !== 'string') {
                                                                        const err24 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/type',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/type/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err24];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err24);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    if (!(data17 === 'global' ||
                                                                        data17 === 'pipe' ||
                                                                        data17 === 'calc' ||
                                                                        data17 === 'reusable' ||
                                                                        data17 === 'tool')) {
                                                                        const err25 = {
                                                                            instancePath: instancePath +
                                                                                '/parameterValues/' +
                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/type',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/type/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema393.properties.type.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err25];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err25);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                    var valid18 = _errs51 === errors;
                                                                }
                                                                else {
                                                                    var valid18 = true;
                                                                }
                                                                if (valid18) {
                                                                    if (data6.pipeID !== undefined) {
                                                                        let data18 = data6.pipeID;
                                                                        const _errs53 = errors;
                                                                        if (errors === _errs53) {
                                                                            if (typeof data18 === 'string') {
                                                                                const b64min1 = Math.ceil((4 * 10) / 3);
                                                                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                                                                if (func529(data18) < b64min1 || func529(data18) > b64max1) {
                                                                                    const err26 = {
                                                                                        instancePath: instancePath +
                                                                                            '/parameterValues/' +
                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/pipeID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/pipeID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: {
                                                                                            error: 'encoded',
                                                                                            b64min: b64min1,
                                                                                            b64max: b64max1,
                                                                                            length: func529(data18)
                                                                                        },
                                                                                        message: 'length must be between ' +
                                                                                            b64min1 +
                                                                                            ' and ' +
                                                                                            b64max1 +
                                                                                            ', but is ' +
                                                                                            func529(data18)
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err26];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err26);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                                else {
                                                                                    const decoded1 = func530(data18);
                                                                                    if (decoded1.length !== 10) {
                                                                                        const err27 = {
                                                                                            instancePath: instancePath +
                                                                                                '/parameterValues/' +
                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/pipeID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/pipeID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'decoded' },
                                                                                            message: 'must decode to 10 bytes'
                                                                                        };
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err27];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err27);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                    else {
                                                                                        const encoded1 = func531(decoded1);
                                                                                        if (func532(encoded1) !== func532(data18)) {
                                                                                            const err28 = {
                                                                                                instancePath: instancePath +
                                                                                                    '/parameterValues/' +
                                                                                                    key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                    '/pipeID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/pipeID/uid',
                                                                                                keyword: 'uid',
                                                                                                params: { error: 'ambiguous' },
                                                                                                message: 'encoding is ambiguous'
                                                                                            };
                                                                                            if (vErrors === null) {
                                                                                                vErrors = [err28];
                                                                                            }
                                                                                            else {
                                                                                                vErrors.push(err28);
                                                                                            }
                                                                                            errors++;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                const err29 = {
                                                                                    instancePath: instancePath +
                                                                                        '/parameterValues/' +
                                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/pipeID',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/pipeID/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                };
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err29];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err29);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                        }
                                                                        var valid18 = _errs53 === errors;
                                                                    }
                                                                    else {
                                                                        var valid18 = true;
                                                                    }
                                                                    if (valid18) {
                                                                        if (data6.description !== undefined) {
                                                                            let data19 = data6.description;
                                                                            const _errs55 = errors;
                                                                            if (errors === _errs55) {
                                                                                if (typeof data19 === 'string') {
                                                                                    if (func2(data19) > 1000) {
                                                                                        const err30 = {
                                                                                            instancePath: instancePath +
                                                                                                '/parameterValues/' +
                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                '/description',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/description/maxLength',
                                                                                            keyword: 'maxLength',
                                                                                            params: { limit: 1000 },
                                                                                            message: 'must NOT have more than 1000 characters'
                                                                                        };
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err30];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err30);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    const err31 = {
                                                                                        instancePath: instancePath +
                                                                                            '/parameterValues/' +
                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/description',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/description/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err31];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err31);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                            }
                                                                            var valid18 = _errs55 === errors;
                                                                        }
                                                                        else {
                                                                            var valid18 = true;
                                                                        }
                                                                        if (valid18) {
                                                                            if (data6.valueType !== undefined) {
                                                                                let data20 = data6.valueType;
                                                                                const _errs57 = errors;
                                                                                if (typeof data20 !== 'string') {
                                                                                    const err32 = {
                                                                                        instancePath: instancePath +
                                                                                            '/parameterValues/' +
                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/valueType',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/valueType/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err32];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err32);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                                if (!(data20 === 'string' ||
                                                                                    data20 === 'number' ||
                                                                                    data20 === 'boolean' ||
                                                                                    data20 === 'date' ||
                                                                                    data20 === 'enum' ||
                                                                                    data20 === 'column' ||
                                                                                    data20 === 'calendar')) {
                                                                                    const err33 = {
                                                                                        instancePath: instancePath +
                                                                                            '/parameterValues/' +
                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/valueType',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/valueType/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema393.properties.valueType.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    };
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err33];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err33);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                                var valid18 = _errs57 === errors;
                                                                            }
                                                                            else {
                                                                                var valid18 = true;
                                                                            }
                                                                            if (valid18) {
                                                                                if (data6.createdAt !== undefined) {
                                                                                    let data21 = data6.createdAt;
                                                                                    const _errs59 = errors;
                                                                                    if (errors === _errs59) {
                                                                                        if (errors === _errs59) {
                                                                                            if (typeof data21 === 'string') {
                                                                                                if (!formats0.validate(data21)) {
                                                                                                    const err34 = {
                                                                                                        instancePath: instancePath +
                                                                                                            '/parameterValues/' +
                                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                            '/createdAt',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/createdAt/format',
                                                                                                        keyword: 'format',
                                                                                                        params: { format: 'date-time' },
                                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                                    };
                                                                                                    if (vErrors === null) {
                                                                                                        vErrors = [err34];
                                                                                                    }
                                                                                                    else {
                                                                                                        vErrors.push(err34);
                                                                                                    }
                                                                                                    errors++;
                                                                                                }
                                                                                            }
                                                                                            else {
                                                                                                const err35 = {
                                                                                                    instancePath: instancePath +
                                                                                                        '/parameterValues/' +
                                                                                                        key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                        '/createdAt',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/createdAt/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                };
                                                                                                if (vErrors === null) {
                                                                                                    vErrors = [err35];
                                                                                                }
                                                                                                else {
                                                                                                    vErrors.push(err35);
                                                                                                }
                                                                                                errors++;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    var valid18 = _errs59 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid18 = true;
                                                                                }
                                                                                if (valid18) {
                                                                                    if (data6.updatedAt !== undefined) {
                                                                                        let data22 = data6.updatedAt;
                                                                                        const _errs61 = errors;
                                                                                        if (errors === _errs61) {
                                                                                            if (errors === _errs61) {
                                                                                                if (typeof data22 === 'string') {
                                                                                                    if (!formats0.validate(data22)) {
                                                                                                        const err36 = {
                                                                                                            instancePath: instancePath +
                                                                                                                '/parameterValues/' +
                                                                                                                key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                '/updatedAt',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/updatedAt/format',
                                                                                                            keyword: 'format',
                                                                                                            params: { format: 'date-time' },
                                                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                                                        };
                                                                                                        if (vErrors === null) {
                                                                                                            vErrors = [err36];
                                                                                                        }
                                                                                                        else {
                                                                                                            vErrors.push(err36);
                                                                                                        }
                                                                                                        errors++;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    const err37 = {
                                                                                                        instancePath: instancePath +
                                                                                                            '/parameterValues/' +
                                                                                                            key2.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                            '/updatedAt',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/properties/updatedAt/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    };
                                                                                                    if (vErrors === null) {
                                                                                                        vErrors = [err37];
                                                                                                    }
                                                                                                    else {
                                                                                                        vErrors.push(err37);
                                                                                                    }
                                                                                                    errors++;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        var valid18 = _errs61 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid18 = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        const err38 = {
                                                            instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: 'urn:wisepipe-base-pipe:ToolParameter/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err38];
                                                        }
                                                        else {
                                                            vErrors.push(err38);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var _valid0 = _errs26 === errors;
                                                valid5 = valid5 || _valid0;
                                            }
                                            if (!valid5) {
                                                const err39 = {
                                                    instancePath: instancePath + '/parameterValues/' + key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                    schemaPath: '#/properties/parameterValues/additionalProperties/anyOf',
                                                    keyword: 'anyOf',
                                                    params: {},
                                                    message: 'must match a schema in anyOf'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err39];
                                                }
                                                else {
                                                    vErrors.push(err39);
                                                }
                                                errors++;
                                                validate284.errors = vErrors;
                                                return false;
                                            }
                                            else {
                                                errors = _errs16;
                                                if (vErrors !== null) {
                                                    if (_errs16) {
                                                        vErrors.length = _errs16;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                            }
                                            var valid4 = _errs15 === errors;
                                            if (!valid4) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate284.errors = [
                                            {
                                                instancePath: instancePath + '/parameterValues',
                                                schemaPath: '#/properties/parameterValues/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs12 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate284.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate284.errors = vErrors;
    return errors === 0;
}
export const reusableLogicEventSchemaValidation = validate287;
const schema394 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        reusableLogicID: { type: 'string', uid: 9 },
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        eventType: { type: 'string', enum: ['remove'] }
    },
    required: ['orgID', 'reusableLogicID', 'userID', 'eventType']
};
const func534 = ucs2length;
const func535 = base64urlToBuffer;
const func536 = base64urlEncode;
const func537 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate287(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.reusableLogicID === undefined && (missing0 = 'reusableLogicID')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.eventType === undefined && (missing0 = 'eventType'))) {
                validate287.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate287.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate287.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.reusableLogicID !== undefined) {
                        let data1 = data.reusableLogicID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func534(data1) < b64min0 || func534(data1) > b64max0) {
                                    validate287.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func534(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func534(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func535(data1);
                                    if (decoded0.length !== 9) {
                                        validate287.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func536(decoded0);
                                        if (func537(encoded0) !== func537(data1)) {
                                            validate287.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicID',
                                                    schemaPath: '#/properties/reusableLogicID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate287.errors = [
                                    {
                                        instancePath: instancePath + '/reusableLogicID',
                                        schemaPath: '#/properties/reusableLogicID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.userID !== undefined) {
                            let data2 = data.userID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats4.test(data2)) {
                                            validate287.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate287.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.userName !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.userName !== 'string') {
                                    validate287.errors = [
                                        {
                                            instancePath: instancePath + '/userName',
                                            schemaPath: '#/properties/userName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.userEmail !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.userEmail !== 'string') {
                                        validate287.errors = [
                                            {
                                                instancePath: instancePath + '/userEmail',
                                                schemaPath: '#/properties/userEmail/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.eventType !== undefined) {
                                        let data5 = data.eventType;
                                        const _errs11 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate287.errors = [
                                                {
                                                    instancePath: instancePath + '/eventType',
                                                    schemaPath: '#/properties/eventType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'remove')) {
                                            validate287.errors = [
                                                {
                                                    instancePath: instancePath + '/eventType',
                                                    schemaPath: '#/properties/eventType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema394.properties.eventType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate287.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate287.errors = vErrors;
    return errors === 0;
}
export const reusableLogicIDOrgIDPairSchemaValidation = validate288;
const schema395 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicIDOrgIDPair',
    type: 'object',
    properties: { orgID: { type: 'string', format: 'uuid' }, reusableLogicID: { type: 'string', uid: 9 } },
    required: ['orgID', 'reusableLogicID']
};
const func538 = ucs2length;
const func539 = base64urlToBuffer;
const func540 = base64urlEncode;
const func541 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate288(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicIDOrgIDPair" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.reusableLogicID === undefined && (missing0 = 'reusableLogicID'))) {
                validate288.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate288.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate288.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.reusableLogicID !== undefined) {
                        let data1 = data.reusableLogicID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func538(data1) < b64min0 || func538(data1) > b64max0) {
                                    validate288.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func538(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func538(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func539(data1);
                                    if (decoded0.length !== 9) {
                                        validate288.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func540(decoded0);
                                        if (func541(encoded0) !== func541(data1)) {
                                            validate288.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicID',
                                                    schemaPath: '#/properties/reusableLogicID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate288.errors = [
                                    {
                                        instancePath: instancePath + '/reusableLogicID',
                                        schemaPath: '#/properties/reusableLogicID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate288.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate288.errors = vErrors;
    return errors === 0;
}
export const reusableLogicInputConfigSchemaValidation = validate289;
const schema396 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicInputConfig',
    type: 'object',
    properties: {
        inputColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:Column' },
            uniqueItemProperties: ['name'],
            minItems: 1
        }
    },
    required: ['inputColumns']
};
const func542 = ajvEqual;
function validate289(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicInputConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.inputColumns === undefined && (missing0 = 'inputColumns')) {
                validate289.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.inputColumns !== undefined) {
                    let data0 = data.inputColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate289.errors = [
                                    {
                                        instancePath: instancePath + '/inputColumns',
                                        schemaPath: '#/properties/inputColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs3 = errors;
                                    if (!validate39(data0[i0], {
                                        instancePath: instancePath + '/inputColumns/' + i0,
                                        parentData: data0,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate39.errors : vErrors.concat(validate39.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    const keys0 = schema396.properties.inputColumns.uniqueItemProperties;
                                    let k0;
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                            let key0 = keys0[k0];
                                            for (i1 = data0.length; i1--;) {
                                                let x0 = data0[i1];
                                                if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                    continue;
                                                }
                                                for (j0 = i1; j0--;) {
                                                    let y0 = data0[j0];
                                                    if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func542(x0[key0], y0[key0])) {
                                                        validate289.errors = [
                                                            {
                                                                instancePath: instancePath + '/inputColumns',
                                                                schemaPath: '#/properties/inputColumns/uniqueItemProperties',
                                                                keyword: 'uniqueItemProperties',
                                                                params: {},
                                                                message: 'must pass "uniqueItemProperties" keyword validation'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate289.errors = [
                                {
                                    instancePath: instancePath + '/inputColumns',
                                    schemaPath: '#/properties/inputColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate289.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate289.errors = vErrors;
    return errors === 0;
}
export const reusableLogicInputMappingColumnSchemaValidation = validate291;
function validate291(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicInputMappingColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.dependeeColumnName === undefined && (missing0 = 'dependeeColumnName')) {
                validate291.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dependantColumnName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.dependantColumnName !== 'string') {
                        validate291.errors = [
                            {
                                instancePath: instancePath + '/dependantColumnName',
                                schemaPath: '#/properties/dependantColumnName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.dependeeColumnName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.dependeeColumnName !== 'string') {
                            validate291.errors = [
                                {
                                    instancePath: instancePath + '/dependeeColumnName',
                                    schemaPath: '#/properties/dependeeColumnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate291.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate291.errors = vErrors;
    return errors === 0;
}
export const reusableLogicInputMappingSchemaValidation = validate285;
export const reusableLogicMigrationRequestSchemaValidation = validate292;
const schema398 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicMigrationRequest',
    type: 'object',
    properties: {
        migrateToOrgID: { type: 'string', format: 'uuid' },
        migrateFromOrgID: { type: 'string', format: 'uuid' },
        integrationUserID: { type: 'string' },
        reusableLogicVersionMap: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                properties: { sourceReusableLogicID: { type: 'string', uid: 9 }, sourceVersionID: { type: 'string', uid: 9 } }
            }
        }
    },
    required: ['migrateToOrgID', 'migrateFromOrgID', 'integrationUserID', 'reusableLogicVersionMap']
};
const func543 = ucs2length;
const func544 = base64urlToBuffer;
const func545 = base64urlEncode;
const func546 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func547 = ucs2length;
const func548 = base64urlToBuffer;
const func549 = base64urlEncode;
const func550 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate292(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicMigrationRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.migrateToOrgID === undefined && (missing0 = 'migrateToOrgID')) ||
                (data.migrateFromOrgID === undefined && (missing0 = 'migrateFromOrgID')) ||
                (data.integrationUserID === undefined && (missing0 = 'integrationUserID')) ||
                (data.reusableLogicVersionMap === undefined && (missing0 = 'reusableLogicVersionMap'))) {
                validate292.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.migrateToOrgID !== undefined) {
                    let data0 = data.migrateToOrgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats4.test(data0)) {
                                    validate292.errors = [
                                        {
                                            instancePath: instancePath + '/migrateToOrgID',
                                            schemaPath: '#/properties/migrateToOrgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate292.errors = [
                                    {
                                        instancePath: instancePath + '/migrateToOrgID',
                                        schemaPath: '#/properties/migrateToOrgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.migrateFromOrgID !== undefined) {
                        let data1 = data.migrateFromOrgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats4.test(data1)) {
                                        validate292.errors = [
                                            {
                                                instancePath: instancePath + '/migrateFromOrgID',
                                                schemaPath: '#/properties/migrateFromOrgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate292.errors = [
                                        {
                                            instancePath: instancePath + '/migrateFromOrgID',
                                            schemaPath: '#/properties/migrateFromOrgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.integrationUserID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.integrationUserID !== 'string') {
                                validate292.errors = [
                                    {
                                        instancePath: instancePath + '/integrationUserID',
                                        schemaPath: '#/properties/integrationUserID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.reusableLogicVersionMap !== undefined) {
                                let data3 = data.reusableLogicVersionMap;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        for (const key0 in data3) {
                                            let data4 = data3[key0];
                                            const _errs10 = errors;
                                            if (errors === _errs10) {
                                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                    if (data4.sourceReusableLogicID !== undefined) {
                                                        let data5 = data4.sourceReusableLogicID;
                                                        const _errs12 = errors;
                                                        if (errors === _errs12) {
                                                            if (typeof data5 === 'string') {
                                                                const b64min0 = Math.ceil((4 * 9) / 3);
                                                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                                                if (func543(data5) < b64min0 || func543(data5) > b64max0) {
                                                                    validate292.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/reusableLogicVersionMap/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/sourceReusableLogicID',
                                                                            schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/uid',
                                                                            keyword: 'uid',
                                                                            params: {
                                                                                error: 'encoded',
                                                                                b64min: b64min0,
                                                                                b64max: b64max0,
                                                                                length: func543(data5)
                                                                            },
                                                                            message: 'length must be between ' +
                                                                                b64min0 +
                                                                                ' and ' +
                                                                                b64max0 +
                                                                                ', but is ' +
                                                                                func543(data5)
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const decoded0 = func544(data5);
                                                                    if (decoded0.length !== 9) {
                                                                        validate292.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/reusableLogicVersionMap/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/sourceReusableLogicID',
                                                                                schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'decoded' },
                                                                                message: 'must decode to 9 bytes'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const encoded0 = func545(decoded0);
                                                                        if (func546(encoded0) !== func546(data5)) {
                                                                            validate292.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/reusableLogicVersionMap/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/sourceReusableLogicID',
                                                                                    schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'ambiguous' },
                                                                                    message: 'encoding is ambiguous'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate292.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/reusableLogicVersionMap/' +
                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/sourceReusableLogicID',
                                                                        schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceReusableLogicID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs12 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data4.sourceVersionID !== undefined) {
                                                            let data6 = data4.sourceVersionID;
                                                            const _errs14 = errors;
                                                            if (errors === _errs14) {
                                                                if (typeof data6 === 'string') {
                                                                    const b64min1 = Math.ceil((4 * 9) / 3);
                                                                    const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                    if (func547(data6) < b64min1 || func547(data6) > b64max1) {
                                                                        validate292.errors = [
                                                                            {
                                                                                instancePath: instancePath +
                                                                                    '/reusableLogicVersionMap/' +
                                                                                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                    '/sourceVersionID',
                                                                                schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min1,
                                                                                    b64max: b64max1,
                                                                                    length: func547(data6)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min1 +
                                                                                    ' and ' +
                                                                                    b64max1 +
                                                                                    ', but is ' +
                                                                                    func547(data6)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded1 = func548(data6);
                                                                        if (decoded1.length !== 9) {
                                                                            validate292.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/reusableLogicVersionMap/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                        '/sourceVersionID',
                                                                                    schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 9 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded1 = func549(decoded1);
                                                                            if (func550(encoded1) !== func550(data6)) {
                                                                                validate292.errors = [
                                                                                    {
                                                                                        instancePath: instancePath +
                                                                                            '/reusableLogicVersionMap/' +
                                                                                            key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                            '/sourceVersionID',
                                                                                        schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate292.errors = [
                                                                        {
                                                                            instancePath: instancePath +
                                                                                '/reusableLogicVersionMap/' +
                                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                '/sourceVersionID',
                                                                            schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/properties/sourceVersionID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs14 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate292.errors = [
                                                        {
                                                            instancePath: instancePath +
                                                                '/reusableLogicVersionMap/' +
                                                                key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/reusableLogicVersionMap/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs10 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate292.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicVersionMap',
                                                schemaPath: '#/properties/reusableLogicVersionMap/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate292.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate292.errors = vErrors;
    return errors === 0;
}
export const reusableLogicNodeEventSchemaValidation = validate293;
const schema399 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicNodeEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        parentID: { type: 'string' },
        elementID: { type: 'string', uid: 10 },
        reusableLogicID: { type: 'string', uid: 9 },
        eventType: { type: 'string', enum: ['insert', 'modify', 'remove'] },
        parentType: { type: 'string', enum: ['ReusableLogic', 'Pipe'] }
    },
    if: { properties: { parentType: { const: 'Pipe' } } },
    then: { properties: { parentID: { type: 'string', uid: 10 } } },
    else: { properties: { parentID: { type: 'string', uid: 9 } } },
    required: ['orgID', 'parentID', 'elementID', 'reusableLogicID', 'eventType', 'parentType']
};
const func551 = ucs2length;
const func552 = base64urlToBuffer;
const func553 = base64urlEncode;
const func554 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func555 = ucs2length;
const func556 = base64urlToBuffer;
const func557 = base64urlEncode;
const func558 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func559 = ucs2length;
const func560 = base64urlToBuffer;
const func561 = base64urlEncode;
const func562 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func563 = ucs2length;
const func564 = base64urlToBuffer;
const func565 = base64urlEncode;
const func566 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate293(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicNodeEvent" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.parentType !== undefined) {
            if ('Pipe' !== data.parentType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.parentID !== undefined) {
                let data1 = data.parentID;
                const _errs5 = errors;
                if (errors === _errs5) {
                    if (typeof data1 === 'string') {
                        const b64min0 = Math.ceil((4 * 10) / 3);
                        const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                        if (func551(data1) < b64min0 || func551(data1) > b64max0) {
                            validate293.errors = [
                                {
                                    instancePath: instancePath + '/parentID',
                                    schemaPath: '#/then/properties/parentID/uid',
                                    keyword: 'uid',
                                    params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func551(data1) },
                                    message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func551(data1)
                                }
                            ];
                            return false;
                        }
                        else {
                            const decoded0 = func552(data1);
                            if (decoded0.length !== 10) {
                                validate293.errors = [
                                    {
                                        instancePath: instancePath + '/parentID',
                                        schemaPath: '#/then/properties/parentID/uid',
                                        keyword: 'uid',
                                        params: { error: 'decoded' },
                                        message: 'must decode to 10 bytes'
                                    }
                                ];
                                return false;
                            }
                            else {
                                const encoded0 = func553(decoded0);
                                if (func554(encoded0) !== func554(data1)) {
                                    validate293.errors = [
                                        {
                                            instancePath: instancePath + '/parentID',
                                            schemaPath: '#/then/properties/parentID/uid',
                                            keyword: 'uid',
                                            params: { error: 'ambiguous' },
                                            message: 'encoding is ambiguous'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    else {
                        validate293.errors = [
                            {
                                instancePath: instancePath + '/parentID',
                                schemaPath: '#/then/properties/parentID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.parentID !== undefined) {
                let data2 = data.parentID;
                const _errs8 = errors;
                if (errors === _errs8) {
                    if (typeof data2 === 'string') {
                        const b64min1 = Math.ceil((4 * 9) / 3);
                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                        if (func555(data2) < b64min1 || func555(data2) > b64max1) {
                            validate293.errors = [
                                {
                                    instancePath: instancePath + '/parentID',
                                    schemaPath: '#/else/properties/parentID/uid',
                                    keyword: 'uid',
                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func555(data2) },
                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func555(data2)
                                }
                            ];
                            return false;
                        }
                        else {
                            const decoded1 = func556(data2);
                            if (decoded1.length !== 9) {
                                validate293.errors = [
                                    {
                                        instancePath: instancePath + '/parentID',
                                        schemaPath: '#/else/properties/parentID/uid',
                                        keyword: 'uid',
                                        params: { error: 'decoded' },
                                        message: 'must decode to 9 bytes'
                                    }
                                ];
                                return false;
                            }
                            else {
                                const encoded1 = func557(decoded1);
                                if (func558(encoded1) !== func558(data2)) {
                                    validate293.errors = [
                                        {
                                            instancePath: instancePath + '/parentID',
                                            schemaPath: '#/else/properties/parentID/uid',
                                            keyword: 'uid',
                                            params: { error: 'ambiguous' },
                                            message: 'encoding is ambiguous'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                    else {
                        validate293.errors = [
                            {
                                instancePath: instancePath + '/parentID',
                                schemaPath: '#/else/properties/parentID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate293.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.parentID === undefined && (missing0 = 'parentID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.reusableLogicID === undefined && (missing0 = 'reusableLogicID')) ||
                (data.eventType === undefined && (missing0 = 'eventType')) ||
                (data.parentType === undefined && (missing0 = 'parentType'))) {
                validate293.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data3 = data.orgID;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (errors === _errs10) {
                            if (typeof data3 === 'string') {
                                if (!formats4.test(data3)) {
                                    validate293.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate293.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid6 = _errs10 === errors;
                }
                else {
                    var valid6 = true;
                }
                if (valid6) {
                    if (data.parentID !== undefined) {
                        const _errs12 = errors;
                        if (typeof data.parentID !== 'string') {
                            validate293.errors = [
                                {
                                    instancePath: instancePath + '/parentID',
                                    schemaPath: '#/properties/parentID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid6 = _errs12 === errors;
                    }
                    else {
                        var valid6 = true;
                    }
                    if (valid6) {
                        if (data.elementID !== undefined) {
                            let data5 = data.elementID;
                            const _errs14 = errors;
                            if (errors === _errs14) {
                                if (typeof data5 === 'string') {
                                    const b64min2 = Math.ceil((4 * 10) / 3);
                                    const b64max2 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func559(data5) < b64min2 || func559(data5) > b64max2) {
                                        validate293.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min2, b64max: b64max2, length: func559(data5) },
                                                message: 'length must be between ' + b64min2 + ' and ' + b64max2 + ', but is ' + func559(data5)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded2 = func560(data5);
                                        if (decoded2.length !== 10) {
                                            validate293.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded2 = func561(decoded2);
                                            if (func562(encoded2) !== func562(data5)) {
                                                validate293.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate293.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid6 = _errs14 === errors;
                        }
                        else {
                            var valid6 = true;
                        }
                        if (valid6) {
                            if (data.reusableLogicID !== undefined) {
                                let data6 = data.reusableLogicID;
                                const _errs16 = errors;
                                if (errors === _errs16) {
                                    if (typeof data6 === 'string') {
                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func563(data6) < b64min3 || func563(data6) > b64max3) {
                                            validate293.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicID',
                                                    schemaPath: '#/properties/reusableLogicID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min3, b64max: b64max3, length: func563(data6) },
                                                    message: 'length must be between ' + b64min3 + ' and ' + b64max3 + ', but is ' + func563(data6)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded3 = func564(data6);
                                            if (decoded3.length !== 9) {
                                                validate293.errors = [
                                                    {
                                                        instancePath: instancePath + '/reusableLogicID',
                                                        schemaPath: '#/properties/reusableLogicID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded3 = func565(decoded3);
                                                if (func566(encoded3) !== func566(data6)) {
                                                    validate293.errors = [
                                                        {
                                                            instancePath: instancePath + '/reusableLogicID',
                                                            schemaPath: '#/properties/reusableLogicID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate293.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid6 = _errs16 === errors;
                            }
                            else {
                                var valid6 = true;
                            }
                            if (valid6) {
                                if (data.eventType !== undefined) {
                                    let data7 = data.eventType;
                                    const _errs18 = errors;
                                    if (typeof data7 !== 'string') {
                                        validate293.errors = [
                                            {
                                                instancePath: instancePath + '/eventType',
                                                schemaPath: '#/properties/eventType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data7 === 'insert' || data7 === 'modify' || data7 === 'remove')) {
                                        validate293.errors = [
                                            {
                                                instancePath: instancePath + '/eventType',
                                                schemaPath: '#/properties/eventType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema399.properties.eventType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid6 = _errs18 === errors;
                                }
                                else {
                                    var valid6 = true;
                                }
                                if (valid6) {
                                    if (data.parentType !== undefined) {
                                        let data8 = data.parentType;
                                        const _errs20 = errors;
                                        if (typeof data8 !== 'string') {
                                            validate293.errors = [
                                                {
                                                    instancePath: instancePath + '/parentType',
                                                    schemaPath: '#/properties/parentType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data8 === 'ReusableLogic' || data8 === 'Pipe')) {
                                            validate293.errors = [
                                                {
                                                    instancePath: instancePath + '/parentType',
                                                    schemaPath: '#/properties/parentType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema399.properties.parentType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid6 = _errs20 === errors;
                                    }
                                    else {
                                        var valid6 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate293.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate293.errors = vErrors;
    return errors === 0;
}
export const reusableLogicOutputConfigSchemaValidation = validate294;
const schema400 = { $id: 'urn:wisepipe-common-pipe:ReusableLogicOutputConfig', type: 'object' };
function validate294(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicOutputConfig" */ let vErrors = null;
    let errors = 0;
    if (!(data && typeof data == 'object' && !Array.isArray(data))) {
        validate294.errors = [
            { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
        ];
        return false;
    }
    validate294.errors = vErrors;
    return errors === 0;
}
export const reusableLogicParameterDefinitionSchemaValidation = validate295;
const schema401 = {
    $id: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        description: { type: 'string', maxLength: 1000 },
        valueType: { type: 'string', enum: ['string', 'number', 'boolean', 'date', 'enum', 'column', 'calendar'] }
    },
    required: ['name', 'valueType']
};
function validate295(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.valueType === undefined && (missing0 = 'valueType'))) {
                validate295.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate295.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate295.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate295.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.description !== undefined) {
                        let data1 = data.description;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 1000) {
                                    validate295.errors = [
                                        {
                                            instancePath: instancePath + '/description',
                                            schemaPath: '#/properties/description/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate295.errors = [
                                    {
                                        instancePath: instancePath + '/description',
                                        schemaPath: '#/properties/description/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.valueType !== undefined) {
                            let data2 = data.valueType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate295.errors = [
                                    {
                                        instancePath: instancePath + '/valueType',
                                        schemaPath: '#/properties/valueType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'string' ||
                                data2 === 'number' ||
                                data2 === 'boolean' ||
                                data2 === 'date' ||
                                data2 === 'enum' ||
                                data2 === 'column' ||
                                data2 === 'calendar')) {
                                validate295.errors = [
                                    {
                                        instancePath: instancePath + '/valueType',
                                        schemaPath: '#/properties/valueType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema401.properties.valueType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate295.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate295.errors = vErrors;
    return errors === 0;
}
export const reusableLogicSchemaValidation = validate296;
const schema402 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogic',
    type: 'object',
    properties: {
        reusableLogicID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        elements: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:GraphElement' } },
        directlyBigPipeCompatible: { type: 'boolean' },
        createdBy: { type: 'string' },
        createdAt: { type: 'string', format: 'date-time' },
        documentation: { $ref: 'urn:wisepipe-base-pipe:PipeDocumentation' },
        description: { type: 'string' },
        publishedVersionID: { type: 'string', uid: 9 },
        lastPublishedBy: { type: 'string' },
        lastPublishedTime: { type: 'string', format: 'date-time' },
        lastEditedTime: { type: 'string', format: 'date-time' },
        editorsSincePublish: {
            type: 'array',
            items: { type: 'object', properties: { name: { type: 'string' }, id: { type: 'string' } } }
        },
        parameters: { type: 'array', items: { $ref: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition' } },
        softDeleted: { type: 'boolean' },
        aiDescription: { type: 'string' }
    },
    required: [
        'reusableLogicID',
        'name',
        'directlyBigPipeCompatible',
        'createdAt',
        'createdBy',
        'publishedVersionID',
        'lastPublishedBy',
        'lastPublishedTime'
    ]
};
const func570 = ucs2length;
const func571 = base64urlToBuffer;
const func572 = base64urlEncode;
const func573 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func576 = ucs2length;
const func577 = base64urlToBuffer;
const func578 = base64urlEncode;
const func579 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func582 = ucs2length;
const func583 = base64urlToBuffer;
const func584 = base64urlEncode;
const func585 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate296(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogic" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.reusableLogicID === undefined && (missing0 = 'reusableLogicID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.directlyBigPipeCompatible === undefined && (missing0 = 'directlyBigPipeCompatible')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt')) ||
                (data.createdBy === undefined && (missing0 = 'createdBy')) ||
                (data.publishedVersionID === undefined && (missing0 = 'publishedVersionID')) ||
                (data.lastPublishedBy === undefined && (missing0 = 'lastPublishedBy')) ||
                (data.lastPublishedTime === undefined && (missing0 = 'lastPublishedTime'))) {
                validate296.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.reusableLogicID !== undefined) {
                    let data0 = data.reusableLogicID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func570(data0) < b64min0 || func570(data0) > b64max0) {
                                validate296.errors = [
                                    {
                                        instancePath: instancePath + '/reusableLogicID',
                                        schemaPath: '#/properties/reusableLogicID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func570(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func570(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func571(data0);
                                if (decoded0.length !== 9) {
                                    validate296.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func572(decoded0);
                                    if (func573(encoded0) !== func573(data0)) {
                                        validate296.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate296.errors = [
                                {
                                    instancePath: instancePath + '/reusableLogicID',
                                    schemaPath: '#/properties/reusableLogicID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate296.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate296.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate296.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.elements !== undefined) {
                            let data2 = data.elements;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid2 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                                let missing1;
                                                if ((data3.elementID === undefined && (missing1 = 'elementID')) ||
                                                    (data3.elementType === undefined && (missing1 = 'elementType'))) {
                                                    validate296.errors = [
                                                        {
                                                            instancePath: instancePath + '/elements/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data3.elementID !== undefined) {
                                                        let data4 = data3.elementID;
                                                        const _errs10 = errors;
                                                        if (errors === _errs10) {
                                                            if (typeof data4 === 'string') {
                                                                const b64min1 = Math.ceil((4 * 10) / 3);
                                                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                                                if (func576(data4) < b64min1 || func576(data4) > b64max1) {
                                                                    validate296.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                            keyword: 'uid',
                                                                            params: {
                                                                                error: 'encoded',
                                                                                b64min: b64min1,
                                                                                b64max: b64max1,
                                                                                length: func576(data4)
                                                                            },
                                                                            message: 'length must be between ' +
                                                                                b64min1 +
                                                                                ' and ' +
                                                                                b64max1 +
                                                                                ', but is ' +
                                                                                func576(data4)
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const decoded1 = func577(data4);
                                                                    if (decoded1.length !== 10) {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'decoded' },
                                                                                message: 'must decode to 10 bytes'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const encoded1 = func578(decoded1);
                                                                        if (func579(encoded1) !== func579(data4)) {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'ambiguous' },
                                                                                    message: 'encoding is ambiguous'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate296.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/elements/' + i0 + '/elementID',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid4 = _errs10 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data3.elementType !== undefined) {
                                                            let data5 = data3.elementType;
                                                            const _errs12 = errors;
                                                            if (errors === _errs12) {
                                                                if (typeof data5 === 'string') {
                                                                    if (!pattern8.test(data5)) {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/pattern',
                                                                                keyword: 'pattern',
                                                                                params: { pattern: 'edge|node|group' },
                                                                                message: 'must match pattern "' + 'edge|node|group' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate296.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/elements/' + i0 + '/elementType',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/elementType/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid4 = _errs12 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data3.lastModified !== undefined) {
                                                                let data6 = data3.lastModified;
                                                                const _errs14 = errors;
                                                                if (errors === _errs14) {
                                                                    if (errors === _errs14) {
                                                                        if (typeof data6 === 'string') {
                                                                            if (!formats0.validate(data6)) {
                                                                                validate296.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/format',
                                                                                        keyword: 'format',
                                                                                        params: { format: 'date-time' },
                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/elements/' + i0 + '/lastModified',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/lastModified/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                var valid4 = _errs14 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                                if (data3.uniqueChangeID !== undefined) {
                                                                    const _errs16 = errors;
                                                                    if (typeof data3.uniqueChangeID !== 'string') {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/elements/' + i0 + '/uniqueChangeID',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:GraphElement/properties/uniqueChangeID/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs16 === errors;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate296.errors = [
                                                    {
                                                        instancePath: instancePath + '/elements/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:GraphElement/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs7 === errors;
                                        if (!valid2) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate296.errors = [
                                        {
                                            instancePath: instancePath + '/elements',
                                            schemaPath: '#/properties/elements/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.directlyBigPipeCompatible !== undefined) {
                                const _errs18 = errors;
                                if (typeof data.directlyBigPipeCompatible !== 'boolean') {
                                    validate296.errors = [
                                        {
                                            instancePath: instancePath + '/directlyBigPipeCompatible',
                                            schemaPath: '#/properties/directlyBigPipeCompatible/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs18 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.createdBy !== undefined) {
                                    const _errs20 = errors;
                                    if (typeof data.createdBy !== 'string') {
                                        validate296.errors = [
                                            {
                                                instancePath: instancePath + '/createdBy',
                                                schemaPath: '#/properties/createdBy/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs20 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.createdAt !== undefined) {
                                        let data10 = data.createdAt;
                                        const _errs22 = errors;
                                        if (errors === _errs22) {
                                            if (errors === _errs22) {
                                                if (typeof data10 === 'string') {
                                                    if (!formats0.validate(data10)) {
                                                        validate296.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate296.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs22 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.documentation !== undefined) {
                                            let data11 = data.documentation;
                                            const _errs24 = errors;
                                            const _errs25 = errors;
                                            if (errors === _errs25) {
                                                if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                    let missing2;
                                                    if ((data11.lastModified === undefined && (missing2 = 'lastModified')) ||
                                                        (data11.content === undefined && (missing2 = 'content'))) {
                                                        validate296.errors = [
                                                            {
                                                                instancePath: instancePath + '/documentation',
                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing2 },
                                                                message: "must have required property '" + missing2 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data11.lastModified !== undefined) {
                                                            let data12 = data11.lastModified;
                                                            const _errs27 = errors;
                                                            if (errors === _errs27) {
                                                                if (errors === _errs27) {
                                                                    if (typeof data12 === 'string') {
                                                                        if (!formats0.validate(data12)) {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/documentation/lastModified',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/documentation/lastModified',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid7 = _errs27 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data11.content !== undefined) {
                                                                let data13 = data11.content;
                                                                const _errs29 = errors;
                                                                if (errors === _errs29) {
                                                                    if (typeof data13 === 'string') {
                                                                        if (func2(data13) > 50000) {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/documentation/content',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/maxLength',
                                                                                    keyword: 'maxLength',
                                                                                    params: { limit: 50000 },
                                                                                    message: 'must NOT have more than 50000 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (func2(data13) < 1) {
                                                                                validate296.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/documentation/content',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/documentation/content',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid7 = _errs29 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate296.errors = [
                                                        {
                                                            instancePath: instancePath + '/documentation',
                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs24 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.description !== undefined) {
                                                const _errs31 = errors;
                                                if (typeof data.description !== 'string') {
                                                    validate296.errors = [
                                                        {
                                                            instancePath: instancePath + '/description',
                                                            schemaPath: '#/properties/description/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs31 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.publishedVersionID !== undefined) {
                                                    let data15 = data.publishedVersionID;
                                                    const _errs33 = errors;
                                                    if (errors === _errs33) {
                                                        if (typeof data15 === 'string') {
                                                            const b64min2 = Math.ceil((4 * 9) / 3);
                                                            const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                            if (func582(data15) < b64min2 || func582(data15) > b64max2) {
                                                                validate296.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/publishedVersionID',
                                                                        schemaPath: '#/properties/publishedVersionID/uid',
                                                                        keyword: 'uid',
                                                                        params: {
                                                                            error: 'encoded',
                                                                            b64min: b64min2,
                                                                            b64max: b64max2,
                                                                            length: func582(data15)
                                                                        },
                                                                        message: 'length must be between ' +
                                                                            b64min2 +
                                                                            ' and ' +
                                                                            b64max2 +
                                                                            ', but is ' +
                                                                            func582(data15)
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                const decoded2 = func583(data15);
                                                                if (decoded2.length !== 9) {
                                                                    validate296.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/publishedVersionID',
                                                                            schemaPath: '#/properties/publishedVersionID/uid',
                                                                            keyword: 'uid',
                                                                            params: { error: 'decoded' },
                                                                            message: 'must decode to 9 bytes'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    const encoded2 = func584(decoded2);
                                                                    if (func585(encoded2) !== func585(data15)) {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/publishedVersionID',
                                                                                schemaPath: '#/properties/publishedVersionID/uid',
                                                                                keyword: 'uid',
                                                                                params: { error: 'ambiguous' },
                                                                                message: 'encoding is ambiguous'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate296.errors = [
                                                                {
                                                                    instancePath: instancePath + '/publishedVersionID',
                                                                    schemaPath: '#/properties/publishedVersionID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs33 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.lastPublishedBy !== undefined) {
                                                        const _errs35 = errors;
                                                        if (typeof data.lastPublishedBy !== 'string') {
                                                            validate296.errors = [
                                                                {
                                                                    instancePath: instancePath + '/lastPublishedBy',
                                                                    schemaPath: '#/properties/lastPublishedBy/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs35 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.lastPublishedTime !== undefined) {
                                                            let data17 = data.lastPublishedTime;
                                                            const _errs37 = errors;
                                                            if (errors === _errs37) {
                                                                if (errors === _errs37) {
                                                                    if (typeof data17 === 'string') {
                                                                        if (!formats0.validate(data17)) {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/lastPublishedTime',
                                                                                    schemaPath: '#/properties/lastPublishedTime/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate296.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/lastPublishedTime',
                                                                                schemaPath: '#/properties/lastPublishedTime/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid0 = _errs37 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.lastEditedTime !== undefined) {
                                                                let data18 = data.lastEditedTime;
                                                                const _errs39 = errors;
                                                                if (errors === _errs39) {
                                                                    if (errors === _errs39) {
                                                                        if (typeof data18 === 'string') {
                                                                            if (!formats0.validate(data18)) {
                                                                                validate296.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/lastEditedTime',
                                                                                        schemaPath: '#/properties/lastEditedTime/format',
                                                                                        keyword: 'format',
                                                                                        params: { format: 'date-time' },
                                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/lastEditedTime',
                                                                                    schemaPath: '#/properties/lastEditedTime/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                var valid0 = _errs39 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.editorsSincePublish !== undefined) {
                                                                    let data19 = data.editorsSincePublish;
                                                                    const _errs41 = errors;
                                                                    if (errors === _errs41) {
                                                                        if (Array.isArray(data19)) {
                                                                            var valid9 = true;
                                                                            const len1 = data19.length;
                                                                            for (let i1 = 0; i1 < len1; i1++) {
                                                                                let data20 = data19[i1];
                                                                                const _errs43 = errors;
                                                                                if (errors === _errs43) {
                                                                                    if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                                        if (data20.name !== undefined) {
                                                                                            const _errs45 = errors;
                                                                                            if (typeof data20.name !== 'string') {
                                                                                                validate296.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/editorsSincePublish/' + i1 + '/name',
                                                                                                        schemaPath: '#/properties/editorsSincePublish/items/properties/name/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid10 = _errs45 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid10 = true;
                                                                                        }
                                                                                        if (valid10) {
                                                                                            if (data20.id !== undefined) {
                                                                                                const _errs47 = errors;
                                                                                                if (typeof data20.id !== 'string') {
                                                                                                    validate296.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/editorsSincePublish/' + i1 + '/id',
                                                                                                            schemaPath: '#/properties/editorsSincePublish/items/properties/id/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid10 = _errs47 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid10 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate296.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/editorsSincePublish/' + i1,
                                                                                                schemaPath: '#/properties/editorsSincePublish/items/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'object' },
                                                                                                message: 'must be object'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid9 = _errs43 === errors;
                                                                                if (!valid9) {
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate296.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/editorsSincePublish',
                                                                                    schemaPath: '#/properties/editorsSincePublish/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'array' },
                                                                                    message: 'must be array'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid0 = _errs41 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                    if (data.parameters !== undefined) {
                                                                        let data23 = data.parameters;
                                                                        const _errs49 = errors;
                                                                        if (errors === _errs49) {
                                                                            if (Array.isArray(data23)) {
                                                                                var valid11 = true;
                                                                                const len2 = data23.length;
                                                                                for (let i2 = 0; i2 < len2; i2++) {
                                                                                    let data24 = data23[i2];
                                                                                    const _errs51 = errors;
                                                                                    const _errs52 = errors;
                                                                                    if (errors === _errs52) {
                                                                                        if (data24 && typeof data24 == 'object' && !Array.isArray(data24)) {
                                                                                            let missing3;
                                                                                            if ((data24.name === undefined && (missing3 = 'name')) ||
                                                                                                (data24.valueType === undefined && (missing3 = 'valueType'))) {
                                                                                                validate296.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/parameters/' + i2,
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/required',
                                                                                                        keyword: 'required',
                                                                                                        params: { missingProperty: missing3 },
                                                                                                        message: "must have required property '" + missing3 + "'"
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                if (data24.name !== undefined) {
                                                                                                    let data25 = data24.name;
                                                                                                    const _errs54 = errors;
                                                                                                    if (errors === _errs54) {
                                                                                                        if (typeof data25 === 'string') {
                                                                                                            if (func2(data25) > 150) {
                                                                                                                validate296.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/parameters/' + i2 + '/name',
                                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/name/maxLength',
                                                                                                                        keyword: 'maxLength',
                                                                                                                        params: { limit: 150 },
                                                                                                                        message: 'must NOT have more than 150 characters'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            else {
                                                                                                                if (func2(data25) < 1) {
                                                                                                                    validate296.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/parameters/' + i2 + '/name',
                                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/name/minLength',
                                                                                                                            keyword: 'minLength',
                                                                                                                            params: { limit: 1 },
                                                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        else {
                                                                                                            validate296.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/parameters/' + i2 + '/name',
                                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/name/type',
                                                                                                                    keyword: 'type',
                                                                                                                    params: { type: 'string' },
                                                                                                                    message: 'must be string'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    var valid13 = _errs54 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid13 = true;
                                                                                                }
                                                                                                if (valid13) {
                                                                                                    if (data24.description !== undefined) {
                                                                                                        let data26 = data24.description;
                                                                                                        const _errs56 = errors;
                                                                                                        if (errors === _errs56) {
                                                                                                            if (typeof data26 === 'string') {
                                                                                                                if (func2(data26) > 1000) {
                                                                                                                    validate296.errors = [
                                                                                                                        {
                                                                                                                            instancePath: instancePath + '/parameters/' + i2 + '/description',
                                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/description/maxLength',
                                                                                                                            keyword: 'maxLength',
                                                                                                                            params: { limit: 1000 },
                                                                                                                            message: 'must NOT have more than 1000 characters'
                                                                                                                        }
                                                                                                                    ];
                                                                                                                    return false;
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                validate296.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/parameters/' + i2 + '/description',
                                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/description/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                        var valid13 = _errs56 === errors;
                                                                                                    }
                                                                                                    else {
                                                                                                        var valid13 = true;
                                                                                                    }
                                                                                                    if (valid13) {
                                                                                                        if (data24.valueType !== undefined) {
                                                                                                            let data27 = data24.valueType;
                                                                                                            const _errs58 = errors;
                                                                                                            if (typeof data27 !== 'string') {
                                                                                                                validate296.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/parameters/' + i2 + '/valueType',
                                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/valueType/type',
                                                                                                                        keyword: 'type',
                                                                                                                        params: { type: 'string' },
                                                                                                                        message: 'must be string'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            if (!(data27 === 'string' ||
                                                                                                                data27 === 'number' ||
                                                                                                                data27 === 'boolean' ||
                                                                                                                data27 === 'date' ||
                                                                                                                data27 === 'enum' ||
                                                                                                                data27 === 'column' ||
                                                                                                                data27 === 'calendar')) {
                                                                                                                validate296.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/parameters/' + i2 + '/valueType',
                                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/valueType/enum',
                                                                                                                        keyword: 'enum',
                                                                                                                        params: {
                                                                                                                            allowedValues: schema401.properties.valueType.enum
                                                                                                                        },
                                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                            var valid13 = _errs58 === errors;
                                                                                                        }
                                                                                                        else {
                                                                                                            var valid13 = true;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate296.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/parameters/' + i2,
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'object' },
                                                                                                    message: 'must be object'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid11 = _errs51 === errors;
                                                                                    if (!valid11) {
                                                                                        break;
                                                                                    }
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate296.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parameters',
                                                                                        schemaPath: '#/properties/parameters/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'array' },
                                                                                        message: 'must be array'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid0 = _errs49 === errors;
                                                                    }
                                                                    else {
                                                                        var valid0 = true;
                                                                    }
                                                                    if (valid0) {
                                                                        if (data.softDeleted !== undefined) {
                                                                            const _errs60 = errors;
                                                                            if (typeof data.softDeleted !== 'boolean') {
                                                                                validate296.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/softDeleted',
                                                                                        schemaPath: '#/properties/softDeleted/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'boolean' },
                                                                                        message: 'must be boolean'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid0 = _errs60 === errors;
                                                                        }
                                                                        else {
                                                                            var valid0 = true;
                                                                        }
                                                                        if (valid0) {
                                                                            if (data.aiDescription !== undefined) {
                                                                                const _errs62 = errors;
                                                                                if (typeof data.aiDescription !== 'string') {
                                                                                    validate296.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/aiDescription',
                                                                                            schemaPath: '#/properties/aiDescription/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid0 = _errs62 === errors;
                                                                            }
                                                                            else {
                                                                                var valid0 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate296.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate296.errors = vErrors;
    return errors === 0;
}
export const reusableLogicVersionSchemaValidation = validate297;
const schema406 = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogicVersion',
    type: 'object',
    properties: {
        versionID: { type: 'string', uid: 9 },
        versionName: { type: 'string', minLength: 1, maxLength: 100 },
        createdAt: { type: 'string', format: 'date-time' },
        createdBy: { type: 'string', format: 'uuid' }
    },
    required: ['versionID', 'versionName', 'createdAt', 'createdBy']
};
const func589 = ucs2length;
const func590 = base64urlToBuffer;
const func591 = base64urlEncode;
const func592 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate297(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ReusableLogicVersion" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.versionID === undefined && (missing0 = 'versionID')) ||
                (data.versionName === undefined && (missing0 = 'versionName')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt')) ||
                (data.createdBy === undefined && (missing0 = 'createdBy'))) {
                validate297.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.versionID !== undefined) {
                    let data0 = data.versionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func589(data0) < b64min0 || func589(data0) > b64max0) {
                                validate297.errors = [
                                    {
                                        instancePath: instancePath + '/versionID',
                                        schemaPath: '#/properties/versionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func589(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func589(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func590(data0);
                                if (decoded0.length !== 9) {
                                    validate297.errors = [
                                        {
                                            instancePath: instancePath + '/versionID',
                                            schemaPath: '#/properties/versionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func591(decoded0);
                                    if (func592(encoded0) !== func592(data0)) {
                                        validate297.errors = [
                                            {
                                                instancePath: instancePath + '/versionID',
                                                schemaPath: '#/properties/versionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate297.errors = [
                                {
                                    instancePath: instancePath + '/versionID',
                                    schemaPath: '#/properties/versionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.versionName !== undefined) {
                        let data1 = data.versionName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate297.errors = [
                                        {
                                            instancePath: instancePath + '/versionName',
                                            schemaPath: '#/properties/versionName/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate297.errors = [
                                            {
                                                instancePath: instancePath + '/versionName',
                                                schemaPath: '#/properties/versionName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate297.errors = [
                                    {
                                        instancePath: instancePath + '/versionName',
                                        schemaPath: '#/properties/versionName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.createdAt !== undefined) {
                            let data2 = data.createdAt;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate297.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate297.errors = [
                                            {
                                                instancePath: instancePath + '/createdAt',
                                                schemaPath: '#/properties/createdAt/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.createdBy !== undefined) {
                                let data3 = data.createdBy;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats4.test(data3)) {
                                                validate297.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdBy',
                                                        schemaPath: '#/properties/createdBy/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate297.errors = [
                                                {
                                                    instancePath: instancePath + '/createdBy',
                                                    schemaPath: '#/properties/createdBy/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate297.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate297.errors = vErrors;
    return errors === 0;
}
export const ruleMapperConfigSchemaValidation = validate298;
const schema407 = {
    $id: 'urn:wisepipe-common-pipe:RuleMapperConfig',
    type: 'object',
    properties: {
        dataOutputColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            minItems: 1,
            maxItems: 100,
            uniqueItems: true
        },
        dataDateColumn: { type: 'string', minLength: 1 },
        dataLeavesOnly: { type: 'boolean' },
        hierarchiesSourceColumn: { type: 'string', minLength: 1 },
        hierarchiesIDColumn: { type: 'string', minLength: 1 },
        hierarchiesParentColumn: { type: 'string', minLength: 1 },
        hierarchiesParentByValue: { type: 'boolean' },
        hierarchiesValueColumn: { type: 'string', minLength: 1 },
        hierarchiesStartColumn: {
            type: 'string',
            minLength: 1,
            allOf: [
                { not: { const: { $data: '1/hierarchiesSourceColumn' } } },
                { not: { const: { $data: '1/hierarchiesIDColumn' } } }
            ]
        },
        hierarchiesEndColumn: {
            type: 'string',
            minLength: 1,
            allOf: [
                { not: { const: { $data: '1/hierarchiesSourceColumn' } } },
                { not: { const: { $data: '1/hierarchiesIDColumn' } } }
            ]
        },
        hierarchiesAttributeColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            maxItems: 100,
            uniqueItems: true
        },
        rulesOutputColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            minItems: 1,
            maxItems: 100,
            uniqueItems: true
        },
        rulesDefColumn: { type: 'string', minLength: 1 },
        rulesValueColumn: { type: 'string', minLength: 1 },
        rulesPrecedenceColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name'],
            maxItems: 10
        },
        rulesStartColumn: { type: 'string', minLength: 1, not: { const: { $data: '1/rulesDefColumn' } } },
        rulesEndColumn: { type: 'string', minLength: 1, not: { const: { $data: '1/rulesDefColumn' } } },
        rulesDecodeMethod: { type: 'string', enum: ['text', 'json'] },
        rulesMultiValues: { type: 'boolean' },
        rulesSplitColumn: { type: 'string', minLength: 1 },
        outputUnmapped: { type: 'boolean' }
    },
    required: [
        'dataOutputColumns',
        'hierarchiesSourceColumn',
        'hierarchiesIDColumn',
        'hierarchiesParentColumn',
        'hierarchiesParentByValue',
        'hierarchiesValueColumn',
        'rulesOutputColumns',
        'rulesDefColumn',
        'rulesValueColumn',
        'rulesPrecedenceColumns'
    ],
    allOf: [
        { if: { required: ['rulesStartColumn'] }, then: { required: ['rulesEndColumn', 'dataDateColumn'] } },
        { if: { required: ['rulesEndColumn'] }, then: { required: ['rulesStartColumn', 'dataDateColumn'] } },
        { if: { required: ['hierarchiesStartColumn'] }, then: { required: ['hierarchiesEndColumn', 'dataDateColumn'] } },
        { if: { required: ['hierarchiesEndColumn'] }, then: { required: ['hierarchiesStartColumn', 'dataDateColumn'] } },
        {
            if: { properties: { rulesMultiValues: { const: true } } },
            then: {
                properties: {
                    rulesStartColumn: { type: 'string', not: { const: { $data: '1/rulesValueColumn' } } },
                    rulesEndColumn: { type: 'string', not: { const: { $data: '1/rulesValueColumn' } } }
                }
            }
        }
    ]
};
const func613 = ajvEqual;
function validate298(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RuleMapperConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.rulesStartColumn === undefined && (missing0 = 'rulesStartColumn')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.rulesEndColumn === undefined && (missing1 = 'rulesEndColumn')) ||
                (data.dataDateColumn === undefined && (missing1 = 'dataDateColumn'))) {
                validate298.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate298.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.rulesEndColumn === undefined && (missing2 = 'rulesEndColumn')) {
                const err2 = {};
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs8 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if ((data.rulesStartColumn === undefined && (missing3 = 'rulesStartColumn')) ||
                    (data.dataDateColumn === undefined && (missing3 = 'dataDateColumn'))) {
                    validate298.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs8 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate298.errors = vErrors;
            return false;
        }
        var valid0 = _errs5 === errors;
        if (valid0) {
            const _errs9 = errors;
            const _errs10 = errors;
            let valid3 = true;
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing4;
                if (data.hierarchiesStartColumn === undefined && (missing4 = 'hierarchiesStartColumn')) {
                    const err4 = {};
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            var _valid2 = _errs11 === errors;
            errors = _errs10;
            if (vErrors !== null) {
                if (_errs10) {
                    vErrors.length = _errs10;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs12 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing5;
                    if ((data.hierarchiesEndColumn === undefined && (missing5 = 'hierarchiesEndColumn')) ||
                        (data.dataDateColumn === undefined && (missing5 = 'dataDateColumn'))) {
                        validate298.errors = [
                            {
                                instancePath,
                                schemaPath: '#/allOf/2/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing5 },
                                message: "must have required property '" + missing5 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs12 === errors;
                valid3 = _valid2;
            }
            if (!valid3) {
                const err5 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
                validate298.errors = vErrors;
                return false;
            }
            var valid0 = _errs9 === errors;
            if (valid0) {
                const _errs13 = errors;
                const _errs14 = errors;
                let valid4 = true;
                const _errs15 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing6;
                    if (data.hierarchiesEndColumn === undefined && (missing6 = 'hierarchiesEndColumn')) {
                        const err6 = {};
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                }
                var _valid3 = _errs15 === errors;
                errors = _errs14;
                if (vErrors !== null) {
                    if (_errs14) {
                        vErrors.length = _errs14;
                    }
                    else {
                        vErrors = null;
                    }
                }
                if (_valid3) {
                    const _errs16 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing7;
                        if ((data.hierarchiesStartColumn === undefined && (missing7 = 'hierarchiesStartColumn')) ||
                            (data.dataDateColumn === undefined && (missing7 = 'dataDateColumn'))) {
                            validate298.errors = [
                                {
                                    instancePath,
                                    schemaPath: '#/allOf/3/then/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing7 },
                                    message: "must have required property '" + missing7 + "'"
                                }
                            ];
                            return false;
                        }
                    }
                    var _valid3 = _errs16 === errors;
                    valid4 = _valid3;
                }
                if (!valid4) {
                    const err7 = {
                        instancePath,
                        schemaPath: '#/allOf/3/if',
                        keyword: 'if',
                        params: { failingKeyword: 'then' },
                        message: 'must match "then" schema'
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                    validate298.errors = vErrors;
                    return false;
                }
                var valid0 = _errs13 === errors;
                if (valid0) {
                    const _errs17 = errors;
                    const _errs18 = errors;
                    let valid5 = true;
                    const _errs19 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        if (data.rulesMultiValues !== undefined) {
                            if (true !== data.rulesMultiValues) {
                                const err8 = {};
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                    }
                    var _valid4 = _errs19 === errors;
                    errors = _errs18;
                    if (vErrors !== null) {
                        if (_errs18) {
                            vErrors.length = _errs18;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                    if (_valid4) {
                        const _errs21 = errors;
                        if (data && typeof data == 'object' && !Array.isArray(data)) {
                            if (data.rulesStartColumn !== undefined) {
                                let data1 = data.rulesStartColumn;
                                const _errs22 = errors;
                                if (typeof data1 !== 'string') {
                                    validate298.errors = [
                                        {
                                            instancePath: instancePath + '/rulesStartColumn',
                                            schemaPath: '#/allOf/4/then/properties/rulesStartColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                const _errs24 = errors;
                                const _errs25 = errors;
                                const vSchema0 = data && data.rulesValueColumn;
                                if (vSchema0 !== undefined && !func0(data1, vSchema0)) {
                                    const err9 = {};
                                    if (vErrors === null) {
                                        vErrors = [err9];
                                    }
                                    else {
                                        vErrors.push(err9);
                                    }
                                    errors++;
                                }
                                var valid8 = _errs25 === errors;
                                if (valid8) {
                                    validate298.errors = [
                                        {
                                            instancePath: instancePath + '/rulesStartColumn',
                                            schemaPath: '#/allOf/4/then/properties/rulesStartColumn/not',
                                            keyword: 'not',
                                            params: {},
                                            message: 'must NOT be valid'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    errors = _errs24;
                                    if (vErrors !== null) {
                                        if (_errs24) {
                                            vErrors.length = _errs24;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid7 = _errs22 === errors;
                            }
                            else {
                                var valid7 = true;
                            }
                            if (valid7) {
                                if (data.rulesEndColumn !== undefined) {
                                    let data2 = data.rulesEndColumn;
                                    const _errs26 = errors;
                                    if (typeof data2 !== 'string') {
                                        validate298.errors = [
                                            {
                                                instancePath: instancePath + '/rulesEndColumn',
                                                schemaPath: '#/allOf/4/then/properties/rulesEndColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    const _errs28 = errors;
                                    const _errs29 = errors;
                                    const vSchema1 = data && data.rulesValueColumn;
                                    if (vSchema1 !== undefined && !func0(data2, vSchema1)) {
                                        const err10 = {};
                                        if (vErrors === null) {
                                            vErrors = [err10];
                                        }
                                        else {
                                            vErrors.push(err10);
                                        }
                                        errors++;
                                    }
                                    var valid9 = _errs29 === errors;
                                    if (valid9) {
                                        validate298.errors = [
                                            {
                                                instancePath: instancePath + '/rulesEndColumn',
                                                schemaPath: '#/allOf/4/then/properties/rulesEndColumn/not',
                                                keyword: 'not',
                                                params: {},
                                                message: 'must NOT be valid'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        errors = _errs28;
                                        if (vErrors !== null) {
                                            if (_errs28) {
                                                vErrors.length = _errs28;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid7 = _errs26 === errors;
                                }
                                else {
                                    var valid7 = true;
                                }
                            }
                        }
                        var _valid4 = _errs21 === errors;
                        valid5 = _valid4;
                    }
                    if (!valid5) {
                        const err11 = {
                            instancePath,
                            schemaPath: '#/allOf/4/if',
                            keyword: 'if',
                            params: { failingKeyword: 'then' },
                            message: 'must match "then" schema'
                        };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                        validate298.errors = vErrors;
                        return false;
                    }
                    var valid0 = _errs17 === errors;
                }
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing8;
            if ((data.dataOutputColumns === undefined && (missing8 = 'dataOutputColumns')) ||
                (data.hierarchiesSourceColumn === undefined && (missing8 = 'hierarchiesSourceColumn')) ||
                (data.hierarchiesIDColumn === undefined && (missing8 = 'hierarchiesIDColumn')) ||
                (data.hierarchiesParentColumn === undefined && (missing8 = 'hierarchiesParentColumn')) ||
                (data.hierarchiesParentByValue === undefined && (missing8 = 'hierarchiesParentByValue')) ||
                (data.hierarchiesValueColumn === undefined && (missing8 = 'hierarchiesValueColumn')) ||
                (data.rulesOutputColumns === undefined && (missing8 = 'rulesOutputColumns')) ||
                (data.rulesDefColumn === undefined && (missing8 = 'rulesDefColumn')) ||
                (data.rulesValueColumn === undefined && (missing8 = 'rulesValueColumn')) ||
                (data.rulesPrecedenceColumns === undefined && (missing8 = 'rulesPrecedenceColumns'))) {
                validate298.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing8 },
                        message: "must have required property '" + missing8 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataOutputColumns !== undefined) {
                    let data3 = data.dataOutputColumns;
                    const _errs30 = errors;
                    if (errors === _errs30) {
                        if (Array.isArray(data3)) {
                            if (data3.length > 100) {
                                validate298.errors = [
                                    {
                                        instancePath: instancePath + '/dataOutputColumns',
                                        schemaPath: '#/properties/dataOutputColumns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data3.length < 1) {
                                    validate298.errors = [
                                        {
                                            instancePath: instancePath + '/dataOutputColumns',
                                            schemaPath: '#/properties/dataOutputColumns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid11 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data4 = data3[i0];
                                        const _errs32 = errors;
                                        if (errors === _errs32) {
                                            if (typeof data4 === 'string') {
                                                if (func2(data4) < 1) {
                                                    validate298.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataOutputColumns/' + i0,
                                                            schemaPath: '#/properties/dataOutputColumns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate298.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataOutputColumns/' + i0,
                                                        schemaPath: '#/properties/dataOutputColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid11 = _errs32 === errors;
                                        if (!valid11) {
                                            break;
                                        }
                                    }
                                    if (valid11) {
                                        let i1 = data3.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data3[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate298.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataOutputColumns',
                                                            schemaPath: '#/properties/dataOutputColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate298.errors = [
                                {
                                    instancePath: instancePath + '/dataOutputColumns',
                                    schemaPath: '#/properties/dataOutputColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid10 = _errs30 === errors;
                }
                else {
                    var valid10 = true;
                }
                if (valid10) {
                    if (data.dataDateColumn !== undefined) {
                        let data5 = data.dataDateColumn;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data5 === 'string') {
                                if (func2(data5) < 1) {
                                    validate298.errors = [
                                        {
                                            instancePath: instancePath + '/dataDateColumn',
                                            schemaPath: '#/properties/dataDateColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate298.errors = [
                                    {
                                        instancePath: instancePath + '/dataDateColumn',
                                        schemaPath: '#/properties/dataDateColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid10 = _errs34 === errors;
                    }
                    else {
                        var valid10 = true;
                    }
                    if (valid10) {
                        if (data.dataLeavesOnly !== undefined) {
                            const _errs36 = errors;
                            if (typeof data.dataLeavesOnly !== 'boolean') {
                                validate298.errors = [
                                    {
                                        instancePath: instancePath + '/dataLeavesOnly',
                                        schemaPath: '#/properties/dataLeavesOnly/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid10 = _errs36 === errors;
                        }
                        else {
                            var valid10 = true;
                        }
                        if (valid10) {
                            if (data.hierarchiesSourceColumn !== undefined) {
                                let data7 = data.hierarchiesSourceColumn;
                                const _errs38 = errors;
                                if (errors === _errs38) {
                                    if (typeof data7 === 'string') {
                                        if (func2(data7) < 1) {
                                            validate298.errors = [
                                                {
                                                    instancePath: instancePath + '/hierarchiesSourceColumn',
                                                    schemaPath: '#/properties/hierarchiesSourceColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate298.errors = [
                                            {
                                                instancePath: instancePath + '/hierarchiesSourceColumn',
                                                schemaPath: '#/properties/hierarchiesSourceColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid10 = _errs38 === errors;
                            }
                            else {
                                var valid10 = true;
                            }
                            if (valid10) {
                                if (data.hierarchiesIDColumn !== undefined) {
                                    let data8 = data.hierarchiesIDColumn;
                                    const _errs40 = errors;
                                    if (errors === _errs40) {
                                        if (typeof data8 === 'string') {
                                            if (func2(data8) < 1) {
                                                validate298.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchiesIDColumn',
                                                        schemaPath: '#/properties/hierarchiesIDColumn/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate298.errors = [
                                                {
                                                    instancePath: instancePath + '/hierarchiesIDColumn',
                                                    schemaPath: '#/properties/hierarchiesIDColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs40 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data.hierarchiesParentColumn !== undefined) {
                                        let data9 = data.hierarchiesParentColumn;
                                        const _errs42 = errors;
                                        if (errors === _errs42) {
                                            if (typeof data9 === 'string') {
                                                if (func2(data9) < 1) {
                                                    validate298.errors = [
                                                        {
                                                            instancePath: instancePath + '/hierarchiesParentColumn',
                                                            schemaPath: '#/properties/hierarchiesParentColumn/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate298.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchiesParentColumn',
                                                        schemaPath: '#/properties/hierarchiesParentColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs42 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                    if (valid10) {
                                        if (data.hierarchiesParentByValue !== undefined) {
                                            const _errs44 = errors;
                                            if (typeof data.hierarchiesParentByValue !== 'boolean') {
                                                validate298.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchiesParentByValue',
                                                        schemaPath: '#/properties/hierarchiesParentByValue/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid10 = _errs44 === errors;
                                        }
                                        else {
                                            var valid10 = true;
                                        }
                                        if (valid10) {
                                            if (data.hierarchiesValueColumn !== undefined) {
                                                let data11 = data.hierarchiesValueColumn;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data11 === 'string') {
                                                        if (func2(data11) < 1) {
                                                            validate298.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesValueColumn',
                                                                    schemaPath: '#/properties/hierarchiesValueColumn/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate298.errors = [
                                                            {
                                                                instancePath: instancePath + '/hierarchiesValueColumn',
                                                                schemaPath: '#/properties/hierarchiesValueColumn/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid10 = _errs46 === errors;
                                            }
                                            else {
                                                var valid10 = true;
                                            }
                                            if (valid10) {
                                                if (data.hierarchiesStartColumn !== undefined) {
                                                    let data12 = data.hierarchiesStartColumn;
                                                    const _errs48 = errors;
                                                    const _errs50 = errors;
                                                    const _errs51 = errors;
                                                    const _errs52 = errors;
                                                    const vSchema2 = data && data.hierarchiesSourceColumn;
                                                    if (vSchema2 !== undefined && !func0(data12, vSchema2)) {
                                                        const err12 = {};
                                                        if (vErrors === null) {
                                                            vErrors = [err12];
                                                        }
                                                        else {
                                                            vErrors.push(err12);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid14 = _errs52 === errors;
                                                    if (valid14) {
                                                        validate298.errors = [
                                                            {
                                                                instancePath: instancePath + '/hierarchiesStartColumn',
                                                                schemaPath: '#/properties/hierarchiesStartColumn/allOf/0/not',
                                                                keyword: 'not',
                                                                params: {},
                                                                message: 'must NOT be valid'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        errors = _errs51;
                                                        if (vErrors !== null) {
                                                            if (_errs51) {
                                                                vErrors.length = _errs51;
                                                            }
                                                            else {
                                                                vErrors = null;
                                                            }
                                                        }
                                                    }
                                                    var valid13 = _errs50 === errors;
                                                    if (valid13) {
                                                        const _errs53 = errors;
                                                        const _errs54 = errors;
                                                        const _errs55 = errors;
                                                        const vSchema3 = data && data.hierarchiesIDColumn;
                                                        if (vSchema3 !== undefined && !func0(data12, vSchema3)) {
                                                            const err13 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err13];
                                                            }
                                                            else {
                                                                vErrors.push(err13);
                                                            }
                                                            errors++;
                                                        }
                                                        var valid15 = _errs55 === errors;
                                                        if (valid15) {
                                                            validate298.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesStartColumn',
                                                                    schemaPath: '#/properties/hierarchiesStartColumn/allOf/1/not',
                                                                    keyword: 'not',
                                                                    params: {},
                                                                    message: 'must NOT be valid'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            errors = _errs54;
                                                            if (vErrors !== null) {
                                                                if (_errs54) {
                                                                    vErrors.length = _errs54;
                                                                }
                                                                else {
                                                                    vErrors = null;
                                                                }
                                                            }
                                                        }
                                                        var valid13 = _errs53 === errors;
                                                    }
                                                    if (errors === _errs48) {
                                                        if (typeof data12 === 'string') {
                                                            if (func2(data12) < 1) {
                                                                validate298.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchiesStartColumn',
                                                                        schemaPath: '#/properties/hierarchiesStartColumn/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate298.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesStartColumn',
                                                                    schemaPath: '#/properties/hierarchiesStartColumn/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid10 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid10 = true;
                                                }
                                                if (valid10) {
                                                    if (data.hierarchiesEndColumn !== undefined) {
                                                        let data13 = data.hierarchiesEndColumn;
                                                        const _errs56 = errors;
                                                        const _errs58 = errors;
                                                        const _errs59 = errors;
                                                        const _errs60 = errors;
                                                        const vSchema4 = data && data.hierarchiesSourceColumn;
                                                        if (vSchema4 !== undefined && !func0(data13, vSchema4)) {
                                                            const err14 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err14];
                                                            }
                                                            else {
                                                                vErrors.push(err14);
                                                            }
                                                            errors++;
                                                        }
                                                        var valid17 = _errs60 === errors;
                                                        if (valid17) {
                                                            validate298.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesEndColumn',
                                                                    schemaPath: '#/properties/hierarchiesEndColumn/allOf/0/not',
                                                                    keyword: 'not',
                                                                    params: {},
                                                                    message: 'must NOT be valid'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            errors = _errs59;
                                                            if (vErrors !== null) {
                                                                if (_errs59) {
                                                                    vErrors.length = _errs59;
                                                                }
                                                                else {
                                                                    vErrors = null;
                                                                }
                                                            }
                                                        }
                                                        var valid16 = _errs58 === errors;
                                                        if (valid16) {
                                                            const _errs61 = errors;
                                                            const _errs62 = errors;
                                                            const _errs63 = errors;
                                                            const vSchema5 = data && data.hierarchiesIDColumn;
                                                            if (vSchema5 !== undefined && !func0(data13, vSchema5)) {
                                                                const err15 = {};
                                                                if (vErrors === null) {
                                                                    vErrors = [err15];
                                                                }
                                                                else {
                                                                    vErrors.push(err15);
                                                                }
                                                                errors++;
                                                            }
                                                            var valid18 = _errs63 === errors;
                                                            if (valid18) {
                                                                validate298.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchiesEndColumn',
                                                                        schemaPath: '#/properties/hierarchiesEndColumn/allOf/1/not',
                                                                        keyword: 'not',
                                                                        params: {},
                                                                        message: 'must NOT be valid'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                errors = _errs62;
                                                                if (vErrors !== null) {
                                                                    if (_errs62) {
                                                                        vErrors.length = _errs62;
                                                                    }
                                                                    else {
                                                                        vErrors = null;
                                                                    }
                                                                }
                                                            }
                                                            var valid16 = _errs61 === errors;
                                                        }
                                                        if (errors === _errs56) {
                                                            if (typeof data13 === 'string') {
                                                                if (func2(data13) < 1) {
                                                                    validate298.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hierarchiesEndColumn',
                                                                            schemaPath: '#/properties/hierarchiesEndColumn/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate298.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchiesEndColumn',
                                                                        schemaPath: '#/properties/hierarchiesEndColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid10 = _errs56 === errors;
                                                    }
                                                    else {
                                                        var valid10 = true;
                                                    }
                                                    if (valid10) {
                                                        if (data.hierarchiesAttributeColumns !== undefined) {
                                                            let data14 = data.hierarchiesAttributeColumns;
                                                            const _errs64 = errors;
                                                            if (errors === _errs64) {
                                                                if (Array.isArray(data14)) {
                                                                    if (data14.length > 100) {
                                                                        validate298.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hierarchiesAttributeColumns',
                                                                                schemaPath: '#/properties/hierarchiesAttributeColumns/maxItems',
                                                                                keyword: 'maxItems',
                                                                                params: { limit: 100 },
                                                                                message: 'must NOT have more than 100 items'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        var valid19 = true;
                                                                        const len1 = data14.length;
                                                                        for (let i2 = 0; i2 < len1; i2++) {
                                                                            let data15 = data14[i2];
                                                                            const _errs66 = errors;
                                                                            if (errors === _errs66) {
                                                                                if (typeof data15 === 'string') {
                                                                                    if (func2(data15) < 1) {
                                                                                        validate298.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/hierarchiesAttributeColumns/' + i2,
                                                                                                schemaPath: '#/properties/hierarchiesAttributeColumns/items/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate298.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/hierarchiesAttributeColumns/' + i2,
                                                                                            schemaPath: '#/properties/hierarchiesAttributeColumns/items/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid19 = _errs66 === errors;
                                                                            if (!valid19) {
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (valid19) {
                                                                            let i3 = data14.length;
                                                                            let j1;
                                                                            if (i3 > 1) {
                                                                                const indices1 = {};
                                                                                for (; i3--;) {
                                                                                    let item1 = data14[i3];
                                                                                    if (typeof item1 !== 'string') {
                                                                                        continue;
                                                                                    }
                                                                                    if (typeof indices1[item1] == 'number') {
                                                                                        j1 = indices1[item1];
                                                                                        validate298.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/hierarchiesAttributeColumns',
                                                                                                schemaPath: '#/properties/hierarchiesAttributeColumns/uniqueItems',
                                                                                                keyword: 'uniqueItems',
                                                                                                params: { i: i3, j: j1 },
                                                                                                message: 'must NOT have duplicate items (items ## ' +
                                                                                                    j1 +
                                                                                                    ' and ' +
                                                                                                    i3 +
                                                                                                    ' are identical)'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                        break;
                                                                                    }
                                                                                    indices1[item1] = i3;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate298.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hierarchiesAttributeColumns',
                                                                            schemaPath: '#/properties/hierarchiesAttributeColumns/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid10 = _errs64 === errors;
                                                        }
                                                        else {
                                                            var valid10 = true;
                                                        }
                                                        if (valid10) {
                                                            if (data.rulesOutputColumns !== undefined) {
                                                                let data16 = data.rulesOutputColumns;
                                                                const _errs68 = errors;
                                                                if (errors === _errs68) {
                                                                    if (Array.isArray(data16)) {
                                                                        if (data16.length > 100) {
                                                                            validate298.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/rulesOutputColumns',
                                                                                    schemaPath: '#/properties/rulesOutputColumns/maxItems',
                                                                                    keyword: 'maxItems',
                                                                                    params: { limit: 100 },
                                                                                    message: 'must NOT have more than 100 items'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data16.length < 1) {
                                                                                validate298.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rulesOutputColumns',
                                                                                        schemaPath: '#/properties/rulesOutputColumns/minItems',
                                                                                        keyword: 'minItems',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 items'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                var valid21 = true;
                                                                                const len2 = data16.length;
                                                                                for (let i4 = 0; i4 < len2; i4++) {
                                                                                    let data17 = data16[i4];
                                                                                    const _errs70 = errors;
                                                                                    if (errors === _errs70) {
                                                                                        if (typeof data17 === 'string') {
                                                                                            if (func2(data17) < 1) {
                                                                                                validate298.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesOutputColumns/' + i4,
                                                                                                        schemaPath: '#/properties/rulesOutputColumns/items/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate298.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesOutputColumns/' + i4,
                                                                                                    schemaPath: '#/properties/rulesOutputColumns/items/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid21 = _errs70 === errors;
                                                                                    if (!valid21) {
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (valid21) {
                                                                                    let i5 = data16.length;
                                                                                    let j2;
                                                                                    if (i5 > 1) {
                                                                                        const indices2 = {};
                                                                                        for (; i5--;) {
                                                                                            let item2 = data16[i5];
                                                                                            if (typeof item2 !== 'string') {
                                                                                                continue;
                                                                                            }
                                                                                            if (typeof indices2[item2] == 'number') {
                                                                                                j2 = indices2[item2];
                                                                                                validate298.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesOutputColumns',
                                                                                                        schemaPath: '#/properties/rulesOutputColumns/uniqueItems',
                                                                                                        keyword: 'uniqueItems',
                                                                                                        params: { i: i5, j: j2 },
                                                                                                        message: 'must NOT have duplicate items (items ## ' +
                                                                                                            j2 +
                                                                                                            ' and ' +
                                                                                                            i5 +
                                                                                                            ' are identical)'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                                break;
                                                                                            }
                                                                                            indices2[item2] = i5;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate298.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/rulesOutputColumns',
                                                                                schemaPath: '#/properties/rulesOutputColumns/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'array' },
                                                                                message: 'must be array'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid10 = _errs68 === errors;
                                                            }
                                                            else {
                                                                var valid10 = true;
                                                            }
                                                            if (valid10) {
                                                                if (data.rulesDefColumn !== undefined) {
                                                                    let data18 = data.rulesDefColumn;
                                                                    const _errs72 = errors;
                                                                    if (errors === _errs72) {
                                                                        if (typeof data18 === 'string') {
                                                                            if (func2(data18) < 1) {
                                                                                validate298.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rulesDefColumn',
                                                                                        schemaPath: '#/properties/rulesDefColumn/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate298.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/rulesDefColumn',
                                                                                    schemaPath: '#/properties/rulesDefColumn/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid10 = _errs72 === errors;
                                                                }
                                                                else {
                                                                    var valid10 = true;
                                                                }
                                                                if (valid10) {
                                                                    if (data.rulesValueColumn !== undefined) {
                                                                        let data19 = data.rulesValueColumn;
                                                                        const _errs74 = errors;
                                                                        if (errors === _errs74) {
                                                                            if (typeof data19 === 'string') {
                                                                                if (func2(data19) < 1) {
                                                                                    validate298.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rulesValueColumn',
                                                                                            schemaPath: '#/properties/rulesValueColumn/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate298.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rulesValueColumn',
                                                                                        schemaPath: '#/properties/rulesValueColumn/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid10 = _errs74 === errors;
                                                                    }
                                                                    else {
                                                                        var valid10 = true;
                                                                    }
                                                                    if (valid10) {
                                                                        if (data.rulesPrecedenceColumns !== undefined) {
                                                                            let data20 = data.rulesPrecedenceColumns;
                                                                            const _errs76 = errors;
                                                                            if (errors === _errs76) {
                                                                                if (Array.isArray(data20)) {
                                                                                    if (data20.length > 10) {
                                                                                        validate298.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rulesPrecedenceColumns',
                                                                                                schemaPath: '#/properties/rulesPrecedenceColumns/maxItems',
                                                                                                keyword: 'maxItems',
                                                                                                params: { limit: 10 },
                                                                                                message: 'must NOT have more than 10 items'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        var valid23 = true;
                                                                                        const len3 = data20.length;
                                                                                        for (let i6 = 0; i6 < len3; i6++) {
                                                                                            const _errs78 = errors;
                                                                                            if (!validate219(data20[i6], {
                                                                                                instancePath: instancePath + '/rulesPrecedenceColumns/' + i6,
                                                                                                parentData: data20,
                                                                                                parentDataProperty: i6,
                                                                                                rootData
                                                                                            })) {
                                                                                                vErrors =
                                                                                                    vErrors === null
                                                                                                        ? validate219.errors
                                                                                                        : vErrors.concat(validate219.errors);
                                                                                                errors = vErrors.length;
                                                                                            }
                                                                                            var valid23 = _errs78 === errors;
                                                                                            if (!valid23) {
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (valid23) {
                                                                                            const keys0 = schema407.properties.rulesPrecedenceColumns.uniqueItemProperties;
                                                                                            let k0;
                                                                                            let i7 = data20.length;
                                                                                            let j3;
                                                                                            if (i7 > 1) {
                                                                                                outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                                                                    let key0 = keys0[k0];
                                                                                                    for (i7 = data20.length; i7--;) {
                                                                                                        let x0 = data20[i7];
                                                                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                                                                            continue;
                                                                                                        }
                                                                                                        for (j3 = i7; j3--;) {
                                                                                                            let y0 = data20[j3];
                                                                                                            if (y0 &&
                                                                                                                typeof y0 == 'object' &&
                                                                                                                !Array.isArray(y0) &&
                                                                                                                func613(x0[key0], y0[key0])) {
                                                                                                                validate298.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/rulesPrecedenceColumns',
                                                                                                                        schemaPath: '#/properties/rulesPrecedenceColumns/uniqueItemProperties',
                                                                                                                        keyword: 'uniqueItemProperties',
                                                                                                                        params: {},
                                                                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                                break outer0;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate298.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rulesPrecedenceColumns',
                                                                                            schemaPath: '#/properties/rulesPrecedenceColumns/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'array' },
                                                                                            message: 'must be array'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid10 = _errs76 === errors;
                                                                        }
                                                                        else {
                                                                            var valid10 = true;
                                                                        }
                                                                        if (valid10) {
                                                                            if (data.rulesStartColumn !== undefined) {
                                                                                let data22 = data.rulesStartColumn;
                                                                                const _errs79 = errors;
                                                                                const _errs81 = errors;
                                                                                const _errs82 = errors;
                                                                                const vSchema6 = data && data.rulesDefColumn;
                                                                                if (vSchema6 !== undefined && !func0(data22, vSchema6)) {
                                                                                    const err16 = {};
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err16];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err16);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                                var valid25 = _errs82 === errors;
                                                                                if (valid25) {
                                                                                    validate298.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rulesStartColumn',
                                                                                            schemaPath: '#/properties/rulesStartColumn/not',
                                                                                            keyword: 'not',
                                                                                            params: {},
                                                                                            message: 'must NOT be valid'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    errors = _errs81;
                                                                                    if (vErrors !== null) {
                                                                                        if (_errs81) {
                                                                                            vErrors.length = _errs81;
                                                                                        }
                                                                                        else {
                                                                                            vErrors = null;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (errors === _errs79) {
                                                                                    if (typeof data22 === 'string') {
                                                                                        if (func2(data22) < 1) {
                                                                                            validate298.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesStartColumn',
                                                                                                    schemaPath: '#/properties/rulesStartColumn/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate298.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rulesStartColumn',
                                                                                                schemaPath: '#/properties/rulesStartColumn/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid10 = _errs79 === errors;
                                                                            }
                                                                            else {
                                                                                var valid10 = true;
                                                                            }
                                                                            if (valid10) {
                                                                                if (data.rulesEndColumn !== undefined) {
                                                                                    let data23 = data.rulesEndColumn;
                                                                                    const _errs83 = errors;
                                                                                    const _errs85 = errors;
                                                                                    const _errs86 = errors;
                                                                                    const vSchema7 = data && data.rulesDefColumn;
                                                                                    if (vSchema7 !== undefined && !func0(data23, vSchema7)) {
                                                                                        const err17 = {};
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err17];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err17);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                    var valid26 = _errs86 === errors;
                                                                                    if (valid26) {
                                                                                        validate298.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rulesEndColumn',
                                                                                                schemaPath: '#/properties/rulesEndColumn/not',
                                                                                                keyword: 'not',
                                                                                                params: {},
                                                                                                message: 'must NOT be valid'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        errors = _errs85;
                                                                                        if (vErrors !== null) {
                                                                                            if (_errs85) {
                                                                                                vErrors.length = _errs85;
                                                                                            }
                                                                                            else {
                                                                                                vErrors = null;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    if (errors === _errs83) {
                                                                                        if (typeof data23 === 'string') {
                                                                                            if (func2(data23) < 1) {
                                                                                                validate298.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesEndColumn',
                                                                                                        schemaPath: '#/properties/rulesEndColumn/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate298.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesEndColumn',
                                                                                                    schemaPath: '#/properties/rulesEndColumn/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid10 = _errs83 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid10 = true;
                                                                                }
                                                                                if (valid10) {
                                                                                    if (data.rulesDecodeMethod !== undefined) {
                                                                                        let data24 = data.rulesDecodeMethod;
                                                                                        const _errs87 = errors;
                                                                                        if (typeof data24 !== 'string') {
                                                                                            validate298.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesDecodeMethod',
                                                                                                    schemaPath: '#/properties/rulesDecodeMethod/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        if (!(data24 === 'text' || data24 === 'json')) {
                                                                                            validate298.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesDecodeMethod',
                                                                                                    schemaPath: '#/properties/rulesDecodeMethod/enum',
                                                                                                    keyword: 'enum',
                                                                                                    params: {
                                                                                                        allowedValues: schema407.properties.rulesDecodeMethod.enum
                                                                                                    },
                                                                                                    message: 'must be equal to one of the allowed values'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid10 = _errs87 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid10 = true;
                                                                                    }
                                                                                    if (valid10) {
                                                                                        if (data.rulesMultiValues !== undefined) {
                                                                                            const _errs89 = errors;
                                                                                            if (typeof data.rulesMultiValues !== 'boolean') {
                                                                                                validate298.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesMultiValues',
                                                                                                        schemaPath: '#/properties/rulesMultiValues/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'boolean' },
                                                                                                        message: 'must be boolean'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid10 = _errs89 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid10 = true;
                                                                                        }
                                                                                        if (valid10) {
                                                                                            if (data.rulesSplitColumn !== undefined) {
                                                                                                let data26 = data.rulesSplitColumn;
                                                                                                const _errs91 = errors;
                                                                                                if (errors === _errs91) {
                                                                                                    if (typeof data26 === 'string') {
                                                                                                        if (func2(data26) < 1) {
                                                                                                            validate298.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rulesSplitColumn',
                                                                                                                    schemaPath: '#/properties/rulesSplitColumn/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate298.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rulesSplitColumn',
                                                                                                                schemaPath: '#/properties/rulesSplitColumn/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid10 = _errs91 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid10 = true;
                                                                                            }
                                                                                            if (valid10) {
                                                                                                if (data.outputUnmapped !== undefined) {
                                                                                                    const _errs93 = errors;
                                                                                                    if (typeof data.outputUnmapped !== 'boolean') {
                                                                                                        validate298.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/outputUnmapped',
                                                                                                                schemaPath: '#/properties/outputUnmapped/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'boolean' },
                                                                                                                message: 'must be boolean'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid10 = _errs93 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid10 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate298.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate298.errors = vErrors;
    return errors === 0;
}
export const ruleMapperV2ConfigSchemaValidation = validate300;
const schema408 = {
    $id: 'urn:wisepipe-common-pipe:RuleMapperV2Config',
    type: 'object',
    properties: {
        dataOutputColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            minItems: 1,
            maxItems: 100,
            uniqueItems: true
        },
        dataDateColumn: { type: 'string', minLength: 1 },
        dataLeavesOnly: { type: 'boolean' },
        hierarchiesSourceColumn: { type: 'string', minLength: 1 },
        hierarchiesIDColumn: { type: 'string', minLength: 1 },
        hierarchiesParentColumn: { type: 'string', minLength: 1 },
        hierarchiesParentByValue: { type: 'boolean' },
        hierarchiesValueColumn: { type: 'string', minLength: 1 },
        hierarchiesStartColumn: {
            type: 'string',
            minLength: 1,
            allOf: [
                { not: { const: { $data: '1/hierarchiesSourceColumn' } } },
                { not: { const: { $data: '1/hierarchiesIDColumn' } } }
            ]
        },
        hierarchiesEndColumn: {
            type: 'string',
            minLength: 1,
            allOf: [
                { not: { const: { $data: '1/hierarchiesSourceColumn' } } },
                { not: { const: { $data: '1/hierarchiesIDColumn' } } }
            ]
        },
        hierarchiesAttributeColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            maxItems: 100,
            uniqueItems: true
        },
        rulesOutputColumns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            minItems: 1,
            maxItems: 100,
            uniqueItems: true
        },
        rulesDefColumn: { type: 'string', minLength: 1 },
        rulesValueColumn: { type: 'string', minLength: 1 },
        rulesPrecedenceColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name'],
            maxItems: 10
        },
        rulesStartColumn: { type: 'string', minLength: 1, not: { const: { $data: '1/rulesDefColumn' } } },
        rulesEndColumn: { type: 'string', minLength: 1, not: { const: { $data: '1/rulesDefColumn' } } },
        rulesDecodeMethod: { type: 'string', enum: ['text', 'json'] },
        rulesMultiValues: { type: 'boolean' },
        rulesSplitColumn: { type: 'string', minLength: 1 },
        outputUnmapped: { type: 'boolean' }
    },
    required: [
        'dataOutputColumns',
        'hierarchiesSourceColumn',
        'hierarchiesIDColumn',
        'hierarchiesParentColumn',
        'hierarchiesParentByValue',
        'hierarchiesValueColumn',
        'rulesOutputColumns',
        'rulesDefColumn',
        'rulesValueColumn',
        'rulesPrecedenceColumns'
    ],
    allOf: [
        { if: { required: ['rulesStartColumn'] }, then: { required: ['rulesEndColumn', 'dataDateColumn'] } },
        { if: { required: ['rulesEndColumn'] }, then: { required: ['rulesStartColumn', 'dataDateColumn'] } },
        { if: { required: ['hierarchiesStartColumn'] }, then: { required: ['hierarchiesEndColumn', 'dataDateColumn'] } },
        { if: { required: ['hierarchiesEndColumn'] }, then: { required: ['hierarchiesStartColumn', 'dataDateColumn'] } },
        {
            if: { properties: { rulesMultiValues: { const: true } } },
            then: {
                properties: {
                    rulesStartColumn: { type: 'string', not: { const: { $data: '1/rulesValueColumn' } } },
                    rulesEndColumn: { type: 'string', not: { const: { $data: '1/rulesValueColumn' } } }
                }
            }
        }
    ]
};
const func637 = ajvEqual;
function validate300(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RuleMapperV2Config" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.rulesStartColumn === undefined && (missing0 = 'rulesStartColumn')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.rulesEndColumn === undefined && (missing1 = 'rulesEndColumn')) ||
                (data.dataDateColumn === undefined && (missing1 = 'dataDateColumn'))) {
                validate300.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate300.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs5 = errors;
        const _errs6 = errors;
        let valid2 = true;
        const _errs7 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.rulesEndColumn === undefined && (missing2 = 'rulesEndColumn')) {
                const err2 = {};
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        var _valid1 = _errs7 === errors;
        errors = _errs6;
        if (vErrors !== null) {
            if (_errs6) {
                vErrors.length = _errs6;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs8 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing3;
                if ((data.rulesStartColumn === undefined && (missing3 = 'rulesStartColumn')) ||
                    (data.dataDateColumn === undefined && (missing3 = 'dataDateColumn'))) {
                    validate300.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing3 },
                            message: "must have required property '" + missing3 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs8 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate300.errors = vErrors;
            return false;
        }
        var valid0 = _errs5 === errors;
        if (valid0) {
            const _errs9 = errors;
            const _errs10 = errors;
            let valid3 = true;
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing4;
                if (data.hierarchiesStartColumn === undefined && (missing4 = 'hierarchiesStartColumn')) {
                    const err4 = {};
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            var _valid2 = _errs11 === errors;
            errors = _errs10;
            if (vErrors !== null) {
                if (_errs10) {
                    vErrors.length = _errs10;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs12 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing5;
                    if ((data.hierarchiesEndColumn === undefined && (missing5 = 'hierarchiesEndColumn')) ||
                        (data.dataDateColumn === undefined && (missing5 = 'dataDateColumn'))) {
                        validate300.errors = [
                            {
                                instancePath,
                                schemaPath: '#/allOf/2/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing5 },
                                message: "must have required property '" + missing5 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs12 === errors;
                valid3 = _valid2;
            }
            if (!valid3) {
                const err5 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
                validate300.errors = vErrors;
                return false;
            }
            var valid0 = _errs9 === errors;
            if (valid0) {
                const _errs13 = errors;
                const _errs14 = errors;
                let valid4 = true;
                const _errs15 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing6;
                    if (data.hierarchiesEndColumn === undefined && (missing6 = 'hierarchiesEndColumn')) {
                        const err6 = {};
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                }
                var _valid3 = _errs15 === errors;
                errors = _errs14;
                if (vErrors !== null) {
                    if (_errs14) {
                        vErrors.length = _errs14;
                    }
                    else {
                        vErrors = null;
                    }
                }
                if (_valid3) {
                    const _errs16 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing7;
                        if ((data.hierarchiesStartColumn === undefined && (missing7 = 'hierarchiesStartColumn')) ||
                            (data.dataDateColumn === undefined && (missing7 = 'dataDateColumn'))) {
                            validate300.errors = [
                                {
                                    instancePath,
                                    schemaPath: '#/allOf/3/then/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing7 },
                                    message: "must have required property '" + missing7 + "'"
                                }
                            ];
                            return false;
                        }
                    }
                    var _valid3 = _errs16 === errors;
                    valid4 = _valid3;
                }
                if (!valid4) {
                    const err7 = {
                        instancePath,
                        schemaPath: '#/allOf/3/if',
                        keyword: 'if',
                        params: { failingKeyword: 'then' },
                        message: 'must match "then" schema'
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                    validate300.errors = vErrors;
                    return false;
                }
                var valid0 = _errs13 === errors;
                if (valid0) {
                    const _errs17 = errors;
                    const _errs18 = errors;
                    let valid5 = true;
                    const _errs19 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        if (data.rulesMultiValues !== undefined) {
                            if (true !== data.rulesMultiValues) {
                                const err8 = {};
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                    }
                    var _valid4 = _errs19 === errors;
                    errors = _errs18;
                    if (vErrors !== null) {
                        if (_errs18) {
                            vErrors.length = _errs18;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                    if (_valid4) {
                        const _errs21 = errors;
                        if (data && typeof data == 'object' && !Array.isArray(data)) {
                            if (data.rulesStartColumn !== undefined) {
                                let data1 = data.rulesStartColumn;
                                const _errs22 = errors;
                                if (typeof data1 !== 'string') {
                                    validate300.errors = [
                                        {
                                            instancePath: instancePath + '/rulesStartColumn',
                                            schemaPath: '#/allOf/4/then/properties/rulesStartColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                const _errs24 = errors;
                                const _errs25 = errors;
                                const vSchema0 = data && data.rulesValueColumn;
                                if (vSchema0 !== undefined && !func0(data1, vSchema0)) {
                                    const err9 = {};
                                    if (vErrors === null) {
                                        vErrors = [err9];
                                    }
                                    else {
                                        vErrors.push(err9);
                                    }
                                    errors++;
                                }
                                var valid8 = _errs25 === errors;
                                if (valid8) {
                                    validate300.errors = [
                                        {
                                            instancePath: instancePath + '/rulesStartColumn',
                                            schemaPath: '#/allOf/4/then/properties/rulesStartColumn/not',
                                            keyword: 'not',
                                            params: {},
                                            message: 'must NOT be valid'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    errors = _errs24;
                                    if (vErrors !== null) {
                                        if (_errs24) {
                                            vErrors.length = _errs24;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid7 = _errs22 === errors;
                            }
                            else {
                                var valid7 = true;
                            }
                            if (valid7) {
                                if (data.rulesEndColumn !== undefined) {
                                    let data2 = data.rulesEndColumn;
                                    const _errs26 = errors;
                                    if (typeof data2 !== 'string') {
                                        validate300.errors = [
                                            {
                                                instancePath: instancePath + '/rulesEndColumn',
                                                schemaPath: '#/allOf/4/then/properties/rulesEndColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    const _errs28 = errors;
                                    const _errs29 = errors;
                                    const vSchema1 = data && data.rulesValueColumn;
                                    if (vSchema1 !== undefined && !func0(data2, vSchema1)) {
                                        const err10 = {};
                                        if (vErrors === null) {
                                            vErrors = [err10];
                                        }
                                        else {
                                            vErrors.push(err10);
                                        }
                                        errors++;
                                    }
                                    var valid9 = _errs29 === errors;
                                    if (valid9) {
                                        validate300.errors = [
                                            {
                                                instancePath: instancePath + '/rulesEndColumn',
                                                schemaPath: '#/allOf/4/then/properties/rulesEndColumn/not',
                                                keyword: 'not',
                                                params: {},
                                                message: 'must NOT be valid'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        errors = _errs28;
                                        if (vErrors !== null) {
                                            if (_errs28) {
                                                vErrors.length = _errs28;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid7 = _errs26 === errors;
                                }
                                else {
                                    var valid7 = true;
                                }
                            }
                        }
                        var _valid4 = _errs21 === errors;
                        valid5 = _valid4;
                    }
                    if (!valid5) {
                        const err11 = {
                            instancePath,
                            schemaPath: '#/allOf/4/if',
                            keyword: 'if',
                            params: { failingKeyword: 'then' },
                            message: 'must match "then" schema'
                        };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                        validate300.errors = vErrors;
                        return false;
                    }
                    var valid0 = _errs17 === errors;
                }
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing8;
            if ((data.dataOutputColumns === undefined && (missing8 = 'dataOutputColumns')) ||
                (data.hierarchiesSourceColumn === undefined && (missing8 = 'hierarchiesSourceColumn')) ||
                (data.hierarchiesIDColumn === undefined && (missing8 = 'hierarchiesIDColumn')) ||
                (data.hierarchiesParentColumn === undefined && (missing8 = 'hierarchiesParentColumn')) ||
                (data.hierarchiesParentByValue === undefined && (missing8 = 'hierarchiesParentByValue')) ||
                (data.hierarchiesValueColumn === undefined && (missing8 = 'hierarchiesValueColumn')) ||
                (data.rulesOutputColumns === undefined && (missing8 = 'rulesOutputColumns')) ||
                (data.rulesDefColumn === undefined && (missing8 = 'rulesDefColumn')) ||
                (data.rulesValueColumn === undefined && (missing8 = 'rulesValueColumn')) ||
                (data.rulesPrecedenceColumns === undefined && (missing8 = 'rulesPrecedenceColumns'))) {
                validate300.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing8 },
                        message: "must have required property '" + missing8 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dataOutputColumns !== undefined) {
                    let data3 = data.dataOutputColumns;
                    const _errs30 = errors;
                    if (errors === _errs30) {
                        if (Array.isArray(data3)) {
                            if (data3.length > 100) {
                                validate300.errors = [
                                    {
                                        instancePath: instancePath + '/dataOutputColumns',
                                        schemaPath: '#/properties/dataOutputColumns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 100 },
                                        message: 'must NOT have more than 100 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data3.length < 1) {
                                    validate300.errors = [
                                        {
                                            instancePath: instancePath + '/dataOutputColumns',
                                            schemaPath: '#/properties/dataOutputColumns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid11 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data4 = data3[i0];
                                        const _errs32 = errors;
                                        if (errors === _errs32) {
                                            if (typeof data4 === 'string') {
                                                if (func2(data4) < 1) {
                                                    validate300.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataOutputColumns/' + i0,
                                                            schemaPath: '#/properties/dataOutputColumns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate300.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataOutputColumns/' + i0,
                                                        schemaPath: '#/properties/dataOutputColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid11 = _errs32 === errors;
                                        if (!valid11) {
                                            break;
                                        }
                                    }
                                    if (valid11) {
                                        let i1 = data3.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data3[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate300.errors = [
                                                        {
                                                            instancePath: instancePath + '/dataOutputColumns',
                                                            schemaPath: '#/properties/dataOutputColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate300.errors = [
                                {
                                    instancePath: instancePath + '/dataOutputColumns',
                                    schemaPath: '#/properties/dataOutputColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid10 = _errs30 === errors;
                }
                else {
                    var valid10 = true;
                }
                if (valid10) {
                    if (data.dataDateColumn !== undefined) {
                        let data5 = data.dataDateColumn;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data5 === 'string') {
                                if (func2(data5) < 1) {
                                    validate300.errors = [
                                        {
                                            instancePath: instancePath + '/dataDateColumn',
                                            schemaPath: '#/properties/dataDateColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate300.errors = [
                                    {
                                        instancePath: instancePath + '/dataDateColumn',
                                        schemaPath: '#/properties/dataDateColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid10 = _errs34 === errors;
                    }
                    else {
                        var valid10 = true;
                    }
                    if (valid10) {
                        if (data.dataLeavesOnly !== undefined) {
                            const _errs36 = errors;
                            if (typeof data.dataLeavesOnly !== 'boolean') {
                                validate300.errors = [
                                    {
                                        instancePath: instancePath + '/dataLeavesOnly',
                                        schemaPath: '#/properties/dataLeavesOnly/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid10 = _errs36 === errors;
                        }
                        else {
                            var valid10 = true;
                        }
                        if (valid10) {
                            if (data.hierarchiesSourceColumn !== undefined) {
                                let data7 = data.hierarchiesSourceColumn;
                                const _errs38 = errors;
                                if (errors === _errs38) {
                                    if (typeof data7 === 'string') {
                                        if (func2(data7) < 1) {
                                            validate300.errors = [
                                                {
                                                    instancePath: instancePath + '/hierarchiesSourceColumn',
                                                    schemaPath: '#/properties/hierarchiesSourceColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate300.errors = [
                                            {
                                                instancePath: instancePath + '/hierarchiesSourceColumn',
                                                schemaPath: '#/properties/hierarchiesSourceColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid10 = _errs38 === errors;
                            }
                            else {
                                var valid10 = true;
                            }
                            if (valid10) {
                                if (data.hierarchiesIDColumn !== undefined) {
                                    let data8 = data.hierarchiesIDColumn;
                                    const _errs40 = errors;
                                    if (errors === _errs40) {
                                        if (typeof data8 === 'string') {
                                            if (func2(data8) < 1) {
                                                validate300.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchiesIDColumn',
                                                        schemaPath: '#/properties/hierarchiesIDColumn/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate300.errors = [
                                                {
                                                    instancePath: instancePath + '/hierarchiesIDColumn',
                                                    schemaPath: '#/properties/hierarchiesIDColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs40 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data.hierarchiesParentColumn !== undefined) {
                                        let data9 = data.hierarchiesParentColumn;
                                        const _errs42 = errors;
                                        if (errors === _errs42) {
                                            if (typeof data9 === 'string') {
                                                if (func2(data9) < 1) {
                                                    validate300.errors = [
                                                        {
                                                            instancePath: instancePath + '/hierarchiesParentColumn',
                                                            schemaPath: '#/properties/hierarchiesParentColumn/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate300.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchiesParentColumn',
                                                        schemaPath: '#/properties/hierarchiesParentColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs42 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                    if (valid10) {
                                        if (data.hierarchiesParentByValue !== undefined) {
                                            const _errs44 = errors;
                                            if (typeof data.hierarchiesParentByValue !== 'boolean') {
                                                validate300.errors = [
                                                    {
                                                        instancePath: instancePath + '/hierarchiesParentByValue',
                                                        schemaPath: '#/properties/hierarchiesParentByValue/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid10 = _errs44 === errors;
                                        }
                                        else {
                                            var valid10 = true;
                                        }
                                        if (valid10) {
                                            if (data.hierarchiesValueColumn !== undefined) {
                                                let data11 = data.hierarchiesValueColumn;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data11 === 'string') {
                                                        if (func2(data11) < 1) {
                                                            validate300.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesValueColumn',
                                                                    schemaPath: '#/properties/hierarchiesValueColumn/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate300.errors = [
                                                            {
                                                                instancePath: instancePath + '/hierarchiesValueColumn',
                                                                schemaPath: '#/properties/hierarchiesValueColumn/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid10 = _errs46 === errors;
                                            }
                                            else {
                                                var valid10 = true;
                                            }
                                            if (valid10) {
                                                if (data.hierarchiesStartColumn !== undefined) {
                                                    let data12 = data.hierarchiesStartColumn;
                                                    const _errs48 = errors;
                                                    const _errs50 = errors;
                                                    const _errs51 = errors;
                                                    const _errs52 = errors;
                                                    const vSchema2 = data && data.hierarchiesSourceColumn;
                                                    if (vSchema2 !== undefined && !func0(data12, vSchema2)) {
                                                        const err12 = {};
                                                        if (vErrors === null) {
                                                            vErrors = [err12];
                                                        }
                                                        else {
                                                            vErrors.push(err12);
                                                        }
                                                        errors++;
                                                    }
                                                    var valid14 = _errs52 === errors;
                                                    if (valid14) {
                                                        validate300.errors = [
                                                            {
                                                                instancePath: instancePath + '/hierarchiesStartColumn',
                                                                schemaPath: '#/properties/hierarchiesStartColumn/allOf/0/not',
                                                                keyword: 'not',
                                                                params: {},
                                                                message: 'must NOT be valid'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        errors = _errs51;
                                                        if (vErrors !== null) {
                                                            if (_errs51) {
                                                                vErrors.length = _errs51;
                                                            }
                                                            else {
                                                                vErrors = null;
                                                            }
                                                        }
                                                    }
                                                    var valid13 = _errs50 === errors;
                                                    if (valid13) {
                                                        const _errs53 = errors;
                                                        const _errs54 = errors;
                                                        const _errs55 = errors;
                                                        const vSchema3 = data && data.hierarchiesIDColumn;
                                                        if (vSchema3 !== undefined && !func0(data12, vSchema3)) {
                                                            const err13 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err13];
                                                            }
                                                            else {
                                                                vErrors.push(err13);
                                                            }
                                                            errors++;
                                                        }
                                                        var valid15 = _errs55 === errors;
                                                        if (valid15) {
                                                            validate300.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesStartColumn',
                                                                    schemaPath: '#/properties/hierarchiesStartColumn/allOf/1/not',
                                                                    keyword: 'not',
                                                                    params: {},
                                                                    message: 'must NOT be valid'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            errors = _errs54;
                                                            if (vErrors !== null) {
                                                                if (_errs54) {
                                                                    vErrors.length = _errs54;
                                                                }
                                                                else {
                                                                    vErrors = null;
                                                                }
                                                            }
                                                        }
                                                        var valid13 = _errs53 === errors;
                                                    }
                                                    if (errors === _errs48) {
                                                        if (typeof data12 === 'string') {
                                                            if (func2(data12) < 1) {
                                                                validate300.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchiesStartColumn',
                                                                        schemaPath: '#/properties/hierarchiesStartColumn/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate300.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesStartColumn',
                                                                    schemaPath: '#/properties/hierarchiesStartColumn/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid10 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid10 = true;
                                                }
                                                if (valid10) {
                                                    if (data.hierarchiesEndColumn !== undefined) {
                                                        let data13 = data.hierarchiesEndColumn;
                                                        const _errs56 = errors;
                                                        const _errs58 = errors;
                                                        const _errs59 = errors;
                                                        const _errs60 = errors;
                                                        const vSchema4 = data && data.hierarchiesSourceColumn;
                                                        if (vSchema4 !== undefined && !func0(data13, vSchema4)) {
                                                            const err14 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err14];
                                                            }
                                                            else {
                                                                vErrors.push(err14);
                                                            }
                                                            errors++;
                                                        }
                                                        var valid17 = _errs60 === errors;
                                                        if (valid17) {
                                                            validate300.errors = [
                                                                {
                                                                    instancePath: instancePath + '/hierarchiesEndColumn',
                                                                    schemaPath: '#/properties/hierarchiesEndColumn/allOf/0/not',
                                                                    keyword: 'not',
                                                                    params: {},
                                                                    message: 'must NOT be valid'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            errors = _errs59;
                                                            if (vErrors !== null) {
                                                                if (_errs59) {
                                                                    vErrors.length = _errs59;
                                                                }
                                                                else {
                                                                    vErrors = null;
                                                                }
                                                            }
                                                        }
                                                        var valid16 = _errs58 === errors;
                                                        if (valid16) {
                                                            const _errs61 = errors;
                                                            const _errs62 = errors;
                                                            const _errs63 = errors;
                                                            const vSchema5 = data && data.hierarchiesIDColumn;
                                                            if (vSchema5 !== undefined && !func0(data13, vSchema5)) {
                                                                const err15 = {};
                                                                if (vErrors === null) {
                                                                    vErrors = [err15];
                                                                }
                                                                else {
                                                                    vErrors.push(err15);
                                                                }
                                                                errors++;
                                                            }
                                                            var valid18 = _errs63 === errors;
                                                            if (valid18) {
                                                                validate300.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchiesEndColumn',
                                                                        schemaPath: '#/properties/hierarchiesEndColumn/allOf/1/not',
                                                                        keyword: 'not',
                                                                        params: {},
                                                                        message: 'must NOT be valid'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                errors = _errs62;
                                                                if (vErrors !== null) {
                                                                    if (_errs62) {
                                                                        vErrors.length = _errs62;
                                                                    }
                                                                    else {
                                                                        vErrors = null;
                                                                    }
                                                                }
                                                            }
                                                            var valid16 = _errs61 === errors;
                                                        }
                                                        if (errors === _errs56) {
                                                            if (typeof data13 === 'string') {
                                                                if (func2(data13) < 1) {
                                                                    validate300.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hierarchiesEndColumn',
                                                                            schemaPath: '#/properties/hierarchiesEndColumn/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate300.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hierarchiesEndColumn',
                                                                        schemaPath: '#/properties/hierarchiesEndColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid10 = _errs56 === errors;
                                                    }
                                                    else {
                                                        var valid10 = true;
                                                    }
                                                    if (valid10) {
                                                        if (data.hierarchiesAttributeColumns !== undefined) {
                                                            let data14 = data.hierarchiesAttributeColumns;
                                                            const _errs64 = errors;
                                                            if (errors === _errs64) {
                                                                if (Array.isArray(data14)) {
                                                                    if (data14.length > 100) {
                                                                        validate300.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/hierarchiesAttributeColumns',
                                                                                schemaPath: '#/properties/hierarchiesAttributeColumns/maxItems',
                                                                                keyword: 'maxItems',
                                                                                params: { limit: 100 },
                                                                                message: 'must NOT have more than 100 items'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        var valid19 = true;
                                                                        const len1 = data14.length;
                                                                        for (let i2 = 0; i2 < len1; i2++) {
                                                                            let data15 = data14[i2];
                                                                            const _errs66 = errors;
                                                                            if (errors === _errs66) {
                                                                                if (typeof data15 === 'string') {
                                                                                    if (func2(data15) < 1) {
                                                                                        validate300.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/hierarchiesAttributeColumns/' + i2,
                                                                                                schemaPath: '#/properties/hierarchiesAttributeColumns/items/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate300.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/hierarchiesAttributeColumns/' + i2,
                                                                                            schemaPath: '#/properties/hierarchiesAttributeColumns/items/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid19 = _errs66 === errors;
                                                                            if (!valid19) {
                                                                                break;
                                                                            }
                                                                        }
                                                                        if (valid19) {
                                                                            let i3 = data14.length;
                                                                            let j1;
                                                                            if (i3 > 1) {
                                                                                const indices1 = {};
                                                                                for (; i3--;) {
                                                                                    let item1 = data14[i3];
                                                                                    if (typeof item1 !== 'string') {
                                                                                        continue;
                                                                                    }
                                                                                    if (typeof indices1[item1] == 'number') {
                                                                                        j1 = indices1[item1];
                                                                                        validate300.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/hierarchiesAttributeColumns',
                                                                                                schemaPath: '#/properties/hierarchiesAttributeColumns/uniqueItems',
                                                                                                keyword: 'uniqueItems',
                                                                                                params: { i: i3, j: j1 },
                                                                                                message: 'must NOT have duplicate items (items ## ' +
                                                                                                    j1 +
                                                                                                    ' and ' +
                                                                                                    i3 +
                                                                                                    ' are identical)'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                        break;
                                                                                    }
                                                                                    indices1[item1] = i3;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate300.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hierarchiesAttributeColumns',
                                                                            schemaPath: '#/properties/hierarchiesAttributeColumns/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'array' },
                                                                            message: 'must be array'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid10 = _errs64 === errors;
                                                        }
                                                        else {
                                                            var valid10 = true;
                                                        }
                                                        if (valid10) {
                                                            if (data.rulesOutputColumns !== undefined) {
                                                                let data16 = data.rulesOutputColumns;
                                                                const _errs68 = errors;
                                                                if (errors === _errs68) {
                                                                    if (Array.isArray(data16)) {
                                                                        if (data16.length > 100) {
                                                                            validate300.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/rulesOutputColumns',
                                                                                    schemaPath: '#/properties/rulesOutputColumns/maxItems',
                                                                                    keyword: 'maxItems',
                                                                                    params: { limit: 100 },
                                                                                    message: 'must NOT have more than 100 items'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            if (data16.length < 1) {
                                                                                validate300.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rulesOutputColumns',
                                                                                        schemaPath: '#/properties/rulesOutputColumns/minItems',
                                                                                        keyword: 'minItems',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 items'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                var valid21 = true;
                                                                                const len2 = data16.length;
                                                                                for (let i4 = 0; i4 < len2; i4++) {
                                                                                    let data17 = data16[i4];
                                                                                    const _errs70 = errors;
                                                                                    if (errors === _errs70) {
                                                                                        if (typeof data17 === 'string') {
                                                                                            if (func2(data17) < 1) {
                                                                                                validate300.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesOutputColumns/' + i4,
                                                                                                        schemaPath: '#/properties/rulesOutputColumns/items/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate300.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesOutputColumns/' + i4,
                                                                                                    schemaPath: '#/properties/rulesOutputColumns/items/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid21 = _errs70 === errors;
                                                                                    if (!valid21) {
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (valid21) {
                                                                                    let i5 = data16.length;
                                                                                    let j2;
                                                                                    if (i5 > 1) {
                                                                                        const indices2 = {};
                                                                                        for (; i5--;) {
                                                                                            let item2 = data16[i5];
                                                                                            if (typeof item2 !== 'string') {
                                                                                                continue;
                                                                                            }
                                                                                            if (typeof indices2[item2] == 'number') {
                                                                                                j2 = indices2[item2];
                                                                                                validate300.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesOutputColumns',
                                                                                                        schemaPath: '#/properties/rulesOutputColumns/uniqueItems',
                                                                                                        keyword: 'uniqueItems',
                                                                                                        params: { i: i5, j: j2 },
                                                                                                        message: 'must NOT have duplicate items (items ## ' +
                                                                                                            j2 +
                                                                                                            ' and ' +
                                                                                                            i5 +
                                                                                                            ' are identical)'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                                break;
                                                                                            }
                                                                                            indices2[item2] = i5;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate300.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/rulesOutputColumns',
                                                                                schemaPath: '#/properties/rulesOutputColumns/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'array' },
                                                                                message: 'must be array'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid10 = _errs68 === errors;
                                                            }
                                                            else {
                                                                var valid10 = true;
                                                            }
                                                            if (valid10) {
                                                                if (data.rulesDefColumn !== undefined) {
                                                                    let data18 = data.rulesDefColumn;
                                                                    const _errs72 = errors;
                                                                    if (errors === _errs72) {
                                                                        if (typeof data18 === 'string') {
                                                                            if (func2(data18) < 1) {
                                                                                validate300.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rulesDefColumn',
                                                                                        schemaPath: '#/properties/rulesDefColumn/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate300.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/rulesDefColumn',
                                                                                    schemaPath: '#/properties/rulesDefColumn/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid10 = _errs72 === errors;
                                                                }
                                                                else {
                                                                    var valid10 = true;
                                                                }
                                                                if (valid10) {
                                                                    if (data.rulesValueColumn !== undefined) {
                                                                        let data19 = data.rulesValueColumn;
                                                                        const _errs74 = errors;
                                                                        if (errors === _errs74) {
                                                                            if (typeof data19 === 'string') {
                                                                                if (func2(data19) < 1) {
                                                                                    validate300.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rulesValueColumn',
                                                                                            schemaPath: '#/properties/rulesValueColumn/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate300.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/rulesValueColumn',
                                                                                        schemaPath: '#/properties/rulesValueColumn/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid10 = _errs74 === errors;
                                                                    }
                                                                    else {
                                                                        var valid10 = true;
                                                                    }
                                                                    if (valid10) {
                                                                        if (data.rulesPrecedenceColumns !== undefined) {
                                                                            let data20 = data.rulesPrecedenceColumns;
                                                                            const _errs76 = errors;
                                                                            if (errors === _errs76) {
                                                                                if (Array.isArray(data20)) {
                                                                                    if (data20.length > 10) {
                                                                                        validate300.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rulesPrecedenceColumns',
                                                                                                schemaPath: '#/properties/rulesPrecedenceColumns/maxItems',
                                                                                                keyword: 'maxItems',
                                                                                                params: { limit: 10 },
                                                                                                message: 'must NOT have more than 10 items'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        var valid23 = true;
                                                                                        const len3 = data20.length;
                                                                                        for (let i6 = 0; i6 < len3; i6++) {
                                                                                            const _errs78 = errors;
                                                                                            if (!validate219(data20[i6], {
                                                                                                instancePath: instancePath + '/rulesPrecedenceColumns/' + i6,
                                                                                                parentData: data20,
                                                                                                parentDataProperty: i6,
                                                                                                rootData
                                                                                            })) {
                                                                                                vErrors =
                                                                                                    vErrors === null
                                                                                                        ? validate219.errors
                                                                                                        : vErrors.concat(validate219.errors);
                                                                                                errors = vErrors.length;
                                                                                            }
                                                                                            var valid23 = _errs78 === errors;
                                                                                            if (!valid23) {
                                                                                                break;
                                                                                            }
                                                                                        }
                                                                                        if (valid23) {
                                                                                            const keys0 = schema408.properties.rulesPrecedenceColumns.uniqueItemProperties;
                                                                                            let k0;
                                                                                            let i7 = data20.length;
                                                                                            let j3;
                                                                                            if (i7 > 1) {
                                                                                                outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                                                                    let key0 = keys0[k0];
                                                                                                    for (i7 = data20.length; i7--;) {
                                                                                                        let x0 = data20[i7];
                                                                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                                                                            continue;
                                                                                                        }
                                                                                                        for (j3 = i7; j3--;) {
                                                                                                            let y0 = data20[j3];
                                                                                                            if (y0 &&
                                                                                                                typeof y0 == 'object' &&
                                                                                                                !Array.isArray(y0) &&
                                                                                                                func637(x0[key0], y0[key0])) {
                                                                                                                validate300.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/rulesPrecedenceColumns',
                                                                                                                        schemaPath: '#/properties/rulesPrecedenceColumns/uniqueItemProperties',
                                                                                                                        keyword: 'uniqueItemProperties',
                                                                                                                        params: {},
                                                                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                                break outer0;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate300.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rulesPrecedenceColumns',
                                                                                            schemaPath: '#/properties/rulesPrecedenceColumns/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'array' },
                                                                                            message: 'must be array'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid10 = _errs76 === errors;
                                                                        }
                                                                        else {
                                                                            var valid10 = true;
                                                                        }
                                                                        if (valid10) {
                                                                            if (data.rulesStartColumn !== undefined) {
                                                                                let data22 = data.rulesStartColumn;
                                                                                const _errs79 = errors;
                                                                                const _errs81 = errors;
                                                                                const _errs82 = errors;
                                                                                const vSchema6 = data && data.rulesDefColumn;
                                                                                if (vSchema6 !== undefined && !func0(data22, vSchema6)) {
                                                                                    const err16 = {};
                                                                                    if (vErrors === null) {
                                                                                        vErrors = [err16];
                                                                                    }
                                                                                    else {
                                                                                        vErrors.push(err16);
                                                                                    }
                                                                                    errors++;
                                                                                }
                                                                                var valid25 = _errs82 === errors;
                                                                                if (valid25) {
                                                                                    validate300.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/rulesStartColumn',
                                                                                            schemaPath: '#/properties/rulesStartColumn/not',
                                                                                            keyword: 'not',
                                                                                            params: {},
                                                                                            message: 'must NOT be valid'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                else {
                                                                                    errors = _errs81;
                                                                                    if (vErrors !== null) {
                                                                                        if (_errs81) {
                                                                                            vErrors.length = _errs81;
                                                                                        }
                                                                                        else {
                                                                                            vErrors = null;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (errors === _errs79) {
                                                                                    if (typeof data22 === 'string') {
                                                                                        if (func2(data22) < 1) {
                                                                                            validate300.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesStartColumn',
                                                                                                    schemaPath: '#/properties/rulesStartColumn/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate300.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rulesStartColumn',
                                                                                                schemaPath: '#/properties/rulesStartColumn/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid10 = _errs79 === errors;
                                                                            }
                                                                            else {
                                                                                var valid10 = true;
                                                                            }
                                                                            if (valid10) {
                                                                                if (data.rulesEndColumn !== undefined) {
                                                                                    let data23 = data.rulesEndColumn;
                                                                                    const _errs83 = errors;
                                                                                    const _errs85 = errors;
                                                                                    const _errs86 = errors;
                                                                                    const vSchema7 = data && data.rulesDefColumn;
                                                                                    if (vSchema7 !== undefined && !func0(data23, vSchema7)) {
                                                                                        const err17 = {};
                                                                                        if (vErrors === null) {
                                                                                            vErrors = [err17];
                                                                                        }
                                                                                        else {
                                                                                            vErrors.push(err17);
                                                                                        }
                                                                                        errors++;
                                                                                    }
                                                                                    var valid26 = _errs86 === errors;
                                                                                    if (valid26) {
                                                                                        validate300.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/rulesEndColumn',
                                                                                                schemaPath: '#/properties/rulesEndColumn/not',
                                                                                                keyword: 'not',
                                                                                                params: {},
                                                                                                message: 'must NOT be valid'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        errors = _errs85;
                                                                                        if (vErrors !== null) {
                                                                                            if (_errs85) {
                                                                                                vErrors.length = _errs85;
                                                                                            }
                                                                                            else {
                                                                                                vErrors = null;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    if (errors === _errs83) {
                                                                                        if (typeof data23 === 'string') {
                                                                                            if (func2(data23) < 1) {
                                                                                                validate300.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesEndColumn',
                                                                                                        schemaPath: '#/properties/rulesEndColumn/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate300.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesEndColumn',
                                                                                                    schemaPath: '#/properties/rulesEndColumn/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid10 = _errs83 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid10 = true;
                                                                                }
                                                                                if (valid10) {
                                                                                    if (data.rulesDecodeMethod !== undefined) {
                                                                                        let data24 = data.rulesDecodeMethod;
                                                                                        const _errs87 = errors;
                                                                                        if (typeof data24 !== 'string') {
                                                                                            validate300.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesDecodeMethod',
                                                                                                    schemaPath: '#/properties/rulesDecodeMethod/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        if (!(data24 === 'text' || data24 === 'json')) {
                                                                                            validate300.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/rulesDecodeMethod',
                                                                                                    schemaPath: '#/properties/rulesDecodeMethod/enum',
                                                                                                    keyword: 'enum',
                                                                                                    params: {
                                                                                                        allowedValues: schema408.properties.rulesDecodeMethod.enum
                                                                                                    },
                                                                                                    message: 'must be equal to one of the allowed values'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid10 = _errs87 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid10 = true;
                                                                                    }
                                                                                    if (valid10) {
                                                                                        if (data.rulesMultiValues !== undefined) {
                                                                                            const _errs89 = errors;
                                                                                            if (typeof data.rulesMultiValues !== 'boolean') {
                                                                                                validate300.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/rulesMultiValues',
                                                                                                        schemaPath: '#/properties/rulesMultiValues/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'boolean' },
                                                                                                        message: 'must be boolean'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid10 = _errs89 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid10 = true;
                                                                                        }
                                                                                        if (valid10) {
                                                                                            if (data.rulesSplitColumn !== undefined) {
                                                                                                let data26 = data.rulesSplitColumn;
                                                                                                const _errs91 = errors;
                                                                                                if (errors === _errs91) {
                                                                                                    if (typeof data26 === 'string') {
                                                                                                        if (func2(data26) < 1) {
                                                                                                            validate300.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/rulesSplitColumn',
                                                                                                                    schemaPath: '#/properties/rulesSplitColumn/minLength',
                                                                                                                    keyword: 'minLength',
                                                                                                                    params: { limit: 1 },
                                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate300.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/rulesSplitColumn',
                                                                                                                schemaPath: '#/properties/rulesSplitColumn/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid10 = _errs91 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid10 = true;
                                                                                            }
                                                                                            if (valid10) {
                                                                                                if (data.outputUnmapped !== undefined) {
                                                                                                    const _errs93 = errors;
                                                                                                    if (typeof data.outputUnmapped !== 'boolean') {
                                                                                                        validate300.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/outputUnmapped',
                                                                                                                schemaPath: '#/properties/outputUnmapped/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'boolean' },
                                                                                                                message: 'must be boolean'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid10 = _errs93 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid10 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate300.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate300.errors = vErrors;
    return errors === 0;
}
export const runningAverageConfigSchemaValidation = validate302;
const schema409 = {
    $id: 'urn:wisepipe-common-pipe:RunningAverageConfig',
    type: 'object',
    properties: {
        valueColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 1 },
        groupColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        orderColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name'],
            minItems: 1
        }
    },
    required: ['valueColumns', 'groupColumns', 'orderColumns']
};
const func645 = ajvEqual;
function validate302(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RunningAverageConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.valueColumns === undefined && (missing0 = 'valueColumns')) ||
                (data.groupColumns === undefined && (missing0 = 'groupColumns')) ||
                (data.orderColumns === undefined && (missing0 = 'orderColumns'))) {
                validate302.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.valueColumns !== undefined) {
                    let data0 = data.valueColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate302.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumns',
                                        schemaPath: '#/properties/valueColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate302.errors = [
                                                    {
                                                        instancePath: instancePath + '/valueColumns/' + i0,
                                                        schemaPath: '#/properties/valueColumns/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate302.errors = [
                                                {
                                                    instancePath: instancePath + '/valueColumns/' + i0,
                                                    schemaPath: '#/properties/valueColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate302.errors = [
                                                    {
                                                        instancePath: instancePath + '/valueColumns',
                                                        schemaPath: '#/properties/valueColumns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate302.errors = [
                                {
                                    instancePath: instancePath + '/valueColumns',
                                    schemaPath: '#/properties/valueColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupColumns !== undefined) {
                        let data2 = data.groupColumns;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                var valid3 = true;
                                const len1 = data2.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data3 = data2[i2];
                                    const _errs7 = errors;
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (func2(data3) < 1) {
                                                validate302.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupColumns/' + i2,
                                                        schemaPath: '#/properties/groupColumns/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate302.errors = [
                                                {
                                                    instancePath: instancePath + '/groupColumns/' + i2,
                                                    schemaPath: '#/properties/groupColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs7 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                                if (valid3) {
                                    let i3 = data2.length;
                                    let j1;
                                    if (i3 > 1) {
                                        const indices1 = {};
                                        for (; i3--;) {
                                            let item1 = data2[i3];
                                            if (typeof item1 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices1[item1] == 'number') {
                                                j1 = indices1[item1];
                                                validate302.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupColumns',
                                                        schemaPath: '#/properties/groupColumns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i3, j: j1 },
                                                        message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices1[item1] = i3;
                                        }
                                    }
                                }
                            }
                            else {
                                validate302.errors = [
                                    {
                                        instancePath: instancePath + '/groupColumns',
                                        schemaPath: '#/properties/groupColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orderColumns !== undefined) {
                            let data4 = data.orderColumns;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (Array.isArray(data4)) {
                                    if (data4.length < 1) {
                                        validate302.errors = [
                                            {
                                                instancePath: instancePath + '/orderColumns',
                                                schemaPath: '#/properties/orderColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid5 = true;
                                        const len2 = data4.length;
                                        for (let i4 = 0; i4 < len2; i4++) {
                                            const _errs11 = errors;
                                            if (!validate219(data4[i4], {
                                                instancePath: instancePath + '/orderColumns/' + i4,
                                                parentData: data4,
                                                parentDataProperty: i4,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid5 = _errs11 === errors;
                                            if (!valid5) {
                                                break;
                                            }
                                        }
                                        if (valid5) {
                                            const keys0 = schema409.properties.orderColumns.uniqueItemProperties;
                                            let k0;
                                            let i5 = data4.length;
                                            let j2;
                                            if (i5 > 1) {
                                                outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                    let key0 = keys0[k0];
                                                    for (i5 = data4.length; i5--;) {
                                                        let x0 = data4[i5];
                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                            continue;
                                                        }
                                                        for (j2 = i5; j2--;) {
                                                            let y0 = data4[j2];
                                                            if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func645(x0[key0], y0[key0])) {
                                                                validate302.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/orderColumns',
                                                                        schemaPath: '#/properties/orderColumns/uniqueItemProperties',
                                                                        keyword: 'uniqueItemProperties',
                                                                        params: {},
                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate302.errors = [
                                        {
                                            instancePath: instancePath + '/orderColumns',
                                            schemaPath: '#/properties/orderColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs9 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate302.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate302.errors = vErrors;
    return errors === 0;
}
export const runningTotalConfigSchemaValidation = validate304;
const schema410 = {
    $id: 'urn:wisepipe-common-pipe:RunningTotalConfig',
    type: 'object',
    properties: {
        valueColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1 }] },
            uniqueItems: true,
            minItems: 1
        },
        groupColumns: {
            type: 'array',
            items: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1 }] },
            uniqueItems: true
        },
        orderColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name'],
            minItems: 1
        }
    },
    required: ['valueColumns', 'groupColumns', 'orderColumns']
};
const func650 = ajvEqual;
function validate304(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:RunningTotalConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.valueColumns === undefined && (missing0 = 'valueColumns')) ||
                (data.groupColumns === undefined && (missing0 = 'groupColumns')) ||
                (data.orderColumns === undefined && (missing0 = 'orderColumns'))) {
                validate304.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.valueColumns !== undefined) {
                    let data0 = data.valueColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate304.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumns',
                                        schemaPath: '#/properties/valueColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    const _errs4 = errors;
                                    let valid2 = false;
                                    let passing0 = null;
                                    const _errs5 = errors;
                                    const _errs6 = errors;
                                    if (errors === _errs6) {
                                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                            const err0 = {
                                                instancePath: instancePath + '/valueColumns/' + i0,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs5 === errors;
                                    if (_valid0) {
                                        valid2 = true;
                                        passing0 = 0;
                                    }
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                const err1 = {
                                                    instancePath: instancePath + '/valueColumns/' + i0,
                                                    schemaPath: '#/properties/valueColumns/items/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err1];
                                                }
                                                else {
                                                    vErrors.push(err1);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err2 = {
                                                instancePath: instancePath + '/valueColumns/' + i0,
                                                schemaPath: '#/properties/valueColumns/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid0 = _errs8 === errors;
                                    if (_valid0 && valid2) {
                                        valid2 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid2) {
                                        const err3 = {
                                            instancePath: instancePath + '/valueColumns/' + i0,
                                            schemaPath: '#/properties/valueColumns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                        validate304.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs4;
                                        if (vErrors !== null) {
                                            if (_errs4) {
                                                vErrors.length = _errs4;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        outer0: for (; i1--;) {
                                            for (j0 = i1; j0--;) {
                                                if (func0(data0[i1], data0[j0])) {
                                                    validate304.errors = [
                                                        {
                                                            instancePath: instancePath + '/valueColumns',
                                                            schemaPath: '#/properties/valueColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate304.errors = [
                                {
                                    instancePath: instancePath + '/valueColumns',
                                    schemaPath: '#/properties/valueColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.groupColumns !== undefined) {
                        let data2 = data.groupColumns;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                            if (Array.isArray(data2)) {
                                var valid5 = true;
                                const len1 = data2.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data3 = data2[i2];
                                    const _errs12 = errors;
                                    const _errs13 = errors;
                                    let valid6 = false;
                                    let passing1 = null;
                                    const _errs14 = errors;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                            const err4 = {
                                                instancePath: instancePath + '/groupColumns/' + i2,
                                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs14 === errors;
                                    if (_valid1) {
                                        valid6 = true;
                                        passing1 = 0;
                                    }
                                    const _errs17 = errors;
                                    if (errors === _errs17) {
                                        if (typeof data3 === 'string') {
                                            if (func2(data3) < 1) {
                                                const err5 = {
                                                    instancePath: instancePath + '/groupColumns/' + i2,
                                                    schemaPath: '#/properties/groupColumns/items/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err5];
                                                }
                                                else {
                                                    vErrors.push(err5);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err6 = {
                                                instancePath: instancePath + '/groupColumns/' + i2,
                                                schemaPath: '#/properties/groupColumns/items/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            }
                                            else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid1 = _errs17 === errors;
                                    if (_valid1 && valid6) {
                                        valid6 = false;
                                        passing1 = [passing1, 1];
                                    }
                                    else {
                                        if (_valid1) {
                                            valid6 = true;
                                            passing1 = 1;
                                        }
                                    }
                                    if (!valid6) {
                                        const err7 = {
                                            instancePath: instancePath + '/groupColumns/' + i2,
                                            schemaPath: '#/properties/groupColumns/items/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing1 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                        validate304.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs13;
                                        if (vErrors !== null) {
                                            if (_errs13) {
                                                vErrors.length = _errs13;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid5 = _errs12 === errors;
                                    if (!valid5) {
                                        break;
                                    }
                                }
                                if (valid5) {
                                    let i3 = data2.length;
                                    let j1;
                                    if (i3 > 1) {
                                        outer1: for (; i3--;) {
                                            for (j1 = i3; j1--;) {
                                                if (func0(data2[i3], data2[j1])) {
                                                    validate304.errors = [
                                                        {
                                                            instancePath: instancePath + '/groupColumns',
                                                            schemaPath: '#/properties/groupColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i3, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer1;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate304.errors = [
                                    {
                                        instancePath: instancePath + '/groupColumns',
                                        schemaPath: '#/properties/groupColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs10 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orderColumns !== undefined) {
                            let data4 = data.orderColumns;
                            const _errs19 = errors;
                            if (errors === _errs19) {
                                if (Array.isArray(data4)) {
                                    if (data4.length < 1) {
                                        validate304.errors = [
                                            {
                                                instancePath: instancePath + '/orderColumns',
                                                schemaPath: '#/properties/orderColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid9 = true;
                                        const len2 = data4.length;
                                        for (let i4 = 0; i4 < len2; i4++) {
                                            const _errs21 = errors;
                                            if (!validate219(data4[i4], {
                                                instancePath: instancePath + '/orderColumns/' + i4,
                                                parentData: data4,
                                                parentDataProperty: i4,
                                                rootData
                                            })) {
                                                vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
                                                errors = vErrors.length;
                                            }
                                            var valid9 = _errs21 === errors;
                                            if (!valid9) {
                                                break;
                                            }
                                        }
                                        if (valid9) {
                                            const keys0 = schema410.properties.orderColumns.uniqueItemProperties;
                                            let k0;
                                            let i5 = data4.length;
                                            let j2;
                                            if (i5 > 1) {
                                                outer2: for (k0 = 0; k0 < keys0.length; k0++) {
                                                    let key0 = keys0[k0];
                                                    for (i5 = data4.length; i5--;) {
                                                        let x0 = data4[i5];
                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                            continue;
                                                        }
                                                        for (j2 = i5; j2--;) {
                                                            let y0 = data4[j2];
                                                            if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func650(x0[key0], y0[key0])) {
                                                                validate304.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/orderColumns',
                                                                        schemaPath: '#/properties/orderColumns/uniqueItemProperties',
                                                                        keyword: 'uniqueItemProperties',
                                                                        params: {},
                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer2;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate304.errors = [
                                        {
                                            instancePath: instancePath + '/orderColumns',
                                            schemaPath: '#/properties/orderColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs19 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate304.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate304.errors = vErrors;
    return errors === 0;
}
export const sampleConfigSchemaValidation = validate306;
const schema413 = {
    $id: 'urn:wisepipe-common-pipe:SampleConfig',
    type: 'object',
    properties: { fraction: { type: 'number', minimum: 0, maximum: 100 } }
};
function validate306(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SampleConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.fraction !== undefined) {
                let data0 = data.fraction;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 == 'number') {
                        if (data0 > 100 || isNaN(data0)) {
                            validate306.errors = [
                                {
                                    instancePath: instancePath + '/fraction',
                                    schemaPath: '#/properties/fraction/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 100 },
                                    message: 'must be <= 100'
                                }
                            ];
                            return false;
                        }
                        else {
                            if (data0 < 0 || isNaN(data0)) {
                                validate306.errors = [
                                    {
                                        instancePath: instancePath + '/fraction',
                                        schemaPath: '#/properties/fraction/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 0 },
                                        message: 'must be >= 0'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    else {
                        validate306.errors = [
                            {
                                instancePath: instancePath + '/fraction',
                                schemaPath: '#/properties/fraction/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate306.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate306.errors = vErrors;
    return errors === 0;
}
export const sampleCustomersConfigSchemaValidation = validate307;
const schema414 = { $id: 'urn:wisepipe-common-pipe:SampleChurnConfig', type: 'object', properties: {} };
function validate307(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SampleChurnConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate307.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate307.errors = vErrors;
    return errors === 0;
}
export const schemasSchemaValidation = validate250;
export const seasonalArimaForecastConfigSchemaValidation = validate308;
const schema415 = {
    $id: 'urn:wisepipe-common-pipe:SeasonalArimaForecastConfig',
    type: 'object',
    properties: {
        seasonalFrequency: { type: 'string', enum: ['yearly', 'monthly', 'quarterly', 'weekly', 'daily'] },
        seasonalityAutomatic: { type: 'boolean' }
    },
    required: ['seasonalFrequency']
};
function validate308(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SeasonalArimaForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.seasonalFrequency === undefined && (missing0 = 'seasonalFrequency')) {
                validate308.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.seasonalFrequency !== undefined) {
                    let data0 = data.seasonalFrequency;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate308.errors = [
                            {
                                instancePath: instancePath + '/seasonalFrequency',
                                schemaPath: '#/properties/seasonalFrequency/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'yearly' ||
                        data0 === 'monthly' ||
                        data0 === 'quarterly' ||
                        data0 === 'weekly' ||
                        data0 === 'daily')) {
                        validate308.errors = [
                            {
                                instancePath: instancePath + '/seasonalFrequency',
                                schemaPath: '#/properties/seasonalFrequency/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema415.properties.seasonalFrequency.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.seasonalityAutomatic !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.seasonalityAutomatic !== 'boolean') {
                            validate308.errors = [
                                {
                                    instancePath: instancePath + '/seasonalityAutomatic',
                                    schemaPath: '#/properties/seasonalityAutomatic/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate308.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate308.errors = vErrors;
    return errors === 0;
}
export const segmentationConfigSchemaValidation = validate309;
const schema416 = {
    $id: 'urn:wisepipe-common-pipe:SegmentationConfig',
    type: 'object',
    properties: {
        target: { type: 'string', minLength: 1, maxLength: 150 },
        alias: { type: 'string', minLength: 1, maxLength: 150 },
        balanced: { type: 'boolean' },
        maxSegments: { type: ['integer', 'null', 'boolean'], if: { type: 'integer' }, then: { minimum: 2, maximum: 25 } },
        minSize: { type: ['number', 'null'], if: { type: 'number' }, then: { minimum: 0.01, maximum: 0.5 } },
        maxDepth: { type: ['integer', 'null'], if: { type: 'integer' }, then: { minimum: 2, maximum: 10 } },
        excludeColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        autoExclude: { type: 'boolean' },
        autoExcludeCorrMethod: { type: 'string', enum: ['pearson', 'kendall', 'spearman'] },
        autoExcludeCorrThreshold: { type: 'number' },
        autoExcludePpsThreshold: { type: 'number' }
    },
    required: ['balanced', 'target', 'alias']
};
function validate309(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SegmentationConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.balanced === undefined && (missing0 = 'balanced')) ||
                (data.target === undefined && (missing0 = 'target')) ||
                (data.alias === undefined && (missing0 = 'alias'))) {
                validate309.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.target !== undefined) {
                    let data0 = data.target;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate309.errors = [
                                    {
                                        instancePath: instancePath + '/target',
                                        schemaPath: '#/properties/target/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate309.errors = [
                                        {
                                            instancePath: instancePath + '/target',
                                            schemaPath: '#/properties/target/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate309.errors = [
                                {
                                    instancePath: instancePath + '/target',
                                    schemaPath: '#/properties/target/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.alias !== undefined) {
                        let data1 = data.alias;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate309.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate309.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate309.errors = [
                                    {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.balanced !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.balanced !== 'boolean') {
                                validate309.errors = [
                                    {
                                        instancePath: instancePath + '/balanced',
                                        schemaPath: '#/properties/balanced/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.maxSegments !== undefined) {
                                let data3 = data.maxSegments;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3)) &&
                                    data3 !== null &&
                                    typeof data3 !== 'boolean') {
                                    validate309.errors = [
                                        {
                                            instancePath: instancePath + '/maxSegments',
                                            schemaPath: '#/properties/maxSegments/type',
                                            keyword: 'type',
                                            params: { type: schema416.properties.maxSegments.type },
                                            message: 'must be integer,null,boolean'
                                        }
                                    ];
                                    return false;
                                }
                                const _errs9 = errors;
                                let valid1 = true;
                                const _errs10 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    const err0 = {};
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                                var _valid0 = _errs10 === errors;
                                errors = _errs9;
                                if (vErrors !== null) {
                                    if (_errs9) {
                                        vErrors.length = _errs9;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                if (_valid0) {
                                    const _errs12 = errors;
                                    if (typeof data3 == 'number') {
                                        if (data3 > 25 || isNaN(data3)) {
                                            validate309.errors = [
                                                {
                                                    instancePath: instancePath + '/maxSegments',
                                                    schemaPath: '#/properties/maxSegments/then/maximum',
                                                    keyword: 'maximum',
                                                    params: { comparison: '<=', limit: 25 },
                                                    message: 'must be <= 25'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3 < 2 || isNaN(data3)) {
                                                validate309.errors = [
                                                    {
                                                        instancePath: instancePath + '/maxSegments',
                                                        schemaPath: '#/properties/maxSegments/then/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 2 },
                                                        message: 'must be >= 2'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var _valid0 = _errs12 === errors;
                                    valid1 = _valid0;
                                }
                                if (!valid1) {
                                    const err1 = {
                                        instancePath: instancePath + '/maxSegments',
                                        schemaPath: '#/properties/maxSegments/if',
                                        keyword: 'if',
                                        params: { failingKeyword: 'then' },
                                        message: 'must match "then" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err1];
                                    }
                                    else {
                                        vErrors.push(err1);
                                    }
                                    errors++;
                                    validate309.errors = vErrors;
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.minSize !== undefined) {
                                    let data4 = data.minSize;
                                    const _errs13 = errors;
                                    if (!(typeof data4 == 'number') && data4 !== null) {
                                        validate309.errors = [
                                            {
                                                instancePath: instancePath + '/minSize',
                                                schemaPath: '#/properties/minSize/type',
                                                keyword: 'type',
                                                params: { type: schema416.properties.minSize.type },
                                                message: 'must be number,null'
                                            }
                                        ];
                                        return false;
                                    }
                                    const _errs15 = errors;
                                    let valid2 = true;
                                    const _errs16 = errors;
                                    if (!(typeof data4 == 'number')) {
                                        const err2 = {};
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                    }
                                    var _valid1 = _errs16 === errors;
                                    errors = _errs15;
                                    if (vErrors !== null) {
                                        if (_errs15) {
                                            vErrors.length = _errs15;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                    if (_valid1) {
                                        const _errs18 = errors;
                                        if (typeof data4 == 'number') {
                                            if (data4 > 0.5 || isNaN(data4)) {
                                                validate309.errors = [
                                                    {
                                                        instancePath: instancePath + '/minSize',
                                                        schemaPath: '#/properties/minSize/then/maximum',
                                                        keyword: 'maximum',
                                                        params: { comparison: '<=', limit: 0.5 },
                                                        message: 'must be <= 0.5'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4 < 0.01 || isNaN(data4)) {
                                                    validate309.errors = [
                                                        {
                                                            instancePath: instancePath + '/minSize',
                                                            schemaPath: '#/properties/minSize/then/minimum',
                                                            keyword: 'minimum',
                                                            params: { comparison: '>=', limit: 0.01 },
                                                            message: 'must be >= 0.01'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var _valid1 = _errs18 === errors;
                                        valid2 = _valid1;
                                    }
                                    if (!valid2) {
                                        const err3 = {
                                            instancePath: instancePath + '/minSize',
                                            schemaPath: '#/properties/minSize/if',
                                            keyword: 'if',
                                            params: { failingKeyword: 'then' },
                                            message: 'must match "then" schema'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err3];
                                        }
                                        else {
                                            vErrors.push(err3);
                                        }
                                        errors++;
                                        validate309.errors = vErrors;
                                        return false;
                                    }
                                    var valid0 = _errs13 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.maxDepth !== undefined) {
                                        let data5 = data.maxDepth;
                                        const _errs19 = errors;
                                        if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5)) && data5 !== null) {
                                            validate309.errors = [
                                                {
                                                    instancePath: instancePath + '/maxDepth',
                                                    schemaPath: '#/properties/maxDepth/type',
                                                    keyword: 'type',
                                                    params: { type: schema416.properties.maxDepth.type },
                                                    message: 'must be integer,null'
                                                }
                                            ];
                                            return false;
                                        }
                                        const _errs21 = errors;
                                        let valid3 = true;
                                        const _errs22 = errors;
                                        if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                                            const err4 = {};
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                        var _valid2 = _errs22 === errors;
                                        errors = _errs21;
                                        if (vErrors !== null) {
                                            if (_errs21) {
                                                vErrors.length = _errs21;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                        if (_valid2) {
                                            const _errs24 = errors;
                                            if (typeof data5 == 'number') {
                                                if (data5 > 10 || isNaN(data5)) {
                                                    validate309.errors = [
                                                        {
                                                            instancePath: instancePath + '/maxDepth',
                                                            schemaPath: '#/properties/maxDepth/then/maximum',
                                                            keyword: 'maximum',
                                                            params: { comparison: '<=', limit: 10 },
                                                            message: 'must be <= 10'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5 < 2 || isNaN(data5)) {
                                                        validate309.errors = [
                                                            {
                                                                instancePath: instancePath + '/maxDepth',
                                                                schemaPath: '#/properties/maxDepth/then/minimum',
                                                                keyword: 'minimum',
                                                                params: { comparison: '>=', limit: 2 },
                                                                message: 'must be >= 2'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var _valid2 = _errs24 === errors;
                                            valid3 = _valid2;
                                        }
                                        if (!valid3) {
                                            const err5 = {
                                                instancePath: instancePath + '/maxDepth',
                                                schemaPath: '#/properties/maxDepth/if',
                                                keyword: 'if',
                                                params: { failingKeyword: 'then' },
                                                message: 'must match "then" schema'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err5];
                                            }
                                            else {
                                                vErrors.push(err5);
                                            }
                                            errors++;
                                            validate309.errors = vErrors;
                                            return false;
                                        }
                                        var valid0 = _errs19 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.excludeColumns !== undefined) {
                                            let data6 = data.excludeColumns;
                                            const _errs25 = errors;
                                            if (errors === _errs25) {
                                                if (Array.isArray(data6)) {
                                                    var valid4 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data7 = data6[i0];
                                                        const _errs27 = errors;
                                                        if (errors === _errs27) {
                                                            if (typeof data7 === 'string') {
                                                                if (func2(data7) < 1) {
                                                                    validate309.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/excludeColumns/' + i0,
                                                                            schemaPath: '#/properties/excludeColumns/items/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate309.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/excludeColumns/' + i0,
                                                                        schemaPath: '#/properties/excludeColumns/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid4 = _errs27 === errors;
                                                        if (!valid4) {
                                                            break;
                                                        }
                                                    }
                                                    if (valid4) {
                                                        let i1 = data6.length;
                                                        let j0;
                                                        if (i1 > 1) {
                                                            const indices0 = {};
                                                            for (; i1--;) {
                                                                let item0 = data6[i1];
                                                                if (typeof item0 !== 'string') {
                                                                    continue;
                                                                }
                                                                if (typeof indices0[item0] == 'number') {
                                                                    j0 = indices0[item0];
                                                                    validate309.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/excludeColumns',
                                                                            schemaPath: '#/properties/excludeColumns/uniqueItems',
                                                                            keyword: 'uniqueItems',
                                                                            params: { i: i1, j: j0 },
                                                                            message: 'must NOT have duplicate items (items ## ' +
                                                                                j0 +
                                                                                ' and ' +
                                                                                i1 +
                                                                                ' are identical)'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                    break;
                                                                }
                                                                indices0[item0] = i1;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate309.errors = [
                                                        {
                                                            instancePath: instancePath + '/excludeColumns',
                                                            schemaPath: '#/properties/excludeColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs25 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.autoExclude !== undefined) {
                                                const _errs29 = errors;
                                                if (typeof data.autoExclude !== 'boolean') {
                                                    validate309.errors = [
                                                        {
                                                            instancePath: instancePath + '/autoExclude',
                                                            schemaPath: '#/properties/autoExclude/type',
                                                            keyword: 'type',
                                                            params: { type: 'boolean' },
                                                            message: 'must be boolean'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs29 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.autoExcludeCorrMethod !== undefined) {
                                                    let data9 = data.autoExcludeCorrMethod;
                                                    const _errs31 = errors;
                                                    if (typeof data9 !== 'string') {
                                                        validate309.errors = [
                                                            {
                                                                instancePath: instancePath + '/autoExcludeCorrMethod',
                                                                schemaPath: '#/properties/autoExcludeCorrMethod/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data9 === 'pearson' || data9 === 'kendall' || data9 === 'spearman')) {
                                                        validate309.errors = [
                                                            {
                                                                instancePath: instancePath + '/autoExcludeCorrMethod',
                                                                schemaPath: '#/properties/autoExcludeCorrMethod/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema416.properties.autoExcludeCorrMethod.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs31 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.autoExcludeCorrThreshold !== undefined) {
                                                        const _errs33 = errors;
                                                        if (!(typeof data.autoExcludeCorrThreshold == 'number')) {
                                                            validate309.errors = [
                                                                {
                                                                    instancePath: instancePath + '/autoExcludeCorrThreshold',
                                                                    schemaPath: '#/properties/autoExcludeCorrThreshold/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs33 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.autoExcludePpsThreshold !== undefined) {
                                                            const _errs35 = errors;
                                                            if (!(typeof data.autoExcludePpsThreshold == 'number')) {
                                                                validate309.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/autoExcludePpsThreshold',
                                                                        schemaPath: '#/properties/autoExcludePpsThreshold/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid0 = _errs35 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate309.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate309.errors = vErrors;
    return errors === 0;
}
export const selectConfigSchemaValidation = validate310;
const schema417 = {
    $id: 'urn:wisepipe-common-pipe:SelectConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: {
                oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
            },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['columns']
};
function validate310(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SelectConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate310.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate310.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate310.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        const _errs4 = errors;
                                        let valid2 = false;
                                        let passing0 = null;
                                        const _errs5 = errors;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                                                const err0 = {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err0];
                                                }
                                                else {
                                                    vErrors.push(err0);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs5 === errors;
                                        if (_valid0) {
                                            valid2 = true;
                                            passing0 = 0;
                                        }
                                        const _errs8 = errors;
                                        if (errors === _errs8) {
                                            if (typeof data1 === 'string') {
                                                if (func2(data1) > 150) {
                                                    const err1 = {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/oneOf/1/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err1];
                                                    }
                                                    else {
                                                        vErrors.push(err1);
                                                    }
                                                    errors++;
                                                }
                                                else {
                                                    if (func2(data1) < 1) {
                                                        const err2 = {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/oneOf/1/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err2];
                                                        }
                                                        else {
                                                            vErrors.push(err2);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err3 = {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/oneOf/1/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err3];
                                                }
                                                else {
                                                    vErrors.push(err3);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid0 = _errs8 === errors;
                                        if (_valid0 && valid2) {
                                            valid2 = false;
                                            passing0 = [passing0, 1];
                                        }
                                        else {
                                            if (_valid0) {
                                                valid2 = true;
                                                passing0 = 1;
                                            }
                                        }
                                        if (!valid2) {
                                            const err4 = {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing0 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                            validate310.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs4;
                                            if (vErrors !== null) {
                                                if (_errs4) {
                                                    vErrors.length = _errs4;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (; i1--;) {
                                                for (j0 = i1; j0--;) {
                                                    if (func0(data0[i1], data0[j0])) {
                                                        validate310.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns',
                                                                schemaPath: '#/properties/columns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break outer0;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate310.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate310.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate310.errors = vErrors;
    return errors === 0;
}
export const selectWordConfigSchemaValidation = validate311;
const schema419 = {
    $id: 'urn:wisepipe-common-pipe:SelectWordConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        index: { type: 'integer', minimum: 1 },
        separator: { type: 'string', minLength: 1 },
        addNewColumns: { type: 'boolean' }
    },
    required: ['columns', 'index']
};
function validate311(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SelectWordConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.index === undefined && (missing0 = 'index'))) {
                validate311.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate311.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate311.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate311.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate311.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate311.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate311.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.index !== undefined) {
                        let data2 = data.index;
                        const _errs5 = errors;
                        if (!(typeof data2 == 'number' && !(data2 % 1) && !isNaN(data2))) {
                            validate311.errors = [
                                {
                                    instancePath: instancePath + '/index',
                                    schemaPath: '#/properties/index/type',
                                    keyword: 'type',
                                    params: { type: 'integer' },
                                    message: 'must be integer'
                                }
                            ];
                            return false;
                        }
                        if (errors === _errs5) {
                            if (typeof data2 == 'number') {
                                if (data2 < 1 || isNaN(data2)) {
                                    validate311.errors = [
                                        {
                                            instancePath: instancePath + '/index',
                                            schemaPath: '#/properties/index/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.separator !== undefined) {
                            let data3 = data.separator;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate311.errors = [
                                            {
                                                instancePath: instancePath + '/separator',
                                                schemaPath: '#/properties/separator/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate311.errors = [
                                        {
                                            instancePath: instancePath + '/separator',
                                            schemaPath: '#/properties/separator/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.addNewColumns !== undefined) {
                                const _errs9 = errors;
                                if (typeof data.addNewColumns !== 'boolean') {
                                    validate311.errors = [
                                        {
                                            instancePath: instancePath + '/addNewColumns',
                                            schemaPath: '#/properties/addNewColumns/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate311.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate311.errors = vErrors;
    return errors === 0;
}
export const simpleExpSmoothingForecastConfigSchemaValidation = validate312;
const schema420 = {
    $id: 'urn:wisepipe-common-pipe:SimpleExpSmoothingForecastConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate312(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SimpleExpSmoothingForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate312.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate312.errors = vErrors;
    return errors === 0;
}
export const simpleToolVariableSchemaValidation = validate313;
function validate313(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:SimpleToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.parameterType === undefined && (missing0 = 'parameterType'))) {
                validate313.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate313.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate313.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.expectedValueType !== undefined) {
                        let data1 = data.expectedValueType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate313.errors = [
                                {
                                    instancePath: instancePath + '/expectedValueType',
                                    schemaPath: '#/properties/expectedValueType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'string' ||
                            data1 === 'number' ||
                            data1 === 'boolean' ||
                            data1 === 'date' ||
                            data1 === 'enum' ||
                            data1 === 'column' ||
                            data1 === 'calendar')) {
                            validate313.errors = [
                                {
                                    instancePath: instancePath + '/expectedValueType',
                                    schemaPath: '#/properties/expectedValueType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema392.properties.expectedValueType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.parameterType !== undefined) {
                            let data2 = data.parameterType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate313.errors = [
                                    {
                                        instancePath: instancePath + '/parameterType',
                                        schemaPath: '#/properties/parameterType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'global' ||
                                data2 === 'pipe' ||
                                data2 === 'calc' ||
                                data2 === 'reusable' ||
                                data2 === 'tool')) {
                                validate313.errors = [
                                    {
                                        instancePath: instancePath + '/parameterType',
                                        schemaPath: '#/properties/parameterType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema392.properties.parameterType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate313.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate313.errors = vErrors;
    return errors === 0;
}
export const singleObjectiveGaalOutlierConfigSchemaValidation = validate314;
const schema422 = {
    $id: 'urn:wisepipe-common-pipe:SingleObjectiveGaalOutlierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate314(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SingleObjectiveGaalOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate314.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate314.errors = vErrors;
    return errors === 0;
}
export const smartMatcherConfigSchemaValidation = validate315;
const schema423 = {
    $id: 'urn:wisepipe-common-pipe:SmartMatcherConfig',
    type: 'object',
    properties: {
        smartMatcherType: { type: 'string', enum: ['one-to-one', 'many-to-one'] },
        trainColumn: { $ref: 'urn:wisepipe-common-pipe:SmartMatcherTrainColumns' },
        matchColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SmartMatcherMatchColumns' },
            minItems: 1,
            uniqueItemProperties: ['leftColumn', 'rightColumn']
        }
    },
    required: ['smartMatcherType', 'trainColumn', 'matchColumns']
};
const schema424 = {
    $id: 'urn:wisepipe-common-pipe:SmartMatcherTrainColumns',
    type: 'object',
    properties: { leftColumn: { type: 'string' }, rightColumn: { type: 'string' } },
    required: ['leftColumn', 'rightColumn']
};
const schema425 = {
    $id: 'urn:wisepipe-common-pipe:SmartMatcherMatchColumns',
    type: 'object',
    properties: { leftColumn: { type: 'string' }, rightColumn: { type: 'string' } },
    required: ['leftColumn', 'rightColumn']
};
const func663 = ajvEqual;
function validate315(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SmartMatcherConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.smartMatcherType === undefined && (missing0 = 'smartMatcherType')) ||
                (data.trainColumn === undefined && (missing0 = 'trainColumn')) ||
                (data.matchColumns === undefined && (missing0 = 'matchColumns'))) {
                validate315.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.smartMatcherType !== undefined) {
                    let data0 = data.smartMatcherType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate315.errors = [
                            {
                                instancePath: instancePath + '/smartMatcherType',
                                schemaPath: '#/properties/smartMatcherType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'one-to-one' || data0 === 'many-to-one')) {
                        validate315.errors = [
                            {
                                instancePath: instancePath + '/smartMatcherType',
                                schemaPath: '#/properties/smartMatcherType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema423.properties.smartMatcherType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.trainColumn !== undefined) {
                        let data1 = data.trainColumn;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if ((data1.leftColumn === undefined && (missing1 = 'leftColumn')) ||
                                    (data1.rightColumn === undefined && (missing1 = 'rightColumn'))) {
                                    validate315.errors = [
                                        {
                                            instancePath: instancePath + '/trainColumn',
                                            schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherTrainColumns/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.leftColumn !== undefined) {
                                        const _errs6 = errors;
                                        if (typeof data1.leftColumn !== 'string') {
                                            validate315.errors = [
                                                {
                                                    instancePath: instancePath + '/trainColumn/leftColumn',
                                                    schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherTrainColumns/properties/leftColumn/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data1.rightColumn !== undefined) {
                                            const _errs8 = errors;
                                            if (typeof data1.rightColumn !== 'string') {
                                                validate315.errors = [
                                                    {
                                                        instancePath: instancePath + '/trainColumn/rightColumn',
                                                        schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherTrainColumns/properties/rightColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                    }
                                }
                            }
                            else {
                                validate315.errors = [
                                    {
                                        instancePath: instancePath + '/trainColumn',
                                        schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherTrainColumns/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.matchColumns !== undefined) {
                            let data4 = data.matchColumns;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (Array.isArray(data4)) {
                                    if (data4.length < 1) {
                                        validate315.errors = [
                                            {
                                                instancePath: instancePath + '/matchColumns',
                                                schemaPath: '#/properties/matchColumns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid3 = true;
                                        const len0 = data4.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data5 = data4[i0];
                                            const _errs12 = errors;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                    let missing2;
                                                    if ((data5.leftColumn === undefined && (missing2 = 'leftColumn')) ||
                                                        (data5.rightColumn === undefined && (missing2 = 'rightColumn'))) {
                                                        validate315.errors = [
                                                            {
                                                                instancePath: instancePath + '/matchColumns/' + i0,
                                                                schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherMatchColumns/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing2 },
                                                                message: "must have required property '" + missing2 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data5.leftColumn !== undefined) {
                                                            const _errs15 = errors;
                                                            if (typeof data5.leftColumn !== 'string') {
                                                                validate315.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/matchColumns/' + i0 + '/leftColumn',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherMatchColumns/properties/leftColumn/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid5 = _errs15 === errors;
                                                        }
                                                        else {
                                                            var valid5 = true;
                                                        }
                                                        if (valid5) {
                                                            if (data5.rightColumn !== undefined) {
                                                                const _errs17 = errors;
                                                                if (typeof data5.rightColumn !== 'string') {
                                                                    validate315.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/matchColumns/' + i0 + '/rightColumn',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherMatchColumns/properties/rightColumn/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid5 = _errs17 === errors;
                                                            }
                                                            else {
                                                                var valid5 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate315.errors = [
                                                        {
                                                            instancePath: instancePath + '/matchColumns/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:SmartMatcherMatchColumns/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs12 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                        if (valid3) {
                                            const keys0 = schema423.properties.matchColumns.uniqueItemProperties;
                                            let k0;
                                            let i1 = data4.length;
                                            let j0;
                                            if (i1 > 1) {
                                                outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                    let key0 = keys0[k0];
                                                    for (i1 = data4.length; i1--;) {
                                                        let x0 = data4[i1];
                                                        if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                            continue;
                                                        }
                                                        for (j0 = i1; j0--;) {
                                                            let y0 = data4[j0];
                                                            if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func663(x0[key0], y0[key0])) {
                                                                validate315.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/matchColumns',
                                                                        schemaPath: '#/properties/matchColumns/uniqueItemProperties',
                                                                        keyword: 'uniqueItemProperties',
                                                                        params: {},
                                                                        message: 'must pass "uniqueItemProperties" keyword validation'
                                                                    }
                                                                ];
                                                                return false;
                                                                break outer0;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate315.errors = [
                                        {
                                            instancePath: instancePath + '/matchColumns',
                                            schemaPath: '#/properties/matchColumns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs10 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate315.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate315.errors = vErrors;
    return errors === 0;
}
export const smartMatcherMatchColumnsSchemaValidation = validate316;
function validate316(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SmartMatcherMatchColumns" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.leftColumn === undefined && (missing0 = 'leftColumn')) ||
                (data.rightColumn === undefined && (missing0 = 'rightColumn'))) {
                validate316.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.leftColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.leftColumn !== 'string') {
                        validate316.errors = [
                            {
                                instancePath: instancePath + '/leftColumn',
                                schemaPath: '#/properties/leftColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rightColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.rightColumn !== 'string') {
                            validate316.errors = [
                                {
                                    instancePath: instancePath + '/rightColumn',
                                    schemaPath: '#/properties/rightColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate316.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate316.errors = vErrors;
    return errors === 0;
}
export const smartMatcherTrainColumnsSchemaValidation = validate317;
function validate317(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SmartMatcherTrainColumns" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.leftColumn === undefined && (missing0 = 'leftColumn')) ||
                (data.rightColumn === undefined && (missing0 = 'rightColumn'))) {
                validate317.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.leftColumn !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.leftColumn !== 'string') {
                        validate317.errors = [
                            {
                                instancePath: instancePath + '/leftColumn',
                                schemaPath: '#/properties/leftColumn/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.rightColumn !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.rightColumn !== 'string') {
                            validate317.errors = [
                                {
                                    instancePath: instancePath + '/rightColumn',
                                    schemaPath: '#/properties/rightColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate317.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate317.errors = vErrors;
    return errors === 0;
}
export const snapshotConfigSchemaValidation = validate318;
const schema428 = { $id: 'urn:wisepipe-common-pipe:SnapshotConfig', type: 'object', properties: {}, required: [] };
function validate318(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SnapshotConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate318.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate318.errors = vErrors;
    return errors === 0;
}
export const sortCalcConfigSchemaValidation = validate319;
const schema429 = { $id: 'urn:wisepipe-common-pipe:SortCalcConfig', type: 'object', properties: {}, required: [] };
function validate319(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SortCalcConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate319.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate319.errors = vErrors;
    return errors === 0;
}
export const sortColumnSchemaValidation = validate219;
export const sortConfigSchemaValidation = validate320;
const schema430 = {
    $id: 'urn:wisepipe-common-pipe:SortConfig',
    type: 'object',
    properties: {
        sortColumns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            uniqueItemProperties: ['name']
        }
    },
    required: ['sortColumns']
};
const func664 = ajvEqual;
function validate320(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SortConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.sortColumns === undefined && (missing0 = 'sortColumns')) {
                validate320.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sortColumns !== undefined) {
                    let data0 = data.sortColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                const _errs3 = errors;
                                if (!validate219(data0[i0], {
                                    instancePath: instancePath + '/sortColumns/' + i0,
                                    parentData: data0,
                                    parentDataProperty: i0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                const keys0 = schema430.properties.sortColumns.uniqueItemProperties;
                                let k0;
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                        let key0 = keys0[k0];
                                        for (i1 = data0.length; i1--;) {
                                            let x0 = data0[i1];
                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                continue;
                                            }
                                            for (j0 = i1; j0--;) {
                                                let y0 = data0[j0];
                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func664(x0[key0], y0[key0])) {
                                                    validate320.errors = [
                                                        {
                                                            instancePath: instancePath + '/sortColumns',
                                                            schemaPath: '#/properties/sortColumns/uniqueItemProperties',
                                                            keyword: 'uniqueItemProperties',
                                                            params: {},
                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate320.errors = [
                                {
                                    instancePath: instancePath + '/sortColumns',
                                    schemaPath: '#/properties/sortColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate320.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate320.errors = vErrors;
    return errors === 0;
}
export const sourceValidationResultSchemaValidation = validate322;
const schema431 = {
    $id: 'urn:wisepipe-common-pipe:SourceValidationResult',
    type: 'object',
    properties: { isValid: { type: 'boolean' }, comment: { type: 'string' }, suggestedFix: { type: 'string' } },
    required: ['isValid']
};
function validate322(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SourceValidationResult" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.isValid === undefined && (missing0 = 'isValid')) {
                validate322.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.isValid !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.isValid !== 'boolean') {
                        validate322.errors = [
                            {
                                instancePath: instancePath + '/isValid',
                                schemaPath: '#/properties/isValid/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.comment !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.comment !== 'string') {
                            validate322.errors = [
                                {
                                    instancePath: instancePath + '/comment',
                                    schemaPath: '#/properties/comment/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.suggestedFix !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.suggestedFix !== 'string') {
                                validate322.errors = [
                                    {
                                        instancePath: instancePath + '/suggestedFix',
                                        schemaPath: '#/properties/suggestedFix/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate322.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate322.errors = vErrors;
    return errors === 0;
}
export const splitColumnsSchemaValidation = validate323;
const schema432 = {
    $id: 'urn:wisepipe-common-pipe:SplitColumnsConfig',
    type: 'object',
    properties: {
        mode: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' }, { type: 'string', enum: ['columns', 'rows'] }]
        },
        columnToSplit: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        delimiter: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 50 }]
        },
        numberOfNewColumns: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:NumberToolVariable' }, { type: 'integer', minimum: 2, maximum: 100 }]
        },
        alias: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string', minLength: 1, maxLength: 150 }]
        },
        extraCharacterHandling: {
            oneOf: [{ $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' }, { type: 'string', enum: ['append', 'drop'] }]
        }
    },
    required: ['mode', 'columnToSplit', 'delimiter'],
    if: { properties: { mode: { type: 'string', enum: ['columns'] } } },
    then: { required: ['numberOfNewColumns', 'alias', 'extraCharacterHandling'] }
};
function validate323(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SplitColumnsConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.mode !== undefined) {
            let data0 = data.mode;
            if (typeof data0 !== 'string') {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            if (!(data0 === 'columns')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.numberOfNewColumns === undefined && (missing0 = 'numberOfNewColumns')) ||
                (data.alias === undefined && (missing0 = 'alias')) ||
                (data.extraCharacterHandling === undefined && (missing0 = 'extraCharacterHandling'))) {
                validate323.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate323.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.mode === undefined && (missing1 = 'mode')) ||
                (data.columnToSplit === undefined && (missing1 = 'columnToSplit')) ||
                (data.delimiter === undefined && (missing1 = 'delimiter'))) {
                validate323.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mode !== undefined) {
                    let data1 = data.mode;
                    const _errs6 = errors;
                    const _errs7 = errors;
                    let valid3 = false;
                    let passing0 = null;
                    const _errs8 = errors;
                    const _errs9 = errors;
                    if (errors === _errs9) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            if (data1.toolEnumType !== undefined) {
                                let data2 = data1.toolEnumType;
                                if (typeof data2 !== 'string') {
                                    const err3 = {
                                        instancePath: instancePath + '/mode/toolEnumType',
                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err3];
                                    }
                                    else {
                                        vErrors.push(err3);
                                    }
                                    errors++;
                                }
                                if (!(data2 === 'SortDirection' ||
                                    data2 === 'AggregateColumnOperation' ||
                                    data2 === 'DateFrequency' ||
                                    data2 === 'DateAddType' ||
                                    data2 === 'DateAddUnit' ||
                                    data2 === 'DateUnitType' ||
                                    data2 === 'DatePartType' ||
                                    data2 === 'JoinOperator' ||
                                    data2 === 'JoinPattern' ||
                                    data2 === 'FilterStatementOp' ||
                                    data2 === 'ColumnType' ||
                                    data2 === 'PeriodAddType')) {
                                    const err4 = {
                                        instancePath: instancePath + '/mode/toolEnumType',
                                        schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema36.properties.toolEnumType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err4];
                                    }
                                    else {
                                        vErrors.push(err4);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err5 = {
                                instancePath: instancePath + '/mode',
                                schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err5];
                            }
                            else {
                                vErrors.push(err5);
                            }
                            errors++;
                        }
                    }
                    var _valid1 = _errs8 === errors;
                    if (_valid1) {
                        valid3 = true;
                        passing0 = 0;
                    }
                    const _errs13 = errors;
                    if (typeof data1 !== 'string') {
                        const err6 = {
                            instancePath: instancePath + '/mode',
                            schemaPath: '#/properties/mode/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                    if (!(data1 === 'columns' || data1 === 'rows')) {
                        const err7 = {
                            instancePath: instancePath + '/mode',
                            schemaPath: '#/properties/mode/oneOf/1/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema432.properties.mode.oneOf[1].enum },
                            message: 'must be equal to one of the allowed values'
                        };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                    var _valid1 = _errs13 === errors;
                    if (_valid1 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid1) {
                            valid3 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid3) {
                        const err8 = {
                            instancePath: instancePath + '/mode',
                            schemaPath: '#/properties/mode/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                        validate323.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs7;
                        if (vErrors !== null) {
                            if (_errs7) {
                                vErrors.length = _errs7;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.columnToSplit !== undefined) {
                        let data3 = data.columnToSplit;
                        const _errs15 = errors;
                        const _errs16 = errors;
                        let valid6 = false;
                        let passing1 = null;
                        const _errs17 = errors;
                        const _errs18 = errors;
                        if (errors === _errs18) {
                            if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
                                const err9 = {
                                    instancePath: instancePath + '/columnToSplit',
                                    schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs17 === errors;
                        if (_valid2) {
                            valid6 = true;
                            passing1 = 0;
                        }
                        const _errs20 = errors;
                        if (errors === _errs20) {
                            if (typeof data3 === 'string') {
                                if (func2(data3) > 150) {
                                    const err10 = {
                                        instancePath: instancePath + '/columnToSplit',
                                        schemaPath: '#/properties/columnToSplit/oneOf/1/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                }
                                else {
                                    if (func2(data3) < 1) {
                                        const err11 = {
                                            instancePath: instancePath + '/columnToSplit',
                                            schemaPath: '#/properties/columnToSplit/oneOf/1/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err11];
                                        }
                                        else {
                                            vErrors.push(err11);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err12 = {
                                    instancePath: instancePath + '/columnToSplit',
                                    schemaPath: '#/properties/columnToSplit/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs20 === errors;
                        if (_valid2 && valid6) {
                            valid6 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid2) {
                                valid6 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid6) {
                            const err13 = {
                                instancePath: instancePath + '/columnToSplit',
                                schemaPath: '#/properties/columnToSplit/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                            validate323.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs16;
                            if (vErrors !== null) {
                                if (_errs16) {
                                    vErrors.length = _errs16;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid2 = _errs15 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.delimiter !== undefined) {
                            let data4 = data.delimiter;
                            const _errs22 = errors;
                            const _errs23 = errors;
                            let valid8 = false;
                            let passing2 = null;
                            const _errs24 = errors;
                            const _errs25 = errors;
                            if (errors === _errs25) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err14 = {
                                        instancePath: instancePath + '/delimiter',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs24 === errors;
                            if (_valid3) {
                                valid8 = true;
                                passing2 = 0;
                            }
                            const _errs27 = errors;
                            if (errors === _errs27) {
                                if (typeof data4 === 'string') {
                                    if (func2(data4) > 50) {
                                        const err15 = {
                                            instancePath: instancePath + '/delimiter',
                                            schemaPath: '#/properties/delimiter/oneOf/1/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 50 },
                                            message: 'must NOT have more than 50 characters'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                    else {
                                        if (func2(data4) < 1) {
                                            const err16 = {
                                                instancePath: instancePath + '/delimiter',
                                                schemaPath: '#/properties/delimiter/oneOf/1/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err16];
                                            }
                                            else {
                                                vErrors.push(err16);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err17 = {
                                        instancePath: instancePath + '/delimiter',
                                        schemaPath: '#/properties/delimiter/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err17];
                                    }
                                    else {
                                        vErrors.push(err17);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs27 === errors;
                            if (_valid3 && valid8) {
                                valid8 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid8 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid8) {
                                const err18 = {
                                    instancePath: instancePath + '/delimiter',
                                    schemaPath: '#/properties/delimiter/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err18];
                                }
                                else {
                                    vErrors.push(err18);
                                }
                                errors++;
                                validate323.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs23;
                                if (vErrors !== null) {
                                    if (_errs23) {
                                        vErrors.length = _errs23;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid2 = _errs22 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.numberOfNewColumns !== undefined) {
                                let data5 = data.numberOfNewColumns;
                                const _errs29 = errors;
                                const _errs30 = errors;
                                let valid10 = false;
                                let passing3 = null;
                                const _errs31 = errors;
                                const _errs32 = errors;
                                if (errors === _errs32) {
                                    if (!(data5 && typeof data5 == 'object' && !Array.isArray(data5))) {
                                        const err19 = {
                                            instancePath: instancePath + '/numberOfNewColumns',
                                            schemaPath: 'urn:wisepipe-base-pipe:NumberToolVariable/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err19];
                                        }
                                        else {
                                            vErrors.push(err19);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs31 === errors;
                                if (_valid4) {
                                    valid10 = true;
                                    passing3 = 0;
                                }
                                const _errs34 = errors;
                                if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                                    const err20 = {
                                        instancePath: instancePath + '/numberOfNewColumns',
                                        schemaPath: '#/properties/numberOfNewColumns/oneOf/1/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err20];
                                    }
                                    else {
                                        vErrors.push(err20);
                                    }
                                    errors++;
                                }
                                if (errors === _errs34) {
                                    if (typeof data5 == 'number') {
                                        if (data5 > 100 || isNaN(data5)) {
                                            const err21 = {
                                                instancePath: instancePath + '/numberOfNewColumns',
                                                schemaPath: '#/properties/numberOfNewColumns/oneOf/1/maximum',
                                                keyword: 'maximum',
                                                params: { comparison: '<=', limit: 100 },
                                                message: 'must be <= 100'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err21];
                                            }
                                            else {
                                                vErrors.push(err21);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data5 < 2 || isNaN(data5)) {
                                                const err22 = {
                                                    instancePath: instancePath + '/numberOfNewColumns',
                                                    schemaPath: '#/properties/numberOfNewColumns/oneOf/1/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 2 },
                                                    message: 'must be >= 2'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err22];
                                                }
                                                else {
                                                    vErrors.push(err22);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                }
                                var _valid4 = _errs34 === errors;
                                if (_valid4 && valid10) {
                                    valid10 = false;
                                    passing3 = [passing3, 1];
                                }
                                else {
                                    if (_valid4) {
                                        valid10 = true;
                                        passing3 = 1;
                                    }
                                }
                                if (!valid10) {
                                    const err23 = {
                                        instancePath: instancePath + '/numberOfNewColumns',
                                        schemaPath: '#/properties/numberOfNewColumns/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing3 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err23];
                                    }
                                    else {
                                        vErrors.push(err23);
                                    }
                                    errors++;
                                    validate323.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs30;
                                    if (vErrors !== null) {
                                        if (_errs30) {
                                            vErrors.length = _errs30;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid2 = _errs29 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.alias !== undefined) {
                                    let data6 = data.alias;
                                    const _errs36 = errors;
                                    const _errs37 = errors;
                                    let valid12 = false;
                                    let passing4 = null;
                                    const _errs38 = errors;
                                    const _errs39 = errors;
                                    if (errors === _errs39) {
                                        if (!(data6 && typeof data6 == 'object' && !Array.isArray(data6))) {
                                            const err24 = {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err24];
                                            }
                                            else {
                                                vErrors.push(err24);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid5 = _errs38 === errors;
                                    if (_valid5) {
                                        valid12 = true;
                                        passing4 = 0;
                                    }
                                    const _errs41 = errors;
                                    if (errors === _errs41) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) > 150) {
                                                const err25 = {
                                                    instancePath: instancePath + '/alias',
                                                    schemaPath: '#/properties/alias/oneOf/1/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 150 },
                                                    message: 'must NOT have more than 150 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err25];
                                                }
                                                else {
                                                    vErrors.push(err25);
                                                }
                                                errors++;
                                            }
                                            else {
                                                if (func2(data6) < 1) {
                                                    const err26 = {
                                                        instancePath: instancePath + '/alias',
                                                        schemaPath: '#/properties/alias/oneOf/1/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err26];
                                                    }
                                                    else {
                                                        vErrors.push(err26);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err27 = {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err27];
                                            }
                                            else {
                                                vErrors.push(err27);
                                            }
                                            errors++;
                                        }
                                    }
                                    var _valid5 = _errs41 === errors;
                                    if (_valid5 && valid12) {
                                        valid12 = false;
                                        passing4 = [passing4, 1];
                                    }
                                    else {
                                        if (_valid5) {
                                            valid12 = true;
                                            passing4 = 1;
                                        }
                                    }
                                    if (!valid12) {
                                        const err28 = {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing4 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err28];
                                        }
                                        else {
                                            vErrors.push(err28);
                                        }
                                        errors++;
                                        validate323.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs37;
                                        if (vErrors !== null) {
                                            if (_errs37) {
                                                vErrors.length = _errs37;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    var valid2 = _errs36 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.extraCharacterHandling !== undefined) {
                                        let data7 = data.extraCharacterHandling;
                                        const _errs43 = errors;
                                        const _errs44 = errors;
                                        let valid14 = false;
                                        let passing5 = null;
                                        const _errs45 = errors;
                                        const _errs46 = errors;
                                        if (errors === _errs46) {
                                            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                if (data7.toolEnumType !== undefined) {
                                                    let data8 = data7.toolEnumType;
                                                    if (typeof data8 !== 'string') {
                                                        const err29 = {
                                                            instancePath: instancePath + '/extraCharacterHandling/toolEnumType',
                                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err29];
                                                        }
                                                        else {
                                                            vErrors.push(err29);
                                                        }
                                                        errors++;
                                                    }
                                                    if (!(data8 === 'SortDirection' ||
                                                        data8 === 'AggregateColumnOperation' ||
                                                        data8 === 'DateFrequency' ||
                                                        data8 === 'DateAddType' ||
                                                        data8 === 'DateAddUnit' ||
                                                        data8 === 'DateUnitType' ||
                                                        data8 === 'DatePartType' ||
                                                        data8 === 'JoinOperator' ||
                                                        data8 === 'JoinPattern' ||
                                                        data8 === 'FilterStatementOp' ||
                                                        data8 === 'ColumnType' ||
                                                        data8 === 'PeriodAddType')) {
                                                        const err30 = {
                                                            instancePath: instancePath + '/extraCharacterHandling/toolEnumType',
                                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema36.properties.toolEnumType.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err30];
                                                        }
                                                        else {
                                                            vErrors.push(err30);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            else {
                                                const err31 = {
                                                    instancePath: instancePath + '/extraCharacterHandling',
                                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err31];
                                                }
                                                else {
                                                    vErrors.push(err31);
                                                }
                                                errors++;
                                            }
                                        }
                                        var _valid6 = _errs45 === errors;
                                        if (_valid6) {
                                            valid14 = true;
                                            passing5 = 0;
                                        }
                                        const _errs50 = errors;
                                        if (typeof data7 !== 'string') {
                                            const err32 = {
                                                instancePath: instancePath + '/extraCharacterHandling',
                                                schemaPath: '#/properties/extraCharacterHandling/oneOf/1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err32];
                                            }
                                            else {
                                                vErrors.push(err32);
                                            }
                                            errors++;
                                        }
                                        if (!(data7 === 'append' || data7 === 'drop')) {
                                            const err33 = {
                                                instancePath: instancePath + '/extraCharacterHandling',
                                                schemaPath: '#/properties/extraCharacterHandling/oneOf/1/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema432.properties.extraCharacterHandling.oneOf[1].enum },
                                                message: 'must be equal to one of the allowed values'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err33];
                                            }
                                            else {
                                                vErrors.push(err33);
                                            }
                                            errors++;
                                        }
                                        var _valid6 = _errs50 === errors;
                                        if (_valid6 && valid14) {
                                            valid14 = false;
                                            passing5 = [passing5, 1];
                                        }
                                        else {
                                            if (_valid6) {
                                                valid14 = true;
                                                passing5 = 1;
                                            }
                                        }
                                        if (!valid14) {
                                            const err34 = {
                                                instancePath: instancePath + '/extraCharacterHandling',
                                                schemaPath: '#/properties/extraCharacterHandling/oneOf',
                                                keyword: 'oneOf',
                                                params: { passingSchemas: passing5 },
                                                message: 'must match exactly one schema in oneOf'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err34];
                                            }
                                            else {
                                                vErrors.push(err34);
                                            }
                                            errors++;
                                            validate323.errors = vErrors;
                                            return false;
                                        }
                                        else {
                                            errors = _errs44;
                                            if (vErrors !== null) {
                                                if (_errs44) {
                                                    vErrors.length = _errs44;
                                                }
                                                else {
                                                    vErrors = null;
                                                }
                                            }
                                        }
                                        var valid2 = _errs43 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate323.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate323.errors = vErrors;
    return errors === 0;
}
export const splitConfigSchemaValidation = validate324;
const schema439 = {
    $id: 'urn:wisepipe-common-pipe:SplitConfig',
    type: 'object',
    properties: { split: { type: 'integer', minimum: 0, maximum: 150 } },
    required: ['split']
};
function validate324(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SplitConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.split === undefined && (missing0 = 'split')) {
                validate324.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.split !== undefined) {
                    let data0 = data.split;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate324.errors = [
                            {
                                instancePath: instancePath + '/split',
                                schemaPath: '#/properties/split/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 150 || isNaN(data0)) {
                                validate324.errors = [
                                    {
                                        instancePath: instancePath + '/split',
                                        schemaPath: '#/properties/split/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 150 },
                                        message: 'must be <= 150'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 0 || isNaN(data0)) {
                                    validate324.errors = [
                                        {
                                            instancePath: instancePath + '/split',
                                            schemaPath: '#/properties/split/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate324.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate324.errors = vErrors;
    return errors === 0;
}
export const spmCalcToolConfigSchemaValidation = validate325;
const schema440 = {
    $id: 'urn:wisepipe-common-pipe:SpmCalcToolConfig',
    type: 'object',
    properties: {
        calendarID: { type: 'string', minLength: 1 },
        start: { type: 'string', format: 'date' },
        end: { type: 'string', format: 'date' }
    },
    required: []
};
const formats106 = formatWrapper.date;
function validate325(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SpmCalcToolConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.calendarID !== undefined) {
                let data0 = data.calendarID;
                const _errs1 = errors;
                if (errors === _errs1) {
                    if (typeof data0 === 'string') {
                        if (func2(data0) < 1) {
                            validate325.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters'
                                }
                            ];
                            return false;
                        }
                    }
                    else {
                        validate325.errors = [
                            {
                                instancePath: instancePath + '/calendarID',
                                schemaPath: '#/properties/calendarID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.start !== undefined) {
                    let data1 = data.start;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!formats106.validate(data1)) {
                                    validate325.errors = [
                                        {
                                            instancePath: instancePath + '/start',
                                            schemaPath: '#/properties/start/format',
                                            keyword: 'format',
                                            params: { format: 'date' },
                                            message: 'must match format "' + 'date' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate325.errors = [
                                    {
                                        instancePath: instancePath + '/start',
                                        schemaPath: '#/properties/start/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.end !== undefined) {
                        let data2 = data.end;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (!formats106.validate(data2)) {
                                        validate325.errors = [
                                            {
                                                instancePath: instancePath + '/end',
                                                schemaPath: '#/properties/end/format',
                                                keyword: 'format',
                                                params: { format: 'date' },
                                                message: 'must match format "' + 'date' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate325.errors = [
                                        {
                                            instancePath: instancePath + '/end',
                                            schemaPath: '#/properties/end/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate325.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate325.errors = vErrors;
    return errors === 0;
}
export const standardScalerConfigSchemaValidation = validate326;
const schema441 = {
    $id: 'urn:wisepipe-common-pipe:StandardScalerConfig',
    type: 'object',
    properties: { columns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true } },
    required: ['columns']
};
function validate326(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:StandardScalerConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate326.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                if (errors === _errs3) {
                                    if (typeof data1 === 'string') {
                                        if (func2(data1) < 1) {
                                            validate326.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate326.errors = [
                                            {
                                                instancePath: instancePath + '/columns/' + i0,
                                                schemaPath: '#/properties/columns/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    const indices0 = {};
                                    for (; i1--;) {
                                        let item0 = data0[i1];
                                        if (typeof item0 !== 'string') {
                                            continue;
                                        }
                                        if (typeof indices0[item0] == 'number') {
                                            j0 = indices0[item0];
                                            validate326.errors = [
                                                {
                                                    instancePath: instancePath + '/columns',
                                                    schemaPath: '#/properties/columns/uniqueItems',
                                                    keyword: 'uniqueItems',
                                                    params: { i: i1, j: j0 },
                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                }
                                            ];
                                            return false;
                                            break;
                                        }
                                        indices0[item0] = i1;
                                    }
                                }
                            }
                        }
                        else {
                            validate326.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate326.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate326.errors = vErrors;
    return errors === 0;
}
export const stringToolVariableSchemaValidation = validate327;
function validate327(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:StringToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate327.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate327.errors = vErrors;
    return errors === 0;
}
export const subspaceOutlierConfigSchemaValidation = validate328;
const schema443 = {
    $id: 'urn:wisepipe-common-pipe:SubspaceOutlierConfig',
    type: 'object',
    properties: {},
    required: []
};
function validate328(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SubspaceOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate328.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate328.errors = vErrors;
    return errors === 0;
}
export const svmTrainConfigSchemaValidation = validate329;
const schema444 = { $id: 'urn:wisepipe-common-pipe:SvmTrainConfig', type: 'object', properties: {}, required: [] };
function validate329(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:SvmTrainConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate329.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate329.errors = vErrors;
    return errors === 0;
}
export const textBetweenConfigSchemaValidation = validate330;
const schema445 = {
    $id: 'urn:wisepipe-common-pipe:TextBetweenConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        after: { type: 'string', minLength: 1 },
        before: { type: 'string', minLength: 1 },
        addNewColumns: { type: 'boolean' }
    },
    required: ['columns']
};
function validate330(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextBetweenConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate330.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate330.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate330.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate330.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate330.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate330.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate330.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.after !== undefined) {
                        let data2 = data.after;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate330.errors = [
                                        {
                                            instancePath: instancePath + '/after',
                                            schemaPath: '#/properties/after/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate330.errors = [
                                    {
                                        instancePath: instancePath + '/after',
                                        schemaPath: '#/properties/after/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.before !== undefined) {
                            let data3 = data.before;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate330.errors = [
                                            {
                                                instancePath: instancePath + '/before',
                                                schemaPath: '#/properties/before/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate330.errors = [
                                        {
                                            instancePath: instancePath + '/before',
                                            schemaPath: '#/properties/before/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.addNewColumns !== undefined) {
                                const _errs9 = errors;
                                if (typeof data.addNewColumns !== 'boolean') {
                                    validate330.errors = [
                                        {
                                            instancePath: instancePath + '/addNewColumns',
                                            schemaPath: '#/properties/addNewColumns/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate330.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate330.errors = vErrors;
    return errors === 0;
}
export const textClassifierConfigSchemaValidation = validate331;
const schema446 = {
    $id: 'urn:wisepipe-common-pipe:TextClassifierConfig',
    type: 'object',
    properties: { options: { type: 'integer', minimum: 1, maximum: 7 } },
    required: ['options']
};
function validate331(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.options === undefined && (missing0 = 'options')) {
                validate331.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.options !== undefined) {
                    let data0 = data.options;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number' && !(data0 % 1) && !isNaN(data0))) {
                        validate331.errors = [
                            {
                                instancePath: instancePath + '/options',
                                schemaPath: '#/properties/options/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer'
                            }
                        ];
                        return false;
                    }
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 > 7 || isNaN(data0)) {
                                validate331.errors = [
                                    {
                                        instancePath: instancePath + '/options',
                                        schemaPath: '#/properties/options/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 7 },
                                        message: 'must be <= 7'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0 < 1 || isNaN(data0)) {
                                    validate331.errors = [
                                        {
                                            instancePath: instancePath + '/options',
                                            schemaPath: '#/properties/options/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 1 },
                                            message: 'must be >= 1'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate331.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate331.errors = vErrors;
    return errors === 0;
}
export const textGradeLevelConfigSchemaValidation = validate332;
const schema447 = {
    $id: 'urn:wisepipe-common-pipe:TextGradeLevelConfig',
    type: 'object',
    properties: {
        targetColumn: { type: 'string', minLength: 1, maxLength: 150 },
        extras: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'automated_readability_index',
                    'coleman_liau_index',
                    'dale_chall_readability_score',
                    'flesch_kincaid_grade',
                    'gunning_fog',
                    'linsear_write_formula',
                    'smog_index'
                ]
            },
            uniqueItems: true
        }
    },
    required: ['targetColumn', 'extras']
};
function validate332(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextGradeLevelConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.targetColumn === undefined && (missing0 = 'targetColumn')) ||
                (data.extras === undefined && (missing0 = 'extras'))) {
                validate332.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.targetColumn !== undefined) {
                    let data0 = data.targetColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate332.errors = [
                                    {
                                        instancePath: instancePath + '/targetColumn',
                                        schemaPath: '#/properties/targetColumn/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate332.errors = [
                                        {
                                            instancePath: instancePath + '/targetColumn',
                                            schemaPath: '#/properties/targetColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate332.errors = [
                                {
                                    instancePath: instancePath + '/targetColumn',
                                    schemaPath: '#/properties/targetColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.extras !== undefined) {
                        let data1 = data.extras;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (typeof data2 !== 'string') {
                                        validate332.errors = [
                                            {
                                                instancePath: instancePath + '/extras/' + i0,
                                                schemaPath: '#/properties/extras/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data2 === 'automated_readability_index' ||
                                        data2 === 'coleman_liau_index' ||
                                        data2 === 'dale_chall_readability_score' ||
                                        data2 === 'flesch_kincaid_grade' ||
                                        data2 === 'gunning_fog' ||
                                        data2 === 'linsear_write_formula' ||
                                        data2 === 'smog_index')) {
                                        validate332.errors = [
                                            {
                                                instancePath: instancePath + '/extras/' + i0,
                                                schemaPath: '#/properties/extras/items/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema447.properties.extras.items.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate332.errors = [
                                                    {
                                                        instancePath: instancePath + '/extras',
                                                        schemaPath: '#/properties/extras/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate332.errors = [
                                    {
                                        instancePath: instancePath + '/extras',
                                        schemaPath: '#/properties/extras/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate332.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate332.errors = vErrors;
    return errors === 0;
}
export const textLengthColumnSchemaValidation = validate333;
const schema448 = {
    $id: 'urn:wisepipe-common-pipe:TextLengthColumn',
    type: 'object',
    properties: {
        source: { type: 'string', minLength: 1, maxLength: 150 },
        alias: { type: 'string', minLength: 1, maxLength: 150 }
    },
    required: ['source', 'alias']
};
function validate333(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextLengthColumn" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.source === undefined && (missing0 = 'source')) || (data.alias === undefined && (missing0 = 'alias'))) {
                validate333.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.source !== undefined) {
                    let data0 = data.source;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate333.errors = [
                                    {
                                        instancePath: instancePath + '/source',
                                        schemaPath: '#/properties/source/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate333.errors = [
                                        {
                                            instancePath: instancePath + '/source',
                                            schemaPath: '#/properties/source/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate333.errors = [
                                {
                                    instancePath: instancePath + '/source',
                                    schemaPath: '#/properties/source/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.alias !== undefined) {
                        let data1 = data.alias;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate333.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate333.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate333.errors = [
                                    {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: '#/properties/alias/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate333.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate333.errors = vErrors;
    return errors === 0;
}
export const textLengthConfigSchemaValidation = validate334;
const schema449 = {
    $id: 'urn:wisepipe-common-pipe:TextLengthConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:TextLengthColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['source', 'alias']
        }
    },
    required: ['columns']
};
const func687 = ajvEqual;
function validate334(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextLengthConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate334.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate334.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate334.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        const _errs4 = errors;
                                        if (errors === _errs4) {
                                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                                let missing1;
                                                if ((data1.source === undefined && (missing1 = 'source')) ||
                                                    (data1.alias === undefined && (missing1 = 'alias'))) {
                                                    validate334.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data1.source !== undefined) {
                                                        let data2 = data1.source;
                                                        const _errs6 = errors;
                                                        if (errors === _errs6) {
                                                            if (typeof data2 === 'string') {
                                                                if (func2(data2) > 150) {
                                                                    validate334.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/source',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/properties/source/maxLength',
                                                                            keyword: 'maxLength',
                                                                            params: { limit: 150 },
                                                                            message: 'must NOT have more than 150 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (func2(data2) < 1) {
                                                                        validate334.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/source',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/properties/source/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate334.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columns/' + i0 + '/source',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/properties/source/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid3 = _errs6 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data1.alias !== undefined) {
                                                            let data3 = data1.alias;
                                                            const _errs8 = errors;
                                                            if (errors === _errs8) {
                                                                if (typeof data3 === 'string') {
                                                                    if (func2(data3) > 150) {
                                                                        validate334.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columns/' + i0 + '/alias',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/properties/alias/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 150 },
                                                                                message: 'must NOT have more than 150 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (func2(data3) < 1) {
                                                                            validate334.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/columns/' + i0 + '/alias',
                                                                                    schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/properties/alias/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate334.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columns/' + i0 + '/alias',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/properties/alias/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs8 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate334.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:TextLengthColumn/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        const keys0 = schema449.properties.columns.uniqueItemProperties;
                                        let k0;
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data0.length; i1--;) {
                                                    let x0 = data0[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data0[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func687(x0[key0], y0[key0])) {
                                                            validate334.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columns',
                                                                    schemaPath: '#/properties/columns/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate334.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate334.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate334.errors = vErrors;
    return errors === 0;
}
export const textPartConfigSchemaValidation = validate335;
const schema451 = {
    $id: 'urn:wisepipe-common-pipe:TextPartConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        },
        type: { type: 'string', enum: ['left', 'mid', 'right'] },
        length: { type: 'integer', minimum: 0 },
        start: { type: 'integer', minimum: 1 },
        addNewColumns: { type: 'boolean' }
    },
    required: ['columns', 'type', 'length'],
    if: { properties: { type: { type: 'string', enum: ['mid'] } } },
    then: { required: ['start'] }
};
function validate335(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextPartConfig" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            let data0 = data.type;
            if (typeof data0 !== 'string') {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
            if (!(data0 === 'mid')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.start === undefined && (missing0 = 'start')) {
                validate335.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate335.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.columns === undefined && (missing1 = 'columns')) ||
                (data.type === undefined && (missing1 = 'type')) ||
                (data.length === undefined && (missing1 = 'length'))) {
                validate335.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data1 = data.columns;
                    const _errs6 = errors;
                    if (errors === _errs6) {
                        if (Array.isArray(data1)) {
                            if (data1.length > 1000) {
                                validate335.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid3 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs8 = errors;
                                    if (errors === _errs8) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) > 150) {
                                                validate335.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data2) < 1) {
                                                    validate335.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate335.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid3 = _errs8 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                                if (valid3) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate335.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate335.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.type !== undefined) {
                        let data3 = data.type;
                        const _errs10 = errors;
                        if (typeof data3 !== 'string') {
                            validate335.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data3 === 'left' || data3 === 'mid' || data3 === 'right')) {
                            validate335.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema451.properties.type.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs10 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.length !== undefined) {
                            let data4 = data.length;
                            const _errs12 = errors;
                            if (!(typeof data4 == 'number' && !(data4 % 1) && !isNaN(data4))) {
                                validate335.errors = [
                                    {
                                        instancePath: instancePath + '/length',
                                        schemaPath: '#/properties/length/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer'
                                    }
                                ];
                                return false;
                            }
                            if (errors === _errs12) {
                                if (typeof data4 == 'number') {
                                    if (data4 < 0 || isNaN(data4)) {
                                        validate335.errors = [
                                            {
                                                instancePath: instancePath + '/length',
                                                schemaPath: '#/properties/length/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid2 = _errs12 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.start !== undefined) {
                                let data5 = data.start;
                                const _errs14 = errors;
                                if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                                    validate335.errors = [
                                        {
                                            instancePath: instancePath + '/start',
                                            schemaPath: '#/properties/start/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs14) {
                                    if (typeof data5 == 'number') {
                                        if (data5 < 1 || isNaN(data5)) {
                                            validate335.errors = [
                                                {
                                                    instancePath: instancePath + '/start',
                                                    schemaPath: '#/properties/start/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 1 },
                                                    message: 'must be >= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid2 = _errs14 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.addNewColumns !== undefined) {
                                    const _errs16 = errors;
                                    if (typeof data.addNewColumns !== 'boolean') {
                                        validate335.errors = [
                                            {
                                                instancePath: instancePath + '/addNewColumns',
                                                schemaPath: '#/properties/addNewColumns/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid2 = _errs16 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate335.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate335.errors = vErrors;
    return errors === 0;
}
export const textSentimentConfigSchemaValidation = validate336;
const schema452 = {
    $id: 'urn:wisepipe-common-pipe:TextSentimentConfig',
    type: 'object',
    properties: { targetColumn: { type: 'string', minLength: 1, maxLength: 150 } },
    required: ['targetColumn']
};
function validate336(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TextSentimentConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.targetColumn === undefined && (missing0 = 'targetColumn')) {
                validate336.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.targetColumn !== undefined) {
                    let data0 = data.targetColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate336.errors = [
                                    {
                                        instancePath: instancePath + '/targetColumn',
                                        schemaPath: '#/properties/targetColumn/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate336.errors = [
                                        {
                                            instancePath: instancePath + '/targetColumn',
                                            schemaPath: '#/properties/targetColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate336.errors = [
                                {
                                    instancePath: instancePath + '/targetColumn',
                                    schemaPath: '#/properties/targetColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate336.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate336.errors = vErrors;
    return errors === 0;
}
export const timeShiftCalcConfigSchemaValidation = validate337;
const schema453 = { $id: 'urn:wisepipe-common-pipe:TimeShiftCalcConfig', type: 'object', properties: {}, required: [] };
function validate337(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TimeShiftCalcConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate337.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate337.errors = vErrors;
    return errors === 0;
}
export const toolConfigInfoSchemaValidation = validate338;
const schema454 = {
    $id: 'urn:wisepipe-common-pipe:ToolConfigInfo',
    type: 'object',
    properties: {
        displayName: { type: 'string' },
        categories: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'calculate',
                    'clean',
                    'combine',
                    'data',
                    'learn',
                    'organize',
                    'sales_performance',
                    'the_basics',
                    'predict',
                    'prepare',
                    'group',
                    'compare',
                    'text_tools',
                    'date_tools',
                    'compute',
                    'understand',
                    'connect',
                    'encode',
                    'sample_data',
                    'optimize',
                    'reusable_logic',
                    'forecast',
                    'outlier',
                    'text_classifier',
                    'classifier',
                    'regressor',
                    'unseen'
                ]
            },
            uniqueItems: true
        },
        ins: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        outs: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        aliases: { type: 'array', items: { type: ['string', 'object'] } },
        sparkAvailable: { type: 'boolean' }
    },
    required: ['displayName', 'ins', 'outs', 'categories', 'sparkAvailable', 'aliases']
};
function validate338(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ToolConfigInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.displayName === undefined && (missing0 = 'displayName')) ||
                (data.ins === undefined && (missing0 = 'ins')) ||
                (data.outs === undefined && (missing0 = 'outs')) ||
                (data.categories === undefined && (missing0 = 'categories')) ||
                (data.sparkAvailable === undefined && (missing0 = 'sparkAvailable')) ||
                (data.aliases === undefined && (missing0 = 'aliases'))) {
                validate338.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.displayName !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.displayName !== 'string') {
                        validate338.errors = [
                            {
                                instancePath: instancePath + '/displayName',
                                schemaPath: '#/properties/displayName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.categories !== undefined) {
                        let data1 = data.categories;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (typeof data2 !== 'string') {
                                        validate338.errors = [
                                            {
                                                instancePath: instancePath + '/categories/' + i0,
                                                schemaPath: '#/properties/categories/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data2 === 'calculate' ||
                                        data2 === 'clean' ||
                                        data2 === 'combine' ||
                                        data2 === 'data' ||
                                        data2 === 'learn' ||
                                        data2 === 'organize' ||
                                        data2 === 'sales_performance' ||
                                        data2 === 'the_basics' ||
                                        data2 === 'predict' ||
                                        data2 === 'prepare' ||
                                        data2 === 'group' ||
                                        data2 === 'compare' ||
                                        data2 === 'text_tools' ||
                                        data2 === 'date_tools' ||
                                        data2 === 'compute' ||
                                        data2 === 'understand' ||
                                        data2 === 'connect' ||
                                        data2 === 'encode' ||
                                        data2 === 'sample_data' ||
                                        data2 === 'optimize' ||
                                        data2 === 'reusable_logic' ||
                                        data2 === 'forecast' ||
                                        data2 === 'outlier' ||
                                        data2 === 'text_classifier' ||
                                        data2 === 'classifier' ||
                                        data2 === 'regressor' ||
                                        data2 === 'unseen')) {
                                        validate338.errors = [
                                            {
                                                instancePath: instancePath + '/categories/' + i0,
                                                schemaPath: '#/properties/categories/items/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema454.properties.categories.items.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate338.errors = [
                                                    {
                                                        instancePath: instancePath + '/categories',
                                                        schemaPath: '#/properties/categories/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate338.errors = [
                                    {
                                        instancePath: instancePath + '/categories',
                                        schemaPath: '#/properties/categories/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.ins !== undefined) {
                            let data3 = data.ins;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len1 = data3.length;
                                    for (let i2 = 0; i2 < len1; i2++) {
                                        const _errs9 = errors;
                                        if (typeof data3[i2] !== 'string') {
                                            validate338.errors = [
                                                {
                                                    instancePath: instancePath + '/ins/' + i2,
                                                    schemaPath: '#/properties/ins/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid3 = _errs9 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                    if (valid3) {
                                        let i3 = data3.length;
                                        let j1;
                                        if (i3 > 1) {
                                            const indices1 = {};
                                            for (; i3--;) {
                                                let item1 = data3[i3];
                                                if (typeof item1 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices1[item1] == 'number') {
                                                    j1 = indices1[item1];
                                                    validate338.errors = [
                                                        {
                                                            instancePath: instancePath + '/ins',
                                                            schemaPath: '#/properties/ins/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i3, j: j1 },
                                                            message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices1[item1] = i3;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate338.errors = [
                                        {
                                            instancePath: instancePath + '/ins',
                                            schemaPath: '#/properties/ins/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.outs !== undefined) {
                                let data5 = data.outs;
                                const _errs11 = errors;
                                if (errors === _errs11) {
                                    if (Array.isArray(data5)) {
                                        var valid5 = true;
                                        const len2 = data5.length;
                                        for (let i4 = 0; i4 < len2; i4++) {
                                            const _errs13 = errors;
                                            if (typeof data5[i4] !== 'string') {
                                                validate338.errors = [
                                                    {
                                                        instancePath: instancePath + '/outs/' + i4,
                                                        schemaPath: '#/properties/outs/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid5 = _errs13 === errors;
                                            if (!valid5) {
                                                break;
                                            }
                                        }
                                        if (valid5) {
                                            let i5 = data5.length;
                                            let j2;
                                            if (i5 > 1) {
                                                const indices2 = {};
                                                for (; i5--;) {
                                                    let item2 = data5[i5];
                                                    if (typeof item2 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices2[item2] == 'number') {
                                                        j2 = indices2[item2];
                                                        validate338.errors = [
                                                            {
                                                                instancePath: instancePath + '/outs',
                                                                schemaPath: '#/properties/outs/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i5, j: j2 },
                                                                message: 'must NOT have duplicate items (items ## ' + j2 + ' and ' + i5 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices2[item2] = i5;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate338.errors = [
                                            {
                                                instancePath: instancePath + '/outs',
                                                schemaPath: '#/properties/outs/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs11 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.aliases !== undefined) {
                                    let data7 = data.aliases;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (Array.isArray(data7)) {
                                            var valid7 = true;
                                            const len3 = data7.length;
                                            for (let i6 = 0; i6 < len3; i6++) {
                                                let data8 = data7[i6];
                                                const _errs17 = errors;
                                                if (typeof data8 !== 'string' &&
                                                    !(data8 && typeof data8 == 'object' && !Array.isArray(data8))) {
                                                    validate338.errors = [
                                                        {
                                                            instancePath: instancePath + '/aliases/' + i6,
                                                            schemaPath: '#/properties/aliases/items/type',
                                                            keyword: 'type',
                                                            params: { type: schema454.properties.aliases.items.type },
                                                            message: 'must be string,object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid7 = _errs17 === errors;
                                                if (!valid7) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate338.errors = [
                                                {
                                                    instancePath: instancePath + '/aliases',
                                                    schemaPath: '#/properties/aliases/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs15 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.sparkAvailable !== undefined) {
                                        const _errs19 = errors;
                                        if (typeof data.sparkAvailable !== 'boolean') {
                                            validate338.errors = [
                                                {
                                                    instancePath: instancePath + '/sparkAvailable',
                                                    schemaPath: '#/properties/sparkAvailable/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs19 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate338.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate338.errors = vErrors;
    return errors === 0;
}
export const toolConfigSchemaValidation = validate131;
export const toolParameterSchemaValidation = validate339;
const func694 = ucs2length;
const func695 = base64urlToBuffer;
const func696 = base64urlEncode;
const func697 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate339(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ToolParameter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('global' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.pipeID !== undefined) {
                let data1 = data.pipeID;
                if (typeof data1 !== 'string') {
                    validate339.errors = [
                        {
                            instancePath: instancePath + '/pipeID',
                            schemaPath: '#/then/properties/pipeID/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if ('AAAAAAAAAAAAAA' !== data1) {
                    validate339.errors = [
                        {
                            instancePath: instancePath + '/pipeID',
                            schemaPath: '#/then/properties/pipeID/const',
                            keyword: 'const',
                            params: { allowedValue: 'AAAAAAAAAAAAAA' },
                            message: 'must be equal to constant'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        const _errs8 = errors;
        let valid3 = true;
        const _errs9 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('reusable' !== data.type) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs9 === errors;
        errors = _errs8;
        if (vErrors !== null) {
            if (_errs8) {
                vErrors.length = _errs8;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.pipeID !== undefined) {
                    let data3 = data.pipeID;
                    if (typeof data3 !== 'string') {
                        validate339.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/else/then/properties/pipeID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if ('BBBBBBBBBBBBBA' !== data3) {
                        validate339.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/else/then/properties/pipeID/const',
                                keyword: 'const',
                                params: { allowedValue: 'BBBBBBBBBBBBBA' },
                                message: 'must be equal to constant'
                            }
                        ];
                        return false;
                    }
                }
            }
            var _valid1 = _errs11 === errors;
            valid3 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs14 = errors;
            const _errs15 = errors;
            let valid6 = true;
            const _errs16 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    if ('tool' !== data.type) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs16 === errors;
            errors = _errs15;
            if (vErrors !== null) {
                if (_errs15) {
                    vErrors.length = _errs15;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs18 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.pipeID !== undefined) {
                        let data5 = data.pipeID;
                        if (typeof data5 !== 'string') {
                            validate339.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/else/else/then/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if ('BBBBBBBBBBBBBA' !== data5) {
                            validate339.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/else/else/then/properties/pipeID/const',
                                    keyword: 'const',
                                    params: { allowedValue: 'BBBBBBBBBBBBBA' },
                                    message: 'must be equal to constant'
                                }
                            ];
                            return false;
                        }
                    }
                }
                var _valid2 = _errs18 === errors;
                valid6 = _valid2;
            }
            if (!valid6) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate339.errors = vErrors;
                return false;
            }
            var _valid1 = _errs14 === errors;
            valid3 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid3) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate339.errors = vErrors;
            return false;
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate339.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.valueType === undefined && (missing0 = 'valueType'))) {
                validate339.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data6 = data.name;
                    const _errs21 = errors;
                    if (errors === _errs21) {
                        if (typeof data6 === 'string') {
                            if (func2(data6) > 150) {
                                validate339.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data6) < 1) {
                                    validate339.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate339.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid9 = _errs21 === errors;
                }
                else {
                    var valid9 = true;
                }
                if (valid9) {
                    if (data.type !== undefined) {
                        let data7 = data.type;
                        const _errs23 = errors;
                        if (typeof data7 !== 'string') {
                            validate339.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data7 === 'global' || data7 === 'pipe' || data7 === 'calc' || data7 === 'reusable' || data7 === 'tool')) {
                            validate339.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema393.properties.type.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid9 = _errs23 === errors;
                    }
                    else {
                        var valid9 = true;
                    }
                    if (valid9) {
                        if (data.pipeID !== undefined) {
                            let data8 = data.pipeID;
                            const _errs25 = errors;
                            if (errors === _errs25) {
                                if (typeof data8 === 'string') {
                                    const b64min0 = Math.ceil((4 * 10) / 3);
                                    const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func694(data8) < b64min0 || func694(data8) > b64max0) {
                                        validate339.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func694(data8) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func694(data8)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func695(data8);
                                        if (decoded0.length !== 10) {
                                            validate339.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func696(decoded0);
                                            if (func697(encoded0) !== func697(data8)) {
                                                validate339.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate339.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid9 = _errs25 === errors;
                        }
                        else {
                            var valid9 = true;
                        }
                        if (valid9) {
                            if (data.description !== undefined) {
                                let data9 = data.description;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (typeof data9 === 'string') {
                                        if (func2(data9) > 1000) {
                                            validate339.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 1000 },
                                                    message: 'must NOT have more than 1000 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate339.errors = [
                                            {
                                                instancePath: instancePath + '/description',
                                                schemaPath: '#/properties/description/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid9 = _errs27 === errors;
                            }
                            else {
                                var valid9 = true;
                            }
                            if (valid9) {
                                if (data.valueType !== undefined) {
                                    let data10 = data.valueType;
                                    const _errs29 = errors;
                                    if (typeof data10 !== 'string') {
                                        validate339.errors = [
                                            {
                                                instancePath: instancePath + '/valueType',
                                                schemaPath: '#/properties/valueType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data10 === 'string' ||
                                        data10 === 'number' ||
                                        data10 === 'boolean' ||
                                        data10 === 'date' ||
                                        data10 === 'enum' ||
                                        data10 === 'column' ||
                                        data10 === 'calendar')) {
                                        validate339.errors = [
                                            {
                                                instancePath: instancePath + '/valueType',
                                                schemaPath: '#/properties/valueType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema393.properties.valueType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid9 = _errs29 === errors;
                                }
                                else {
                                    var valid9 = true;
                                }
                                if (valid9) {
                                    if (data.createdAt !== undefined) {
                                        let data11 = data.createdAt;
                                        const _errs31 = errors;
                                        if (errors === _errs31) {
                                            if (errors === _errs31) {
                                                if (typeof data11 === 'string') {
                                                    if (!formats0.validate(data11)) {
                                                        validate339.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate339.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid9 = _errs31 === errors;
                                    }
                                    else {
                                        var valid9 = true;
                                    }
                                    if (valid9) {
                                        if (data.updatedAt !== undefined) {
                                            let data12 = data.updatedAt;
                                            const _errs33 = errors;
                                            if (errors === _errs33) {
                                                if (errors === _errs33) {
                                                    if (typeof data12 === 'string') {
                                                        if (!formats0.validate(data12)) {
                                                            validate339.errors = [
                                                                {
                                                                    instancePath: instancePath + '/updatedAt',
                                                                    schemaPath: '#/properties/updatedAt/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'date-time' },
                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate339.errors = [
                                                            {
                                                                instancePath: instancePath + '/updatedAt',
                                                                schemaPath: '#/properties/updatedAt/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid9 = _errs33 === errors;
                                        }
                                        else {
                                            var valid9 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate339.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate339.errors = vErrors;
    return errors === 0;
}
export const toolValidationResultSchemaValidation = validate340;
const schema456 = {
    $id: 'urn:wisepipe-common-pipe:ToolValidationResult',
    type: 'object',
    properties: {
        validationState: {
            type: 'number',
            enum: [
                'VALID',
                'INVALID',
                'BAD_METADATA',
                'EMPTY',
                'PORT_MISMATCH',
                'PORT_MISSING_EDGES',
                'TWO_INCOMING_EDGES',
                'CYCLE',
                'SPARK_UNAVAILABLE',
                'DEPRECATED',
                'MISSING_INCOMING_EDGE',
                'NO_COLUMN_TYPE_FOUND',
                'MULTI_PORT_NOT_USED_INCOMING_EDGE',
                'MULTI_PORT_UNMAPPED_INPUT',
                'MULTI_PORT_UNMAPPED_OUTPUT',
                'MULTI_PORT_MAPPED_INPUT_MISSING',
                'MULTI_PORT_MAPPED_COLUMN_INVALID',
                'REUSABLE_LOGIC_EXTRA_PARAMETER_VALUE',
                'REUSABLE_LOGIC_PARAMETER_VALUE_TYPE_MISMATCH',
                'REUSABLE_LOGIC_UNMAPPED_INPUT',
                'REUSABLE_LOGIC_UNMAPPED_OUTPUT',
                'REUSABLE_LOGIC_MAPPED_INPUT_MISSING',
                'REUSABLE_LOGIC_MAPPED_COLUMN_INVALID',
                'REUSABLE_LOGIC_FORBIDDEN_TOOL',
                'REUSABLE_LOGIC_CYCLE',
                'REUSABLE_LOGIC_INNER_INVALID',
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25
            ]
        },
        comment: { type: 'string' },
        suggestedFix: { type: 'string' }
    },
    required: ['validationState']
};
function validate340(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ToolValidationResult" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.validationState === undefined && (missing0 = 'validationState')) {
                validate340.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.validationState !== undefined) {
                    let data0 = data.validationState;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number')) {
                        validate340.errors = [
                            {
                                instancePath: instancePath + '/validationState',
                                schemaPath: '#/properties/validationState/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'VALID' ||
                        data0 === 'INVALID' ||
                        data0 === 'BAD_METADATA' ||
                        data0 === 'EMPTY' ||
                        data0 === 'PORT_MISMATCH' ||
                        data0 === 'PORT_MISSING_EDGES' ||
                        data0 === 'TWO_INCOMING_EDGES' ||
                        data0 === 'CYCLE' ||
                        data0 === 'SPARK_UNAVAILABLE' ||
                        data0 === 'DEPRECATED' ||
                        data0 === 'MISSING_INCOMING_EDGE' ||
                        data0 === 'NO_COLUMN_TYPE_FOUND' ||
                        data0 === 'MULTI_PORT_NOT_USED_INCOMING_EDGE' ||
                        data0 === 'MULTI_PORT_UNMAPPED_INPUT' ||
                        data0 === 'MULTI_PORT_UNMAPPED_OUTPUT' ||
                        data0 === 'MULTI_PORT_MAPPED_INPUT_MISSING' ||
                        data0 === 'MULTI_PORT_MAPPED_COLUMN_INVALID' ||
                        data0 === 'REUSABLE_LOGIC_EXTRA_PARAMETER_VALUE' ||
                        data0 === 'REUSABLE_LOGIC_PARAMETER_VALUE_TYPE_MISMATCH' ||
                        data0 === 'REUSABLE_LOGIC_UNMAPPED_INPUT' ||
                        data0 === 'REUSABLE_LOGIC_UNMAPPED_OUTPUT' ||
                        data0 === 'REUSABLE_LOGIC_MAPPED_INPUT_MISSING' ||
                        data0 === 'REUSABLE_LOGIC_MAPPED_COLUMN_INVALID' ||
                        data0 === 'REUSABLE_LOGIC_FORBIDDEN_TOOL' ||
                        data0 === 'REUSABLE_LOGIC_CYCLE' ||
                        data0 === 'REUSABLE_LOGIC_INNER_INVALID' ||
                        data0 === 0 ||
                        data0 === 1 ||
                        data0 === 2 ||
                        data0 === 3 ||
                        data0 === 4 ||
                        data0 === 5 ||
                        data0 === 6 ||
                        data0 === 7 ||
                        data0 === 8 ||
                        data0 === 9 ||
                        data0 === 10 ||
                        data0 === 11 ||
                        data0 === 12 ||
                        data0 === 13 ||
                        data0 === 14 ||
                        data0 === 15 ||
                        data0 === 16 ||
                        data0 === 17 ||
                        data0 === 18 ||
                        data0 === 19 ||
                        data0 === 20 ||
                        data0 === 21 ||
                        data0 === 22 ||
                        data0 === 23 ||
                        data0 === 24 ||
                        data0 === 25)) {
                        validate340.errors = [
                            {
                                instancePath: instancePath + '/validationState',
                                schemaPath: '#/properties/validationState/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema456.properties.validationState.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.comment !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.comment !== 'string') {
                            validate340.errors = [
                                {
                                    instancePath: instancePath + '/comment',
                                    schemaPath: '#/properties/comment/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.suggestedFix !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.suggestedFix !== 'string') {
                                validate340.errors = [
                                    {
                                        instancePath: instancePath + '/suggestedFix',
                                        schemaPath: '#/properties/suggestedFix/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate340.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate340.errors = vErrors;
    return errors === 0;
}
export const trimConfigSchemaValidation = validate341;
const schema457 = {
    $id: 'urn:wisepipe-common-pipe:TrimConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            maxItems: 1000
        }
    },
    required: ['columns']
};
function validate341(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TrimConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.columns === undefined && (missing0 = 'columns')) {
                validate341.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate341.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) > 150) {
                                                validate341.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 150 },
                                                        message: 'must NOT have more than 150 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (func2(data1) < 1) {
                                                    validate341.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        else {
                                            validate341.errors = [
                                                {
                                                    instancePath: instancePath + '/columns/' + i0,
                                                    schemaPath: '#/properties/columns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate341.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns',
                                                        schemaPath: '#/properties/columns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate341.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate341.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate341.errors = vErrors;
    return errors === 0;
}
export const trimTagsConfigSchemaValidation = validate342;
const schema458 = {
    $id: 'urn:wisepipe-common-pipe:TrimTagsConfig',
    type: 'object',
    properties: {
        column: { type: 'string', minLength: 1, maxLength: 150 },
        newColumn: { type: 'string', minLength: 1, maxLength: 150 }
    },
    required: ['column']
};
function validate342(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TrimTagsConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.column === undefined && (missing0 = 'column')) {
                validate342.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data0 = data.column;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate342.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate342.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate342.errors = [
                                {
                                    instancePath: instancePath + '/column',
                                    schemaPath: '#/properties/column/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.newColumn !== undefined) {
                        let data1 = data.newColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate342.errors = [
                                        {
                                            instancePath: instancePath + '/newColumn',
                                            schemaPath: '#/properties/newColumn/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate342.errors = [
                                            {
                                                instancePath: instancePath + '/newColumn',
                                                schemaPath: '#/properties/newColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate342.errors = [
                                    {
                                        instancePath: instancePath + '/newColumn',
                                        schemaPath: '#/properties/newColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate342.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate342.errors = vErrors;
    return errors === 0;
}
export const trueUpConfigSchemaValidation = validate343;
const schema459 = {
    $id: 'urn:wisepipe-common-pipe:TrueUpConfig',
    type: 'object',
    properties: {
        valueColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 1 },
        periodColumn: { type: 'string', minLength: 1 },
        resetLevel: { type: 'string', minLength: 1 },
        partitionColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true }
    },
    required: ['valueColumns', 'periodColumn', 'resetLevel']
};
function validate343(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:TrueUpConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.valueColumns === undefined && (missing0 = 'valueColumns')) ||
                (data.periodColumn === undefined && (missing0 = 'periodColumn')) ||
                (data.resetLevel === undefined && (missing0 = 'resetLevel'))) {
                validate343.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.valueColumns !== undefined) {
                    let data0 = data.valueColumns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length < 1) {
                                validate343.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumns',
                                        schemaPath: '#/properties/valueColumns/minItems',
                                        keyword: 'minItems',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                var valid1 = true;
                                const len0 = data0.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data1 = data0[i0];
                                    const _errs3 = errors;
                                    if (errors === _errs3) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate343.errors = [
                                                    {
                                                        instancePath: instancePath + '/valueColumns/' + i0,
                                                        schemaPath: '#/properties/valueColumns/items/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate343.errors = [
                                                {
                                                    instancePath: instancePath + '/valueColumns/' + i0,
                                                    schemaPath: '#/properties/valueColumns/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid1 = _errs3 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data0.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data0[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate343.errors = [
                                                    {
                                                        instancePath: instancePath + '/valueColumns',
                                                        schemaPath: '#/properties/valueColumns/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate343.errors = [
                                {
                                    instancePath: instancePath + '/valueColumns',
                                    schemaPath: '#/properties/valueColumns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.periodColumn !== undefined) {
                        let data2 = data.periodColumn;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 1) {
                                    validate343.errors = [
                                        {
                                            instancePath: instancePath + '/periodColumn',
                                            schemaPath: '#/properties/periodColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate343.errors = [
                                    {
                                        instancePath: instancePath + '/periodColumn',
                                        schemaPath: '#/properties/periodColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.resetLevel !== undefined) {
                            let data3 = data.resetLevel;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (typeof data3 === 'string') {
                                    if (func2(data3) < 1) {
                                        validate343.errors = [
                                            {
                                                instancePath: instancePath + '/resetLevel',
                                                schemaPath: '#/properties/resetLevel/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate343.errors = [
                                        {
                                            instancePath: instancePath + '/resetLevel',
                                            schemaPath: '#/properties/resetLevel/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.partitionColumns !== undefined) {
                                let data4 = data.partitionColumns;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (Array.isArray(data4)) {
                                        var valid3 = true;
                                        const len1 = data4.length;
                                        for (let i2 = 0; i2 < len1; i2++) {
                                            let data5 = data4[i2];
                                            const _errs11 = errors;
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (func2(data5) < 1) {
                                                        validate343.errors = [
                                                            {
                                                                instancePath: instancePath + '/partitionColumns/' + i2,
                                                                schemaPath: '#/properties/partitionColumns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate343.errors = [
                                                        {
                                                            instancePath: instancePath + '/partitionColumns/' + i2,
                                                            schemaPath: '#/properties/partitionColumns/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs11 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                        if (valid3) {
                                            let i3 = data4.length;
                                            let j1;
                                            if (i3 > 1) {
                                                const indices1 = {};
                                                for (; i3--;) {
                                                    let item1 = data4[i3];
                                                    if (typeof item1 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices1[item1] == 'number') {
                                                        j1 = indices1[item1];
                                                        validate343.errors = [
                                                            {
                                                                instancePath: instancePath + '/partitionColumns',
                                                                schemaPath: '#/properties/partitionColumns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i3, j: j1 },
                                                                message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices1[item1] = i3;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate343.errors = [
                                            {
                                                instancePath: instancePath + '/partitionColumns',
                                                schemaPath: '#/properties/partitionColumns/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate343.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate343.errors = vErrors;
    return errors === 0;
}
export const undersampleConfigSchemaValidation = validate344;
const schema460 = {
    $id: 'urn:wisepipe-common-pipe:UndersampleConfig',
    type: 'object',
    properties: { labelColumn: { type: 'string', minLength: 1 } },
    required: ['labelColumn']
};
function validate344(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UndersampleConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.labelColumn === undefined && (missing0 = 'labelColumn')) {
                validate344.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.labelColumn !== undefined) {
                    let data0 = data.labelColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate344.errors = [
                                    {
                                        instancePath: instancePath + '/labelColumn',
                                        schemaPath: '#/properties/labelColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate344.errors = [
                                {
                                    instancePath: instancePath + '/labelColumn',
                                    schemaPath: '#/properties/labelColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate344.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate344.errors = vErrors;
    return errors === 0;
}
export const unionConfigSchemaValidation = validate345;
const schema461 = { $id: 'urn:wisepipe-common-pipe:UnionConfig', type: 'object', properties: {} };
function validate345(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UnionConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate345.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate345.errors = vErrors;
    return errors === 0;
}
export const uniqueKeysSchemaValidation = validate346;
const schema462 = {
    $id: 'urn:wisepipe-common-pipe:UniqueKeys',
    type: 'object',
    properties: {
        uniqueKeys: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        }
    },
    required: ['uniqueKeys']
};
function validate346(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UniqueKeys" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.uniqueKeys === undefined && (missing0 = 'uniqueKeys')) {
                validate346.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.uniqueKeys !== undefined) {
                    let data0 = data.uniqueKeys;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                let data1 = data0[key0];
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (Array.isArray(data1)) {
                                        var valid2 = true;
                                        const len0 = data1.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs6 = errors;
                                            if (typeof data1[i0] !== 'string') {
                                                validate346.errors = [
                                                    {
                                                        instancePath: instancePath + '/uniqueKeys/' + key0.replace(/~/g, '~0').replace(/\//g, '~1') + '/' + i0,
                                                        schemaPath: '#/properties/uniqueKeys/additionalProperties/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs6 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                        if (valid2) {
                                            let i1 = data1.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data1[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate346.errors = [
                                                            {
                                                                instancePath: instancePath + '/uniqueKeys/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                schemaPath: '#/properties/uniqueKeys/additionalProperties/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate346.errors = [
                                            {
                                                instancePath: instancePath + '/uniqueKeys/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/uniqueKeys/additionalProperties/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate346.errors = [
                                {
                                    instancePath: instancePath + '/uniqueKeys',
                                    schemaPath: '#/properties/uniqueKeys/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate346.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate346.errors = vErrors;
    return errors === 0;
}
export const unitTestColumnOverrideSchemaValidation = validate347;
const schema463 = {
    $id: 'urn:wisepipe-common-pipe:UnitTestColumnOverride',
    type: 'object',
    properties: {
        originalColName: { type: 'string', minLength: 1 },
        unitTestDataColName: { type: 'string', minLength: 1 }
    },
    required: ['originalColName', 'unitTestDataColName']
};
function validate347(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UnitTestColumnOverride" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.originalColName === undefined && (missing0 = 'originalColName')) ||
                (data.unitTestDataColName === undefined && (missing0 = 'unitTestDataColName'))) {
                validate347.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.originalColName !== undefined) {
                    let data0 = data.originalColName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate347.errors = [
                                    {
                                        instancePath: instancePath + '/originalColName',
                                        schemaPath: '#/properties/originalColName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate347.errors = [
                                {
                                    instancePath: instancePath + '/originalColName',
                                    schemaPath: '#/properties/originalColName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.unitTestDataColName !== undefined) {
                        let data1 = data.unitTestDataColName;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate347.errors = [
                                        {
                                            instancePath: instancePath + '/unitTestDataColName',
                                            schemaPath: '#/properties/unitTestDataColName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate347.errors = [
                                    {
                                        instancePath: instancePath + '/unitTestDataColName',
                                        schemaPath: '#/properties/unitTestDataColName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate347.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate347.errors = vErrors;
    return errors === 0;
}
export const unitTestDataOverrideSchemaValidation = validate348;
const schema464 = {
    $id: 'urn:wisepipe-common-pipe:UnitTestDataOverride',
    type: 'object',
    properties: {
        overrideType: { type: 'string', enum: ['originalEmpty', 'unitTestData'] },
        unitTestDataSourceID: { type: 'string' },
        columnOverrides: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:UnitTestColumnOverride' },
            uniqueItemProperties: ['originalColName']
        }
    },
    required: ['overrideType'],
    if: { properties: { overrideType: { const: 'unitTestData' } } },
    then: { required: ['unitTestDataSourceID'] }
};
const func714 = ajvEqual;
function validate348(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UnitTestDataOverride" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.overrideType !== undefined) {
            if ('unitTestData' !== data.overrideType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.unitTestDataSourceID === undefined && (missing0 = 'unitTestDataSourceID')) {
                validate348.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate348.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.overrideType === undefined && (missing1 = 'overrideType')) {
                validate348.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.overrideType !== undefined) {
                    let data1 = data.overrideType;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate348.errors = [
                            {
                                instancePath: instancePath + '/overrideType',
                                schemaPath: '#/properties/overrideType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'originalEmpty' || data1 === 'unitTestData')) {
                        validate348.errors = [
                            {
                                instancePath: instancePath + '/overrideType',
                                schemaPath: '#/properties/overrideType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema464.properties.overrideType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.unitTestDataSourceID !== undefined) {
                        const _errs7 = errors;
                        if (typeof data.unitTestDataSourceID !== 'string') {
                            validate348.errors = [
                                {
                                    instancePath: instancePath + '/unitTestDataSourceID',
                                    schemaPath: '#/properties/unitTestDataSourceID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.columnOverrides !== undefined) {
                            let data3 = data.columnOverrides;
                            const _errs9 = errors;
                            if (errors === _errs9) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data4 = data3[i0];
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                                let missing2;
                                                if ((data4.originalColName === undefined && (missing2 = 'originalColName')) ||
                                                    (data4.unitTestDataColName === undefined && (missing2 = 'unitTestDataColName'))) {
                                                    validate348.errors = [
                                                        {
                                                            instancePath: instancePath + '/columnOverrides/' + i0,
                                                            schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data4.originalColName !== undefined) {
                                                        let data5 = data4.originalColName;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data5 === 'string') {
                                                                if (func2(data5) < 1) {
                                                                    validate348.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columnOverrides/' + i0 + '/originalColName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/originalColName/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate348.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/columnOverrides/' + i0 + '/originalColName',
                                                                        schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/originalColName/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid5 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid5 = true;
                                                    }
                                                    if (valid5) {
                                                        if (data4.unitTestDataColName !== undefined) {
                                                            let data6 = data4.unitTestDataColName;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data6 === 'string') {
                                                                    if (func2(data6) < 1) {
                                                                        validate348.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/columnOverrides/' + i0 + '/unitTestDataColName',
                                                                                schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/unitTestDataColName/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate348.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/columnOverrides/' + i0 + '/unitTestDataColName',
                                                                            schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/properties/unitTestDataColName/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid5 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid5 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate348.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnOverrides/' + i0,
                                                        schemaPath: 'urn:wisepipe-common-pipe:UnitTestColumnOverride/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid3 = _errs11 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                    if (valid3) {
                                        const keys0 = schema464.properties.columnOverrides.uniqueItemProperties;
                                        let k0;
                                        let i1 = data3.length;
                                        let j0;
                                        if (i1 > 1) {
                                            outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                                let key0 = keys0[k0];
                                                for (i1 = data3.length; i1--;) {
                                                    let x0 = data3[i1];
                                                    if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                        continue;
                                                    }
                                                    for (j0 = i1; j0--;) {
                                                        let y0 = data3[j0];
                                                        if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func714(x0[key0], y0[key0])) {
                                                            validate348.errors = [
                                                                {
                                                                    instancePath: instancePath + '/columnOverrides',
                                                                    schemaPath: '#/properties/columnOverrides/uniqueItemProperties',
                                                                    keyword: 'uniqueItemProperties',
                                                                    params: {},
                                                                    message: 'must pass "uniqueItemProperties" keyword validation'
                                                                }
                                                            ];
                                                            return false;
                                                            break outer0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate348.errors = [
                                        {
                                            instancePath: instancePath + '/columnOverrides',
                                            schemaPath: '#/properties/columnOverrides/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            validate348.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate348.errors = vErrors;
    return errors === 0;
}
export const usIncomeConfigSchemaValidation = validate349;
const schema466 = {
    $id: 'urn:wisepipe-common-pipe:USIncomeConfig',
    type: 'object',
    properties: {
        countyColumn: { type: 'string', minLength: 1 },
        stateColumn: { type: 'string', minLength: 1 },
        columns: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'Total',
                    '<$10,000',
                    '$10,000-$14,999',
                    '$15,000-$24,999',
                    '$25,000-$34,999',
                    '$35,000-$49,999',
                    '$50,000-$74,999',
                    '$75,000-$99,999',
                    '$100,000-$149,999',
                    '$150,000-$199,999',
                    '$200,000+',
                    'Median Income',
                    'Mean Income'
                ]
            },
            minItems: 1,
            uniqueItems: true
        }
    },
    required: ['stateColumn', 'columns']
};
function validate349(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:USIncomeConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stateColumn === undefined && (missing0 = 'stateColumn')) ||
                (data.columns === undefined && (missing0 = 'columns'))) {
                validate349.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.countyColumn !== undefined) {
                    let data0 = data.countyColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate349.errors = [
                                    {
                                        instancePath: instancePath + '/countyColumn',
                                        schemaPath: '#/properties/countyColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate349.errors = [
                                {
                                    instancePath: instancePath + '/countyColumn',
                                    schemaPath: '#/properties/countyColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.stateColumn !== undefined) {
                        let data1 = data.stateColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate349.errors = [
                                        {
                                            instancePath: instancePath + '/stateColumn',
                                            schemaPath: '#/properties/stateColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate349.errors = [
                                    {
                                        instancePath: instancePath + '/stateColumn',
                                        schemaPath: '#/properties/stateColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.columns !== undefined) {
                            let data2 = data.columns;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    if (data2.length < 1) {
                                        validate349.errors = [
                                            {
                                                instancePath: instancePath + '/columns',
                                                schemaPath: '#/properties/columns/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid1 = true;
                                        const len0 = data2.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data3 = data2[i0];
                                            const _errs7 = errors;
                                            if (typeof data3 !== 'string') {
                                                validate349.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data3 === 'Total' ||
                                                data3 === '<$10,000' ||
                                                data3 === '$10,000-$14,999' ||
                                                data3 === '$15,000-$24,999' ||
                                                data3 === '$25,000-$34,999' ||
                                                data3 === '$35,000-$49,999' ||
                                                data3 === '$50,000-$74,999' ||
                                                data3 === '$75,000-$99,999' ||
                                                data3 === '$100,000-$149,999' ||
                                                data3 === '$150,000-$199,999' ||
                                                data3 === '$200,000+' ||
                                                data3 === 'Median Income' ||
                                                data3 === 'Mean Income')) {
                                                validate349.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema466.properties.columns.items.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid1 = _errs7 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            let i1 = data2.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data2[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate349.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns',
                                                                schemaPath: '#/properties/columns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate349.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate349.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate349.errors = vErrors;
    return errors === 0;
}
export const usPopulationConfigSchemaValidation = validate350;
const schema467 = {
    $id: 'urn:wisepipe-common-pipe:USPopulationConfig',
    type: 'object',
    properties: {
        countyColumn: { type: 'string', minLength: 1 },
        stateColumn: { type: 'string', minLength: 1 },
        year: {
            type: 'string',
            enum: ['2010_cen', '2011_est', '2012_est', '2013_est', '2014_est', '2015_est', '2016_est', '2017_est', '2018_est']
        },
        genders: {
            type: 'array',
            items: { type: 'string', enum: ['male', 'female', 'total'] },
            minItems: 1,
            uniqueItems: true
        },
        ageGroups: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    '0_4',
                    '5_9',
                    '10_14',
                    '15_19',
                    '20_24',
                    '25_29',
                    '30_34',
                    '35_39',
                    '40_44',
                    '45_49',
                    '50_54',
                    '55_59',
                    '60_64',
                    '65_69',
                    '70_74',
                    '75_79',
                    '80_84',
                    '85',
                    'total'
                ]
            },
            minItems: 1,
            uniqueItems: true
        }
    },
    required: ['stateColumn', 'year', 'genders', 'ageGroups']
};
function validate350(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:USPopulationConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stateColumn === undefined && (missing0 = 'stateColumn')) ||
                (data.year === undefined && (missing0 = 'year')) ||
                (data.genders === undefined && (missing0 = 'genders')) ||
                (data.ageGroups === undefined && (missing0 = 'ageGroups'))) {
                validate350.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.countyColumn !== undefined) {
                    let data0 = data.countyColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate350.errors = [
                                    {
                                        instancePath: instancePath + '/countyColumn',
                                        schemaPath: '#/properties/countyColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate350.errors = [
                                {
                                    instancePath: instancePath + '/countyColumn',
                                    schemaPath: '#/properties/countyColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.stateColumn !== undefined) {
                        let data1 = data.stateColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate350.errors = [
                                        {
                                            instancePath: instancePath + '/stateColumn',
                                            schemaPath: '#/properties/stateColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate350.errors = [
                                    {
                                        instancePath: instancePath + '/stateColumn',
                                        schemaPath: '#/properties/stateColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.year !== undefined) {
                            let data2 = data.year;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate350.errors = [
                                    {
                                        instancePath: instancePath + '/year',
                                        schemaPath: '#/properties/year/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === '2010_cen' ||
                                data2 === '2011_est' ||
                                data2 === '2012_est' ||
                                data2 === '2013_est' ||
                                data2 === '2014_est' ||
                                data2 === '2015_est' ||
                                data2 === '2016_est' ||
                                data2 === '2017_est' ||
                                data2 === '2018_est')) {
                                validate350.errors = [
                                    {
                                        instancePath: instancePath + '/year',
                                        schemaPath: '#/properties/year/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema467.properties.year.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.genders !== undefined) {
                                let data3 = data.genders;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        if (data3.length < 1) {
                                            validate350.errors = [
                                                {
                                                    instancePath: instancePath + '/genders',
                                                    schemaPath: '#/properties/genders/minItems',
                                                    keyword: 'minItems',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            var valid1 = true;
                                            const len0 = data3.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data4 = data3[i0];
                                                const _errs9 = errors;
                                                if (typeof data4 !== 'string') {
                                                    validate350.errors = [
                                                        {
                                                            instancePath: instancePath + '/genders/' + i0,
                                                            schemaPath: '#/properties/genders/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data4 === 'male' || data4 === 'female' || data4 === 'total')) {
                                                    validate350.errors = [
                                                        {
                                                            instancePath: instancePath + '/genders/' + i0,
                                                            schemaPath: '#/properties/genders/items/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema467.properties.genders.items.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid1 = _errs9 === errors;
                                                if (!valid1) {
                                                    break;
                                                }
                                            }
                                            if (valid1) {
                                                let i1 = data3.length;
                                                let j0;
                                                if (i1 > 1) {
                                                    const indices0 = {};
                                                    for (; i1--;) {
                                                        let item0 = data3[i1];
                                                        if (typeof item0 !== 'string') {
                                                            continue;
                                                        }
                                                        if (typeof indices0[item0] == 'number') {
                                                            j0 = indices0[item0];
                                                            validate350.errors = [
                                                                {
                                                                    instancePath: instancePath + '/genders',
                                                                    schemaPath: '#/properties/genders/uniqueItems',
                                                                    keyword: 'uniqueItems',
                                                                    params: { i: i1, j: j0 },
                                                                    message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                                }
                                                            ];
                                                            return false;
                                                            break;
                                                        }
                                                        indices0[item0] = i1;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate350.errors = [
                                            {
                                                instancePath: instancePath + '/genders',
                                                schemaPath: '#/properties/genders/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.ageGroups !== undefined) {
                                    let data5 = data.ageGroups;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (Array.isArray(data5)) {
                                            if (data5.length < 1) {
                                                validate350.errors = [
                                                    {
                                                        instancePath: instancePath + '/ageGroups',
                                                        schemaPath: '#/properties/ageGroups/minItems',
                                                        keyword: 'minItems',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 items'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                var valid3 = true;
                                                const len1 = data5.length;
                                                for (let i2 = 0; i2 < len1; i2++) {
                                                    let data6 = data5[i2];
                                                    const _errs13 = errors;
                                                    if (typeof data6 !== 'string') {
                                                        validate350.errors = [
                                                            {
                                                                instancePath: instancePath + '/ageGroups/' + i2,
                                                                schemaPath: '#/properties/ageGroups/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data6 === '0_4' ||
                                                        data6 === '5_9' ||
                                                        data6 === '10_14' ||
                                                        data6 === '15_19' ||
                                                        data6 === '20_24' ||
                                                        data6 === '25_29' ||
                                                        data6 === '30_34' ||
                                                        data6 === '35_39' ||
                                                        data6 === '40_44' ||
                                                        data6 === '45_49' ||
                                                        data6 === '50_54' ||
                                                        data6 === '55_59' ||
                                                        data6 === '60_64' ||
                                                        data6 === '65_69' ||
                                                        data6 === '70_74' ||
                                                        data6 === '75_79' ||
                                                        data6 === '80_84' ||
                                                        data6 === '85' ||
                                                        data6 === 'total')) {
                                                        validate350.errors = [
                                                            {
                                                                instancePath: instancePath + '/ageGroups/' + i2,
                                                                schemaPath: '#/properties/ageGroups/items/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema467.properties.ageGroups.items.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid3 = _errs13 === errors;
                                                    if (!valid3) {
                                                        break;
                                                    }
                                                }
                                                if (valid3) {
                                                    let i3 = data5.length;
                                                    let j1;
                                                    if (i3 > 1) {
                                                        const indices1 = {};
                                                        for (; i3--;) {
                                                            let item1 = data5[i3];
                                                            if (typeof item1 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices1[item1] == 'number') {
                                                                j1 = indices1[item1];
                                                                validate350.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/ageGroups',
                                                                        schemaPath: '#/properties/ageGroups/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i3, j: j1 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices1[item1] = i3;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate350.errors = [
                                                {
                                                    instancePath: instancePath + '/ageGroups',
                                                    schemaPath: '#/properties/ageGroups/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate350.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate350.errors = vErrors;
    return errors === 0;
}
export const userDefinedCalcConfigSchemaValidation = validate351;
const schema468 = {
    $id: 'urn:wisepipe-common-pipe:UserDefinedCalcConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        },
        values: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['columns', 'values']
};
function validate351(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:UserDefinedCalcConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columns === undefined && (missing0 = 'columns')) ||
                (data.values === undefined && (missing0 = 'values'))) {
                validate351.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columns !== undefined) {
                    let data0 = data.columns;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            if (data0.length > 1000) {
                                validate351.errors = [
                                    {
                                        instancePath: instancePath + '/columns',
                                        schemaPath: '#/properties/columns/maxItems',
                                        keyword: 'maxItems',
                                        params: { limit: 1000 },
                                        message: 'must NOT have more than 1000 items'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.length < 1) {
                                    validate351.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data0.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data1 = data0[i0];
                                        const _errs3 = errors;
                                        if (errors === _errs3) {
                                            if (typeof data1 === 'string') {
                                                if (func2(data1) > 150) {
                                                    validate351.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns/' + i0,
                                                            schemaPath: '#/properties/columns/items/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 150 },
                                                            message: 'must NOT have more than 150 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func2(data1) < 1) {
                                                        validate351.errors = [
                                                            {
                                                                instancePath: instancePath + '/columns/' + i0,
                                                                schemaPath: '#/properties/columns/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate351.errors = [
                                                    {
                                                        instancePath: instancePath + '/columns/' + i0,
                                                        schemaPath: '#/properties/columns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs3 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data0.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data0[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate351.errors = [
                                                        {
                                                            instancePath: instancePath + '/columns',
                                                            schemaPath: '#/properties/columns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate351.errors = [
                                {
                                    instancePath: instancePath + '/columns',
                                    schemaPath: '#/properties/columns/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.values !== undefined) {
                        let data2 = data.values;
                        const _errs5 = errors;
                        if (errors === _errs5) {
                            if (Array.isArray(data2)) {
                                if (data2.length > 1000) {
                                    validate351.errors = [
                                        {
                                            instancePath: instancePath + '/values',
                                            schemaPath: '#/properties/values/maxItems',
                                            keyword: 'maxItems',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.length < 1) {
                                        validate351.errors = [
                                            {
                                                instancePath: instancePath + '/values',
                                                schemaPath: '#/properties/values/minItems',
                                                keyword: 'minItems',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        var valid3 = true;
                                        const len1 = data2.length;
                                        for (let i2 = 0; i2 < len1; i2++) {
                                            let data3 = data2[i2];
                                            const _errs7 = errors;
                                            if (errors === _errs7) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) > 150) {
                                                        validate351.errors = [
                                                            {
                                                                instancePath: instancePath + '/values/' + i2,
                                                                schemaPath: '#/properties/values/items/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 150 },
                                                                message: 'must NOT have more than 150 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (func2(data3) < 1) {
                                                            validate351.errors = [
                                                                {
                                                                    instancePath: instancePath + '/values/' + i2,
                                                                    schemaPath: '#/properties/values/items/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate351.errors = [
                                                        {
                                                            instancePath: instancePath + '/values/' + i2,
                                                            schemaPath: '#/properties/values/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid3 = _errs7 === errors;
                                            if (!valid3) {
                                                break;
                                            }
                                        }
                                        if (valid3) {
                                            let i3 = data2.length;
                                            let j1;
                                            if (i3 > 1) {
                                                const indices1 = {};
                                                for (; i3--;) {
                                                    let item1 = data2[i3];
                                                    if (typeof item1 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices1[item1] == 'number') {
                                                        j1 = indices1[item1];
                                                        validate351.errors = [
                                                            {
                                                                instancePath: instancePath + '/values',
                                                                schemaPath: '#/properties/values/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i3, j: j1 },
                                                                message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices1[item1] = i3;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate351.errors = [
                                    {
                                        instancePath: instancePath + '/values',
                                        schemaPath: '#/properties/values/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate351.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate351.errors = vErrors;
    return errors === 0;
}
export const validationTaskSchemaValidation = validate352;
const schema469 = {
    $id: 'urn:wisepipe-common-pipe:ValidationTask',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        dataSourceID: { type: 'string' },
        eventTriggerType: {
            type: 'string',
            enum: ['pipe_change', 'data_source_change', 'data_source_delete', 'export_node_delete']
        },
        elementID: { type: 'string', uid: 10 }
    },
    required: ['orgID', 'eventTriggerType'],
    allOf: [
        { if: { properties: { eventTriggerType: { const: 'pipe_change' } } }, then: { required: ['pipeID'] } },
        { if: { properties: { eventTriggerType: { const: 'data_source_change' } } }, then: { required: ['dataSourceID'] } },
        { if: { properties: { eventTriggerType: { const: 'data_source_delete' } } }, then: { required: ['dataSourceID'] } },
        {
            if: { properties: { eventTriggerType: { const: 'export_node_delete' } } },
            then: { required: ['pipeID', 'elementID'] }
        }
    ]
};
const func723 = ucs2length;
const func724 = base64urlToBuffer;
const func725 = base64urlEncode;
const func726 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func727 = ucs2length;
const func728 = base64urlToBuffer;
const func729 = base64urlEncode;
const func730 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate352(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ValidationTask" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.eventTriggerType !== undefined) {
            if ('pipe_change' !== data.eventTriggerType) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.pipeID === undefined && (missing0 = 'pipeID')) {
                validate352.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate352.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.eventTriggerType !== undefined) {
                if ('data_source_change' !== data.eventTriggerType) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.dataSourceID === undefined && (missing1 = 'dataSourceID')) {
                    validate352.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate352.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
        if (valid0) {
            const _errs11 = errors;
            const _errs12 = errors;
            let valid5 = true;
            const _errs13 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.eventTriggerType !== undefined) {
                    if ('data_source_delete' !== data.eventTriggerType) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs13 === errors;
            errors = _errs12;
            if (vErrors !== null) {
                if (_errs12) {
                    vErrors.length = _errs12;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs15 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if (data.dataSourceID === undefined && (missing2 = 'dataSourceID')) {
                        validate352.errors = [
                            {
                                instancePath,
                                schemaPath: '#/allOf/2/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs15 === errors;
                valid5 = _valid2;
            }
            if (!valid5) {
                const err5 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
                validate352.errors = vErrors;
                return false;
            }
            var valid0 = _errs11 === errors;
            if (valid0) {
                const _errs16 = errors;
                const _errs17 = errors;
                let valid7 = true;
                const _errs18 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.eventTriggerType !== undefined) {
                        if ('export_node_delete' !== data.eventTriggerType) {
                            const err6 = {};
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                        }
                    }
                }
                var _valid3 = _errs18 === errors;
                errors = _errs17;
                if (vErrors !== null) {
                    if (_errs17) {
                        vErrors.length = _errs17;
                    }
                    else {
                        vErrors = null;
                    }
                }
                if (_valid3) {
                    const _errs20 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing3;
                        if ((data.pipeID === undefined && (missing3 = 'pipeID')) ||
                            (data.elementID === undefined && (missing3 = 'elementID'))) {
                            validate352.errors = [
                                {
                                    instancePath,
                                    schemaPath: '#/allOf/3/then/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing3 },
                                    message: "must have required property '" + missing3 + "'"
                                }
                            ];
                            return false;
                        }
                    }
                    var _valid3 = _errs20 === errors;
                    valid7 = _valid3;
                }
                if (!valid7) {
                    const err7 = {
                        instancePath,
                        schemaPath: '#/allOf/3/if',
                        keyword: 'if',
                        params: { failingKeyword: 'then' },
                        message: 'must match "then" schema'
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                    validate352.errors = vErrors;
                    return false;
                }
                var valid0 = _errs16 === errors;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.orgID === undefined && (missing4 = 'orgID')) ||
                (data.eventTriggerType === undefined && (missing4 = 'eventTriggerType'))) {
                validate352.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data4 = data.orgID;
                    const _errs21 = errors;
                    if (errors === _errs21) {
                        if (errors === _errs21) {
                            if (typeof data4 === 'string') {
                                if (!formats4.test(data4)) {
                                    validate352.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate352.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid9 = _errs21 === errors;
                }
                else {
                    var valid9 = true;
                }
                if (valid9) {
                    if (data.pipeID !== undefined) {
                        let data5 = data.pipeID;
                        const _errs23 = errors;
                        if (errors === _errs23) {
                            if (typeof data5 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func723(data5) < b64min0 || func723(data5) > b64max0) {
                                    validate352.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func723(data5) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func723(data5)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func724(data5);
                                    if (decoded0.length !== 10) {
                                        validate352.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func725(decoded0);
                                        if (func726(encoded0) !== func726(data5)) {
                                            validate352.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate352.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid9 = _errs23 === errors;
                    }
                    else {
                        var valid9 = true;
                    }
                    if (valid9) {
                        if (data.dataSourceID !== undefined) {
                            const _errs25 = errors;
                            if (typeof data.dataSourceID !== 'string') {
                                validate352.errors = [
                                    {
                                        instancePath: instancePath + '/dataSourceID',
                                        schemaPath: '#/properties/dataSourceID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid9 = _errs25 === errors;
                        }
                        else {
                            var valid9 = true;
                        }
                        if (valid9) {
                            if (data.eventTriggerType !== undefined) {
                                let data7 = data.eventTriggerType;
                                const _errs27 = errors;
                                if (typeof data7 !== 'string') {
                                    validate352.errors = [
                                        {
                                            instancePath: instancePath + '/eventTriggerType',
                                            schemaPath: '#/properties/eventTriggerType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data7 === 'pipe_change' ||
                                    data7 === 'data_source_change' ||
                                    data7 === 'data_source_delete' ||
                                    data7 === 'export_node_delete')) {
                                    validate352.errors = [
                                        {
                                            instancePath: instancePath + '/eventTriggerType',
                                            schemaPath: '#/properties/eventTriggerType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema469.properties.eventTriggerType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid9 = _errs27 === errors;
                            }
                            else {
                                var valid9 = true;
                            }
                            if (valid9) {
                                if (data.elementID !== undefined) {
                                    let data8 = data.elementID;
                                    const _errs29 = errors;
                                    if (errors === _errs29) {
                                        if (typeof data8 === 'string') {
                                            const b64min1 = Math.ceil((4 * 10) / 3);
                                            const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                            if (func727(data8) < b64min1 || func727(data8) > b64max1) {
                                                validate352.errors = [
                                                    {
                                                        instancePath: instancePath + '/elementID',
                                                        schemaPath: '#/properties/elementID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func727(data8) },
                                                        message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func727(data8)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded1 = func728(data8);
                                                if (decoded1.length !== 10) {
                                                    validate352.errors = [
                                                        {
                                                            instancePath: instancePath + '/elementID',
                                                            schemaPath: '#/properties/elementID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 10 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded1 = func729(decoded1);
                                                    if (func730(encoded1) !== func730(data8)) {
                                                        validate352.errors = [
                                                            {
                                                                instancePath: instancePath + '/elementID',
                                                                schemaPath: '#/properties/elementID/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate352.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid9 = _errs29 === errors;
                                }
                                else {
                                    var valid9 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate352.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate352.errors = vErrors;
    return errors === 0;
}
export const vectorAutoRegressiveForecastConfigSchemaValidation = validate353;
const schema470 = {
    $id: 'urn:wisepipe-common-pipe:VectorAutoRegressiveForecastConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumns: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 2 },
        aliases: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            uniqueItems: true,
            minItems: { $data: '1/valueColumns/length' },
            maxItems: { $data: '1/valueColumns/length' }
        },
        periods: { type: 'integer', minimum: 1 },
        frequency: { type: 'string', enum: ['D', 'W-MON', 'MS', 'AS-JAN', 'QS-', 'BEST_GUESS'] },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true },
        uncertainty: { type: 'boolean' }
    },
    required: ['dateColumn', 'valueColumns', 'aliases', 'periods']
};
function validate353(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:VectorAutoRegressiveForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.valueColumns === undefined && (missing0 = 'valueColumns')) ||
                (data.aliases === undefined && (missing0 = 'aliases')) ||
                (data.periods === undefined && (missing0 = 'periods'))) {
                validate353.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate353.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate353.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.valueColumns !== undefined) {
                        let data1 = data.valueColumns;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                if (data1.length < 2) {
                                    validate353.errors = [
                                        {
                                            instancePath: instancePath + '/valueColumns',
                                            schemaPath: '#/properties/valueColumns/minItems',
                                            keyword: 'minItems',
                                            params: { limit: 2 },
                                            message: 'must NOT have fewer than 2 items'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    var valid1 = true;
                                    const len0 = data1.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data2 = data1[i0];
                                        const _errs5 = errors;
                                        if (errors === _errs5) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate353.errors = [
                                                        {
                                                            instancePath: instancePath + '/valueColumns/' + i0,
                                                            schemaPath: '#/properties/valueColumns/items/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate353.errors = [
                                                    {
                                                        instancePath: instancePath + '/valueColumns/' + i0,
                                                        schemaPath: '#/properties/valueColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid1 = _errs5 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                    if (valid1) {
                                        let i1 = data1.length;
                                        let j0;
                                        if (i1 > 1) {
                                            const indices0 = {};
                                            for (; i1--;) {
                                                let item0 = data1[i1];
                                                if (typeof item0 !== 'string') {
                                                    continue;
                                                }
                                                if (typeof indices0[item0] == 'number') {
                                                    j0 = indices0[item0];
                                                    validate353.errors = [
                                                        {
                                                            instancePath: instancePath + '/valueColumns',
                                                            schemaPath: '#/properties/valueColumns/uniqueItems',
                                                            keyword: 'uniqueItems',
                                                            params: { i: i1, j: j0 },
                                                            message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                        }
                                                    ];
                                                    return false;
                                                    break;
                                                }
                                                indices0[item0] = i1;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate353.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumns',
                                        schemaPath: '#/properties/valueColumns/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.aliases !== undefined) {
                            let data3 = data.aliases;
                            const _errs7 = errors;
                            if (errors === _errs7) {
                                if (Array.isArray(data3)) {
                                    const vSchema0 = data && data.valueColumns && data.valueColumns.length;
                                    if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data3.length > vSchema0)) {
                                        validate353.errors = [
                                            {
                                                instancePath: instancePath + '/aliases',
                                                schemaPath: '#/properties/aliases/maxItems',
                                                keyword: 'maxItems',
                                                params: { limit: vSchema0 },
                                                message: 'must NOT have more than ' + vSchema0 + ' items'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const vSchema1 = data && data.valueColumns && data.valueColumns.length;
                                        if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data3.length < vSchema1)) {
                                            validate353.errors = [
                                                {
                                                    instancePath: instancePath + '/aliases',
                                                    schemaPath: '#/properties/aliases/minItems',
                                                    keyword: 'minItems',
                                                    params: { limit: vSchema1 },
                                                    message: 'must NOT have fewer than ' + vSchema1 + ' items'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            var valid3 = true;
                                            const len1 = data3.length;
                                            for (let i2 = 0; i2 < len1; i2++) {
                                                let data4 = data3[i2];
                                                const _errs9 = errors;
                                                if (errors === _errs9) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate353.errors = [
                                                                {
                                                                    instancePath: instancePath + '/aliases/' + i2,
                                                                    schemaPath: '#/properties/aliases/items/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate353.errors = [
                                                            {
                                                                instancePath: instancePath + '/aliases/' + i2,
                                                                schemaPath: '#/properties/aliases/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid3 = _errs9 === errors;
                                                if (!valid3) {
                                                    break;
                                                }
                                            }
                                            if (valid3) {
                                                let i3 = data3.length;
                                                let j1;
                                                if (i3 > 1) {
                                                    const indices1 = {};
                                                    for (; i3--;) {
                                                        let item1 = data3[i3];
                                                        if (typeof item1 !== 'string') {
                                                            continue;
                                                        }
                                                        if (typeof indices1[item1] == 'number') {
                                                            j1 = indices1[item1];
                                                            validate353.errors = [
                                                                {
                                                                    instancePath: instancePath + '/aliases',
                                                                    schemaPath: '#/properties/aliases/uniqueItems',
                                                                    keyword: 'uniqueItems',
                                                                    params: { i: i3, j: j1 },
                                                                    message: 'must NOT have duplicate items (items ## ' + j1 + ' and ' + i3 + ' are identical)'
                                                                }
                                                            ];
                                                            return false;
                                                            break;
                                                        }
                                                        indices1[item1] = i3;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate353.errors = [
                                        {
                                            instancePath: instancePath + '/aliases',
                                            schemaPath: '#/properties/aliases/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs7 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.periods !== undefined) {
                                let data5 = data.periods;
                                const _errs11 = errors;
                                if (!(typeof data5 == 'number' && !(data5 % 1) && !isNaN(data5))) {
                                    validate353.errors = [
                                        {
                                            instancePath: instancePath + '/periods',
                                            schemaPath: '#/properties/periods/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs11) {
                                    if (typeof data5 == 'number') {
                                        if (data5 < 1 || isNaN(data5)) {
                                            validate353.errors = [
                                                {
                                                    instancePath: instancePath + '/periods',
                                                    schemaPath: '#/properties/periods/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 1 },
                                                    message: 'must be >= 1'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs11 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.frequency !== undefined) {
                                    let data6 = data.frequency;
                                    const _errs13 = errors;
                                    if (typeof data6 !== 'string') {
                                        validate353.errors = [
                                            {
                                                instancePath: instancePath + '/frequency',
                                                schemaPath: '#/properties/frequency/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data6 === 'D' ||
                                        data6 === 'W-MON' ||
                                        data6 === 'MS' ||
                                        data6 === 'AS-JAN' ||
                                        data6 === 'QS-' ||
                                        data6 === 'BEST_GUESS')) {
                                        validate353.errors = [
                                            {
                                                instancePath: instancePath + '/frequency',
                                                schemaPath: '#/properties/frequency/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema470.properties.frequency.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs13 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.groupByColumns !== undefined) {
                                        let data7 = data.groupByColumns;
                                        const _errs15 = errors;
                                        if (errors === _errs15) {
                                            if (Array.isArray(data7)) {
                                                var valid5 = true;
                                                const len2 = data7.length;
                                                for (let i4 = 0; i4 < len2; i4++) {
                                                    const _errs17 = errors;
                                                    if (typeof data7[i4] !== 'string') {
                                                        validate353.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupByColumns/' + i4,
                                                                schemaPath: '#/properties/groupByColumns/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid5 = _errs17 === errors;
                                                    if (!valid5) {
                                                        break;
                                                    }
                                                }
                                                if (valid5) {
                                                    let i5 = data7.length;
                                                    let j2;
                                                    if (i5 > 1) {
                                                        const indices2 = {};
                                                        for (; i5--;) {
                                                            let item2 = data7[i5];
                                                            if (typeof item2 !== 'string') {
                                                                continue;
                                                            }
                                                            if (typeof indices2[item2] == 'number') {
                                                                j2 = indices2[item2];
                                                                validate353.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groupByColumns',
                                                                        schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                        keyword: 'uniqueItems',
                                                                        params: { i: i5, j: j2 },
                                                                        message: 'must NOT have duplicate items (items ## ' + j2 + ' and ' + i5 + ' are identical)'
                                                                    }
                                                                ];
                                                                return false;
                                                                break;
                                                            }
                                                            indices2[item2] = i5;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate353.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupByColumns',
                                                        schemaPath: '#/properties/groupByColumns/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs15 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.uncertainty !== undefined) {
                                            const _errs19 = errors;
                                            if (typeof data.uncertainty !== 'boolean') {
                                                validate353.errors = [
                                                    {
                                                        instancePath: instancePath + '/uncertainty',
                                                        schemaPath: '#/properties/uncertainty/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs19 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate353.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate353.errors = vErrors;
    return errors === 0;
}
export const weatherConfigSchemaValidation = validate354;
const schema471 = {
    $id: 'urn:wisepipe-common-pipe:WeatherConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        cityColumn: { type: 'string', minLength: 1 },
        stateColumn: { type: 'string', minLength: 1 },
        countryColumn: { type: 'string', minLength: 1 }
    },
    required: ['dateColumn', 'cityColumn', 'stateColumn', 'countryColumn']
};
function validate354(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:WeatherConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.cityColumn === undefined && (missing0 = 'cityColumn')) ||
                (data.stateColumn === undefined && (missing0 = 'stateColumn')) ||
                (data.countryColumn === undefined && (missing0 = 'countryColumn'))) {
                validate354.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate354.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate354.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.cityColumn !== undefined) {
                        let data1 = data.cityColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate354.errors = [
                                        {
                                            instancePath: instancePath + '/cityColumn',
                                            schemaPath: '#/properties/cityColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate354.errors = [
                                    {
                                        instancePath: instancePath + '/cityColumn',
                                        schemaPath: '#/properties/cityColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.stateColumn !== undefined) {
                            let data2 = data.stateColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate354.errors = [
                                            {
                                                instancePath: instancePath + '/stateColumn',
                                                schemaPath: '#/properties/stateColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate354.errors = [
                                        {
                                            instancePath: instancePath + '/stateColumn',
                                            schemaPath: '#/properties/stateColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.countryColumn !== undefined) {
                                let data3 = data.countryColumn;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate354.errors = [
                                                {
                                                    instancePath: instancePath + '/countryColumn',
                                                    schemaPath: '#/properties/countryColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate354.errors = [
                                            {
                                                instancePath: instancePath + '/countryColumn',
                                                schemaPath: '#/properties/countryColumn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate354.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate354.errors = vErrors;
    return errors === 0;
}
export const weightedAverageConfigSchemaValidation = validate355;
const schema472 = {
    $id: 'urn:wisepipe-common-pipe:WeightedAverageConfig',
    type: 'object',
    properties: {
        columnName: { type: 'string', minLength: 1 },
        valueColumn: { type: 'string', minLength: 1 },
        weightColumn: { type: 'string', minLength: 1 },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['columnName', 'valueColumn', 'weightColumn', 'groupByColumns']
};
function validate355(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:WeightedAverageConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnName === undefined && (missing0 = 'columnName')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn')) ||
                (data.weightColumn === undefined && (missing0 = 'weightColumn')) ||
                (data.groupByColumns === undefined && (missing0 = 'groupByColumns'))) {
                validate355.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.columnName !== undefined) {
                    let data0 = data.columnName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate355.errors = [
                                    {
                                        instancePath: instancePath + '/columnName',
                                        schemaPath: '#/properties/columnName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate355.errors = [
                                {
                                    instancePath: instancePath + '/columnName',
                                    schemaPath: '#/properties/columnName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.valueColumn !== undefined) {
                        let data1 = data.valueColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate355.errors = [
                                        {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate355.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.weightColumn !== undefined) {
                            let data2 = data.weightColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate355.errors = [
                                            {
                                                instancePath: instancePath + '/weightColumn',
                                                schemaPath: '#/properties/weightColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate355.errors = [
                                        {
                                            instancePath: instancePath + '/weightColumn',
                                            schemaPath: '#/properties/weightColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.groupByColumns !== undefined) {
                                let data3 = data.groupByColumns;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid1 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs9 = errors;
                                            if (typeof data3[i0] !== 'string') {
                                                validate355.errors = [
                                                    {
                                                        instancePath: instancePath + '/groupByColumns/' + i0,
                                                        schemaPath: '#/properties/groupByColumns/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid1 = _errs9 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                        if (valid1) {
                                            let i1 = data3.length;
                                            let j0;
                                            if (i1 > 1) {
                                                const indices0 = {};
                                                for (; i1--;) {
                                                    let item0 = data3[i1];
                                                    if (typeof item0 !== 'string') {
                                                        continue;
                                                    }
                                                    if (typeof indices0[item0] == 'number') {
                                                        j0 = indices0[item0];
                                                        validate355.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupByColumns',
                                                                schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                keyword: 'uniqueItems',
                                                                params: { i: i1, j: j0 },
                                                                message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                            }
                                                        ];
                                                        return false;
                                                        break;
                                                    }
                                                    indices0[item0] = i1;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate355.errors = [
                                            {
                                                instancePath: instancePath + '/groupByColumns',
                                                schemaPath: '#/properties/groupByColumns/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate355.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate355.errors = vErrors;
    return errors === 0;
}
export const weightedMovingAverageForecastConfigSchemaValidation = validate356;
const schema473 = {
    $id: 'urn:wisepipe-common-pipe:WeightedMovingAverageForecastConfig',
    type: 'object',
    properties: {
        dateColumn: { type: 'string', minLength: 1 },
        valueColumn: { type: 'string', minLength: 1 },
        alias: { type: 'string', minLength: 1 },
        window: { type: 'integer', minimum: 3 },
        weights: {
            type: 'array',
            items: { type: 'number' },
            oneOf: [
                { minItems: 0, maxItems: 0 },
                { minItems: { $data: '1/window' }, maxItems: { $data: '1/window' } }
            ]
        },
        periods: { type: 'integer', minimum: 1 },
        frequency: { type: 'string', enum: ['D', 'W-MON', 'MS', 'AS-JAN', 'QS-', 'BEST_GUESS'] },
        groupByColumns: { type: 'array', items: { type: 'string' }, uniqueItems: true }
    },
    required: ['dateColumn', 'valueColumn', 'alias', 'window', 'weights', 'periods']
};
function validate356(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:WeightedMovingAverageForecastConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.dateColumn === undefined && (missing0 = 'dateColumn')) ||
                (data.valueColumn === undefined && (missing0 = 'valueColumn')) ||
                (data.alias === undefined && (missing0 = 'alias')) ||
                (data.window === undefined && (missing0 = 'window')) ||
                (data.weights === undefined && (missing0 = 'weights')) ||
                (data.periods === undefined && (missing0 = 'periods'))) {
                validate356.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateColumn !== undefined) {
                    let data0 = data.dateColumn;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate356.errors = [
                                    {
                                        instancePath: instancePath + '/dateColumn',
                                        schemaPath: '#/properties/dateColumn/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate356.errors = [
                                {
                                    instancePath: instancePath + '/dateColumn',
                                    schemaPath: '#/properties/dateColumn/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.valueColumn !== undefined) {
                        let data1 = data.valueColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate356.errors = [
                                        {
                                            instancePath: instancePath + '/valueColumn',
                                            schemaPath: '#/properties/valueColumn/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate356.errors = [
                                    {
                                        instancePath: instancePath + '/valueColumn',
                                        schemaPath: '#/properties/valueColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.alias !== undefined) {
                            let data2 = data.alias;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate356.errors = [
                                            {
                                                instancePath: instancePath + '/alias',
                                                schemaPath: '#/properties/alias/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate356.errors = [
                                        {
                                            instancePath: instancePath + '/alias',
                                            schemaPath: '#/properties/alias/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.window !== undefined) {
                                let data3 = data.window;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    validate356.errors = [
                                        {
                                            instancePath: instancePath + '/window',
                                            schemaPath: '#/properties/window/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 3 || isNaN(data3)) {
                                            validate356.errors = [
                                                {
                                                    instancePath: instancePath + '/window',
                                                    schemaPath: '#/properties/window/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 3 },
                                                    message: 'must be >= 3'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.weights !== undefined) {
                                    let data4 = data.weights;
                                    const _errs9 = errors;
                                    const _errs11 = errors;
                                    let valid1 = false;
                                    let passing0 = null;
                                    const _errs12 = errors;
                                    if (Array.isArray(data4)) {
                                        if (data4.length > 0) {
                                            const err0 = {
                                                instancePath: instancePath + '/weights',
                                                schemaPath: '#/properties/weights/oneOf/0/maxItems',
                                                keyword: 'maxItems',
                                                params: { limit: 0 },
                                                message: 'must NOT have more than 0 items'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err0];
                                            }
                                            else {
                                                vErrors.push(err0);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data4.length < 0) {
                                                const err1 = {
                                                    instancePath: instancePath + '/weights',
                                                    schemaPath: '#/properties/weights/oneOf/0/minItems',
                                                    keyword: 'minItems',
                                                    params: { limit: 0 },
                                                    message: 'must NOT have fewer than 0 items'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err1];
                                                }
                                                else {
                                                    vErrors.push(err1);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid0 = _errs12 === errors;
                                    if (_valid0) {
                                        valid1 = true;
                                        passing0 = 0;
                                    }
                                    const _errs13 = errors;
                                    if (Array.isArray(data4)) {
                                        const vSchema0 = data && data.window;
                                        if (vSchema0 !== undefined && (!(typeof vSchema0 == 'number') || data4.length > vSchema0)) {
                                            const err2 = {
                                                instancePath: instancePath + '/weights',
                                                schemaPath: '#/properties/weights/oneOf/1/maxItems',
                                                keyword: 'maxItems',
                                                params: { limit: vSchema0 },
                                                message: 'must NOT have more than ' + vSchema0 + ' items'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err2];
                                            }
                                            else {
                                                vErrors.push(err2);
                                            }
                                            errors++;
                                        }
                                        else {
                                            const vSchema1 = data && data.window;
                                            if (vSchema1 !== undefined && (!(typeof vSchema1 == 'number') || data4.length < vSchema1)) {
                                                const err3 = {
                                                    instancePath: instancePath + '/weights',
                                                    schemaPath: '#/properties/weights/oneOf/1/minItems',
                                                    keyword: 'minItems',
                                                    params: { limit: vSchema1 },
                                                    message: 'must NOT have fewer than ' + vSchema1 + ' items'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err3];
                                                }
                                                else {
                                                    vErrors.push(err3);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid0 = _errs13 === errors;
                                    if (_valid0 && valid1) {
                                        valid1 = false;
                                        passing0 = [passing0, 1];
                                    }
                                    else {
                                        if (_valid0) {
                                            valid1 = true;
                                            passing0 = 1;
                                        }
                                    }
                                    if (!valid1) {
                                        const err4 = {
                                            instancePath: instancePath + '/weights',
                                            schemaPath: '#/properties/weights/oneOf',
                                            keyword: 'oneOf',
                                            params: { passingSchemas: passing0 },
                                            message: 'must match exactly one schema in oneOf'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                        validate356.errors = vErrors;
                                        return false;
                                    }
                                    else {
                                        errors = _errs11;
                                        if (vErrors !== null) {
                                            if (_errs11) {
                                                vErrors.length = _errs11;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                    }
                                    if (errors === _errs9) {
                                        if (Array.isArray(data4)) {
                                            var valid2 = true;
                                            const len0 = data4.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                const _errs14 = errors;
                                                if (!(typeof data4[i0] == 'number')) {
                                                    validate356.errors = [
                                                        {
                                                            instancePath: instancePath + '/weights/' + i0,
                                                            schemaPath: '#/properties/weights/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs14 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate356.errors = [
                                                {
                                                    instancePath: instancePath + '/weights',
                                                    schemaPath: '#/properties/weights/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.periods !== undefined) {
                                        let data6 = data.periods;
                                        const _errs16 = errors;
                                        if (!(typeof data6 == 'number' && !(data6 % 1) && !isNaN(data6))) {
                                            validate356.errors = [
                                                {
                                                    instancePath: instancePath + '/periods',
                                                    schemaPath: '#/properties/periods/type',
                                                    keyword: 'type',
                                                    params: { type: 'integer' },
                                                    message: 'must be integer'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (errors === _errs16) {
                                            if (typeof data6 == 'number') {
                                                if (data6 < 1 || isNaN(data6)) {
                                                    validate356.errors = [
                                                        {
                                                            instancePath: instancePath + '/periods',
                                                            schemaPath: '#/properties/periods/minimum',
                                                            keyword: 'minimum',
                                                            params: { comparison: '>=', limit: 1 },
                                                            message: 'must be >= 1'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs16 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.frequency !== undefined) {
                                            let data7 = data.frequency;
                                            const _errs18 = errors;
                                            if (typeof data7 !== 'string') {
                                                validate356.errors = [
                                                    {
                                                        instancePath: instancePath + '/frequency',
                                                        schemaPath: '#/properties/frequency/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data7 === 'D' ||
                                                data7 === 'W-MON' ||
                                                data7 === 'MS' ||
                                                data7 === 'AS-JAN' ||
                                                data7 === 'QS-' ||
                                                data7 === 'BEST_GUESS')) {
                                                validate356.errors = [
                                                    {
                                                        instancePath: instancePath + '/frequency',
                                                        schemaPath: '#/properties/frequency/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema473.properties.frequency.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs18 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.groupByColumns !== undefined) {
                                                let data8 = data.groupByColumns;
                                                const _errs20 = errors;
                                                if (errors === _errs20) {
                                                    if (Array.isArray(data8)) {
                                                        var valid3 = true;
                                                        const len1 = data8.length;
                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                            const _errs22 = errors;
                                                            if (typeof data8[i1] !== 'string') {
                                                                validate356.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/groupByColumns/' + i1,
                                                                        schemaPath: '#/properties/groupByColumns/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid3 = _errs22 === errors;
                                                            if (!valid3) {
                                                                break;
                                                            }
                                                        }
                                                        if (valid3) {
                                                            let i2 = data8.length;
                                                            let j0;
                                                            if (i2 > 1) {
                                                                const indices0 = {};
                                                                for (; i2--;) {
                                                                    let item0 = data8[i2];
                                                                    if (typeof item0 !== 'string') {
                                                                        continue;
                                                                    }
                                                                    if (typeof indices0[item0] == 'number') {
                                                                        j0 = indices0[item0];
                                                                        validate356.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/groupByColumns',
                                                                                schemaPath: '#/properties/groupByColumns/uniqueItems',
                                                                                keyword: 'uniqueItems',
                                                                                params: { i: i2, j: j0 },
                                                                                message: 'must NOT have duplicate items (items ## ' +
                                                                                    j0 +
                                                                                    ' and ' +
                                                                                    i2 +
                                                                                    ' are identical)'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                        break;
                                                                    }
                                                                    indices0[item0] = i2;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate356.errors = [
                                                            {
                                                                instancePath: instancePath + '/groupByColumns',
                                                                schemaPath: '#/properties/groupByColumns/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs20 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate356.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate356.errors = vErrors;
    return errors === 0;
}
export const wordFrequencyConfigSchemaValidation = validate357;
const schema474 = {
    $id: 'urn:wisepipe-common-pipe:WordFrequencyConfig',
    type: 'object',
    properties: {
        matchType: { type: 'string', enum: ['exact'] },
        sourceColumn: { type: 'string', minLength: 1, maxLength: 150 },
        taxonomyColumn: { type: 'string', minLength: 1, maxLength: 150 },
        outputColumnName: { type: 'string', minLength: 1, maxLength: 150 },
        caseInsensitive: { type: 'boolean' }
    },
    required: ['matchType', 'sourceColumn', 'taxonomyColumn']
};
function validate357(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:WordFrequencyConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.matchType === undefined && (missing0 = 'matchType')) ||
                (data.sourceColumn === undefined && (missing0 = 'sourceColumn')) ||
                (data.taxonomyColumn === undefined && (missing0 = 'taxonomyColumn'))) {
                validate357.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.matchType !== undefined) {
                    let data0 = data.matchType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate357.errors = [
                            {
                                instancePath: instancePath + '/matchType',
                                schemaPath: '#/properties/matchType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'exact')) {
                        validate357.errors = [
                            {
                                instancePath: instancePath + '/matchType',
                                schemaPath: '#/properties/matchType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema474.properties.matchType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.sourceColumn !== undefined) {
                        let data1 = data.sourceColumn;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 150) {
                                    validate357.errors = [
                                        {
                                            instancePath: instancePath + '/sourceColumn',
                                            schemaPath: '#/properties/sourceColumn/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 150 },
                                            message: 'must NOT have more than 150 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate357.errors = [
                                            {
                                                instancePath: instancePath + '/sourceColumn',
                                                schemaPath: '#/properties/sourceColumn/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate357.errors = [
                                    {
                                        instancePath: instancePath + '/sourceColumn',
                                        schemaPath: '#/properties/sourceColumn/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.taxonomyColumn !== undefined) {
                            let data2 = data.taxonomyColumn;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 150) {
                                        validate357.errors = [
                                            {
                                                instancePath: instancePath + '/taxonomyColumn',
                                                schemaPath: '#/properties/taxonomyColumn/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 150 },
                                                message: 'must NOT have more than 150 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate357.errors = [
                                                {
                                                    instancePath: instancePath + '/taxonomyColumn',
                                                    schemaPath: '#/properties/taxonomyColumn/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate357.errors = [
                                        {
                                            instancePath: instancePath + '/taxonomyColumn',
                                            schemaPath: '#/properties/taxonomyColumn/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.outputColumnName !== undefined) {
                                let data3 = data.outputColumnName;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) > 150) {
                                            validate357.errors = [
                                                {
                                                    instancePath: instancePath + '/outputColumnName',
                                                    schemaPath: '#/properties/outputColumnName/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 150 },
                                                    message: 'must NOT have more than 150 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (func2(data3) < 1) {
                                                validate357.errors = [
                                                    {
                                                        instancePath: instancePath + '/outputColumnName',
                                                        schemaPath: '#/properties/outputColumnName/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    else {
                                        validate357.errors = [
                                            {
                                                instancePath: instancePath + '/outputColumnName',
                                                schemaPath: '#/properties/outputColumnName/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.caseInsensitive !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.caseInsensitive !== 'boolean') {
                                        validate357.errors = [
                                            {
                                                instancePath: instancePath + '/caseInsensitive',
                                                schemaPath: '#/properties/caseInsensitive/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate357.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate357.errors = vErrors;
    return errors === 0;
}
export const xgbClassifierConfigSchemaValidation = validate358;
const schema475 = { $id: 'urn:wisepipe-common-pipe:XgbClassifierConfig', type: 'object', properties: {}, required: [] };
function validate358(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:XgbClassifierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate358.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate358.errors = vErrors;
    return errors === 0;
}
export const xgbRegressorConfigSchemaValidation = validate359;
const schema476 = { $id: 'urn:wisepipe-common-pipe:XgbRegressorConfig', type: 'object', properties: {}, required: [] };
function validate359(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:XgbRegressorConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate359.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate359.errors = vErrors;
    return errors === 0;
}
export const zScoreOutlierConfigSchemaValidation = validate360;
const schema477 = { $id: 'urn:wisepipe-common-pipe:ZScoreOutlierConfig', type: 'object', properties: {}, required: [] };
function validate360(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-pipe:ZScoreOutlierConfig" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate360.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate360.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map